/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(584);
	module.exports = __webpack_require__(343);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(588);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(497)();
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.combineActions = exports.handleActions = exports.handleAction = exports.createActions = exports.createAction = undefined;
	
	var _createAction = __webpack_require__(240);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _handleAction = __webpack_require__(242);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _handleActions = __webpack_require__(592);
	
	var _handleActions2 = _interopRequireDefault(_handleActions);
	
	var _combineActions = __webpack_require__(239);
	
	var _combineActions2 = _interopRequireDefault(_combineActions);
	
	var _createActions = __webpack_require__(591);
	
	var _createActions2 = _interopRequireDefault(_createActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createAction = _createAction2.default;
	exports.createActions = _createActions2.default;
	exports.handleAction = _handleAction2.default;
	exports.handleActions = _handleActions2.default;
	exports.combineActions = _combineActions2.default;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dragDropContext = __webpack_require__(522);
	
	Object.defineProperty(exports, 'DragDropContext', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dragDropContext).default;
	  }
	});
	
	var _droppable = __webpack_require__(540);
	
	Object.defineProperty(exports, 'Droppable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_droppable).default;
	  }
	});
	
	var _draggable = __webpack_require__(534);
	
	Object.defineProperty(exports, 'Draggable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_draggable).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.extractStrings = extractStrings;
	exports.capitalize = capitalize;
	exports.reorder = reorder;
	exports.getMonitorValue = getMonitorValue;
	exports.calculateColorNumber = calculateColorNumber;
	exports.hiddenInPaging = hiddenInPaging;
	exports.getAvailableColumnTypes = getAvailableColumnTypes;
	exports.getAvailableEquipmentTypes = getAvailableEquipmentTypes;
	exports.getStageElementsByTypes = getStageElementsByTypes;
	exports.validateSearchResults = validateSearchResults;
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function extractStrings(input) {
	  var output = [];
	
	  if (typeof input === 'string') {
	    output.push(input);
	  } else if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object') {
	    for (var i in input) {
	      output = output.concat(extractStrings(input[i]));
	    }
	  }
	
	  return output;
	}
	
	function capitalize(string) {
	  string = string.replace(/\b\w/g, function (l) {
	    return l.toUpperCase();
	  });
	
	  return string;
	}
	
	function reorder(list, startIndex, endIndex) {
	  var result = Array.from(list);
	
	  var _result$splice = result.splice(startIndex, 1),
	      _result$splice2 = _slicedToArray(_result$splice, 1),
	      removed = _result$splice2[0];
	
	  result.splice(endIndex, 0, removed);
	
	  return result;
	}
	
	function getMonitorValue(item) {
	  return item.value || item.member ? (item.value || item.member.name) + ' (' + item.title + ')' : item.title;
	}
	
	function calculateColorNumber(position, maxNumbers) {
	  var multiplier = Math.floor(position / maxNumbers);
	  var number = position - multiplier * maxNumbers;
	
	  return number + 1;
	}
	
	function hiddenInPaging(paging, index) {
	  var offset = paging.stickyColumn && paging.hideFirstColumn ? paging.offset + 1 : paging.offset;
	  var size = paging.stickyColumn ? paging.size - 1 : paging.size;
	
	  if (offset > index || index >= offset + size) return true;
	  return false;
	}
	
	function getAvailableColumnTypes(columns, equipmentTypes) {
	  var availableColumnTypes = [].concat(_toConsumableArray(equipmentTypes));
	
	  columns.forEach(function (column, index) {
	    var columnIndex = availableColumnTypes.map(function (equipmentType) {
	      return equipmentType.title;
	    }).indexOf(column.title);
	
	    if (columnIndex !== -1) availableColumnTypes.splice(columnIndex, 1);
	  });
	
	  return availableColumnTypes;
	}
	
	function getAvailableEquipmentTypes(columns, items) {
	  var availableEquipmentTypes = {
	    objects: [],
	    ids: []
	  };
	
	  if (columns) {
	    columns.forEach(function (column) {
	      if (column.type !== 'instrument') {
	        var itemIndex = items.map(function (item) {
	          return item.type && item.type.slug;
	        }).indexOf(column.type);
	        var customItemIndex = column.type === 'custom' ? items.map(function (item) {
	          return item.params && item.params.columnId;
	        }).indexOf(column.id) : null;
	
	        if (customItemIndex === -1 || itemIndex === -1) {
	          availableEquipmentTypes = (0, _immutabilityHelper2.default)(availableEquipmentTypes, {
	            objects: {
	              $push: [{
	                id: column.id,
	                title: column.title,
	                type: {
	                  title: column.title,
	                  slug: column.type
	                },
	                params: column.type === 'custom' ? { columnId: column.id } : null
	              }]
	            }
	          });
	
	          availableEquipmentTypes = (0, _immutabilityHelper2.default)(availableEquipmentTypes, {
	            ids: {
	              $push: [column.type]
	            }
	          });
	        }
	      }
	    });
	  }
	
	  return availableEquipmentTypes;
	}
	
	function getStageElementsByTypes() {
	  var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var elements = arguments[1];
	
	  var stageElements = undefined;
	
	  if (elements) {
	    stageElements = [];
	
	    types.forEach(function (type, index) {
	      if (elements[type]) {
	        var element = Array.isArray(elements[type]) ? elements[type] : [elements[type]];
	
	        stageElements = [].concat(_toConsumableArray(stageElements), _toConsumableArray(element));
	      }
	    });
	  }
	
	  return stageElements;
	}
	
	function validateSearchResults(stageElements) {
	  var search = stageElements.search;
	
	
	  var hasSearchObject = search && Object.keys(search).length > 0;
	  var hasStageElements = hasSearchObject && stageElements.isFetching !== true;
	  var hasSearchResults = hasStageElements && search.results;
	
	  return hasSearchResults ? search.results : undefined;
	}

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(10);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var splice = Array.prototype.splice;
	
	var toString = Object.prototype.toString
	var type = function(obj) {
	  return toString.call(obj).slice(8, -1);
	}
	
	var assign = Object.assign || /* istanbul ignore next */ function assign(target, source) {
	  getAllKeys(source).forEach(function(key) {
	    if (hasOwnProperty.call(source, key)) {
	      target[key] = source[key];
	    }
	  });
	  return target;
	};
	
	var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
	  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
	  /* istanbul ignore next */ function(obj) { return Object.keys(obj) };
	
	/* istanbul ignore next */
	function copy(object) {
	  if (Array.isArray(object)) {
	    return assign(object.constructor(object.length), object)
	  } else if (type(object) === 'Map') {
	    return new Map(object)
	  } else if (type(object) === 'Set') {
	    return new Set(object)
	  } else if (object && typeof object === 'object') {
	    var prototype = object.constructor && object.constructor.prototype
	    return assign(Object.create(prototype || null), object);
	  } else {
	    return object;
	  }
	}
	
	function newContext() {
	  var commands = assign({}, defaultCommands);
	  update.extend = function(directive, fn) {
	    commands[directive] = fn;
	  };
	  update.isEquals = function(a, b) { return a === b; };
	
	  return update;
	
	  function update(object, spec) {
	    if (typeof spec === 'function') {
	      return spec(object);
	    }
	
	    if (!(Array.isArray(object) && Array.isArray(spec))) {
	      invariant(
	        !Array.isArray(spec),
	        'update(): You provided an invalid spec to update(). The spec may ' +
	        'not contain an array except as the value of $set, $push, $unshift, ' +
	        '$splice or any custom command allowing an array value.'
	      );
	    }
	
	    invariant(
	      typeof spec === 'object' && spec !== null,
	      'update(): You provided an invalid spec to update(). The spec and ' +
	      'every included key path must be plain objects containing one of the ' +
	      'following commands: %s.',
	      Object.keys(commands).join(', ')
	    );
	
	    var nextObject = object;
	    var index, key;
	    getAllKeys(spec).forEach(function(key) {
	      if (hasOwnProperty.call(commands, key)) {
	        var objectWasNextObject = object === nextObject;
	        nextObject = commands[key](spec[key], nextObject, spec, object);
	        if (objectWasNextObject && update.isEquals(nextObject, object)) {
	          nextObject = object;
	        }
	      } else {
	        var nextValueForKey = update(object[key], spec[key]);
	        if (!update.isEquals(nextValueForKey, nextObject[key]) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
	          if (nextObject === object) {
	            nextObject = copy(object);
	          }
	          nextObject[key] = nextValueForKey;
	        }
	      }
	    })
	    return nextObject;
	  }
	
	}
	
	var defaultCommands = {
	  $push: function(value, nextObject, spec) {
	    invariantPushAndUnshift(nextObject, spec, '$push');
	    return value.length ? nextObject.concat(value) : nextObject;
	  },
	  $unshift: function(value, nextObject, spec) {
	    invariantPushAndUnshift(nextObject, spec, '$unshift');
	    return value.length ? value.concat(nextObject) : nextObject;
	  },
	  $splice: function(value, nextObject, spec, originalObject) {
	    invariantSplices(nextObject, spec);
	    value.forEach(function(args) {
	      invariantSplice(args);
	      if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
	      splice.apply(nextObject, args);
	    });
	    return nextObject;
	  },
	  $set: function(value, nextObject, spec) {
	    invariantSet(spec);
	    return value;
	  },
	  $toggle: function(targets, nextObject) {
	    invariantSpecArray(targets, '$toggle');
	    var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
	
	    targets.forEach(function(target) {
	      nextObjectCopy[target] = !nextObject[target];
	    });
	
	    return nextObjectCopy;
	  },
	  $unset: function(value, nextObject, spec, originalObject) {
	    invariantSpecArray(value, '$unset');
	    value.forEach(function(key) {
	      if (Object.hasOwnProperty.call(nextObject, key)) {
	        if (nextObject === originalObject) nextObject = copy(originalObject);
	        delete nextObject[key];
	      }
	    });
	    return nextObject;
	  },
	  $add: function(value, nextObject, spec, originalObject) {
	    invariantMapOrSet(nextObject, '$add');
	    invariantSpecArray(value, '$add');
	    if (type(nextObject) === 'Map') {
	      value.forEach(function(pair) {
	        var key = pair[0];
	        var value = pair[1];
	        if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
	        nextObject.set(key, value);
	      });
	    } else {
	      value.forEach(function(value) {
	        if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
	        nextObject.add(value);
	      });
	    }
	    return nextObject;
	  },
	  $remove: function(value, nextObject, spec, originalObject) {
	    invariantMapOrSet(nextObject, '$remove');
	    invariantSpecArray(value, '$remove');
	    value.forEach(function(key) {
	      if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
	      nextObject.delete(key);
	    });
	    return nextObject;
	  },
	  $merge: function(value, nextObject, spec, originalObject) {
	    invariantMerge(nextObject, value);
	    getAllKeys(value).forEach(function(key) {
	      if (value[key] !== nextObject[key]) {
	        if (nextObject === originalObject) nextObject = copy(originalObject);
	        nextObject[key] = value[key];
	      }
	    });
	    return nextObject;
	  },
	  $apply: function(value, original) {
	    invariantApply(value);
	    return value(original);
	  }
	};
	
	var contextForExport = newContext();
	
	module.exports = contextForExport;
	module.exports.default = contextForExport;
	module.exports.newContext = newContext;
	
	// invariants
	
	function invariantPushAndUnshift(value, spec, command) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected target of %s to be an array; got %s.',
	    command,
	    value
	  );
	  invariantSpecArray(spec[command], command)
	}
	
	function invariantSpecArray(spec, command) {
	  invariant(
	    Array.isArray(spec),
	    'update(): expected spec of %s to be an array; got %s. ' +
	    'Did you forget to wrap your parameter in an array?',
	    command,
	    spec
	  );
	}
	
	function invariantSplices(value, spec) {
	  invariant(
	    Array.isArray(value),
	    'Expected $splice target to be an array; got %s',
	    value
	  );
	  invariantSplice(spec['$splice']);
	}
	
	function invariantSplice(value) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
	    'Did you forget to wrap your parameters in an array?',
	    value
	  );
	}
	
	function invariantApply(fn) {
	  invariant(
	    typeof fn === 'function',
	    'update(): expected spec of $apply to be a function; got %s.',
	    fn
	  );
	}
	
	function invariantSet(spec) {
	  invariant(
	    Object.keys(spec).length === 1,
	    'Cannot have more than one key in an object with $set'
	  );
	}
	
	function invariantMerge(target, specValue) {
	  invariant(
	    specValue && typeof specValue === 'object',
	    'update(): $merge expects a spec of type \'object\'; got %s',
	    specValue
	  );
	  invariant(
	    target && typeof target === 'object',
	    'update(): $merge expects a target of type \'object\'; got %s',
	    target
	  );
	}
	
	function invariantMapOrSet(target, command) {
	  var typeOfTarget = type(target);
	  invariant(
	    typeOfTarget === 'Map' || typeOfTarget === 'Set',
	    'update(): %s expects a target of type Set or Map; got %s',
	    command,
	    typeOfTarget
	  );
	}


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(558);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(224);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(559);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(250);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Api = function () {
	  function Api() {
	    _classCallCheck(this, Api);
	  }
	
	  _createClass(Api, null, [{
	    key: 'setTokenStrings',
	    value: function setTokenStrings(response) {
	      localStorage.setItem('authHeaderToken', response.data.token);
	      localStorage.setItem('authRefreshToken', response.data.refresh_token);
	      localStorage.setItem('authHeaderTokenExpiration', new Date(response.data.expiresTimestamp * 1000));
	    }
	  }, {
	    key: 'removeTokenStrings',
	    value: function removeTokenStrings() {
	      localStorage.removeItem('authHeaderToken');
	      localStorage.removeItem('authRefreshToken');
	      localStorage.removeItem('authHeaderTokenExpiration');
	    }
	  }, {
	    key: 'getToken',
	    value: function getToken() {
	      var currentTime = new Date();
	      var tokenExpiration = this.getTokenExpiration();
	
	      var tokenString = localStorage.getItem('authHeaderToken');
	      if (tokenString === 'undefined') tokenString = undefined;
	
	      var token = currentTime < tokenExpiration ? tokenString : undefined;
	      return token;
	    }
	  }, {
	    key: 'getRefreshToken',
	    value: function getRefreshToken() {
	      var refreshTokenString = localStorage.getItem('authRefreshToken');
	      if (refreshTokenString === 'undefined') refreshTokenString = undefined;
	
	      var refreshToken = refreshTokenString;
	      return refreshToken;
	    }
	  }, {
	    key: 'getTokenExpiration',
	    value: function getTokenExpiration() {
	      var tokenExpirationString = localStorage.getItem('authHeaderTokenExpiration');
	      if (tokenExpirationString === 'undefined') tokenExpirationString = undefined;
	
	      var tokenExpiration = tokenExpirationString ? new Date(tokenExpirationString) : undefined;
	      return tokenExpiration;
	    }
	  }, {
	    key: 'getTokenRefreshPeriod',
	    value: function getTokenRefreshPeriod() {
	      var currentTime = new Date();
	      var tokenExpiration = this.getTokenExpiration();
	
	      if (tokenExpiration === undefined) return undefined;
	      if (currentTime >= tokenExpiration) return true; // instant user-session refresh()
	
	      var tokenRefreshPeriod = Math.ceil((tokenExpiration.getTime() - currentTime.getTime()) / 2);
	      return tokenRefreshPeriod;
	    }
	  }, {
	    key: 'getHeaders',
	    value: function getHeaders(useAuth) {
	      var headers = {
	        'Access-Control-Allow-Origin': '*'
	      };
	
	      if (useAuth && this.getToken()) {
	        headers['Authorization'] = 'Bearer ' + this.getToken();
	      }
	
	      return headers;
	    }
	  }, {
	    key: 'getBaseUrl',
	    value: function getBaseUrl() {
	      return 'https://api.ridline.com/';
	    }
	  }, {
	    key: 'addInterceptor',
	    value: function addInterceptor(type, url) {
	      var _this = this;
	
	      _axios2.default.interceptors.response.use(function (response) {
	        if (response.request.responseURL === url && response.data.token) {
	          if (type === 'authentication') {
	            _this.setTokenStrings(response);
	          } else if (type === 'registration') {
	            _this.removeTokenStrings();
	            if (response.data.userstatus === 'active') _this.setTokenStrings(response);
	          } else if (type === 'verification') {
	            _this.removeTokenStrings();
	            _this.setTokenStrings(response);
	          }
	        }
	
	        return response;
	      }, function (error) {
	        return Promise.reject(error);
	      });
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.removeTokenStrings();
	    }
	  }, {
	    key: 'login',
	    value: function login(username, password) {
	      var url = this.getBaseUrl() + 'login_check';
	
	      this.addInterceptor('authentication', url);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(false),
	        data: {
	          _username: username,
	          _password: password
	        }
	      });
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var url = this.getBaseUrl() + 'token/refresh';
	
	      this.addInterceptor('authentication', url);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(false),
	        data: {
	          refresh_token: this.getRefreshToken()
	        }
	      });
	    }
	  }, {
	    key: 'getUserRequestInfo',
	    value: function getUserRequestInfo(joinCode) {
	      var url = this.getBaseUrl() + ('user/request_info/' + joinCode);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'get',
	        headers: this.getHeaders(false)
	      });
	    }
	  }, {
	    key: 'register',
	    value: function register(user, requestCode) {
	      var url = this.getBaseUrl() + 'user/register';
	
	      this.addInterceptor('registration', url);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(false),
	        data: {
	          register: {
	            name: user.name,
	            email: user.email,
	            password: user.password,
	            request_code: requestCode
	          }
	        }
	      });
	    }
	  }, {
	    key: 'verifyUserEmail',
	    value: function verifyUserEmail(verificationCode) {
	      var url = this.getBaseUrl() + ('user/verifymail/' + verificationCode);
	
	      this.addInterceptor('verification', url);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(false)
	      });
	    }
	  }, {
	    key: 'getUserData',
	    value: function getUserData() {
	      var url = this.getBaseUrl() + 'user/view';
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'get',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'searchUsers',
	    value: function searchUsers(email) {
	      var url = this.getBaseUrl() + ('user/search?search=' + email);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'get',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'getNotifications',
	    value: function getNotifications(limit, offset) {
	      // const url = this.getBaseUrl() + `user/notifications?limit=${limit}&offset=${offset}`
	      var url = this.getBaseUrl() + 'user/notifications?limit=6&offset=0';
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'get',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'getDashboard',
	    value: function getDashboard() {
	      var url = this.getBaseUrl() + 'dashboard/';
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'get',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'getRiderList',
	    value: function getRiderList() {
	      var url = this.getBaseUrl() + 'rider/list';
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'get',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'createRider',
	    value: function createRider(title) {
	      var url = this.getBaseUrl() + 'rider/create';
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create: {
	            title: title
	          }
	        }
	      });
	    }
	  }, {
	    key: 'viewRider',
	    value: function viewRider(id) {
	      var url = this.getBaseUrl() + 'rider/view/' + id;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'get',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'editRider',
	    value: function editRider(id, data) {
	      var url = this.getBaseUrl() + 'rider/edit/' + id;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'patch',
	        headers: this.getHeaders(true),
	        data: {
	          edit: {
	            title: data.title,
	            description: data.description,
	            artist: data.artist,
	            public: data.publicSharing,
	            link_sharing: data.linkSharing
	          }
	        }
	      });
	    }
	  }, {
	    key: 'shareRider',
	    value: function shareRider(riderId, email) {
	      var url = this.getBaseUrl() + 'rider/share/' + riderId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          share: {
	            email: email,
	            role: 'write'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'removeRiderShare',
	    value: function removeRiderShare(shareId) {
	      var url = this.getBaseUrl() + 'rider/share/' + shareId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'delete',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'deleteRider',
	    value: function deleteRider(riderId) {
	      var url = this.getBaseUrl() + 'rider/delete/' + riderId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'delete',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'moveRiderColumn',
	    value: function moveRiderColumn(column) {
	      var url = this.getBaseUrl() + ('rider/column/move/' + column.id + '/' + column.position);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'patch',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'deleteRiderColumn',
	    value: function deleteRiderColumn(id) {
	      var url = this.getBaseUrl() + 'rider/column/delete/' + id;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'delete',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'createRiderColumn',
	    value: function createRiderColumn(riderId, column) {
	      var url = this.getBaseUrl() + ('rider/column/create/' + riderId);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create: {
	            title: column.title,
	            type: column.type,
	            position: column.position
	          }
	        }
	      });
	    }
	  }, {
	    key: 'createRiderContact',
	    value: function createRiderContact(riderId, contact) {
	      var url = this.getBaseUrl() + 'rider/contact/create/' + riderId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create: {
	            title: contact.title,
	            name: contact.name,
	            description: 'Please add key responsibilities',
	            email: contact.email,
	            phone: contact.phone
	          }
	        }
	      });
	    }
	  }, {
	    key: 'editRiderContact',
	    value: function editRiderContact(contact) {
	      var url = this.getBaseUrl() + 'rider/contact/edit/' + contact.id;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'patch',
	        headers: this.getHeaders(true),
	        data: {
	          edit: {
	            title: contact.title,
	            name: contact.name,
	            description: contact.description,
	            email: contact.email,
	            phone: contact.phone
	          }
	        }
	      });
	    }
	  }, {
	    key: 'deleteRiderContact',
	    value: function deleteRiderContact(contact) {
	      var url = this.getBaseUrl() + 'rider/contact/delete/' + contact.id;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'delete',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'createRiderMember',
	    value: function createRiderMember(riderId, member) {
	      var url = this.getBaseUrl() + 'rider/member/create/' + riderId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create: {
	            name: member.name,
	            email: member.email,
	            phone: member.phone,
	            items: member.items
	          }
	        }
	      });
	    }
	  }, {
	    key: 'editRiderMember',
	    value: function editRiderMember(member) {
	      var url = this.getBaseUrl() + 'rider/member/edit/' + member.id;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'patch',
	        headers: this.getHeaders(true),
	        data: {
	          edit: {
	            name: member.name,
	            email: member.email,
	            phone: member.phone,
	            items: member.items
	          }
	        }
	      });
	    }
	  }, {
	    key: 'moveRiderMember',
	    value: function moveRiderMember(id, position) {
	      var url = this.getBaseUrl() + ('rider/member/move/' + id + '/' + position);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'patch',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'deleteRiderMember',
	    value: function deleteRiderMember(member) {
	      var url = this.getBaseUrl() + 'rider/member/delete/' + member.id;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'delete',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'createRiderItem',
	    value: function createRiderItem(riderId, item) {
	      var url = this.getBaseUrl() + 'rider/item/create/' + riderId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create: {
	            type: item.type,
	            group: item.group,
	            class: item.class,
	            position: item.position,
	            value: item.value,
	            title: item.title,
	            content: item.content,
	            parent: item.parent,
	            relation: item.relation,
	            params: item.params,
	            member: item.member
	          }
	        }
	      });
	    }
	  }, {
	    key: 'createRiderItems',
	    value: function createRiderItems(riderId, parent, items) {
	      var url = this.getBaseUrl() + 'rider/item/create_multi/' + riderId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create_multi: {
	            parent: parent,
	            items: items
	          }
	        }
	      });
	    }
	  }, {
	    key: 'cloneRiderItem',
	    value: function cloneRiderItem(riderId, _ref) {
	      var parent_create = _ref.parent_create,
	          parent = _ref.parent,
	          clone_item = _ref.clone_item,
	          clone_count = _ref.clone_count,
	          delete_cloned = _ref.delete_cloned;
	
	      var url = this.getBaseUrl() + 'rider/item/clone/' + riderId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          clone_item: {
	            parent_create: parent_create,
	            parent: parent,
	            clone_item: clone_item,
	            clone_count: clone_count,
	            delete_cloned: delete_cloned
	          }
	        }
	      });
	    }
	  }, {
	    key: 'editRiderItem',
	    value: function editRiderItem(item) {
	      var url = this.getBaseUrl() + 'rider/item/edit/' + item.id;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'patch',
	        headers: this.getHeaders(true),
	        data: {
	          edit: {
	            type: item.type,
	            group: item.group,
	            class: item.class,
	            position: item.position,
	            value: item.value,
	            title: item.title,
	            content: item.content,
	            params: item.params,
	            parent: item.parent,
	            relation: item.relation,
	            required: item.required,
	            member: item.member
	          }
	        }
	      });
	    }
	  }, {
	    key: 'moveRiderItem',
	    value: function moveRiderItem(id, position) {
	      var url = this.getBaseUrl() + ('rider/item/move/' + id + '/' + position);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'patch',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'deleteRiderItem',
	    value: function deleteRiderItem(id) {
	      var url = this.getBaseUrl() + 'rider/item/delete/' + id;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'delete',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'createRiderStageplan',
	    value: function createRiderStageplan(riderId, stageplan) {
	      var url = this.getBaseUrl() + 'rider/stageplan/create/' + riderId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create: {
	            title: stageplan.title,
	            description: stageplan.description,
	            width: stageplan.width,
	            height: stageplan.height
	          }
	        }
	      });
	    }
	  }, {
	    key: 'editRiderStageplan',
	    value: function editRiderStageplan(stageplan) {
	      var url = this.getBaseUrl() + 'rider/stageplan/edit/' + stageplan.id;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'patch',
	        headers: this.getHeaders(true),
	        data: {
	          edit: {
	            title: stageplan.title,
	            description: stageplan.description,
	            width: stageplan.width,
	            height: stageplan.height
	          }
	        }
	      });
	    }
	  }, {
	    key: 'viewRiderStageplan',
	    value: function viewRiderStageplan(stageplanId) {
	      var url = this.getBaseUrl() + 'rider/stageplan/view/' + stageplanId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'get',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'deleteRiderStageplan',
	    value: function deleteRiderStageplan(stageplanId) {
	      var url = this.getBaseUrl() + 'rider/stageplan/delete/' + stageplanId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'delete',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'createRiderStageplanItem',
	    value: function createRiderStageplanItem(stageplanId, item) {
	      var url = this.getBaseUrl() + 'rider/stageplan/item/create/' + stageplanId + '/' + item.type;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create: {
	            top: item.top,
	            left: item.left,
	            width: item.width,
	            height: item.height,
	            rotation: item.rotation,
	            icon: item.icon,
	            title: item.title, // type === 'custom'
	            description: item.description, // type === 'custom'
	            rider_item: item.riderItemId, // type === 'rider_item'
	            rider_member: item.riderMemberId, // type === 'rider_member'
	            params: item.params
	          }
	        }
	      });
	    }
	  }, {
	    key: 'editRiderStageplanItem',
	    value: function editRiderStageplanItem(item) {
	      var url = this.getBaseUrl() + 'rider/stageplan/item/edit/' + item.id;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'patch',
	        headers: this.getHeaders(true),
	        data: {
	          edit: {
	            top: item.top,
	            left: item.left,
	            width: item.width,
	            height: item.height,
	            rotation: item.rotation,
	            icon: item.icon,
	            title: item.title, // type === 'custom'
	            description: item.description, // type === 'custom'
	            rider_item: item.rider_item && item.rider_item.id, // type === 'rider_item'
	            rider_member: item.rider_member, // type === 'rider_member'
	            params: item.params
	          }
	        }
	      });
	    }
	  }, {
	    key: 'deleteRiderStageplanItem',
	    value: function deleteRiderStageplanItem(itemId) {
	      var url = this.getBaseUrl() + 'rider/stageplan/item/delete/' + itemId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'delete',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'getStageElements',
	    value: function getStageElements() {
	      var url = this.getBaseUrl() + 'stage_element/list';
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'get',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'createStageElement',
	    value: function createStageElement(data) {
	      var url = this.getBaseUrl() + 'stage_element/create';
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create: {
	            title: data.title,
	            group: data.group
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getEventList',
	    value: function getEventList() {
	      var url = this.getBaseUrl() + 'event/list';
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'get',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'viewEvent',
	    value: function viewEvent(id) {
	      var url = this.getBaseUrl() + 'event/view/' + id;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'get',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'createEvent',
	    value: function createEvent(event) {
	      var url = this.getBaseUrl() + 'event/create';
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create: {
	            title: event.title,
	            start: event.start,
	            end: event.end
	          }
	        }
	      });
	    }
	  }, {
	    key: 'editEvent',
	    value: function editEvent(eventId, data) {
	      var url = this.getBaseUrl() + ('event/edit/' + eventId);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'patch',
	        headers: this.getHeaders(true),
	        data: {
	          edit: {
	            title: data.title
	          }
	        }
	      });
	    }
	  }, {
	    key: 'deleteEvent',
	    value: function deleteEvent(eventId) {
	      var url = this.getBaseUrl() + ('event/delete/' + eventId);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'delete',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'deleteEventStage',
	    value: function deleteEventStage(stageId) {
	      var url = this.getBaseUrl() + ('event/stage/delete/' + stageId);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'delete',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'createEventStage',
	    value: function createEventStage(eventId, stage) {
	      var url = this.getBaseUrl() + 'event/stage/create/' + eventId;
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create: {
	            title: stage.title
	          }
	        }
	      });
	    }
	  }, {
	    key: 'createEventUser',
	    value: function createEventUser(eventId, user) {
	      var url = this.getBaseUrl() + ('event/user/create/' + eventId);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create: {
	            email: user.email,
	            role: user.role
	          }
	        }
	      });
	    }
	  }, {
	    key: 'deleteEventUser',
	    value: function deleteEventUser(eventId, userId) {
	      var url = this.getBaseUrl() + ('event/user/delete/' + eventId + '/' + userId);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'delete',
	        headers: this.getHeaders(true)
	      });
	    }
	  }, {
	    key: 'createRiderRequest',
	    value: function createRiderRequest(eventId, request) {
	      var url = this.getBaseUrl() + ('event/rider_request/create/' + eventId);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          create: {
	            email: request.email,
	            title: request.title,
	            description: request.description,
	            stage: request.stage
	          }
	        }
	      });
	    }
	  }, {
	    key: 'fulfillRiderRequest',
	    value: function fulfillRiderRequest(requestId, riderId) {
	      var url = this.getBaseUrl() + ('event/rider_request/fulfill/' + requestId);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'post',
	        headers: this.getHeaders(true),
	        data: {
	          fulfill: {
	            rider: riderId
	          }
	        }
	      });
	    }
	  }, {
	    key: 'deleteRiderRequest',
	    value: function deleteRiderRequest(requestId) {
	      var url = this.getBaseUrl() + ('event/rider_request/delete/' + requestId);
	
	      return (0, _axios2.default)({
	        url: url,
	        method: 'delete',
	        headers: this.getHeaders(true)
	      });
	    }
	  }]);
	
	  return Api;
	}();
	
	exports.default = Api;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(245);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(598);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(597);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(596);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(244);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(246);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(568);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(569);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(228);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(570);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(571);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(572);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(573);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(229);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(142);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(574);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(575);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(576);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(577);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearAllAlerts = exports.clearAlert = exports.setAlert = exports.CLEAR_ALL_ALERTS = exports.CLEAR_ALERT = exports.SET_ALERT = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _rider = __webpack_require__(21);
	
	var SET_ALERT = exports.SET_ALERT = (0, _reduxActions.createAction)('SET_ALERT');
	var CLEAR_ALERT = exports.CLEAR_ALERT = (0, _reduxActions.createAction)('CLEAR_ALERT');
	var CLEAR_ALL_ALERTS = exports.CLEAR_ALL_ALERTS = (0, _reduxActions.createAction)('CLEAR_ALL_ALERTS');
	
	var setAlert = exports.setAlert = function setAlert() {
	  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var link = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	  var status = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
	
	  return function (dispatch) {
	    if (type) dispatch((0, _rider.RIDER_SAVING)({ type: type }));
	
	    dispatch(SET_ALERT({ message: message, link: link, type: type, status: status }));
	  };
	};
	
	var clearAlert = exports.clearAlert = function clearAlert(index) {
	  return function (dispatch) {
	    dispatch((0, _rider.RIDER_SAVING)());
	
	    dispatch(CLEAR_ALERT({ index: index }));
	  };
	};
	
	var clearAllAlerts = exports.clearAllAlerts = function clearAllAlerts() {
	  return function (dispatch) {
	    dispatch(CLEAR_ALL_ALERTS());
	  };
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.closest = exports.distance = exports.patch = exports.absolute = exports.negate = exports.isEqual = exports.subtract = exports.add = undefined;
	
	var _toConsumableArray2 = __webpack_require__(97);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var add = exports.add = function add(point1, point2) {
	  return {
	    x: point1.x + point2.x,
	    y: point1.y + point2.y
	  };
	};
	
	var subtract = exports.subtract = function subtract(point1, point2) {
	  return {
	    x: point1.x - point2.x,
	    y: point1.y - point2.y
	  };
	};
	
	var isEqual = exports.isEqual = function isEqual(point1, point2) {
	  return point1.x === point2.x && point1.y === point2.y;
	};
	
	var negate = exports.negate = function negate(point) {
	  return {
	    x: point.x !== 0 ? -point.x : 0,
	    y: point.y !== 0 ? -point.y : 0
	  };
	};
	
	var absolute = exports.absolute = function absolute(point) {
	  return {
	    x: Math.abs(point.x),
	    y: Math.abs(point.y)
	  };
	};
	
	var patch = exports.patch = function patch(line, value) {
	  var _ref;
	
	  var otherValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  return _ref = {}, (0, _defineProperty3.default)(_ref, line, value), (0, _defineProperty3.default)(_ref, line === 'x' ? 'y' : 'x', otherValue), _ref;
	};
	
	var distance = exports.distance = function distance(point1, point2) {
	  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
	};
	
	var closest = exports.closest = function closest(target, points) {
	  return Math.min.apply(Math, (0, _toConsumableArray3.default)(points.map(function (point) {
	    return distance(target, point);
	  })));
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(545);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(153);
	var isBuffer = __webpack_require__(447);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 17 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.4' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (resultFn) {
	  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;
	
	  var lastThis = void 0;
	  var lastArgs = [];
	  var lastResult = void 0;
	  var calledOnce = false;
	
	  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
	    return isEqual(newArg, lastArgs[index]);
	  };
	
	  var result = function result() {
	    for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
	      newArgs[_key] = arguments[_key];
	    }
	
	    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
	      return lastResult;
	    }
	
	    calledOnce = true;
	    lastThis = this;
	    lastArgs = newArgs;
	    lastResult = resultFn.apply(this, newArgs);
	    return lastResult;
	  };
	
	  return result;
	};
	
	var simpleIsEqual = function simpleIsEqual(a, b) {
	  return a === b;
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(86);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(231);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(585);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(232);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(234);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(233);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(146);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(235);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(236);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(145);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deleteRider = exports.exportRider = exports.removeRiderShare = exports.shareRider = exports.editRider = exports.createRider = exports.fetchRider = exports.DELETE_RIDER = exports.RECEIVE_RIDER_EXPORT = exports.REQUEST_RIDER_EXPORT = exports.REMOVE_RIDER_SHARE = exports.SHARE_RIDER = exports.EDIT_RIDER = exports.CREATE_RIDER = exports.RECEIVE_RIDER = exports.REQUEST_RIDER = exports.RIDER_SAVING = exports.SAVE_RIDER = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _export = __webpack_require__(281);
	
	var _alerts = __webpack_require__(13);
	
	var _riderItem = __webpack_require__(91);
	
	var _riderStageplan = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SAVE_RIDER = exports.SAVE_RIDER = (0, _reduxActions.createAction)('SAVE_RIDER');
	var RIDER_SAVING = exports.RIDER_SAVING = (0, _reduxActions.createAction)('RIDER_SAVING');
	
	var REQUEST_RIDER = exports.REQUEST_RIDER = (0, _reduxActions.createAction)('REQUEST_RIDER');
	var RECEIVE_RIDER = exports.RECEIVE_RIDER = (0, _reduxActions.createAction)('RECEIVE_RIDER');
	var CREATE_RIDER = exports.CREATE_RIDER = (0, _reduxActions.createAction)('CREATE_RIDER');
	var EDIT_RIDER = exports.EDIT_RIDER = (0, _reduxActions.createAction)('EDIT_RIDER');
	var SHARE_RIDER = exports.SHARE_RIDER = (0, _reduxActions.createAction)('SHARE_RIDER');
	var REMOVE_RIDER_SHARE = exports.REMOVE_RIDER_SHARE = (0, _reduxActions.createAction)('REMOVE_RIDER_SHARE');
	var REQUEST_RIDER_EXPORT = exports.REQUEST_RIDER_EXPORT = (0, _reduxActions.createAction)('REQUEST_RIDER_EXPORT');
	var RECEIVE_RIDER_EXPORT = exports.RECEIVE_RIDER_EXPORT = (0, _reduxActions.createAction)('RECEIVE_RIDER_EXPORT');
	var DELETE_RIDER = exports.DELETE_RIDER = (0, _reduxActions.createAction)('DELETE_RIDER');
	
	var fetchRider = exports.fetchRider = function fetchRider(id) {
	  return function (dispatch) {
	    dispatch(REQUEST_RIDER());
	
	    return _Api2.default.viewRider(id).then(function (response) {
	      return dispatch(RECEIVE_RIDER({ data: response.data }));
	    }).catch(function (error) {
	      dispatch(RECEIVE_RIDER(error.response));
	      dispatch((0, _alerts.setAlert)(error.response.data.message, undefined, 'error'));
	    });
	  };
	};
	
	var createRider = exports.createRider = function createRider(title) {
	  return function (dispatch) {
	    dispatch(SAVE_RIDER());
	
	    return _Api2.default.createRider(title).then(function (response) {
	      dispatch(CREATE_RIDER({ data: response.data }));
	
	      var id = response.data.id;
	
	
	      dispatch((0, _riderItem.createRiderItems)(id, {
	        class: 'instrument',
	        group: 'input',
	        type: 'guitar',
	        title: 'Your first demo guitar',
	        position: 1
	      }, [{
	        class: 'equipment',
	        group: 'input',
	        type: 'microphone',
	        title: 'Microphone',
	        position: 1
	      }, {
	        class: 'equipment',
	        group: 'input',
	        type: 'stand',
	        title: 'Stand',
	        position: 2
	      }, {
	        class: 'equipment',
	        group: 'input',
	        type: 'cable',
	        title: 'Cable',
	        position: 3
	      }, {
	        class: 'equipment',
	        group: 'input',
	        type: 'insert',
	        title: 'Insert',
	        position: 4
	      }]));
	
	      dispatch((0, _riderItem.createRiderItems)(id, null, [{
	        group: 'output',
	        class: 'monitor',
	        type: 'monitor',
	        title: 'Monitor'
	      }, {
	        group: 'output',
	        class: 'monitor',
	        type: 'monitor',
	        title: 'Monitor'
	      }, {
	        group: 'output',
	        class: 'monitor',
	        type: 'monitor',
	        title: 'Monitor'
	      }]));
	
	      dispatch((0, _riderStageplan.createRiderStageplan)(id, {
	        title: 'minu stageplan',
	        description: 'stageplani kirjeldus',
	        width: '1000',
	        height: '500'
	      }));
	    }).catch(function (error) {
	      return dispatch((0, _alerts.setAlert)('Sorry, we were unable to create this rider.', undefined, 'error'));
	    });
	  };
	};
	
	var editRider = exports.editRider = function editRider(id, data) {
	  return function (dispatch) {
	    dispatch(SAVE_RIDER());
	
	    return dispatch(EDIT_RIDER(_Api2.default.editRider(id, data)));
	  };
	};
	
	var shareRider = exports.shareRider = function shareRider(riderId, email) {
	  return function (dispatch) {
	    dispatch(SAVE_RIDER());
	
	    return dispatch(SHARE_RIDER(_Api2.default.shareRider(riderId, email)));
	  };
	};
	
	var removeRiderShare = exports.removeRiderShare = function removeRiderShare(riderId, email) {
	  return function (dispatch) {
	    dispatch(SAVE_RIDER());
	
	    return dispatch(REMOVE_RIDER_SHARE(_Api2.default.removeRiderShare(riderId, email)));
	  };
	};
	
	var exportRider = exports.exportRider = function exportRider(selector) {
	  return function (dispatch) {
	    dispatch(REQUEST_RIDER_EXPORT());
	
	    return (0, _export.exportPDF)(selector).then(function (response) {
	      dispatch(RECEIVE_RIDER_EXPORT({ data: response.data }));
	      dispatch((0, _alerts.setAlert)('We have successfully exported your rider', undefined, 'success'));
	    }).catch(function (error) {
	      return dispatch((0, _alerts.setAlert)('Sorry, we were unable to export this rider.', undefined, 'error'));
	    });
	  };
	};
	
	var deleteRider = exports.deleteRider = function deleteRider(riderId) {
	  return function (dispatch) {
	    dispatch(SAVE_RIDER());
	
	    return dispatch(DELETE_RIDER(_Api2.default.deleteRider(riderId)));
	  };
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(108)('wks');
	var uid = __webpack_require__(75);
	var Symbol = __webpack_require__(29).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(366), __esModule: true };

/***/ },
/* 24 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(170);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(358);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(357);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(98);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(98);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(29);
	var core = __webpack_require__(17);
	var ctx = __webpack_require__(100);
	var hide = __webpack_require__(50);
	var has = __webpack_require__(38);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 29 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(48);
	var IE8_DOM_DEFINE = __webpack_require__(172);
	var toPrimitive = __webpack_require__(110);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(37) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 31 */
/***/ function(module, exports) {

	'use strict';
	
	// http://dev.w3.org/csswg/css-color/
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HEX3 = /^#([a-f0-9]{3})$/i;
	var hex3 = function hex3(value) {
	    var match = value.match(HEX3);
	    if (match) {
	        return [parseInt(match[1][0] + match[1][0], 16), parseInt(match[1][1] + match[1][1], 16), parseInt(match[1][2] + match[1][2], 16), null];
	    }
	    return false;
	};
	
	var HEX6 = /^#([a-f0-9]{6})$/i;
	var hex6 = function hex6(value) {
	    var match = value.match(HEX6);
	    if (match) {
	        return [parseInt(match[1].substring(0, 2), 16), parseInt(match[1].substring(2, 4), 16), parseInt(match[1].substring(4, 6), 16), null];
	    }
	    return false;
	};
	
	var RGB = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
	var rgb = function rgb(value) {
	    var match = value.match(RGB);
	    if (match) {
	        return [Number(match[1]), Number(match[2]), Number(match[3]), null];
	    }
	    return false;
	};
	
	var RGBA = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;
	var rgba = function rgba(value) {
	    var match = value.match(RGBA);
	    if (match && match.length > 4) {
	        return [Number(match[1]), Number(match[2]), Number(match[3]), Number(match[4])];
	    }
	    return false;
	};
	
	var fromArray = function fromArray(array) {
	    return [Math.min(array[0], 255), Math.min(array[1], 255), Math.min(array[2], 255), array.length > 3 ? array[3] : null];
	};
	
	var namedColor = function namedColor(name) {
	    var color = NAMED_COLORS[name.toLowerCase()];
	    return color ? color : false;
	};
	
	var Color = function () {
	    function Color(value) {
	        _classCallCheck(this, Color);
	
	        var _ref = Array.isArray(value) ? fromArray(value) : hex3(value) || rgb(value) || rgba(value) || namedColor(value) || hex6(value) || [0, 0, 0, null],
	            _ref2 = _slicedToArray(_ref, 4),
	            r = _ref2[0],
	            g = _ref2[1],
	            b = _ref2[2],
	            a = _ref2[3];
	
	        this.r = r;
	        this.g = g;
	        this.b = b;
	        this.a = a;
	    }
	
	    _createClass(Color, [{
	        key: 'isTransparent',
	        value: function isTransparent() {
	            return this.a === 0;
	        }
	    }, {
	        key: 'toString',
	        value: function toString() {
	            return this.a !== null && this.a !== 1 ? 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',' + this.a + ')' : 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')';
	        }
	    }]);
	
	    return Color;
	}();
	
	exports.default = Color;
	
	
	var NAMED_COLORS = {
	    transparent: [0, 0, 0, 0],
	    aliceblue: [240, 248, 255, null],
	    antiquewhite: [250, 235, 215, null],
	    aqua: [0, 255, 255, null],
	    aquamarine: [127, 255, 212, null],
	    azure: [240, 255, 255, null],
	    beige: [245, 245, 220, null],
	    bisque: [255, 228, 196, null],
	    black: [0, 0, 0, null],
	    blanchedalmond: [255, 235, 205, null],
	    blue: [0, 0, 255, null],
	    blueviolet: [138, 43, 226, null],
	    brown: [165, 42, 42, null],
	    burlywood: [222, 184, 135, null],
	    cadetblue: [95, 158, 160, null],
	    chartreuse: [127, 255, 0, null],
	    chocolate: [210, 105, 30, null],
	    coral: [255, 127, 80, null],
	    cornflowerblue: [100, 149, 237, null],
	    cornsilk: [255, 248, 220, null],
	    crimson: [220, 20, 60, null],
	    cyan: [0, 255, 255, null],
	    darkblue: [0, 0, 139, null],
	    darkcyan: [0, 139, 139, null],
	    darkgoldenrod: [184, 134, 11, null],
	    darkgray: [169, 169, 169, null],
	    darkgreen: [0, 100, 0, null],
	    darkgrey: [169, 169, 169, null],
	    darkkhaki: [189, 183, 107, null],
	    darkmagenta: [139, 0, 139, null],
	    darkolivegreen: [85, 107, 47, null],
	    darkorange: [255, 140, 0, null],
	    darkorchid: [153, 50, 204, null],
	    darkred: [139, 0, 0, null],
	    darksalmon: [233, 150, 122, null],
	    darkseagreen: [143, 188, 143, null],
	    darkslateblue: [72, 61, 139, null],
	    darkslategray: [47, 79, 79, null],
	    darkslategrey: [47, 79, 79, null],
	    darkturquoise: [0, 206, 209, null],
	    darkviolet: [148, 0, 211, null],
	    deeppink: [255, 20, 147, null],
	    deepskyblue: [0, 191, 255, null],
	    dimgray: [105, 105, 105, null],
	    dimgrey: [105, 105, 105, null],
	    dodgerblue: [30, 144, 255, null],
	    firebrick: [178, 34, 34, null],
	    floralwhite: [255, 250, 240, null],
	    forestgreen: [34, 139, 34, null],
	    fuchsia: [255, 0, 255, null],
	    gainsboro: [220, 220, 220, null],
	    ghostwhite: [248, 248, 255, null],
	    gold: [255, 215, 0, null],
	    goldenrod: [218, 165, 32, null],
	    gray: [128, 128, 128, null],
	    green: [0, 128, 0, null],
	    greenyellow: [173, 255, 47, null],
	    grey: [128, 128, 128, null],
	    honeydew: [240, 255, 240, null],
	    hotpink: [255, 105, 180, null],
	    indianred: [205, 92, 92, null],
	    indigo: [75, 0, 130, null],
	    ivory: [255, 255, 240, null],
	    khaki: [240, 230, 140, null],
	    lavender: [230, 230, 250, null],
	    lavenderblush: [255, 240, 245, null],
	    lawngreen: [124, 252, 0, null],
	    lemonchiffon: [255, 250, 205, null],
	    lightblue: [173, 216, 230, null],
	    lightcoral: [240, 128, 128, null],
	    lightcyan: [224, 255, 255, null],
	    lightgoldenrodyellow: [250, 250, 210, null],
	    lightgray: [211, 211, 211, null],
	    lightgreen: [144, 238, 144, null],
	    lightgrey: [211, 211, 211, null],
	    lightpink: [255, 182, 193, null],
	    lightsalmon: [255, 160, 122, null],
	    lightseagreen: [32, 178, 170, null],
	    lightskyblue: [135, 206, 250, null],
	    lightslategray: [119, 136, 153, null],
	    lightslategrey: [119, 136, 153, null],
	    lightsteelblue: [176, 196, 222, null],
	    lightyellow: [255, 255, 224, null],
	    lime: [0, 255, 0, null],
	    limegreen: [50, 205, 50, null],
	    linen: [250, 240, 230, null],
	    magenta: [255, 0, 255, null],
	    maroon: [128, 0, 0, null],
	    mediumaquamarine: [102, 205, 170, null],
	    mediumblue: [0, 0, 205, null],
	    mediumorchid: [186, 85, 211, null],
	    mediumpurple: [147, 112, 219, null],
	    mediumseagreen: [60, 179, 113, null],
	    mediumslateblue: [123, 104, 238, null],
	    mediumspringgreen: [0, 250, 154, null],
	    mediumturquoise: [72, 209, 204, null],
	    mediumvioletred: [199, 21, 133, null],
	    midnightblue: [25, 25, 112, null],
	    mintcream: [245, 255, 250, null],
	    mistyrose: [255, 228, 225, null],
	    moccasin: [255, 228, 181, null],
	    navajowhite: [255, 222, 173, null],
	    navy: [0, 0, 128, null],
	    oldlace: [253, 245, 230, null],
	    olive: [128, 128, 0, null],
	    olivedrab: [107, 142, 35, null],
	    orange: [255, 165, 0, null],
	    orangered: [255, 69, 0, null],
	    orchid: [218, 112, 214, null],
	    palegoldenrod: [238, 232, 170, null],
	    palegreen: [152, 251, 152, null],
	    paleturquoise: [175, 238, 238, null],
	    palevioletred: [219, 112, 147, null],
	    papayawhip: [255, 239, 213, null],
	    peachpuff: [255, 218, 185, null],
	    peru: [205, 133, 63, null],
	    pink: [255, 192, 203, null],
	    plum: [221, 160, 221, null],
	    powderblue: [176, 224, 230, null],
	    purple: [128, 0, 128, null],
	    rebeccapurple: [102, 51, 153, null],
	    red: [255, 0, 0, null],
	    rosybrown: [188, 143, 143, null],
	    royalblue: [65, 105, 225, null],
	    saddlebrown: [139, 69, 19, null],
	    salmon: [250, 128, 114, null],
	    sandybrown: [244, 164, 96, null],
	    seagreen: [46, 139, 87, null],
	    seashell: [255, 245, 238, null],
	    sienna: [160, 82, 45, null],
	    silver: [192, 192, 192, null],
	    skyblue: [135, 206, 235, null],
	    slateblue: [106, 90, 205, null],
	    slategray: [112, 128, 144, null],
	    slategrey: [112, 128, 144, null],
	    snow: [255, 250, 250, null],
	    springgreen: [0, 255, 127, null],
	    steelblue: [70, 130, 180, null],
	    tan: [210, 180, 140, null],
	    teal: [0, 128, 128, null],
	    thistle: [216, 191, 216, null],
	    tomato: [255, 99, 71, null],
	    turquoise: [64, 224, 208, null],
	    violet: [238, 130, 238, null],
	    wheat: [245, 222, 179, null],
	    white: [255, 255, 255, null],
	    whitesmoke: [245, 245, 245, null],
	    yellow: [255, 255, 0, null],
	    yellowgreen: [154, 205, 50, null]
	};
	
	var TRANSPARENT = exports.TRANSPARENT = new Color([0, 0, 0, 0]);

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(204);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearModal = exports.setModal = exports.CLEAR_MODAL = exports.SET_MODAL = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var SET_MODAL = exports.SET_MODAL = (0, _reduxActions.createAction)('SET_MODAL');
	var CLEAR_MODAL = exports.CLEAR_MODAL = (0, _reduxActions.createAction)('CLEAR_MODAL');
	
	var setModal = exports.setModal = function setModal(name, data) {
	  return function (dispatch) {
	    return new Promise(function (resolve, reject) {
	      dispatch(SET_MODAL({ name: name, data: data }));
	      resolve();
	    });
	  };
	};
	
	var clearModal = exports.clearModal = function clearModal() {
	  return function (dispatch) {
	    dispatch(CLEAR_MODAL());
	  };
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUserData = exports.verifyUserEmail = exports.userRegister = exports.getUserRequestInfo = exports.removeUserSession = exports.checkUserSession = exports.setUserSession = exports.RECEIVE_USER_DATA = exports.REQUEST_USER_DATA = exports.VERIFY_USER_EMAIL = exports.REGISTER_USER = exports.RECEIVE_USER_REQUEST_INFO = exports.REMOVE_USER_SESSION = exports.CHECK_USER_SESSION = exports.RECEIVE_USER_SESSION = exports.REQUEST_USER_SESSION = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _alerts = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUEST_USER_SESSION = exports.REQUEST_USER_SESSION = (0, _reduxActions.createAction)('REQUEST_USER_SESSION');
	var RECEIVE_USER_SESSION = exports.RECEIVE_USER_SESSION = (0, _reduxActions.createAction)('RECEIVE_USER_SESSION', function (session) {
	  return session;
	});
	var CHECK_USER_SESSION = exports.CHECK_USER_SESSION = (0, _reduxActions.createAction)('CHECK_USER_SESSION', function (session) {
	  return session;
	});
	var REMOVE_USER_SESSION = exports.REMOVE_USER_SESSION = (0, _reduxActions.createAction)('REMOVE_USER_SESSION');
	var RECEIVE_USER_REQUEST_INFO = exports.RECEIVE_USER_REQUEST_INFO = (0, _reduxActions.createAction)('RECEIVE_USER_REQUEST_INFO');
	var REGISTER_USER = exports.REGISTER_USER = (0, _reduxActions.createAction)('REGISTER_USER', function (session) {
	  return session;
	});
	var VERIFY_USER_EMAIL = exports.VERIFY_USER_EMAIL = (0, _reduxActions.createAction)('VERIFY_USER_EMAIL');
	var REQUEST_USER_DATA = exports.REQUEST_USER_DATA = (0, _reduxActions.createAction)('REQUEST_USER_DATA');
	var RECEIVE_USER_DATA = exports.RECEIVE_USER_DATA = (0, _reduxActions.createAction)('RECEIVE_USER_DATA', function (session) {
	  return session;
	});
	
	var setUserSession = exports.setUserSession = function setUserSession(username, password) {
	  return function (dispatch) {
	    dispatch(REQUEST_USER_SESSION());
	
	    return _Api2.default.login(username, password).then(function (response) {
	      return dispatch(RECEIVE_USER_SESSION({ data: response.data }));
	    }).catch(function (error) {
	      dispatch(RECEIVE_USER_SESSION({ data: error.response.data }));
	      dispatch((0, _alerts.setAlert)(error.response.data.message, undefined, 'error'));
	    });
	  };
	};
	
	var checkUserSession = exports.checkUserSession = function checkUserSession() {
	  return function (dispatch) {
	    dispatch(CHECK_USER_SESSION({
	      data: {
	        token: _Api2.default.getToken()
	      }
	    }));
	  };
	};
	
	var removeUserSession = exports.removeUserSession = function removeUserSession() {
	  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  _Api2.default.logout();
	
	  return function (dispatch) {
	    dispatch(REMOVE_USER_SESSION({
	      error: error
	    }));
	  };
	};
	
	var getUserRequestInfo = exports.getUserRequestInfo = function getUserRequestInfo(joinCode) {
	  return function (dispatch) {
	    return _Api2.default.getUserRequestInfo(joinCode).then(function (response) {
	      return dispatch(RECEIVE_USER_REQUEST_INFO({ data: response.data }));
	    }).catch(function (error) {
	      return dispatch(RECEIVE_USER_REQUEST_INFO(error.response));
	    });
	  };
	};
	
	var userRegister = exports.userRegister = function userRegister(user, requestCode) {
	  return function (dispatch) {
	    return dispatch(REGISTER_USER(_Api2.default.register(user, requestCode)));
	  };
	};
	
	var verifyUserEmail = exports.verifyUserEmail = function verifyUserEmail(code) {
	  return function (dispatch) {
	    return _Api2.default.verifyUserEmail(code).then(function (response) {
	      return dispatch(VERIFY_USER_EMAIL({ data: response.data }));
	    }).catch(function (error) {
	      return dispatch(VERIFY_USER_EMAIL(error.response));
	    });
	  };
	};
	
	var getUserData = exports.getUserData = function getUserData() {
	  return function (dispatch) {
	    dispatch(REQUEST_USER_DATA());
	
	    return dispatch(RECEIVE_USER_DATA(_Api2.default.getUserData()));
	  };
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(367), __esModule: true };

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(356);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(49)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 38 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseBoundCurves = exports.calculatePaddingBoxPath = exports.calculateBorderBoxPath = exports.parsePathForBorder = exports.parseDocumentSize = exports.calculateContentBox = exports.calculatePaddingBox = exports.parseBounds = exports.Bounds = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Vector = __webpack_require__(81);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	var _BezierCurve = __webpack_require__(430);
	
	var _BezierCurve2 = _interopRequireDefault(_BezierCurve);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TOP = 0;
	var RIGHT = 1;
	var BOTTOM = 2;
	var LEFT = 3;
	
	var H = 0;
	var V = 1;
	
	var Bounds = exports.Bounds = function () {
	    function Bounds(x, y, w, h) {
	        _classCallCheck(this, Bounds);
	
	        this.left = x;
	        this.top = y;
	        this.width = w;
	        this.height = h;
	    }
	
	    _createClass(Bounds, null, [{
	        key: 'fromClientRect',
	        value: function fromClientRect(clientRect, scrollX, scrollY) {
	            return new Bounds(clientRect.left + scrollX, clientRect.top + scrollY, clientRect.width, clientRect.height);
	        }
	    }]);
	
	    return Bounds;
	}();
	
	var parseBounds = exports.parseBounds = function parseBounds(node, scrollX, scrollY) {
	    return Bounds.fromClientRect(node.getBoundingClientRect(), scrollX, scrollY);
	};
	
	var calculatePaddingBox = exports.calculatePaddingBox = function calculatePaddingBox(bounds, borders) {
	    return new Bounds(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth));
	};
	
	var calculateContentBox = exports.calculateContentBox = function calculateContentBox(bounds, padding, borders) {
	    // TODO support percentage paddings
	    var paddingTop = padding[TOP].value;
	    var paddingRight = padding[RIGHT].value;
	    var paddingBottom = padding[BOTTOM].value;
	    var paddingLeft = padding[LEFT].value;
	
	    return new Bounds(bounds.left + paddingLeft + borders[LEFT].borderWidth, bounds.top + paddingTop + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth + paddingLeft + paddingRight), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth + paddingTop + paddingBottom));
	};
	
	var parseDocumentSize = exports.parseDocumentSize = function parseDocumentSize(document) {
	    var body = document.body;
	    var documentElement = document.documentElement;
	
	    if (!body || !documentElement) {
	        throw new Error( false ? 'Unable to get document size' : '');
	    }
	    var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
	
	    var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
	
	    return new Bounds(0, 0, width, height);
	};
	
	var parsePathForBorder = exports.parsePathForBorder = function parsePathForBorder(curves, borderSide) {
	    switch (borderSide) {
	        case TOP:
	            return createPathFromCurves(curves.topLeftOuter, curves.topLeftInner, curves.topRightOuter, curves.topRightInner);
	        case RIGHT:
	            return createPathFromCurves(curves.topRightOuter, curves.topRightInner, curves.bottomRightOuter, curves.bottomRightInner);
	        case BOTTOM:
	            return createPathFromCurves(curves.bottomRightOuter, curves.bottomRightInner, curves.bottomLeftOuter, curves.bottomLeftInner);
	        case LEFT:
	        default:
	            return createPathFromCurves(curves.bottomLeftOuter, curves.bottomLeftInner, curves.topLeftOuter, curves.topLeftInner);
	    }
	};
	
	var createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
	    var path = [];
	    if (outer1 instanceof _BezierCurve2.default) {
	        path.push(outer1.subdivide(0.5, false));
	    } else {
	        path.push(outer1);
	    }
	
	    if (outer2 instanceof _BezierCurve2.default) {
	        path.push(outer2.subdivide(0.5, true));
	    } else {
	        path.push(outer2);
	    }
	
	    if (inner2 instanceof _BezierCurve2.default) {
	        path.push(inner2.subdivide(0.5, true).reverse());
	    } else {
	        path.push(inner2);
	    }
	
	    if (inner1 instanceof _BezierCurve2.default) {
	        path.push(inner1.subdivide(0.5, false).reverse());
	    } else {
	        path.push(inner1);
	    }
	
	    return path;
	};
	
	var calculateBorderBoxPath = exports.calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
	    return [curves.topLeftOuter, curves.topRightOuter, curves.bottomRightOuter, curves.bottomLeftOuter];
	};
	
	var calculatePaddingBoxPath = exports.calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
	    return [curves.topLeftInner, curves.topRightInner, curves.bottomRightInner, curves.bottomLeftInner];
	};
	
	var parseBoundCurves = exports.parseBoundCurves = function parseBoundCurves(bounds, borders, borderRadius) {
	    var tlh = borderRadius[CORNER.TOP_LEFT][H].getAbsoluteValue(bounds.width);
	    var tlv = borderRadius[CORNER.TOP_LEFT][V].getAbsoluteValue(bounds.height);
	    var trh = borderRadius[CORNER.TOP_RIGHT][H].getAbsoluteValue(bounds.width);
	    var trv = borderRadius[CORNER.TOP_RIGHT][V].getAbsoluteValue(bounds.height);
	    var brh = borderRadius[CORNER.BOTTOM_RIGHT][H].getAbsoluteValue(bounds.width);
	    var brv = borderRadius[CORNER.BOTTOM_RIGHT][V].getAbsoluteValue(bounds.height);
	    var blh = borderRadius[CORNER.BOTTOM_LEFT][H].getAbsoluteValue(bounds.width);
	    var blv = borderRadius[CORNER.BOTTOM_LEFT][V].getAbsoluteValue(bounds.height);
	
	    var factors = [];
	    factors.push((tlh + trh) / bounds.width);
	    factors.push((blh + brh) / bounds.width);
	    factors.push((tlv + blv) / bounds.height);
	    factors.push((trv + brv) / bounds.height);
	    var maxFactor = Math.max.apply(Math, factors);
	
	    if (maxFactor > 1) {
	        tlh /= maxFactor;
	        tlv /= maxFactor;
	        trh /= maxFactor;
	        trv /= maxFactor;
	        brh /= maxFactor;
	        brv /= maxFactor;
	        blh /= maxFactor;
	        blv /= maxFactor;
	    }
	
	    var topWidth = bounds.width - trh;
	    var rightHeight = bounds.height - brv;
	    var bottomWidth = bounds.width - brh;
	    var leftHeight = bounds.height - blv;
	
	    return {
	        topLeftOuter: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new _Vector2.default(bounds.left, bounds.top),
	        topLeftInner: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, Math.max(0, tlh - borders[LEFT].borderWidth), Math.max(0, tlv - borders[TOP].borderWidth), CORNER.TOP_LEFT) : new _Vector2.default(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth),
	        topRightOuter: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new _Vector2.default(bounds.left + bounds.width, bounds.top),
	        topRightInner: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borders[LEFT].borderWidth), bounds.top + borders[TOP].borderWidth, topWidth > bounds.width + borders[LEFT].borderWidth ? 0 : trh - borders[LEFT].borderWidth, trv - borders[TOP].borderWidth, CORNER.TOP_RIGHT) : new _Vector2.default(bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + borders[TOP].borderWidth),
	        bottomRightOuter: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new _Vector2.default(bounds.left + bounds.width, bounds.top + bounds.height),
	        bottomRightInner: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borders[LEFT].borderWidth), bounds.top + Math.min(rightHeight, bounds.height + borders[TOP].borderWidth), Math.max(0, brh - borders[RIGHT].borderWidth), brv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_RIGHT) : new _Vector2.default(bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth),
	        bottomLeftOuter: blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new _Vector2.default(bounds.left, bounds.top + bounds.height),
	        bottomLeftInner: blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + leftHeight, Math.max(0, blh - borders[LEFT].borderWidth), blv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_LEFT) : new _Vector2.default(bounds.left + borders[LEFT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth)
	    };
	};
	
	var CORNER = {
	    TOP_LEFT: 0,
	    TOP_RIGHT: 1,
	    BOTTOM_RIGHT: 2,
	    BOTTOM_LEFT: 3
	};
	
	var getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
	    var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
	    var ox = r1 * kappa; // control point offset horizontal
	    var oy = r2 * kappa; // control point offset vertical
	    var xm = x + r1; // x-middle
	    var ym = y + r2; // y-middle
	
	    switch (position) {
	        case CORNER.TOP_LEFT:
	            return new _BezierCurve2.default(new _Vector2.default(x, ym), new _Vector2.default(x, ym - oy), new _Vector2.default(xm - ox, y), new _Vector2.default(xm, y));
	        case CORNER.TOP_RIGHT:
	            return new _BezierCurve2.default(new _Vector2.default(x, y), new _Vector2.default(x + ox, y), new _Vector2.default(xm, ym - oy), new _Vector2.default(xm, ym));
	        case CORNER.BOTTOM_RIGHT:
	            return new _BezierCurve2.default(new _Vector2.default(xm, y), new _Vector2.default(xm, y + oy), new _Vector2.default(x + ox, ym), new _Vector2.default(x, ym));
	        case CORNER.BOTTOM_LEFT:
	        default:
	            return new _BezierCurve2.default(new _Vector2.default(xm, ym), new _Vector2.default(xm - ox, ym), new _Vector2.default(x, y + oy), new _Vector2.default(x, y));
	    }
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.calculateLengthFromValueWithUnit = exports.LENGTH_TYPE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _NodeContainer = __webpack_require__(54);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LENGTH_WITH_UNIT = /([\d.]+)(px|r?em|%)/i;
	
	var LENGTH_TYPE = exports.LENGTH_TYPE = {
	    PX: 0,
	    PERCENTAGE: 1
	};
	
	var Length = function () {
	    function Length(value) {
	        _classCallCheck(this, Length);
	
	        this.type = value.substr(value.length - 1) === '%' ? LENGTH_TYPE.PERCENTAGE : LENGTH_TYPE.PX;
	        var parsedValue = parseFloat(value);
	        if (false) {
	            console.error('Invalid value given for Length: "' + value + '"');
	        }
	        this.value = isNaN(parsedValue) ? 0 : parsedValue;
	    }
	
	    _createClass(Length, [{
	        key: 'isPercentage',
	        value: function isPercentage() {
	            return this.type === LENGTH_TYPE.PERCENTAGE;
	        }
	    }, {
	        key: 'getAbsoluteValue',
	        value: function getAbsoluteValue(parentLength) {
	            return this.isPercentage() ? parentLength * (this.value / 100) : this.value;
	        }
	    }], [{
	        key: 'create',
	        value: function create(v) {
	            return new Length(v);
	        }
	    }]);
	
	    return Length;
	}();
	
	exports.default = Length;
	
	
	var getRootFontSize = function getRootFontSize(container) {
	    var parent = container.parent;
	    return parent ? getRootFontSize(parent) : parseFloat(container.style.font.fontSize);
	};
	
	var calculateLengthFromValueWithUnit = exports.calculateLengthFromValueWithUnit = function calculateLengthFromValueWithUnit(container, value, unit) {
	    switch (unit) {
	        case 'px':
	        case '%':
	            return new Length(value + unit);
	        case 'em':
	        case 'rem':
	            var length = new Length(value);
	            length.value *= unit === 'em' ? parseFloat(container.style.font.fontSize) : getRootFontSize(container);
	            return length;
	        default:
	            // TODO: handle correctly if unknown unit is used
	            return new Length('0');
	    }
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(118),
	    getRawTag = __webpack_require__(473),
	    objectToString = __webpack_require__(478);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    getPrototype = __webpack_require__(472),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(35);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _memoizeOne = __webpack_require__(18);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _memoizeOne2.default)(function (droppable, draggables) {
	  return (0, _keys2.default)(draggables).map(function (id) {
	    return draggables[id];
	  }).filter(function (draggable) {
	    return droppable.id === draggable.droppableId;
	  }).sort(function (a, b) {
	    return a.page.withoutMargin.center[droppable.axis.line] - b.page.withoutMargin.center[droppable.axis.line];
	  });
	});

/***/ },
/* 45 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var prefix = function prefix(key) {
	  return 'private-drag-drop-key-do-not-use-store-' + key;
	};
	
	var storeKey = exports.storeKey = prefix('store');
	var droppableIdKey = exports.droppableIdKey = prefix('droppable-id');

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RIESelect = exports.RIETags = exports.RIENumber = exports.RIETextArea = exports.RIEInput = exports.RIEToggle = undefined;
	
	var _RIEToggle = __webpack_require__(604);
	
	var _RIEToggle2 = _interopRequireDefault(_RIEToggle);
	
	var _RIEStatefulBase2 = __webpack_require__(72);
	
	var _RIEStatefulBase3 = _interopRequireDefault(_RIEStatefulBase2);
	
	var _RIETextArea = __webpack_require__(603);
	
	var _RIETextArea2 = _interopRequireDefault(_RIETextArea);
	
	var _RIENumber = __webpack_require__(600);
	
	var _RIENumber2 = _interopRequireDefault(_RIENumber);
	
	var _RIETags = __webpack_require__(602);
	
	var _RIETags2 = _interopRequireDefault(_RIETags);
	
	var _RIESelect = __webpack_require__(601);
	
	var _RIESelect2 = _interopRequireDefault(_RIESelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RIEInput = function (_RIEStatefulBase) {
	  _inherits(RIEInput, _RIEStatefulBase);
	
	  function RIEInput() {
	    _classCallCheck(this, RIEInput);
	
	    return _possibleConstructorReturn(this, (RIEInput.__proto__ || Object.getPrototypeOf(RIEInput)).apply(this, arguments));
	  }
	
	  return RIEInput;
	}(_RIEStatefulBase3.default);
	
	exports.RIEToggle = _RIEToggle2.default;
	exports.RIEInput = RIEInput;
	exports.RIETextArea = _RIETextArea2.default;
	exports.RIENumber = _RIENumber2.default;
	exports.RIETags = _RIETags2.default;
	exports.RIESelect = _RIESelect2.default;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Loading = function Loading(props) {
	  var _classnames;
	
	  var className = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, props.className, props.className), _defineProperty(_classnames, 'loading', true), _classnames));
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      { className: 'spinner' },
	      _react2.default.createElement('div', { className: 'bounce1' }),
	      _react2.default.createElement('div', { className: 'bounce2' }),
	      _react2.default.createElement('div', { className: 'bounce3' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      props.message
	    )
	  );
	};
	
	Loading.propTypes = {
	  className: _propTypes2.default.string,
	  message: _propTypes2.default.string
	};
	
	Loading.defaultProps = {
	  className: '',
	  message: ''
	};
	
	exports.default = Loading;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(51);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(30);
	var createDesc = __webpack_require__(63);
	module.exports = __webpack_require__(37) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(173);
	var defined = __webpack_require__(101);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Color = __webpack_require__(31);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Util = __webpack_require__(55);
	
	var _background = __webpack_require__(65);
	
	var _border = __webpack_require__(116);
	
	var _borderRadius = __webpack_require__(434);
	
	var _display = __webpack_require__(435);
	
	var _float = __webpack_require__(436);
	
	var _font = __webpack_require__(437);
	
	var _letterSpacing = __webpack_require__(438);
	
	var _lineBreak = __webpack_require__(439);
	
	var _listStyle = __webpack_require__(82);
	
	var _margin = __webpack_require__(440);
	
	var _overflow = __webpack_require__(441);
	
	var _overflowWrap = __webpack_require__(194);
	
	var _padding = __webpack_require__(195);
	
	var _position = __webpack_require__(196);
	
	var _textDecoration = __webpack_require__(117);
	
	var _textShadow = __webpack_require__(442);
	
	var _textTransform = __webpack_require__(197);
	
	var _transform = __webpack_require__(443);
	
	var _visibility = __webpack_require__(444);
	
	var _wordBreak = __webpack_require__(445);
	
	var _zIndex = __webpack_require__(446);
	
	var _Bounds = __webpack_require__(39);
	
	var _Input = __webpack_require__(189);
	
	var _ListItem = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
	
	var NodeContainer = function () {
	    function NodeContainer(node, parent, resourceLoader, index) {
	        var _this = this;
	
	        _classCallCheck(this, NodeContainer);
	
	        this.parent = parent;
	        this.tagName = node.tagName;
	        this.index = index;
	        this.childNodes = [];
	        this.listItems = [];
	        if (typeof node.start === 'number') {
	            this.listStart = node.start;
	        }
	        var defaultView = node.ownerDocument.defaultView;
	        var scrollX = defaultView.pageXOffset;
	        var scrollY = defaultView.pageYOffset;
	        var style = defaultView.getComputedStyle(node, null);
	        var display = (0, _display.parseDisplay)(style.display);
	
	        var IS_INPUT = node.type === 'radio' || node.type === 'checkbox';
	
	        var position = (0, _position.parsePosition)(style.position);
	
	        this.style = {
	            background: IS_INPUT ? _Input.INPUT_BACKGROUND : (0, _background.parseBackground)(style, resourceLoader),
	            border: IS_INPUT ? _Input.INPUT_BORDERS : (0, _border.parseBorder)(style),
	            borderRadius: (node instanceof defaultView.HTMLInputElement || node instanceof HTMLInputElement) && IS_INPUT ? (0, _Input.getInputBorderRadius)(node) : (0, _borderRadius.parseBorderRadius)(style),
	            color: IS_INPUT ? _Input.INPUT_COLOR : new _Color2.default(style.color),
	            display: display,
	            float: (0, _float.parseCSSFloat)(style.float),
	            font: (0, _font.parseFont)(style),
	            letterSpacing: (0, _letterSpacing.parseLetterSpacing)(style.letterSpacing),
	            listStyle: display === _display.DISPLAY.LIST_ITEM ? (0, _listStyle.parseListStyle)(style) : null,
	            lineBreak: (0, _lineBreak.parseLineBreak)(style.lineBreak),
	            margin: (0, _margin.parseMargin)(style),
	            opacity: parseFloat(style.opacity),
	            overflow: INPUT_TAGS.indexOf(node.tagName) === -1 ? (0, _overflow.parseOverflow)(style.overflow) : _overflow.OVERFLOW.HIDDEN,
	            overflowWrap: (0, _overflowWrap.parseOverflowWrap)(style.overflowWrap ? style.overflowWrap : style.wordWrap),
	            padding: (0, _padding.parsePadding)(style),
	            position: position,
	            textDecoration: (0, _textDecoration.parseTextDecoration)(style),
	            textShadow: (0, _textShadow.parseTextShadow)(style.textShadow),
	            textTransform: (0, _textTransform.parseTextTransform)(style.textTransform),
	            transform: (0, _transform.parseTransform)(style),
	            visibility: (0, _visibility.parseVisibility)(style.visibility),
	            wordBreak: (0, _wordBreak.parseWordBreak)(style.wordBreak),
	            zIndex: (0, _zIndex.parseZIndex)(position !== _position.POSITION.STATIC ? style.zIndex : 'auto')
	        };
	
	        if (this.isTransformed()) {
	            // getBoundingClientRect provides values post-transform, we want them without the transformation
	            node.style.transform = 'matrix(1,0,0,1,0,0)';
	        }
	
	        if (display === _display.DISPLAY.LIST_ITEM) {
	            var listOwner = (0, _ListItem.getListOwner)(this);
	            if (listOwner) {
	                var listIndex = listOwner.listItems.length;
	                listOwner.listItems.push(this);
	                this.listIndex = node.hasAttribute('value') && typeof node.value === 'number' ? node.value : listIndex === 0 ? typeof listOwner.listStart === 'number' ? listOwner.listStart : 1 : listOwner.listItems[listIndex - 1].listIndex + 1;
	            }
	        }
	
	        // TODO move bound retrieval for all nodes to a later stage?
	        if (node.tagName === 'IMG') {
	            node.addEventListener('load', function () {
	                _this.bounds = (0, _Bounds.parseBounds)(node, scrollX, scrollY);
	                _this.curvedBounds = (0, _Bounds.parseBoundCurves)(_this.bounds, _this.style.border, _this.style.borderRadius);
	            });
	        }
	        this.image = getImage(node, resourceLoader);
	        this.bounds = IS_INPUT ? (0, _Input.reformatInputBounds)((0, _Bounds.parseBounds)(node, scrollX, scrollY)) : (0, _Bounds.parseBounds)(node, scrollX, scrollY);
	        this.curvedBounds = (0, _Bounds.parseBoundCurves)(this.bounds, this.style.border, this.style.borderRadius);
	
	        if (false) {
	            this.name = '' + node.tagName.toLowerCase() + (node.id ? '#' + node.id : '') + node.className.toString().split(' ').map(function (s) {
	                return s.length ? '.' + s : '';
	            }).join('');
	        }
	    }
	
	    _createClass(NodeContainer, [{
	        key: 'getClipPaths',
	        value: function getClipPaths() {
	            var parentClips = this.parent ? this.parent.getClipPaths() : [];
	            var isClipped = this.style.overflow !== _overflow.OVERFLOW.VISIBLE;
	
	            return isClipped ? parentClips.concat([(0, _Bounds.calculatePaddingBoxPath)(this.curvedBounds)]) : parentClips;
	        }
	    }, {
	        key: 'isInFlow',
	        value: function isInFlow() {
	            return this.isRootElement() && !this.isFloating() && !this.isAbsolutelyPositioned();
	        }
	    }, {
	        key: 'isVisible',
	        value: function isVisible() {
	            return !(0, _Util.contains)(this.style.display, _display.DISPLAY.NONE) && this.style.opacity > 0 && this.style.visibility === _visibility.VISIBILITY.VISIBLE;
	        }
	    }, {
	        key: 'isAbsolutelyPositioned',
	        value: function isAbsolutelyPositioned() {
	            return this.style.position !== _position.POSITION.STATIC && this.style.position !== _position.POSITION.RELATIVE;
	        }
	    }, {
	        key: 'isPositioned',
	        value: function isPositioned() {
	            return this.style.position !== _position.POSITION.STATIC;
	        }
	    }, {
	        key: 'isFloating',
	        value: function isFloating() {
	            return this.style.float !== _float.FLOAT.NONE;
	        }
	    }, {
	        key: 'isRootElement',
	        value: function isRootElement() {
	            return this.parent === null;
	        }
	    }, {
	        key: 'isTransformed',
	        value: function isTransformed() {
	            return this.style.transform !== null;
	        }
	    }, {
	        key: 'isPositionedWithZIndex',
	        value: function isPositionedWithZIndex() {
	            return this.isPositioned() && !this.style.zIndex.auto;
	        }
	    }, {
	        key: 'isInlineLevel',
	        value: function isInlineLevel() {
	            return (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_BLOCK) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_FLEX) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_GRID) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_LIST_ITEM) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_TABLE);
	        }
	    }, {
	        key: 'isInlineBlockOrInlineTable',
	        value: function isInlineBlockOrInlineTable() {
	            return (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_BLOCK) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_TABLE);
	        }
	    }]);
	
	    return NodeContainer;
	}();
	
	exports.default = NodeContainer;
	
	
	var getImage = function getImage(node, resourceLoader) {
	    if (node instanceof node.ownerDocument.defaultView.SVGSVGElement || node instanceof SVGSVGElement) {
	        var s = new XMLSerializer();
	        return resourceLoader.loadImage('data:image/svg+xml,' + encodeURIComponent(s.serializeToString(node)));
	    }
	    switch (node.tagName) {
	        case 'IMG':
	            // $FlowFixMe
	            var img = node;
	            return resourceLoader.loadImage(img.currentSrc || img.src);
	        case 'CANVAS':
	            // $FlowFixMe
	            var canvas = node;
	            return resourceLoader.loadCanvas(canvas);
	        case 'IFRAME':
	            var iframeKey = node.getAttribute('data-html2canvas-internal-iframe-key');
	            if (iframeKey) {
	                return iframeKey;
	            }
	            break;
	    }
	
	    return null;
	};

/***/ },
/* 55 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var contains = exports.contains = function contains(bit, value) {
	    return (bit & value) !== 0;
	};
	
	var distance = exports.distance = function distance(a, b) {
	    return Math.sqrt(a * a + b * b);
	};
	
	var copyCSSStyles = exports.copyCSSStyles = function copyCSSStyles(style, target) {
	    // Edge does not provide value for cssText
	    for (var i = style.length - 1; i >= 0; i--) {
	        var property = style.item(i);
	        // Safari shows pseudoelements if content is set
	        if (property !== 'content') {
	            target.style.setProperty(property, style.getPropertyValue(property));
	        }
	    }
	    return target;
	};
	
	var SMALL_IMAGE = exports.SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    isObject = __webpack_require__(122);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Switch = function Switch(props) {
	  var className = (0, _classnames2.default)({
	    'ui-switch': true,
	    'ui-switch--on': props.required,
	    'ui-switch--off': !props.required
	  });
	
	  return _react2.default.createElement('div', { className: className, onClick: function onClick() {
	      return props.toggleSwitch(!props.required);
	    } });
	};
	
	Switch.propTypes = {
	  required: _propTypes2.default.bool,
	  toggleSwitch: _propTypes2.default.func
	};
	
	Switch.defaultProps = {
	  required: false,
	  toggleSwitch: function toggleSwitch() {}
	};
	
	exports.default = Switch;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(20);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectForm = function (_Component) {
	  _inherits(SelectForm, _Component);
	
	  function SelectForm(props) {
	    _classCallCheck(this, SelectForm);
	
	    var _this = _possibleConstructorReturn(this, (SelectForm.__proto__ || Object.getPrototypeOf(SelectForm)).call(this, props));
	
	    _this.getOptions = function (input) {
	      if (_this.state.searchInputTimeout) clearTimeout(_this.state.searchInputTimeout);
	
	      var searchInputTimeout = setTimeout(function () {
	        var _this$props = _this.props,
	            options = _this$props.options,
	            categories = _this$props.categories,
	            searchResults = _this$props.searchResults;
	
	
	        _this.props.getSearchResults(options && options.length > 0 ? options : categories, input);
	
	        if (searchResults !== undefined) _this.setState({ itemSelectorIsLoading: false });
	      }, 500);
	
	      _this.setState({ itemSelectorIsLoading: input.length > 0 ? true : false, searchInputTimeout: searchInputTimeout });
	    };
	
	    _this.state = {
	      itemSelectorValue: '',
	      itemSelectorIsLoading: false,
	      selectedItem: undefined,
	      itemGroupChild: {},
	      showItemGrouping: false,
	      typeSelectorValue: '',
	      showTypeSelector: false,
	      searchInputTimeout: null
	    };
	
	    _this.selector = _react2.default.createRef();
	    _this.hiddenInput = _react2.default.createRef();
	    _this.typeSelector = _react2.default.createRef();
	    _this.groupingButton = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(SelectForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          options = _props.options,
	          categories = _props.categories,
	          searchResults = _props.searchResults;
	
	
	      if (searchResults === undefined && (options || categories)) this.getInitialSearchResults(options, categories, searchResults);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var options = nextProps.options,
	          categories = nextProps.categories,
	          searchResults = nextProps.searchResults;
	
	
	      if (searchResults === undefined && (options && this.props.options === undefined || categories && this.props.categories === undefined)) this.getInitialSearchResults(options, categories, searchResults);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var item = nextProps.item,
	          options = nextProps.options,
	          categories = nextProps.categories,
	          searchResults = nextProps.searchResults;
	
	
	      if (item !== this.props.item) return true;
	      if (options !== this.props.options) return true;
	      if (categories !== this.props.categories) return true;
	      if (searchResults !== this.props.searchResults) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var item = nextProps.item;
	
	
	      if (item !== this.props.item && item.id !== undefined) this.props.removeFocus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.searchInputTimeout) clearTimeout(this.state.searchInputTimeout);
	    }
	  }, {
	    key: 'getInitialSearchResults',
	    value: function getInitialSearchResults(options, categories, searchResults) {
	      var _this2 = this;
	
	      this.setState({ itemSelectorIsLoading: false }, function () {
	        _this2.props.getSearchResults(options && options.length > 0 ? options : categories, _this2.state.itemSelectorValue);
	      });
	    }
	  }, {
	    key: 'setSelectorFocus',
	    value: function setSelectorFocus(selector, value, searchResults) {
	      this.setState({
	        itemSelectorIsLoading: searchResults === undefined ? true : false
	      }, function () {
	        var select = selector.current.select;
	
	        if (select) selector.current.select.handleInputChange({ target: { value: value && value.title || '' } });
	      });
	    }
	  }, {
	    key: 'clearSearchResults',
	    value: function clearSearchResults() {
	      this.props.getSearchResults([]);
	    }
	  }, {
	    key: 'clearFocus',
	    value: function clearFocus() {
	      var _this3 = this;
	
	      this.setState({ itemGroupChild: null }, function () {
	        return _this3.props.removeFocus();
	      });
	    }
	  }, {
	    key: 'itemIsSelected',
	    value: function itemIsSelected(item, value) {
	      this.setState({ showTypeSelector: false, showItemGrouping: false });
	
	      if (item.id !== undefined) {
	        if (!item.parent && value.type && value.type.indexOf('drum') !== -1) {
	          this.suggestItemGrouping(Object.assign({}, value, { id: item.id }));
	        } else if (value.title === '') {
	          this.props.deleteRiderItem(item.id);
	        } else {
	          this.props.editRiderItem({
	            id: item.id,
	            type: value.type,
	            title: value.title
	          });
	        }
	      } else {
	        if (!item.parent && value.type && value.type.indexOf('drum') !== -1) {
	          this.suggestItemGrouping(value);
	        } else {
	          this.props.createRiderItem({
	            type: value.type,
	            group: this.props.group,
	            class: item.class,
	            title: value.title,
	            position: this.props.position,
	            parent: item.parent,
	            params: value.params || item.params
	          });
	
	          // if (item.class !== 'instrument') this.clearFocus()
	          if (value.stageElementGroup) this.props.createStageElement({ title: value.title, group: value.stageElementGroup });
	        }
	      }
	    }
	  }, {
	    key: 'createItemGroup',
	    value: function createItemGroup(id, group) {
	      var itemGroupChild = this.state.itemGroupChild;
	
	      // TODO: Replace createChildren with multi call, creating drum element from existing instruments creates a duplicate
	
	      if (group) {
	        this.props.createRiderItem({
	          type: itemGroupChild.type,
	          group: this.props.group,
	          class: 'instrument',
	          title: itemGroupChild.title,
	          position: group.children.length + 1,
	          parent: group.id
	        });
	      } else if (id) {
	        this.props.editRiderItem({
	          id: id,
	          type: 'drum-set',
	          group: this.props.group,
	          class: 'instrument-group',
	          title: 'Drum set',
	          position: this.props.position,
	          parent: null
	        });
	      } else {
	        this.props.createRiderItem({
	          type: 'drum-set',
	          group: this.props.group,
	          class: 'instrument-group',
	          title: 'Drum set',
	          position: this.props.position,
	          parent: null,
	          params: {
	            createChildren: itemGroupChild.type && itemGroupChild.title ? [this.state.itemGroupChild] : null
	          }
	        });
	      }
	
	      this.clearFocus();
	    }
	  }, {
	    key: 'suggestItemGrouping',
	    value: function suggestItemGrouping(value) {
	      var _this4 = this;
	
	      if (value.title === 'Drums' || value.title === 'Drumm set') {
	        this.createItemGroup(value.id);
	      } else {
	        this.setState({
	          showItemGrouping: true,
	          itemGroupChild: value
	        }, function () {
	          return _this4.groupingButton.current.focus();
	        });
	      }
	    }
	  }, {
	    key: 'renderItemGrouping',
	    value: function renderItemGrouping(itemGroups, itemGroupingText) {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          !itemGroupingText ? 'You have entered a drum element. It is advised to group those into a "Drum set"' : itemGroupingText,
	          _react2.default.createElement(
	            'button',
	            { ref: this.groupingButton, onClick: function onClick() {
	                return _this5.createItemGroup();
	              } },
	            !itemGroupingText ? 'Group now' : 'a new drum set'
	          )
	        ),
	        itemGroups.length > 0 ? _react2.default.createElement(
	          'p',
	          { className: 'item-groups' },
	          !itemGroupingText ? 'Alternatively you can add it to one of your existing drum sets:' : 'or add to existing',
	          itemGroups.map(function (group, index) {
	            return _react2.default.createElement(
	              'button',
	              { key: index, ref: _this5.groupingButton, onClick: function onClick() {
	                  return _this5.createItemGroup(null, group);
	                } },
	              'drum set (ch ' + group.position + ' - ' + (group.position + group.children.length) + ')'
	            );
	          })
	        ) : null
	      );
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue(item, selectedItem) {
	      if (selectedItem && selectedItem.title) {
	        return selectedItem;
	      } else if (item.title) {
	        return item;
	      } else {
	        return undefined;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props2 = this.props,
	          item = _props2.item,
	          itemGroups = _props2.itemGroups,
	          placeholder = _props2.placeholder,
	          _promptTextCreator = _props2.promptTextCreator,
	          typeSelectorText = _props2.typeSelectorText,
	          itemGroupingText = _props2.itemGroupingText,
	          categories = _props2.categories,
	          searchResults = _props2.searchResults;
	      var _state = this.state,
	          itemSelectorValue = _state.itemSelectorValue,
	          itemSelectorIsLoading = _state.itemSelectorIsLoading,
	          selectedItem = _state.selectedItem,
	          typeSelectorValue = _state.typeSelectorValue,
	          showTypeSelector = _state.showTypeSelector;
	
	
	      var value = this.getValue(item, selectedItem);
	
	      var skipEntry = !itemSelectorValue || itemSelectorValue === item.title;
	      var enableXaxis = !itemSelectorValue;
	      var enableYaxis = searchResults && searchResults.length <= 1 && showTypeSelector !== true;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'select-form' },
	        _react2.default.createElement('div', { className: 'select-form-escape', onClick: function onClick() {
	            return _this6.clearFocus();
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'select-form-fields',
	            onKeyDown: function onKeyDown(e) {
	              if ((e.key === 'Enter' || e.key === 'Tab') && skipEntry || (e.key === 'ArrowLeft' || e.key === 'ArrowRight') && enableXaxis || (e.key === 'ArrowUp' || e.key === 'ArrowDown') && enableYaxis) {
	                _this6.props.changeFocus(e);
	                _this6.props.removeFocus();
	              } else if (e.key === 'Enter' || e.key === 'Tab') {
	                _this6.props.setFocusKey(e);
	              }
	            } },
	          _react2.default.createElement(_reactSelect.Creatable, { ref: this.selector,
	            cache: false,
	            autoFocus: this.props.setFocus,
	            openOnFocus: this.props.setFocus,
	            isLoading: itemSelectorIsLoading,
	            className: 'select-form-field',
	            value: value,
	            valueKey: 'id',
	            labelKey: 'title',
	            clearable: false,
	            placeholder: placeholder ? placeholder : 'Search ' + item.class + ' by it\'s type or brand name',
	            searchPromptText: null,
	            promptTextCreator: function promptTextCreator(label) {
	              if (value && value.title === label) return placeholder || 'Add ' + item.class;
	              return _promptTextCreator ? _promptTextCreator + ' "' + label + '"' : 'Add custom ' + item.class + ' "' + label + '"';
	            },
	            onOpen: function onOpen() {
	              return _this6.setSelectorFocus(_this6.selector, value, searchResults);
	            },
	            onInputKeyDown: function onInputKeyDown(e) {
	              if (e.key === 'Backspace' && !itemSelectorValue) {
	                if (item.id) _this6.props.deleteRiderItem(item.id);
	                _this6.props.removeFocus();
	              } else if (e.key === 'Escape') {
	                _this6.props.removeFocus();
	              }
	            },
	            onInputChange: function onInputChange(input) {
	              _this6.setState({ itemSelectorValue: input }, function () {
	                return _this6.getOptions(input);
	              });
	
	              return input;
	            },
	            onChange: function onChange(value) {
	              _this6.setState({ selectedItem: value }, function () {
	                return _this6.itemIsSelected(item, { title: value && value.title || '', type: item.type ? item.type.slug : value.type.slug });
	              });
	
	              _this6.clearSearchResults();
	            },
	            onNewOptionClick: function onNewOptionClick(value) {
	              if (item.parent && item.type) {
	                _this6.setState({ selectedItem: value }, function () {
	                  _this6.itemIsSelected(item, { title: value.title, type: item.type.slug });
	                  _this6.hiddenInput.current.focus(); // TODO: Replace hiddenInput with unfocus
	                });
	              } else {
	                var _selectedItem = { title: value.title, type: undefined };
	                _this6.setState({ selectedItem: _selectedItem, showTypeSelector: true }, function () {
	                  return _this6.typeSelector.current.focus();
	                });
	              }
	            },
	            onBlur: function onBlur() {
	              return _this6.clearSearchResults();
	            },
	            loadingPlaceholder: null,
	            noResultsText: searchResults !== undefined ? '' : 'Loading results...',
	            options: searchResults,
	            filterOptions: function filterOptions(options, filter) {
	              return options.map(function (option) {
	                if (option.title.toLowerCase() === filter.toLowerCase()) {
	                  return Object.assign({}, option, { title: filter });
	                } else {
	                  return option;
	                }
	              });
	            } }),
	          _react2.default.createElement('input', { ref: this.hiddenInput, style: { position: 'absolute', top: 0, left: 0, opacity: 0, zIndex: -1 } }),
	          this.state.showTypeSelector ? _react2.default.createElement('hr', null) : null,
	          this.state.showTypeSelector && !typeSelectorText ? _react2.default.createElement(
	            'p',
	            null,
	            'Oops, we did not recognize this ' + item.class + '. Can you tell us it\'s category?'
	          ) : null,
	          this.state.showTypeSelector ? _react2.default.createElement(_reactSelect2.default, { ref: this.typeSelector,
	            cache: false,
	            openOnFocus: true,
	            className: 'select-form-field',
	            value: undefined,
	            valueKey: 'id',
	            labelKey: 'title',
	            clearable: false,
	            placeholder: typeSelectorText ? typeSelectorText : 'Select...',
	            onInputKeyDown: function onInputKeyDown(e) {
	              if (e.key === 'Enter' && !typeSelectorValue) {
	                _this6.itemIsSelected(item, { title: selectedItem.title, type: 'custom' });
	              }
	            },
	            onChange: function onChange(value) {
	              _this6.itemIsSelected(item, { title: selectedItem.title, type: value.type.slug, params: value.params, stageElementGroup: value.id });
	            },
	            noResultsText: categories.length > 0 ? 'Clear field to select an existing category' : 'Loading results...',
	            options: categories }) : null,
	          this.state.showItemGrouping ? this.renderItemGrouping(itemGroups, itemGroupingText) : null
	        )
	      );
	    }
	  }]);
	
	  return SelectForm;
	}(_react.Component);
	
	SelectForm.propTypes = {
	  group: _propTypes2.default.string,
	  item: _propTypes2.default.object,
	  itemGroups: _propTypes2.default.array,
	  position: _propTypes2.default.number,
	  placeholder: _propTypes2.default.string,
	  promptTextCreator: _propTypes2.default.string,
	  typeSelectorText: _propTypes2.default.string,
	  itemGroupingText: _propTypes2.default.string,
	  setFocus: _propTypes2.default.bool,
	  setFocusKey: _propTypes2.default.func,
	  changeFocus: _propTypes2.default.func,
	  removeFocus: _propTypes2.default.func,
	  createRiderColumn: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  options: _propTypes2.default.array,
	  categories: _propTypes2.default.array,
	  creatableCategory: _propTypes2.default.bool,
	  createStageElement: _propTypes2.default.func,
	  searchResults: _propTypes2.default.array,
	  getSearchResults: _propTypes2.default.func
	};
	
	SelectForm.defaultProps = {
	  group: '',
	  item: {},
	  itemGroups: [],
	  position: 0,
	  placeholder: null,
	  promptTextCreator: null,
	  typeSelectorText: null,
	  itemGroupingText: null,
	  setFocus: false,
	  setFocusKey: function setFocusKey() {},
	  changeFocus: function changeFocus() {},
	  removeFocus: function removeFocus() {},
	  createRiderColumn: function createRiderColumn() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  options: undefined,
	  categories: undefined,
	  creatableCategory: false,
	  createStageElement: function createStageElement() {},
	  searchResults: undefined,
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = SelectForm;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _userSession = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	    _this.logIn = function (e) {
	      e.preventDefault();
	
	      var _this$state = _this.state,
	          email = _this$state.email,
	          password = _this$state.password,
	          isLoggingIn = _this$state.isLoggingIn;
	
	
	      if (!email || !password) {
	        var credentials = 'credentials';
	        credentials = !email ? 'email' : credentials;
	        credentials = !password ? 'password' : credentials;
	        credentials = !email && !password ? 'email and password' : credentials;
	
	        _this.setState({ error: 'Please enter correct ' + credentials + '.' });
	      } else if (isLoggingIn === false) {
	        _this.setState({ error: null }, function () {
	          return _this.props.setUserSession(email, password);
	        });
	      }
	    };
	
	    _this.state = {
	      email: '',
	      password: '',
	      isLoggingIn: false,
	      error: null
	    };
	
	    _this.activeUser = _react2.default.createRef();
	    _this.email = _react2.default.createRef();
	    _this.password = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          email = _props.email,
	          userSession = _props.userSession;
	
	      // if (userSession.loggedIn === true && userSession.verification) this.props.removeUserSession()
	      // if (userSession.verification && userSession.verification.email) this.setState({email: userSession.verification.email}) // TODO: Should still display it? Authorization will fetch user data twice if user was already signed in
	
	      if (email) this.setState({ email: email });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var userSession = this.props.userSession;
	      var email = this.state.email;
	
	
	      if (this.activeUser.current) {
	        this.activeUser.current.focus();
	      } else if (email) {
	        this.password.current.focus();
	      } else {
	        this.email.current.focus();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var userSession = nextProps.userSession;
	      var pathname = nextProps.location.pathname;
	
	
	      if (userSession.isLoggingIn !== this.props.userSession.isLoggingIn) this.setState({ isLoggingIn: userSession.isLoggingIn });
	      if (userSession.loggedIn === true && this.props.userSession.loggedIn === false) {
	        if (this.props.setModal) {
	          this.props.setModal(false);
	
	          this.props.history.replace({ pathname: pathname });
	        } else {
	          this.props.history.replace({ pathname: '/library' });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var userSession = this.props.userSession;
	
	
	      if (this.activeUser.current) this.activeUser.current.focus();
	    }
	  }, {
	    key: 'renderActiveUserButton',
	    value: function renderActiveUserButton() {
	      var _this2 = this;
	
	      var userSession = this.props.userSession;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center' } },
	        _react2.default.createElement('input', { ref: this.activeUser,
	          type: 'button',
	          className: 'button button-continue button--primary',
	          value: 'Continue as ' + userSession.user.email,
	          onClick: function onClick() {
	            return _this2.props.history.replace({ pathname: '/library' });
	          } })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          modal = _props2.modal,
	          userSession = _props2.userSession;
	      var _state = this.state,
	          email = _state.email,
	          password = _state.password,
	          isLoggingIn = _state.isLoggingIn,
	          error = _state.error;
	
	
	      var className = (0, _classnames2.default)({
	        'login': true,
	        'login--modal': modal === true
	      });
	
	      var formClassName = (0, _classnames2.default)({
	        'valid': email && password,
	        'invalid': error
	      });
	
	      var buttonClassName = (0, _classnames2.default)({
	        'button--disabled': isLoggingIn,
	        'placeholder-loader': isLoggingIn,
	        'placeholder-loader--success': isLoggingIn
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        modal !== true ? _react2.default.createElement(
	          'h1',
	          { className: 'h1--default' },
	          'Log in to Ridline'
	        ) : _react2.default.createElement(
	          'h4',
	          null,
	          'Log in to Ridline'
	        ),
	        userSession.loggedIn && userSession.user && userSession.user.email ? this.renderActiveUserButton() : null,
	        _react2.default.createElement(
	          'form',
	          { className: formClassName, onSubmit: this.logIn },
	          _react2.default.createElement(
	            'ul',
	            { className: 'ul--inline', 'data-error-msg': error },
	            _react2.default.createElement(
	              'li',
	              { 'data-title': 'Email' },
	              _react2.default.createElement('input', { ref: this.email,
	                type: 'text',
	                className: 'input--light',
	                value: email,
	                onChange: function onChange(e) {
	                  return _this3.setState({ email: e.target.value });
	                } })
	            ),
	            _react2.default.createElement(
	              'li',
	              { 'data-title': 'Password' },
	              _react2.default.createElement('input', { ref: this.password,
	                type: 'password',
	                className: 'input--light',
	                value: password,
	                onChange: function onChange(e) {
	                  return _this3.setState({ password: e.target.value });
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: buttonClassName, type: 'submit' },
	            'Log in'
	          )
	        ),
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: '/register' },
	          'Or sign up alternatively'
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	Login.propTypes = {
	  match: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired,
	  modal: _propTypes2.default.bool,
	  email: _propTypes2.default.string,
	  userSession: _propTypes2.default.object,
	  setUserSession: _propTypes2.default.func,
	  removeUserSession: _propTypes2.default.func
	};
	
	Login.defaultProps = {
	  match: {},
	  location: {},
	  history: {},
	  modal: false,
	  email: '',
	  userSession: {},
	  setUserSession: function setUserSession() {},
	  removeUserSession: function removeUserSession() {}
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    userSession: state.userSession
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    setUserSession: _userSession.setUserSession,
	    removeUserSession: _userSession.removeUserSession
	  }, dispatch);
	};
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Login));

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(170);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 61 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(178);
	var enumBugKeys = __webpack_require__(102);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 63 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(101);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseBackgroundImage = exports.parseBackground = exports.calculateBackgroundRepeatPath = exports.calculateBackgroundPosition = exports.calculateBackgroungPositioningArea = exports.calculateBackgroungPaintingArea = exports.calculateGradientBackgroundSize = exports.calculateBackgroundSize = exports.BACKGROUND_ORIGIN = exports.BACKGROUND_CLIP = exports.BACKGROUND_SIZE = exports.BACKGROUND_REPEAT = undefined;
	
	var _Color = __webpack_require__(31);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Length = __webpack_require__(40);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	var _Size = __webpack_require__(432);
	
	var _Size2 = _interopRequireDefault(_Size);
	
	var _Vector = __webpack_require__(81);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	var _Bounds = __webpack_require__(39);
	
	var _padding = __webpack_require__(195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BACKGROUND_REPEAT = exports.BACKGROUND_REPEAT = {
	    REPEAT: 0,
	    NO_REPEAT: 1,
	    REPEAT_X: 2,
	    REPEAT_Y: 3
	};
	
	var BACKGROUND_SIZE = exports.BACKGROUND_SIZE = {
	    AUTO: 0,
	    CONTAIN: 1,
	    COVER: 2,
	    LENGTH: 3
	};
	
	var BACKGROUND_CLIP = exports.BACKGROUND_CLIP = {
	    BORDER_BOX: 0,
	    PADDING_BOX: 1,
	    CONTENT_BOX: 2
	};
	
	var BACKGROUND_ORIGIN = exports.BACKGROUND_ORIGIN = BACKGROUND_CLIP;
	
	var AUTO = 'auto';
	
	var BackgroundSize = function BackgroundSize(size) {
	    _classCallCheck(this, BackgroundSize);
	
	    switch (size) {
	        case 'contain':
	            this.size = BACKGROUND_SIZE.CONTAIN;
	            break;
	        case 'cover':
	            this.size = BACKGROUND_SIZE.COVER;
	            break;
	        case 'auto':
	            this.size = BACKGROUND_SIZE.AUTO;
	            break;
	        default:
	            this.value = new _Length2.default(size);
	    }
	};
	
	var calculateBackgroundSize = exports.calculateBackgroundSize = function calculateBackgroundSize(backgroundImage, image, bounds) {
	    var width = 0;
	    var height = 0;
	    var size = backgroundImage.size;
	    if (size[0].size === BACKGROUND_SIZE.CONTAIN || size[0].size === BACKGROUND_SIZE.COVER) {
	        var targetRatio = bounds.width / bounds.height;
	        var currentRatio = image.width / image.height;
	        return targetRatio < currentRatio !== (size[0].size === BACKGROUND_SIZE.COVER) ? new _Size2.default(bounds.width, bounds.width / currentRatio) : new _Size2.default(bounds.height * currentRatio, bounds.height);
	    }
	
	    if (size[0].value) {
	        width = size[0].value.getAbsoluteValue(bounds.width);
	    }
	
	    if (size[0].size === BACKGROUND_SIZE.AUTO && size[1].size === BACKGROUND_SIZE.AUTO) {
	        height = image.height;
	    } else if (size[1].size === BACKGROUND_SIZE.AUTO) {
	        height = width / image.width * image.height;
	    } else if (size[1].value) {
	        height = size[1].value.getAbsoluteValue(bounds.height);
	    }
	
	    if (size[0].size === BACKGROUND_SIZE.AUTO) {
	        width = height / image.height * image.width;
	    }
	
	    return new _Size2.default(width, height);
	};
	
	var calculateGradientBackgroundSize = exports.calculateGradientBackgroundSize = function calculateGradientBackgroundSize(backgroundImage, bounds) {
	    var size = backgroundImage.size;
	    var width = size[0].value ? size[0].value.getAbsoluteValue(bounds.width) : bounds.width;
	    var height = size[1].value ? size[1].value.getAbsoluteValue(bounds.height) : size[0].value ? width : bounds.height;
	
	    return new _Size2.default(width, height);
	};
	
	var AUTO_SIZE = new BackgroundSize(AUTO);
	
	var calculateBackgroungPaintingArea = exports.calculateBackgroungPaintingArea = function calculateBackgroungPaintingArea(curves, clip) {
	    switch (clip) {
	        case BACKGROUND_CLIP.BORDER_BOX:
	            return (0, _Bounds.calculateBorderBoxPath)(curves);
	        case BACKGROUND_CLIP.PADDING_BOX:
	        default:
	            return (0, _Bounds.calculatePaddingBoxPath)(curves);
	    }
	};
	
	var calculateBackgroungPositioningArea = exports.calculateBackgroungPositioningArea = function calculateBackgroungPositioningArea(backgroundOrigin, bounds, padding, border) {
	    var paddingBox = (0, _Bounds.calculatePaddingBox)(bounds, border);
	
	    switch (backgroundOrigin) {
	        case BACKGROUND_ORIGIN.BORDER_BOX:
	            return bounds;
	        case BACKGROUND_ORIGIN.CONTENT_BOX:
	            var paddingLeft = padding[_padding.PADDING_SIDES.LEFT].getAbsoluteValue(bounds.width);
	            var paddingRight = padding[_padding.PADDING_SIDES.RIGHT].getAbsoluteValue(bounds.width);
	            var paddingTop = padding[_padding.PADDING_SIDES.TOP].getAbsoluteValue(bounds.width);
	            var paddingBottom = padding[_padding.PADDING_SIDES.BOTTOM].getAbsoluteValue(bounds.width);
	            return new _Bounds.Bounds(paddingBox.left + paddingLeft, paddingBox.top + paddingTop, paddingBox.width - paddingLeft - paddingRight, paddingBox.height - paddingTop - paddingBottom);
	        case BACKGROUND_ORIGIN.PADDING_BOX:
	        default:
	            return paddingBox;
	    }
	};
	
	var calculateBackgroundPosition = exports.calculateBackgroundPosition = function calculateBackgroundPosition(position, size, bounds) {
	    return new _Vector2.default(position[0].getAbsoluteValue(bounds.width - size.width), position[1].getAbsoluteValue(bounds.height - size.height));
	};
	
	var calculateBackgroundRepeatPath = exports.calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(background, position, size, backgroundPositioningArea, bounds) {
	    var repeat = background.repeat;
	    switch (repeat) {
	        case BACKGROUND_REPEAT.REPEAT_X:
	            return [new _Vector2.default(Math.round(bounds.left), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(size.height + backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left), Math.round(size.height + backgroundPositioningArea.top + position.y))];
	        case BACKGROUND_REPEAT.REPEAT_Y:
	            return [new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.height + bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.height + bounds.top))];
	        case BACKGROUND_REPEAT.NO_REPEAT:
	            return [new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y + size.height)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y + size.height))];
	        default:
	            return [new _Vector2.default(Math.round(bounds.left), Math.round(bounds.top)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.top)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.height + bounds.top)), new _Vector2.default(Math.round(bounds.left), Math.round(bounds.height + bounds.top))];
	    }
	};
	
	var parseBackground = exports.parseBackground = function parseBackground(style, resourceLoader) {
	    return {
	        backgroundColor: new _Color2.default(style.backgroundColor),
	        backgroundImage: parseBackgroundImages(style, resourceLoader),
	        backgroundClip: parseBackgroundClip(style.backgroundClip),
	        backgroundOrigin: parseBackgroundOrigin(style.backgroundOrigin)
	    };
	};
	
	var parseBackgroundClip = function parseBackgroundClip(backgroundClip) {
	    switch (backgroundClip) {
	        case 'padding-box':
	            return BACKGROUND_CLIP.PADDING_BOX;
	        case 'content-box':
	            return BACKGROUND_CLIP.CONTENT_BOX;
	    }
	    return BACKGROUND_CLIP.BORDER_BOX;
	};
	
	var parseBackgroundOrigin = function parseBackgroundOrigin(backgroundOrigin) {
	    switch (backgroundOrigin) {
	        case 'padding-box':
	            return BACKGROUND_ORIGIN.PADDING_BOX;
	        case 'content-box':
	            return BACKGROUND_ORIGIN.CONTENT_BOX;
	    }
	    return BACKGROUND_ORIGIN.BORDER_BOX;
	};
	
	var parseBackgroundRepeat = function parseBackgroundRepeat(backgroundRepeat) {
	    switch (backgroundRepeat.trim()) {
	        case 'no-repeat':
	            return BACKGROUND_REPEAT.NO_REPEAT;
	        case 'repeat-x':
	        case 'repeat no-repeat':
	            return BACKGROUND_REPEAT.REPEAT_X;
	        case 'repeat-y':
	        case 'no-repeat repeat':
	            return BACKGROUND_REPEAT.REPEAT_Y;
	        case 'repeat':
	            return BACKGROUND_REPEAT.REPEAT;
	    }
	
	    if (false) {
	        console.error('Invalid background-repeat value "' + backgroundRepeat + '"');
	    }
	
	    return BACKGROUND_REPEAT.REPEAT;
	};
	
	var parseBackgroundImages = function parseBackgroundImages(style, resourceLoader) {
	    var sources = parseBackgroundImage(style.backgroundImage).map(function (backgroundImage) {
	        if (backgroundImage.method === 'url') {
	            var key = resourceLoader.loadImage(backgroundImage.args[0]);
	            backgroundImage.args = key ? [key] : [];
	        }
	        return backgroundImage;
	    });
	    var positions = style.backgroundPosition.split(',');
	    var repeats = style.backgroundRepeat.split(',');
	    var sizes = style.backgroundSize.split(',');
	
	    return sources.map(function (source, index) {
	        var size = (sizes[index] || AUTO).trim().split(' ').map(parseBackgroundSize);
	        var position = (positions[index] || AUTO).trim().split(' ').map(parseBackgoundPosition);
	
	        return {
	            source: source,
	            repeat: parseBackgroundRepeat(typeof repeats[index] === 'string' ? repeats[index] : repeats[0]),
	            size: size.length < 2 ? [size[0], AUTO_SIZE] : [size[0], size[1]],
	            position: position.length < 2 ? [position[0], position[0]] : [position[0], position[1]]
	        };
	    });
	};
	
	var parseBackgroundSize = function parseBackgroundSize(size) {
	    return size === 'auto' ? AUTO_SIZE : new BackgroundSize(size);
	};
	
	var parseBackgoundPosition = function parseBackgoundPosition(position) {
	    switch (position) {
	        case 'bottom':
	        case 'right':
	            return new _Length2.default('100%');
	        case 'left':
	        case 'top':
	            return new _Length2.default('0%');
	        case 'auto':
	            return new _Length2.default('0');
	    }
	    return new _Length2.default(position);
	};
	
	var parseBackgroundImage = exports.parseBackgroundImage = function parseBackgroundImage(image) {
	    var whitespace = /^\s$/;
	    var results = [];
	
	    var args = [];
	    var method = '';
	    var quote = null;
	    var definition = '';
	    var mode = 0;
	    var numParen = 0;
	
	    var appendResult = function appendResult() {
	        var prefix = '';
	        if (method) {
	            if (definition.substr(0, 1) === '"') {
	                definition = definition.substr(1, definition.length - 2);
	            }
	
	            if (definition) {
	                args.push(definition.trim());
	            }
	
	            var prefix_i = method.indexOf('-', 1) + 1;
	            if (method.substr(0, 1) === '-' && prefix_i > 0) {
	                prefix = method.substr(0, prefix_i).toLowerCase();
	                method = method.substr(prefix_i);
	            }
	            method = method.toLowerCase();
	            if (method !== 'none') {
	                results.push({
	                    prefix: prefix,
	                    method: method,
	                    args: args
	                });
	            }
	        }
	        args = [];
	        method = definition = '';
	    };
	
	    image.split('').forEach(function (c) {
	        if (mode === 0 && whitespace.test(c)) {
	            return;
	        }
	        switch (c) {
	            case '"':
	                if (!quote) {
	                    quote = c;
	                } else if (quote === c) {
	                    quote = null;
	                }
	                break;
	            case '(':
	                if (quote) {
	                    break;
	                } else if (mode === 0) {
	                    mode = 1;
	                    return;
	                } else {
	                    numParen++;
	                }
	                break;
	            case ')':
	                if (quote) {
	                    break;
	                } else if (mode === 1) {
	                    if (numParen === 0) {
	                        mode = 0;
	                        appendResult();
	                        return;
	                    } else {
	                        numParen--;
	                    }
	                }
	                break;
	
	            case ',':
	                if (quote) {
	                    break;
	                } else if (mode === 0) {
	                    appendResult();
	                    return;
	                } else if (mode === 1) {
	                    if (numParen === 0 && !method.match(/^url$/i)) {
	                        args.push(definition.trim());
	                        definition = '';
	                        return;
	                    }
	                }
	                break;
	        }
	
	        if (mode === 0) {
	            method += c;
	        } else {
	            definition += c;
	        }
	    });
	
	    appendResult();
	    return results;
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(466),
	    getValue = __webpack_require__(474);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 67 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 68 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isDraggableWithin = exports.isPointWithinDroppable = exports.getVisibleBounds = undefined;
	
	var _isWithin = __webpack_require__(217);
	
	var _isWithin2 = _interopRequireDefault(_isWithin);
	
	var _position = __webpack_require__(14);
	
	var _spacing = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getVisibleBounds = exports.getVisibleBounds = function getVisibleBounds(droppable) {
	  var _droppable$container = droppable.container,
	      scroll = _droppable$container.scroll,
	      containerBounds = _droppable$container.bounds;
	
	  var containerScrollDiff = (0, _position.subtract)(scroll.initial, scroll.current);
	
	  var droppableBounds = (0, _spacing.offset)(droppable.page.withMargin, containerScrollDiff);
	
	  var clippedBounds = {
	    top: Math.max(droppableBounds.top, containerBounds.top),
	    right: Math.min(droppableBounds.right, containerBounds.right),
	    bottom: Math.min(droppableBounds.bottom, containerBounds.bottom),
	    left: Math.max(droppableBounds.left, containerBounds.left)
	  };
	
	  return clippedBounds;
	};
	
	var isPointWithin = function isPointWithin(bounds) {
	  var isWithinHorizontal = (0, _isWithin2.default)(bounds.left, bounds.right);
	  var isWithinVertical = (0, _isWithin2.default)(bounds.top, bounds.bottom);
	
	  return function (point) {
	    return isWithinHorizontal(point.x) && isWithinVertical(point.y);
	  };
	};
	
	var isPointWithinDroppable = exports.isPointWithinDroppable = function isPointWithinDroppable(droppable) {
	  return isPointWithin(getVisibleBounds(droppable));
	};
	
	var isDraggableWithin = exports.isDraggableWithin = function isDraggableWithin(bounds) {
	  var top = bounds.top,
	      right = bounds.right,
	      bottom = bounds.bottom,
	      left = bounds.left;
	
	  var isWithinHorizontal = (0, _isWithin2.default)(left - 1, right + 1);
	  var isWithinVertical = (0, _isWithin2.default)(top - 1, bottom + 1);
	
	  return function (draggable) {
	    var fragment = draggable.page.withoutMargin;
	
	    return isWithinHorizontal(fragment.left) && isWithinHorizontal(fragment.right) && isWithinVertical(fragment.top) && isWithinVertical(fragment.bottom);
	  };
	};

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(14);
	
	exports.default = function (_ref) {
	  var source = _ref.source,
	      sourceEdge = _ref.sourceEdge,
	      destination = _ref.destination,
	      destinationEdge = _ref.destinationEdge,
	      destinationAxis = _ref.destinationAxis;
	
	  var getCorner = function getCorner(fragment) {
	    return (0, _position.patch)(destinationAxis.line, fragment[destinationAxis[destinationEdge]], fragment[destinationAxis.crossAxisStart]);
	  };
	
	  var corner = getCorner(destination);
	
	  var centerDiff = (0, _position.absolute)((0, _position.subtract)(source.center, getCorner(source)));
	
	  var signed = (0, _position.patch)(destinationAxis.line, (sourceEdge === 'end' ? -1 : 1) * centerDiff[destinationAxis.line], centerDiff[destinationAxis.crossLine]);
	
	  return (0, _position.add)(corner, signed);
	};

/***/ },
/* 71 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = defaultMemoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RIEBase2 = __webpack_require__(247);
	
	var _RIEBase3 = _interopRequireDefault(_RIEBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = __webpack_require__(76)('RIEStatefulBase');
	
	var RIEStatefulBase = function (_RIEBase) {
	    _inherits(RIEStatefulBase, _RIEBase);
	
	    function RIEStatefulBase(props) {
	        _classCallCheck(this, RIEStatefulBase);
	
	        var _this = _possibleConstructorReturn(this, (RIEStatefulBase.__proto__ || Object.getPrototypeOf(RIEStatefulBase)).call(this, props));
	
	        _this.startEditing = function () {
	            debug('startEditing');
	            _this.props.beforeStart ? _this.props.beforeStart() : null;
	            if (_this.props.isDisabled) return;
	            _this.setState({ editing: true });
	            _this.props.afterStart ? _this.props.afterStart() : null;
	        };
	
	        _this.finishEditing = function () {
	            debug('finishEditing');
	            _this.props.beforeFinish ? _this.props.beforeFinish() : null;
	            var newValue = _reactDom2.default.findDOMNode(_this.refs.input).value;
	            var result = _this.doValidations(newValue);
	            if (result && _this.props.value !== newValue) {
	                _this.commit(newValue);
	            }
	            if (!result && _this.props.handleValidationFail) {
	                _this.props.handleValidationFail(result, newValue, function () {
	                    return _this.cancelEditing();
	                });
	            } else {
	                _this.cancelEditing();
	            }
	            _this.props.afterFinish ? _this.props.afterFinish() : null;
	        };
	
	        _this.cancelEditing = function () {
	            debug('cancelEditing');
	            _this.setState({ editing: false, invalid: false });
	        };
	
	        _this.keyDown = function (event) {
	            debug('keyDown(${event.keyCode})');
	            if (event.keyCode === 13) {
	                _this.finishEditing();
	            } // Enter
	            else if (event.keyCode === 27) {
	                    _this.cancelEditing();
	                } // Escape
	        };
	
	        _this.textChanged = function (event) {
	            debug('textChanged(${event.target.value})');
	            _this.doValidations(event.target.value.trim());
	        };
	
	        _this.componentDidUpdate = function (prevProps, prevState) {
	            debug('componentDidUpdate(' + prevProps + ', ' + prevState + ')');
	            var inputElem = _reactDom2.default.findDOMNode(_this.refs.input);
	            debug(inputElem);
	            if (_this.state.editing && !prevState.editing) {
	                debug('entering edit mode');
	                inputElem.focus();
	                _this.selectInputText(inputElem);
	            } else if (_this.state.editing && prevProps.text != _this.props.text) {
	                debug('not editing && text not equal previous props -- finishing editing');
	                _this.finishEditing();
	            }
	        };
	
	        _this.renderEditingComponent = function () {
	            debug('renderEditingComponent()');
	            return _react2.default.createElement('input', _extends({
	                disabled: _this.state.loading,
	                className: _this.makeClassString(),
	                defaultValue: _this.props.value,
	                onInput: _this.textChanged,
	                onBlur: _this.elementBlur,
	                ref: 'input',
	                onKeyDown: _this.keyDown
	            }, _this.props.editProps));
	        };
	
	        _this.renderNormalComponent = function () {
	            debug('renderNormalComponent');
	            return _react2.default.createElement(
	                'span',
	                _extends({
	                    tabIndex: '0',
	                    className: _this.makeClassString(),
	                    onFocus: _this.startEditing,
	                    onClick: _this.startEditing
	                }, _this.props.defaultProps),
	                _this.state.newValue || _this.props.value
	            );
	        };
	
	        _this.elementBlur = function (event) {
	            debug('elementBlur(' + event + ')');
	            _this.finishEditing();
	        };
	
	        _this.elementClick = function (event) {
	            debug('elementClick(' + event + ')');
	            _this.startEditing();
	            event.target.element.focus();
	        };
	
	        _this.render = function () {
	            debug('render()');
	            if (_this.state.editing) {
	                return _this.renderEditingComponent();
	            } else {
	                return _this.renderNormalComponent();
	            }
	        };
	
	        return _this;
	    }
	
	    return RIEStatefulBase;
	}(_RIEBase3.default);
	
	exports.default = RIEStatefulBase;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LandingFeatures = exports.LinkIcon = exports.ViewOnlyIcon = exports.SuccessIcon = exports.Logo = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Logo = exports.Logo = function Logo() {
	    return _react2.default.createElement(
	        'svg',
	        { className: 'logo', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 225.59 70' },
	        _react2.default.createElement('path', { fill: '#ffffff', d: 'M851.65,500q-.2-.7-.4-1.3a10,10,0,0,1-.35-1.5,18.39,18.39,0,0,1-.2-2.3q-.05-1.4,0-3.5v-11q0-4.9-1.7-6.9t-5.5-2h-3.8V500h-11V430h16.6q8.6,0,12.45,4t3.85,12.1v5.5q0,10.8-7.2,14.2a9.86,9.86,0,0,1,5.75,5.55,25.08,25.08,0,0,1,1.55,9.35v10.8a44.78,44.78,0,0,0,.2,4.55,14.57,14.57,0,0,0,1,4Zm-12-60v21.5h4.3a6.92,6.92,0,0,0,4.85-1.6q1.75-1.6,1.75-5.8v-6.9q0-3.8-1.35-5.5a5.1,5.1,0,0,0-4.25-1.7Z', transform: 'translate(-828.65 -430)' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: 'M868.84,430h11v70h-11Z', transform: 'translate(-828.65 -430)' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: 'M887.84,430h17.4q8.3,0,12.35,4.4t4,12.9v35.4q0,8.5-4,12.9T905.24,500h-17.4Zm11,10v50H905a5.54,5.54,0,0,0,4.1-1.5q1.5-1.5,1.5-5.3V446.8q0-3.8-1.5-5.3A5.54,5.54,0,0,0,905,440Z', transform: 'translate(-828.65 -430)' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: 'M928.64,430h11v60h18.1v10h-29.1Z', transform: 'translate(-828.65 -430)' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: 'M962.54,430h11v70h-11Z', transform: 'translate(-828.65 -430)' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: 'M991.34,449.3V500h-9.9V430h13.8l11.3,41.9V430h9.8v70H1005Z', transform: 'translate(-828.65 -430)' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: 'M1035.24,459.5h15.1v10h-15.1V490h19v10h-30V430h30v10h-19Z', transform: 'translate(-828.65 -430)' })
	    );
	};
	
	var SuccessIcon = exports.SuccessIcon = function SuccessIcon() {
	    return _react2.default.createElement(
	        'svg',
	        { className: 'icon success-icon', viewBox: '0 0 39 37', xmlns: 'http://www.w3.org/2000/svg', xlinkHref: 'http://www.w3.org/1999/xlink' },
	        _react2.default.createElement(
	            'g',
	            { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(-635.000000, -150.000000)' },
	                _react2.default.createElement(
	                    'g',
	                    { transform: 'translate(440.000000, 150.000000)' },
	                    _react2.default.createElement(
	                        'g',
	                        { transform: 'translate(195.000000, 0.000000)' },
	                        _react2.default.createElement(
	                            'g',
	                            null,
	                            _react2.default.createElement('ellipse', { strokeOpacity: '0', stroke: '#979797', fill: '#FFFFFF', cx: '18.059043', cy: '17.3781465', rx: '17.3551582', ry: '16.7008009' }),
	                            _react2.default.createElement(
	                                'g',
	                                { fill: '#2DDD6F', fillRule: 'nonzero' },
	                                _react2.default.createElement('path', { d: 'M19.2248521,0 C8.60776073,0 0,8.28286763 0,18.5 C0,28.7171324 8.60776073,37 19.2248521,37 C29.8431149,37 38.4497041,28.7171324 38.4497041,18.5 C38.4497041,8.28286763 29.8427545,0 19.2248521,0 Z M15.6982277,28.0030891 L7.23312158,19.8574974 L10.0545833,17.1424158 L15.6982277,22.5729259 L28.3951208,10.3544084 L31.2165826,13.06949 L15.6982277,28.0030891 Z' })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var ViewOnlyIcon = exports.ViewOnlyIcon = function ViewOnlyIcon() {
	    return _react2.default.createElement(
	        'svg',
	        { className: 'icon view-only-icon', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 80 50' },
	        _react2.default.createElement('path', { className: 'icon--view-only', fill: '#ffffff', d: 'M0,25.13s35.59,55.62,80,.5C80,25.63,43.31-31.71,0,25.13ZM40,44.38A19.38,19.38,0,1,1,59.14,25,19.26,19.26,0,0,1,40,44.38Z' }),
	        _react2.default.createElement('path', { className: 'icon--view-only', fill: '#ffffff', d: 'M32.08,25A7.92,7.92,0,1,0,40,17a8,8,0,0,0-7.92,8Z' })
	    );
	};
	
	var LinkIcon = exports.LinkIcon = function LinkIcon(props) {
	    var className = (0, _classnames3.default)(_defineProperty({
	        'icon': true,
	        'icon--link': true
	    }, props.className, props.className));
	
	    return _react2.default.createElement(
	        'svg',
	        { className: className, xmlns: 'http://www.w3.org/2000/svg', xlinkHref: 'http://www.w3.org/1999/xlink', viewBox: '0 0 482.8 482.8' },
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { className: 'icon-fill', fill: '#ffffff', d: 'M255.2,209.3c-5.3,5.3-5.3,13.8,0,19.1c21.9,21.9,21.9,57.5,0,79.4l-115,115c-21.9,21.9-57.5,21.9-79.4,0l-17.3-17.3c-21.9-21.9-21.9-57.5,0-79.4l115-115c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-115,115C8.7,322.7,0,343.6,0,365.8c0,22.2,8.6,43.1,24.4,58.8l17.3,17.3c16.2,16.2,37.5,24.3,58.8,24.3s42.6-8.1,58.8-24.3l115-115c32.4-32.4,32.4-85.2,0-117.6C269.1,204,260.5,204,255.2,209.3z' }),
	            _react2.default.createElement('path', { className: 'icon-fill', fill: '#ffffff', d: 'M458.5,58.2l-17.3-17.3c-32.4-32.4-85.2-32.4-117.6,0l-115,115c-32.4,32.4-32.4,85.2,0,117.6c5.3,5.3,13.8,5.3,19.1,0s5.3-13.8,0-19.1c-21.9-21.9-21.9-57.5,0-79.4l115-115c21.9-21.9,57.5-21.9,79.4,0l17.3,17.3c21.9,21.9,21.9,57.5,0,79.4l-115,115c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l115-115c15.7-15.7,24.4-36.6,24.4-58.8C482.8,94.8,474.2,73.9,458.5,58.2z' })
	        )
	    );
	};
	
	var LandingFeatures = exports.LandingFeatures = function LandingFeatures() {
	    return _react2.default.createElement(
	        'svg',
	        { className: 'landing-divider', width: '1440px', height: '287px', viewBox: '0 0 1440 287', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xlinkHref: 'http://www.w3.org/1999/xlink' },
	        _react2.default.createElement(
	            'g',
	            { id: 'Landing', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	            _react2.default.createElement(
	                'g',
	                { id: 'Sales-page---5', transform: 'translate(0.000000, -3560.000000)' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'Group-12', transform: 'translate(-340.000000, 3560.000000)' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Page-1', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '0.48' },
	                        _react2.default.createElement('polyline', { id: 'Stroke-1', stroke: '#2DDD6F', points: '0.24 126.7074 214.484 61.9434 246.05 53.2304 277.804 44.8264 309.72 36.8684 341.774 29.5044 360.828 25.5054 379.559 21.9134 398.506 18.4844 417.399 15.3424 436.482 12.5084 455.51 9.9564 474.73 7.7144 494.137 5.7754 513.737 4.1454 533.037 2.7804 552.257 1.8424 571.209 1.0234 590.348 0.5174 609.407 0.4354 628.683 0.5174 647.69 0.7214 666.371 1.3314 685.026 2.0854 703.41 2.9594 721.986 4.1434 758.325 6.8704 794.042 10.2704 829.195 14.0574 864.021 18.2504 931.756 27.6294 995.925 37.5674 1059.739 48.0564 1593.979 146.6504 1683.161 161.6684 1726.941 168.2364 1770.287 174.4784 1812.088 179.7124 1854.217 184.5394 1896.99 188.5544' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-3', stroke: '#2DDD6F', points: '46.153 112.7162 216.272 64.2762 247.243 56.0912 278.646 48.2352 310.212 40.8272 341.916 34.0142 360.674 30.2792 379.375 26.8292 398.053 23.5242 416.892 20.6662 435.706 17.9532 454.707 15.5442 473.656 13.4222 493.037 11.6272 512.148 9.9542 531.178 8.7102 550.157 7.7522 569.107 6.9362 587.977 6.5462 606.821 6.3022 625.61 6.3432 644.371 6.5252 662.837 6.9722 681.007 7.6842 717.507 9.5552 753.629 12.1202 789.399 15.2362 824.605 18.7342 858.998 22.6012 925.867 31.3222 989.682 40.5072 1053.12 50.3812 1585.863 143.7682 1674.937 158.0502 1761.902 170.4082 1803.242 175.4592 1845.397 180.1452 1887.928 184.1382 1930.106 187.3762' }),
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'Group-8', transform: 'translate(0.000000, 11.390000)', stroke: '#2DDD6F' },
	                            _react2.default.createElement('polyline', { id: 'Stroke-4', points: '0.5881 113.4629 217.8151 55.1949 279.7331 40.2779 310.7331 33.2569 342.0831 26.9919 360.5711 23.3779 379.2201 20.2149 397.8441 17.1929 416.4401 14.3159 435.1991 11.8859 453.9291 9.6019 472.6091 7.5989 491.7471 5.7839 510.5611 4.3749 529.5931 3.1299 548.3271 2.1509 567.0061 1.4559 585.6591 0.9039 604.2331 0.7799 622.8061 0.6559 641.2991 0.9599 659.5461 1.2439 677.4731 1.9339 713.5381 3.4789 749.2001 5.8589 784.7831 8.6659 819.5541 11.8389 853.7321 15.5399 920.2511 23.5059 983.4431 32.0549 1046.7421 41.3369 1391.4631 98.1899 1577.9931 129.5179 1666.7141 143.0439 1753.5111 154.9529 1794.8571 160.0029 1836.7951 164.5249 1878.8361 168.4779 1921.0181 171.7119' }),
	                            _react2.default.createElement('polyline', { id: 'Stroke-6', points: '0.8034 112.3204 219.6034 57.5274 280.6024 43.5434 311.2504 37.0734 342.0354 31.1934 360.4684 27.8664 379.0914 24.8434 397.4174 22.0894 415.9864 19.3524 434.4764 17.0454 453.1804 14.9034 471.8324 13.0444 490.4584 11.3304 509.2724 9.9224 527.7904 8.7774 546.2794 7.7764 564.9604 7.0814 583.3424 6.6514 601.6984 6.3624 620.0034 6.3604 638.2774 6.5014 674.2354 7.3094 709.8164 8.8114 745.0444 10.8644 780.1944 13.3424 814.7484 16.3514 848.7364 19.7464 914.3864 27.0584 977.6854 35.0354 1040.3934 43.5414 1570.1504 126.5124 1658.7094 139.5914 1745.0994 151.0274 1786.2534 155.7734 1827.9474 160.2714 1869.9934 164.2224 1911.9294 167.4394' })
	                        ),
	                        _react2.default.createElement('polyline', { id: 'Stroke-9', stroke: '#2DDD6F', points: '1.0183 122.5678 221.1733 71.0868 281.4733 58.2008 311.7693 52.2818 341.9873 46.7868 378.7193 40.8458 397.2623 38.2528 415.5343 35.7808 433.7523 33.5968 452.1863 31.5728 470.8393 29.7148 489.1953 28.1248 507.7393 26.8358 526.2553 25.6918 544.4753 24.8118 562.9133 24.0958 581.0523 23.6428 599.1663 23.3348 635.5003 23.4518 670.7553 24.0538 706.1203 25.3938 741.1583 27.1378 775.8473 29.4328 809.9703 32.1128 843.7673 35.2018 909.0383 41.8998 971.7183 49.2418 1153.5853 73.7818 1650.7283 147.3828 1736.9573 158.3748 1819.5863 167.4548 1861.1473 171.3628 1902.8373 174.5578' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-10', stroke: '#2DDD6F', points: '1.26 121.2836 222.745 73.2546 283.125 61.2476 312.829 55.8526 342.209 50.8686 378.618 45.3336 415.135 40.5346 433.327 38.4896 451.493 36.5916 469.845 34.9976 488.175 33.5466 506.475 32.2386 524.722 31.2166 542.699 30.3146 560.893 29.5756 596.903 28.7956 632.778 28.7266 667.789 29.3086 702.449 30.4416 737.272 32.0216 771.5 34.1326 838.798 39.2646 903.692 45.3516 1028.423 59.4026 1147.236 74.6766 1642.72 143.9296 1728.785 154.4706 1810.984 163.2226 1852.543 167.1316 1893.99 170.3036' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-11', stroke: '#2DDD6F', points: '1.5276 119.8568 224.0716 75.3998 283.7516 64.4928 313.1586 59.3628 342.1886 54.9288 378.5156 49.8218 414.4926 45.2628 450.7956 41.6078 486.9646 38.6648 523.2426 36.4548 558.8996 34.9158 594.3946 34.2358 629.8116 33.9818 664.5776 34.5428 699.0496 35.3668 733.4126 36.7628 767.4526 38.5658 834.0996 43.2098 898.5876 48.8228 1022.3156 61.6268 1140.6126 75.6978 1547.2646 129.3818 1720.8616 150.5878 1802.6006 159.1568 1843.9386 162.8988 1885.3626 166.2158 1925.8916 169.0208' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-12', stroke: '#2DDD6F', points: '1.8235 118.2865 225.6445 77.5675 284.6745 67.4745 342.1925 58.8455 378.2245 54.0045 414.0945 50.0175 449.8565 46.6025 485.9985 43.8015 521.7625 41.6925 557.1495 40.2755 592.1865 39.4095 627.3325 39.2795 661.6665 39.5115 695.8945 40.3165 729.7975 41.5255 763.3765 43.1435 829.4015 47.1505 893.5085 52.1515 1016.7205 63.7515 1134.5035 76.6165 1712.9325 146.7075 1794.4825 154.9685 1876.5155 161.9665 1917.0175 164.9115' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-13', stroke: '#2DDD6F', points: '2.1179 116.7162 285.3279 70.5782 342.2249 62.6202 378.1759 58.2062 413.7479 54.4862 449.2149 51.3332 484.8149 48.7782 520.3089 46.7892 555.2089 45.3302 589.9769 44.5862 624.6609 44.2702 658.7529 44.4812 692.5209 45.0992 726.2079 46.1472 759.5969 47.4572 824.9739 50.9732 888.4569 55.3402 1011.1289 65.8752 1128.3969 77.5352 1705.0089 142.8252 1786.1239 150.7582 1868.1299 157.8982 1947.7259 163.3772' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-14', stroke: '#2DDD6F', points: '2.4402 115.0033 286.0342 73.3973 342.2582 66.3953 377.8852 62.3883 413.4032 58.9523 448.5712 56.0663 483.6582 53.6083 518.8822 51.7423 553.5132 50.4053 588.0372 49.6393 622.2352 49.2803 655.8662 49.3073 689.4182 49.7623 755.8192 51.7703 820.5442 54.7953 883.6482 58.5473 987.2862 66.4103 1092.3842 75.7063 1290.9562 95.6063' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-15', stroke: '#2DDD6F', points: '1301.636 96.6801 1697.324 138.9651 1859.5 153.8111 1938.801 159.5531' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-16', stroke: '#2DDD6F', points: '2.7624 113.2895 286.7144 76.3565 342.3164 70.0265 378.3764 66.3475 413.5974 63.1755 448.4694 60.5545 482.7734 58.3185 516.9714 56.6555 551.0874 55.4165 585.1514 54.4665 619.8354 54.1475 653.2514 54.0115 686.3154 54.4235 752.0674 55.9395 816.3874 58.4955 879.0844 61.7775 997.2914 69.7475 1116.1794 79.3745 1851.1404 149.6005 1930.1164 155.7525' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-17', stroke: '#2DDD6F', points: '3.112 111.434 342.403 73.515 413.28 67.5 447.638 64.98 481.645 63.007 515.572 61.463 549.445 60.205 583.238 59.376 617.463 58.875 683.51 58.824 748.584 59.99 812.254 62.053 874.548 64.864 992.215 71.772 1110.313 80.312 1848.863 145.921 1995.085 157.49' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-18', stroke: '#2DDD6F', points: '117.0461 98.725 342.4881 77.005 413.0151 71.54 480.7871 67.575 547.8291 64.854 615.1181 63.458 680.7031 63.219 745.1031 64.039 808.3661 65.629 870.0091 67.952 987.3771 73.817 1104.7181 81.133 2047.4531 159.149' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-19', stroke: '#2DDD6F', points: '121.0749 98.349 342.5999 80.351 412.5079 75.558 479.7119 71.979 546.2129 69.499 613.0409 67.919 677.9249 67.475 741.6479 67.946 865.7419 70.915 982.8089 75.742 1099.1229 81.95 1315.1249 95.97 1667.1049 123.423 2037.7199 156.995' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-20', stroke: '#2DDD6F', points: '123.1013 98.0893 342.7403 83.5563 478.9063 76.2623 544.6253 74.0053 610.9673 72.3823 675.3903 71.7503 738.4353 71.8733 861.4753 73.8813 978.2453 77.6633 1093.5543 82.6273 1308.6883 94.6823 1659.6913 119.4413 1824.2463 133.4773 2058.1033 157.7543' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-22', stroke: '#2DDD6F', points: '4.6677 103.1576 478.1017 80.5436 608.9187 76.7006 735.5207 75.5376 857.4787 76.7236 1031.2377 81.2636 1198.3777 88.1256' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-23', stroke: '#2DDD6F', points: '1210.8684 88.7777 1476.6954 103.5077 1652.2764 115.4597 1816.1294 129.2897 1890.6484 136.7927' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-24', stroke: '#2DDD6F', points: '134.1047 97.4525 342.8027 89.8005 606.8967 80.8765 732.3357 79.3215 853.4807 79.5675 969.4077 81.2475 1082.8767 84.1635 1296.0597 92.1315 1470.0657 100.6075 1645.1077 111.4975 1728.7337 117.9075 1808.2557 125.1235 1882.4797 132.8885 1917.0597 137.0595' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-25', stroke: '#2DDD6F', points: '5.5271 98.5883 177.3041 96.5703 729.4491 82.8423 849.5091 82.2683 1077.5521 84.8593 1289.8931 90.7273 1463.4411 97.7123 1637.9371 107.5363 1721.3771 113.6423 1800.4091 120.8103 1837.9941 124.8103 1874.0641 128.9633 1908.5941 133.4223' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-26', stroke: '#2DDD6F', points: '5.9558 96.3041 178.4408 97.1041 342.9458 95.6151 845.8098 84.8491 1072.4978 85.4361 1283.9708 89.3411 1456.8138 94.8141 1544.6268 98.6881 1630.7678 103.5751 1714.0188 109.3731 1753.9288 112.8491 1792.8058 116.5231 1830.1468 120.4981 1865.9208 124.9201 1900.1568 129.6411' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-27', stroke: '#2DDD6F', points: '6.4128 93.8774 179.3608 97.4754 262.7908 98.3564 342.9228 98.3674 474.6348 96.3454 842.3528 87.4484 1067.4458 86.0114 1277.8058 87.9334 1456.3498 92.0174 1541.5688 95.2294 1623.6288 99.4724 1702.2788 104.7244 1741.4838 107.9924 1780.1208 111.6474 1818.1668 115.8284 1854.8848 120.4784 1872.7058 123.0444 1890.2528 125.7314' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-28', stroke: '#2DDD6F', points: '6.8952 91.309 180.5232 97.868 263.7142 100.032 343.1692 101.002 409.2432 100.807 473.7212 99.892 838.6512 90.028 1062.6332 86.608 1271.8832 86.547 1449.7212 89.12 1534.8322 91.597 1616.7272 95.392 1655.8772 97.637 1695.1872 100.333 1734.1502 103.58 1772.7872 107.236 1810.3182 111.518 1828.9232 113.866 1846.9842 116.451 1864.8062 119.019 1882.3002 121.992 1899.3082 124.926' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-29', stroke: '#2DDD6F', points: '7.3518 88.8832 241.0848 100.6742 292.6978 102.4082 343.1748 103.6142 408.8698 104.1102 473.0498 103.4602 835.2218 92.4852 1110.4038 86.4132' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-30', stroke: '#2DDD6F', points: '1121.3254 86.2055 1266.2044 85.1825 1443.1494 85.9345 1527.8524 87.9425 1609.6104 91.1435 1648.7594 93.3915 1687.8554 95.9255 1726.8184 99.1725 1765.2164 102.8065 1802.7154 107.2305 1821.2944 109.7185 1839.1114 112.2845 1856.8774 115.1375 1874.1314 118.0905 1891.0854 121.3085' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-31', stroke: '#2DDD6F', points: '7.8357 86.3129 241.8437 101.9009 293.0787 104.3309 343.2037 106.0839 376.2147 106.7809 408.7927 107.1509 472.1357 107.0079 534.4487 105.7599 1053.0377 87.6579 1260.3077 83.6529 1436.7937 82.9159 1521.1427 84.1659 1562.2107 85.4189 1602.7357 86.9169 1641.9147 89.0239 1681.0097 91.5559 1719.7547 94.6379 1757.8807 98.3939 1776.7817 100.4749 1795.3837 102.8209 1813.6897 105.4289 1831.4837 108.1399 1849.0067 110.9689 1866.2047 114.2089 1882.8897 117.5459 1899.2787 121.1509' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-32', stroke: '#2DDD6F', points: '8.3445 83.6029 242.6295 102.9809 293.4875 106.1049 343.5055 108.4289 376.1905 109.5349 408.4715 110.1679 440.1035 110.3119 471.5185 110.2899 533.2905 109.2859 594.7135 107.5259 1048.2515 88.1109 1254.6545 82.1469 1343.7595 80.4729 1430.4605 79.7529 1514.6775 80.4119 1555.5535 81.3609 1595.8655 82.6929 1635.0945 84.5109 1673.9475 87.0249 1712.6925 90.1079 1731.8905 91.9239 1750.8165 93.8629 1769.4495 96.0649 1788.0525 98.4109 1806.1145 100.9979 1823.8795 103.8499 1841.3485 106.9659 1858.3045 110.1839 1874.9365 113.8099 1891.0255 117.6749' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-33', stroke: '#2DDD6F', points: '8.8274 81.0307 243.4414 103.9247 293.9214 107.7397 343.5614 110.7577 376.1954 112.1457 408.1794 113.0457 439.5134 113.4527 470.6584 113.5527 532.1334 112.8117 593.3394 110.8867 1043.7374 88.4447 1249.0054 80.6377 1337.5394 78.0437 1424.1034 76.7337 1507.9654 76.6357 1548.8974 77.2987 1589.2344 78.4897 1628.2514 80.1447 1667.1264 82.5127 1705.6564 85.4337 1724.8534 87.2507 1743.7554 89.3317 1762.3854 91.5317 1780.7184 94.0007 1798.7554 96.7317 1816.5194 99.5837 1833.7194 102.8227 1850.6194 106.3237 1858.9514 108.0627 1866.9804 110.0687 1875.0404 111.9307 1883.0464 114.0797 1895.9994 117.5287' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-35', stroke: '#2DDD6F', points: '193.5578 99.5824 269.5358 107.2114 306.7668 110.4524 343.6468 112.9384 375.9828 114.5924 407.9118 115.7774 439.1918 116.4694 470.0678 116.6904 500.5068 116.5854 531.0308 116.0504 591.9648 114.2484 709.3158 108.3614 1243.3748 78.9874 1331.8048 75.6594 1417.7708 73.5694 1459.9468 72.8914 1501.4968 72.8814 1542.4858 73.2574 1582.6318 74.1434 1621.4298 75.6334 1660.3358 77.8604 1679.6158 79.2504 1698.8378 80.9234 1717.7928 82.7174 1736.7198 84.6554 1755.3218 87.0024 1773.4128 89.4474 1791.4208 92.3204 1808.9188 95.2944 1826.0898 98.6734 1834.6618 100.4364 1842.9648 102.3204 1851.2678 104.2044 1859.2988 106.2094 1867.3038 108.3544 1875.0658 110.4834 1889.1298 114.6084' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-37', stroke: '#2DDD6F', points: '194.531 99.6645 270.052 108.4185 307.202 112.0895 343.728 115.1245 376.012 117.0625 407.645 118.5095 438.63 119.4675 469.233 119.8105 499.675 119.7075 529.926 119.2925 590.374 117.4455 648.036 114.6335 1237.971 77.5005 1325.826 73.2535 1411.713 70.2875 1453.669 69.4415 1495.059 68.9845 1535.828 69.1965 1576.03 69.7955 1614.854 71.1435 1634.455 72.1265 1653.787 73.2275 1673.068 74.6175 1692.046 76.2695 1711.002 78.0645 1729.656 80.1245 1748.258 82.4695 1766.324 85.0575 1784.091 87.9095 1801.557 91.0275 1810.133 92.7875 1818.701 94.5505 1827.031 96.2915 1835.307 98.3175 1843.583 100.3445 1851.617 102.3485 1859.379 104.4755 1867.115 106.7425 1874.12 108.9495 1881.124 111.1545 1894.62 115.6665' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-39', stroke: '#2DDD6F', points: '195.9909 99.7934 245.6629 106.5854 295.0099 112.4774 319.5329 114.9004 343.8409 117.1644 375.8009 119.5124 407.1359 121.2224 438.0919 122.3224 468.6699 122.8104 498.8409 122.8244 528.8219 122.5324 558.9089 121.6714 589.0529 120.5234 646.4719 117.6874 1030.6819 89.4834' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-40', stroke: '#2DDD6F', points: '1039.196 88.9193 1232.584 75.8713 1320.089 70.8673 1405.624 67.1463 1447.395 65.9943 1488.593 65.2293 1529.443 65.0143 1569.427 65.4473 1609.01 66.7173 1628.368 67.6783 1647.7 68.7833 1667.005 70.0273 1685.74 71.6563 1704.452 73.4323 1722.863 75.4703 1740.985 77.7733 1759.045 80.3603 1776.541 83.3363 1785.382 84.9763 1793.983 86.5963 1802.558 88.3563 1810.86 90.2393 1819.159 92.1243 1827.435 94.1493 1835.681 96.3173 1843.689 98.4663 1851.666 100.7573 1859.377 103.1703 1866.38 105.3733 1873.115 107.7023 1886.56 112.4993 1899.703 117.5613' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-41', stroke: '#2DDD6F', points: '10.8943 70.0434 246.5293 107.2404 295.2543 113.8034 319.6983 116.6564 343.9793 119.0604 360.0133 120.6024 375.8563 121.8354 391.4853 122.9074 406.9233 123.6714 437.5813 125.0334 467.8623 125.7864 498.0063 125.9434 528.0153 125.5084 557.8333 124.7694 587.9763 123.6204 644.9353 120.6024 703.0543 116.6664 1026.4103 89.8374' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-42', stroke: '#2DDD6F', points: '1030.6819 89.4838 1227.2039 74.2428 1314.3569 68.4838 1399.5379 64.0038 1441.1419 62.4028 1482.3969 61.3528 1523.0319 60.9748 1563.0689 61.1228 1582.7779 61.5338 1602.4319 62.2288 1621.8189 63.0468 1641.1779 64.0058 1660.2089 65.3748 1679.2209 66.8828 1697.6589 68.7798 1716.0739 70.8178 1734.1629 73.2618 1751.9799 75.8298 1760.8529 77.3288 1769.4519 78.9468 1778.2939 80.5868 1786.8659 82.3488 1795.1959 84.0888 1803.7419 85.9938 1812.0169 88.0208 1820.0219 90.1698 1828.2709 92.3358 1836.2489 94.6278 1843.9569 97.0398 1851.6659 99.4518 1858.6429 101.7998 1865.3509 104.2698 1878.7429 109.3518 1891.6179 114.5358' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-43', stroke: '#2DDD6F', points: '11.4314 67.1869 247.1254 108.0169 271.4074 111.7269 295.7434 115.1519 319.8904 118.2699 344.0904 121.1009 359.8804 122.6219 375.6984 123.9989 391.2994 125.2119 406.6844 126.2629 421.8774 127.0039 437.0714 127.7469 467.3254 128.6399 497.2274 128.7769 526.9384 128.6059 556.7574 127.8659 586.6554 126.6969 644.3984 123.4569 701.0844 119.2519 1072.4974 85.4359' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-44', stroke: '#2DDD6F', points: '1073.4983 85.3764 1308.6483 65.9544 1393.4773 60.7194 1435.1363 58.8324 1476.1993 57.4774 1516.8883 56.8124 1556.7093 56.7974 1576.4453 57.0654 1595.8833 57.5974 1615.5123 58.4364 1634.6283 59.3754 1653.6633 60.7414 1672.6703 62.2514 1691.1393 64.0044 1709.2823 66.1634 1727.3713 68.6094 1736.2683 69.9644 1745.1623 71.3184 1754.0343 72.8164 1762.6343 74.4364 1771.2053 76.1974 1779.7783 77.9584 1788.0813 79.8424 1796.6253 81.7464 1804.6313 83.8964 1812.8793 86.0644 1820.8583 88.3554 1828.5663 90.7654 1836.5173 93.1994 1843.9563 95.7324 1850.9083 98.2254 1857.5863 100.8384 1864.2693 103.4494 1870.7073 106.0434 1883.5273 111.5094 1944.9913 139.7824' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-45', stroke: '#2DDD6F', points: '11.9685 64.3324 247.7465 108.6504 271.9755 112.6464 295.9875 116.4794 320.0805 119.8814 344.2545 122.8574 359.9915 124.6614 375.5385 126.1604 391.1135 127.5174 406.4695 128.7084 421.6375 129.5954 436.5895 130.3164 451.5685 130.8954 466.5725 131.3304 496.4195 131.7544 525.8875 131.5614 555.7065 130.8214 585.3625 129.6314 614.0985 128.0714 642.8885 126.2274 699.3585 121.8574 915.2585 100.9054 1018.4085 90.3024 1302.9125 63.5704 1387.3905 57.5774 1428.8855 55.2444 1470.0055 53.6024 1510.5025 52.6294 1550.3495 52.4734 1570.0895 52.7394 1589.5515 53.1284 1608.9645 53.8034 1628.3215 54.7624 1647.1395 55.9664 1665.9045 57.4564 1684.5885 59.3714 1702.7325 61.5304 1711.6825 62.6024 1720.8245 63.9784 1729.7175 65.3324 1738.3445 66.8094 1747.2135 68.3064 1755.8115 69.9244 1764.3855 71.6884 1772.9305 73.5914 1781.2345 75.4744 1789.4835 77.6454 1797.4885 79.7914 1805.4945 81.9384 1813.4445 84.3724 1821.3965 86.8064 1828.8325 89.3384 1836.4865 92.0354 1843.1695 94.6504 1849.8485 97.2624 1856.5075 100.0174 1862.8905 102.8944' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-47', stroke: '#2DDD6F', points: '12.5051 61.4779 248.6121 109.3079 272.5181 113.7079 296.5031 117.6859 320.2721 121.4939 344.1501 124.7339 359.8591 126.6839 375.3801 128.3249 390.9261 129.8219 406.0411 130.9939 421.1811 132.0209 436.1051 132.8849 451.0571 133.6069 466.0631 134.0429 480.8231 134.4569 495.6391 134.5869 525.1081 134.3959 554.4391 133.6139 584.3381 132.4449 612.8311 130.8619 641.4051 128.8529 697.4151 124.2999 806.7841 113.5119 1211.5441 69.3969 1297.4241 61.2069 1381.5741 54.3159 1422.8791 51.6739 1463.8081 49.7249 1504.3581 48.4679 1524.4451 48.1849 1544.0181 48.0039 1563.7521 48.2709 1583.2471 48.5179 1602.6581 49.1929 1621.7741 50.1299 1640.8361 51.3559 1659.6001 52.8429 1678.0651 54.5959 1696.2101 56.7559 1705.1321 57.9689 1714.2751 59.3449 1722.9271 60.6789 1731.7931 62.1759 1740.3951 63.7949 1748.9671 65.5579 1757.5401 67.3199 1766.0841 69.2219 1774.3631 71.2499 1782.3651 73.3969 1790.6141 75.5669 1798.3521 77.8359 1806.2751 80.4129 1813.9571 82.9659 1821.6111 85.6639 1829.0231 88.3419 1835.6761 91.0949 1842.3311 93.8509 1848.9591 96.7489 1855.3441 99.6259 1867.8131 105.6459 1927.5771 136.3809' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-49', stroke: '#2DDD6F', points: '224.4924 104.7416 272.8704 114.4676 296.7764 118.8686 320.4914 122.9646 344.3134 126.4876 359.9964 128.5806 375.4904 130.3636 390.7664 131.9836 405.8554 133.2966 420.7254 134.4486 435.6224 135.4546 450.5744 136.1766 465.3094 136.7336 480.0724 137.1476 494.6414 137.2546 509.4584 137.3846 524.0834 137.2086 553.6594 136.4466 583.0714 135.2346 611.5914 133.5106 640.1374 131.6426 695.7144 126.7626 804.4874 115.1976 1291.9584 58.6986 1334.0204 54.6736 1375.7294 51.1956 1416.8444 48.2476 1457.8524 45.8706 1498.2134 44.3056 1518.0844 43.8596 1537.9024 43.6996 1557.4514 43.6606 1576.9134 44.0486 1596.3544 44.5816 1615.4684 45.5196 1634.5584 46.6016 1653.0754 48.0686 1671.5194 49.9656 1680.7114 51.0556 1689.6624 52.1256 1698.8274 53.3576 1707.7234 54.7126 1716.5944 56.2106 1725.2214 57.6856 1733.8194 59.3046 1742.3884 61.0676 1750.9374 62.9726 1759.2384 64.8556 1767.4894 67.0246 1775.4924 69.1726 1783.4734 71.4616 1791.4214 73.8956 1799.1324 76.3086 1806.7864 79.0056 1814.1724 81.8246 1821.5554 84.6436 1826.5874 86.8216 1831.6464 88.8576 1841.4364 93.3376' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-52', stroke: '#2DDD6F', points: '226.386 105.1967 273.44 115.3857 297.048 120.0527 320.738 124.2917 344.479 128.2437 359.891 130.4577 375.358 132.3837 390.608 134.1457 405.426 135.5827 420.511 136.8937 435.166 137.8807 450.091 138.7447 464.827 139.3027 479.344 139.6947 493.89 139.9477 508.705 140.0747 523.331 139.8997 537.956 139.7217 552.635 139.2597 582.075 137.9067 610.568 136.3237 638.681 134.1297 694.285 129.1037 748.563 123.2407 1286.467 56.3367 1328.364 51.8597 1369.911 47.9337 1411.08 44.6997 1451.903 42.0147 1492.047 40.2877 1512.187 39.7197 1531.786 39.3947 1551.361 39.2127 1570.854 39.4607 1590.049 39.9697 1609.19 40.7657 1628.25 41.9917 1646.772 43.4587 1656.019 44.2637 1665.238 45.2117 1674.19 46.2807 1683.358 47.5127 1692.276 48.7247 1701.178 50.0817 1710.046 51.5797 1718.644 53.1987 1727.243 54.8167 1735.815 56.5787 1744.118 58.4627 1752.394 60.4887 1760.641 62.6577 1768.619 64.9477 1776.599 67.2387 1784.282 69.7927 1791.962 72.3457 1799.588 75.1867 1806.976 78.0057 1814.089 80.9467 1819.119 83.1267 1824.152 85.3037 1833.917 89.9267' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-55', stroke: '#2DDD6F', points: '227.3322 105.4242 274.0352 116.1632 297.5632 121.2602 320.9552 125.7612 332.9062 127.9612 344.6692 129.8562 360.0552 132.2132 375.2242 134.4042 390.2322 136.1452 405.2662 137.7432 420.0812 139.1792 434.7102 140.3062 449.3932 141.1502 464.1002 141.8512 478.5912 142.3862 493.1362 142.6392 507.7082 142.7442 522.3332 142.5682 536.9582 142.3922 551.6402 141.9282 581.0502 140.7162 609.3542 138.8292 637.4422 136.7772 665.1222 134.2552 692.6122 131.4252 746.6992 125.2542 965.3722 96.1292' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-56', stroke: '#2DDD6F', points: '975.8044 94.5717 1280.9994 53.8297 1322.7124 49.0457 1364.3134 44.8347 1405.0754 41.1297 1445.9474 38.1607 1466.1944 37.0207 1486.1484 36.1457 1506.0704 35.4157 1525.6974 34.9477 1545.2714 34.7667 1564.7644 35.0117 1583.9844 35.3807 1603.1284 36.1767 1621.9734 37.2367 1631.2454 37.8997 1640.4924 38.7047 1649.7124 39.6527 1658.9334 40.6007 1667.8834 41.6697 1677.0774 42.7597 1685.9734 44.1137 1694.8684 45.4697 1703.4974 46.9457 1712.0944 48.5647 1720.6684 50.3267 1729.2144 52.2307 1737.5174 54.1147 1745.7654 56.2837 1754.0154 58.4537 1761.9914 60.7427 1769.7014 63.1547 1777.6234 65.7307 1785.0354 68.4077 1792.4204 71.2257 1799.7764 74.1887 1806.8664 77.2717 1813.4674 80.3117 1820.0684 83.3527 1826.3704 86.6597 1832.6724 89.9647 1844.7674 96.6747 1913.7094 137.7847' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-58', stroke: '#2DDD6F', points: '228.0344 105.6293 274.3614 117.0643 297.8624 122.2983 321.2004 127.0883 332.8834 129.4103 344.6174 131.4463 359.9774 133.9473 375.1204 136.2773 390.0734 138.3063 405.1074 139.9073 419.6524 141.4613 434.2804 142.5903 448.9354 143.5763 463.6164 144.4203 478.1074 144.9553 492.4104 145.1863 506.9814 145.2933 521.5804 145.2603 535.9634 145.0613 550.6424 144.5963 565.3484 143.9933 580.0814 143.2443 608.1154 141.4783 636.2554 139.1413 663.9344 136.6183 691.2084 133.6233 744.8374 127.2683 1275.7554 51.4873 1317.0574 46.2333 1358.4944 41.5703 1399.3124 37.5803 1439.9954 34.3043 1460.2694 33.0233 1480.2474 32.0053 1500.1714 31.2753 1519.8244 30.6653 1539.1524 30.4613 1558.6994 30.4223 1577.9254 30.7903 1596.8204 31.5643 1615.6684 32.6253 1625.1834 33.3103 1634.4304 34.1153 1643.6794 34.9203 1652.6544 35.8473 1661.8494 36.9363 1670.7734 38.1493 1679.6694 39.5043 1688.5604 40.8583 1697.1644 42.4783 1705.7614 44.0963 1714.3354 45.8593 1722.6374 47.7423 1731.1544 49.7893 1739.1604 51.9383 1747.3854 54.2483 1755.3624 56.5383 1763.0434 59.0943 1770.6994 61.7913 1778.1104 64.4683 1785.4684 67.4293 1792.5814 70.3693 1799.6424 73.5963 1806.2424 76.6373 1812.7904 79.9623' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-60', stroke: '#2DDD6F', points: '51.9983 56.6479 252.0783 111.9309 274.9843 117.6969 298.1613 123.3419 321.4433 128.4159 333.1003 130.8789 344.8103 133.0619 359.8983 135.6789 374.7703 138.1369 389.7253 140.1629 404.7053 142.0479 419.7383 143.6469 434.5813 144.9379 449.6953 146.1099 464.8913 146.8519 479.3823 147.3879 493.8993 147.7819 508.2283 147.8679 522.5853 147.8129 536.7233 147.5919 550.8893 147.2319 565.1073 146.5839 579.0853 145.9149 606.9013 143.9859 634.7983 141.6249 662.0193 138.9169 689.0503 135.9029 743.0023 129.1409 795.5743 121.8209 1270.2893 48.9789 1311.6463 43.4399 1352.8943 38.4719 1393.5203 34.1759 1434.2603 30.6139 1454.3183 29.1689 1474.3503 27.8659 1494.0543 26.9689 1513.9493 26.3819 1533.3103 26.0349 1552.6123 25.9749 1571.8613 26.2019 1590.7873 26.8339 1600.3283 27.3739 1609.6313 27.8939 1618.9053 28.5549 1628.1543 29.3599 1637.3723 30.3089 1646.5953 31.2569 1655.5453 32.3269 1664.4653 33.5389 1673.3613 34.8919 1682.2333 36.3899 1690.8563 37.8679 1699.4333 39.6289 1708.0023 41.3899 1716.2813 43.4179 1724.5563 45.4429 1732.8033 47.6119 1740.7563 50.0439 1748.7053 52.4789 1756.3883 55.0329 1763.7993 57.7089 1771.4253 60.5479 1778.5413 63.4899 1785.6023 66.7159 1792.6613 69.9409 1798.9923 73.1049 1805.5403 76.4309 1811.8163 79.8779 1817.8223 83.4489 1829.8103 90.7309 1896.9723 134.7299' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-63', stroke: '#2DDD6F', points: '231.8205 106.5385 275.5795 118.4755 298.4575 124.3825 321.6915 129.7415 333.3445 132.2055 345.0015 134.6735 359.8185 137.4145 374.6925 139.8695 389.5925 142.1805 404.5455 144.2105 419.3355 145.7865 434.3965 147.2435 449.5085 148.4135 464.6765 149.2995 478.9005 149.9575 493.4165 150.3515 507.7455 150.4375 521.8595 150.3615 535.9975 150.1415 550.1635 149.7775 564.1395 149.1095 578.1435 148.2975 605.9315 146.5105 633.6115 143.9875 660.8325 141.2805 687.6475 138.1015 741.1655 131.0105 793.7925 123.4065 1265.0435 46.6365 1306.2075 40.7905 1347.2935 35.3735 1388.0035 30.6485 1428.3055 26.7585 1448.3905 25.1705 1468.4215 23.8675 1488.4005 22.8515 1507.8375 22.0775 1527.4625 21.6105 1546.7935 21.4045 1565.7715 21.7525 1575.3725 22.0095 1584.9665 22.2635 1594.2675 22.7825 1603.5685 23.3045 1612.8445 23.9655 1622.0915 24.7705 1631.3375 25.5755 1640.5275 26.6655 1649.4805 27.7365 1658.4035 28.9485 1667.3025 30.3025 1675.9265 31.7795 1684.7695 33.4185 1693.3415 35.1825 1701.6685 36.9235 1709.9465 38.9475 1718.1955 41.1175 1726.4175 43.4285 1734.3955 45.7195 1742.0745 48.2745 1749.7345 50.9725 1757.1175 53.7905 1764.5015 56.6095 1771.5875 59.6925 1778.6465 62.9195 1785.4375 66.2675 1791.9855 69.5935' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-65', stroke: '#2DDD6F', points: '53.8557 52.0209 253.4037 112.7709 275.9327 119.2289 299.0287 125.3029 321.9357 131.0699 333.5647 133.6759 344.9757 136.1219 359.9847 139.1679 374.5867 141.7449 389.4847 144.0589 404.4127 146.2289 419.1767 147.9489 433.9667 149.5279 449.0797 150.6969 464.2217 151.7269 478.6857 152.4069 492.9597 152.7779 507.2637 153.0069 521.3757 152.9309 535.5137 152.7099 549.4637 152.1839 563.4127 151.6579 577.4167 150.8459 604.9887 148.8949 632.4257 146.3499 659.6727 143.4999 686.2707 140.1589 739.5747 132.9019 791.7927 124.8289 929.7487 101.4419' }),
	                        _react2.default.createElement('path', { d: 'M938.9655,99.7777 L941.7765,99.2967', id: 'Stroke-66', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-67', stroke: '#2DDD6F', points: '943.0456 99.1166 988.8326 91.0606 1176.8146 58.1036 1259.7936 44.2936 1300.7986 37.9986 1341.6916 32.2746 1382.2126 27.2436 1402.4306 24.9406 1422.5706 23.0676 1442.6806 21.3376 1462.7366 19.8906 1482.5006 18.7096 1502.2086 17.8156 1521.6176 17.1826 1540.7036 16.9606 1559.9526 17.1856 1569.5516 17.4386 1578.9056 17.6756 1588.2056 18.1936 1597.7516 18.7336 1607.0216 19.3966 1616.2726 20.2016 1625.2726 20.9856 1634.4686 22.0786 1643.4176 23.1456 1652.3426 24.3586 1661.2386 25.7126 1669.8386 27.3326 1678.4376 28.9516 1687.0096 30.7146 1695.5546 32.6176 1703.8316 34.6446 1711.8346 36.7916 1720.0576 39.1036 1727.7396 41.6576 1735.6636 44.2336 1743.0766 46.9106 1750.4616 49.7296 1757.7926 52.8336 1764.8786 55.9176 1771.6946 59.1226 1778.4576 62.6126 1784.9786 66.0816' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-70', stroke: '#2DDD6F', points: '239.3401 108.644 276.5551 119.864 299.3281 126.344 322.2081 132.253 333.8081 135.004 345.1941 137.592 359.9331 140.76 374.7521 143.5 389.3801 145.936 404.0371 148.227 419.0171 150.112 433.8081 151.69 448.8941 153.003 464.0351 154.032 478.2571 154.689 492.5031 155.206 506.5641 155.413 520.6751 155.335 534.8141 155.116 548.7361 154.732 562.7141 154.063 576.4721 153.231 590.2321 152.396 604.0461 151.28 631.4831 148.735 658.2701 145.7 684.8951 142.214 738.0091 134.653 790.0391 126.271 1254.7891 41.972 1295.6311 35.227 1336.3351 29.196 1376.6631 23.858 1396.9121 21.414 1416.8601 19.234 1436.9991 17.361 1456.8421 15.751 1476.6001 14.569 1496.3341 13.533 1515.7441 12.901 1535.1021 12.556 1544.4851 12.647 1554.1081 12.759 1563.4881 12.849 1573.0601 13.249 1582.3861 13.626 1591.6881 14.145 1600.9631 14.807 1610.2101 15.613 1619.4571 16.417 1628.4071 17.487 1637.3561 18.555 1646.2521 19.912 1655.1491 21.266 1663.7781 22.743 1672.3481 24.505 1680.9201 26.265 1689.2231 28.149 1697.4701 30.319 1705.6951 32.631 1713.6721 34.92 1721.5971 37.496 1729.2521 40.193 1736.6641 42.871 1744.0211 45.832 1751.1081 48.915 1758.1671 52.141 1764.9601 55.489 1771.4791 58.957 1777.9721 62.57' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-71', stroke: '#231F20', points: '1778.6467 62.9193 1783.9777 66.1393 1789.3067 69.3593 1794.6127 72.7233 1799.6707 76.0653 1809.4957 83.0143 1872.3897 129.9793 1877.8317 133.9363 1883.5397 137.7693 1889.2737 141.4583' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-72', stroke: '#2DDD6F', points: '92.823 59.185 254.729 113.614 276.908 120.62 299.654 127.244 310.932 130.402 322.479 133.437 333.81 136.309 345.169 139.039 359.88 142.352 374.429 145.213 389.031 147.79 403.904 150.246 411.395 151.19 418.885 152.133 426.375 153.074 433.649 153.853 441.164 154.65 448.709 155.307 463.605 156.315 477.801 157.116 492.048 157.631 506.108 157.84 520.219 157.762 534.114 157.522 548.037 157.137 562.014 156.469 575.772 155.635 589.56 154.66 603.13 153.518 630.323 150.955 657.138 147.777 683.519 144.271 736.443 136.403 788.041 127.695 1249.542 39.629 1290.193 32.578 1330.979 26.119 1371.118 20.475 1391.149 17.866 1411.367 15.565 1431.289 13.527 1451.157 11.773 1470.945 10.451 1490.706 9.269 1509.871 8.618 1529.23 8.271 1538.638 8.221 1548.289 8.19 1557.642 8.425 1567.24 8.678 1576.571 9.056 1585.868 9.576 1595.144 10.239 1604.389 11.044 1613.396 11.829 1622.588 12.918 1631.512 14.13 1640.435 15.342 1649.061 16.819 1657.93 18.317 1666.5 20.078 1674.804 21.962 1683.108 23.846 1691.355 26.014 1699.579 28.325 1707.531 30.759 1715.209 33.313 1722.841 36.154 1730.223 38.972 1737.58 41.935 1744.639 45.161 1751.459 48.365 1758.221 51.855 1764.742 55.324' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-73', stroke: '#231F20', points: '1764.9602 55.4887 1771.1842 59.2217 1777.4042 62.9567 1783.6002 66.8327 1789.5282 70.8307 1800.8642 78.9237 1864.2502 128.5467 1869.9332 132.5227 1875.3992 136.3347 1881.1082 140.1687 1886.8452 143.8607 1892.8532 147.4277' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-75', stroke: '#2DDD6F', points: '239.5832 108.6654 277.5302 121.2554 299.9792 128.1414 311.2292 131.4414 322.7502 134.6214 334.0552 137.6374 345.3872 140.5114 359.8282 143.9424 374.3512 146.9484 381.7602 148.3184 388.9262 149.6684 396.3622 150.8944 403.7982 152.1224 411.2612 153.2094 418.4812 154.2724 425.9722 155.2144 433.4882 156.0154 441.0052 156.8134 448.3062 157.4484 455.8492 158.1044 463.4202 158.6204 477.6142 159.4204 491.6192 159.9144 505.6522 160.2654 519.7632 160.1894 533.6572 159.9474 547.3382 159.5444 561.3142 158.8734 575.0742 158.0414 588.6172 157.0444 602.1862 155.9014 629.4352 153.0524 656.0052 149.8544 682.3882 146.3484 708.6322 142.2504 734.9042 138.0094 786.5562 129.0144 1244.5362 37.3074 1284.9962 29.9504 1325.3512 23.1624 1365.5712 17.0884 1385.6272 14.3384 1405.6302 11.8724 1425.7972 9.8564 1445.6912 7.9624 1465.2872 6.3314 1485.0492 5.1504 1504.2442 4.3554 1513.9482 4.0384 1523.3832 3.8464 1533.0362 3.8154 1542.4442 3.7654 1552.0402 4.0204 1561.3942 4.2544 1570.7222 4.6304 1580.0232 5.1504 1589.3262 5.6714 1598.5732 6.4754 1607.5472 7.4024 1616.7692 8.3504 1625.6902 9.5614 1634.3442 10.8954 1643.2112 12.3934 1651.8402 13.8704 1660.4132 15.6304 1668.9602 17.5354 1677.2342 19.5614 1685.2132 21.8524 1693.4352 24.1634 1701.1172 26.7184 1709.0412 29.2944 1716.4272 32.1124 1723.7832 35.0744 1731.1132 38.1804 1737.9302 41.3844 1744.7222 44.7304 1751.4852 48.2224 1757.7332 51.8114 1764.2002 55.5674' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-76', stroke: '#231F20', points: '1764.8782 55.9174 1770.1832 59.2804 1775.4582 62.7854 1780.4652 66.4124 1785.4982 69.8974 1795.2402 77.2744 1856.3822 126.9894 1861.7952 131.0894 1867.4762 135.0654 1872.9142 139.0204 1878.6232 142.8544 1884.6352 146.4244 1887.5042 148.2694 1890.3942 149.9724' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-77', stroke: '#2DDD6F', points: '1902.8625 268.1918 1854.4245 257.8188 1808.5295 247.4088 1722.9825 226.4138 1367.6495 130.1438 1322.1675 119.0218 1299.5645 113.7878 1276.9905 108.9648 1254.9095 104.5138 1233.3255 100.5748 1211.7705 97.0418 1201.2385 95.4608 1190.9545 94.1368 1174.3735 92.1668 1158.2735 90.4308 1142.4435 89.2208 1126.8585 88.2698 1111.5265 87.5708 1096.4525 87.2628 1081.6265 87.2128 1067.0555 87.4158 1052.7405 88.0068 1038.6755 88.8568 1024.8585 89.9608 1011.2935 91.3188 997.9755 92.9338 984.6785 94.8168 971.8625 96.9408 959.0635 99.3368 946.7365 101.8358 934.8795 104.4348 923.0425 107.3098 911.6845 110.4218 900.5575 113.5168 889.4505 116.8818 878.8105 120.3558 868.4135 123.9438 858.0265 127.6698 848.0985 131.3628 838.4135 135.1748 828.7435 139.2568 819.2975 143.1918 810.3215 147.2278 792.3885 155.5678 776.7285 163.3418 761.5415 171.2188 732.7785 186.8608 654.7275 232.3908 630.4485 245.9458 618.3905 252.2428 612.5925 255.3718 606.5435 258.2488 600.4955 261.1258 594.4285 263.7318 588.3615 266.3358 582.5135 268.7888 578.9055 270.1328 575.5145 271.3248 571.9065 272.6698 568.5175 273.8598 564.8865 274.9278 561.4885 275.9848 557.8605 277.0578 554.4515 277.9768 550.8135 278.9138 547.3955 279.7008 543.7475 280.4988 540.3295 281.2848 536.6715 281.9498 533.0135 282.6118 529.5765 283.1258 525.9085 283.6538 522.2315 284.0468 518.5635 284.5768 515.1085 284.8188 511.4305 285.2138 507.7335 285.3348 504.2775 285.5758 500.5815 285.7008 497.1155 285.8058 493.4095 285.7938 489.9345 285.7648 486.2285 285.7508 482.7425 285.5868 479.0265 285.4378 475.5415 285.2738 471.8265 285.1238 468.3315 284.8248 461.3325 284.0868 454.3335 283.3538 447.3145 282.3438 440.2975 281.3378 433.2575 280.0568 426.4505 278.7618 419.6435 277.4678 412.8275 276.0398 399.4045 272.8888 386.1925 269.4528 373.2035 265.8668 360.4325 262.1258 336.2765 254.5518 312.0995 246.7058 266.5125 230.8168 183.3155 200.5328' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-78', stroke: '#2DDD6F', points: '1911.7913 263.4779 1863.6233 253.6309 1817.9943 243.7479 1732.9883 223.8039 1379.6193 132.4399 1334.1803 121.8579 1311.8283 116.8819 1289.5033 112.3129 1267.6703 108.1179 1246.0973 104.3139 1224.7903 101.0349 1203.9753 98.1309 1187.8633 96.2619 1171.7733 94.6619 1156.1593 93.3029 1140.5783 92.3509 1125.4863 91.7719 1110.6333 91.3119 1095.8103 91.2599 1081.4673 91.4479 1067.1403 91.9049 1053.2963 92.6029 1039.4713 93.5709 1025.8963 94.7919 1012.5693 96.2719 999.4943 98.0039 986.4273 99.8739 973.8393 101.9819 961.5023 104.3419 949.4063 106.8269 937.7813 109.4129 926.1723 112.2669 915.0363 115.2289 904.1393 118.3089 893.2523 121.5239 882.6033 124.8599 872.4283 128.2949 862.2513 131.7339 852.3233 135.4259 842.6283 139.1049 833.1713 142.8999 823.9463 146.6819 805.9733 154.4809 790.0563 161.8629 774.8293 169.1989 745.7683 183.9069 667.0643 226.7559 642.4973 239.5139 630.4193 245.5389 618.3143 251.1579 612.2473 253.7619 606.1793 256.3679 600.3333 258.8219 594.2363 261.0189 590.6263 262.3619 587.2383 263.5529 583.6183 264.7599 579.9993 265.9669 576.5993 267.0229 572.9613 267.9599 569.3323 269.0329 565.9233 269.9509 562.2753 270.7519 558.6273 271.5529 555.2093 272.3359 551.5523 273.0019 547.8943 273.6659 544.4663 274.3149 540.7983 274.8479 537.1323 275.3739 533.4633 275.9049 529.7873 276.2969 526.3313 276.5399 522.6533 276.9319 518.9663 277.1899 515.4993 277.2979 511.8053 277.4199 508.3393 277.5269 504.6423 277.6479 501.1663 277.6209 497.4603 277.6069 493.9753 277.4419 490.2703 277.4289 486.7833 277.2639 483.2893 276.9639 479.5733 276.8149 472.5833 276.2139 465.5853 275.4769 458.5753 274.6059 451.7873 273.5819 444.7693 272.5739 437.9713 271.4149 430.9353 270.1369 424.1273 268.8409 410.7133 265.8279 397.5213 262.6649 384.5493 259.3489 371.8093 256.0129 347.4513 248.8639 323.3033 241.4229 277.7833 226.4849 182.8443 193.8859' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-79', stroke: '#2DDD6F', points: '1920.2581 258.7992 1872.5881 249.4612 1827.2331 240.1022 1742.9891 221.1962 1391.3511 134.6172 1356.9981 126.9392' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-80', stroke: '#2DDD6F', points: '1346.178 124.5619 1312.814 117.7669 1280.189 111.6009 1264.012 108.7819 1248.094 106.3549 1232.416 104.0429 1216.986 101.9929 1200.882 100.2559 1185.025 98.6429 1169.423 97.4159 1154.298 96.4319 1139.207 95.8519 1124.356 95.3929 1109.761 95.3259 1095.407 95.3769 1081.315 95.8179 1067.23 96.3969 1053.623 97.2129 1040.269 98.2839 1026.933 99.6259 1013.838 101.0879 1000.991 102.8069 988.165 104.7939 976.04 106.8699 963.923 109.0799 952.056 111.5469 940.66 114.1159 929.274 116.8209 918.359 119.6279 907.46 122.7079 896.796 125.7729 886.369 128.9559 876.181 132.2579 866.225 135.5439 856.521 139.0849 846.816 142.6269 837.569 146.1359 819.337 153.5439 803.372 160.2499 787.877 167.0599 758.758 180.9539 679.17 221.1379 654.324 233.2359 642.22 238.8529 630.085 244.0619 624.016 246.6689 617.93 249.0039 611.843 251.3369 605.977 253.5179 602.358 254.7269 598.738 255.9339 595.109 257.0059 591.481 258.0789 587.852 259.1499 584.443 260.0679 580.804 261.0039 577.166 261.9419 573.517 262.7429 570.099 263.5259 566.441 264.1909 562.794 264.9929 559.134 265.6559 555.698 266.1689 552.031 266.7009 548.364 267.2289 544.686 267.6239 541.009 268.0159 537.332 268.4119 533.876 268.6529 530.189 268.9109 526.502 269.1689 523.036 269.2749 519.339 269.3989 515.873 269.5039 512.167 269.4899 508.692 269.4589 504.986 269.4479 501.501 269.2839 498.026 269.2519 490.814 268.8039 483.836 268.3379 476.845 267.7389 469.837 266.8669 462.828 265.9949 456.05 265.1079 449.022 263.9639 442.224 262.8049 435.426 261.6419 422.032 258.9039 408.63 256.0259 395.676 252.9809 383.177 249.7679 358.866 243.2919 334.516 236.2759 289.064 222.2889 205.638 195.2879 182.411 187.7839' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-81', stroke: '#2DDD6F', points: '1928.7249 254.1156 1836.4669 236.4556 1752.5319 218.6196 1402.8469 136.6756 1368.7609 129.5226' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-82', stroke: '#2DDD6F', points: '1356.7795 127.0893 1324.1335 120.6543 1291.7675 114.8793 1276.0715 112.3003 1260.3815 109.8553 1244.9525 107.8013 1229.7645 105.8653 1213.8935 104.1163 1198.0415 102.6353 1182.6735 101.3943 1167.5585 100.5463 1152.4565 99.8313 1137.8325 99.3583 1123.2305 99.1523 1109.1095 99.1883 1095.0045 99.4953 1081.1495 100.0553 1067.5375 100.7353 1054.1715 101.6713 1040.8275 102.8783 1027.9525 104.1903 1015.0955 105.7723 1002.2515 107.4863 990.1045 109.2913 977.9795 111.3673 966.3245 113.5473 954.6885 115.9943 943.2815 118.4293 932.3565 121.1003 921.4315 123.7763 910.7545 126.7023 900.0795 129.6303 889.8735 132.6623 879.9075 135.8143 869.9415 138.9623 860.2165 142.2343 850.7315 145.6253 832.2315 152.5053 816.2355 158.8063 800.9435 165.1903 771.5175 178.0163 679.1705 221.1383' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-83', stroke: '#2DDD6F', points: '678.4894 221.3236 666.1544 226.9576 654.0184 232.1676 641.6334 237.1216 635.5474 239.4576 629.4584 241.7906 623.3644 243.9886 617.4784 245.8996 609.9994 248.1946 606.6004 249.2516 602.9714 250.3226 599.3434 251.3946 595.7024 252.3316 592.0564 253.1316 588.4174 254.0686 584.7684 254.8656 581.1114 255.5326 577.6924 256.3166 574.0354 256.9816 570.3674 257.5116 566.7094 258.1776 563.0414 258.7066 559.3654 259.0986 555.6874 259.4936 552.0124 259.8886 548.5634 260.2646 544.8774 260.5226 541.1904 260.7806 537.7334 261.0226 534.0384 261.1466 530.3514 261.4046 526.8754 261.3736 523.1794 261.4986 519.7034 261.4686 515.9974 261.4536 509.0364 261.2616 501.8354 260.9476 494.8574 260.4826 487.8764 260.0156 480.8764 259.2796 473.8794 258.5426 467.0984 257.6546 460.0814 256.6486 453.2914 255.6256 446.5054 254.6006 433.1304 252.1296 419.7464 249.5246 406.8034 246.6126 394.3214 243.6726 369.8104 237.6216 345.7294 231.1316 300.1134 218.1086 182.0164 182.2246' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-84', stroke: '#2DDD6F', points: '1936.9534 249.3168 1845.2404 232.8418 1762.0654 215.9078 1414.1064 138.7478 1369.4734 129.7458 1325.8344 121.7598 1304.2794 118.2278 1283.2044 114.9338 1262.6204 112.0148 1242.3044 109.6208 1226.4324 107.8718 1210.8224 106.5118 1195.4494 105.2698 1180.5704 104.4038 1165.6964 103.6728 1151.0734 103.1988 1136.7014 102.9788 1122.5804 103.0148 1108.4634 103.1848 1094.8324 103.5938 1081.2074 104.1398 1067.8354 104.9398 1054.7074 105.9958 1041.5964 107.1838 1028.9604 108.6158 1016.3254 110.0458 1003.9484 111.8638 991.8044 113.6678 980.1394 115.7128 968.4744 117.7548 957.0604 120.0538 946.1144 122.4548 934.9484 125.0088 924.2534 127.6658 913.7884 130.3058 903.3334 133.0838 893.3494 135.9628 883.3724 138.9758 863.8964 145.1088 845.1244 151.4678 829.0934 157.2228 813.5394 163.2158 784.0464 175.0918 702.9334 210.0718 677.7504 220.6928 665.3654 225.6488 653.1934 230.3168 647.0954 232.5148 640.9904 234.5778 634.8834 236.6418 628.7674 238.5688 621.5104 240.7118 614.0124 242.7368 606.7244 244.4718 603.0854 245.4098 599.4384 246.2098 596.0204 246.9928 592.3624 247.6588 588.7034 248.3218 585.0464 248.9878 581.3794 249.5188 577.7224 250.1838 574.0434 250.5748 570.3774 251.1068 566.6994 251.4998 563.0224 251.8938 559.3454 252.2878 555.8884 252.5288 552.2024 252.7868 548.5154 253.0448 545.0484 253.1528 541.3524 253.2748 534.1914 253.5038 527.0174 253.5968 519.8284 253.4178 512.6374 253.2408 505.6564 252.7768 498.6764 252.3128 491.9174 251.6948 484.9274 251.0948 477.9284 250.3578 471.1494 249.4678 464.3614 248.4458 457.5834 247.5548 443.9974 245.3738 430.8534 242.8848 417.9404 240.3828 405.2474 237.7308 380.9954 232.0688 356.7214 226.1368 311.1744 214.0608 181.6604 177.2078' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-85', stroke: '#2DDD6F', points: '1945.1907 244.6508 1854.0067 229.0948 1771.3687 213.2138 1425.1307 140.6998 1402.8267 136.4008' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-86', stroke: '#2DDD6F', points: '1391.5569 134.1938 1356.1329 127.8168 1321.2229 122.0848 1287.3039 117.2368 1270.7049 114.9918 1254.3639 113.1378 1238.7319 111.5068 1223.3519 110.1318 1208.2189 109.0098 1193.1069 108.1598 1178.4669 107.4138 1164.0759 106.9228 1149.7029 106.7038 1135.5709 106.6008 1121.6849 106.7548 1108.0419 107.0278 1094.4189 107.5738 1081.2669 108.2208 1068.1329 109.1408 1055.2379 110.1808 1042.3539 111.3558 1029.7189 112.7858 1017.5449 114.1838 1005.3889 115.8518 993.4859 117.7768 982.0419 119.6688 970.6079 121.6948 959.4119 123.8408 948.4589 126.1068 937.7439 128.4938 927.0399 131.0148 916.7929 133.5028 906.5709 136.2628 896.5659 138.8718 876.8269 144.6128 857.7899 150.4448 841.7279 155.7938 826.1359 161.2458 796.3439 172.1878 689.3569 214.5678 676.7129 219.1318 664.2889 223.5428 652.0699 227.5368 645.9509 229.4618 640.0569 231.2348 632.5589 233.2608 625.2829 235.1328 617.7649 236.8888 610.4689 238.4878 603.1529 239.8158 595.8379 241.1468 592.1689 241.6748 588.5019 242.2048 584.8349 242.7348 581.1579 243.1288 577.4899 243.6588 573.8029 243.9158 566.6709 244.5498 559.2959 245.0678 552.1429 245.4328 544.9809 245.6618 537.8099 245.7548 530.6169 245.5788 523.4259 245.3988 516.4659 245.2068 509.4879 244.7398 502.7359 244.2568 495.7459 243.6578 488.7579 243.0578 481.9889 242.3028 468.4319 240.5278 454.8649 238.6178 441.7399 236.4018 428.8369 234.0338 416.3929 231.6318 391.9489 226.5328 367.7149 221.1438 321.9939 209.8998 181.3339 172.5938' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-87', stroke: '#2DDD6F', points: '1953.1897 239.8647 1862.7637 225.2117 1780.4327 210.3977 1413.8467 138.3557' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-88', stroke: '#2DDD6F', points: '1402.8264 136.4008 1367.4354 130.4318 1332.7844 125.0908 1299.1054 120.3618 1282.7524 118.3738 1266.4224 116.6548 1250.7914 115.0218 1235.6534 113.7658 1220.5184 112.6458 1205.6364 111.7798 1190.9964 111.0318 1176.6024 110.5438 1162.4614 110.3068 1148.5514 110.0528 1134.6674 110.2078 1121.0144 110.3458 1107.6124 110.7398 1094.4584 111.3878 1081.3124 112.1718 1068.4134 113.0738 1055.7474 114.0978 1043.0934 115.2568 1030.9194 116.6548 1018.7454 118.0508 1006.8214 119.7048 995.3684 121.4618 983.9234 123.3508 972.7094 125.2268 961.7444 127.3578 950.7814 129.4878 940.2874 131.7228 929.7934 133.9558 909.3074 138.9338 889.5284 144.1318 870.4644 149.5558 854.1324 154.3798 838.5014 159.2908 808.6534 169.4208 700.7324 208.4548 688.0714 212.7488 675.3984 216.9058 663.1564 220.6258 657.2524 222.2638 651.1174 223.9218 643.6174 225.9468 636.3304 227.6808 628.8054 229.2988 621.4994 230.7628 614.1834 232.0928 606.6284 233.3058 599.3024 234.4998 591.9484 235.2878 584.5944 236.0738 577.2304 236.7258 570.0864 237.2258 562.9334 237.5898 555.7734 237.8208 548.6004 237.9138 541.4194 237.8718 534.2374 237.8268 527.2764 237.6348 520.3044 237.3058 513.3254 236.8388 506.3464 236.3758 499.5864 235.7578 492.5964 235.1558 479.0584 233.6508 465.7334 231.8578 452.6274 229.9148 439.7524 227.9558 427.0884 225.7078 402.6724 221.0108 378.4674 216.0298 332.8234 205.8708 181.0554 168.6628' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-89', stroke: '#2DDD6F', points: '1960.9436 234.9623 1871.2786 221.2093 1789.4866 207.4493 1446.6756 144.0993 1402.8466 136.6753 1360.0056 130.1373 1318.3836 124.4633 1298.0696 122.0703 1278.2316 119.9153 1262.8386 118.4033 1247.7006 117.1483 1232.8096 116.1473 1217.9276 115.2783 1203.5176 114.5183 1189.1236 114.0263 1174.9716 113.6553 1161.0726 113.5373 1147.4086 113.5393 1133.7566 113.6803 1120.3406 113.9353 1107.1816 114.4473 1094.2566 115.0813 1081.3436 115.8493 1068.6726 116.7353 1056.2386 117.7433 1043.8236 119.0213 1031.8716 120.2673 1019.9276 121.6493 1008.4636 123.2683 997.0006 124.8883 985.7766 126.6283 974.5636 128.5033 963.8096 130.3473 942.5646 134.4253 922.0366 138.8583 902.2316 143.6523 882.6656 148.5663 866.5366 152.9643 850.8776 157.4683 820.7206 166.5283 711.8896 202.4943 699.1966 206.3833 686.4956 210.1353 674.2456 213.7153 662.1866 216.7403 654.6786 218.6293 647.1516 220.2473 639.6246 221.8633 632.3086 223.1953 624.7616 224.5383 617.4366 225.7333 610.0926 226.6563 602.5176 227.5973 595.1636 228.3823 588.0306 229.0193 580.6556 229.5363 573.5046 229.8993 566.3416 230.1293 559.1696 230.2213 551.9986 230.3163 544.8166 230.2743 537.8556 230.0813 530.8946 229.8863 523.9236 229.5563 516.9436 229.0923 503.2146 228.1453 489.6866 226.7753 476.3796 225.2543 463.2936 223.5803 450.4276 221.7573 437.7826 219.7793 413.4056 215.6253 389.2396 211.1863 343.4226 201.8573 180.7956 165.0023' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-90', stroke: '#2DDD6F', points: '1987.1536 232.31 1879.5626 217.221 1798.3006 204.379 1457.1986 145.542 1414.1066 138.747' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-91', stroke: '#2DDD6F', points: '1413.635 138.641 1381.588 134.072 1350.251 129.726 1319.661 126.146 1289.804 123.06 1259.51 120.41 1229.976 118.662 1215.567 117.896 1201.404 117.391 1187.252 117.017 1173.571 116.748 1159.908 116.752 1146.255 116.891 1133.067 116.997 1119.892 117.374 1106.959 117.871 1094.037 118.502 1081.594 119.374 1068.921 120.261 1056.718 121.252 1044.755 122.36 1032.803 123.611 1021.089 124.973 1009.846 126.443 998.373 127.927 976.608 131.224 955.102 134.912 934.548 138.939 914.463 143.07 894.867 147.574 878.71 151.569 862.781 155.546 832.579 163.928 723.045 196.537 710.333 200.152 697.613 203.631 685.334 206.808 673.264 209.699 665.518 211.465 657.98 212.948 650.444 214.427 642.896 215.774 635.571 216.969 628.008 218.045 620.672 219.102 613.088 219.909 605.734 220.693 598.369 221.345 591.227 221.845 583.843 222.227 576.681 222.457 569.517 222.683 562.347 222.778 555.395 222.72 548.214 222.677 541.253 222.483 534.524 222.273 527.552 221.944 513.832 221.132 500.323 220.034 487.036 218.785 473.958 217.246 461.114 215.695 448.488 213.99 423.907 210.256 399.771 206.224 354.021 197.843 180.574 161.883' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-92', stroke: '#2DDD6F', points: '1986.7024 225.9369 1887.8304 212.9599 1807.0934 201.0359 1656.2604 176.9839 1467.7114 146.8499 1425.1214 140.5659' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-93', stroke: '#2DDD6F', points: '1424.1887 140.4936 1361.3217 132.3596 1330.9697 128.8966 1301.3607 126.0616 1271.0817 123.5506 1241.7757 121.7856 1213.4437 120.6366 1185.6107 119.9936 1158.5077 119.8496 1132.3737 120.3166 1106.7287 121.1566 1081.5967 122.6456 1057.1677 124.3556 1033.7147 126.6786 1010.9707 129.2236 988.9447 132.1316 967.6427 135.3936 946.8187 138.8966 926.7047 142.6196 906.8387 146.6016 890.6527 150.1866 874.6957 153.7596 844.4257 161.1906 734.2107 190.7126 708.4997 197.1446 696.2007 200.0516 684.1137 202.6696 676.3557 204.3026 668.5887 205.8006 661.0437 207.1466 653.4867 208.3566 645.9317 209.5666 638.5957 210.6256 631.0207 211.5636 623.6667 212.3526 616.0827 213.1566 608.9387 213.6566 601.5657 214.1736 594.4227 214.6736 587.0297 214.9186 579.8687 215.1456 572.7067 215.3746 565.7627 215.4506 558.8127 215.3946 551.8517 215.1996 537.9307 214.8106 524.2197 214.1376 510.7307 213.3096 497.4517 212.1936 484.3947 210.9306 458.9517 208.0766 435.3527 205.0976 411.7137 201.5736 364.6207 193.8316 180.3727 159.0356' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-94', stroke: '#2DDD6F', points: '1896.0774 208.434 1665.6494 175.507 1477.9744 147.904 1435.8944 142.264' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-95', stroke: '#2DDD6F', points: '1434.7336 142.2084 1372.1306 134.6004 1342.0386 131.5294 1312.6736 128.8124 1282.6396 126.5574 1253.5756 124.9134 1225.2376 123.6254 1197.6326 122.9704 1170.7586 122.8084 1144.3766 123.0204 1118.9516 123.7074 1094.0276 124.9084 1069.5836 126.3484 1046.1006 128.2654 1023.3376 130.5404 1001.2836 133.0394 979.9496 135.8954 958.8566 138.8694 938.4846 142.2054 918.8216 145.7624 886.3816 151.9864 856.0426 158.4714 745.1436 184.9034 719.3956 190.7974 706.8456 193.4444 694.7406 195.7914 678.9666 198.6674 671.1896 200.0284 663.6256 201.1054 656.0586 202.1804 648.7236 203.2384 641.3696 204.0264 634.0256 204.9494 626.6606 205.5994 619.2976 206.2534 612.1546 206.7534 605.0016 207.1174 597.6186 207.4984 590.4576 207.7294 583.2946 207.9564 575.8926 208.0644 561.9996 208.0844 548.0876 207.8314 534.6256 207.4124 521.1466 206.7204 507.6466 205.7554 494.6086 204.7624 469.2046 202.4534 445.6246 199.7414 421.7846 196.6434 374.9986 189.9694 291.5836 176.1874 180.1986 156.5934' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-96', stroke: '#2DDD6F', points: '1985.7795 212.9193 1821.8495 193.5983 1675.0285 173.8973 1488.0005 148.8373 1445.2535 143.6513' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-97', stroke: '#2DDD6F', points: '1442.4495 143.3051 1381.5415 136.6661 1352.1615 133.8191 1323.7415 131.4471 1293.9515 129.3101 1264.8965 127.7991 1236.7945 126.6331 1209.4115 125.8251 1182.5395 125.6611 1156.3775 125.7221 1130.9445 126.2761 1105.9915 127.0701 1081.7685 128.3571 1058.2535 129.8661 1035.4625 131.7361 1013.3805 133.8261 991.7885 136.2931 970.9065 138.9811 950.4945 141.7731 930.3335 144.8211 899.8995 149.9491 871.0955 155.2351' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-98', stroke: '#2DDD6F', points: '867.4396 155.8988 730.0626 184.4608 705.3786 189.0498 689.3526 191.6708 674.0026 193.9748 659.0826 195.8368 644.1536 197.5618 629.6466 198.7138 615.1296 199.7318 600.5946 200.4758 586.2596 200.7978 572.1466 200.9678 558.4756 200.8358 544.7936 200.5688 531.3326 200.1478 518.0836 199.4408 505.0546 198.5818 479.4476 196.6938 455.8976 194.3898 432.0966 191.8328 385.3776 186.1098 301.8456 173.9688 180.0546 154.5608' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-99', stroke: '#2DDD6F', points: '1985.3176 206.4096 1827.1006 189.2776 1684.3786 171.8796 1498.2326 149.4836 1455.5276 144.8396' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-100', stroke: '#2DDD6F', points: '1449.2288 144.1918 1390.4698 138.4928 1334.5728 133.9598 1305.0198 131.9398 1276.1978 130.4138 1248.1038 129.3838 1220.7228 128.5778 1194.0738 128.2588 1168.1368 128.3068 1142.6848 128.5898 1117.9548 129.2298 1093.7098 130.2448 1070.1798 131.4838 1047.3588 132.9468 1025.2578 134.7658 1003.6268 136.6908 982.4868 138.9888 962.0458 141.3738 941.8448 143.8768 909.5178 148.4558 878.8358 153.3318 740.5058 178.2788 715.7848 182.3288 699.7518 184.8118 684.3818 186.8428 669.2308 188.7218 654.2818 190.1738 639.7848 191.4648 625.2678 192.4798 610.7318 193.2238 596.1768 193.6988 582.3038 193.9908 568.4108 194.0088 554.7398 193.8748 541.2878 193.5908 528.0568 193.1538 515.0488 192.5648 489.7018 191.0718 465.9498 189.1918 442.1858 187.1758 395.5238 182.2658 351.8478 177.0108 179.9298 152.7978' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-101', stroke: '#2DDD6F', points: '1984.8362 199.6293 1508.2282 150.0083 1424.3052 142.1203 1384.2482 138.9273 1345.3832 136.1993 1286.5672 132.9593 1258.4752 131.9293 1231.1022 131.2573 1204.6732 130.7903 1178.9592 130.6833 1153.9602 130.7993 1129.6782 131.2723 1105.8772 131.9833 1082.5562 132.9353 1059.9452 134.1093 1037.8152 135.5233 1015.9262 137.0553 994.7452 138.8093 953.1262 142.9513 925.5712 146.2423' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-102', stroke: '#2DDD6F', points: '920.7521 146.8539 875.1001 152.9099 726.2001 175.7379 710.1491 177.9529 694.5381 179.8639 679.3771 181.6069 664.4291 183.0599 649.6921 184.2269 635.1741 185.2439 620.6481 186.1259 606.0941 186.5999 592.2311 187.0259 578.3571 187.3159 564.6951 187.3189 551.4841 187.1539 525.2731 186.5349 499.7241 185.4609 475.7791 184.1429 452.0361 182.3989 405.6821 178.5569 362.0641 174.1149 322.1511 169.6859 249.7311 160.7209 179.8151 151.1709' }),
	                        _react2.default.createElement('path', { d: 'M1984.3557,192.8481 L1465.5597,145.9081', id: 'Stroke-103', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-104', stroke: '#2DDD6F', points: '1454.843 145.0268 1356.174 138.1698 1297.616 135.3198 1242.384 133.5998 1190.47 133.0098 1141.16 133.1918 1094 134.3128 1049.212 136.2248 1005.861 138.8498 964.418 142.1608 931.976 145.1128 901.175 148.3598 704.464 172.8998 674.347 175.9608 659.609 177.1298 645.091 178.1468 630.566 179.0258 616.021 179.6368 601.937 180.2148 588.294 180.4888 561.217 180.7488 535.035 180.5388 509.757 179.9908 485.831 178.9408 461.896 177.7558 415.839 174.8468 372.28 171.2188 332.426 167.6058 254.252 159.1788 179.718 149.8168' }),
	                        _react2.default.createElement('path', { d: 'M1983.8567,185.7973 L1474.8627,146.4863', id: 'Stroke-105', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-106', stroke: '#2DDD6F', points: '1465.5598 145.9076 1366.7258 140.0206 1308.4298 137.5626 1253.6658 135.9456 1201.7428 135.2186 1152.4138 135.1296 1105.4438 135.6936 1060.3768 136.9416 1017.2138 138.8726 975.4668 141.2506' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-107', stroke: '#2DDD6F', points: '964.1765 142.0404 903.1445 146.7254 714.6305 166.0564 684.2615 168.8624 655.0085 171.0484 625.9565 172.8084 598.0175 173.9474 570.9625 174.4784 545.0395 174.6584 519.5595 174.5344 495.4425 174.0424 471.7655 173.2474 425.7655 171.1544 382.2735 168.4744 300.5295 161.9344 258.7935 157.9054 218.1905 153.5244 179.6325 148.5954' }),
	                        _react2.default.createElement('path', { d: 'M1983.3459,178.6107 L1465.5599,145.9077', id: 'Stroke-108', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-109', stroke: '#2DDD6F', points: '1462.3049 145.7289 1377.2669 141.7349 1264.7059 138.1699 1212.7649 137.1729 1163.4139 136.8119 1116.4289 137.1049 1071.3149 137.6749 1028.0899 138.7929 986.2879 140.3559' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-110', stroke: '#2DDD6F', points: '984.9055 140.4535 920.9915 143.7035 863.3765 147.5985 757.0285 156.5445 693.9585 161.9155 664.9455 164.2195 635.6625 165.9975 607.5115 167.4225 580.7165 168.3455 554.8225 168.9315 529.3615 169.0795 481.4035 168.7595 435.4635 167.4765 392.4885 165.5805 352.2785 163.4885 307.6055 160.4865 263.1235 156.9205 241.2035 154.7765 219.9775 152.5845 199.4295 150.2075 179.5545 147.5125' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-111', stroke: '#2DDD6F', points: '1982.8264 171.2895 1387.5594 143.1945 1275.7294 140.1245 1174.4194 138.4935 1082.0164 138.4225 997.1074 139.4635 933.0984 141.3545 874.2244 143.8415 819.3254 146.8695 617.0064 160.8965 590.4714 162.2105 564.3654 163.0835 538.9414 163.7745 491.0414 164.2655 445.3994 163.9185 402.2524 162.8515 362.0904 161.4375 314.6894 159.1715 290.9674 157.6975 267.2324 156.0905 244.3914 154.0105 221.7694 151.7745 200.2834 149.1935 189.7704 147.8855 179.4784 146.4265' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-112', stroke: '#2DDD6F', points: '1982.2981 163.8315 1397.8341 144.3815 1048.6941 138.7115' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-113', stroke: '#2DDD6F', points: '1038.7366 138.7289 944.0536 139.0889 884.6136 140.1149 829.1586 141.8179 776.9956 144.2449 599.7636 156.1089 548.5226 158.4709 500.4506 159.7909 455.1056 160.3769 412.2566 160.2459 371.9126 159.5249 321.5546 158.0079 296.4666 156.9029 271.5816 155.3749 247.1276 153.4079 235.2416 152.3329 223.5766 151.1059 212.1426 149.8619 201.1586 148.4519 190.1546 146.7689 179.3916 145.2049' }),
	                        _react2.default.createElement('path', { d: 'M1981.7502,156.102 L1476.4762,146.373', id: 'Stroke-114', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('path', { d: 'M1467.9016,146.2924 L1463.9566,146.1584', id: 'Stroke-115', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-116', stroke: '#2DDD6F', points: '1462.3342 146.1342 895.0012 136.3912 838.7582 136.7842 812.1722 137.4202 786.7602 138.2462 754.2212 139.8432 609.2952 150.1252 558.1132 153.3022 509.8702 155.4542 464.5812 156.8522 422.0202 157.5172 381.7342 157.6102 347.2092 157.3032 314.2782 156.6122 298.2542 155.9622 282.6902 155.2802 267.3372 154.3102 252.4372 153.1722 234.0312 151.6002 224.6892 150.4832 215.5882 149.4852 206.4672 148.2142 197.3362 146.8102 188.2062 145.4052 179.2862 143.7152' }),
	                        _react2.default.createElement('path', { d: 'M1981.1917,148.2367 L1472.0707,146.2717', id: 'Stroke-117', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-118', stroke: '#2DDD6F', points: '1466.7415 146.2348 1305.0215 145.0208 1206.2255 142.9448 905.1685 132.8168 848.3665 131.8888 821.7455 131.9828 796.5325 132.3818 779.8945 132.8668 763.7255 133.4548 732.3615 135.2418 567.4745 148.1478 519.0665 151.2638 474.0675 153.4638 431.7935 154.9228 391.3345 155.8478 356.8575 156.2188 323.9555 155.9308 307.9595 155.6908 292.4065 155.1428 277.0735 154.4458 262.1825 153.4448 251.7075 152.6778 241.2145 151.6448 230.7095 150.4688 220.2055 149.2978 209.6735 147.7178 199.3715 146.1248 189.2805 144.2408 184.3455 143.2228 179.1705 142.0878' }),
	                        _react2.default.createElement('path', { d: 'M1980.6145,140.099 L1473.4625,146.31', id: 'Stroke-119', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('path', { d: 'M1472.0706,146.2719 L1465.8296,146.4359', id: 'Stroke-120', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-121', stroke: '#2DDD6F', points: '1465.1292 146.3481 1428.3392 146.7441 1329.2072 146.4641 1240.6272 144.7601 1159.1552 142.0161 1082.0172 138.4221' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-122', stroke: '#2DDD6F', points: '1081.7883 138.4379 915.3453 129.3809 858.9193 127.1979 832.0173 126.6289 806.0753 126.5389 789.4163 126.7499 773.2483 127.3359 757.3213 128.0429 741.8633 128.8529 711.6803 130.9659 528.2543 146.9419 483.5523 150.0729 441.5673 152.3319 400.9363 154.0859 372.2763 154.8639 344.5303 155.4459 317.8973 155.4029 304.9073 155.0859 292.1463 154.7519' }),
	                        _react2.default.createElement('path', { d: 'M1980.0286,131.8305 L1476.0076,146.2685', id: 'Stroke-123', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('path', { d: 'M1472.0706,146.2719 L1469.0646,146.3439', id: 'Stroke-124', stroke: '#231F20' }),
	                        _react2.default.createElement('path', { d: 'M1465.8293,146.4359 L1464.4483,146.5339', id: 'Stroke-125', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-126', stroke: '#2DDD6F', points: '1462.134 146.558 1380.467 147.645 1326.271 147.487 1275.259 146.558 1226.766 145.187 1180.323 143.396 1135.46 140.948 896.671 124.009 868.768 122.42 841.828 121.309 828.608 121.008 815.626 120.828 798.961 120.906 782.543 121.235 766.604 121.805 751.138 122.478 735.92 123.41 720.952 124.592 691.728 127.184 537.23 142.907 492.807 146.7 451.111 149.755 410.306 152.339 376.146 153.913 359.517 154.535 343.1 154.865 327.373 155.148 311.618 155.027 296.545 154.719 281.442 154.002 268.422 153.28 261.663 152.662 255.145 152.166 248.606 151.396 242.078 150.765 235.529 149.859 228.982 148.954 222.425 147.915 216.087 146.723 209.751 145.533 203.404 144.205 197.278 142.725 191.143 141.112 185.007 139.496 178.853 137.61' }),
	                        _react2.default.createElement('path', { d: 'M1979.4329,123.4232 L1475.9989,146.1322', id: 'Stroke-127', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('path', { d: 'M1465.6077,146.5873 L1460.5187,146.6713', id: 'Stroke-128', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-129', stroke: '#2DDD6F', points: '1457.7454 146.7309 1390.4614 148.1709 1336.5234 148.4039 1285.5324 147.7509 1236.7984 146.2559 1190.3294 144.0579 1145.4434 141.3419 1101.6824 138.1369 906.5774 120.0449 878.6374 117.9149 851.4294 116.2769 838.1894 115.7049 825.1904 115.2509 808.2724 115.0709 791.8364 115.1329 775.8884 115.5669 760.1904 116.2589 744.9734 117.1889 729.9964 118.2379 700.7814 120.9629 502.0724 143.4619 460.6634 147.3149 419.9084 150.5769 398.2474 152.0949 377.2694 153.4289 356.7234 154.3209 336.8494 154.8929' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-131', stroke: '#2DDD6F', points: '1978.8352 115.0141 1544.5082 142.4281 1475.9992 146.1321' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-132', stroke: '#2DDD6F', points: '1471.1565 146.4711 1458.4545 146.9521 1401.8375 148.5991 1347.9275 149.2391 1296.4765 148.6181 1246.8195 147.1891 1218.2395 145.7831 1190.3385 144.1921' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-133', stroke: '#2DDD6F', points: '1176.3762 143.265 1121.4212 138.935 1068.7102 133.63 916.2562 116.096 888.2682 113.287 874.5292 112.205 860.7902 111.123 847.5402 110.415 834.5302 109.827 825.9372 109.473 817.5932 109.377 809.2502 109.282 801.1472 109.301 793.0442 109.325 784.9602 109.62 769.4832 110.157 754.0242 110.966 739.0592 112.152 724.3302 113.455 709.6122 114.896 682.5082 118.017 511.3362 140.223 469.0632 144.955 429.2872 148.967 394.9922 151.913 378.4022 153.075 362.2632 154.069' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-136', stroke: '#2DDD6F', points: '1978.2385 106.6078 1555.0515 140.8728 1486.8445 145.6458' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-137', stroke: '#2DDD6F', points: '1476.0071 146.269 1439.5431 148.005 1411.8221 148.992 1384.5371 149.54 1357.9351 149.904 1331.7611 149.828 1306.2711 149.567 1281.2121 148.871 1256.8361 147.987 1232.6681 146.817 1209.1841 145.465' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-138', stroke: '#2DDD6F', points: '1186.1418 143.8061 1158.4138 141.3871 1131.1378 138.8001 1078.3778 132.8211 925.9418 112.2831 897.6858 108.9491 883.9178 107.4601 870.3988 106.2261 856.8908 105.1281 843.8718 104.4041 835.2688 103.9171 826.9158 103.6821 818.5628 103.4501 810.2308 103.4901 802.1268 103.5101 794.2538 103.5161 786.1688 103.8101 778.5458 104.0721 763.0898 104.8831 748.1208 106.0651 733.1618 107.3851 718.6838 108.9451 691.3598 112.2191 520.3698 137.0021 478.3858 142.5321 438.4368 147.3701 416.3738 149.7331 394.9818 151.7781' }),
	                        _react2.default.createElement('path', { d: 'M378.4118,153.2104 L371.7298,153.6794', id: 'Stroke-139', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-140', stroke: '#2DDD6F', points: '368.9641 153.8715 359.9681 154.3655 351.2031 154.8435 342.1981 155.1995 333.6421 155.3905' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-144', stroke: '#2DDD6F', points: '1977.6331 98.0649 1564.8921 139.2289 1496.7541 144.9539' }),
	                        _react2.default.createElement('path', { d: 'M1486.845,145.6459 L1476.007,146.2689', id: 'Stroke-145', stroke: '#231F20' }),
	                        _react2.default.createElement('path', { d: 'M1473.4719,146.4457 L1472.3199,146.5267', id: 'Stroke-146', stroke: '#231F20' }),
	                        _react2.default.createElement('path', { d: 'M1468.1731,146.8168 L1467.7111,146.8498', id: 'Stroke-147', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-148', stroke: '#2DDD6F', points: '1466.7903 146.9154 1439.7993 148.3944 1413.4763 149.4204 1387.8213 150.1274 1362.6093 150.5274 1338.0593 150.4774 1313.7303 150.2714 1289.8343 149.6284 1266.6183 148.8024 1232.4493 146.9704' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-149', stroke: '#2DDD6F', points: '1218.719 146.0219 1184.71 143.2249 1151.599 139.9559 1119.377 136.2169 1088.057 132.1419 935.407 108.6229 907.104 104.6099 893.317 102.8489 879.548 101.3609 866.261 100.1099 853.221 99.1149 844.38 98.5069 836.016 98.1399 827.665 97.9069 819.312 97.6739 811.206 97.6969 803.106 97.7189 795.241 97.8599 787.388 98.1359 779.775 98.5339 772.161 98.9319 764.557 99.4629 756.953 99.9969 741.994 101.3149 727.297 103.0269 713.749 104.6579 699.981 106.4369 672.485 110.5429 487.488 140.2599 447.816 145.7599 413.618 150.0639' }),
	                        _react2.default.createElement('path', { d: 'M404.4304,151.1156 L397.3074,151.8866', id: 'Stroke-150', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-151', stroke: '#2DDD6F', points: '395.0017 152.0492 383.5007 153.1272 372.2187 154.0522 360.9287 154.8412 349.8497 155.3482' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-152', stroke: '#2DDD6F', points: '349.6184 155.3637 343.1584 155.6777 336.6864 155.8607 330.2054 155.9037 323.9554 155.9307' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-155', stroke: '#2DDD6F', points: '1977.0471 89.7943 1569.4221 137.8193 1532.4121 141.6373 1496.7441 144.8163' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-156', stroke: '#2DDD6F', points: '1476.4758 146.3734 1449.5058 148.1244 1423.1998 149.4214 1397.5658 150.3964 1372.3628 150.9354 1347.5918 151.0374 1323.4968 150.8144 1299.6078 150.3054 1276.1628 149.4954 1258.9588 148.5194 1242.2118 147.5134' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-157', stroke: '#2DDD6F', points: '1228.4836 146.5658 1211.2386 145.0458 1194.2256 143.5128 1161.0926 139.9728 1128.8416 135.8268 1097.4956 131.3438 1064.4676 126.0238 944.6346 104.8448 916.5316 100.4088 902.7256 98.3748 889.1686 96.5998 875.6296 95.0938 862.3426 93.8428 853.4996 93.2358 845.1176 92.5958 836.5256 92.2438 828.4026 91.9948 820.0606 91.8978 812.1886 91.9068 804.0926 92.0608 796.2306 92.2048 788.6166 92.6018 781.0016 92.9998 773.3976 93.5318 765.7956 94.0628 750.8476 95.5188 736.1386 97.0918 722.3706 98.8748 708.6226 100.9278 681.1346 105.1688 496.5886 137.9858 439.7906 146.8688' }),
	                        _react2.default.createElement('path', { d: 'M430.6213,148.1908 L422.8163,149.1478', id: 'Stroke-158', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-159', stroke: '#2DDD6F', points: '421.2121 149.394 405.6021 151.306 390.2111 153.064 378.4801 154.16 366.7371 155.118 354.9761 155.806 349.4371 156.056 343.6561 156.189' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-160', stroke: '#2DDD6F', points: '340.1911 156.2943 334.4101 156.4293 328.6221 156.4253 323.9841 156.3383 319.3461 156.2553 314.7091 156.1713 310.0631 155.9523 305.4141 155.7313 300.7691 155.5133 296.3421 155.1433 291.6761 154.6483' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-162', stroke: '#2DDD6F', points: '1976.4602 81.5229 1579.4742 135.8899 1542.2732 140.2649 1506.4122 144.0019' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-163', stroke: '#2DDD6F', points: '1486.8547 145.7816 1459.9067 147.8056 1433.3857 149.3896 1407.7607 150.5026 1382.3487 151.3266 1357.5897 151.5626 1333.2697 151.4936 1309.3817 150.9856 1285.6957 150.0566 1276.1627 149.4956' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-164', stroke: '#2DDD6F', points: '1261.5188 148.7494 1240.8018 147.2024 1220.5338 145.4864 1200.7058 143.4664 1181.3318 141.2804 1162.4078 138.9284 1143.6938 136.2844 1106.9328 130.5474 1074.0958 124.6684 954.1088 101.3184 925.7288 96.2184 911.9048 93.9154 898.3268 91.8684 884.7698 90.0924 878.0008 89.3404 871.4728 88.7074 862.6208 87.9634 854.0078 87.3424 845.6368 86.8384 837.2728 86.4684 829.1518 86.2194 821.0488 86.2424 812.9458 86.2644 805.0808 86.4064 797.4688 86.8034 789.6228 87.2154 782.0098 87.6124 774.4158 88.2794 767.0518 88.9334 759.4588 89.6014 744.7598 91.3104 731.0008 93.2284 717.0218 95.2964 689.5638 99.9444 638.8338 109.4924 505.4588 135.7284 466.1248 142.7064' }),
	                        _react2.default.createElement('path', { d: 'M456.9748,144.3022 L448.7388,145.6962', id: 'Stroke-165', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-166', stroke: '#2DDD6F', points: '447.8259 145.8969 423.3149 149.6569 411.3899 151.3089 399.4569 152.8269 391.6419 153.6469 383.8269 154.4659' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-167', stroke: '#2DDD6F', points: '383.5964 154.4809 371.8644 155.5779 366.1034 155.9809 360.3334 156.2469 354.5724 156.6489 349.0224 156.7679 343.4844 157.0169 337.6944 157.0159 330.5124 156.9719' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-171', stroke: '#2DDD6F', points: '1975.8918 73.5199 1589.2788 133.7059 1552.1138 138.6239 1516.2918 142.9039' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-172', stroke: '#2DDD6F', points: '1496.7542 144.9535 1469.6042 147.3985 1443.3332 149.2385 1417.4992 150.6365 1392.0822 151.4635 1367.3412 151.9685 1342.7942 151.9165 1318.9062 151.4075 1295.2292 150.6115 1285.6952 150.0575' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-173', stroke: '#2DDD6F', points: '1270.8147 149.1879 1250.0957 147.6419 1229.8187 145.7899 1210.2227 143.7549 1190.8287 141.2969 1171.6627 138.8269 1152.9317 135.9109 1134.4297 132.9809 1116.1397 129.7669 1083.2757 123.4819 963.1247 97.8259 934.9357 92.1669 921.0907 89.5939 907.2667 87.2909 893.6887 85.2459 886.9107 84.3569 880.3717 83.5859 871.5117 82.7099 862.8877 81.9489 854.5147 81.4469 846.1447 80.9419 837.7917 80.7089 829.9107 80.5799 821.8057 80.6009 813.9417 80.7429 806.0887 81.0199 798.4757 81.4189 790.6307 81.8309 783.0367 82.4999 775.6737 83.1489 768.0887 83.9539 760.7347 84.7419 753.1587 85.6809 738.9497 87.7649 724.9817 89.9709 711.4817 92.2799 697.9937 94.7219 672.1867 99.7969 556.0937 124.8249 475.0547 141.2659 441.2307 147.5849 424.9757 150.2229 408.7027 152.5889 400.8977 153.5449 392.8607 154.5159 385.0467 155.3339 377.4607 156.1389 369.6277 156.6859 362.0137 157.0839 354.3997 157.4799 347.0077 157.7269 342.1497 157.7939 337.0517 157.7409 332.1837 157.6719 327.3067 157.4679 322.6607 157.2509 317.7817 157.0469 312.8957 156.7069 307.9987 156.2319' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-176', stroke: '#2DDD6F', points: '1975.3342 65.6566 1604.3412 130.6056 1569.2882 135.9236 1535.5812 140.5986' }),
	                        _react2.default.createElement('path', { d: 'M1506.4124,144.0024 L1495.8414,145.1524', id: 'Stroke-177', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-178', stroke: '#2DDD6F', points: '1492.8567 145.4984 1467.7787 147.7994 1443.1337 149.6594 1419.1417 150.9334 1395.5897 151.8984 1372.2317 152.3084 1349.3017 152.2774 1326.8157 151.9454 1304.5257 151.0534 1295.2287 150.6114' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-179', stroke: '#2DDD6F', points: '1276.1526 149.3617 1256.1246 147.7647 1236.3076 145.8817 1216.9326 143.6947 1197.9996 141.2047 1179.5066 138.4117 1161.2356 135.4667 1143.1856 132.3697 1125.3466 128.9867 1092.4426 122.1587 972.3706 94.3167 944.1426 88.1157 930.2776 85.2697 916.4336 82.6957 902.6176 80.5317 895.8296 79.5077 889.2816 78.6037 880.4096 77.5887 871.7776 76.6947 863.1676 76.0697 854.7936 75.5657 846.6626 75.1817 838.5486 75.0697 830.4386 74.9537 822.5736 75.0957 814.7196 75.3747 807.0976 75.6347 799.2606 76.1847 791.6576 76.7167 784.0636 77.3827 776.7086 78.1727 769.1336 79.1107 761.5586 80.0497 747.3506 82.1347 733.3906 84.4757 719.6706 86.9357 706.4316 89.6327 680.6436 94.9827 608.6386 111.4697 564.6856 121.9047 483.9826 139.8207 450.1976 146.6857 433.9726 149.7277 417.9496 152.3507 409.9326 153.5917 402.1266 154.5487 394.3216 155.5037 386.5066 156.3237 378.9216 157.1287 371.0866 157.6747 363.7036 158.0547 356.0796 158.3167 350.5306 158.4327 344.7416 158.4297 339.1836 158.4097 333.6146 158.2567 328.0356 157.9637 322.6886 157.6567 317.0906 157.0937 311.7236 156.5157' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-182', stroke: '#2DDD6F', points: '1974.7874 57.9262 1644.7604 122.5972 1604.0534 129.8082 1564.4584 136.3962 1544.9784 139.2592 1526.1704 141.8022' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-183', stroke: '#2DDD6F', points: '1516.303 143.0385 1489.659 146.1305 1463.658 148.4975 1438.092 150.4225 1425.63 151.0235 1413.168 151.6235 1400.698 152.0865 1388.446 152.3985 1376.416 152.5595 1364.157 152.7365 1352.336 152.6125 1340.509 152.3495 1328.679 152.0885 1316.842 151.6895' }),
	                        _react2.default.createElement('path', { d: 'M1304.5256,151.0531 L1301.7296,150.8401', id: 'Stroke-184', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-185', stroke: '#2DDD6F', points: '1295.219 150.4789 1275.903 149.1049 1257.018 147.2929 1238.352 145.3309 1220.117 142.9269 1197.893 139.7109 1176.11 136.1959 1154.993 132.3599 1134.322 128.2189 1101.621 120.9699 1070.524 113.4729 981.395 90.9579 953.119 84.0799 939.245 81.0989 925.382 78.2559 911.546 75.8179 904.749 74.6569 897.97 73.7699 889.09 72.6209 880.446 71.5879 872.056 70.8149 863.674 70.1739 855.312 69.8069 847.19 69.5589 839.077 69.4429 831.202 69.4509 823.35 69.7279 815.497 70.0039 807.894 70.5369 800.289 71.0699 792.694 71.7379 785.109 72.5409 777.533 73.4809 769.968 74.5549 762.864 75.5979 755.769 76.7749 741.809 79.1149 728.099 81.7109 714.639 84.5629 688.87 90.1809 492.922 138.5149 459.184 146.0559 442.968 149.2369 434.971 150.7499 426.974 152.2619 418.957 153.5059 411.171 154.7309 403.365 155.6869 395.559 156.6429 387.975 157.4459 380.15 158.1309 372.546 158.6639 368.86 158.9209 365.164 159.0419 359.384 159.1749 353.834 159.2919 348.275 159.2739 342.706 159.1179 337.129 158.8259 331.55 158.5369 325.962 158.1079 323.39 157.7439 320.595 157.5309' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-188', stroke: '#2DDD6F', points: '1974.2678 50.6039 1695.7978 110.8469 1623.8998 125.5559 1588.6928 131.9739 1554.6018 137.7669' }),
	                        _react2.default.createElement('path', { d: 'M1544.9788,139.2592 L1535.5818,140.5992', id: 'Stroke-189', stroke: '#231F20' }),
	                        _react2.default.createElement('path', { d: 'M1525.9495,141.9555 L1507.3615,144.3465', id: 'Stroke-190', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-191', stroke: '#2DDD6F', points: '1505.76 144.5961 1485.309 146.8451 1465.071 148.8061 1445.266 150.3271 1425.428 151.4461 1403.269 152.4511 1381.302 152.9011 1359.999 152.8931 1338.664 152.4781' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-192', stroke: '#231F20', points: '1313.8069 151.3578 1297.9939 150.4178 1282.3939 149.1968 1266.9999 147.6838 1251.8309 146.0198' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-193', stroke: '#2DDD6F', points: '1250.9026 145.9506 1228.9336 143.1286 1206.6876 139.6426 1185.1256 135.9746 1163.9906 131.8676 1143.2986 127.4556 1110.5716 119.8006 1079.2016 111.7746 990.4206 87.6006 961.8746 80.1976 947.9826 76.9456 934.0986 73.8306 927.2906 72.5356 920.4746 71.1046 913.4456 69.9616 906.6486 68.8016 897.9876 67.5006 889.1156 66.4856 880.7156 65.5746 872.1026 64.9526 863.9616 64.4296 855.8396 64.1816 847.7166 63.9336 839.6136 63.9566 831.7596 64.2316 823.9066 64.5106 816.2926 64.9076 808.6986 65.5756 800.8756 66.2596 793.2886 67.0626 785.9446 67.9846 778.3786 69.0606 771.0446 70.1206 763.9486 71.2996 750.0086 73.9086 736.3076 76.6396 722.8476 79.4906 697.1096 85.5166 672.3196 91.8866 540.7426 127.1276' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-194', stroke: '#2DDD6F', points: '532.1022 129.3656 501.8512 137.0726 468.1602 145.2906 451.9742 148.8766 443.9872 150.5286 435.9882 152.0406 427.9822 153.4196 420.2062 154.7786 412.4182 156.0076 404.6122 156.9626 396.8072 157.9186 389.2232 158.7206 381.6192 159.2536 377.9322 159.5116 374.0152 159.7866 368.4662 159.9026 362.9162 160.0186 357.1362 160.1506 351.5682 159.9946 345.9992 159.8406 343.2062 159.6286 340.4122 159.4136 337.6272 159.3366 335.0542 158.9706 332.2602 158.7606 329.4572 158.4086' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-196', stroke: '#2DDD6F', points: '1973.7688 43.5531 1705.7058 106.8831 1633.4328 122.8461 1598.2758 129.9401 1563.9798 136.1571' }),
	                        _react2.default.createElement('path', { d: 'M1545.2112,139.2426 L1544.9792,139.2596', id: 'Stroke-197', stroke: '#231F20' }),
	                        _react2.default.createElement('path', { d: 'M1535.5911,140.7328 L1516.7891,143.4138', id: 'Stroke-198', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-199', stroke: '#2DDD6F', points: '1515.6467 143.6313 1495.2187 146.1513 1474.7557 148.2633 1454.7387 150.0733 1434.9127 151.3273 1423.6117 151.9813 1412.5327 152.4843 1401.4457 152.8533 1390.5757 153.0673 1379.9317 153.1333 1369.0507 153.2133 1358.3847 153.0053 1347.9487 152.7813' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-200', stroke: '#231F20', points: '1332.1663 152.2524 1321.2363 151.6534 1310.5333 150.9044' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-201', stroke: '#2DDD6F', points: '1307.7473 150.8266 1289.8143 149.3586 1272.3223 147.5846 1255.0363 145.5236 1237.9673 143.1766 1226.7263 141.3726 1215.7123 139.5546 1193.8983 135.6336 1172.7573 131.3896 1152.0473 126.7066 1135.5533 122.6826 1119.2783 118.5096 1088.1203 110.1956 999.2133 84.2606 970.8693 76.4326 956.9583 72.9106 942.8253 69.5396 935.9983 67.9726 929.1823 66.5426 922.1443 65.2636 915.3453 64.1026 906.4463 62.6836 897.7963 61.5176 893.5903 60.9936 889.1543 60.4886 884.9573 60.0996 880.7623 59.7126 876.5763 59.4596 872.3913 59.2086 868.4343 58.9406 864.2573 58.8246 860.0823 58.7066 856.1363 58.5726 852.2003 58.5776 848.2623 58.5806 840.1683 58.7386 832.3143 59.0146 824.7033 59.4126 816.8693 59.9596 809.2823 60.7646 801.6973 61.5686 794.1233 62.5076 786.5583 63.5826 779.2333 64.7766 772.1373 65.9536 765.0533 67.2686 758.2073 68.7026 744.2863 71.5846 731.0653 74.5536 718.0853 77.6426 705.1243 81.0046 680.3443 87.5086 510.5573 135.7816 477.1363 144.5266 460.9693 148.3856 452.7623 150.1846 444.7843 151.9696 437.0163 153.4676 429.2493 154.9656 421.4633 156.1916 413.6773 157.4176 405.8713 158.3746 398.2963 159.3136 394.3793 159.5886 390.7023 159.9816 386.7853 160.2556 383.0983 160.5136 379.4013 160.6366 375.7063 160.7586 372.0083 160.8816 368.3123 161.0026 364.6063 160.9896 360.9003 160.9766 357.1843 160.8296 353.4693 160.6806 349.9833 160.5156 346.2593 160.2306 342.5353 159.9456 339.0303 159.5116 335.2933 159.0916 331.7903 158.6546 328.2753 158.0836 324.5223 157.3916' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-203', stroke: '#2DDD6F', points: '1973.2874 36.7729 1715.6034 102.7849 1648.4364 118.9329 1615.6024 126.1369 1583.4124 132.6169' }),
	                        _react2.default.createElement('path', { d: 'M1563.9885,136.2934 L1554.6115,137.9024', id: 'Stroke-204', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-205', stroke: '#2DDD6F', points: '1554.1506 137.935 1540.1886 140.277 1525.9886 142.497 1512.2306 144.415 1498.4516 146.061 1484.6786 147.706 1471.1126 149.066 1457.5356 150.287 1444.1706 151.223 1432.8696 151.879 1421.8006 152.517 1410.9426 152.87 1399.8516 153.235 1388.9736 153.317 1378.3256 153.379 1367.6696 153.31 1357.0026 153.101' }),
	                        _react2.default.createElement('path', { d: 'M1335.4094,152.2982 L1329.3624,151.9042', id: 'Stroke-206', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-207', stroke: '#2DDD6F', points: '1328.8997 151.9369 1318.1967 151.1869 1307.7197 150.4209 1297.2377 149.5189 1286.9707 148.4679 1276.6997 147.2779 1266.6567 146.0739 1256.5957 144.5959 1246.5407 143.2569 1235.5297 141.4369 1224.2757 139.5019 1213.4777 137.3979 1202.6737 135.2909 1181.5147 130.7759 1160.7947 125.9589 1144.2807 121.6659 1127.9937 117.3529 1096.7997 108.4969 1008.0167 81.0549 979.6337 72.6859 965.4657 68.7719 951.5507 65.2489 944.7247 63.6819 937.6677 62.1329 930.8517 60.7039 924.0437 59.4079 919.5797 58.4929 915.1357 57.8509 910.6797 57.0729 906.2427 56.5639 902.0287 55.9069 897.5937 55.3989 893.3987 55.0119 889.2027 54.6239 885.0077 54.2349 880.8207 53.9839 876.8647 53.7169 872.6777 53.4659 868.5027 53.3469 864.5557 53.2159 860.6187 53.2169 856.4517 53.2389 852.5157 53.2399 848.5797 53.2449 844.6527 53.3829 840.7247 53.5209 832.8807 53.9339 825.2887 54.6019 817.4637 55.2869 809.8887 56.2239 802.3127 57.1639 794.5177 58.2539 787.4227 59.4339 780.3357 60.7479 773.2517 62.0589 766.1747 63.5089 752.4947 66.5109 739.0537 69.6339 726.0927 72.9959 713.1317 76.3549 688.3897 83.4019 519.2667 134.4889 485.8847 143.7779 469.7447 148.0409 461.7767 149.9609 453.7987 151.7479 445.8207 153.5339 438.0537 155.0309 430.2857 156.5289 422.5007 157.7549 414.7037 158.8429 411.0377 159.3729 407.1287 159.7849 403.2307 160.3309 399.5437 160.5869 395.6367 160.9979 391.9507 161.2549 385.9487 161.5409 383.1847 161.7329 380.1797 161.8099 377.4047 161.8659 374.3987 161.9399 371.6157 161.8619 368.6007 161.8009 365.8167 161.7239 362.8017 161.6629 360.0167 161.5849 356.9927 161.3869 354.1997 161.1739 351.3957 160.8249 348.3717 160.6269 345.5677 160.2799' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-209', stroke: '#2DDD6F', points: '1972.8342 30.4008 1725.2722 98.6998 1662.9622 114.7818 1632.2232 122.1118 1602.3642 128.8348' }),
	                        _react2.default.createElement('path', { d: 'M1582.7375,132.935 L1564.4585,136.396', id: 'Stroke-210', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-211', stroke: '#2DDD6F', points: '1563.5481 136.5961 1549.3671 139.0881 1535.4081 141.4281 1521.4291 143.4971 1507.6691 145.4151 1493.8921 147.0601 1480.3381 148.5561 1466.7701 149.9151 1453.4161 150.9871 1442.1251 151.7751 1431.0541 152.4141 1419.9761 152.9161 1409.1181 153.2681 1398.2501 153.4861 1387.6021 153.5481 1376.7111 153.4931 1366.2771 153.2701' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-212', stroke: '#2DDD6F', points: '1347.9387 152.6459 1335.8507 151.9949 1323.9867 151.1899 1312.1077 150.2499 1300.4527 149.1569 1289.0177 147.9149 1277.8037 146.5179 1266.3377 144.8689 1255.3357 143.1859 1244.0957 141.3849 1233.0627 139.2949 1222.0297 137.2059 1211.2267 135.1019 1190.0507 130.3139 1169.5407 125.2089 1152.7857 120.7949 1136.7137 116.1979 1105.4817 106.7979 1016.5897 77.8639 988.1717 68.9529 974.2197 64.8859 960.2877 61.0939 953.2127 59.2729 946.3767 57.5709 939.3287 56.1559 932.5117 54.7239 928.0457 53.8109 923.5927 53.0329 919.1367 52.2539 914.6927 51.6129 910.4767 50.9539 906.0417 50.4479 901.8347 49.9229 897.6397 49.5359 893.4437 49.1489 889.2487 48.7599 885.0627 48.5079 881.1067 48.2399 876.9297 48.1259 872.9837 47.9919 868.8087 47.8759 864.8727 47.8779 860.9357 47.8819 856.7687 47.9009 852.8407 48.0389 848.9137 48.1779 844.9877 48.3159 841.0707 48.5899 837.1537 48.8649 833.4667 49.1229 825.6527 49.9429 817.8377 50.7639 810.2707 51.8379 802.7157 53.0479 795.3907 54.2419 788.3047 55.5549 781.2187 56.8689 774.1527 58.4559 760.2507 61.6079 747.0517 64.8479 734.0997 68.3449 721.1487 71.8409 696.4277 79.1599 527.9637 133.0639 494.6407 143.1639 478.5217 147.6999 470.5617 149.7559 462.5937 151.6759 454.6147 153.4609 446.8667 155.2309 439.0997 156.7269 431.3237 158.0909 423.5467 159.4549 419.6477 159.9979 415.9727 160.3949 412.0737 160.9389 408.1667 161.3479 404.4897 161.7409 400.5727 162.0149 396.8847 162.2729 393.1987 162.5329 389.2707 162.6699 385.5757 162.7919 381.8707 162.7829 378.1637 162.7669 374.4567 162.7529 370.5117 162.6219 366.7947 162.4719 363.0707 162.1879 359.3457 161.9039 355.6107 161.4829 351.8767 161.0649 348.3617 160.4929 344.6177 159.9369 340.8637 159.2459 337.3387 158.5379 333.5757 157.7109 329.8027 156.7509 326.2597 155.7719 322.7157 154.7919 318.9247 153.5609 315.3627 152.3099 311.7997 151.0619 308.2277 149.6739 304.6467 148.1549 301.0657 146.6339 297.4747 144.9789 294.1037 143.1689 290.7337 141.3599 287.1237 139.4329 283.7437 137.4919 280.5947 135.5289 277.2057 133.4519 270.8777 129.1249 264.5307 124.5279 228.0727 96.9629 221.9757 92.6199 219.0467 90.5079 215.8967 88.5469 212.9877 86.7089 209.8487 84.8829 208.3987 84.0299 206.7287 83.3309 205.2787 82.4769 203.6067 81.7779 202.1677 81.0609 200.7267 80.3429 199.0657 79.7799 197.6357 79.1969 196.9257 78.9749 195.9737 78.6319 195.2637 78.4099 194.5527 78.1869 193.8427 77.9639 192.9017 77.7559 192.1917 77.5339 191.4907 77.4479 190.7797 77.2239 190.0687 77.0009 189.3687 76.9139 188.4377 76.8399 187.7357 76.7549 187.0357 76.6689 186.3347 76.5829 185.6337 76.4959 184.9327 76.4069 184.2407 76.4549 183.5407 76.3679 182.8507 76.4169 182.1477 76.3299 181.4577 76.3769 180.7667 76.4259 180.0747 76.4749 179.3827 76.5229 178.7027 76.7079 178.0107 76.7559 177.3187 76.8039 176.6367 76.9889 175.9567 77.1729 175.2657 77.2209 174.5837 77.4049' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-213', stroke: '#2DDD6F', points: '1972.4114 24.435 1734.9384 94.618 1672.4774 111.798 1641.7734 119.672 1611.4834 126.836' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-214', stroke: '#2DDD6F', points: '1593.0217 130.9906 1572.4767 135.1506 1558.5377 137.7656 1544.5847 140.2406 1530.6257 142.5826 1516.8767 144.6346 1503.1107 146.4146 1489.5627 148.0436 1476.0057 149.5396 1462.4317 150.7616 1451.3717 151.5366 1440.0777 152.3286 1429.2297 152.8136 1418.1517 153.3186 1407.2827 153.5336 1396.6437 153.7316 1385.7577 153.6776 1375.3197 153.4556' }),
	                        _react2.default.createElement('path', { d: 'M1362.5618,153.1205 L1359.0758,152.9575', id: 'Stroke-215', stroke: '#231F20' }),
	                        _react2.default.createElement('path', { d: 'M1357.2229,152.9506 L1351.4139,152.6766', id: 'Stroke-216', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-217', stroke: '#2DDD6F', points: '1346.5364 152.4711 1335.8324 151.7211 1325.3494 150.8231 1314.8644 149.9211 1304.3714 148.8821 1294.0874 147.5581 1284.0334 146.2191 1273.9804 144.8781 1263.9104 143.2681 1252.6564 141.3291 1241.6244 139.2401 1230.5864 137.0151 1219.7724 134.7741 1209.1824 132.3791 1198.5834 129.8541 1178.0554 124.4781 1161.2814 119.7921 1145.1994 115.0571 1113.9294 105.1171 1025.1644 74.6761 996.7144 65.3591 982.7454 61.0201 968.7944 56.9571 961.7084 55.0001 954.6414 53.3111 947.8044 51.6101 940.9774 50.0441 936.5154 49.1301 932.0594 48.3521 927.6044 47.5761 923.3794 46.7821 918.9354 46.1361 914.4884 45.4941 910.2844 44.9721 906.0774 44.4491 901.6524 44.0761 897.4574 43.6881 893.2614 43.3021 888.8444 43.0661 884.6594 42.8141 880.4814 42.6971 876.3064 42.5811 871.9094 42.6171 867.9714 42.6191 864.0354 42.6211 859.8784 42.7771 855.9524 42.9161 852.0244 43.0531 848.1084 43.3281 844.4214 43.5861 840.5134 43.9961 832.9194 44.6641 825.3444 45.6041 818.0084 46.6621 810.6744 47.7221 803.3594 49.0501 796.2734 50.3651 789.1974 51.8141 782.1314 53.3981 775.2954 54.9681 768.4594 56.5361 755.2774 60.0491 742.0964 63.5621 729.1654 67.3281 704.2404 75.0701 536.4414 131.7891 503.3954 142.5511 487.2864 147.2221 479.3464 149.5491 471.3884 151.6061 463.4194 153.5261 455.6814 155.4311 447.9244 157.0651 440.1564 158.5621 436.2684 159.2441 432.3804 159.9261 428.4834 160.4701 424.5844 161.0151 420.9164 161.5451 417.0094 161.9551 413.1024 162.3661 409.4234 162.7571 406.1984 162.9831 402.7414 163.2251 399.5154 163.4501 396.2794 163.5431 392.8154 163.6501 389.5794 163.7391 386.3334 163.6931 383.0884 163.6471 379.8444 163.6031 376.3584 163.4371 373.1034 163.2561 369.8494 163.0761 366.5844 162.7611 363.3204 162.4431 360.0464 161.9921 357.0024 161.5241' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-218', stroke: '#2DDD6F', points: '355.8313 161.3334 352.5583 160.8794 349.5033 160.2754 345.7413 159.4504 341.9773 158.6224 338.4433 157.7794 334.6603 156.6804 331.1183 155.7024 327.5543 154.4534 323.7633 153.2214 320.1913 151.8354 316.6203 150.4484 313.0383 148.9294 309.4473 147.2734 306.0863 145.6014 302.4863 143.8084 299.1063 141.8664 295.4963 139.9364 292.1063 137.8584 288.9473 135.7624 285.5573 133.6824 279.2213 129.2234 272.8643 124.4884 236.0983 95.8544 229.9923 91.3764 227.0543 89.1304 223.8953 87.0334 220.7463 85.0744 217.8363 83.2324 216.1563 82.3964 214.7063 81.5464 213.0263 80.7084 211.5853 79.9934 209.9053 79.1554 208.4653 78.4384 206.8043 77.8744 205.3733 77.2924 204.4233 76.9504 203.7123 76.7284 202.9923 76.3694 202.2813 76.1454 201.3413 75.9374 200.6293 75.7164 199.9203 75.4944 199.2093 75.2704 198.2773 75.1994 197.5673 74.9764 196.8673 74.8904 196.1563 74.6674 195.4543 74.5804 194.5243 74.5084 193.8233 74.4234 193.5833 74.3024 193.1233 74.3364 192.6613 74.3664 192.1903 74.2644 191.9613 74.2794 191.4893 74.1764 191.0293 74.2094 190.5673 74.2404 190.1073 74.2734 189.8773 74.2904 189.4073 74.1874 188.9463 74.2174 188.4843 74.2504 188.2543 74.2664 187.7953 74.2984 187.3323 74.3294 186.8713 74.3624 186.6423 74.3784 186.1893 74.5484 185.7273 74.5804 185.4993 74.5954 185.0383 74.6294 184.5863 74.7954 184.3563 74.8124 183.8953 74.8444 183.4443 75.0124 182.9843 75.0434 182.7543 75.0604 182.0723 75.2454 181.1683 75.5794 180.4863 75.7634 179.8063 75.9484 178.8943 76.1484 178.2223 76.4674 177.5493 76.7884' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-220', stroke: '#2DDD6F', points: '1972.0168 18.8725 1744.5948 90.3955 1692.4268 105.7685 1666.5338 112.8975 1640.8538 119.7365' }),
	                        _react2.default.createElement('path', { d: 'M1631.5305,122.1606 L1622.1985,124.4486', id: 'Stroke-221', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('path', { d: 'M1620.8352,124.8178 L1603.2932,128.9088', id: 'Stroke-222', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('path', { d: 'M1601.0198,129.475 L1583.9098,133.127', id: 'Stroke-223', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-224', stroke: '#2DDD6F', points: '1581.634 133.6938 1567.483 136.5928 1553.544 139.2048 1539.815 141.5298 1525.846 143.7328 1512.325 145.7688 1498.558 147.5508 1485.002 149.0478 1471.665 150.3898 1460.386 151.3138 1449.325 152.0868 1438.257 152.7298 1427.177 153.2298 1416.318 153.5838 1405.448 153.7998 1394.802 153.8618 1384.133 153.6568' }),
	                        _react2.default.createElement('path', { d: 'M1371.6067,153.3061 L1367.6597,153.1731', id: 'Stroke-225', stroke: '#231F20' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-226', stroke: '#231F20', points: '1366.2668 153.1352 1355.5818 152.6582 1345.1168 152.0262' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-227', stroke: '#2DDD6F', points: '1343.0227 151.8998 1333.9417 151.1728 1324.8497 150.3118 1315.9777 149.2958 1307.1077 148.2828 1298.2347 147.2678 1289.5747 145.9678 1280.9167 144.6658 1272.2437 143.2298 1260.9907 141.2908 1249.9507 139.0658 1238.9097 136.8388 1228.3187 134.4478 1217.4877 131.9358 1207.1107 129.2558 1186.3407 123.7598 1169.7897 118.9218 1153.4557 113.9348 1122.1567 103.5868 1033.5167 71.6358 1005.2497 61.6248 991.2697 57.1538 977.0687 52.8318 970.2137 50.8588 963.1287 48.9028 956.0617 47.2168 949.2257 45.5148 944.7607 44.6018 940.2967 43.6878 935.8317 42.7738 931.6077 41.9788 927.1627 41.3378 922.9467 40.6778 918.5017 40.0348 914.2967 39.5118 909.8607 39.0048 905.6647 38.6168 901.2397 38.2458 897.0537 37.9948 892.8667 37.7418 888.4497 37.5048 884.2747 37.3898 880.1067 37.4078 875.9327 37.2928 872.0047 37.4318 867.8387 37.4518 863.9117 37.5878 859.9937 37.8618 856.0757 38.1368 852.3897 38.3948 848.4727 38.6698 844.5647 39.0818 840.8867 39.4738 833.3117 40.4148 825.7457 41.4888 818.4127 42.5458 811.3257 43.8588 804.0197 45.3258 796.9427 46.7758 789.8777 48.3588 783.0537 50.0638 776.2267 51.7688 763.0447 55.2788 749.8827 59.0638 736.9597 62.9678 712.0567 70.9798 666.1847 87.0018 544.9297 130.6488 511.9127 141.8178 495.8317 146.8978 487.8917 149.2248 479.9517 151.5518 472.2227 153.5928 464.2537 155.5138 456.5067 157.2818 448.7497 158.9148 444.8707 159.7328 440.9827 160.4138 437.3247 161.0788 433.4257 161.6248 429.5287 162.1698 425.6307 162.7138 421.9547 163.1078 418.0467 163.5158 414.8297 163.8788 411.3747 164.1218 408.1477 164.3488 404.9127 164.4368 401.4557 164.6778 398.2117 164.6338 394.9757 164.7228 391.7307 164.6778 388.2547 164.6478 384.9997 164.4668 381.7457 164.2878 378.4907 164.1068 375.2257 163.7908 371.9607 163.4758 368.6877 163.0228 365.4137 162.5688' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-228', stroke: '#2DDD6F', points: '364.4719 162.3627 361.1989 161.9107 357.9149 161.3217 354.1519 160.4957 350.6169 159.6517 346.8449 158.6917 343.0719 157.7287 339.5189 156.6137 335.9559 155.3647 332.1539 153.9967 328.5829 152.6117 325.0109 151.2257 321.4199 149.5697 317.8289 147.9147 314.2389 146.2567 310.8579 144.3127 307.4779 142.3697 303.8689 140.4417 300.4789 138.3637 297.3099 136.1317 293.9119 133.9167 287.5549 129.1817 280.9679 124.4667 244.1239 94.7487 237.9989 89.9987 234.8309 87.7667 231.6719 85.6727 228.7429 83.5597 225.6049 81.7357 222.4629 79.9127 220.7829 79.0757 219.3329 78.2227 217.6529 77.3867 216.2119 76.6707 214.5439 75.9677 212.8709 75.2677 212.1599 75.0457 211.4409 74.6887 210.7299 74.4657 209.7809 74.1227 209.0699 73.8987 208.3589 73.6747 207.4179 73.4697 206.7079 73.2467 205.9969 73.0217 205.0659 72.9537 204.3549 72.7297 203.6539 72.6447 202.9439 72.4217 202.0129 72.3497 201.7829 72.3657 201.3109 72.2617 201.0809 72.2787 200.6109 72.1747 200.1499 72.2087 199.6799 72.1037 199.2189 72.1367 198.9879 72.1527 198.5179 72.0497 198.0559 72.0807 197.5959 72.1127 197.1349 72.1447 196.9059 72.1627 196.4349 72.0587 195.9739 72.0917 195.5129 72.1237 195.0519 72.1547 194.8209 72.1717 194.3709 72.3387 193.9089 72.3707 193.4489 72.4037 193.2179 72.4207 192.7569 72.4527 192.3059 72.6217 192.0749 72.6347 191.6149 72.6687 191.1639 72.8357 190.7019 72.8687 190.4719 72.8847 190.0209 73.0517 189.5609 73.0857 189.3399 73.2377 188.4269 73.4377 187.7459 73.6207 187.0739 73.9387 186.3929 74.1247 185.4899 74.4597 184.8069 74.6437 184.1359 74.9637 183.4639 75.2837 182.7929 75.6017 182.1199 75.9227 181.4479 76.2407 180.7859 76.6977 180.1129 77.0167 179.4409 77.3387 178.7789 77.7927 178.1069 78.1117 176.7819 79.0227 175.8989 79.6287 174.7849 80.2517' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-229', stroke: '#2DDD6F', points: '1971.6418 13.5844 1754.2538 86.1784 1701.9228 102.5154 1675.8288 110.0644 1650.1728 117.3124' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-230', stroke: '#2DDD6F', points: '1631.7698 122.2816 1610.8288 127.4256 1590.5518 132.1176 1576.4128 135.1506 1562.4908 138.0336 1548.7828 140.6286 1535.0518 142.9516 1521.3018 145.0046 1507.5428 146.9216 1494.0068 148.6876 1480.6718 150.0316 1469.4028 151.0936 1458.1208 152.0176 1447.0498 152.6576 1436.2098 153.2806 1425.3508 153.6336 1414.4838 153.8456 1403.6048 153.9276 1392.9508 153.8556' }),
	                        _react2.default.createElement('path', { d: 'M1380.4192,153.5063 L1376.4732,153.3753', id: 'Stroke-231', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-232', stroke: '#2DDD6F', points: '1375.3098 153.3197 1363.0008 152.8177 1350.6758 152.0467 1338.7908 150.9697 1326.8928 149.7577 1314.9868 148.4117 1303.5328 146.8977 1292.0598 145.1117 1280.8188 143.3077 1269.3268 141.2537 1258.2858 139.0287 1247.2328 136.6667 1236.6348 134.1357 1225.7938 131.4907 1215.4148 128.8087 1194.8578 123.0277 1178.0548 117.9367 1161.9428 112.7967 1130.6158 102.0427 1041.8588 68.4657 1013.5728 58.1797 999.5648 53.3007 985.5758 48.6937 978.4798 46.6007 971.3938 44.6437 964.5488 42.8057 957.4718 40.9867 952.9988 39.9357 948.5328 39.0227 944.0678 38.1077 939.8458 37.3147 935.3888 36.5367 930.9348 35.7577 926.7198 35.0987 922.2838 34.5907 918.0788 34.0697 913.6418 33.5597 909.4488 33.1747 905.0298 32.9377 900.8358 32.5497 896.4278 32.4497 892.2518 32.3357 887.8458 32.2337 883.9098 32.2367 879.9718 32.2397 875.8058 32.2587 871.8778 32.3977 867.9618 32.6707 864.0338 32.8087 860.1188 33.0857 856.2108 33.4947 852.5328 33.8877 848.6238 34.2997 844.9498 34.6917 841.0508 35.2377 833.7148 36.2967 826.1588 37.5077 819.0728 38.8207 811.7668 40.2847 804.7028 41.8717 797.6348 43.4557 790.8088 45.1597 783.9928 47.0007 770.5908 50.6647 757.6678 54.5667 744.7548 58.6047 719.8808 67.0237 674.0558 83.7237 631.4308 99.7907 553.4078 129.3757 520.4378 141.2207 504.3758 146.5707 496.4458 149.0347 488.7468 151.4817 480.7968 153.6737 473.0698 155.7137 465.3308 157.6187 457.3528 159.4027 453.7038 160.2037 449.8158 160.8837 445.9268 161.5647 442.0388 162.2457 438.1508 162.9277 434.2518 163.4737 430.5748 163.8667 426.6778 164.4117 423.4528 164.6377 420.0038 165.0147 416.7798 165.2407 413.5528 165.4657 410.0878 165.5737 406.8518 165.6657 403.6158 165.7547 400.1408 165.7247 396.8958 165.6797 393.6408 165.4997 390.3858 165.3167 387.1308 165.1357 383.6358 164.8377 380.3718 164.5207 377.0988 164.0687 373.8238 163.6157' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-233', stroke: '#2DDD6F', points: '372.8825 163.4096 369.6095 162.9576 366.3265 162.3696 362.7915 161.5256 359.0285 160.6996 355.2545 159.7356 351.4725 158.6386 347.9195 157.5246 344.1275 156.2906 340.5555 154.9066 336.9835 153.5206 333.4025 152.0006 329.8105 150.3446 326.2115 148.5536 322.6115 146.7606 319.2395 144.9516 315.6195 142.8896 312.2305 140.8086 308.8405 138.7296 305.4425 136.5156 302.2635 134.1496 295.6665 129.2956 289.2925 124.2896 252.1505 93.6416 246.0155 88.7566 242.8465 86.5236 239.6785 84.2936 236.5095 82.0596 233.3615 80.1016 230.2115 78.1426 228.5315 77.3056 227.0805 76.4536 225.4005 75.6176 223.7205 74.7806 222.2815 74.0636 220.6105 73.3636 219.8995 73.1406 218.9485 72.8006 218.2285 72.4406 217.5185 72.2176 216.5765 72.0116 215.8565 71.6516 215.1475 71.4306 214.2065 71.2226 213.4945 70.9996 212.7935 70.9126 211.8535 70.7076 211.1425 70.4836 210.4415 70.3966 209.5105 70.3236 209.2705 70.2056 208.8105 70.2376 208.3395 70.1346 208.1095 70.1506 207.6385 70.0476 207.1775 70.0796 206.7075 69.9756 206.2465 70.0086 205.7855 70.0416 205.5445 69.9206 205.0845 69.9536 204.6235 69.9846 204.1625 70.0176 203.7025 70.0506 203.2415 70.0826 203.0105 70.0986 202.5495 70.1316 202.0895 70.1626 201.6275 70.1956 201.3975 70.2116 200.9375 70.2436 200.4765 70.2756 200.0245 70.4446 199.7955 70.4606 199.3335 70.4926 198.8825 70.6606 198.4225 70.6926 198.1915 70.7096 197.7395 70.8766 197.2785 70.9096 196.8285 71.0766 196.5975 71.0936 196.1455 71.2606 195.6955 71.4306 195.0135 71.6126 194.3315 71.7966 193.6595 72.1176 192.7575 72.4526 192.0745 72.6356 191.4025 72.9556 190.7315 73.2756 190.0585 73.5976 189.1675 74.0666 188.4935 74.3876 187.8225 74.7056 187.1595 75.1606 186.4885 75.4816 185.8245 75.9346 185.1535 76.2556 184.0595 77.1486 182.7245 77.9256 181.6315 78.8186 180.5365 79.7136 179.4415 80.6056 178.3465 81.5006 177.2535 82.3956 175.0725 84.3196' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-234', stroke: '#2DDD6F', points: '1971.3059 8.8373 1763.6819 81.9723 1721.8259 95.8073 1679.9059 108.8243' }),
	                        _react2.default.createElement('path', { d: 'M1670.6145,111.6557 L1661.3115,114.3547', id: 'Stroke-235', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-236', stroke: '#2DDD6F', points: '1659.2688 114.9047 1628.8318 123.3027 1614.0468 127.0667 1599.2518 130.6897 1585.3498 133.8437 1571.4408 136.8647 1557.7388 139.5917 1544.0188 142.0517 1530.2808 144.2407 1516.5338 146.2937 1503.0058 148.1947 1489.4488 149.6897 1478.1878 150.8877 1467.1368 151.7977 1456.0768 152.5707 1445.0038 153.2117 1434.1568 153.6957 1423.2898 153.9107 1412.4188 154.1297 1401.7628 154.0577' }),
	                        _react2.default.createElement('path', { d: 'M1389.0022,153.724 L1385.0562,153.591', id: 'Stroke-237', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('path', { d: 'M1384.1331,153.6566 L1373.2091,153.0576', id: 'Stroke-238', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-239', stroke: '#2DDD6F', points: '1372.5061 152.9701 1361.5811 152.3711 1350.8671 151.4891 1340.3741 150.4501 1329.8801 149.4141 1319.3651 148.1041 1309.3021 146.6301 1299.0031 145.0331 1288.9211 143.2881 1277.6511 141.0781 1266.6091 138.8531 1255.5451 136.3581 1244.7151 133.8461 1234.1081 131.1821 1223.7071 128.2291 1213.3191 125.4131 1202.9121 122.3271 1186.3321 117.0821 1169.9701 111.6891 1154.2931 106.1081 1138.8321 100.3761 1021.8871 54.6011 1007.8691 49.5851 993.8601 44.7061 986.7561 42.4771 979.6601 40.3861 972.5731 38.4281 965.7291 36.5921 961.2451 35.4061 956.7821 34.4931 952.3061 33.4451 947.8411 32.5301 943.6171 31.7351 939.1631 30.9571 934.7181 30.3161 930.5031 29.6561 926.0651 29.1471 921.8611 28.6251 917.4361 28.2521 913.0091 27.8831 908.8121 27.4951 904.4061 27.3951 900.2201 27.1421 895.8121 27.0421 891.6461 27.0631 887.7101 27.0641 883.7831 27.2031 879.6161 27.2211 875.6991 27.4961 871.7721 27.6351 867.8641 28.0451 864.1771 28.3031 860.2711 28.7121 856.3621 29.1221 852.6871 29.5171 848.7901 30.0631 845.1201 30.5911 841.4531 31.1181 833.9061 32.4671 826.5921 33.7961 819.5151 35.2471 812.4481 36.8311 805.3921 38.5511 798.3461 40.4081 791.5291 42.2481 778.3651 46.0321 765.2221 50.0861 752.3291 54.3951 727.4731 63.0851 704.6911 71.6311 561.8841 128.1011 528.9631 140.6241 512.9211 146.2441 505.0001 148.8411 497.3001 151.2891 489.3701 153.7541 481.6521 155.9301 473.9231 157.9711 469.8231 158.9371 465.9441 159.7541 462.0761 160.7081 458.1871 161.3881 454.5391 162.1901 450.6511 162.8691 446.7611 163.5501 442.8641 164.0961 438.9661 164.6421 435.2991 165.1711 432.5441 165.4991 429.7791 165.6951 427.2541 166.0081 424.4891 166.2011 421.7231 166.3951 418.9501 166.4521 416.4151 166.6301 413.6391 166.6871' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-240', stroke: '#2DDD6F', points: '412.4768 166.6322 408.7718 166.6192 404.8358 166.6242 401.1198 166.4772 397.4048 166.3262 393.6788 166.0412 389.7138 165.6392 387.8518 165.4952 385.9788 165.2162 384.1058 164.9402 382.2338 164.6602' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-241', stroke: '#2DDD6F', points: '381.5339 164.5756 378.0199 164.0046 374.7259 163.2816 372.8539 163.0036 370.9719 162.5886 369.0809 162.0386 367.1989 161.6276 363.6559 160.6476 359.8729 159.5506 356.0889 158.4536 352.5179 157.0676 348.7169 155.6976 345.1449 154.3126 341.5539 152.6576 337.9619 150.9996 334.3719 149.3436 330.7619 147.4156 327.3809 145.4736 324.0019 143.5276 320.3719 141.3306 316.9739 139.1156 313.7959 136.7486 310.3869 134.3966 303.7809 129.4096 297.3959 124.2686 260.1879 92.6696 253.8119 87.6656 247.4549 82.9296 244.2869 80.7016 241.1279 78.6056 237.9689 76.5096 236.2869 75.6716 234.8269 74.6846 233.1499 73.8486 231.4679 73.0126 229.7979 72.3096 228.3469 71.4586 227.4069 71.2526 226.6869 70.8936 225.7369 70.5526 225.0159 70.1926 224.0749 69.9876 223.3649 69.7636 222.6439 69.4036 221.7029 69.1996 220.9929 68.9756 220.0529 68.7696 219.3519 68.6826 218.6409 68.4596 217.7099 68.3876 217.4699 68.2706 216.9979 68.1676 216.5379 68.1976 216.2979 68.0786 215.8359 68.1106 215.3669 68.0086 214.9069 68.0386 214.4349 67.9366 214.2059 67.9536 213.7349 67.8486 213.2729 67.8836 212.8129 67.9126 212.3519 67.9456 211.8809 67.8426 211.4219 67.8746 211.1899 67.8896 210.7289 67.9226 210.2679 67.9556 209.8079 67.9876 209.3469 68.0196 208.8869 68.0516 208.6559 68.0686 208.2039 68.2366 207.7439 68.2686 207.2839 68.3026 207.0529 68.3166 206.6019 68.4866 206.1409 68.5186 205.6899 68.6846 205.4589 68.7016 204.9979 68.7336 204.5469 68.9016 204.0959 69.0686 203.8659 69.0856 203.4129 69.2546 202.9519 69.2876 202.7319 69.4376 202.2809 69.6036 201.5989 69.7896 200.6969 70.1246 200.0249 70.4446 199.3529 70.7646 198.4509 71.0976 197.7789 71.4186 197.1059 71.7406 196.4349 72.0586 195.7729 72.5146 195.0999 72.8346 194.4379 73.2896 193.7649 73.6076 193.1039 74.0626 192.4399 74.5196 191.1159 75.4286 190.0109 76.1876 188.9079 76.9466 188.0439 77.8236 186.9409 78.5826 185.8459 79.4756 184.9819 80.3556 182.8019 82.2786 181.0829 84.1716 179.1349 86.0796 177.4259 88.1056 175.4859 90.1516' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-242', stroke: '#2DDD6F', points: '1970.9875 4.3637 1773.1085 77.7697 1731.0785 92.4317 1689.2135 106.1297' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-243', stroke: '#2DDD6F', points: '1680.1487 108.9447 1661.5507 114.4687 1643.3957 119.6957 1625.6807 124.6147 1607.9417 129.1287 1594.0577 132.5517 1580.3777 135.5537 1566.4577 138.4367 1552.7557 141.1677 1539.0277 143.4897 1525.5197 145.6627 1511.7687 147.7157 1498.4537 149.3327 1487.1917 150.5267 1475.9197 151.5897 1464.8727 152.4977 1453.7997 153.1387 1442.9507 153.6257 1432.0907 153.9787 1421.2237 154.1947 1410.5667 154.1207' }),
	                        _react2.default.createElement('path', { d: 'M1397.8157,153.9252 L1393.6407,153.8072', id: 'Stroke-244', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('path', { d: 'M1393.1702,153.7025 L1382.4912,153.3615', id: 'Stroke-245', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('path', { d: 'M1380.8606,153.2045 L1368.5316,152.4305', id: 'Stroke-246', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-247', stroke: '#2DDD6F', points: '1367.3694 152.3764 1358.2894 151.6484 1349.4264 150.7704 1340.5574 149.7564 1331.6834 148.7434 1323.0224 147.4434 1314.3624 146.1404 1305.7034 144.8394 1297.2524 143.2504 1285.7504 141.0574 1274.7014 138.6934 1263.6424 136.1974 1252.8034 133.5524 1242.1814 130.7534 1231.7814 127.8024 1221.3754 124.7124 1211.1964 121.6094 1194.3774 116.2474 1178.2264 110.5674 1162.2984 104.7294 1146.8304 98.8614 1030.2124 51.1554 1016.1744 45.8684 1001.9154 40.7354 994.8004 38.3734 987.9244 36.1274 980.8314 34.0334 973.7554 32.2134 969.2704 31.0304 965.0274 29.9634 960.5524 28.9134 956.0884 28.0004 951.6234 27.0874 947.3994 26.2914 942.9434 25.5134 938.4994 24.8714 934.0534 24.2294 929.6174 23.7204 925.1824 23.2164 920.9864 22.8274 916.5694 22.5924 912.1534 22.3544 907.9674 22.1034 903.5604 22.0034 899.6254 22.0044 895.4574 22.0254 891.5214 22.0274 887.3634 22.1834 883.4374 22.3204 879.5204 22.5964 875.6024 22.8694 871.6854 23.1434 868.0084 23.5374 864.1004 23.9474 860.2024 24.4944 856.5364 25.0214 852.6374 25.5674 848.9704 26.0984 841.6544 27.4274 834.3484 28.8934 827.0414 30.3574 819.9854 32.0804 812.9284 33.7994 806.1124 35.6404 799.2954 37.4794 792.4894 39.4544 785.9214 41.5494 772.7874 45.7404 759.9044 50.1864 747.2604 54.7514 735.0754 59.2824 712.3134 68.1004 570.1314 126.8404 537.4794 139.8934 521.4664 145.9184 513.5554 148.6514 505.6344 151.2534 497.9354 153.6984 490.2254 156.0104 482.2764 158.2044 478.4164 159.2894 474.5474 160.2434 470.6684 161.0594 466.7994 162.0114 462.9214 162.8284 459.0334 163.5094 455.1454 164.1904 451.4864 164.8544 447.5874 165.4004 443.6904 165.9474 440.4744 166.3084 437.0274 166.6864 433.8014 166.9124 430.3564 167.2894 427.1194 167.3794 423.8934 167.6054 420.4284 167.7124 417.1824 167.6664 413.7074 167.6374 410.4624 167.5914 407.2064 167.4104 403.9514 167.2274 400.4574 166.9294 397.1924 166.6114 393.9194 166.1604 390.6454 165.7104' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-248', stroke: '#2DDD6F', points: '389.9441 165.6225 386.4301 165.0495 383.1371 164.3275 381.2551 163.9125 379.3731 163.4995 377.4921 163.0895 375.6091 162.6725 373.7181 162.1245 371.8271 161.5745 369.9361 161.0255 368.0441 160.4765 364.4821 159.2275 360.6891 157.9935 357.1181 156.6095 353.3061 155.1055 349.7151 153.4485 346.1231 151.7915 342.5231 150.0005 339.1431 148.0575 335.5341 146.1295 332.1441 144.0475 328.7451 141.8335 325.3351 139.4835 321.9271 137.1315 318.5091 134.6455 311.8931 129.5215 305.2681 124.2625 267.9821 91.5785 261.5991 86.4395 255.2311 81.5705 252.0541 79.2025 248.8851 76.9715 245.7361 75.0115 244.0361 73.9025 242.3561 73.0665 240.6671 72.0965 238.9861 71.2615 237.5361 70.4065 235.8641 69.7065 234.9141 69.3645 234.1941 69.0065 233.2441 68.6625 232.5251 68.3055 231.5821 68.0975 230.8631 67.7405 230.1521 67.5175 229.2121 67.3105 228.4921 66.9535 227.5601 66.8815 226.8491 66.6585 225.9091 66.4525 225.2081 66.3635 224.7361 66.2605 224.2681 66.1585 224.0361 66.1745 223.5661 66.0725 223.0951 65.9675 222.8651 65.9835 222.3941 65.8805 221.9341 65.9125 221.4631 65.8095 221.0021 65.8425 220.5421 65.8745 220.0711 65.7705 219.6101 65.8015 219.1491 65.8345 218.6881 65.8655 218.2271 65.8985 217.7671 65.9315 217.3051 65.9635 217.0761 65.9795 216.6151 66.0135 216.1541 66.0425 215.6921 66.0755 215.2331 66.1075 214.7811 66.2775 214.3201 66.3095 214.0901 66.3255 213.6381 66.4945 213.1771 66.5265 212.7181 66.5575 212.2651 66.7265 212.0361 66.7425 211.5841 66.9095 211.1321 67.0765 210.6721 67.1095 210.2201 67.2765 210.0001 67.4305 209.5491 67.5995 209.0881 67.6305 208.4151 67.9495 207.7441 68.2685 206.8411 68.6045 206.1701 68.9245 205.4961 69.2425 204.8251 69.5635 204.1531 69.8825 203.4811 70.2035 202.8181 70.6575 202.1471 70.9765 201.4841 71.4325 200.8221 71.8885 200.1591 72.3425 199.4871 72.6635 198.1621 73.5725 196.8471 74.6175 195.7531 75.5155 194.4371 76.5595 193.3531 77.5895 192.2681 78.6195 190.9621 79.8005 188.8021 81.9965 186.6531 84.3265 184.5121 86.7925 182.5921 89.1085 180.6811 91.5585 178.3481 94.5845 176.0251 97.7445' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-249', stroke: '#2DDD6F', points: '1970.7083 0.4311 1782.5493 73.7021 1750.9443 85.1831 1719.3093 96.2551' }),
	                        _react2.default.createElement('path', { d: 'M1710.0334,99.3578 L1700.7624,102.4608', id: 'Stroke-250', stroke: '#2DDD6F' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-251', stroke: '#2DDD6F', points: '1698.2747 103.3168 1677.4497 110.0868 1656.8317 116.4378 1636.6397 122.3468 1616.6387 127.7018 1602.7567 131.1268 1589.0977 134.3988 1575.1837 137.4178 1561.4927 140.2838 1547.7717 142.7438 1534.2747 145.0488 1520.5267 147.1018 1506.9997 149.0058 1495.7367 150.2018 1484.7047 151.3838 1473.6537 152.2918 1462.5947 153.0668 1451.5157 153.5708 1440.6677 154.0568 1429.7977 154.2758 1419.1397 154.2008' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-252', stroke: '#2DDD6F', points: '1401.7532 153.9223 1389.2142 153.4353 1376.6542 152.6803 1364.3092 151.6373 1352.1722 150.3073 1340.2682 148.9593 1328.5622 147.1893 1316.8492 145.2853 1305.1272 143.2433 1293.8562 141.0333 1282.7942 138.5383 1271.7252 135.9063 1260.8862 133.2583 1250.2552 130.3253 1239.8562 127.3693 1229.4392 124.1483 1219.2532 120.9103 1202.4122 115.2763 1186.2532 109.4573 1170.3152 103.4853 1154.8282 97.3493 1038.3042 47.7273 1024.2472 42.1703 1010.2092 36.8833 1003.0852 34.3853 995.9712 32.0203 988.8672 29.7933 981.7812 27.8363 977.2972 26.6523 973.0442 25.4513 968.5692 24.3993 964.0942 23.3523 959.6312 22.4383 955.1662 21.5253 950.7102 20.7453 946.4962 20.0863 942.0512 19.4433 937.6042 18.8013 933.1692 18.2933 928.7432 17.9233 924.3182 17.5533 920.1322 17.3003 915.7152 17.0633 911.3082 16.9633 907.1322 16.8473 903.1942 16.8503 899.0382 17.0023 895.1102 17.1423 891.1842 17.2803 887.2672 17.5553 883.3502 17.8303 879.4342 18.1053 875.5242 18.5133 871.6162 18.9243 867.9502 19.4533 864.0532 19.9983 860.3852 20.5283 856.4872 21.0743 852.8292 21.7393 849.1702 22.4043 841.8642 23.8683 834.5692 25.4723 827.5122 27.1913 820.4662 29.0483 813.4172 30.9033 806.6112 32.8793 800.0442 34.9743 793.4772 37.0683 780.3542 41.3963 767.2492 45.9913 754.8442 50.6763 742.4502 55.4963 719.9372 64.5673 578.3882 125.7173 545.7742 139.3093 529.7712 145.4753 522.1092 148.4633 514.1972 151.1993 508.3132 153.1073 502.4282 155.0213 496.7632 156.7793 490.8692 158.5553 485.1862 160.0433 479.2712 161.5463 473.5792 162.9003 467.8752 164.1183' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-253', stroke: '#2DDD6F', points: '467.6447 164.1342 463.7557 164.8142 459.8677 165.4942 455.9797 166.1762 452.0817 166.7232 448.8657 167.0842 445.4287 167.5952 442.2037 167.8222 438.7557 168.1972 435.5207 168.2892 432.0637 168.5322 428.8277 168.6212 425.5917 168.7132 422.1177 168.6852 418.8627 168.5022 415.6167 168.4592 412.1327 168.2922 408.8687 167.9752 405.6037 167.6592 402.3307 167.2072 398.8247 166.7722' }),
	                        _react2.default.createElement('polyline', { id: 'Stroke-254', stroke: '#2DDD6F', points: '398.1233 166.6859 394.8313 165.9609 391.3163 165.3879 389.4343 164.9739 387.5543 164.5629 385.6623 164.0139 383.7813 163.6009 381.8893 163.0509 379.9973 162.5019 378.1053 161.9539 376.2143 161.4049 374.3213 160.8559 372.6513 160.1539 368.8603 158.9209 365.2793 157.3999 361.4663 155.8959 357.8753 154.2399 354.2743 152.4479 350.6743 150.6539 347.0643 148.7279 343.6753 146.6479 340.2743 144.4329 336.8763 142.2189 333.4773 140.0019 330.0593 137.5149 326.6413 135.0329 320.0063 129.6349 313.3723 124.2409 275.7893 90.6229 269.3843 85.2129 263.0083 80.2059 259.8213 77.7059 256.6523 75.4729 253.2623 73.3949 251.5633 72.2879 250.1033 71.2979 248.4143 70.3269 246.7343 69.4909 245.0533 68.6549 243.3733 67.8179 242.4223 67.4749 241.7033 67.1189 240.7513 66.7739 240.0323 66.4169 239.0813 66.0749 238.3703 65.8529 237.4213 65.5089 236.7093 65.2859 235.7693 65.0799 235.0593 64.8569 234.1163 64.6509 233.4063 64.4279 232.9363 64.3239 232.4673 64.2209 232.2363 64.2379 231.7653 64.1339 231.2933 64.0289 230.8333 64.0629 230.5933 63.9439 230.1333 63.9749 229.6623 63.8719 229.1923 63.7679 228.7303 63.8009 228.2703 63.8319 227.8003 63.7289 227.3393 63.7629 226.8783 63.7929 226.4073 63.6919 225.9473 63.7239 225.4863 63.7559 225.0253 63.7889 224.5643 63.8209 224.1033 63.8539 223.6423 63.8859 223.4123 63.9029 222.9603 64.0669 222.4993 64.0999 222.0383 64.1329 221.5893 64.3009 221.1263 64.3329 220.6653 64.3659 220.4453 64.5169 219.9843 64.5489 219.5333 64.7179 219.0733 64.7489 218.6213 64.9169 218.1693 65.0849 217.9403 65.1019 217.4893 65.2709 217.0383 65.4379 216.5863 65.6069 216.3643 65.7579 215.6823 65.9409 215.2323 66.1079 214.5513 66.2939 214.1093 66.5959 213.4283 66.7819 212.9863 67.0829 212.5433 67.3879 211.8623 67.5719 211.4213 67.8739 210.9793 68.1789 209.8663 68.8019 208.9823 69.4089 207.8693 70.0319 207.2063 70.4849 206.5453 70.9419 205.2193 71.8519 203.9043 72.8969 202.8193 73.9289 201.5033 74.9749 200.4193 76.0029 199.1033 77.0489 198.0283 78.2149 195.8773 80.5479 193.7383 83.0139 191.5973 85.4789 189.6863 87.9299 187.7863 90.5159 184.8193 94.4019 182.0933 98.4109 176.6693 106.8289' })
	                    ),
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Group', transform: 'translate(640.000000, 117.000000)', fill: '#1F1F1F' },
	                        _react2.default.createElement('circle', { id: 'Oval', stroke: '#2DDD6F', strokeWidth: '3', opacity: '0.200000003', cx: '7.5', cy: '7.5', r: '9' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy', stroke: '#FFFFFF', strokeWidth: '2', cx: '7.5', cy: '7.5', r: '5.5' })
	                    ),
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Group', transform: 'translate(805.000000, 143.000000)', fill: '#1F1F1F' },
	                        _react2.default.createElement('circle', { id: 'Oval', stroke: '#2DDD6F', strokeWidth: '3', opacity: '0.200000003', cx: '7.5', cy: '7.5', r: '9' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy', stroke: '#FFFFFF', strokeWidth: '2', cx: '7.5', cy: '7.5', r: '5.5' })
	                    ),
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Group', transform: 'translate(418.000000, 201.000000)', fill: '#1F1F1F' },
	                        _react2.default.createElement('circle', { id: 'Oval', stroke: '#2DDD6F', strokeWidth: '3', opacity: '0.200000003', cx: '7.5', cy: '7.5', r: '9' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy', stroke: '#FFFFFF', strokeWidth: '2', cx: '7.5', cy: '7.5', r: '5.5' })
	                    ),
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Group', transform: 'translate(1509.000000, 102.000000)', fill: '#1F1F1F' },
	                        _react2.default.createElement('circle', { id: 'Oval', stroke: '#2DDD6F', strokeWidth: '3', opacity: '0.200000003', cx: '7.5', cy: '7.5', r: '9' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy', stroke: '#FFFFFF', strokeWidth: '2', cx: '7.5', cy: '7.5', r: '5.5' })
	                    ),
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Group', transform: 'translate(1731.000000, 151.000000)', fill: '#1F1F1F' },
	                        _react2.default.createElement('circle', { id: 'Oval', stroke: '#2DDD6F', strokeWidth: '3', opacity: '0.200000003', cx: '7.5', cy: '7.5', r: '9' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy', stroke: '#FFFFFF', strokeWidth: '2', cx: '7.5', cy: '7.5', r: '5.5' })
	                    ),
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Group', transform: 'translate(1211.000000, 102.000000)', fill: '#1F1F1F' },
	                        _react2.default.createElement('circle', { id: 'Oval', stroke: '#2DDD6F', strokeWidth: '3', opacity: '0.200000003', cx: '7.5', cy: '7.5', r: '9' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy', stroke: '#FFFFFF', strokeWidth: '2', cx: '7.5', cy: '7.5', r: '5.5' })
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 74 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 75 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(409);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_URL":""}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(599);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(613);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ForeignObjectRenderer = __webpack_require__(199);
	
	var testRangeBounds = function testRangeBounds(document) {
	    var TEST_HEIGHT = 123;
	
	    if (document.createRange) {
	        var range = document.createRange();
	        if (range.getBoundingClientRect) {
	            var testElement = document.createElement('boundtest');
	            testElement.style.height = TEST_HEIGHT + 'px';
	            testElement.style.display = 'block';
	            document.body.appendChild(testElement);
	
	            range.selectNode(testElement);
	            var rangeBounds = range.getBoundingClientRect();
	            var rangeHeight = Math.round(rangeBounds.height);
	            document.body.removeChild(testElement);
	            if (rangeHeight === TEST_HEIGHT) {
	                return true;
	            }
	        }
	    }
	
	    return false;
	};
	
	// iOS 10.3 taints canvas with base64 images unless crossOrigin = 'anonymous'
	var testBase64 = function testBase64(document, src) {
	    var img = new Image();
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	
	    return new Promise(function (resolve) {
	        // Single pixel base64 image renders fine on iOS 10.3???
	        img.src = src;
	
	        var onload = function onload() {
	            try {
	                ctx.drawImage(img, 0, 0);
	                canvas.toDataURL();
	            } catch (e) {
	                return resolve(false);
	            }
	
	            return resolve(true);
	        };
	
	        img.onload = onload;
	        img.onerror = function () {
	            return resolve(false);
	        };
	
	        if (img.complete === true) {
	            setTimeout(function () {
	                onload();
	            }, 500);
	        }
	    });
	};
	
	var testCORS = function testCORS() {
	    return typeof new Image().crossOrigin !== 'undefined';
	};
	
	var testResponseType = function testResponseType() {
	    return typeof new XMLHttpRequest().responseType === 'string';
	};
	
	var testSVG = function testSVG(document) {
	    var img = new Image();
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	    img.src = 'data:image/svg+xml,<svg xmlns=\'http://www.w3.org/2000/svg\'></svg>';
	
	    try {
	        ctx.drawImage(img, 0, 0);
	        canvas.toDataURL();
	    } catch (e) {
	        return false;
	    }
	    return true;
	};
	
	var isGreenPixel = function isGreenPixel(data) {
	    return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
	};
	
	var testForeignObject = function testForeignObject(document) {
	    var canvas = document.createElement('canvas');
	    var size = 100;
	    canvas.width = size;
	    canvas.height = size;
	    var ctx = canvas.getContext('2d');
	    ctx.fillStyle = 'rgb(0, 255, 0)';
	    ctx.fillRect(0, 0, size, size);
	
	    var img = new Image();
	    var greenImageSrc = canvas.toDataURL();
	    img.src = greenImageSrc;
	    var svg = (0, _ForeignObjectRenderer.createForeignObjectSVG)(size, size, 0, 0, img);
	    ctx.fillStyle = 'red';
	    ctx.fillRect(0, 0, size, size);
	
	    return (0, _ForeignObjectRenderer.loadSerializedSVG)(svg).then(function (img) {
	        ctx.drawImage(img, 0, 0);
	        var data = ctx.getImageData(0, 0, size, size).data;
	        ctx.fillStyle = 'red';
	        ctx.fillRect(0, 0, size, size);
	
	        var node = document.createElement('div');
	        node.style.backgroundImage = 'url(' + greenImageSrc + ')';
	        node.style.height = size + 'px';
	        // Firefox 55 does not render inline <img /> tags
	        return isGreenPixel(data) ? (0, _ForeignObjectRenderer.loadSerializedSVG)((0, _ForeignObjectRenderer.createForeignObjectSVG)(size, size, 0, 0, node)) : Promise.reject(false);
	    }).then(function (img) {
	        ctx.drawImage(img, 0, 0);
	        // Edge does not render background-images
	        return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
	    }).catch(function (e) {
	        return false;
	    });
	};
	
	var FEATURES = {
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_RANGE_BOUNDS() {
	        'use strict';
	
	        var value = testRangeBounds(document);
	        Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_SVG_DRAWING() {
	        'use strict';
	
	        var value = testSVG(document);
	        Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_BASE64_DRAWING() {
	        'use strict';
	
	        return function (src) {
	            var _value = testBase64(document, src);
	            Object.defineProperty(FEATURES, 'SUPPORT_BASE64_DRAWING', { value: function value() {
	                    return _value;
	                } });
	            return _value;
	        };
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_FOREIGNOBJECT_DRAWING() {
	        'use strict';
	
	        var value = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
	        Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_CORS_IMAGES() {
	        'use strict';
	
	        var value = testCORS();
	        Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_RESPONSE_TYPE() {
	        'use strict';
	
	        var value = testResponseType();
	        Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_CORS_XHR() {
	        'use strict';
	
	        var value = 'withCredentials' in new XMLHttpRequest();
	        Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
	        return value;
	    }
	};
	
	exports.default = FEATURES;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _textTransform = __webpack_require__(197);
	
	var _TextBounds = __webpack_require__(192);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TextContainer = function () {
	    function TextContainer(text, parent, bounds) {
	        _classCallCheck(this, TextContainer);
	
	        this.text = text;
	        this.parent = parent;
	        this.bounds = bounds;
	    }
	
	    _createClass(TextContainer, null, [{
	        key: 'fromTextNode',
	        value: function fromTextNode(node, parent) {
	            var text = transform(node.data, parent.style.textTransform);
	            return new TextContainer(text, parent, (0, _TextBounds.parseTextBounds)(text, parent, node));
	        }
	    }]);
	
	    return TextContainer;
	}();
	
	exports.default = TextContainer;
	
	
	var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
	
	var transform = function transform(text, _transform) {
	    switch (_transform) {
	        case _textTransform.TEXT_TRANSFORM.LOWERCASE:
	            return text.toLowerCase();
	        case _textTransform.TEXT_TRANSFORM.CAPITALIZE:
	            return text.replace(CAPITALIZE, capitalize);
	        case _textTransform.TEXT_TRANSFORM.UPPERCASE:
	            return text.toUpperCase();
	        default:
	            return text;
	    }
	};
	
	function capitalize(m, p1, p2) {
	    if (m.length > 0) {
	        return p1 + p2.toUpperCase();
	    }
	
	    return m;
	}

/***/ },
/* 80 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var PATH = exports.PATH = {
	    VECTOR: 0,
	    BEZIER_CURVE: 1,
	    CIRCLE: 2
	};

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Path = __webpack_require__(80);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Vector = function Vector(x, y) {
	    _classCallCheck(this, Vector);
	
	    this.type = _Path.PATH.VECTOR;
	    this.x = x;
	    this.y = y;
	    if (false) {
	        if (isNaN(x)) {
	            console.error('Invalid x value given for Vector');
	        }
	        if (isNaN(y)) {
	            console.error('Invalid y value given for Vector');
	        }
	    }
	};
	
	exports.default = Vector;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseListStyle = exports.parseListStyleType = exports.LIST_STYLE_TYPE = exports.LIST_STYLE_POSITION = undefined;
	
	var _background = __webpack_require__(65);
	
	var LIST_STYLE_POSITION = exports.LIST_STYLE_POSITION = {
	    INSIDE: 0,
	    OUTSIDE: 1
	};
	
	var LIST_STYLE_TYPE = exports.LIST_STYLE_TYPE = {
	    NONE: -1,
	    DISC: 0,
	    CIRCLE: 1,
	    SQUARE: 2,
	    DECIMAL: 3,
	    CJK_DECIMAL: 4,
	    DECIMAL_LEADING_ZERO: 5,
	    LOWER_ROMAN: 6,
	    UPPER_ROMAN: 7,
	    LOWER_GREEK: 8,
	    LOWER_ALPHA: 9,
	    UPPER_ALPHA: 10,
	    ARABIC_INDIC: 11,
	    ARMENIAN: 12,
	    BENGALI: 13,
	    CAMBODIAN: 14,
	    CJK_EARTHLY_BRANCH: 15,
	    CJK_HEAVENLY_STEM: 16,
	    CJK_IDEOGRAPHIC: 17,
	    DEVANAGARI: 18,
	    ETHIOPIC_NUMERIC: 19,
	    GEORGIAN: 20,
	    GUJARATI: 21,
	    GURMUKHI: 22,
	    HEBREW: 22,
	    HIRAGANA: 23,
	    HIRAGANA_IROHA: 24,
	    JAPANESE_FORMAL: 25,
	    JAPANESE_INFORMAL: 26,
	    KANNADA: 27,
	    KATAKANA: 28,
	    KATAKANA_IROHA: 29,
	    KHMER: 30,
	    KOREAN_HANGUL_FORMAL: 31,
	    KOREAN_HANJA_FORMAL: 32,
	    KOREAN_HANJA_INFORMAL: 33,
	    LAO: 34,
	    LOWER_ARMENIAN: 35,
	    MALAYALAM: 36,
	    MONGOLIAN: 37,
	    MYANMAR: 38,
	    ORIYA: 39,
	    PERSIAN: 40,
	    SIMP_CHINESE_FORMAL: 41,
	    SIMP_CHINESE_INFORMAL: 42,
	    TAMIL: 43,
	    TELUGU: 44,
	    THAI: 45,
	    TIBETAN: 46,
	    TRAD_CHINESE_FORMAL: 47,
	    TRAD_CHINESE_INFORMAL: 48,
	    UPPER_ARMENIAN: 49,
	    DISCLOSURE_OPEN: 50,
	    DISCLOSURE_CLOSED: 51
	};
	
	var parseListStyleType = exports.parseListStyleType = function parseListStyleType(type) {
	    switch (type) {
	        case 'disc':
	            return LIST_STYLE_TYPE.DISC;
	        case 'circle':
	            return LIST_STYLE_TYPE.CIRCLE;
	        case 'square':
	            return LIST_STYLE_TYPE.SQUARE;
	        case 'decimal':
	            return LIST_STYLE_TYPE.DECIMAL;
	        case 'cjk-decimal':
	            return LIST_STYLE_TYPE.CJK_DECIMAL;
	        case 'decimal-leading-zero':
	            return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
	        case 'lower-roman':
	            return LIST_STYLE_TYPE.LOWER_ROMAN;
	        case 'upper-roman':
	            return LIST_STYLE_TYPE.UPPER_ROMAN;
	        case 'lower-greek':
	            return LIST_STYLE_TYPE.LOWER_GREEK;
	        case 'lower-alpha':
	            return LIST_STYLE_TYPE.LOWER_ALPHA;
	        case 'upper-alpha':
	            return LIST_STYLE_TYPE.UPPER_ALPHA;
	        case 'arabic-indic':
	            return LIST_STYLE_TYPE.ARABIC_INDIC;
	        case 'armenian':
	            return LIST_STYLE_TYPE.ARMENIAN;
	        case 'bengali':
	            return LIST_STYLE_TYPE.BENGALI;
	        case 'cambodian':
	            return LIST_STYLE_TYPE.CAMBODIAN;
	        case 'cjk-earthly-branch':
	            return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
	        case 'cjk-heavenly-stem':
	            return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
	        case 'cjk-ideographic':
	            return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
	        case 'devanagari':
	            return LIST_STYLE_TYPE.DEVANAGARI;
	        case 'ethiopic-numeric':
	            return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
	        case 'georgian':
	            return LIST_STYLE_TYPE.GEORGIAN;
	        case 'gujarati':
	            return LIST_STYLE_TYPE.GUJARATI;
	        case 'gurmukhi':
	            return LIST_STYLE_TYPE.GURMUKHI;
	        case 'hebrew':
	            return LIST_STYLE_TYPE.HEBREW;
	        case 'hiragana':
	            return LIST_STYLE_TYPE.HIRAGANA;
	        case 'hiragana-iroha':
	            return LIST_STYLE_TYPE.HIRAGANA_IROHA;
	        case 'japanese-formal':
	            return LIST_STYLE_TYPE.JAPANESE_FORMAL;
	        case 'japanese-informal':
	            return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
	        case 'kannada':
	            return LIST_STYLE_TYPE.KANNADA;
	        case 'katakana':
	            return LIST_STYLE_TYPE.KATAKANA;
	        case 'katakana-iroha':
	            return LIST_STYLE_TYPE.KATAKANA_IROHA;
	        case 'khmer':
	            return LIST_STYLE_TYPE.KHMER;
	        case 'korean-hangul-formal':
	            return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
	        case 'korean-hanja-formal':
	            return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
	        case 'korean-hanja-informal':
	            return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
	        case 'lao':
	            return LIST_STYLE_TYPE.LAO;
	        case 'lower-armenian':
	            return LIST_STYLE_TYPE.LOWER_ARMENIAN;
	        case 'malayalam':
	            return LIST_STYLE_TYPE.MALAYALAM;
	        case 'mongolian':
	            return LIST_STYLE_TYPE.MONGOLIAN;
	        case 'myanmar':
	            return LIST_STYLE_TYPE.MYANMAR;
	        case 'oriya':
	            return LIST_STYLE_TYPE.ORIYA;
	        case 'persian':
	            return LIST_STYLE_TYPE.PERSIAN;
	        case 'simp-chinese-formal':
	            return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
	        case 'simp-chinese-informal':
	            return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
	        case 'tamil':
	            return LIST_STYLE_TYPE.TAMIL;
	        case 'telugu':
	            return LIST_STYLE_TYPE.TELUGU;
	        case 'thai':
	            return LIST_STYLE_TYPE.THAI;
	        case 'tibetan':
	            return LIST_STYLE_TYPE.TIBETAN;
	        case 'trad-chinese-formal':
	            return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
	        case 'trad-chinese-informal':
	            return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
	        case 'upper-armenian':
	            return LIST_STYLE_TYPE.UPPER_ARMENIAN;
	        case 'disclosure-open':
	            return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
	        case 'disclosure-closed':
	            return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
	        case 'none':
	        default:
	            return LIST_STYLE_TYPE.NONE;
	    }
	};
	
	var parseListStyle = exports.parseListStyle = function parseListStyle(style) {
	    var listStyleImage = (0, _background.parseBackgroundImage)(style.getPropertyValue('list-style-image'));
	    return {
	        listStyleType: parseListStyleType(style.getPropertyValue('list-style-type')),
	        listStyleImage: listStyleImage.length ? listStyleImage[0] : null,
	        listStylePosition: parseListStylePosition(style.getPropertyValue('list-style-position'))
	    };
	};
	
	var parseListStylePosition = function parseListStylePosition(position) {
	    switch (position) {
	        case 'inside':
	            return LIST_STYLE_POSITION.INSIDE;
	        case 'outside':
	        default:
	            return LIST_STYLE_POSITION.OUTSIDE;
	    }
	};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCorners = exports.offset = exports.isEqual = exports.addPosition = exports.add = undefined;
	
	var _extends2 = __webpack_require__(36);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var add = exports.add = function add(spacing1, spacing2) {
	  return {
	    top: spacing1.top + spacing2.top,
	    left: spacing1.left + spacing2.left,
	    right: spacing1.right + spacing2.right,
	    bottom: spacing1.bottom + spacing2.bottom
	  };
	};
	
	var addPosition = exports.addPosition = function addPosition(spacing, position) {
	  return (0, _extends3.default)({}, spacing, {
	    right: spacing.right + position.x,
	    bottom: spacing.bottom + position.y
	  });
	};
	
	var isEqual = exports.isEqual = function isEqual(spacing1, spacing2) {
	  return spacing1.top === spacing2.top && spacing1.right === spacing2.right && spacing1.bottom === spacing2.bottom && spacing1.left === spacing2.left;
	};
	
	var offset = exports.offset = function offset(spacing, position) {
	  return {
	    top: spacing.top + position.y,
	    right: spacing.right + position.x,
	    bottom: spacing.bottom + position.y,
	    left: spacing.left + position.x
	  };
	};
	
	var getCorners = exports.getCorners = function getCorners(spacing) {
	  return [{ x: spacing.left, y: spacing.top }, { x: spacing.right, y: spacing.top }, { x: spacing.left, y: spacing.bottom }, { x: spacing.right, y: spacing.bottom }];
	};

/***/ },
/* 84 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (event) {
	  event.preventDefault();
	  event.stopPropagation();
	};

/***/ },
/* 85 */
/***/ function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(548);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(87);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _defaultArrowRenderer = __webpack_require__(235);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(236);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(145);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(146);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(233);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(234);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
				var pref = document.addEventListener ? '' : 'on';
	
				document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
				document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false,
							focusedOption: null
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen,
						focusedOption: null
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (!this.props.closeOnSelect) {
					return;
				}
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value,
								values: valueArray
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'div',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(16);
	var normalizeHeaderName = __webpack_require__(265);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(149);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(149);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deleteRiderRequest = exports.fulfillRiderRequest = exports.createRiderRequest = exports.DELETE_RIDER_REQUEST = exports.FULFILL_RIDER_REQUEST = exports.CREATE_RIDER_REQUEST = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _alerts = __webpack_require__(13);
	
	var _modal = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { fetchDashboard } from './dashboard'
	
	var CREATE_RIDER_REQUEST = exports.CREATE_RIDER_REQUEST = (0, _reduxActions.createAction)('CREATE_RIDER_REQUEST');
	var FULFILL_RIDER_REQUEST = exports.FULFILL_RIDER_REQUEST = (0, _reduxActions.createAction)('FULFILL_RIDER_REQUEST');
	var DELETE_RIDER_REQUEST = exports.DELETE_RIDER_REQUEST = (0, _reduxActions.createAction)('DELETE_RIDER_REQUEST');
	
	var createRiderRequest = exports.createRiderRequest = function createRiderRequest(eventId, request) {
	  return function (dispatch) {
	    dispatch((0, _modal.clearModal)());
	
	    return _Api2.default.createRiderRequest(eventId, request).then(function (response) {
	      dispatch(CREATE_RIDER_REQUEST({ data: response.data }));
	      dispatch((0, _alerts.setAlert)('We have successfully sent out rider request', undefined, 'success'));
	    }).catch(function (error) {
	      return dispatch((0, _alerts.setAlert)('Sorry, we were unable to create this rider.', undefined, 'error'));
	    });
	  };
	};
	
	var fulfillRiderRequest = exports.fulfillRiderRequest = function fulfillRiderRequest(requestId, riderId) {
	  return function (dispatch) {
	    dispatch((0, _modal.clearModal)());
	
	    return _Api2.default.fulfillRiderRequest(requestId, riderId).then(function (response) {
	      dispatch(FULFILL_RIDER_REQUEST({ data: response.data }));
	      // dispatch(fetchDashboard()) // TODO: Enable when createdEventId is disabled
	    }).catch(function (error) {
	      return dispatch((0, _alerts.setAlert)('Sorry, we were unable to create this rider.', undefined, 'error'));
	    });
	  };
	};
	
	var deleteRiderRequest = exports.deleteRiderRequest = function deleteRiderRequest(requestId) {
	  return function (dispatch) {
	    dispatch((0, _modal.clearModal)());
	
	    return dispatch(DELETE_RIDER_REQUEST(_Api2.default.deleteRiderRequest(requestId)));
	  };
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deleteEventStage = exports.deleteEvent = exports.editEvent = exports.createEvent = exports.fetchEvent = exports.DELETE_EVENT_STAGE = exports.DELETE_EVENT = exports.EDIT_EVENT = exports.CREATE_EVENT = exports.RECEIVE_EVENT = exports.REQUEST_EVENT = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _alerts = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUEST_EVENT = exports.REQUEST_EVENT = (0, _reduxActions.createAction)('REQUEST_EVENT');
	var RECEIVE_EVENT = exports.RECEIVE_EVENT = (0, _reduxActions.createAction)('RECEIVE_EVENT');
	var CREATE_EVENT = exports.CREATE_EVENT = (0, _reduxActions.createAction)('CREATE_EVENT');
	var EDIT_EVENT = exports.EDIT_EVENT = (0, _reduxActions.createAction)('EDIT_EVENT');
	var DELETE_EVENT = exports.DELETE_EVENT = (0, _reduxActions.createAction)('DELETE_EVENT');
	var DELETE_EVENT_STAGE = exports.DELETE_EVENT_STAGE = (0, _reduxActions.createAction)('DELETE_EVENT_STAGE');
	
	var fetchEvent = exports.fetchEvent = function fetchEvent(id) {
	  return function (dispatch) {
	    dispatch(REQUEST_EVENT());
	
	    return _Api2.default.viewEvent(id).then(function (response) {
	      return dispatch(RECEIVE_EVENT({ data: response.data }));
	    }).catch(function (error) {
	      dispatch(RECEIVE_EVENT(error.response));
	      dispatch((0, _alerts.setAlert)(error.response.data.message, undefined, 'error'));
	    });
	  };
	};
	
	var createEvent = exports.createEvent = function createEvent(event) {
	  return function (dispatch) {
	    return dispatch(CREATE_EVENT(_Api2.default.createEvent(event)));
	  };
	};
	
	var editEvent = exports.editEvent = function editEvent(eventId, data) {
	  return function (dispatch) {
	    return dispatch(EDIT_EVENT(_Api2.default.editEvent(eventId, data)));
	  };
	};
	
	var deleteEvent = exports.deleteEvent = function deleteEvent(eventId) {
	  return function (dispatch) {
	    return dispatch(DELETE_EVENT(_Api2.default.deleteEvent(eventId)));
	  };
	};
	
	var deleteEventStage = exports.deleteEventStage = function deleteEventStage(stageId) {
	  return function (dispatch) {
	    return dispatch(DELETE_EVENT_STAGE(_Api2.default.deleteEventStage(stageId)));
	  };
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deleteRiderItemGroup = exports.deleteRiderItem = exports.moveRiderItem = exports.editRiderItem = exports.cloneRiderItem = exports.createRiderItems = exports.createRiderItem = exports.removeRiderItem = exports.addRiderItem = exports.DELETE_RIDER_ITEM_GROUP = exports.DELETE_RIDER_ITEM = exports.MOVE_RIDER_ITEM = exports.EDIT_RIDER_ITEM = exports.CLONE_RIDER_ITEM = exports.CREATE_RIDER_ITEMS = exports.CREATE_RIDER_ITEM = exports.REMOVE_RIDER_ITEM = exports.ADD_RIDER_ITEM = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _alerts = __webpack_require__(13);
	
	var _rider = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_RIDER_ITEM = exports.ADD_RIDER_ITEM = (0, _reduxActions.createAction)('ADD_RIDER_ITEM', function (item) {
	  return item;
	});
	var REMOVE_RIDER_ITEM = exports.REMOVE_RIDER_ITEM = (0, _reduxActions.createAction)('REMOVE_RIDER_ITEM', function (item) {
	  return item;
	});
	var CREATE_RIDER_ITEM = exports.CREATE_RIDER_ITEM = (0, _reduxActions.createAction)('CREATE_RIDER_ITEM', function (item) {
	  return item;
	});
	var CREATE_RIDER_ITEMS = exports.CREATE_RIDER_ITEMS = (0, _reduxActions.createAction)('CREATE_RIDER_ITEMS', function (item) {
	  return item;
	});
	var CLONE_RIDER_ITEM = exports.CLONE_RIDER_ITEM = (0, _reduxActions.createAction)('CLONE_RIDER_ITEM', function (item) {
	  return item;
	});
	var EDIT_RIDER_ITEM = exports.EDIT_RIDER_ITEM = (0, _reduxActions.createAction)('EDIT_RIDER_ITEM', function (item) {
	  return item;
	});
	var MOVE_RIDER_ITEM = exports.MOVE_RIDER_ITEM = (0, _reduxActions.createAction)('MOVE_RIDER_ITEM', function (item) {
	  return item;
	});
	var DELETE_RIDER_ITEM = exports.DELETE_RIDER_ITEM = (0, _reduxActions.createAction)('DELETE_RIDER_ITEM', function (item) {
	  return item;
	});
	var DELETE_RIDER_ITEM_GROUP = exports.DELETE_RIDER_ITEM_GROUP = (0, _reduxActions.createAction)('DELETE_RIDER_ITEM_GROUP', function (item) {
	  return item;
	});
	
	var addRiderItem = exports.addRiderItem = function addRiderItem(item) {
	  return function (dispatch) {
	    return dispatch(ADD_RIDER_ITEM({ item: item }));
	  };
	};
	
	var removeRiderItem = exports.removeRiderItem = function removeRiderItem(item) {
	  return function (dispatch) {
	    return dispatch(REMOVE_RIDER_ITEM({ item: item }));
	  };
	};
	
	var createRiderItem = exports.createRiderItem = function createRiderItem(riderId, item) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return _Api2.default.createRiderItem(riderId, item).then(function (response) {
	      return dispatch(CREATE_RIDER_ITEM({ data: response.data }));
	    }).catch(function (error) {
	      return dispatch((0, _alerts.setAlert)('Sorry, we were unable to process your request at this time.', undefined, 'error'));
	    });
	  };
	};
	
	var createRiderItems = exports.createRiderItems = function createRiderItems(riderId, parent, items) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return _Api2.default.createRiderItems(riderId, parent, items).then(function (response) {
	      return dispatch(CREATE_RIDER_ITEMS({ data: response.data }));
	    }).catch(function (error) {
	      return dispatch((0, _alerts.setAlert)('Sorry, we were unable to process your request at this time.', undefined, 'error'));
	    });
	  };
	};
	
	var cloneRiderItem = exports.cloneRiderItem = function cloneRiderItem(riderId, parent, item) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return _Api2.default.cloneRiderItem(riderId, parent, item).then(function (response) {
	      return dispatch(CLONE_RIDER_ITEM({ data: response.data }));
	    }).catch(function (error) {
	      return dispatch((0, _alerts.setAlert)('Sorry, we were unable to process your request at this time.', undefined, 'error'));
	    });
	  };
	};
	
	var editRiderItem = exports.editRiderItem = function editRiderItem(riderId, item) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return _Api2.default.editRiderItem(item).then(function (response) {
	      return dispatch(EDIT_RIDER_ITEM({ data: response.data }));
	    }).catch(function (error) {
	      return dispatch((0, _alerts.setAlert)('Sorry, we were unable to process your request at this time.', undefined, 'error'));
	    });
	  };
	};
	
	var moveRiderItem = exports.moveRiderItem = function moveRiderItem(id, position) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(MOVE_RIDER_ITEM(_Api2.default.moveRiderItem(id, position)));
	  };
	};
	
	var deleteRiderItem = exports.deleteRiderItem = function deleteRiderItem(id) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(DELETE_RIDER_ITEM(_Api2.default.deleteRiderItem(id)));
	  };
	};
	
	var deleteRiderItemGroup = exports.deleteRiderItemGroup = function deleteRiderItemGroup(item) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    var children = item.children;
	
	
	    children.forEach(function (child, index) {
	      if (child.class === 'monitor') {
	        _Api2.default.editRiderItem({
	          id: child.id,
	          value: item.value || null,
	          member: item.member && item.member.id || null,
	          parent: null
	        }).then(function (response) {
	          dispatch(EDIT_RIDER_ITEM({ data: response.data }));
	
	          if (index === children.length - 1) dispatch(DELETE_RIDER_ITEM(_Api2.default.deleteRiderItem(item.id)));
	        }).catch(function (error) {
	          return dispatch((0, _alerts.setAlert)('Sorry, we were unable to process your request at this time.', undefined, 'error'));
	        });
	      }
	    });
	  };
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deleteRiderStageplan = exports.viewRiderStageplan = exports.editRiderStageplan = exports.createRiderStageplan = exports.DELETE_RIDER_STAGEPLAN = exports.VIEW_RIDER_STAGEPLAN = exports.EDIT_RIDER_STAGEPLAN = exports.CREATE_RIDER_STAGEPLAN = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _rider = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CREATE_RIDER_STAGEPLAN = exports.CREATE_RIDER_STAGEPLAN = (0, _reduxActions.createAction)('CREATE_RIDER_STAGEPLAN');
	var EDIT_RIDER_STAGEPLAN = exports.EDIT_RIDER_STAGEPLAN = (0, _reduxActions.createAction)('EDIT_RIDER_STAGEPLAN');
	var VIEW_RIDER_STAGEPLAN = exports.VIEW_RIDER_STAGEPLAN = (0, _reduxActions.createAction)('VIEW_RIDER_STAGEPLAN');
	var DELETE_RIDER_STAGEPLAN = exports.DELETE_RIDER_STAGEPLAN = (0, _reduxActions.createAction)('DELETE_RIDER_STAGEPLAN');
	
	var createRiderStageplan = exports.createRiderStageplan = function createRiderStageplan(riderId, stageplan) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(CREATE_RIDER_STAGEPLAN(_Api2.default.createRiderStageplan(riderId, stageplan)));
	  };
	};
	
	var editRiderStageplan = exports.editRiderStageplan = function editRiderStageplan(stageplan) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(EDIT_RIDER_STAGEPLAN(_Api2.default.editRiderStageplan(stageplan)));
	  };
	};
	
	var viewRiderStageplan = exports.viewRiderStageplan = function viewRiderStageplan(stageplanId) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(VIEW_RIDER_STAGEPLAN(_Api2.default.viewRiderStageplan(stageplanId)));
	  };
	};
	
	var deleteRiderStageplan = exports.deleteRiderStageplan = function deleteRiderStageplan(stageplanId) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(DELETE_RIDER_STAGEPLAN(_Api2.default.deleteRiderStageplan(stageplanId)));
	  };
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _alerts = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFound = function NotFound(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'not-found' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Not Found'
	    ),
	    _react2.default.createElement(
	      _reactRouterDom.NavLink,
	      { to: '/library', onClick: function onClick() {
	          return props.clearAllAlerts();
	        } },
	      '\u2190 Home'
	    )
	  );
	};
	
	NotFound.propTypes = {
	  object: _propTypes2.default.object
	};
	
	NotFound.defaultProps = {
	  object: {}
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    clearAllAlerts: _alerts.clearAllAlerts
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(NotFound);

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Restricted = function Restricted(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'ui-restricted', onClick: function onClick() {
	        return props.setModal('LoginModal');
	      } },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Please ',
	      _react2.default.createElement(
	        'a',
	        null,
	        'log in'
	      ),
	      ' to view ',
	      props.section
	    )
	  );
	};
	
	Restricted.propTypes = {
	  section: _propTypes2.default.string,
	  setModal: _propTypes2.default.func
	};
	
	Restricted.defaultProps = {
	  section: '',
	  setModal: function setModal() {}
	};
	
	exports.default = Restricted;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _alert = __webpack_require__(270);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _alerts = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alerts = function (_Component) {
	  _inherits(Alerts, _Component);
	
	  function Alerts() {
	    _classCallCheck(this, Alerts);
	
	    return _possibleConstructorReturn(this, (Alerts.__proto__ || Object.getPrototypeOf(Alerts)).apply(this, arguments));
	  }
	
	  _createClass(Alerts, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var alerts = this.props.alerts;
	
	
	      if (alerts.length === 0) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'alerts' },
	        alerts.map(function (alert, index) {
	          return alert.status !== 'resolved' ? _react2.default.createElement(_alert2.default, { key: index,
	            alert: alert,
	            clearAlert: function clearAlert() {
	              return _this2.props.clearAlert(index);
	            } }) : null;
	        })
	      );
	    }
	  }]);
	
	  return Alerts;
	}(_react.Component);
	
	Alerts.propTypes = {
	  alerts: _propTypes2.default.array
	};
	
	Alerts.defaultProps = {
	  alerts: []
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    alerts: state.alerts
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    clearAlert: _alerts.clearAlert
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Alerts);

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _userSession = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Register = function (_Component) {
	  _inherits(Register, _Component);
	
	  function Register(props) {
	    _classCallCheck(this, Register);
	
	    var _this = _possibleConstructorReturn(this, (Register.__proto__ || Object.getPrototypeOf(Register)).call(this, props));
	
	    _this.state = {
	      name: '',
	      email: '',
	      password: '',
	      isRegistering: false,
	      error: null
	    };
	
	    _this.name = _react2.default.createRef();
	    _this.email = _react2.default.createRef();
	    _this.password = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(Register, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var email = this.props.email;
	
	
	      if (email) this.setState({ email: email });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var email = this.state.email;
	
	
	      if (email && this.name.current) {
	        this.name.current.focus();
	      } else if (this.email.current) {
	        this.email.current.focus();
	      }
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      var requestCode = this.props.requestCode;
	      var _state = this.state,
	          name = _state.name,
	          email = _state.email,
	          password = _state.password,
	          isRegistering = _state.isRegistering;
	
	
	      if (!name || !email || !password) {
	        var credentials = 'credentials';
	        credentials = !name ? 'full name' : credentials;
	        credentials = !email ? 'email' : credentials;
	        credentials = !password ? 'password' : credentials;
	        credentials = !name && !email ? 'full name and email' : credentials;
	        credentials = !name && !password ? 'full name and password' : credentials;
	        credentials = !email && !password ? 'email and password' : credentials;
	        credentials = !name && !email && !password ? 'full name, email and password' : credentials;
	
	        this.setState({ error: 'Please enter your ' + credentials + '.' });
	      } else if (isRegistering === false) {
	        this.setState({ isRegistering: true, error: null }, function () {
	          return _this2.props.userRegister({ name: name, email: email, password: password }, requestCode);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          modal = _props.modal,
	          userSession = _props.userSession,
	          requestCode = _props.requestCode;
	      var _state2 = this.state,
	          name = _state2.name,
	          email = _state2.email,
	          password = _state2.password,
	          isRegistering = _state2.isRegistering,
	          error = _state2.error;
	
	
	      var className = (0, _classnames2.default)({
	        'register': true,
	        'register--modal': modal === true
	      });
	
	      var formClassName = (0, _classnames2.default)({
	        'valid': this.state.email && this.state.password
	      });
	
	      var buttonClassName = (0, _classnames2.default)({
	        'button--disabled': isRegistering,
	        'placeholder-loader': isRegistering,
	        'placeholder-loader--success': isRegistering
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        userSession.registration ? _react2.default.createElement(
	          'div',
	          { style: { textAlign: 'center' } },
	          _react2.default.createElement(
	            'p',
	            null,
	            'A verification email has just been sent over to ',
	            userSession.registration.email
	          )
	        ) : _react2.default.createElement(
	          'form',
	          { className: formClassName, onSubmit: this.onSubmit.bind(this) },
	          _react2.default.createElement(
	            'ul',
	            { className: 'group', 'data-error-msg': error },
	            _react2.default.createElement(
	              'h1',
	              { className: 'h1--default' },
	              'Sign up for Ridline account'
	            ),
	            _react2.default.createElement(
	              'li',
	              { 'data-title': 'Email' },
	              _react2.default.createElement('input', { ref: this.email,
	                type: 'email',
	                className: 'input--light',
	                value: email,
	                onChange: function onChange(e) {
	                  return _this3.setState({ email: e.target.value });
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'li',
	              { 'data-title': 'Full name' },
	              _react2.default.createElement('input', { ref: this.name,
	                type: 'text',
	                className: 'input--light',
	                value: name,
	                onChange: function onChange(e) {
	                  return _this3.setState({ name: e.target.value });
	                } })
	            ),
	            _react2.default.createElement(
	              'li',
	              { 'data-title': 'Password' },
	              _react2.default.createElement('input', { ref: this.password,
	                type: 'password',
	                className: 'input--light',
	                value: password,
	                onChange: function onChange(e) {
	                  return _this3.setState({ password: e.target.value });
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: buttonClassName, type: 'submit' },
	            'Register'
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/login' },
	            'Already a user? Log in instead'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Register;
	}(_react.Component);
	
	Register.propTypes = {
	  modal: _propTypes2.default.bool,
	  email: _propTypes2.default.string,
	  userSession: _propTypes2.default.object,
	  requestCode: _propTypes2.default.string,
	  userRegister: _propTypes2.default.func
	};
	
	Register.defaultProps = {
	  modal: false,
	  email: '',
	  userSession: {},
	  requestCode: undefined,
	  userRegister: function userRegister() {}
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    userSession: state.userSession
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    userRegister: _userSession.userRegister
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Register);

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(355);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(360);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(359);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 99 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(371);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 101 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 102 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 103 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(48);
	var dPs = __webpack_require__(386);
	var enumBugKeys = __webpack_require__(102);
	var IE_PROTO = __webpack_require__(107)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(171)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(377).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 105 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(30).f;
	var has = __webpack_require__(38);
	var TAG = __webpack_require__(22)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(108)('keys');
	var uid = __webpack_require__(75);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(29);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 109 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(51);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(29);
	var core = __webpack_require__(17);
	var LIBRARY = __webpack_require__(103);
	var wksExt = __webpack_require__(112);
	var defineProperty = __webpack_require__(30).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(22);


/***/ },
/* 113 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var toCodePoints = exports.toCodePoints = function toCodePoints(str) {
	    var codePoints = [];
	    var i = 0;
	    var length = str.length;
	    while (i < length) {
	        var value = str.charCodeAt(i++);
	        if (value >= 0xd800 && value <= 0xdbff && i < length) {
	            var extra = str.charCodeAt(i++);
	            if ((extra & 0xfc00) === 0xdc00) {
	                codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
	            } else {
	                codePoints.push(value);
	                i--;
	            }
	        } else {
	            codePoints.push(value);
	        }
	    }
	    return codePoints;
	};
	
	var fromCodePoint = exports.fromCodePoint = function fromCodePoint() {
	    if (String.fromCodePoint) {
	        return String.fromCodePoint.apply(String, arguments);
	    }
	
	    var length = arguments.length;
	    if (!length) {
	        return '';
	    }
	
	    var codeUnits = [];
	
	    var index = -1;
	    var result = '';
	    while (++index < length) {
	        var codePoint = arguments.length <= index ? undefined : arguments[index];
	        if (codePoint <= 0xffff) {
	            codeUnits.push(codePoint);
	        } else {
	            codePoint -= 0x10000;
	            codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
	        }
	        if (index + 1 === length || codeUnits.length > 0x4000) {
	            result += String.fromCharCode.apply(String, codeUnits);
	            codeUnits.length = 0;
	        }
	    }
	    return result;
	};
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	// Use a lookup table to find the index.
	var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
	for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	}
	
	var decode = exports.decode = function decode(base64) {
	    var bufferLength = base64.length * 0.75,
	        len = base64.length,
	        i = void 0,
	        p = 0,
	        encoded1 = void 0,
	        encoded2 = void 0,
	        encoded3 = void 0,
	        encoded4 = void 0;
	
	    if (base64[base64.length - 1] === '=') {
	        bufferLength--;
	        if (base64[base64.length - 2] === '=') {
	            bufferLength--;
	        }
	    }
	
	    var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
	    var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
	
	    for (i = 0; i < len; i += 4) {
	        encoded1 = lookup[base64.charCodeAt(i)];
	        encoded2 = lookup[base64.charCodeAt(i + 1)];
	        encoded3 = lookup[base64.charCodeAt(i + 2)];
	        encoded4 = lookup[base64.charCodeAt(i + 3)];
	
	        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
	        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
	        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
	    }
	
	    return buffer;
	};
	
	var polyUint16Array = exports.polyUint16Array = function polyUint16Array(buffer) {
	    var length = buffer.length;
	    var bytes = [];
	    for (var _i = 0; _i < length; _i += 2) {
	        bytes.push(buffer[_i + 1] << 8 | buffer[_i]);
	    }
	    return bytes;
	};
	
	var polyUint32Array = exports.polyUint32Array = function polyUint32Array(buffer) {
	    var length = buffer.length;
	    var bytes = [];
	    for (var _i2 = 0; _i2 < length; _i2 += 4) {
	        bytes.push(buffer[_i2 + 3] << 24 | buffer[_i2 + 2] << 16 | buffer[_i2 + 1] << 8 | buffer[_i2]);
	    }
	    return bytes;
	};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createCounterText = exports.inlineListItemElement = exports.getListOwner = undefined;
	
	var _Util = __webpack_require__(55);
	
	var _NodeContainer = __webpack_require__(54);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _TextContainer = __webpack_require__(79);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _listStyle = __webpack_require__(82);
	
	var _Unicode = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Margin between the enumeration and the list item content
	var MARGIN_RIGHT = 7;
	
	var ancestorTypes = ['OL', 'UL', 'MENU'];
	
	var getListOwner = exports.getListOwner = function getListOwner(container) {
	    var parent = container.parent;
	    if (!parent) {
	        return null;
	    }
	
	    do {
	        var isAncestor = ancestorTypes.indexOf(parent.tagName) !== -1;
	        if (isAncestor) {
	            return parent;
	        }
	        parent = parent.parent;
	    } while (parent);
	
	    return container.parent;
	};
	
	var inlineListItemElement = exports.inlineListItemElement = function inlineListItemElement(node, container, resourceLoader) {
	    var listStyle = container.style.listStyle;
	
	    if (!listStyle) {
	        return;
	    }
	
	    var style = node.ownerDocument.defaultView.getComputedStyle(node, null);
	    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
	    (0, _Util.copyCSSStyles)(style, wrapper);
	
	    wrapper.style.position = 'absolute';
	    wrapper.style.bottom = 'auto';
	    wrapper.style.display = 'block';
	    wrapper.style.letterSpacing = 'normal';
	
	    switch (listStyle.listStylePosition) {
	        case _listStyle.LIST_STYLE_POSITION.OUTSIDE:
	            wrapper.style.left = 'auto';
	            wrapper.style.right = node.ownerDocument.defaultView.innerWidth - container.bounds.left - container.style.margin[1].getAbsoluteValue(container.bounds.width) + MARGIN_RIGHT + 'px';
	            wrapper.style.textAlign = 'right';
	            break;
	        case _listStyle.LIST_STYLE_POSITION.INSIDE:
	            wrapper.style.left = container.bounds.left - container.style.margin[3].getAbsoluteValue(container.bounds.width) + 'px';
	            wrapper.style.right = 'auto';
	            wrapper.style.textAlign = 'left';
	            break;
	    }
	
	    var text = void 0;
	    var MARGIN_TOP = container.style.margin[0].getAbsoluteValue(container.bounds.width);
	    var styleImage = listStyle.listStyleImage;
	    if (styleImage) {
	        if (styleImage.method === 'url') {
	            var image = node.ownerDocument.createElement('img');
	            image.src = styleImage.args[0];
	            wrapper.style.top = container.bounds.top - MARGIN_TOP + 'px';
	            wrapper.style.width = 'auto';
	            wrapper.style.height = 'auto';
	            wrapper.appendChild(image);
	        } else {
	            var size = parseFloat(container.style.font.fontSize) * 0.5;
	            wrapper.style.top = container.bounds.top - MARGIN_TOP + container.bounds.height - 1.5 * size + 'px';
	            wrapper.style.width = size + 'px';
	            wrapper.style.height = size + 'px';
	            wrapper.style.backgroundImage = style.listStyleImage;
	        }
	    } else if (typeof container.listIndex === 'number') {
	        text = node.ownerDocument.createTextNode(createCounterText(container.listIndex, listStyle.listStyleType, true));
	        wrapper.appendChild(text);
	        wrapper.style.top = container.bounds.top - MARGIN_TOP + 'px';
	    }
	
	    // $FlowFixMe
	    var body = node.ownerDocument.body;
	    body.appendChild(wrapper);
	
	    if (text) {
	        container.childNodes.push(_TextContainer2.default.fromTextNode(text, container));
	        body.removeChild(wrapper);
	    } else {
	        // $FlowFixMe
	        container.childNodes.push(new _NodeContainer2.default(wrapper, container, resourceLoader, 0));
	    }
	};
	
	var ROMAN_UPPER = {
	    integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
	    values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
	};
	
	var ARMENIAN = {
	    integers: [9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
	    values: ['Ք', 'Փ', 'Ւ', 'Ց', 'Ր', 'Տ', 'Վ', 'Ս', 'Ռ', 'Ջ', 'Պ', 'Չ', 'Ո', 'Շ', 'Ն', 'Յ', 'Մ', 'Ճ', 'Ղ', 'Ձ', 'Հ', 'Կ', 'Ծ', 'Խ', 'Լ', 'Ի', 'Ժ', 'Թ', 'Ը', 'Է', 'Զ', 'Ե', 'Դ', 'Գ', 'Բ', 'Ա']
	};
	
	var HEBREW = {
	    integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
	    values: ['י׳', 'ט׳', 'ח׳', 'ז׳', 'ו׳', 'ה׳', 'ד׳', 'ג׳', 'ב׳', 'א׳', 'ת', 'ש', 'ר', 'ק', 'צ', 'פ', 'ע', 'ס', 'נ', 'מ', 'ל', 'כ', 'יט', 'יח', 'יז', 'טז', 'טו', 'י', 'ט', 'ח', 'ז', 'ו', 'ה', 'ד', 'ג', 'ב', 'א']
	};
	
	var GEORGIAN = {
	    integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
	    values: ['ჵ', 'ჰ', 'ჯ', 'ჴ', 'ხ', 'ჭ', 'წ', 'ძ', 'ც', 'ჩ', 'შ', 'ყ', 'ღ', 'ქ', 'ფ', 'ჳ', 'ტ', 'ს', 'რ', 'ჟ', 'პ', 'ო', 'ჲ', 'ნ', 'მ', 'ლ', 'კ', 'ი', 'თ', 'ჱ', 'ზ', 'ვ', 'ე', 'დ', 'გ', 'ბ', 'ა']
	};
	
	var createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {
	    if (value < min || value > max) {
	        return createCounterText(value, fallback, suffix.length > 0);
	    }
	
	    return symbols.integers.reduce(function (string, integer, index) {
	        while (value >= integer) {
	            value -= integer;
	            string += symbols.values[index];
	        }
	        return string;
	    }, '') + suffix;
	};
	
	var createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {
	    var string = '';
	
	    do {
	        if (!isNumeric) {
	            value--;
	        }
	        string = resolver(value) + string;
	        value /= codePointRangeLength;
	    } while (value * codePointRangeLength >= codePointRangeLength);
	
	    return string;
	};
	
	var createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
	    var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
	
	    return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
	        return (0, _Unicode.fromCodePoint)(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
	    }) + suffix);
	};
	
	var createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols) {
	    var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '. ';
	
	    var codePointRangeLength = symbols.length;
	    return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) {
	        return symbols[Math.floor(codePoint % codePointRangeLength)];
	    }) + suffix;
	};
	
	var CJK_ZEROS = 1 << 0;
	var CJK_TEN_COEFFICIENTS = 1 << 1;
	var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
	var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
	
	var createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {
	    if (value < -9999 || value > 9999) {
	        return createCounterText(value, _listStyle.LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
	    }
	    var tmp = Math.abs(value);
	    var string = suffix;
	
	    if (tmp === 0) {
	        return numbers[0] + string;
	    }
	
	    for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
	        var coefficient = tmp % 10;
	
	        if (coefficient === 0 && (0, _Util.contains)(flags, CJK_ZEROS) && string !== '') {
	            string = numbers[coefficient] + string;
	        } else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && (0, _Util.contains)(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && (0, _Util.contains)(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && (0, _Util.contains)(flags, CJK_HUNDRED_COEFFICIENTS)) {
	            string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
	        } else if (coefficient === 1 && digit > 0) {
	            string = multipliers[digit - 1] + string;
	        }
	        tmp = Math.floor(tmp / 10);
	    }
	
	    return (value < 0 ? negativeSign : '') + string;
	};
	
	var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
	var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
	var JAPANESE_NEGATIVE = 'マイナス';
	var KOREAN_NEGATIVE = '마이너스 ';
	
	var createCounterText = exports.createCounterText = function createCounterText(value, type, appendSuffix) {
	    var defaultSuffix = appendSuffix ? '. ' : '';
	    var cjkSuffix = appendSuffix ? '、' : '';
	    var koreanSuffix = appendSuffix ? ', ' : '';
	    switch (type) {
	        case _listStyle.LIST_STYLE_TYPE.DISC:
	            return '•';
	        case _listStyle.LIST_STYLE_TYPE.CIRCLE:
	            return '◦';
	        case _listStyle.LIST_STYLE_TYPE.SQUARE:
	            return '◾';
	        case _listStyle.LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
	            var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
	            return string.length < 4 ? '0' + string : string;
	        case _listStyle.LIST_STYLE_TYPE.CJK_DECIMAL:
	            return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LOWER_ROMAN:
	            return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
	        case _listStyle.LIST_STYLE_TYPE.UPPER_ROMAN:
	            return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LOWER_GREEK:
	            return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LOWER_ALPHA:
	            return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.UPPER_ALPHA:
	            return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.ARABIC_INDIC:
	            return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.ARMENIAN:
	        case _listStyle.LIST_STYLE_TYPE.UPPER_ARMENIAN:
	            return createAdditiveCounter(value, 1, 9999, ARMENIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LOWER_ARMENIAN:
	            return createAdditiveCounter(value, 1, 9999, ARMENIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
	        case _listStyle.LIST_STYLE_TYPE.BENGALI:
	            return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.CAMBODIAN:
	        case _listStyle.LIST_STYLE_TYPE.KHMER:
	            return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
	            return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
	            return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
	        case _listStyle.LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
	            return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
	            return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
	            return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
	            return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.JAPANESE_INFORMAL:
	            return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
	        case _listStyle.LIST_STYLE_TYPE.JAPANESE_FORMAL:
	            return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
	            return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
	            return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
	        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
	            return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.DEVANAGARI:
	            return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.GEORGIAN:
	            return createAdditiveCounter(value, 1, 19999, GEORGIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.GUJARATI:
	            return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.GURMUKHI:
	            return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.HEBREW:
	            return createAdditiveCounter(value, 1, 10999, HEBREW, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.HIRAGANA:
	            return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
	        case _listStyle.LIST_STYLE_TYPE.HIRAGANA_IROHA:
	            return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
	        case _listStyle.LIST_STYLE_TYPE.KANNADA:
	            return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.KATAKANA:
	            return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.KATAKANA_IROHA:
	            return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LAO:
	            return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.MONGOLIAN:
	            return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.MYANMAR:
	            return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.ORIYA:
	            return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.PERSIAN:
	            return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.TAMIL:
	            return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.TELUGU:
	            return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.THAI:
	            return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.TIBETAN:
	            return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.DECIMAL:
	        default:
	            return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
	    }
	};

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseBorder = exports.BORDER_SIDES = exports.BORDER_STYLE = undefined;
	
	var _Color = __webpack_require__(31);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BORDER_STYLE = exports.BORDER_STYLE = {
	    NONE: 0,
	    SOLID: 1
	};
	
	var BORDER_SIDES = exports.BORDER_SIDES = {
	    TOP: 0,
	    RIGHT: 1,
	    BOTTOM: 2,
	    LEFT: 3
	};
	
	var SIDES = Object.keys(BORDER_SIDES).map(function (s) {
	    return s.toLowerCase();
	});
	
	var parseBorderStyle = function parseBorderStyle(style) {
	    switch (style) {
	        case 'none':
	            return BORDER_STYLE.NONE;
	    }
	    return BORDER_STYLE.SOLID;
	};
	
	var parseBorder = exports.parseBorder = function parseBorder(style) {
	    return SIDES.map(function (side) {
	        var borderColor = new _Color2.default(style.getPropertyValue('border-' + side + '-color'));
	        var borderStyle = parseBorderStyle(style.getPropertyValue('border-' + side + '-style'));
	        var borderWidth = parseFloat(style.getPropertyValue('border-' + side + '-width'));
	        return {
	            borderColor: borderColor,
	            borderStyle: borderStyle,
	            borderWidth: isNaN(borderWidth) ? 0 : borderWidth
	        };
	    });
	};

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTextDecoration = exports.TEXT_DECORATION_LINE = exports.TEXT_DECORATION = exports.TEXT_DECORATION_STYLE = undefined;
	
	var _Color = __webpack_require__(31);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TEXT_DECORATION_STYLE = exports.TEXT_DECORATION_STYLE = {
	    SOLID: 0,
	    DOUBLE: 1,
	    DOTTED: 2,
	    DASHED: 3,
	    WAVY: 4
	};
	
	var TEXT_DECORATION = exports.TEXT_DECORATION = {
	    NONE: null
	};
	
	var TEXT_DECORATION_LINE = exports.TEXT_DECORATION_LINE = {
	    UNDERLINE: 1,
	    OVERLINE: 2,
	    LINE_THROUGH: 3,
	    BLINK: 4
	};
	
	var parseLine = function parseLine(line) {
	    switch (line) {
	        case 'underline':
	            return TEXT_DECORATION_LINE.UNDERLINE;
	        case 'overline':
	            return TEXT_DECORATION_LINE.OVERLINE;
	        case 'line-through':
	            return TEXT_DECORATION_LINE.LINE_THROUGH;
	    }
	    return TEXT_DECORATION_LINE.BLINK;
	};
	
	var parseTextDecorationLine = function parseTextDecorationLine(line) {
	    if (line === 'none') {
	        return null;
	    }
	
	    return line.split(' ').map(parseLine);
	};
	
	var parseTextDecorationStyle = function parseTextDecorationStyle(style) {
	    switch (style) {
	        case 'double':
	            return TEXT_DECORATION_STYLE.DOUBLE;
	        case 'dotted':
	            return TEXT_DECORATION_STYLE.DOTTED;
	        case 'dashed':
	            return TEXT_DECORATION_STYLE.DASHED;
	        case 'wavy':
	            return TEXT_DECORATION_STYLE.WAVY;
	    }
	    return TEXT_DECORATION_STYLE.SOLID;
	};
	
	var parseTextDecoration = exports.parseTextDecoration = function parseTextDecoration(style) {
	    var textDecorationLine = parseTextDecorationLine(style.textDecorationLine ? style.textDecorationLine : style.textDecoration);
	    if (textDecorationLine === null) {
	        return TEXT_DECORATION.NONE;
	    }
	
	    var textDecorationColor = style.textDecorationColor ? new _Color2.default(style.textDecorationColor) : null;
	    var textDecorationStyle = parseTextDecorationStyle(style.textDecorationStyle);
	
	    return {
	        textDecorationLine: textDecorationLine,
	        textDecorationColor: textDecorationColor,
	        textDecorationStyle: textDecorationStyle
	    };
	};

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(32);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 119 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(56),
	    isLength = __webpack_require__(212);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(464),
	    baseUnary = __webpack_require__(203),
	    nodeUtil = __webpack_require__(207);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ },
/* 122 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    isArray = __webpack_require__(67),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 125 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(499)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var TextareaAutosize_1 = __webpack_require__(501);
	exports["default"] = TextareaAutosize_1["default"];


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lift = exports.dropAnimationFinished = exports.cancel = exports.drop = exports.completeDrop = exports.prepare = exports.clean = exports.crossAxisMoveBackward = exports.crossAxisMoveForward = exports.moveForward = exports.moveBackward = exports.moveByWindowScroll = exports.move = exports.updateDroppableDimensionIsEnabled = exports.updateDroppableDimensionScroll = exports.publishDroppableDimension = exports.publishDraggableDimension = exports.completeLift = exports.requestDimensions = undefined;
	
	var _noImpact = __webpack_require__(132);
	
	var _noImpact2 = _interopRequireDefault(_noImpact);
	
	var _getNewHomeClientCenter = __webpack_require__(510);
	
	var _getNewHomeClientCenter2 = _interopRequireDefault(_getNewHomeClientCenter);
	
	var _position = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origin = { x: 0, y: 0 };
	
	var getScrollDiff = function getScrollDiff(_ref) {
	  var initial = _ref.initial,
	      current = _ref.current,
	      droppable = _ref.droppable;
	
	  var windowScrollDiff = (0, _position.subtract)(initial.windowScroll, current.windowScroll);
	
	  var droppableScrollDiff = droppable ? (0, _position.subtract)(droppable.container.scroll.initial, droppable.container.scroll.current) : origin;
	
	  return (0, _position.add)(windowScrollDiff, droppableScrollDiff);
	};
	
	var requestDimensions = exports.requestDimensions = function requestDimensions(type) {
	  return {
	    type: 'REQUEST_DIMENSIONS',
	    payload: type
	  };
	};
	
	var completeLift = exports.completeLift = function completeLift(id, type, client, windowScroll, isScrollAllowed) {
	  return {
	    type: 'COMPLETE_LIFT',
	    payload: {
	      id: id,
	      type: type,
	      client: client,
	      windowScroll: windowScroll,
	      isScrollAllowed: isScrollAllowed
	    }
	  };
	};
	
	var publishDraggableDimension = exports.publishDraggableDimension = function publishDraggableDimension(dimension) {
	  return {
	    type: 'PUBLISH_DRAGGABLE_DIMENSION',
	    payload: dimension
	  };
	};
	
	var publishDroppableDimension = exports.publishDroppableDimension = function publishDroppableDimension(dimension) {
	  return {
	    type: 'PUBLISH_DROPPABLE_DIMENSION',
	    payload: dimension
	  };
	};
	
	var updateDroppableDimensionScroll = exports.updateDroppableDimensionScroll = function updateDroppableDimensionScroll(id, offset) {
	  return {
	    type: 'UPDATE_DROPPABLE_DIMENSION_SCROLL',
	    payload: {
	      id: id,
	      offset: offset
	    }
	  };
	};
	
	var updateDroppableDimensionIsEnabled = exports.updateDroppableDimensionIsEnabled = function updateDroppableDimensionIsEnabled(id, isEnabled) {
	  return {
	    type: 'UPDATE_DROPPABLE_DIMENSION_IS_ENABLED',
	    payload: {
	      id: id,
	      isEnabled: isEnabled
	    }
	  };
	};
	
	var move = exports.move = function move(id, client, windowScroll) {
	  return {
	    type: 'MOVE',
	    payload: {
	      id: id,
	      client: client,
	      windowScroll: windowScroll
	    }
	  };
	};
	
	var moveByWindowScroll = exports.moveByWindowScroll = function moveByWindowScroll(id, windowScroll) {
	  return {
	    type: 'MOVE_BY_WINDOW_SCROLL',
	    payload: {
	      id: id,
	      windowScroll: windowScroll
	    }
	  };
	};
	
	var moveBackward = exports.moveBackward = function moveBackward(id) {
	  return {
	    type: 'MOVE_BACKWARD',
	    payload: id
	  };
	};
	
	var moveForward = exports.moveForward = function moveForward(id) {
	  return {
	    type: 'MOVE_FORWARD',
	    payload: id
	  };
	};
	
	var crossAxisMoveForward = exports.crossAxisMoveForward = function crossAxisMoveForward(id) {
	  return {
	    type: 'CROSS_AXIS_MOVE_FORWARD',
	    payload: id
	  };
	};
	
	var crossAxisMoveBackward = exports.crossAxisMoveBackward = function crossAxisMoveBackward(id) {
	  return {
	    type: 'CROSS_AXIS_MOVE_BACKWARD',
	    payload: id
	  };
	};
	
	var clean = exports.clean = function clean() {
	  return {
	    type: 'CLEAN',
	    payload: null
	  };
	};
	
	var prepare = exports.prepare = function prepare() {
	  return {
	    type: 'PREPARE',
	    payload: null
	  };
	};
	
	var animateDrop = function animateDrop(_ref2) {
	  var trigger = _ref2.trigger,
	      newHomeOffset = _ref2.newHomeOffset,
	      impact = _ref2.impact,
	      result = _ref2.result;
	  return {
	    type: 'DROP_ANIMATE',
	    payload: {
	      trigger: trigger,
	      newHomeOffset: newHomeOffset,
	      impact: impact,
	      result: result
	    }
	  };
	};
	
	var completeDrop = exports.completeDrop = function completeDrop(result) {
	  return {
	    type: 'DROP_COMPLETE',
	    payload: result
	  };
	};
	
	var drop = exports.drop = function drop() {
	  return function (dispatch, getState) {
	    var state = getState();
	
	    if (state.phase === 'COLLECTING_DIMENSIONS') {
	      dispatch(clean());
	      return;
	    }
	
	    if (state.phase !== 'DRAGGING') {
	      console.error('not able to drop in phase: \'' + state.phase + '\'');
	      dispatch(clean());
	      return;
	    }
	
	    if (!state.drag) {
	      console.error('not able to drop when there is invalid drag state', state);
	      dispatch(clean());
	      return;
	    }
	
	    var _state$drag = state.drag,
	        impact = _state$drag.impact,
	        initial = _state$drag.initial,
	        current = _state$drag.current;
	
	    var draggable = state.dimension.draggable[current.id];
	    var home = state.dimension.droppable[draggable.droppableId];
	    var destination = impact.destination ? state.dimension.droppable[impact.destination.droppableId] : null;
	
	    var result = {
	      draggableId: current.id,
	      type: current.type,
	      source: initial.source,
	      destination: impact.destination
	    };
	
	    var newCenter = (0, _getNewHomeClientCenter2.default)({
	      movement: impact.movement,
	      draggable: draggable,
	      draggables: state.dimension.draggable,
	      destination: destination
	    });
	
	    var clientOffset = (0, _position.subtract)(newCenter, draggable.client.withMargin.center);
	    var scrollDiff = getScrollDiff({
	      initial: initial,
	      current: current,
	      droppable: destination || home
	    });
	    var newHomeOffset = (0, _position.add)(clientOffset, scrollDiff);
	
	    var isAnimationRequired = !(0, _position.isEqual)(current.client.offset, newHomeOffset);
	
	    if (!isAnimationRequired) {
	      dispatch(completeDrop(result));
	      return;
	    }
	
	    dispatch(animateDrop({
	      trigger: 'DROP',
	      newHomeOffset: newHomeOffset,
	      impact: impact,
	      result: result
	    }));
	  };
	};
	
	var cancel = exports.cancel = function cancel() {
	  return function (dispatch, getState) {
	    var state = getState();
	
	    if (state.phase !== 'DRAGGING') {
	      dispatch(clean());
	      return;
	    }
	
	    if (!state.drag) {
	      console.error('invalid drag state', state);
	      dispatch(clean());
	      return;
	    }
	
	    var _state$drag2 = state.drag,
	        initial = _state$drag2.initial,
	        current = _state$drag2.current;
	
	    var droppable = state.dimension.droppable[initial.source.droppableId];
	
	    var result = {
	      draggableId: current.id,
	      type: current.type,
	      source: initial.source,
	
	      destination: null
	    };
	
	    var isAnimationRequired = !(0, _position.isEqual)(current.client.offset, origin);
	
	    if (!isAnimationRequired) {
	      dispatch(completeDrop(result));
	      return;
	    }
	
	    var scrollDiff = getScrollDiff({ initial: initial, current: current, droppable: droppable });
	
	    dispatch(animateDrop({
	      trigger: 'CANCEL',
	      newHomeOffset: scrollDiff,
	      impact: _noImpact2.default,
	      result: result
	    }));
	  };
	};
	
	var dropAnimationFinished = exports.dropAnimationFinished = function dropAnimationFinished() {
	  return function (dispatch, getState) {
	    var state = getState();
	
	    if (state.phase !== 'DROP_ANIMATING') {
	      console.error('cannot end drop that is no longer animating', state);
	      dispatch(clean());
	      return;
	    }
	
	    if (!state.drop || !state.drop.pending) {
	      console.error('cannot end drop that has no pending state', state);
	      dispatch(clean());
	      return;
	    }
	
	    dispatch(completeDrop(state.drop.pending.result));
	  };
	};
	
	var lift = exports.lift = function lift(id, type, client, windowScroll, isScrollAllowed) {
	  return function (dispatch, getState) {
	    var initial = getState();
	
	    if (initial.phase === 'DROP_ANIMATING') {
	      if (!initial.drop || !initial.drop.pending) {
	        console.error('cannot flush drop animation if there is no pending');
	        dispatch(clean());
	      } else {
	        dispatch(completeDrop(initial.drop.pending.result));
	      }
	    }
	
	    dispatch(prepare());
	
	    setTimeout(function () {
	      var state = getState();
	
	      if (state.phase !== 'PREPARING') {
	        return;
	      }
	
	      dispatch(requestDimensions(type));
	
	      setTimeout(function () {
	        var newState = getState();
	
	        if (newState.phase !== 'COLLECTING_DIMENSIONS') {
	          return;
	        }
	
	        dispatch(completeLift(id, type, client, windowScroll, isScrollAllowed));
	      });
	    });
	  };
	};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDroppableDimension = exports.getDraggableDimension = exports.getFragment = exports.noSpacing = undefined;
	
	var _axis = __webpack_require__(502);
	
	var _getClientRect = __webpack_require__(131);
	
	var _getClientRect2 = _interopRequireDefault(_getClientRect);
	
	var _spacing = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origin = { x: 0, y: 0 };
	
	var noSpacing = exports.noSpacing = {
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0
	};
	
	var getWithPosition = function getWithPosition(clientRect, point) {
	  var top = clientRect.top,
	      right = clientRect.right,
	      bottom = clientRect.bottom,
	      left = clientRect.left;
	
	  return (0, _getClientRect2.default)({
	    top: top + point.y,
	    left: left + point.x,
	    bottom: bottom + point.y,
	    right: right + point.x
	  });
	};
	
	var getWithSpacing = function getWithSpacing(clientRect, spacing) {
	  var top = clientRect.top,
	      right = clientRect.right,
	      bottom = clientRect.bottom,
	      left = clientRect.left;
	
	  return (0, _getClientRect2.default)({
	    top: top - spacing.top,
	    left: left - spacing.left,
	
	    bottom: bottom + spacing.bottom,
	    right: right + spacing.right
	  });
	};
	
	var getFragment = exports.getFragment = function getFragment(initial) {
	  var point = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : origin;
	
	  var rect = (0, _getClientRect2.default)({
	    top: initial.top + point.y,
	    left: initial.left + point.x,
	    bottom: initial.bottom + point.y,
	    right: initial.right + point.x
	  });
	
	  return {
	    top: rect.top,
	    right: rect.right,
	    bottom: rect.bottom,
	    left: rect.left,
	    width: rect.width,
	    height: rect.height,
	    center: {
	      x: (rect.right + rect.left) / 2,
	      y: (rect.bottom + rect.top) / 2
	    }
	  };
	};
	
	var getDraggableDimension = exports.getDraggableDimension = function getDraggableDimension(_ref) {
	  var id = _ref.id,
	      droppableId = _ref.droppableId,
	      clientRect = _ref.clientRect,
	      _ref$margin = _ref.margin,
	      margin = _ref$margin === undefined ? noSpacing : _ref$margin,
	      _ref$windowScroll = _ref.windowScroll,
	      windowScroll = _ref$windowScroll === undefined ? origin : _ref$windowScroll;
	
	  var withScroll = getWithPosition(clientRect, windowScroll);
	
	  var dimension = {
	    id: id,
	    droppableId: droppableId,
	    placeholder: {
	      margin: margin,
	      withoutMargin: {
	        width: clientRect.width,
	        height: clientRect.height
	      }
	    },
	
	    client: {
	      withoutMargin: getFragment(clientRect),
	      withMargin: getFragment(getWithSpacing(clientRect, margin))
	    },
	
	    page: {
	      withoutMargin: getFragment(withScroll),
	      withMargin: getFragment(getWithSpacing(withScroll, margin))
	    }
	  };
	
	  return dimension;
	};
	
	var getDroppableDimension = exports.getDroppableDimension = function getDroppableDimension(_ref2) {
	  var id = _ref2.id,
	      clientRect = _ref2.clientRect,
	      containerRect = _ref2.containerRect,
	      _ref2$direction = _ref2.direction,
	      direction = _ref2$direction === undefined ? 'vertical' : _ref2$direction,
	      _ref2$margin = _ref2.margin,
	      margin = _ref2$margin === undefined ? noSpacing : _ref2$margin,
	      _ref2$padding = _ref2.padding,
	      padding = _ref2$padding === undefined ? noSpacing : _ref2$padding,
	      _ref2$windowScroll = _ref2.windowScroll,
	      windowScroll = _ref2$windowScroll === undefined ? origin : _ref2$windowScroll,
	      _ref2$scroll = _ref2.scroll,
	      scroll = _ref2$scroll === undefined ? origin : _ref2$scroll,
	      _ref2$isEnabled = _ref2.isEnabled,
	      isEnabled = _ref2$isEnabled === undefined ? true : _ref2$isEnabled;
	
	  var withMargin = getWithSpacing(clientRect, margin);
	  var withWindowScroll = getWithPosition(clientRect, windowScroll);
	
	  var containerRectWithWindowScroll = !containerRect || (0, _spacing.isEqual)(containerRect, clientRect) ? getWithPosition(withMargin, windowScroll) : getWithPosition(containerRect, windowScroll);
	
	  var dimension = {
	    id: id,
	    isEnabled: isEnabled,
	    axis: direction === 'vertical' ? _axis.vertical : _axis.horizontal,
	    client: {
	      withoutMargin: getFragment(clientRect),
	      withMargin: getFragment(withMargin),
	      withMarginAndPadding: getFragment(getWithSpacing(withMargin, padding))
	    },
	    page: {
	      withoutMargin: getFragment(withWindowScroll),
	      withMargin: getFragment(getWithSpacing(withWindowScroll, margin)),
	      withMarginAndPadding: getFragment(getWithSpacing(withWindowScroll, (0, _spacing.add)(margin, padding)))
	    },
	    container: {
	      scroll: {
	        initial: scroll,
	
	        current: scroll
	      },
	      bounds: getFragment(containerRectWithWindowScroll)
	    }
	  };
	
	  return dimension;
	};

/***/ },
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var top = _ref.top,
	      right = _ref.right,
	      bottom = _ref.bottom,
	      left = _ref.left;
	  return {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left,
	    width: right - left,
	    height: bottom - top
	  };
	};

/***/ },
/* 132 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var origin = { x: 0, y: 0 };
	
	var noMovement = exports.noMovement = {
	  draggables: [],
	  amount: origin,
	  isBeyondStartPosition: false
	};
	
	var noImpact = {
	  movement: noMovement,
	  direction: null,
	  destination: null
	};
	
	exports.default = noImpact;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _memoizeOne = __webpack_require__(18);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _rafSchd = __webpack_require__(216);
	
	var _rafSchd2 = _interopRequireDefault(_rafSchd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (callbacks, isDraggingFn) {
	  var ifDragging = function ifDragging(fn) {
	    if (isDraggingFn()) {
	      fn();
	    }
	  };
	
	  var memoizedMove = (0, _memoizeOne2.default)(function (x, y) {
	    var point = { x: x, y: y };
	    callbacks.onMove(point);
	  });
	
	  var move = (0, _rafSchd2.default)(function (point) {
	    ifDragging(function () {
	      return memoizedMove(point.x, point.y);
	    });
	  });
	
	  var moveForward = (0, _rafSchd2.default)(function () {
	    ifDragging(callbacks.onMoveForward);
	  });
	
	  var moveBackward = (0, _rafSchd2.default)(function () {
	    ifDragging(callbacks.onMoveBackward);
	  });
	
	  var crossAxisMoveForward = (0, _rafSchd2.default)(function () {
	    ifDragging(callbacks.onCrossAxisMoveForward);
	  });
	
	  var crossAxisMoveBackward = (0, _rafSchd2.default)(function () {
	    ifDragging(callbacks.onCrossAxisMoveBackward);
	  });
	
	  var windowScrollMove = (0, _rafSchd2.default)(function () {
	    ifDragging(callbacks.onWindowScroll);
	  });
	
	  return {
	    move: move,
	    moveForward: moveForward,
	    moveBackward: moveBackward,
	    crossAxisMoveForward: crossAxisMoveForward,
	    crossAxisMoveBackward: crossAxisMoveBackward,
	    windowScrollMove: windowScrollMove
	  };
	};

/***/ },
/* 134 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var interactiveTagNames = exports.interactiveTagNames = ['input', 'button', 'textarea', 'select', 'option', 'optgroup', 'video', 'audio'];
	
	var isContentEditable = function isContentEditable(parent, current) {
	  if (current == null) {
	    return false;
	  }
	
	  var attribute = current.getAttribute('contenteditable');
	  if (attribute === 'true' || attribute === '') {
	    return true;
	  }
	
	  if (current === parent) {
	    return false;
	  }
	
	  return isContentEditable(parent, current.parentElement);
	};
	
	exports.default = function (event, props) {
	  if (props.canDragInteractiveElements) {
	    return true;
	  }
	
	  var target = event.target,
	      currentTarget = event.currentTarget;
	
	  if (!(target instanceof HTMLElement) || !(currentTarget instanceof HTMLElement)) {
	    return true;
	  }
	
	  var isTargetInteractive = interactiveTagNames.indexOf(target.tagName.toLowerCase()) !== -1;
	
	  if (isTargetInteractive) {
	    return false;
	  }
	
	  return !isContentEditable(currentTarget, target);
	};

/***/ },
/* 135 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (ref) {
	  return ref ? ref.ownerDocument.defaultView : window;
	};

/***/ },
/* 136 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    x: window.pageXOffset,
	    y: window.pageYOffset
	  };
	};

/***/ },
/* 137 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tab = exports.tab = 9;
	var enter = exports.enter = 13;
	var escape = exports.escape = 27;
	var space = exports.space = 32;
	var arrowLeft = exports.arrowLeft = 37;
	var arrowUp = exports.arrowUp = 38;
	var arrowRight = exports.arrowRight = 39;
	var arrowDown = exports.arrowDown = 40;

/***/ },
/* 138 */
/***/ function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 139 */
/***/ function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 140 */
/***/ function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ },
/* 141 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(143);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(493);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(237);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(587);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(87);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownKeys;
	
	var _isMap = __webpack_require__(121);
	
	var _isMap2 = _interopRequireDefault(_isMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object) {
	
	  if ((0, _isMap2.default)(object)) {
	    return Array.from(object.keys());
	  }
	
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    return Reflect.ownKeys(object);
	  }
	
	  var keys = Object.getOwnPropertyNames(object);
	
	  if (typeof Object.getOwnPropertySymbols === 'function') {
	    keys = keys.concat(Object.getOwnPropertySymbols(object));
	  }
	
	  return keys;
	}

/***/ },
/* 148 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	var settle = __webpack_require__(257);
	var buildURL = __webpack_require__(260);
	var parseHeaders = __webpack_require__(266);
	var isURLSameOrigin = __webpack_require__(264);
	var createError = __webpack_require__(152);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(259);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(262);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 150 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 151 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(256);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 153 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchDashboard = exports.RECEIVE_DASHBOARD = exports.REQUEST_DASHBOARD = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUEST_DASHBOARD = exports.REQUEST_DASHBOARD = (0, _reduxActions.createAction)('REQUEST_DASHBOARD');
	var RECEIVE_DASHBOARD = exports.RECEIVE_DASHBOARD = (0, _reduxActions.createAction)('RECEIVE_DASHBOARD', function (list) {
	  return list;
	});
	
	var fetchDashboard = exports.fetchDashboard = function fetchDashboard() {
	  return function (dispatch) {
	    dispatch(REQUEST_DASHBOARD());
	
	    return dispatch(RECEIVE_DASHBOARD(_Api2.default.getDashboard()));
	  };
	};

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createEventStage = exports.CREATE_EVENT_STAGE = exports.UPDATE_EVENT_STAGE = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UPDATE_EVENT_STAGE = exports.UPDATE_EVENT_STAGE = (0, _reduxActions.createAction)('UPDATE_EVENT_STAGE');
	var CREATE_EVENT_STAGE = exports.CREATE_EVENT_STAGE = (0, _reduxActions.createAction)('CREATE_EVENT_STAGE');
	
	var createEventStage = exports.createEventStage = function createEventStage(eventId, stage) {
	  return function (dispatch) {
	    dispatch(UPDATE_EVENT_STAGE());
	
	    return dispatch(CREATE_EVENT_STAGE(_Api2.default.createEventStage(eventId, stage)));
	  };
	};

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deleteEventUser = exports.createEventUser = exports.DELETE_EVENT_USER = exports.CREATE_EVENT_USER = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _alerts = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CREATE_EVENT_USER = exports.CREATE_EVENT_USER = (0, _reduxActions.createAction)('CREATE_EVENT_USER');
	var DELETE_EVENT_USER = exports.DELETE_EVENT_USER = (0, _reduxActions.createAction)('DELETE_EVENT_USER');
	
	var createEventUser = exports.createEventUser = function createEventUser(eventId, user) {
	  return function (dispatch) {
	    return _Api2.default.createEventUser(eventId, user).then(function (response) {
	      dispatch(CREATE_EVENT_USER({ data: response.data }));
	      dispatch((0, _alerts.setAlert)('We have successfully shared this event', undefined, 'success'));
	    }).catch(function (error) {
	      return dispatch((0, _alerts.setAlert)(error.response.data.message, undefined, 'error'));
	    });
	  };
	};
	
	var deleteEventUser = exports.deleteEventUser = function deleteEventUser(eventId, userId) {
	  return function (dispatch) {
	    return dispatch(DELETE_EVENT_USER(_Api2.default.deleteEventUser(eventId, userId)));
	  };
	};

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchRiderList = exports.fetchEventList = exports.RECEIVE_RIDER_LIST = exports.REQUEST_RIDER_LIST = exports.RECEIVE_EVENT_LIST = exports.REQUEST_EVENT_LIST = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _alerts = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUEST_EVENT_LIST = exports.REQUEST_EVENT_LIST = (0, _reduxActions.createAction)('REQUEST_EVENT_LIST');
	var RECEIVE_EVENT_LIST = exports.RECEIVE_EVENT_LIST = (0, _reduxActions.createAction)('RECEIVE_EVENT_LIST', function (list) {
	  return list;
	});
	var REQUEST_RIDER_LIST = exports.REQUEST_RIDER_LIST = (0, _reduxActions.createAction)('REQUEST_RIDER_LIST');
	var RECEIVE_RIDER_LIST = exports.RECEIVE_RIDER_LIST = (0, _reduxActions.createAction)('RECEIVE_RIDER_LIST', function (list) {
	  return list;
	});
	
	var fetchEventList = exports.fetchEventList = function fetchEventList() {
	  return function (dispatch) {
	    dispatch(REQUEST_EVENT_LIST());
	
	    return _Api2.default.getEventList().then(function (response) {
	      return dispatch(RECEIVE_EVENT_LIST({ data: response.data }));
	    }).catch(function (error) {
	      var errorMessage = error.response.data.message === "Technical error" ? "Sorry, we are undergoing maintenance. Please check back soon." : error.response.data.message;
	
	      dispatch((0, _alerts.setAlert)(errorMessage, undefined, 'error'));
	    });
	  };
	};
	
	var fetchRiderList = exports.fetchRiderList = function fetchRiderList() {
	  return function (dispatch) {
	    dispatch(REQUEST_RIDER_LIST());
	
	    return _Api2.default.getRiderList().then(function (response) {
	      return dispatch(RECEIVE_RIDER_LIST({ data: response.data }));
	    }).catch(function (error) {
	      var errorMessage = error.response.data.message === "Technical error" ? "Sorry, we are undergoing maintenance. Please check back soon." : error.response.data.message;
	
	      dispatch((0, _alerts.setAlert)(errorMessage, undefined, 'error'));
	    });
	  };
	};

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchNotifications = exports.RECEIVE_NOTIFICATIONS = exports.REQUEST_NOTIFICATIONS = undefined;
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reduxActions = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUEST_NOTIFICATIONS = exports.REQUEST_NOTIFICATIONS = (0, _reduxActions.createAction)('REQUEST_NOTIFICATIONS');
	var RECEIVE_NOTIFICATIONS = exports.RECEIVE_NOTIFICATIONS = (0, _reduxActions.createAction)('RECEIVE_NOTIFICATIONS');
	
	var fetchNotifications = exports.fetchNotifications = function fetchNotifications(limit, offset) {
	  return function (dispatch) {
	    dispatch(REQUEST_NOTIFICATIONS());
	
	    return dispatch(RECEIVE_NOTIFICATIONS(_Api2.default.getNotifications(limit, offset)));
	  };
	};

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deleteRiderColumn = exports.moveRiderColumn = exports.createRiderColumn = exports.removeRiderColumn = exports.addRiderColumn = exports.DELETE_RIDER_COLUMN = exports.MOVE_RIDER_COLUMN = exports.CREATE_RIDER_COLUMN = exports.REMOVE_RIDER_COLUMN = exports.ADD_RIDER_COLUMN = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _rider = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_RIDER_COLUMN = exports.ADD_RIDER_COLUMN = (0, _reduxActions.createAction)('ADD_RIDER_COLUMN', function (column) {
	  return column;
	});
	var REMOVE_RIDER_COLUMN = exports.REMOVE_RIDER_COLUMN = (0, _reduxActions.createAction)('REMOVE_RIDER_COLUMN', function (index) {
	  return index;
	});
	var CREATE_RIDER_COLUMN = exports.CREATE_RIDER_COLUMN = (0, _reduxActions.createAction)('CREATE_RIDER_COLUMN', function (column) {
	  return column;
	});
	var MOVE_RIDER_COLUMN = exports.MOVE_RIDER_COLUMN = (0, _reduxActions.createAction)('MOVE_RIDER_COLUMN', function (column) {
	  return column;
	});
	var DELETE_RIDER_COLUMN = exports.DELETE_RIDER_COLUMN = (0, _reduxActions.createAction)('DELETE_RIDER_COLUMN', function (column) {
	  return column;
	});
	
	var addRiderColumn = exports.addRiderColumn = function addRiderColumn() {
	  var column = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return function (dispatch) {
	    return dispatch(ADD_RIDER_COLUMN({ column: column }));
	  };
	};
	
	var removeRiderColumn = exports.removeRiderColumn = function removeRiderColumn(index) {
	  return function (dispatch) {
	    return dispatch(REMOVE_RIDER_COLUMN({ index: index }));
	  };
	};
	
	var createRiderColumn = exports.createRiderColumn = function createRiderColumn(riderId, column) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(CREATE_RIDER_COLUMN(_Api2.default.createRiderColumn(riderId, column)));
	  };
	};
	
	var moveRiderColumn = exports.moveRiderColumn = function moveRiderColumn(column) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(MOVE_RIDER_COLUMN(_Api2.default.moveRiderColumn(column)));
	  };
	};
	
	var deleteRiderColumn = exports.deleteRiderColumn = function deleteRiderColumn(id) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(DELETE_RIDER_COLUMN(_Api2.default.deleteRiderColumn(id)));
	  };
	};

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deleteRiderContact = exports.editRiderContact = exports.createRiderContact = exports.removeRiderContact = exports.addRiderContact = exports.DELETE_RIDER_CONTACT = exports.EDIT_RIDER_CONTACT = exports.CREATE_RIDER_CONTACT = exports.REMOVE_RIDER_CONTACT = exports.ADD_RIDER_CONTACT = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _rider = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_RIDER_CONTACT = exports.ADD_RIDER_CONTACT = (0, _reduxActions.createAction)('ADD_RIDER_CONTACT');
	var REMOVE_RIDER_CONTACT = exports.REMOVE_RIDER_CONTACT = (0, _reduxActions.createAction)('REMOVE_RIDER_CONTACT');
	var CREATE_RIDER_CONTACT = exports.CREATE_RIDER_CONTACT = (0, _reduxActions.createAction)('CREATE_RIDER_CONTACT');
	var EDIT_RIDER_CONTACT = exports.EDIT_RIDER_CONTACT = (0, _reduxActions.createAction)('EDIT_RIDER_CONTACT');
	var DELETE_RIDER_CONTACT = exports.DELETE_RIDER_CONTACT = (0, _reduxActions.createAction)('DELETE_RIDER_CONTACT');
	
	var addRiderContact = exports.addRiderContact = function addRiderContact(contact) {
	  return function (dispatch) {
	    return dispatch(ADD_RIDER_CONTACT({ contact: contact }));
	  };
	};
	
	var removeRiderContact = exports.removeRiderContact = function removeRiderContact(index) {
	  return function (dispatch) {
	    return dispatch(REMOVE_RIDER_CONTACT({ index: index }));
	  };
	};
	
	var createRiderContact = exports.createRiderContact = function createRiderContact(riderId, contact) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(CREATE_RIDER_CONTACT(_Api2.default.createRiderContact(riderId, contact)));
	  };
	};
	
	var editRiderContact = exports.editRiderContact = function editRiderContact(contact) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(EDIT_RIDER_CONTACT(_Api2.default.editRiderContact(contact)));
	  };
	};
	
	var deleteRiderContact = exports.deleteRiderContact = function deleteRiderContact(contact) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(EDIT_RIDER_CONTACT(_Api2.default.deleteRiderContact(contact)));
	  };
	};

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deleteRiderMember = exports.moveRiderMember = exports.editRiderMember = exports.createRiderMember = exports.removeRiderMember = exports.addRiderMember = exports.DELETE_RIDER_MEMBER = exports.MOVE_RIDER_MEMBER = exports.EDIT_RIDER_MEMBER = exports.CREATE_RIDER_MEMBER = exports.REMOVE_RIDER_MEMBER = exports.ADD_RIDER_MEMBER = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _rider = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_RIDER_MEMBER = exports.ADD_RIDER_MEMBER = (0, _reduxActions.createAction)('ADD_RIDER_MEMBER');
	var REMOVE_RIDER_MEMBER = exports.REMOVE_RIDER_MEMBER = (0, _reduxActions.createAction)('REMOVE_RIDER_MEMBER');
	var CREATE_RIDER_MEMBER = exports.CREATE_RIDER_MEMBER = (0, _reduxActions.createAction)('CREATE_RIDER_MEMBER');
	var EDIT_RIDER_MEMBER = exports.EDIT_RIDER_MEMBER = (0, _reduxActions.createAction)('EDIT_RIDER_MEMBER');
	var MOVE_RIDER_MEMBER = exports.MOVE_RIDER_MEMBER = (0, _reduxActions.createAction)('MOVE_RIDER_MEMBER');
	var DELETE_RIDER_MEMBER = exports.DELETE_RIDER_MEMBER = (0, _reduxActions.createAction)('DELETE_RIDER_MEMBER');
	
	var addRiderMember = exports.addRiderMember = function addRiderMember(member) {
	  return function (dispatch) {
	    return dispatch(ADD_RIDER_MEMBER({ member: member }));
	  };
	};
	
	var removeRiderMember = exports.removeRiderMember = function removeRiderMember(index) {
	  return function (dispatch) {
	    return dispatch(REMOVE_RIDER_MEMBER({ index: index }));
	  };
	};
	
	var createRiderMember = exports.createRiderMember = function createRiderMember(riderId, member) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(CREATE_RIDER_MEMBER(_Api2.default.createRiderMember(riderId, member)));
	  };
	};
	
	var editRiderMember = exports.editRiderMember = function editRiderMember(member) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(EDIT_RIDER_MEMBER(_Api2.default.editRiderMember(member)));
	  };
	};
	
	var moveRiderMember = exports.moveRiderMember = function moveRiderMember(id, position) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(MOVE_RIDER_MEMBER(_Api2.default.moveRiderMember(id, position)));
	  };
	};
	
	var deleteRiderMember = exports.deleteRiderMember = function deleteRiderMember(member) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(EDIT_RIDER_MEMBER(_Api2.default.deleteRiderMember(member)));
	  };
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deleteRiderStageplanItem = exports.editRiderStageplanItem = exports.createRiderStageplanItem = exports.removeRiderStageplanItem = exports.addRiderStageplanItem = exports.DELETE_RIDER_STAGEPLAN_ITEM = exports.EDIT_RIDER_STAGEPLAN_ITEM = exports.CREATE_RIDER_STAGEPLAN_ITEM = exports.REMOVE_RIDER_STAGEPLAN_ITEM = exports.ADD_RIDER_STAGEPLAN_ITEM = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _rider = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_RIDER_STAGEPLAN_ITEM = exports.ADD_RIDER_STAGEPLAN_ITEM = (0, _reduxActions.createAction)('ADD_RIDER_STAGEPLAN_ITEM');
	var REMOVE_RIDER_STAGEPLAN_ITEM = exports.REMOVE_RIDER_STAGEPLAN_ITEM = (0, _reduxActions.createAction)('REMOVE_RIDER_STAGEPLAN_ITEM');
	var CREATE_RIDER_STAGEPLAN_ITEM = exports.CREATE_RIDER_STAGEPLAN_ITEM = (0, _reduxActions.createAction)('CREATE_RIDER_STAGEPLAN_ITEM');
	var EDIT_RIDER_STAGEPLAN_ITEM = exports.EDIT_RIDER_STAGEPLAN_ITEM = (0, _reduxActions.createAction)('EDIT_RIDER_STAGEPLAN_ITEM');
	var DELETE_RIDER_STAGEPLAN_ITEM = exports.DELETE_RIDER_STAGEPLAN_ITEM = (0, _reduxActions.createAction)('DELETE_RIDER_STAGEPLAN_ITEM');
	
	var addRiderStageplanItem = exports.addRiderStageplanItem = function addRiderStageplanItem(item) {
	  return function (dispatch) {
	    return dispatch(ADD_RIDER_STAGEPLAN_ITEM({ item: item }));
	  };
	};
	
	var removeRiderStageplanItem = exports.removeRiderStageplanItem = function removeRiderStageplanItem(index) {
	  return function (dispatch) {
	    return dispatch(REMOVE_RIDER_STAGEPLAN_ITEM({ index: index }));
	  };
	};
	
	var createRiderStageplanItem = exports.createRiderStageplanItem = function createRiderStageplanItem(stageplanId, item) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return dispatch(CREATE_RIDER_STAGEPLAN_ITEM(_Api2.default.createRiderStageplanItem(stageplanId, item)));
	  };
	};
	
	var editRiderStageplanItem = exports.editRiderStageplanItem = function editRiderStageplanItem(item, index) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return _Api2.default.editRiderStageplanItem(item).then(function (_ref) {
	      var data = _ref.data;
	      return dispatch(EDIT_RIDER_STAGEPLAN_ITEM({ data: data, index: index }));
	    });
	  };
	};
	
	var deleteRiderStageplanItem = exports.deleteRiderStageplanItem = function deleteRiderStageplanItem(item, index) {
	  return function (dispatch) {
	    dispatch((0, _rider.SAVE_RIDER)());
	
	    return _Api2.default.deleteRiderStageplanItem(item).then(function (_ref2) {
	      var data = _ref2.data;
	      return dispatch(DELETE_RIDER_STAGEPLAN_ITEM({ data: data, index: index }));
	    });
	  };
	};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSearchResults = exports.getAvailableEquipmentTypes = exports.createStageElement = exports.fetchStageElements = exports.RECEIVE_SEARCH_RESULTS = exports.REQUEST_SEARCH_RESULTS = exports.GET_AVAILABLE_EQUIPMENT_TYPES = exports.CREATE_STAGE_ELEMENT = exports.RECEIVE_STAGE_ELEMENTS = exports.REQUEST_STAGE_ELEMENTS = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _functions = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUEST_STAGE_ELEMENTS = exports.REQUEST_STAGE_ELEMENTS = (0, _reduxActions.createAction)('REQUEST_STAGE_ELEMENTS');
	var RECEIVE_STAGE_ELEMENTS = exports.RECEIVE_STAGE_ELEMENTS = (0, _reduxActions.createAction)('RECEIVE_STAGE_ELEMENTS');
	var CREATE_STAGE_ELEMENT = exports.CREATE_STAGE_ELEMENT = (0, _reduxActions.createAction)('CREATE_STAGE_ELEMENT');
	var GET_AVAILABLE_EQUIPMENT_TYPES = exports.GET_AVAILABLE_EQUIPMENT_TYPES = (0, _reduxActions.createAction)('GET_AVAILABLE_EQUIPMENT_TYPES');
	var REQUEST_SEARCH_RESULTS = exports.REQUEST_SEARCH_RESULTS = (0, _reduxActions.createAction)('REQUEST_SEARCH_RESULTS', function (term) {
	  return { term: term };
	});
	var RECEIVE_SEARCH_RESULTS = exports.RECEIVE_SEARCH_RESULTS = (0, _reduxActions.createAction)('RECEIVE_SEARCH_RESULTS', function (term, results) {
	  return { term: term, results: results };
	});
	
	var fetchStageElements = exports.fetchStageElements = function fetchStageElements() {
	  return function (dispatch) {
	    dispatch(REQUEST_STAGE_ELEMENTS());
	
	    dispatch(REQUEST_SEARCH_RESULTS(''));
	
	    return dispatch(RECEIVE_STAGE_ELEMENTS(_Api2.default.getStageElements()));
	  };
	};
	
	var createStageElement = exports.createStageElement = function createStageElement(data) {
	  return function (dispatch) {
	    return dispatch(CREATE_STAGE_ELEMENT(_Api2.default.createStageElement(data)));
	  };
	};
	
	var getAvailableEquipmentTypes = exports.getAvailableEquipmentTypes = function getAvailableEquipmentTypes() {
	  var equipmentTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var availableColumnTypes = (0, _functions.getAvailableColumnTypes)(columns, equipmentTypes);
	
	  return function (dispatch) {
	    return dispatch(GET_AVAILABLE_EQUIPMENT_TYPES({ availableColumnTypes: availableColumnTypes }));
	  };
	};
	
	var getSearchResults = exports.getSearchResults = function getSearchResults() {
	  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	  var term = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var searchResults = function searchResults(instrument) {
	    var regexStr = '(?=.*' + term.split(/\,|\s/).join(')(?=.*') + ')';
	    var searchRegEx = new RegExp(regexStr, 'gi');
	    return instrument.title.toLowerCase().match(searchRegEx) !== null;
	  };
	
	  return function (dispatch) {
	    if (array !== undefined) {
	      if (term.length >= 3) {
	        dispatch(RECEIVE_SEARCH_RESULTS(term, array.filter(searchResults)));
	      } else {
	        dispatch(RECEIVE_SEARCH_RESULTS(term, []));
	      }
	    } else {
	      dispatch(REQUEST_SEARCH_RESULTS(term));
	    }
	  };
	};

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _reactSelect = __webpack_require__(20);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _functions = __webpack_require__(6);
	
	var _selectForm = __webpack_require__(58);
	
	var _selectForm2 = _interopRequireDefault(_selectForm);
	
	var _listEquipment = __webpack_require__(300);
	
	var _listEquipment2 = _interopRequireDefault(_listEquipment);
	
	var _switch = __webpack_require__(57);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItem = function (_Component) {
	  _inherits(ListItem, _Component);
	
	  function ListItem(props) {
	    _classCallCheck(this, ListItem);
	
	    var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));
	
	    _this.state = {
	      required: false,
	      showSelectForm: false,
	      showTypeSelectForm: false,
	      showDropdown: false,
	      showTypeDropdown: false
	    };
	    return _this;
	  }
	
	  _createClass(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var required = this.props.required;
	
	
	      this.setState({ required: required });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var required = nextProps.required;
	
	
	      if (this.props.required !== required) {
	        this.setState({ required: required });
	      }
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown(item, parentItem) {
	      var _this2 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  _this2.props.addRiderItem({
	                    class: "equipment",
	                    position: item.children.length + 1,
	                    parent: item.id,
	                    indexes: _this2.props.parentItemIndex !== undefined ? [_this2.props.parentItemIndex, _this2.props.itemIndex, item.children.length] : [_this2.props.itemIndex, item.children.length]
	                  });
	                });
	              } },
	            'Add equipment to this instrument'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showSelectForm: true, showDropdown: false });
	              } },
	            'Rename instrument'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  parentItem && parentItem.children && parentItem.children.length <= 1 ? _this2.props.deleteRiderItem(parentItem.id) : _this2.props.deleteRiderItem(item.id);
	                });
	              } },
	            'Remove this instrument'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderTypeDropdown',
	    value: function renderTypeDropdown(item) {
	      var _this3 = this;
	
	      var showTypeDropdown = this.state.showTypeDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showTypeDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showTypeDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this3.setState({ showTypeDropdown: !showTypeDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this3.setState({ showTypeDropdown: !showTypeDropdown });
	          } }),
	        showTypeDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this3.setState({ showTypeSelectForm: true, showTypeDropdown: false });
	              } },
	            'Change category'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderEmptyListItem',
	    value: function renderEmptyListItem(item, stageElements, categories, options) {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'list-item list-item--empty' },
	        _react2.default.createElement('div', { className: 'list-item-handle' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'list-item-channel' },
	          item.channel
	        ),
	        _react2.default.createElement(_selectForm2.default, {
	          group: 'input',
	          item: {
	            class: 'instrument',
	            parent: item.parent,
	            type: item.type
	          },
	          itemGroups: this.props.itemGroups,
	          position: item.position,
	          setFocus: true,
	          removeFocus: function removeFocus() {
	            return _this4.props.removeRiderItem(item);
	          },
	          createRiderItem: this.props.createRiderItem,
	          editRiderItem: this.props.editRiderItem,
	          options: options ? options : (0, _functions.getStageElementsByTypes)(['instrument'], stageElements),
	          categories: categories ? categories : (0, _functions.getStageElementsByTypes)(['children'], stageElements.groups && stageElements.groups.instrument),
	          createStageElement: this.props.createStageElement,
	          searchResults: (0, _functions.validateSearchResults)(stageElements),
	          getSearchResults: this.props.getSearchResults })
	      );
	    }
	  }, {
	    key: 'renderListItem',
	    value: function renderListItem(columns, item, parentItem, stageElements, options, categories) {
	      var _this5 = this;
	
	      var view = this.props.view;
	
	
	      var renderSelectForm = function renderSelectForm(item, stageElements) {
	        return _react2.default.createElement(_selectForm2.default, {
	          group: _this5.props.group,
	          item: item,
	          itemGroups: _this5.props.itemGroups,
	          position: _this5.props.position,
	          setFocus: true,
	          removeFocus: function removeFocus() {
	            return _this5.setState({ showSelectForm: false });
	          },
	          createRiderItem: _this5.props.createRiderItem,
	          editRiderItem: _this5.props.editRiderItem,
	          options: options ? options : (0, _functions.getStageElementsByTypes)(['instrument'], stageElements),
	          categories: categories ? categories : (0, _functions.getStageElementsByTypes)(['children'], stageElements.groups && stageElements.groups.instrument),
	          createStageElement: _this5.props.createStageElement,
	          searchResults: (0, _functions.validateSearchResults)(stageElements),
	          getSearchResults: _this5.props.getSearchResults });
	      };
	
	      var renderListInstrumentItem = function renderListInstrumentItem(item, stageElements) {
	        var view = _this5.props.view;
	        var _state = _this5.state,
	            required = _state.required,
	            showTypeSelectForm = _state.showTypeSelectForm;
	
	        var grouped = _this5.props.dragDropType.indexOf('instrument-group') !== -1;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'list-instrument-item' },
	          view.editable ? _this5.renderDropdown(item, parentItem) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'list-instrument-item--title', onClick: function onClick() {
	                return _this5.setState({ showSelectForm: true });
	              } },
	            item.title
	          ),
	          !grouped && !showTypeSelectForm && view.editable ? _this5.renderTypeDropdown(item) : null,
	          !grouped ? !showTypeSelectForm ? _react2.default.createElement(
	            'div',
	            { className: 'list-instrument-item--type', onClick: function onClick() {
	                return _this5.setState({ showTypeDropdown: !_this5.state.showTypeDropdown });
	              } },
	            item.type.title
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'select-form select-form--type' },
	            _react2.default.createElement('div', { className: 'select-form-escape', onClick: function onClick() {
	                return _this5.setState({ showTypeSelectForm: false });
	              } }),
	            _react2.default.createElement(
	              'div',
	              { className: 'select-form-fields' },
	              _react2.default.createElement(_reactSelect2.default, {
	                autoFocus: true,
	                openOnFocus: true,
	                className: 'select-form-field',
	                name: 'item-type-selector-' + item.id,
	                value: undefined,
	                valueKey: 'id',
	                labelKey: 'title',
	                clearable: false,
	                onChange: function onChange(selectedItem) {
	                  return _this5.setState({ showTypeSelectForm: false }, function () {
	                    return _this5.props.editRiderItem({ id: item.id, type: selectedItem.type.slug });
	                  });
	                },
	                categories: (0, _functions.getStageElementsByTypes)(['children'], stageElements.groups && stageElements.groups.instrument) })
	            )
	          ) : null,
	          view.editable ? _react2.default.createElement(_switch2.default, {
	            required: required,
	            toggleSwitch: function toggleSwitch(required) {
	              return _this5.setState({ required: required }, function () {
	                return _this5.props.editRiderItem({ id: item.id, required: required });
	              });
	            } }) : item.required ? _react2.default.createElement(
	            'div',
	            null,
	            'Required'
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            'Band brings'
	          )
	        );
	      };
	
	      var showSelectForm = this.state.showSelectForm;
	
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Draggable,
	        { draggableId: item.id, isDragDisabled: !view.editable, type: this.props.dragDropType },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'list-item' },
	            _react2.default.createElement(
	              'div',
	              { className: 'list-item--draggable',
	                ref: provided.innerRef,
	                style: provided.draggableStyle },
	              view.editable ? _react2.default.createElement('div', Object.assign({ className: 'list-item-handle' }, provided.dragHandleProps)) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'list-item-channel' },
	                item.channel
	              ),
	              showSelectForm && view.editable ? renderSelectForm(item, stageElements) : renderListInstrumentItem(item, stageElements),
	              _react2.default.createElement(_listEquipment2.default, {
	                view: view,
	                group: _this5.props.group,
	                columns: columns,
	                itemId: item.id,
	                itemIndex: _this5.props.itemIndex,
	                parentItemIndex: _this5.props.parentItemIndex,
	                items: item.children,
	                createRiderColumn: _this5.props.createRiderColumn,
	                addRiderItem: _this5.props.addRiderItem,
	                removeRiderItem: _this5.props.removeRiderItem,
	                createRiderItem: _this5.props.createRiderItem,
	                editRiderItem: _this5.props.editRiderItem,
	                deleteRiderItem: _this5.props.deleteRiderItem,
	                stageElements: _this5.props.stageElements,
	                getSearchResults: _this5.props.getSearchResults })
	            ),
	            provided.placeholder
	          );
	        }
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          columns = _props.columns,
	          item = _props.item,
	          parentItem = _props.parentItem,
	          stageElements = _props.stageElements,
	          options = _props.options,
	          categories = _props.categories;
	
	
	      return item.id !== undefined ? this.renderListItem(columns, item, parentItem, stageElements, options, categories) : this.renderEmptyListItem(item, stageElements, options, categories);
	    }
	  }]);
	
	  return ListItem;
	}(_react.Component);
	
	ListItem.propTypes = {
	  view: _propTypes2.default.object,
	  dragDropType: _propTypes2.default.string,
	  group: _propTypes2.default.string,
	  columns: _propTypes2.default.array,
	  item: _propTypes2.default.object,
	  itemIndex: _propTypes2.default.number,
	  parentItem: _propTypes2.default.object,
	  parentItemIndex: _propTypes2.default.number,
	  position: _propTypes2.default.number,
	  required: _propTypes2.default.bool,
	  setFocus: _propTypes2.default.bool,
	  itemGroups: _propTypes2.default.array,
	  createRiderColumn: _propTypes2.default.func,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  options: _propTypes2.default.array,
	  categories: _propTypes2.default.array,
	  createStageElement: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func
	};
	
	ListItem.defaultProps = {
	  view: {},
	  dragDropType: '',
	  group: '',
	  columns: [],
	  item: {},
	  itemIndex: undefined,
	  parentItem: {},
	  parentItemIndex: undefined,
	  position: 0,
	  required: false,
	  setFocus: false,
	  itemGroups: [],
	  createRiderColumn: function createRiderColumn() {},
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  stageElements: {},
	  options: undefined,
	  categories: undefined,
	  createStageElement: function createStageElement() {},
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = ListItem;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _tableCell = __webpack_require__(303);
	
	var _tableCell2 = _interopRequireDefault(_tableCell);
	
	var _selectForm = __webpack_require__(58);
	
	var _selectForm2 = _interopRequireDefault(_selectForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableRow = function (_Component) {
	  _inherits(TableRow, _Component);
	
	  function TableRow(props) {
	    _classCallCheck(this, TableRow);
	
	    var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));
	
	    _this.state = {
	      showDropdown: false
	    };
	    return _this;
	  }
	
	  _createClass(TableRow, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var item = nextProps.item,
	          paging = nextProps.paging,
	          stageElements = nextProps.stageElements;
	
	
	      if (item !== this.props.item) return true;
	      if (paging !== this.props.paging) return true;
	      if (stageElements !== this.props.stageElements) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown(item, parentItem) {
	      var _this2 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  parentItem && parentItem.children && parentItem.children.length <= 1 ? _this2.props.deleteRiderItem(parentItem.id) : _this2.props.deleteRiderItem(item.id);
	                });
	              } },
	            'Remove this instrument'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderEmptyTableRow',
	    value: function renderEmptyTableRow(columns, item, paging, stageElements, options, categories) {
	      var _this3 = this;
	
	      var view = this.props.view;
	
	
	      if (view.editable !== true) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-row table-row--empty' },
	        _react2.default.createElement('div', { className: 'table-row-handle' }),
	        _react2.default.createElement('div', { className: 'table-row-channel' }),
	        _react2.default.createElement('div', { className: 'ui-dropdown' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'table-row-item' },
	          columns.map(function (column, index) {
	            if (paging.stickyColumn) {
	              if (column.type !== 'instrument' && (0, _functions.hiddenInPaging)(paging, index)) return null;
	            } else {
	              if ((0, _functions.hiddenInPaging)(paging, index)) return null;
	            }
	
	            return _react2.default.createElement(
	              'div',
	              { key: index, className: 'table-cell',
	                style: { minWidth: 100 / paging.size + '%', maxWidth: 100 / paging.size + '%' } },
	              column.type === 'instrument' ? _react2.default.createElement(_selectForm2.default, {
	                group: 'input',
	                item: {
	                  class: 'instrument',
	                  position: item.position,
	                  parent: item.parent,
	                  type: item.type
	                },
	                position: item.position,
	                placeholder: 'Enter ' + column.title.toLowerCase(),
	                promptTextCreator: 'Add',
	                typeSelectorText: 'Specify it\'s category',
	                itemGroups: _this3.props.itemGroups,
	                itemGroupingText: 'We suggest grouping drum elements into',
	                setFocus: true,
	                changeFocus: function changeFocus(e, current) {
	                  return _this3.props.changeFocus(e, Object.assign({}, current, { channel: current.channel + 1 }));
	                },
	                removeFocus: function removeFocus() {
	                  return _this3.props.removeRiderItem(item);
	                },
	                createRiderItem: _this3.props.createRiderItem,
	                editRiderItem: _this3.props.editRiderItem,
	                options: options ? options : (0, _functions.getStageElementsByTypes)(['instrument'], stageElements),
	                categories: categories ? categories : (0, _functions.getStageElementsByTypes)(['children'], stageElements.groups && stageElements.groups.instrument),
	                createStageElement: _this3.props.createStageElement,
	                searchResults: (0, _functions.validateSearchResults)(stageElements),
	                getSearchResults: _this3.props.getSearchResults }) : null
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderTableRow',
	    value: function renderTableRow(item, parentItem, paging, stageElements, options, categories) {
	      var _this4 = this;
	
	      var view = this.props.view;
	      var channel = item.channel,
	          row = item.row;
	
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Draggable,
	        { draggableId: item.id, isDragDisabled: !view.editable, type: this.props.dragDropType },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'table-row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'table-row--draggable',
	                ref: provided.innerRef,
	                style: provided.draggableStyle },
	              _react2.default.createElement('div', Object.assign({ className: 'table-row-handle' }, provided.dragHandleProps, { tabIndex: '-1' })),
	              _react2.default.createElement(
	                'div',
	                { className: 'table-row-channel' },
	                item.channel
	              ),
	              view.editable ? _this4.renderDropdown(item, parentItem) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'table-row-item' },
	                row.map(function (item, index) {
	                  if (paging.stickyColumn) {
	                    if (item.class !== 'instrument' && (0, _functions.hiddenInPaging)(paging, index)) return null;
	                  } else {
	                    if ((0, _functions.hiddenInPaging)(paging, index)) return null;
	                  }
	
	                  return _react2.default.createElement(_tableCell2.default, { key: index,
	                    view: view,
	                    group: _this4.props.group,
	                    channel: channel,
	                    item: item,
	                    cellIndex: index,
	                    paging: paging,
	                    itemGroups: _this4.props.itemGroups,
	                    changeFocus: function changeFocus(e, current) {
	                      return _this4.props.changeFocus(e, Object.assign({}, current, { channel: channel }));
	                    },
	                    createRiderItem: _this4.props.createRiderItem,
	                    editRiderItem: _this4.props.editRiderItem,
	                    deleteRiderItem: _this4.props.deleteRiderItem,
	                    stageElements: _this4.props.stageElements,
	                    options: options,
	                    categories: categories,
	                    createStageElement: _this4.props.createStageElement,
	                    getSearchResults: _this4.props.getSearchResults });
	                })
	              )
	            ),
	            provided.placeholder,
	            view.editable ? _react2.default.createElement(
	              'div',
	              { className: 'table-row-separator', onClick: function onClick() {
	                  _this4.props.addRiderItem({
	                    class: "instrument",
	                    position: item.position + 1,
	                    parent: item.parent || null,
	                    indexes: _this4.props.parentRowIndex !== undefined ? [_this4.props.parentRowIndex, _this4.props.rowIndex + 1] : [_this4.props.rowIndex + 1]
	                  });
	                } },
	              _react2.default.createElement('button', { className: 'button--add-row oval-button', 'data-value': 'Insert row', tabIndex: '-1' })
	            ) : null
	          );
	        }
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          columns = _props.columns,
	          item = _props.item,
	          parentItem = _props.parentItem,
	          paging = _props.paging,
	          stageElements = _props.stageElements,
	          options = _props.options,
	          categories = _props.categories;
	
	
	      return item.id !== undefined ? this.renderTableRow(item, parentItem, paging, stageElements, options, categories) : this.renderEmptyTableRow(columns, item, paging, stageElements, options, categories);
	    }
	  }]);
	
	  return TableRow;
	}(_react.Component);
	
	TableRow.propTypes = {
	  view: _propTypes2.default.object,
	  dragDropType: _propTypes2.default.string,
	  group: _propTypes2.default.string,
	  columns: _propTypes2.default.array,
	  item: _propTypes2.default.object,
	  rowIndex: _propTypes2.default.number,
	  parentItem: _propTypes2.default.object,
	  parentRowIndex: _propTypes2.default.number,
	  paging: _propTypes2.default.object,
	  itemGroups: _propTypes2.default.array,
	  changeFocus: _propTypes2.default.func,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  options: _propTypes2.default.array,
	  categories: _propTypes2.default.array,
	  createStageElement: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func
	};
	
	TableRow.defaultProps = {
	  view: {},
	  dragDropType: '',
	  group: '',
	  columns: [],
	  item: {},
	  rowIndex: undefined,
	  parentItem: {},
	  parentRowIndex: undefined,
	  paging: {},
	  itemGroups: [],
	  changeFocus: function changeFocus() {},
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  stageElements: {},
	  options: undefined,
	  categories: undefined,
	  createStageElement: function createStageElement() {},
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = TableRow;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RangeForm = function (_Component) {
	  _inherits(RangeForm, _Component);
	
	  function RangeForm(props) {
	    _classCallCheck(this, RangeForm);
	
	    var _this = _possibleConstructorReturn(this, (RangeForm.__proto__ || Object.getPrototypeOf(RangeForm)).call(this, props));
	
	    _this.state = {
	      value: 0
	    };
	    return _this;
	  }
	
	  _createClass(RangeForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var value = this.props.value;
	
	
	      this.setState({ value: value });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var value = nextProps.value;
	
	
	      if (value !== this.props.value) this.setState({ value: value });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var child = nextProps.child,
	          value = nextProps.value;
	
	
	      if (child !== this.props.child) return true;
	      if (value !== this.props.value) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'onValueChange',
	    value: function onValueChange(child, value) {
	      if (child.id !== undefined) {
	        this.props.editRiderItem({
	          id: child.id,
	          value: value
	        });
	      } else {
	        this.props.createRiderItem({
	          value: value,
	          class: child.class,
	          parent: child.parent,
	          relation: child.relation,
	          type: 'monitor',
	          title: 'Monitor',
	          position: 0
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          child = _props.child;
	      var value = this.state.value;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'range-form' },
	        _react2.default.createElement('input', { className: 'fader',
	          type: 'range',
	          min: '0',
	          max: '10',
	          value: value,
	          'data-value': value * 10,
	          onChange: function onChange(e) {
	            return view.editable ? _this2.setState({ value: e.target.value }) : null;
	          },
	          onMouseUp: function onMouseUp() {
	            return view.editable ? _this2.onValueChange(child, value) : null;
	          } })
	      );
	    }
	  }]);
	
	  return RangeForm;
	}(_react.Component);
	
	RangeForm.propTypes = {
	  view: _propTypes2.default.object,
	  child: _propTypes2.default.object,
	  value: _propTypes2.default.number,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func
	};
	
	RangeForm.defaultProps = {
	  view: {},
	  child: {},
	  value: null,
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {}
	};
	
	exports.default = RangeForm;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(20);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectForm = function (_Component) {
	  _inherits(SelectForm, _Component);
	
	  function SelectForm(props) {
	    _classCallCheck(this, SelectForm);
	
	    var _this = _possibleConstructorReturn(this, (SelectForm.__proto__ || Object.getPrototypeOf(SelectForm)).call(this, props));
	
	    _this.state = {
	      itemSelectorValue: '',
	      selectedItem: undefined,
	      showMemberSelector: false
	    };
	
	    _this.memberSelector = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(SelectForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          item = _props.item,
	          focusMemberSelector = _props.focusMemberSelector;
	
	
	      if (focusMemberSelector) {
	        this.setState({
	          selectedItem: { title: item.title, type: item.type.slug },
	          showMemberSelector: true
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var showMemberSelector = this.state.showMemberSelector;
	
	
	      if (showMemberSelector === true) this.memberSelector.current.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          value = _props2.value,
	          item = _props2.item,
	          itemTypes = _props2.itemTypes,
	          members = _props2.members;
	      var _state = this.state,
	          itemSelectorValue = _state.itemSelectorValue,
	          selectedItem = _state.selectedItem;
	
	
	      var enableMemberSelector = item.indexes ? true : false; // added new monitor
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'select-form' },
	        _react2.default.createElement('div', { className: 'select-form-escape', onClick: function onClick() {
	            return _this2.props.removeFocus();
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'select-form-fields' },
	          _react2.default.createElement(_reactSelect.Creatable, {
	            autoFocus: selectedItem === undefined ? true : false,
	            openOnFocus: true,
	            className: 'select-form-field',
	            value: selectedItem || value,
	            valueKey: 'id',
	            labelKey: 'title',
	            clearable: false,
	            placeholder: item.value || item.title || "Select monitor type",
	            noResultsText: 'Please choose "Wedge monitor" or "In-ear monitor"',
	            onInputChange: function onInputChange(input) {
	              _this2.setState({ itemSelectorValue: input });
	
	              return input;
	            },
	            onChange: function onChange(_ref) {
	              var id = _ref.id,
	                  title = _ref.title,
	                  type = _ref.type,
	                  name = _ref.name;
	
	              if (type) {
	                // selected 'monitor type'
	                selectedItem = { title: title, type: type };
	              } else {
	                // selected 'assign a member'
	                selectedItem = { title: item.title, type: item.type.slug };
	                enableMemberSelector = true;
	              }
	              if (name) selectedItem = { title: 'Monitor (' + name + ')', member: id, value: null // assigned 'member'
	
	              };if (enableMemberSelector) {
	                _this2.setState({ selectedItem: selectedItem, showMemberSelector: true });
	              } else {
	                _this2.props.onItemSelect(selectedItem);
	              }
	            },
	            promptTextCreator: function promptTextCreator(label) {
	              return 'Assign monitor to "' + label + '"';
	            },
	            onNewOptionClick: function onNewOptionClick(_ref2) {
	              var title = _ref2.title;
	
	              var name = title;
	              selectedItem = { title: 'Monitor (' + name + ')', value: name };
	
	              _this2.setState({ selectedItem: selectedItem, showMemberSelector: true });
	            },
	            options: itemSelectorValue.length === 0 ? itemTypes : members.map(function (member) {
	              return { id: member.id, title: member.name, name: member.name };
	            }) }),
	          this.state.showMemberSelector ? selectedItem.member || selectedItem.value ? _react2.default.createElement(_reactSelect2.default, {
	            ref: this.memberSelector,
	            cache: false,
	            autoFocus: selectedItem ? true : false,
	            openOnFocus: true,
	            className: 'select-form-field',
	            value: undefined,
	            valueKey: 'id',
	            labelKey: 'title',
	            clearable: false,
	            placeholder: 'Select monitor type',
	            onChange: function onChange(_ref3) {
	              var title = _ref3.title,
	                  type = _ref3.type;
	
	              if (type) selectedItem = Object.assign({}, selectedItem, { title: title, type: type });
	
	              _this2.props.onItemSelect(selectedItem);
	            },
	            options: itemTypes }) : _react2.default.createElement(_reactSelect.Creatable, {
	            ref: this.memberSelector,
	            cache: false,
	            autoFocus: selectedItem ? true : false,
	            openOnFocus: true,
	            className: 'select-form-field',
	            value: undefined,
	            valueKey: 'id',
	            labelKey: 'name',
	            clearable: false,
	            placeholder: 'Assign this monitor to...',
	            onChange: function onChange(_ref4) {
	              var id = _ref4.id,
	                  name = _ref4.name;
	
	              if (id) selectedItem = Object.assign({}, selectedItem, { member: id, value: null });
	
	              _this2.props.onItemSelect(selectedItem);
	            },
	            promptTextCreator: function promptTextCreator(label) {
	              return 'Name as "' + label + '"';
	            },
	            onNewOptionClick: function onNewOptionClick(_ref5) {
	              var name = _ref5.name;
	
	              selectedItem = Object.assign({}, selectedItem, { member: null, value: name });
	
	              _this2.props.onItemSelect(selectedItem);
	            },
	            options: [].concat(_toConsumableArray(members), [{ id: null, name: 'Not right now' }]) }) : null
	        )
	      );
	    }
	  }]);
	
	  return SelectForm;
	}(_react.Component);
	
	SelectForm.propTypes = {
	  value: _propTypes2.default.string,
	  item: _propTypes2.default.object,
	  itemTypes: _propTypes2.default.array,
	  members: _propTypes2.default.array,
	  focusMemberSelector: _propTypes2.default.bool,
	  onItemSelect: _propTypes2.default.func,
	  removeFocus: _propTypes2.default.func
	};
	
	SelectForm.defaultProps = {
	  value: '',
	  item: {},
	  itemTypes: [],
	  members: [],
	  focusMemberSelector: undefined,
	  onItemSelect: function onItemSelect() {},
	  removeFocus: function removeFocus() {}
	};
	
	exports.default = SelectForm;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _listItem = __webpack_require__(320);
	
	var _listItem2 = _interopRequireDefault(_listItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List(props) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));
	
	    _this.reorderList = function (result) {
	      if (!result.destination) return null;
	
	      var items = (0, _functions.reorder)(_this.state.items, result.source.index, result.destination.index);
	
	      _this.setState({ items: items }, function () {
	        return _this.props.moveRiderItem({ id: result.draggableId, position: result.destination.index + 1 });
	      });
	    };
	
	    _this.state = {
	      items: []
	    };
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var items = this.props.items;
	
	
	      this.setState({ items: items });
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var items = nextProps.items;
	
	
	      if (items !== this.props.items) this.setState({ items: items });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          requirements = _props.requirements;
	      var items = this.state.items;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'list' },
	        _react2.default.createElement(
	          _reactBeautifulDnd.DragDropContext,
	          { onDragEnd: this.reorderList },
	          _react2.default.createElement(
	            _reactBeautifulDnd.Droppable,
	            { droppableId: 'list', isDropDisabled: !view.editable, type: 'requirement' },
	            function (provided, snapshot) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'list--droppable',
	                  ref: provided.innerRef },
	                items.length > 0 ? items.map(function (item, index) {
	                  return item.class === 'requirement' ? _react2.default.createElement(_listItem2.default, { key: item.id || index,
	                    view: view,
	                    item: item,
	                    required: item.required,
	                    removeRiderItem: _this2.props.removeRiderItem,
	                    createRiderItem: function createRiderItem(item) {
	                      return _this2.props.createRiderItem(Object.assign({}, item));
	                    },
	                    editRiderItem: _this2.props.editRiderItem,
	                    deleteRiderItem: _this2.props.deleteRiderItem }) : null;
	                }) : _react2.default.createElement(
	                  'p',
	                  null,
	                  'Start by adding your ',
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                        _this2.props.addRiderItem(Object.assign({}, requirements, {
	                          position: items.length + 1,
	                          indexes: [items.length]
	                        }));
	                      } },
	                    'first requirement'
	                  ),
	                  '.'
	                ),
	                provided.placeholder
	              );
	            }
	          )
	        ),
	        view.editable ? _react2.default.createElement(
	          'button',
	          { className: 'list--add-button button--link', onClick: function onClick() {
	              _this2.props.addRiderItem(Object.assign({}, requirements, {
	                position: items.length + 1,
	                indexes: [items.length]
	              }));
	            } },
	          'Insert ',
	          requirements.title
	        ) : null
	      );
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	List.propTypes = {
	  view: _propTypes2.default.object,
	  requirements: _propTypes2.default.object,
	  items: _propTypes2.default.array,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func
	};
	
	List.defaultProps = {
	  view: {},
	  requirements: {},
	  items: [],
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {}
	};
	
	exports.default = List;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageplanSidebarItem = function (_Component) {
	  _inherits(StageplanSidebarItem, _Component);
	
	  function StageplanSidebarItem(props) {
	    _classCallCheck(this, StageplanSidebarItem);
	
	    var _this = _possibleConstructorReturn(this, (StageplanSidebarItem.__proto__ || Object.getPrototypeOf(StageplanSidebarItem)).call(this, props));
	
	    _this.item = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(StageplanSidebarItem, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          item = _props.item,
	          itemIndex = _props.itemIndex,
	          parentItemIndex = _props.parentItemIndex,
	          existingItem = _props.existingItem,
	          fontSize = _props.fontSize,
	          hideAnimation = _props.hideAnimation;
	
	
	      var className = function className(snapshot) {
	        return (0, _classnames2.default)({
	          'stageplan-sidebar-item': true,
	          'stageplan-sidebar-item--disabled': existingItem,
	          'stageplan-sidebar-item--hidden': snapshot.isDragging && hideAnimation
	        });
	      };
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Draggable,
	        { draggableId: !isNaN(parentItemIndex) ? parentItemIndex + '-' + itemIndex : itemIndex, isDragDisabled: existingItem, type: 'stageplan' },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'li',
	            { ref: provided.innerRef },
	            _react2.default.createElement(
	              'div',
	              { className: className(snapshot), style: provided.draggableStyle },
	              _react2.default.createElement(
	                'div',
	                Object.assign({ className: 'stageplan-item', ref: _this2.item,
	                  style: {
	                    fontSize: fontSize,
	                    padding: fontSize * 0.5 + 'px ' + fontSize * 1.5 + 'px'
	                  },
	                  onMouseEnter: function onMouseEnter() {
	                    if (existingItem) _this2.props.setRiderStageplanItemFocus(existingItem);
	                  },
	                  onMouseLeave: function onMouseLeave() {
	                    return _this2.props.setRiderStageplanItemFocus(undefined);
	                  },
	                  onMouseMove: function onMouseMove(e) {
	                    if (!existingItem) {
	                      var clientRect = _reactDom2.default.findDOMNode(_this2.item.current).getBoundingClientRect();
	                      var width = clientRect.width,
	                          height = clientRect.height;
	
	
	                      var x = e.nativeEvent.offsetX;
	                      var y = e.nativeEvent.offsetY;
	
	                      _this2.props.setDragStartOffset({
	                        width: width,
	                        height: height,
	                        x: width / 2 - x,
	                        y: height / 2 - y
	                      });
	                    }
	                  },
	                  onDoubleClick: function onDoubleClick(e) {
	                    if (!existingItem) _this2.props.createRiderStageplanItem(item);
	                  }
	                }, provided.dragHandleProps),
	                item.channel ? _react2.default.createElement(
	                  'span',
	                  { className: 'channel', style: { fontSize: fontSize * 1.1 } },
	                  item.channel
	                ) : null,
	                item.value || item.title || item.name
	              )
	            ),
	            provided.placeholder
	          );
	        }
	      );
	    }
	  }]);
	
	  return StageplanSidebarItem;
	}(_react.Component);
	
	StageplanSidebarItem.propTypes = {
	  item: _propTypes2.default.object,
	  itemIndex: _propTypes2.default.number,
	  parentItemIndex: _propTypes2.default.number,
	  existingItem: _propTypes2.default.string,
	  fontSize: _propTypes2.default.number,
	  hideAnimation: _propTypes2.default.bool,
	  setDragStartOffset: _propTypes2.default.func,
	  setRiderStageplanItemFocus: _propTypes2.default.func,
	  createRiderStageplanItem: _propTypes2.default.func
	};
	
	StageplanSidebarItem.defaultProps = {
	  item: {},
	  itemIndex: undefined,
	  parentItemIndex: undefined,
	  existingItem: undefined,
	  fontSize: 12,
	  hideAnimation: false,
	  setDragStartOffset: function setDragStartOffset() {},
	  setRiderStageplanItemFocus: function setRiderStageplanItemFocus() {},
	  createRiderStageplanItem: function createRiderStageplanItem() {}
	};
	
	exports.default = StageplanSidebarItem;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(365), __esModule: true };

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(51);
	var document = __webpack_require__(29).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(37) && !__webpack_require__(49)(function () {
	  return Object.defineProperty(__webpack_require__(171)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(99);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(103);
	var $export = __webpack_require__(28);
	var redefine = __webpack_require__(180);
	var hide = __webpack_require__(50);
	var Iterators = __webpack_require__(61);
	var $iterCreate = __webpack_require__(381);
	var setToStringTag = __webpack_require__(106);
	var getPrototypeOf = __webpack_require__(177);
	var ITERATOR = __webpack_require__(22)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(74);
	var createDesc = __webpack_require__(63);
	var toIObject = __webpack_require__(52);
	var toPrimitive = __webpack_require__(110);
	var has = __webpack_require__(38);
	var IE8_DOM_DEFINE = __webpack_require__(172);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(37) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(178);
	var hiddenKeys = __webpack_require__(102).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(38);
	var toObject = __webpack_require__(64);
	var IE_PROTO = __webpack_require__(107)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(38);
	var toIObject = __webpack_require__(52);
	var arrayIndexOf = __webpack_require__(373)(false);
	var IE_PROTO = __webpack_require__(107)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(28);
	var core = __webpack_require__(17);
	var fails = __webpack_require__(49);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(50);


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(109);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(389)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(174)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 183 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(77);
	
	var _PathUtils = __webpack_require__(53);
	
	var _createTransitionManager = __webpack_require__(114);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(77);
	
	var _PathUtils = __webpack_require__(53);
	
	var _createTransitionManager = __webpack_require__(114);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(53);
	
	var _LocationUtils = __webpack_require__(77);
	
	var _createTransitionManager = __webpack_require__(114);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FontMetrics = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Util = __webpack_require__(55);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SAMPLE_TEXT = 'Hidden Text';
	
	var FontMetrics = exports.FontMetrics = function () {
	    function FontMetrics(document) {
	        _classCallCheck(this, FontMetrics);
	
	        this._data = {};
	        this._document = document;
	    }
	
	    _createClass(FontMetrics, [{
	        key: '_parseMetrics',
	        value: function _parseMetrics(font) {
	            var container = this._document.createElement('div');
	            var img = this._document.createElement('img');
	            var span = this._document.createElement('span');
	
	            var body = this._document.body;
	            if (!body) {
	                throw new Error( false ? 'No document found for font metrics' : '');
	            }
	
	            container.style.visibility = 'hidden';
	            container.style.fontFamily = font.fontFamily;
	            container.style.fontSize = font.fontSize;
	            container.style.margin = '0';
	            container.style.padding = '0';
	
	            body.appendChild(container);
	
	            img.src = _Util.SMALL_IMAGE;
	            img.width = 1;
	            img.height = 1;
	
	            img.style.margin = '0';
	            img.style.padding = '0';
	            img.style.verticalAlign = 'baseline';
	
	            span.style.fontFamily = font.fontFamily;
	            span.style.fontSize = font.fontSize;
	            span.style.margin = '0';
	            span.style.padding = '0';
	
	            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
	            container.appendChild(span);
	            container.appendChild(img);
	            var baseline = img.offsetTop - span.offsetTop + 2;
	
	            container.removeChild(span);
	            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
	
	            container.style.lineHeight = 'normal';
	            img.style.verticalAlign = 'super';
	
	            var middle = img.offsetTop - container.offsetTop + 2;
	
	            body.removeChild(container);
	
	            return { baseline: baseline, middle: middle };
	        }
	    }, {
	        key: 'getMetrics',
	        value: function getMetrics(font) {
	            var key = font.fontFamily + ' ' + font.fontSize;
	            if (this._data[key] === undefined) {
	                this._data[key] = this._parseMetrics(font);
	            }
	
	            return this._data[key];
	        }
	    }]);
	
	    return FontMetrics;
	}();

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.reformatInputBounds = exports.inlineSelectElement = exports.inlineTextAreaElement = exports.inlineInputElement = exports.getInputBorderRadius = exports.INPUT_BACKGROUND = exports.INPUT_BORDERS = exports.INPUT_COLOR = undefined;
	
	var _TextContainer = __webpack_require__(79);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _background = __webpack_require__(65);
	
	var _border = __webpack_require__(116);
	
	var _Circle = __webpack_require__(431);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	var _Vector = __webpack_require__(81);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	var _Color = __webpack_require__(31);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Length = __webpack_require__(40);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	var _Bounds = __webpack_require__(39);
	
	var _TextBounds = __webpack_require__(192);
	
	var _Util = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INPUT_COLOR = exports.INPUT_COLOR = new _Color2.default([42, 42, 42]);
	var INPUT_BORDER_COLOR = new _Color2.default([165, 165, 165]);
	var INPUT_BACKGROUND_COLOR = new _Color2.default([222, 222, 222]);
	var INPUT_BORDER = {
	    borderWidth: 1,
	    borderColor: INPUT_BORDER_COLOR,
	    borderStyle: _border.BORDER_STYLE.SOLID
	};
	var INPUT_BORDERS = exports.INPUT_BORDERS = [INPUT_BORDER, INPUT_BORDER, INPUT_BORDER, INPUT_BORDER];
	var INPUT_BACKGROUND = exports.INPUT_BACKGROUND = {
	    backgroundColor: INPUT_BACKGROUND_COLOR,
	    backgroundImage: [],
	    backgroundClip: _background.BACKGROUND_CLIP.PADDING_BOX,
	    backgroundOrigin: _background.BACKGROUND_ORIGIN.PADDING_BOX
	};
	
	var RADIO_BORDER_RADIUS = new _Length2.default('50%');
	var RADIO_BORDER_RADIUS_TUPLE = [RADIO_BORDER_RADIUS, RADIO_BORDER_RADIUS];
	var INPUT_RADIO_BORDER_RADIUS = [RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE];
	
	var CHECKBOX_BORDER_RADIUS = new _Length2.default('3px');
	var CHECKBOX_BORDER_RADIUS_TUPLE = [CHECKBOX_BORDER_RADIUS, CHECKBOX_BORDER_RADIUS];
	var INPUT_CHECKBOX_BORDER_RADIUS = [CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE];
	
	var getInputBorderRadius = exports.getInputBorderRadius = function getInputBorderRadius(node) {
	    return node.type === 'radio' ? INPUT_RADIO_BORDER_RADIUS : INPUT_CHECKBOX_BORDER_RADIUS;
	};
	
	var inlineInputElement = exports.inlineInputElement = function inlineInputElement(node, container) {
	    if (node.type === 'radio' || node.type === 'checkbox') {
	        if (node.checked) {
	            var size = Math.min(container.bounds.width, container.bounds.height);
	            container.childNodes.push(node.type === 'checkbox' ? [new _Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79), new _Vector2.default(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549), new _Vector2.default(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071), new _Vector2.default(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649), new _Vector2.default(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23), new _Vector2.default(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085), new _Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)] : new _Circle2.default(container.bounds.left + size / 4, container.bounds.top + size / 4, size / 4));
	        }
	    } else {
	        inlineFormElement(getInputValue(node), node, container, false);
	    }
	};
	
	var inlineTextAreaElement = exports.inlineTextAreaElement = function inlineTextAreaElement(node, container) {
	    inlineFormElement(node.value, node, container, true);
	};
	
	var inlineSelectElement = exports.inlineSelectElement = function inlineSelectElement(node, container) {
	    var option = node.options[node.selectedIndex || 0];
	    inlineFormElement(option ? option.text || '' : '', node, container, false);
	};
	
	var reformatInputBounds = exports.reformatInputBounds = function reformatInputBounds(bounds) {
	    if (bounds.width > bounds.height) {
	        bounds.left += (bounds.width - bounds.height) / 2;
	        bounds.width = bounds.height;
	    } else if (bounds.width < bounds.height) {
	        bounds.top += (bounds.height - bounds.width) / 2;
	        bounds.height = bounds.width;
	    }
	    return bounds;
	};
	
	var inlineFormElement = function inlineFormElement(value, node, container, allowLinebreak) {
	    var body = node.ownerDocument.body;
	    if (value.length > 0 && body) {
	        var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
	        (0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node, null), wrapper);
	        wrapper.style.position = 'absolute';
	        wrapper.style.left = container.bounds.left + 'px';
	        wrapper.style.top = container.bounds.top + 'px';
	        if (!allowLinebreak) {
	            wrapper.style.whiteSpace = 'nowrap';
	        }
	        var text = node.ownerDocument.createTextNode(value);
	        wrapper.appendChild(text);
	        body.appendChild(wrapper);
	        container.childNodes.push(_TextContainer2.default.fromTextNode(text, container));
	        body.removeChild(wrapper);
	    }
	};
	
	var getInputValue = function getInputValue(node) {
	    var value = node.type === 'password' ? new Array(node.value.length + 1).join('\u2022') : node.value;
	
	    return value.length === 0 ? node.placeholder || '' : value;
	};

/***/ },
/* 190 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Logger = function () {
	    function Logger(enabled, id, start) {
	        _classCallCheck(this, Logger);
	
	        this.enabled = typeof window !== 'undefined' && enabled;
	        this.start = start ? start : Date.now();
	        this.id = id;
	    }
	
	    _createClass(Logger, [{
	        key: 'child',
	        value: function child(id) {
	            return new Logger(this.enabled, id, this.start);
	        }
	
	        // eslint-disable-next-line flowtype/no-weak-types
	
	    }, {
	        key: 'log',
	        value: function log() {
	            if (this.enabled && window.console && window.console.log) {
	                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                    args[_key] = arguments[_key];
	                }
	
	                Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [Date.now() - this.start + 'ms', this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'].concat([].slice.call(args, 0)));
	            }
	        }
	
	        // eslint-disable-next-line flowtype/no-weak-types
	
	    }, {
	        key: 'error',
	        value: function error() {
	            if (this.enabled && window.console && window.console.error) {
	                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	                    args[_key2] = arguments[_key2];
	                }
	
	                Function.prototype.bind.call(window.console.error, window.console).apply(window.console, [Date.now() - this.start + 'ms', this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'].concat([].slice.call(args, 0)));
	            }
	        }
	    }]);
	
	    return Logger;
	}();
	
	exports.default = Logger;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Proxy = undefined;
	
	var _Feature = __webpack_require__(78);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Proxy = exports.Proxy = function Proxy(src, options) {
	    if (!options.proxy) {
	        return Promise.reject( false ? 'No proxy defined' : null);
	    }
	    var proxy = options.proxy;
	
	    return new Promise(function (resolve, reject) {
	        var responseType = _Feature2.default.SUPPORT_CORS_XHR && _Feature2.default.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
	        var xhr = _Feature2.default.SUPPORT_CORS_XHR ? new XMLHttpRequest() : new XDomainRequest();
	        xhr.onload = function () {
	            if (xhr instanceof XMLHttpRequest) {
	                if (xhr.status === 200) {
	                    if (responseType === 'text') {
	                        resolve(xhr.response);
	                    } else {
	                        var reader = new FileReader();
	                        // $FlowFixMe
	                        reader.addEventListener('load', function () {
	                            return resolve(reader.result);
	                        }, false);
	                        // $FlowFixMe
	                        reader.addEventListener('error', function (e) {
	                            return reject(e);
	                        }, false);
	                        reader.readAsDataURL(xhr.response);
	                    }
	                } else {
	                    reject( false ? 'Failed to proxy resource ' + src.substring(0, 256) + ' with status code ' + xhr.status : '');
	                }
	            } else {
	                resolve(xhr.responseText);
	            }
	        };
	
	        xhr.onerror = reject;
	        xhr.open('GET', proxy + '?url=' + encodeURIComponent(src) + '&responseType=' + responseType);
	
	        if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
	            xhr.responseType = responseType;
	        }
	
	        if (options.imageTimeout) {
	            var timeout = options.imageTimeout;
	            xhr.timeout = timeout;
	            xhr.ontimeout = function () {
	                return reject( false ? 'Timed out (' + timeout + 'ms) proxying ' + src.substring(0, 256) : '');
	            };
	        }
	
	        xhr.send();
	    });
	};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTextBounds = exports.TextBounds = undefined;
	
	var _Bounds = __webpack_require__(39);
	
	var _textDecoration = __webpack_require__(117);
	
	var _Feature = __webpack_require__(78);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _Unicode = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TextBounds = exports.TextBounds = function TextBounds(text, bounds) {
	    _classCallCheck(this, TextBounds);
	
	    this.text = text;
	    this.bounds = bounds;
	};
	
	var parseTextBounds = exports.parseTextBounds = function parseTextBounds(value, parent, node) {
	    var letterRendering = parent.style.letterSpacing !== 0;
	    var textList = letterRendering ? (0, _Unicode.toCodePoints)(value).map(function (i) {
	        return (0, _Unicode.fromCodePoint)(i);
	    }) : (0, _Unicode.breakWords)(value, parent);
	    var length = textList.length;
	    var defaultView = node.parentNode ? node.parentNode.ownerDocument.defaultView : null;
	    var scrollX = defaultView ? defaultView.pageXOffset : 0;
	    var scrollY = defaultView ? defaultView.pageYOffset : 0;
	    var textBounds = [];
	    var offset = 0;
	    for (var i = 0; i < length; i++) {
	        var text = textList[i];
	        if (parent.style.textDecoration !== _textDecoration.TEXT_DECORATION.NONE || text.trim().length > 0) {
	            if (_Feature2.default.SUPPORT_RANGE_BOUNDS) {
	                textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length, scrollX, scrollY)));
	            } else {
	                var replacementNode = node.splitText(text.length);
	                textBounds.push(new TextBounds(text, getWrapperBounds(node, scrollX, scrollY)));
	                node = replacementNode;
	            }
	        } else if (!_Feature2.default.SUPPORT_RANGE_BOUNDS) {
	            node = node.splitText(text.length);
	        }
	        offset += text.length;
	    }
	    return textBounds;
	};
	
	var getWrapperBounds = function getWrapperBounds(node, scrollX, scrollY) {
	    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
	    wrapper.appendChild(node.cloneNode(true));
	    var parentNode = node.parentNode;
	    if (parentNode) {
	        parentNode.replaceChild(wrapper, node);
	        var bounds = (0, _Bounds.parseBounds)(wrapper, scrollX, scrollY);
	        if (wrapper.firstChild) {
	            parentNode.replaceChild(wrapper.firstChild, wrapper);
	        }
	        return bounds;
	    }
	    return new _Bounds.Bounds(0, 0, 0, 0);
	};
	
	var getRangeBounds = function getRangeBounds(node, offset, length, scrollX, scrollY) {
	    var range = node.ownerDocument.createRange();
	    range.setStart(node, offset);
	    range.setEnd(node, offset + length);
	    return _Bounds.Bounds.fromClientRect(range.getBoundingClientRect(), scrollX, scrollY);
	};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.breakWords = exports.fromCodePoint = exports.toCodePoints = undefined;
	
	var _cssLineBreak = __webpack_require__(407);
	
	Object.defineProperty(exports, 'toCodePoints', {
	    enumerable: true,
	    get: function get() {
	        return _cssLineBreak.toCodePoints;
	    }
	});
	Object.defineProperty(exports, 'fromCodePoint', {
	    enumerable: true,
	    get: function get() {
	        return _cssLineBreak.fromCodePoint;
	    }
	});
	
	var _NodeContainer = __webpack_require__(54);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _overflowWrap = __webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var breakWords = exports.breakWords = function breakWords(str, parent) {
	    var breaker = (0, _cssLineBreak.LineBreaker)(str, {
	        lineBreak: parent.style.lineBreak,
	        wordBreak: parent.style.overflowWrap === _overflowWrap.OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : parent.style.wordBreak
	    });
	
	    var words = [];
	    var bk = void 0;
	
	    while (!(bk = breaker.next()).done) {
	        words.push(bk.value.slice());
	    }
	
	    return words;
	};

/***/ },
/* 194 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var OVERFLOW_WRAP = exports.OVERFLOW_WRAP = {
	    NORMAL: 0,
	    BREAK_WORD: 1
	};
	
	var parseOverflowWrap = exports.parseOverflowWrap = function parseOverflowWrap(overflow) {
	    switch (overflow) {
	        case 'break-word':
	            return OVERFLOW_WRAP.BREAK_WORD;
	        case 'normal':
	        default:
	            return OVERFLOW_WRAP.NORMAL;
	    }
	};

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parsePadding = exports.PADDING_SIDES = undefined;
	
	var _Length = __webpack_require__(40);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PADDING_SIDES = exports.PADDING_SIDES = {
	    TOP: 0,
	    RIGHT: 1,
	    BOTTOM: 2,
	    LEFT: 3
	};
	
	var SIDES = ['top', 'right', 'bottom', 'left'];
	
	var parsePadding = exports.parsePadding = function parsePadding(style) {
	    return SIDES.map(function (side) {
	        return new _Length2.default(style.getPropertyValue('padding-' + side));
	    });
	};

/***/ },
/* 196 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var POSITION = exports.POSITION = {
	    STATIC: 0,
	    RELATIVE: 1,
	    ABSOLUTE: 2,
	    FIXED: 3,
	    STICKY: 4
	};
	
	var parsePosition = exports.parsePosition = function parsePosition(position) {
	    switch (position) {
	        case 'relative':
	            return POSITION.RELATIVE;
	        case 'absolute':
	            return POSITION.ABSOLUTE;
	        case 'fixed':
	            return POSITION.FIXED;
	        case 'sticky':
	            return POSITION.STICKY;
	    }
	
	    return POSITION.STATIC;
	};

/***/ },
/* 197 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TEXT_TRANSFORM = exports.TEXT_TRANSFORM = {
	    NONE: 0,
	    LOWERCASE: 1,
	    UPPERCASE: 2,
	    CAPITALIZE: 3
	};
	
	var parseTextTransform = exports.parseTextTransform = function parseTextTransform(textTransform) {
	    switch (textTransform) {
	        case 'uppercase':
	            return TEXT_TRANSFORM.UPPERCASE;
	        case 'lowercase':
	            return TEXT_TRANSFORM.LOWERCASE;
	        case 'capitalize':
	            return TEXT_TRANSFORM.CAPITALIZE;
	    }
	
	    return TEXT_TRANSFORM.NONE;
	};

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Path = __webpack_require__(80);
	
	var _textDecoration = __webpack_require__(117);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var addColorStops = function addColorStops(gradient, canvasGradient) {
	    var maxStop = Math.max.apply(null, gradient.colorStops.map(function (colorStop) {
	        return colorStop.stop;
	    }));
	    var f = 1 / Math.max(1, maxStop);
	    gradient.colorStops.forEach(function (colorStop) {
	        canvasGradient.addColorStop(f * colorStop.stop, colorStop.color.toString());
	    });
	};
	
	var CanvasRenderer = function () {
	    function CanvasRenderer(canvas) {
	        _classCallCheck(this, CanvasRenderer);
	
	        this.canvas = canvas ? canvas : document.createElement('canvas');
	    }
	
	    _createClass(CanvasRenderer, [{
	        key: 'render',
	        value: function render(options) {
	            this.ctx = this.canvas.getContext('2d');
	            this.options = options;
	            this.canvas.width = Math.floor(options.width * options.scale);
	            this.canvas.height = Math.floor(options.height * options.scale);
	            this.canvas.style.width = options.width + 'px';
	            this.canvas.style.height = options.height + 'px';
	
	            this.ctx.scale(this.options.scale, this.options.scale);
	            this.ctx.translate(-options.x, -options.y);
	            this.ctx.textBaseline = 'bottom';
	            options.logger.log('Canvas renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + this.options.scale);
	        }
	    }, {
	        key: 'clip',
	        value: function clip(clipPaths, callback) {
	            var _this = this;
	
	            if (clipPaths.length) {
	                this.ctx.save();
	                clipPaths.forEach(function (path) {
	                    _this.path(path);
	                    _this.ctx.clip();
	                });
	            }
	
	            callback();
	
	            if (clipPaths.length) {
	                this.ctx.restore();
	            }
	        }
	    }, {
	        key: 'drawImage',
	        value: function drawImage(image, source, destination) {
	            this.ctx.drawImage(image, source.left, source.top, source.width, source.height, destination.left, destination.top, destination.width, destination.height);
	        }
	    }, {
	        key: 'drawShape',
	        value: function drawShape(path, color) {
	            this.path(path);
	            this.ctx.fillStyle = color.toString();
	            this.ctx.fill();
	        }
	    }, {
	        key: 'fill',
	        value: function fill(color) {
	            this.ctx.fillStyle = color.toString();
	            this.ctx.fill();
	        }
	    }, {
	        key: 'getTarget',
	        value: function getTarget() {
	            this.canvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
	            return Promise.resolve(this.canvas);
	        }
	    }, {
	        key: 'path',
	        value: function path(_path) {
	            var _this2 = this;
	
	            this.ctx.beginPath();
	            if (Array.isArray(_path)) {
	                _path.forEach(function (point, index) {
	                    var start = point.type === _Path.PATH.VECTOR ? point : point.start;
	                    if (index === 0) {
	                        _this2.ctx.moveTo(start.x, start.y);
	                    } else {
	                        _this2.ctx.lineTo(start.x, start.y);
	                    }
	
	                    if (point.type === _Path.PATH.BEZIER_CURVE) {
	                        _this2.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
	                    }
	                });
	            } else {
	                this.ctx.arc(_path.x + _path.radius, _path.y + _path.radius, _path.radius, 0, Math.PI * 2, true);
	            }
	
	            this.ctx.closePath();
	        }
	    }, {
	        key: 'rectangle',
	        value: function rectangle(x, y, width, height, color) {
	            this.ctx.fillStyle = color.toString();
	            this.ctx.fillRect(x, y, width, height);
	        }
	    }, {
	        key: 'renderLinearGradient',
	        value: function renderLinearGradient(bounds, gradient) {
	            var linearGradient = this.ctx.createLinearGradient(bounds.left + gradient.direction.x1, bounds.top + gradient.direction.y1, bounds.left + gradient.direction.x0, bounds.top + gradient.direction.y0);
	
	            addColorStops(gradient, linearGradient);
	            this.ctx.fillStyle = linearGradient;
	            this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
	        }
	    }, {
	        key: 'renderRadialGradient',
	        value: function renderRadialGradient(bounds, gradient) {
	            var _this3 = this;
	
	            var x = bounds.left + gradient.center.x;
	            var y = bounds.top + gradient.center.y;
	
	            var radialGradient = this.ctx.createRadialGradient(x, y, 0, x, y, gradient.radius.x);
	            if (!radialGradient) {
	                return;
	            }
	
	            addColorStops(gradient, radialGradient);
	            this.ctx.fillStyle = radialGradient;
	
	            if (gradient.radius.x !== gradient.radius.y) {
	                // transforms for elliptical radial gradient
	                var midX = bounds.left + 0.5 * bounds.width;
	                var midY = bounds.top + 0.5 * bounds.height;
	                var f = gradient.radius.y / gradient.radius.x;
	                var invF = 1 / f;
	
	                this.transform(midX, midY, [1, 0, 0, f, 0, 0], function () {
	                    return _this3.ctx.fillRect(bounds.left, invF * (bounds.top - midY) + midY, bounds.width, bounds.height * invF);
	                });
	            } else {
	                this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
	            }
	        }
	    }, {
	        key: 'renderRepeat',
	        value: function renderRepeat(path, image, imageSize, offsetX, offsetY) {
	            this.path(path);
	            this.ctx.fillStyle = this.ctx.createPattern(this.resizeImage(image, imageSize), 'repeat');
	            this.ctx.translate(offsetX, offsetY);
	            this.ctx.fill();
	            this.ctx.translate(-offsetX, -offsetY);
	        }
	    }, {
	        key: 'renderTextNode',
	        value: function renderTextNode(textBounds, color, font, textDecoration, textShadows) {
	            var _this4 = this;
	
	            this.ctx.font = [font.fontStyle, font.fontVariant, font.fontWeight, font.fontSize, font.fontFamily].join(' ');
	
	            textBounds.forEach(function (text) {
	                _this4.ctx.fillStyle = color.toString();
	                if (textShadows && text.text.trim().length) {
	                    textShadows.slice(0).reverse().forEach(function (textShadow) {
	                        _this4.ctx.shadowColor = textShadow.color.toString();
	                        _this4.ctx.shadowOffsetX = textShadow.offsetX * _this4.options.scale;
	                        _this4.ctx.shadowOffsetY = textShadow.offsetY * _this4.options.scale;
	                        _this4.ctx.shadowBlur = textShadow.blur;
	
	                        _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
	                    });
	                } else {
	                    _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
	                }
	
	                if (textDecoration !== null) {
	                    var textDecorationColor = textDecoration.textDecorationColor || color;
	                    textDecoration.textDecorationLine.forEach(function (textDecorationLine) {
	                        switch (textDecorationLine) {
	                            case _textDecoration.TEXT_DECORATION_LINE.UNDERLINE:
	                                // Draws a line at the baseline of the font
	                                // TODO As some browsers display the line as more than 1px if the font-size is big,
	                                // need to take that into account both in position and size
	                                var _options$fontMetrics$ = _this4.options.fontMetrics.getMetrics(font),
	                                    baseline = _options$fontMetrics$.baseline;
	
	                                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1, textDecorationColor);
	                                break;
	                            case _textDecoration.TEXT_DECORATION_LINE.OVERLINE:
	                                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1, textDecorationColor);
	                                break;
	                            case _textDecoration.TEXT_DECORATION_LINE.LINE_THROUGH:
	                                // TODO try and find exact position for line-through
	                                var _options$fontMetrics$2 = _this4.options.fontMetrics.getMetrics(font),
	                                    middle = _options$fontMetrics$2.middle;
	
	                                _this4.rectangle(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1, textDecorationColor);
	                                break;
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'resizeImage',
	        value: function resizeImage(image, size) {
	            if (image.width === size.width && image.height === size.height) {
	                return image;
	            }
	
	            var canvas = this.canvas.ownerDocument.createElement('canvas');
	            canvas.width = size.width;
	            canvas.height = size.height;
	            var ctx = canvas.getContext('2d');
	            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, size.width, size.height);
	            return canvas;
	        }
	    }, {
	        key: 'setOpacity',
	        value: function setOpacity(opacity) {
	            this.ctx.globalAlpha = opacity;
	        }
	    }, {
	        key: 'transform',
	        value: function transform(offsetX, offsetY, matrix, callback) {
	            this.ctx.save();
	            this.ctx.translate(offsetX, offsetY);
	            this.ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	            this.ctx.translate(-offsetX, -offsetY);
	
	            callback();
	
	            this.ctx.restore();
	        }
	    }]);
	
	    return CanvasRenderer;
	}();
	
	exports.default = CanvasRenderer;

/***/ },
/* 199 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ForeignObjectRenderer = function () {
	    function ForeignObjectRenderer(element) {
	        _classCallCheck(this, ForeignObjectRenderer);
	
	        this.element = element;
	    }
	
	    _createClass(ForeignObjectRenderer, [{
	        key: 'render',
	        value: function render(options) {
	            var _this = this;
	
	            this.options = options;
	            this.canvas = document.createElement('canvas');
	            this.ctx = this.canvas.getContext('2d');
	            this.canvas.width = Math.floor(options.width) * options.scale;
	            this.canvas.height = Math.floor(options.height) * options.scale;
	            this.canvas.style.width = options.width + 'px';
	            this.canvas.style.height = options.height + 'px';
	
	            options.logger.log('ForeignObject renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + options.scale);
	            var svg = createForeignObjectSVG(Math.max(options.windowWidth, options.width) * options.scale, Math.max(options.windowHeight, options.height) * options.scale, options.scrollX * options.scale, options.scrollY * options.scale, this.element);
	
	            return loadSerializedSVG(svg).then(function (img) {
	                if (options.backgroundColor) {
	                    _this.ctx.fillStyle = options.backgroundColor.toString();
	                    _this.ctx.fillRect(0, 0, options.width * options.scale, options.height * options.scale);
	                }
	
	                _this.ctx.drawImage(img, -options.x * options.scale, -options.y * options.scale);
	                return _this.canvas;
	            });
	        }
	    }]);
	
	    return ForeignObjectRenderer;
	}();
	
	exports.default = ForeignObjectRenderer;
	var createForeignObjectSVG = exports.createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
	    var xmlns = 'http://www.w3.org/2000/svg';
	    var svg = document.createElementNS(xmlns, 'svg');
	    var foreignObject = document.createElementNS(xmlns, 'foreignObject');
	    svg.setAttributeNS(null, 'width', width);
	    svg.setAttributeNS(null, 'height', height);
	
	    foreignObject.setAttributeNS(null, 'width', '100%');
	    foreignObject.setAttributeNS(null, 'height', '100%');
	    foreignObject.setAttributeNS(null, 'x', x);
	    foreignObject.setAttributeNS(null, 'y', y);
	    foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
	    svg.appendChild(foreignObject);
	
	    foreignObject.appendChild(node);
	
	    return svg;
	};
	
	var loadSerializedSVG = exports.loadSerializedSVG = function loadSerializedSVG(svg) {
	    return new Promise(function (resolve, reject) {
	        var img = new Image();
	        img.onload = function () {
	            return resolve(img);
	        };
	        img.onerror = reject;
	
	        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(svg));
	    });
	};

/***/ },
/* 200 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },
/* 201 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(206),
	    nativeKeys = __webpack_require__(477);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 203 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 204 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(455),
	    Map = __webpack_require__(456),
	    Promise = __webpack_require__(457),
	    Set = __webpack_require__(458),
	    WeakMap = __webpack_require__(459),
	    baseGetTag = __webpack_require__(41),
	    toSource = __webpack_require__(209);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 206 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(204);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(148)(module)))

/***/ },
/* 208 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 209 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(463),
	    isObjectLike = __webpack_require__(42);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(32),
	    stubFalse = __webpack_require__(486);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(148)(module)))

/***/ },
/* 212 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 213 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(467),
	    baseUnary = __webpack_require__(203),
	    nodeUtil = __webpack_require__(207);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(248);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 216 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (fn) {
	  var lastArgs = [];
	  var frameId = null;
	
	  var wrapperFn = function wrapperFn() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    lastArgs = args;
	
	    if (frameId) {
	      return frameId;
	    }
	
	    frameId = requestAnimationFrame(function () {
	      frameId = null;
	      fn.apply(undefined, lastArgs);
	    });
	
	    return frameId;
	  };
	
	  wrapperFn.cancel = function () {
	    if (!frameId) {
	      return;
	    }
	
	    cancelAnimationFrame(frameId);
	    frameId = null;
	  };
	
	  var resultFn = wrapperFn;
	
	  return resultFn;
	};

/***/ },
/* 217 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (lowerBound, upperBound) {
	  return function (value) {
	    return value <= upperBound && value >= lowerBound;
	  };
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.draggingDraggableSelector = exports.dragSelector = exports.pendingDropSelector = exports.phaseSelector = undefined;
	
	var _reselect = __webpack_require__(71);
	
	var phaseSelector = exports.phaseSelector = function phaseSelector(state) {
	  return state.phase;
	};
	
	var pendingDropSelector = exports.pendingDropSelector = function pendingDropSelector(state) {
	  if (!state.drop || !state.drop.pending) {
	    return null;
	  }
	  return state.drop.pending;
	};
	
	var dragSelector = exports.dragSelector = function dragSelector(state) {
	  return state.drag;
	};
	
	var draggableMapSelector = function draggableMapSelector(state) {
	  return state.dimension.draggable;
	};
	
	var draggingDraggableSelector = exports.draggingDraggableSelector = (0, _reselect.createSelector)([phaseSelector, dragSelector, pendingDropSelector, draggableMapSelector], function (phase, drag, pending, draggables) {
	  if (phase === 'DRAGGING') {
	    if (!drag) {
	      console.error('cannot get placeholder dimensions as there is an invalid drag state');
	      return null;
	    }
	
	    var draggable = draggables[drag.current.id];
	    return draggable;
	  }
	
	  if (phase === 'DROP_ANIMATING') {
	    if (!pending) {
	      console.error('cannot get placeholder dimensions as there is an invalid drag state');
	      return null;
	    }
	
	    if (!pending.result.destination) {
	      return null;
	    }
	
	    var _draggable = draggables[pending.result.draggableId];
	    return _draggable;
	  }
	
	  return null;
	});

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.css = exports.physics = undefined;
	
	var _extends2 = __webpack_require__(36);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var physics = exports.physics = function () {
	  var base = {
	    stiffness: 1000,
	    damping: 60,
	
	    precision: 0.99
	  };
	
	  var standard = (0, _extends3.default)({}, base);
	
	  var fast = (0, _extends3.default)({}, base, {
	    stiffness: base.stiffness * 2
	  });
	
	  return { standard: standard, fast: fast };
	}();
	
	var css = exports.css = {
	  outOfTheWay: 'transform 0.2s cubic-bezier(0.2, 0, 0, 1)'
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keyCodes = __webpack_require__(137);
	
	var keyCodes = _interopRequireWildcard(_keyCodes);
	
	var _stopEvent = __webpack_require__(84);
	
	var _stopEvent2 = _interopRequireDefault(_stopEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var blocked = [keyCodes.enter, keyCodes.tab];
	
	exports.default = function (event) {
	  if (blocked.indexOf(event.keyCode) >= 0) {
	    (0, _stopEvent2.default)(event);
	  }
	};

/***/ },
/* 221 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (el) {
	  var _el$getBoundingClient = el.getBoundingClientRect(),
	      top = _el$getBoundingClient.top,
	      right = _el$getBoundingClient.right,
	      bottom = _el$getBoundingClient.bottom,
	      left = _el$getBoundingClient.left;
	
	  var centerX = (left + right) / 2;
	  var centerY = (top + bottom) / 2;
	
	  return {
	    x: centerX,
	    y: centerY
	  };
	};

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _placeholder = __webpack_require__(544);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_placeholder).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 223 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(187);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(565);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(227);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(43);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(230);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(144);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(86);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(237);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(145);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(146);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(86);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator,
				    showNewOptionAtTop = _props2.showNewOptionAtTop;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						if (showNewOptionAtTop) {
							filteredOptions.unshift(this._createPlaceholderOption);
						} else {
							filteredOptions.push(this._createPlaceholderOption);
						}
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
		showNewOptionAtTop: true
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func,
	
		// Where to show prompt/placeholder option text.
		// true: new option prompt at top of list (default)
		// false: new option prompt at bottom of list
		showNewOptionAtTop: _propTypes2.default.bool
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(87);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(586);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(87);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ },
/* 237 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ },
/* 238 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// based on https://github.com/lodash/lodash/blob/4.17.2/lodash.js#L14100
	// eslint-disable-next-line max-len
	var wordPattern = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:(?:1ST|2ND|3RD|(?![123])\dTH)\b)|\d*(?:(?:1st|2nd|3rd|(?![123])\dth)\b)|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
	var namespacer = '/';
	
	function camelCase(string) {
	  return string.match(wordPattern).reduce(function (camelCased, word, index) {
	    return camelCased + (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
	  }, '');
	}
	
	exports.default = function (type) {
	  return type.split(namespacer).map(camelCase).join(namespacer);
	};

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ACTION_TYPE_DELIMITER = undefined;
	exports.default = combineActions;
	
	var _isString = __webpack_require__(123);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isFunction = __webpack_require__(56);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isEmpty = __webpack_require__(481);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _toString = __webpack_require__(490);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	var _isSymbol = __webpack_require__(124);
	
	var _isSymbol2 = _interopRequireDefault(_isSymbol);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTION_TYPE_DELIMITER = exports.ACTION_TYPE_DELIMITER = '||';
	
	function isValidActionType(type) {
	  return (0, _isString2.default)(type) || (0, _isFunction2.default)(type) || (0, _isSymbol2.default)(type);
	}
	
	function isValidActionTypes(types) {
	  if ((0, _isEmpty2.default)(types)) {
	    return false;
	  }
	  return types.every(isValidActionType);
	}
	
	function combineActions() {
	  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
	    actionsTypes[_key] = arguments[_key];
	  }
	
	  (0, _invariant2.default)(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
	  var combinedActionType = actionsTypes.map(_toString2.default).join(ACTION_TYPE_DELIMITER);
	  return { toString: function toString() {
	      return combinedActionType;
	    } };
	}

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAction;
	
	var _identity = __webpack_require__(119);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isFunction = __webpack_require__(56);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isNull = __webpack_require__(482);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createAction(type) {
	  var payloadCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
	  var metaCreator = arguments[2];
	
	  (0, _invariant2.default)((0, _isFunction2.default)(payloadCreator) || (0, _isNull2.default)(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');
	
	  var finalPayloadCreator = (0, _isNull2.default)(payloadCreator) || payloadCreator === _identity2.default ? _identity2.default : function (head) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return head instanceof Error ? head : payloadCreator.apply(undefined, [head].concat(args));
	  };
	
	  var hasMeta = (0, _isFunction2.default)(metaCreator);
	  var typeString = type.toString();
	
	  var actionCreator = function actionCreator() {
	    var payload = finalPayloadCreator.apply(undefined, arguments);
	    var action = { type: type };
	
	    if (payload instanceof Error) {
	      action.error = true;
	    }
	
	    if (payload !== undefined) {
	      action.payload = payload;
	    }
	
	    if (hasMeta) {
	      action.meta = metaCreator.apply(undefined, arguments);
	    }
	
	    return action;
	  };
	
	  actionCreator.toString = function () {
	    return typeString;
	  };
	
	  return actionCreator;
	}

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unflattenActionCreators = exports.flattenReducerMap = exports.flattenActionMap = exports.defaultNamespace = undefined;
	
	var _camelCase = __webpack_require__(238);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _ownKeys = __webpack_require__(147);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	var _hasGeneratorInterface = __webpack_require__(593);
	
	var _hasGeneratorInterface2 = _interopRequireDefault(_hasGeneratorInterface);
	
	var _isPlainObject = __webpack_require__(43);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isMap = __webpack_require__(121);
	
	var _isMap2 = _interopRequireDefault(_isMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultNamespace = exports.defaultNamespace = '/';
	
	function get(key, x) {
	  return (0, _isMap2.default)(x) ? x.get(key) : x[key];
	}
	
	var flattenWhenNode = function flattenWhenNode(predicate) {
	  return function flatten(map) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref$namespace = _ref.namespace,
	        namespace = _ref$namespace === undefined ? defaultNamespace : _ref$namespace,
	        prefix = _ref.prefix;
	
	    var partialFlatMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var partialFlatActionType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	    function connectNamespace(type) {
	      return partialFlatActionType ? '' + partialFlatActionType + namespace + type : type;
	    }
	
	    function connectPrefix(type) {
	      if (partialFlatActionType || !prefix) {
	        return type;
	      }
	
	      return '' + prefix + namespace + type;
	    }
	
	    (0, _ownKeys2.default)(map).forEach(function (type) {
	      var nextNamespace = connectPrefix(connectNamespace(type));
	      var mapValue = get(type, map);
	
	      if (!predicate(mapValue)) {
	        partialFlatMap[nextNamespace] = mapValue;
	      } else {
	        flatten(mapValue, { namespace: namespace, prefix: prefix }, partialFlatMap, nextNamespace);
	      }
	    });
	
	    return partialFlatMap;
	  };
	};
	
	var flattenActionMap = flattenWhenNode(_isPlainObject2.default);
	var flattenReducerMap = flattenWhenNode(function (node) {
	  return ((0, _isPlainObject2.default)(node) || (0, _isMap2.default)(node)) && !(0, _hasGeneratorInterface2.default)(node);
	});
	
	function unflattenActionCreators(flatActionCreators) {
	  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref2$namespace = _ref2.namespace,
	      namespace = _ref2$namespace === undefined ? defaultNamespace : _ref2$namespace,
	      prefix = _ref2.prefix;
	
	  function unflatten(flatActionType) {
	    var partialNestedActionCreators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var partialFlatActionTypePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var nextNamespace = (0, _camelCase2.default)(partialFlatActionTypePath.shift());
	    if (partialFlatActionTypePath.length) {
	      if (!partialNestedActionCreators[nextNamespace]) {
	        partialNestedActionCreators[nextNamespace] = {};
	      }
	      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
	    } else {
	      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
	    }
	  }
	
	  var nestedActionCreators = {};
	  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
	    var unprefixedType = prefix ? type.replace('' + prefix + namespace, '') : type;
	    return unflatten(type, nestedActionCreators, unprefixedType.split(namespace));
	  });
	
	  return nestedActionCreators;
	}
	
	exports.flattenActionMap = flattenActionMap;
	exports.flattenReducerMap = flattenReducerMap;
	exports.unflattenActionCreators = unflattenActionCreators;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = handleAction;
	
	var _isFunction = __webpack_require__(56);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isPlainObject = __webpack_require__(43);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _identity = __webpack_require__(119);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isNil = __webpack_require__(213);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _isUndefined = __webpack_require__(483);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _includes = __webpack_require__(480);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _combineActions = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleAction(type) {
	  var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
	  var defaultState = arguments[2];
	
	  var types = type.toString().split(_combineActions.ACTION_TYPE_DELIMITER);
	  (0, _invariant2.default)(!(0, _isUndefined2.default)(defaultState), 'defaultState for reducer handling ' + types.join(', ') + ' should be defined');
	  (0, _invariant2.default)((0, _isFunction2.default)(reducer) || (0, _isPlainObject2.default)(reducer), 'Expected reducer to be a function or object with next and throw reducers');
	
	  var _ref = (0, _isFunction2.default)(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
	    return (0, _isNil2.default)(aReducer) ? _identity2.default : aReducer;
	  }),
	      _ref2 = _slicedToArray(_ref, 2),
	      nextReducer = _ref2[0],
	      throwReducer = _ref2[1];
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	    var actionType = action.type;
	
	    if (!actionType || !(0, _includes2.default)(types, actionType.toString())) {
	      return state;
	    }
	
	    return (action.error === true ? throwReducer : nextReducer)(state, action);
	  };
	}

/***/ },
/* 243 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 244 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(43);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(605);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 246 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = __webpack_require__(76)('RIEBase');
	
	var RIEBase = function (_React$Component) {
	    _inherits(RIEBase, _React$Component);
	
	    function RIEBase(props) {
	        _classCallCheck(this, RIEBase);
	
	        var _this = _possibleConstructorReturn(this, (RIEBase.__proto__ || Object.getPrototypeOf(RIEBase)).call(this, props));
	
	        _this.doValidations = function (value) {
	            debug('doValidations(' + value + ')');
	            var isValid = void 0;
	            if (_this.props.validate) {
	                isValid = _this.props.validate(value);
	            } else if (_this.validate) {
	                isValid = _this.validate(value);
	            } else return true;
	            _this.setState({ invalid: !isValid });
	            return isValid;
	        };
	
	        _this.selectInputText = function (element) {
	            debug('selectInputText(' + element.value + ')');
	            if (element.setSelectionRange) element.setSelectionRange(0, element.value.length);
	        };
	
	        _this.elementClick = function (event) {
	            throw "RIEBase must be subclassed first: use a concrete class like RIEInput, RIEToggle et.c";
	        };
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            debug('componentWillReceiveProps(' + nextProps + ')');
	            if ('value' in nextProps && !(nextProps.shouldRemainWhileInvalid && _this.state.invalid)) {
	                _this.setState({ loading: false, editing: false, invalid: false, newValue: null });
	            }
	        };
	
	        _this.commit = function (value) {
	            debug('commit(' + value + ')');
	            if (!_this.state.invalid) {
	                var newProp = {};
	                newProp[_this.props.propName] = value;
	                _this.setState({ loading: true, newValue: value });
	                _this.props.change(newProp);
	            }
	        };
	
	        _this.makeClassString = function () {
	            debug('makeClassString()');
	            var classNames = [];
	            if (_this.props.className) classNames.push(_this.props.className);
	            if (_this.state.editing && _this.props.classEditing) classNames.push(_this.props.classEditing);
	            if (_this.state.loading && _this.props.classLoading) classNames.push(_this.props.classLoading);
	            if (_this.state.disabled && _this.props.classDisabled) classNames.push(_this.props.classDisabled);
	            if (_this.state.invalid && _this.props.classInvalid) classNames.push(_this.props.classInvalid);
	            return classNames.join(' ');
	        };
	
	        _this.render = function () {
	            debuf('render()');
	            return _react2.default.createElement(
	                'span',
	                _extends({}, _this.props.defaultProps, { tabindex: '0', className: _this.makeClassString(), onClick: _this.elementClick }),
	                _this.props.value
	            );
	        };
	
	        if (!_this.props.propName) throw "RTFM: missing 'propName' prop";
	        if (!_this.props.change) throw "RTFM: missing 'change' prop";
	        if (typeof _this.props.value == 'undefined') throw "RTFM: missing 'value' prop";
	
	        _this.state = {
	            editing: false,
	            loading: false,
	            disabled: false,
	            invalid: false
	        };
	        return _this;
	    }
	
	    return RIEBase;
	}(_react2.default.Component);
	
	RIEBase.propTypes = {
	    value: _propTypes2.default.any.isRequired,
	    change: _propTypes2.default.func.isRequired,
	    propName: _propTypes2.default.string.isRequired,
	    editProps: _propTypes2.default.object,
	    defaultProps: _propTypes2.default.object,
	    isDisabled: _propTypes2.default.bool,
	    validate: _propTypes2.default.func,
	    handleValidationFail: _propTypes2.default.func,
	    shouldBlockWhileLoading: _propTypes2.default.bool,
	    shouldRemainWhileInvalid: _propTypes2.default.bool,
	    classLoading: _propTypes2.default.string,
	    classEditing: _propTypes2.default.string,
	    classDisabled: _propTypes2.default.string,
	    classInvalid: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    beforeStart: _propTypes2.default.func,
	    afterStart: _propTypes2.default.func,
	    beforeFinish: _propTypes2.default.func,
	    afterFinish: _propTypes2.default.func
	};
	exports.default = RIEBase;

/***/ },
/* 248 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		autosize 4.0.2
		license: MIT
		http://www.jacklmoore.com/autosize
	*/
	(function (global, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports !== "undefined") {
			factory(module, exports);
		} else {
			var mod = {
				exports: {}
			};
			factory(mod, mod.exports);
			global.autosize = mod.exports;
		}
	})(this, function (module, exports) {
		'use strict';
	
		var map = typeof Map === "function" ? new Map() : function () {
			var keys = [];
			var values = [];
	
			return {
				has: function has(key) {
					return keys.indexOf(key) > -1;
				},
				get: function get(key) {
					return values[keys.indexOf(key)];
				},
				set: function set(key, value) {
					if (keys.indexOf(key) === -1) {
						keys.push(key);
						values.push(value);
					}
				},
				delete: function _delete(key) {
					var index = keys.indexOf(key);
					if (index > -1) {
						keys.splice(index, 1);
						values.splice(index, 1);
					}
				}
			};
		}();
	
		var createEvent = function createEvent(name) {
			return new Event(name, { bubbles: true });
		};
		try {
			new Event('test');
		} catch (e) {
			// IE does not support `new Event()`
			createEvent = function createEvent(name) {
				var evt = document.createEvent('Event');
				evt.initEvent(name, true, false);
				return evt;
			};
		}
	
		function assign(ta) {
			if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;
	
			var heightOffset = null;
			var clientWidth = null;
			var cachedHeight = null;
	
			function init() {
				var style = window.getComputedStyle(ta, null);
	
				if (style.resize === 'vertical') {
					ta.style.resize = 'none';
				} else if (style.resize === 'both') {
					ta.style.resize = 'horizontal';
				}
	
				if (style.boxSizing === 'content-box') {
					heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
				} else {
					heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
				}
				// Fix when a textarea is not on document body and heightOffset is Not a Number
				if (isNaN(heightOffset)) {
					heightOffset = 0;
				}
	
				update();
			}
	
			function changeOverflow(value) {
				{
					// Chrome/Safari-specific fix:
					// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
					// made available by removing the scrollbar. The following forces the necessary text reflow.
					var width = ta.style.width;
					ta.style.width = '0px';
					// Force reflow:
					/* jshint ignore:start */
					ta.offsetWidth;
					/* jshint ignore:end */
					ta.style.width = width;
				}
	
				ta.style.overflowY = value;
			}
	
			function getParentOverflows(el) {
				var arr = [];
	
				while (el && el.parentNode && el.parentNode instanceof Element) {
					if (el.parentNode.scrollTop) {
						arr.push({
							node: el.parentNode,
							scrollTop: el.parentNode.scrollTop
						});
					}
					el = el.parentNode;
				}
	
				return arr;
			}
	
			function resize() {
				if (ta.scrollHeight === 0) {
					// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
					return;
				}
	
				var overflows = getParentOverflows(ta);
				var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)
	
				ta.style.height = '';
				ta.style.height = ta.scrollHeight + heightOffset + 'px';
	
				// used to check if an update is actually necessary on window.resize
				clientWidth = ta.clientWidth;
	
				// prevents scroll-position jumping
				overflows.forEach(function (el) {
					el.node.scrollTop = el.scrollTop;
				});
	
				if (docTop) {
					document.documentElement.scrollTop = docTop;
				}
			}
	
			function update() {
				resize();
	
				var styleHeight = Math.round(parseFloat(ta.style.height));
				var computed = window.getComputedStyle(ta, null);
	
				// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
				var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;
	
				// The actual height not matching the style height (set via the resize method) indicates that 
				// the max-height has been exceeded, in which case the overflow should be allowed.
				if (actualHeight < styleHeight) {
					if (computed.overflowY === 'hidden') {
						changeOverflow('scroll');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				} else {
					// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
					if (computed.overflowY !== 'hidden') {
						changeOverflow('hidden');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				}
	
				if (cachedHeight !== actualHeight) {
					cachedHeight = actualHeight;
					var evt = createEvent('autosize:resized');
					try {
						ta.dispatchEvent(evt);
					} catch (err) {
						// Firefox will throw an error on dispatchEvent for a detached element
						// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
					}
				}
			}
	
			var pageResize = function pageResize() {
				if (ta.clientWidth !== clientWidth) {
					update();
				}
			};
	
			var destroy = function (style) {
				window.removeEventListener('resize', pageResize, false);
				ta.removeEventListener('input', update, false);
				ta.removeEventListener('keyup', update, false);
				ta.removeEventListener('autosize:destroy', destroy, false);
				ta.removeEventListener('autosize:update', update, false);
	
				Object.keys(style).forEach(function (key) {
					ta.style[key] = style[key];
				});
	
				map.delete(ta);
			}.bind(ta, {
				height: ta.style.height,
				resize: ta.style.resize,
				overflowY: ta.style.overflowY,
				overflowX: ta.style.overflowX,
				wordWrap: ta.style.wordWrap
			});
	
			ta.addEventListener('autosize:destroy', destroy, false);
	
			// IE9 does not fire onpropertychange or oninput for deletions,
			// so binding to onkeyup to catch most of those events.
			// There is no way that I know of to detect something like 'cut' in IE9.
			if ('onpropertychange' in ta && 'oninput' in ta) {
				ta.addEventListener('keyup', update, false);
			}
	
			window.addEventListener('resize', pageResize, false);
			ta.addEventListener('input', update, false);
			ta.addEventListener('autosize:update', update, false);
			ta.style.overflowX = 'hidden';
			ta.style.wordWrap = 'break-word';
	
			map.set(ta, {
				destroy: destroy,
				update: update
			});
	
			init();
		}
	
		function destroy(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.destroy();
			}
		}
	
		function update(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.update();
			}
		}
	
		var autosize = null;
	
		// Do nothing in Node.js environment and IE8 (or lower)
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
			autosize = function autosize(el) {
				return el;
			};
			autosize.destroy = function (el) {
				return el;
			};
			autosize.update = function (el) {
				return el;
			};
		} else {
			autosize = function autosize(el, options) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], function (x) {
						return assign(x, options);
					});
				}
				return el;
			};
			autosize.destroy = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], destroy);
				}
				return el;
			};
			autosize.update = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], update);
				}
				return el;
			};
		}
	
		exports.default = autosize;
		module.exports = exports['default'];
	});

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(251);

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	var bind = __webpack_require__(153);
	var Axios = __webpack_require__(253);
	var defaults = __webpack_require__(88);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(150);
	axios.CancelToken = __webpack_require__(252);
	axios.isCancel = __webpack_require__(151);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(267);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(150);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(88);
	var utils = __webpack_require__(16);
	var InterceptorManager = __webpack_require__(254);
	var dispatchRequest = __webpack_require__(255);
	var isAbsoluteURL = __webpack_require__(263);
	var combineURLs = __webpack_require__(261);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	  config.method = config.method.toLowerCase();
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	var transformData = __webpack_require__(258);
	var isCancel = __webpack_require__(151);
	var defaults = __webpack_require__(88);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 256 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(152);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 259 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 261 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 263 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 267 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _userSession = __webpack_require__(340);
	
	var _userSession2 = _interopRequireDefault(_userSession);
	
	var _landing = __webpack_require__(271);
	
	var _landing2 = _interopRequireDefault(_landing);
	
	var _login = __webpack_require__(59);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _register = __webpack_require__(96);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _verify = __webpack_require__(342);
	
	var _verify2 = _interopRequireDefault(_verify);
	
	var _join = __webpack_require__(334);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _dashboard = __webpack_require__(332);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _library = __webpack_require__(335);
	
	var _library2 = _interopRequireDefault(_library);
	
	var _rider = __webpack_require__(338);
	
	var _rider2 = _interopRequireDefault(_rider);
	
	var _event = __webpack_require__(333);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _notFound = __webpack_require__(93);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	var _professionals = __webpack_require__(273);
	
	var _professionals2 = _interopRequireDefault(_professionals);
	
	__webpack_require__(410);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      var userSession = this.props.userSession;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'app' },
	        _react2.default.createElement(
	          _reactRouterDom.BrowserRouter,
	          null,
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: _landing2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/login', component: (0, _userSession2.default)(_login2.default) }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/register', component: (0, _userSession2.default)(_register2.default) }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, from: '/get-started', component: function component() {
	                window.location.href = 'https://medium.com/ridline-com/tips-on-how-to-use-ridline-when-creating-your-tech-rider-875d88131a48';
	                return null;
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/professionals/:status?', component: _professionals2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/for-professionals/:status?', component: _professionals2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/verify/:verificationCode', component: _verify2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/join/:joinCode', component: _join2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/library', component: (0, _userSession2.default)(_dashboard2.default) }),
	            _react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: '/rider', to: '/library' }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/rider/:riderId/:section?', component: (0, _userSession2.default)(_rider2.default) }),
	            _react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: '/event', to: '/library' }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/event/:eventId/stage', render: function render(_ref) {
	                var match = _ref.match;
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/event/' + match.params.eventId });
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/event/:eventId/:section?', component: (0, _userSession2.default)(_event2.default) }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/event/:eventId/stage/:stageId/rider', render: function render(_ref2) {
	                var match = _ref2.match;
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/event/' + match.params.eventId + '/stage/' + match.params.stageId });
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/event/:eventId/stage/:stageId/:section?', component: (0, _userSession2.default)(_event2.default) }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/event/:eventId/stage/:stageId/rider/:riderId/:section?', component: (0, _userSession2.default)(_event2.default) }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '*', component: _notFound2.default })
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cacheComment = exports.addComment = exports.getComments = exports.CACHE_COMMENT = exports.ADD_COMMENT = exports.RECEIVE_COMMENTS = undefined;
	
	var _reduxActions = __webpack_require__(4);
	
	var RECEIVE_COMMENTS = exports.RECEIVE_COMMENTS = (0, _reduxActions.createAction)('RECEIVE_COMMENTS');
	var ADD_COMMENT = exports.ADD_COMMENT = (0, _reduxActions.createAction)('ADD_COMMENT');
	var CACHE_COMMENT = exports.CACHE_COMMENT = (0, _reduxActions.createAction)('CACHE_COMMENT');
	
	var getComments = exports.getComments = function getComments(value, items, position) {
	  return function (dispatch) {
	    return dispatch(RECEIVE_COMMENTS({ value: value, items: items, position: position }));
	  };
	};
	
	var addComment = exports.addComment = function addComment(comment) {
	  return function (dispatch) {
	    return dispatch(ADD_COMMENT({ comment: comment }));
	  };
	};
	
	var cacheComment = exports.cacheComment = function cacheComment(comment) {
	  return function (dispatch) {
	    return dispatch(CACHE_COMMENT(comment));
	  };
	};

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alert = function (_Component) {
	  _inherits(Alert, _Component);
	
	  function Alert(props) {
	    _classCallCheck(this, Alert);
	
	    var _this = _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));
	
	    _this.state = {
	      clearAlert: false,
	      clearAlertTimeout: undefined
	    };
	    return _this;
	  }
	
	  _createClass(Alert, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var alert = this.props.alert;
	
	
	      if (alert.type !== 'error') {
	        var clearAlertTimeout = setTimeout(function () {
	          return _this2.props.clearAlert();
	        }, 3000);
	
	        this.setState({ clearAlertTimeout: clearAlertTimeout });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var clearAlert = nextState.clearAlert;
	
	
	      if (clearAlert !== this.state.clearAlert) clearTimeout(this.state.clearAlertTimeout);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var alert = this.props.alert;
	
	
	      var className = (0, _classnames2.default)({
	        'alert': true,
	        'alert--animate': alert.type !== 'error',
	        'alert--error': alert.type === 'error'
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement('div', { className: 'clear-alert', onClick: function onClick() {
	            return _this3.setState({ clearAlert: true }, function () {
	              return _this3.props.clearAlert();
	            });
	          } }),
	        alert.type === 'error' ? _react2.default.createElement(
	          'span',
	          null,
	          alert.message
	        ) : alert.message
	      );
	    }
	  }]);
	
	  return Alert;
	}(_react.Component);
	
	Alert.propTypes = {
	  alert: _propTypes2.default.object,
	  clearAlert: _propTypes2.default.func
	};
	
	Alert.defaultProps = {
	  alert: {},
	  clearAlert: function clearAlert() {}
	};
	
	exports.default = Alert;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _alerts = __webpack_require__(95);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _login = __webpack_require__(59);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _register = __webpack_require__(96);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _icons = __webpack_require__(73);
	
	var _AvoidDave = __webpack_require__(608);
	
	var _AvoidDave2 = _interopRequireDefault(_AvoidDave);
	
	var _VirgoSillamaa = __webpack_require__(609);
	
	var _VirgoSillamaa2 = _interopRequireDefault(_VirgoSillamaa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var testimonials = [{
	  content: '\u201CRidline is a team with a clear goal in sight, necessary skill sets present and very motivated leadership from day one!\u201D',
	  title: "Music Estonia",
	  name: "Virgo Sillamaa",
	  img: _VirgoSillamaa2.default
	}, {
	  content: '\u201CA beautiful product clearly made by a passionate, experienced team.\u201D',
	  title: "Head of Tallinna Lauluväljak",
	  name: "Tim Van Damme",
	  img: _VirgoSillamaa2.default
	}, {
	  content: '\u201CA beautiful product clearly made by a passionate, experienced team.\u201D',
	  title: "Head of Tallinna Lauluväljak",
	  name: "Tim Van Damme",
	  img: _VirgoSillamaa2.default
	}];
	
	var Landing = function (_Component) {
	  _inherits(Landing, _Component);
	
	  function Landing(props) {
	    _classCallCheck(this, Landing);
	
	    var _this = _possibleConstructorReturn(this, (Landing.__proto__ || Object.getPrototypeOf(Landing)).call(this, props));
	
	    _this.tryItNow = function (e) {
	      e.preventDefault();
	
	      _this.setState({ showSignupModal: true });
	    };
	
	    _this.state = {
	      showLoginModal: false,
	      showSignupModal: false,
	      email: '',
	      bandsPerspective: true,
	      activeSlide: 0
	    };
	    return _this;
	  }
	
	  _createClass(Landing, [{
	    key: 'renderLoginModal',
	    value: function renderLoginModal() {
	      var _this2 = this;
	
	      var _state = this.state,
	          showLoginModal = _state.showLoginModal,
	          email = _state.email;
	
	
	      if (showLoginModal !== true) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal' },
	        _react2.default.createElement('div', { className: 'modal-escape', onClick: function onClick() {
	            return _this2.setState({ showLoginModal: false });
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement(_login2.default, { modal: true })
	        )
	      );
	    }
	  }, {
	    key: 'renderSignupModal',
	    value: function renderSignupModal() {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          showSignupModal = _state2.showSignupModal,
	          email = _state2.email;
	
	
	      if (showSignupModal !== true) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal' },
	        _react2.default.createElement('div', { className: 'modal-escape', onClick: function onClick() {
	            return _this3.setState({ showSignupModal: false });
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement(_register2.default, { modal: true, email: email })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state3 = this.state,
	          email = _state3.email,
	          bandsPerspective = _state3.bandsPerspective,
	          activeSlide = _state3.activeSlide;
	
	
	      var bandsClassName = (0, _classnames2.default)({
	        'button--inline': true,
	        'button--success': bandsPerspective === true,
	        'button--primary': bandsPerspective !== true
	      });
	
	      var venuesClassName = (0, _classnames2.default)({
	        'button--inline': true,
	        'button--success': bandsPerspective !== true,
	        'button--primary': bandsPerspective === true
	      });
	
	      var featuresSideClassName = (0, _classnames2.default)({
	        'landing-features-side-screen': true,
	        'landing-features-side-screen--venue': bandsPerspective !== true,
	        'landing-features-side-screen--band': bandsPerspective === true
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'landing' },
	        _react2.default.createElement(_alerts2.default, null),
	        this.renderLoginModal(),
	        this.renderSignupModal(),
	        _react2.default.createElement(
	          'section',
	          { className: 'landing-header' },
	          _react2.default.createElement(_icons.Logo, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'landing-header-cta' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'heading' },
	              'Tech riders. ',
	              _react2.default.createElement('br', null),
	              'Organized.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'subheading' },
	              'Manage your riders online. ',
	              _react2.default.createElement('br', null),
	              'Designed to bring clarity to every concert.'
	            ),
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.tryItNow },
	              _react2.default.createElement('input', {
	                type: 'text',
	                className: 'input--light',
	                value: email,
	                placeholder: 'Insert your e-mail address',
	                onChange: function onChange(e) {
	                  return _this4.setState({ email: e.target.value });
	                } }),
	              _react2.default.createElement(
	                'button',
	                { className: 'button--success focus', type: 'submit' },
	                'Try it now'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'landing-header-featured' },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: 'rider/4c8342e6-e1b6-11e8-8bcc-06663252a404/general', target: '_blank' },
	              _react2.default.createElement('img', { src: _AvoidDave2.default }),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Avoid Dave joined Ridline'
	              ),
	              _react2.default.createElement(
	                'h4',
	                null,
	                'View their rider now'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'landing-header-navigation' },
	            _react2.default.createElement(
	              'button',
	              { className: 'button--inline button--primary', onClick: function onClick() {
	                  return _this4.setState({ showLoginModal: true });
	                } },
	              'Log in'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'landing-header-features' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Tech rider online'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Stage plan maker'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Crew collaboration'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Clear overview'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Efficient concert production'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'landing-features' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'section-title' },
	            'Features'
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'section-subtitle' },
	            'Features & values'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'landing-features-side' },
	            _react2.default.createElement(
	              'div',
	              { className: 'landing-features-side-navigation' },
	              _react2.default.createElement(
	                'button',
	                { className: bandsClassName, onClick: function onClick() {
	                    return _this4.setState({ bandsPerspective: true });
	                  } },
	                'Band\u2019s perspective'
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: venuesClassName, onClick: function onClick() {
	                    return _this4.setState({ bandsPerspective: false });
	                  } },
	                'Organizer\u2019s perspective'
	              )
	            ),
	            bandsPerspective ? _react2.default.createElement(
	              'ol',
	              { className: 'landing-features-list' },
	              _react2.default.createElement(
	                'li',
	                { className: 'landing-features-list-item' },
	                _react2.default.createElement('div', { className: 'landing-features-list-item-bullet', 'data-value': '\u2022' }),
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Create your rider'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Professional technical requirements ',
	                  _react2.default.createElement('br', null),
	                  'communication for every band'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'landing-features-list-item' },
	                _react2.default.createElement('div', { className: 'landing-features-list-item-bullet', 'data-value': '\u2022' }),
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Collaborate and share with ease'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Work together with your sound engineer, ',
	                  _react2.default.createElement('br', null),
	                  'band members or share information out as a link'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'landing-features-list-item' },
	                _react2.default.createElement('div', { className: 'landing-features-list-item-bullet', 'data-value': '\u2022' }),
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Exchange feedback and be ready for the concert'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Once sent to an event, all of the performance agreement ',
	                  _react2.default.createElement('br', null),
	                  'changes will are recorded between bands and concert organizers'
	                )
	              )
	            ) : _react2.default.createElement(
	              'ol',
	              { className: 'landing-features-list' },
	              _react2.default.createElement(
	                'li',
	                { className: 'landing-features-list-item' },
	                _react2.default.createElement('div', { className: 'landing-features-list-item-bullet', 'data-value': '\u2022' }),
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Handle riders for your event'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Overview of all the performers technical ',
	                  _react2.default.createElement('br', null),
	                  'aspects in one place for the whole crew'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'landing-features-list-item' },
	                _react2.default.createElement('div', { className: 'landing-features-list-item-bullet', 'data-value': '\u2022' }),
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Elaborate with bands, order equipment'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Agreement changes from all sides are recorded and automatically summarized ',
	                  _react2.default.createElement('br', null),
	                  'technical needs are made per event, stage or band -  however you need it'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'landing-features-list-item' },
	                _react2.default.createElement('div', { className: 'landing-features-list-item-bullet', 'data-value': '\u2022' }),
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Be stage ready'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'For all quality music events - keep things under control, ',
	                  _react2.default.createElement('br', null),
	                  'satisfy your performers and audience to the top'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: featuresSideClassName })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'landing-values' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'section-title' },
	            'Why are we different?'
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'section-subtitle' },
	            'What do we like so much about Ridline?'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'landing-values-list' },
	            _react2.default.createElement(
	              'div',
	              { className: 'landing-values-list-item' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Clear overview of ',
	                _react2.default.createElement('br', null),
	                'all agreements'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Manage your riders online. Designed to bring clarity to every concert.'
	              ),
	              _react2.default.createElement('div', { className: 'landing-values-list-item-bullet' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'landing-values-list-item' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Built on experience'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Manage your riders online. Designed to bring clarity to every concert.'
	              ),
	              _react2.default.createElement('div', { className: 'landing-values-list-item-bullet' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'landing-values-list-item' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Saves 25 hours on ',
	                _react2.default.createElement('br', null),
	                'document handling'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Manage your riders online. Designed to bring clarity to every concert.'
	              ),
	              _react2.default.createElement('div', { className: 'landing-values-list-item-bullet' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'landing-values-list-item' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Fastest rider creating ',
	                _react2.default.createElement('br', null),
	                'and processing tool'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Manage your riders online. Designed to bring clarity to every concert.'
	              ),
	              _react2.default.createElement('div', { className: 'landing-values-list-item-bullet' })
	            )
	          ),
	          _react2.default.createElement(_icons.LandingFeatures, null)
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'landing-testimonials' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'section-title' },
	            'Others on us'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'landing-testimonials-slides' },
	            _react2.default.createElement(
	              'li',
	              { className: 'landing-testimonials-slide' },
	              _react2.default.createElement('div', { className: 'landing-testimonials-slide-img', style: { backgroundImage: 'url(' + testimonials[activeSlide].img + ')' } }),
	              _react2.default.createElement(
	                'span',
	                { className: 'h1 landing-testimonials-slide-content' },
	                testimonials[activeSlide].content
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'h4 landing-testimonials-slide-name' },
	                testimonials[activeSlide].name
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'landing-testimonials-slide-title' },
	                testimonials[activeSlide].title
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'landing-footer-cta' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'section-title' },
	            'Work smarter, not harder'
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.NavLink,
	            { to: '/register' },
	            _react2.default.createElement(
	              'button',
	              { className: 'button--block button--success' },
	              'Start now'
	            )
	          ),
	          _react2.default.createElement('hr', null)
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'landing-footer' },
	          _react2.default.createElement(
	            'span',
	            null,
	            'info@ridline.com'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Veerenni 24, Tallinn, Estonia'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            '+372 5647 3580'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Landing;
	}(_react.Component);
	
	exports.default = Landing;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _navigation = __webpack_require__(337);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _user = __webpack_require__(341);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _alerts = __webpack_require__(95);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _modals = __webpack_require__(336);
	
	var _modals2 = _interopRequireDefault(_modals);
	
	var _saving = __webpack_require__(339);
	
	var _saving2 = _interopRequireDefault(_saving);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(props) {
	  var userSession = props.userSession,
	      pathname = props.pathname;
	
	
	  var loggedIn = userSession.loggedIn !== undefined && userSession.loggedIn !== null && userSession.loggedIn !== false;
	  var showUser = pathname.includes('library') || pathname.includes('event') || pathname.includes('rider');
	
	  var className = (0, _classnames2.default)({
	    layout: true,
	    parallax: false
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    loggedIn ? _react2.default.createElement(_navigation2.default, null) : null,
	    loggedIn && showUser ? _react2.default.createElement(_user2.default, null) : null,
	    _react2.default.createElement(_alerts2.default, null),
	    _react2.default.createElement(_modals2.default, null),
	    _react2.default.createElement(_saving2.default, { pathname: pathname }),
	    _react2.default.createElement('div', { className: 'background' }),
	    _react2.default.createElement(
	      'main',
	      null,
	      props.children
	    )
	  );
	};
	
	Layout.propTypes = {
	  userSession: _propTypes2.default.object,
	  pathname: _propTypes2.default.string
	};
	
	Layout.defaultProps = {
	  userSession: {},
	  pathname: ''
	};
	
	exports.default = Layout;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactMailchimpSubscribe = __webpack_require__(550);
	
	var _reactMailchimpSubscribe2 = _interopRequireDefault(_reactMailchimpSubscribe);
	
	var _alerts = __webpack_require__(95);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _icons = __webpack_require__(73);
	
	var _campaignFeature = __webpack_require__(610);
	
	var _campaignFeature2 = _interopRequireDefault(_campaignFeature);
	
	var _campaignFeature3 = __webpack_require__(611);
	
	var _campaignFeature4 = _interopRequireDefault(_campaignFeature3);
	
	var _campaignFeature5 = __webpack_require__(612);
	
	var _campaignFeature6 = _interopRequireDefault(_campaignFeature5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mailchimpSubscribeUrl = "https://ridline.us20.list-manage.com/subscribe/post?u=a6a2e9fc965a8546c0c4d2de1&id=e1b0cb1f24";
	
	var CustomForm = function CustomForm(_ref) {
	  var status = _ref.status,
	      message = _ref.message,
	      onValidated = _ref.onValidated,
	      emailSubmitted = _ref.emailSubmitted;
	
	  var email = void 0;
	
	  var submit = function submit(e) {
	    e.preventDefault();
	
	    email && email.value.indexOf("@") > -1 && onValidated({
	      EMAIL: email.value
	    });
	  };
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: submit },
	    !emailSubmitted && _react2.default.createElement(
	      'h3',
	      { className: 'subheading' },
	      'Subscribe to never miss an update'
	    ),
	    status === "sending" && _react2.default.createElement(
	      'div',
	      null,
	      'Sending...'
	    ),
	    status === "error" && _react2.default.createElement('div', {
	      style: { color: "#ea464a" },
	      dangerouslySetInnerHTML: { __html: message }
	    }),
	    status === "success" && _react2.default.createElement('h3', {
	      style: { color: "#3adb74" },
	      className: 'subheading',
	      dangerouslySetInnerHTML: { __html: message }
	    }),
	    !emailSubmitted && _react2.default.createElement('input', {
	      ref: function ref(node) {
	        return email = node;
	      },
	      type: 'email',
	      className: 'input--light',
	      placeholder: 'Enter your email here'
	    }),
	    !emailSubmitted && _react2.default.createElement(
	      'button',
	      { type: 'submit', className: 'button--success focus' },
	      'Subscribe now'
	    )
	  );
	};
	
	var Professionals = function (_Component) {
	  _inherits(Professionals, _Component);
	
	  function Professionals(props) {
	    _classCallCheck(this, Professionals);
	
	    var _this = _possibleConstructorReturn(this, (Professionals.__proto__ || Object.getPrototypeOf(Professionals)).call(this, props));
	
	    _this.state = {
	      email: '',
	      emailSubmitted: false
	    };
	    return _this;
	  }
	
	  _createClass(Professionals, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var match = this.props.match;
	      var params = match.params;
	      var emailSubmitted = this.state.emailSubmitted;
	
	
	      if (params.status === 'thank-you' && emailSubmitted !== true) this.setState({ emailSubmitted: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var match = this.props.match;
	      var _state = this.state,
	          email = _state.email,
	          emailSubmitted = _state.emailSubmitted;
	      var url = match.url;
	
	      url = url.includes('for-professionals') ? '/for-professionals' : '/professionals';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'landing campaign' },
	        _react2.default.createElement(_alerts2.default, null),
	        _react2.default.createElement(
	          'section',
	          { className: 'landing-header' },
	          _react2.default.createElement(_icons.Logo, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'landing-header-cta' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'heading' },
	              'Plan quality music events with your crew'
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'subheading' },
	              'Collaboration software for the music industry'
	            ),
	            _react2.default.createElement(_reactMailchimpSubscribe2.default, {
	              url: mailchimpSubscribeUrl,
	              render: function render(_ref2) {
	                var subscribe = _ref2.subscribe,
	                    status = _ref2.status,
	                    message = _ref2.message;
	                return _react2.default.createElement(CustomForm, {
	                  status: status,
	                  message: message,
	                  onValidated: function onValidated(formData) {
	                    subscribe(formData);
	                    _this2.props.history.replace(url + '/thank-you');
	                  },
	                  emailSubmitted: emailSubmitted });
	              }
	            })
	          ),
	          _react2.default.createElement('div', { className: 'landing-header-navigation' })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'landing-features landing-about' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'section-title' },
	            'About'
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'section-subtitle' },
	            'Be Stage Ready'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ridline strives to create a transparent communication channel between every live music professional. We value teamwork and up- to- date communication in everything we do. We strive to create ways of work that are more efficient and let\u2019s us concentrate on what\u2019s most important. We know that the only way to make headway is to embrace modern ways of working by having transparency and efficiency in the competitive field of entertainment industry. Our goal is to make that as an everyday life for small and big crews working in live concert productions.'
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'landing-features landing-testimonials' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'section-title' },
	            'Coming soon'
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'section-subtitle' },
	            'Organize your production like never before'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'landing-features-side' },
	            _react2.default.createElement(
	              'ol',
	              { className: 'landing-features-list' },
	              _react2.default.createElement(
	                'li',
	                { className: 'landing-features-list-item' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'landing-features-list-item-wrapper' },
	                  _react2.default.createElement('div', { className: 'landing-features-list-item-bullet', 'data-value': 'I' }),
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Your production at the palm of your hands'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Overview your crews or artists production progress on one page. Never miss out on any details.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'landing-features-list-item-wrapper' },
	                  _react2.default.createElement('img', { src: _campaignFeature2.default })
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'landing-features-list-item landing-features-list-item--reverse' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'landing-features-list-item-wrapper' },
	                  _react2.default.createElement('div', { className: 'landing-features-list-item-bullet', 'data-value': 'II' }),
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Manage your crew and artists'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Send out information or collect files from as many people as you want, with just one click. One task to rule them all.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'landing-features-list-item-wrapper' },
	                  _react2.default.createElement('img', { src: _campaignFeature4.default })
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'landing-features-list-item' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'landing-features-list-item-wrapper' },
	                  _react2.default.createElement('div', { className: 'landing-features-list-item-bullet', 'data-value': 'III' }),
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Spread the word. Fast.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Send information to all of your crew members and artists. If needed, send even direct messages. You choose.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'landing-features-list-item-wrapper' },
	                  _react2.default.createElement('img', { src: _campaignFeature6.default })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'landing-features landing-difference' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'section-title' },
	            'Why are we different?'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'landing-features-side' },
	            _react2.default.createElement(
	              'ol',
	              { className: 'landing-features-list' },
	              _react2.default.createElement(
	                'li',
	                { className: 'landing-features-list-item' },
	                _react2.default.createElement('div', { className: 'landing-features-list-item-bullet', 'data-value': '1' }),
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  'Tailor made for the music industry'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'landing-features-list-item' },
	                _react2.default.createElement('div', { className: 'landing-features-list-item-bullet', 'data-value': '2' }),
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  'Saves you from the endless production emails'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'landing-features-list-item' },
	                _react2.default.createElement('div', { className: 'landing-features-list-item-bullet', 'data-value': '3' }),
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  'Collaborate stress free with your crew and members outside of it'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'landing-footer-cta' },
	          _react2.default.createElement(_icons.LandingFeatures, null),
	          _react2.default.createElement(
	            'h2',
	            { className: 'section-title' },
	            'Like the idea?'
	          ),
	          _react2.default.createElement(_reactMailchimpSubscribe2.default, {
	            url: mailchimpSubscribeUrl,
	            render: function render(_ref3) {
	              var subscribe = _ref3.subscribe,
	                  status = _ref3.status,
	                  message = _ref3.message;
	              return _react2.default.createElement(CustomForm, {
	                status: status,
	                message: message,
	                onValidated: function onValidated(formData) {
	                  subscribe(formData);
	                  _this2.props.history.replace(url + '/thank-you');
	                },
	                emailSubmitted: emailSubmitted });
	            }
	          }),
	          _react2.default.createElement('hr', null)
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'landing-footer' },
	          _react2.default.createElement(
	            'span',
	            null,
	            'info@ridline.com'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Veerenni 24, Tallinn, Estonia'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            '+372 5647 3580'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Professionals;
	}(_react.Component);
	
	exports.default = Professionals;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SavingIndicator = function (_Component) {
	  _inherits(SavingIndicator, _Component);
	
	  function SavingIndicator() {
	    _classCallCheck(this, SavingIndicator);
	
	    return _possibleConstructorReturn(this, (SavingIndicator.__proto__ || Object.getPrototypeOf(SavingIndicator)).apply(this, arguments));
	  }
	
	  _createClass(SavingIndicator, [{
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)({
	        'saving-indicator': true,
	        'saving-indicator--show': this.props.savingInstance.saving
	      });
	
	      var spinnerClassName = (0, _classnames2.default)({
	        'saving-indicator-bar': true,
	        'saving-indicator-bar--loaded': !this.props.savingInstance.saving,
	        'saving-indicator-bar--error': this.props.savingInstance.error
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement('div', { className: spinnerClassName })
	      );
	    }
	  }]);
	
	  return SavingIndicator;
	}(_react.Component);
	
	SavingIndicator.propTypes = {
	  savingInstance: _propTypes2.default.object
	};
	
	SavingIndicator.defaultProps = {
	  savingInstance: {}
	};
	
	exports.default = SavingIndicator;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _riek = __webpack_require__(46);
	
	var _sharingForm = __webpack_require__(278);
	
	var _sharingForm2 = _interopRequireDefault(_sharingForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventBreadcrumbs = function (_Component) {
	  _inherits(EventBreadcrumbs, _Component);
	
	  function EventBreadcrumbs(props) {
	    _classCallCheck(this, EventBreadcrumbs);
	
	    var _this = _possibleConstructorReturn(this, (EventBreadcrumbs.__proto__ || Object.getPrototypeOf(EventBreadcrumbs)).call(this, props));
	
	    _this.state = {
	      title: '',
	      showSharingDropdown: false
	    };
	
	    _this.title = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(EventBreadcrumbs, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var event = this.props.event;
	
	
	      if (event.title) this.setState({ title: event.title });
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown() {
	      var _this2 = this;
	
	      var event = this.props.event;
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--main': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'ui-dropdown-handle', onClick: function onClick() {
	              return _this2.setState({ showDropdown: !showDropdown });
	            } },
	          _react2.default.createElement('div', { className: 'ui-dropdown-handle-ball' }),
	          _react2.default.createElement('div', { className: 'ui-dropdown-handle-ball' }),
	          _react2.default.createElement('div', { className: 'ui-dropdown-handle-ball' })
	        ),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  return _this2.title.current.startEditing();
	                });
	              } },
	            'Rename event'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false, showSharingDropdown: true });
	              } },
	            'Share rider'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.props.deleteEvent();
	              } },
	            'Delete event'
	          ),
	          event.stages.map(function (stage, index) {
	            return _react2.default.createElement(
	              'li',
	              { key: index, onClick: function onClick() {
	                  return _this2.props.deleteEventStage(stage.id);
	                } },
	              'Delete stage "' + stage.title + '"'
	            );
	          })
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderSharingDropdown',
	    value: function renderSharingDropdown() {
	      var _this3 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          event = _props.event;
	      var users = event.users;
	      var showSharingDropdown = this.state.showSharingDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--sharing': true,
	        'ui-dropdown--active': showSharingDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showSharingDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this3.setState({ showSharingDropdown: !showSharingDropdown });
	          } }) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'ui-dropdown-value', onClick: function onClick() {
	              return _this3.setState({ showSharingDropdown: !showSharingDropdown });
	            } },
	          'Share'
	        ),
	        showSharingDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'small',
	              null,
	              'Invite event organizer with write permission:'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(_sharingForm2.default, {
	              removeFocus: function removeFocus() {
	                return _this3.setState({ showSharingDropdown: false });
	              },
	              createEventUser: this.props.createEventUser })
	          ),
	          users.length > 0 ? _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'small',
	              null,
	              'Current collaborators:'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              users.map(function (user, index) {
	                if (user.id !== (view.user && view.user.id)) return _react2.default.createElement(
	                  'li',
	                  { key: index, onClick: function onClick() {
	                      return _this3.props.deleteEventUser(user.id);
	                    } },
	                  '\u2014 ',
	                  user.email
	                );
	                return null;
	              })
	            )
	          ) : null
	        ) : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          view = _props2.view,
	          event = _props2.event,
	          stage = _props2.stage;
	      var title = this.state.title;
	
	
	      var titleClassName = (0, _classnames2.default)({
	        'riek': true,
	        'riek--focusable': view.editable,
	        'title': true,
	        'h1': true,
	        'placeholder': !title
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'event-breadcrumbs' },
	        view.editable ? _react2.default.createElement(_riek.RIEInput, { ref: this.title,
	          value: title || 'Title - click to add',
	          propName: 'title',
	          className: titleClassName,
	          classEditing: 'riek-editing',
	          change: function change(_ref) {
	            var title = _ref.title;
	            return _this4.setState({ title: title }, function () {
	              return _this4.props.editEvent({ title: title });
	            });
	          } }) : _react2.default.createElement(
	          'div',
	          { className: titleClassName },
	          event.title
	        ),
	        view.editable ? this.renderSharingDropdown() : null,
	        view.editable ? this.renderDropdown() : null
	      );
	    }
	  }]);
	
	  return EventBreadcrumbs;
	}(_react.Component);
	
	EventBreadcrumbs.propTypes = {
	  view: _propTypes2.default.object,
	  event: _propTypes2.default.object,
	  stage: _propTypes2.default.object,
	  editEvent: _propTypes2.default.func,
	  deleteEvent: _propTypes2.default.func,
	  deleteEventStage: _propTypes2.default.func,
	  createEventUser: _propTypes2.default.func,
	  deleteEventUser: _propTypes2.default.func
	};
	
	EventBreadcrumbs.defaultProps = {
	  view: {},
	  event: {},
	  stage: {},
	  editEvent: function editEvent() {},
	  deleteEvent: function deleteEvent() {},
	  deleteEventStage: function deleteEventStage() {},
	  createEventUser: function createEventUser() {},
	  deleteEventUser: function deleteEventUser() {}
	};
	
	exports.default = EventBreadcrumbs;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventNavigation = function EventNavigation(props) {
	  return _react2.default.createElement(
	    'nav',
	    { className: 'rider-navigation' },
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _reactRouterDom.NavLink,
	          { activeClassName: 'active', to: props.url + '/riders' },
	          'Riders'
	        )
	      )
	    )
	  );
	};
	
	EventNavigation.propTypes = {
	  url: _propTypes2.default.string,
	  eventId: _propTypes2.default.string
	};
	
	EventNavigation.defaultProps = {
	  url: '',
	  eventId: ''
	};
	
	exports.default = EventNavigation;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _userSearch = __webpack_require__(280);
	
	var _userSearch2 = _interopRequireDefault(_userSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventRiders = function (_Component) {
	  _inherits(EventRiders, _Component);
	
	  function EventRiders(props) {
	    _classCallCheck(this, EventRiders);
	
	    var _this = _possibleConstructorReturn(this, (EventRiders.__proto__ || Object.getPrototypeOf(EventRiders)).call(this, props));
	
	    _this.state = {
	      email: undefined
	    };
	    return _this;
	  }
	
	  _createClass(EventRiders, [{
	    key: 'getRiderStatusMessage',
	    value: function getRiderStatusMessage(status) {
	      return {
	        'completed': 'Confirmed',
	        'pending': 'Rider request sent'
	      }[status];
	    }
	  }, {
	    key: 'renderRider',
	    value: function renderRider(rider, index) {
	      var _this2 = this;
	
	      var className = function className(status) {
	        return (0, _classnames2.default)({
	          'event-rider': true,
	          'event-rider--completed': status === 'completed'
	        });
	      };
	
	      var statusMessage = this.getRiderStatusMessage(rider.status);
	
	      return rider.status === 'pending' ? _react2.default.createElement(
	        'li',
	        { key: index, className: className(rider.status), onClick: function onClick() {
	            return _this2.props.setModal('EventDeleteRiderRequestModal', { riderRequest: Object.assign({}, rider, { statusMessage: statusMessage }) });
	          } },
	        _react2.default.createElement(
	          'span',
	          { className: 'status' },
	          statusMessage
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'title' },
	          rider.title
	        )
	      ) : _react2.default.createElement(
	        'li',
	        { key: index, className: className(rider.status) },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: '/rider/' + rider.id, target: '_blank' },
	          _react2.default.createElement(
	            'span',
	            { className: 'status' },
	            statusMessage
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            rider.title
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderStageRiders',
	    value: function renderStageRiders(stage) {
	      var _this3 = this;
	
	      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var view = this.props.view;
	      var riders = stage.riders;
	
	      var riderRequests = stage.rider_requests;
	
	      return _react2.default.createElement(
	        'div',
	        { key: index, className: 'subsection' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          stage.title
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          riders.map(function (rider, index) {
	            return _this3.renderRider(Object.assign({}, rider, { status: 'completed' }), index);
	          }),
	          riderRequests.map(function (request, index) {
	            if (request.status !== 'completed') return _this3.renderRider(request, index);
	          }),
	          view.editable ? _react2.default.createElement(
	            'li',
	            { className: 'event-rider event-rider--add', onClick: function onClick() {
	                return _this3.props.setModal('EventCreateRiderRequestModal', { stage: stage });
	              } },
	            'Request a rider'
	          ) : null
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          eventId = _props.eventId,
	          stage = _props.stage,
	          stages = _props.stages,
	          riderRequests = _props.riderRequests;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'event-riders' },
	        stage.id ? this.renderStageRiders(stage) : stages.length > 0 ? stages.map(function (stage, index) {
	          return _this4.renderStageRiders(stage, index);
	        }) : _react2.default.createElement(
	          'div',
	          null,
	          'To request riders, start by ',
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this4.props.setModal('EventStageCreateModal', { eventId: eventId });
	              } },
	            'adding a stage'
	          ),
	          '.'
	        )
	      );
	    }
	  }]);
	
	  return EventRiders;
	}(_react.Component);
	
	EventRiders.propTypes = {
	  view: _propTypes2.default.object,
	  eventId: _propTypes2.default.string,
	  stage: _propTypes2.default.object,
	  stages: _propTypes2.default.array,
	  deleteRiderRequest: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	EventRiders.defaultProps = {
	  view: {},
	  eventId: undefined,
	  stage: {},
	  stages: [],
	  deleteRiderRequest: function deleteRiderRequest() {},
	  setModal: function setModal() {}
	};
	
	exports.default = EventRiders;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SharingForm = function (_Component) {
	  _inherits(SharingForm, _Component);
	
	  function SharingForm(props) {
	    _classCallCheck(this, SharingForm);
	
	    var _this = _possibleConstructorReturn(this, (SharingForm.__proto__ || Object.getPrototypeOf(SharingForm)).call(this, props));
	
	    _this.state = {
	      email: ''
	    };
	
	    _this.email = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(SharingForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.email.current.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var email = this.state.email;
	
	
	      var buttonClassName = (0, _classnames2.default)({
	        'button--primary': true,
	        'button--success': email.indexOf('@') !== -1
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sharing-form' },
	        _react2.default.createElement('input', { ref: this.email,
	          type: 'text',
	          className: 'input--light',
	          value: email || '',
	          placeholder: 'Email',
	          onChange: function onChange(e) {
	            return _this2.setState({ email: e.target.value });
	          } }),
	        _react2.default.createElement(
	          'button',
	          { className: buttonClassName, onClick: function onClick() {
	              _this2.props.createEventUser({ email: _this2.state.email, role: 'read' });
	              _this2.props.removeFocus();
	            } },
	          'Invite'
	        )
	      );
	    }
	  }]);
	
	  return SharingForm;
	}(_react.Component);
	
	SharingForm.propTypes = {
	  removeFocus: _propTypes2.default.func,
	  createEventUser: _propTypes2.default.func
	};
	
	SharingForm.defaultProps = {
	  removeFocus: function removeFocus() {},
	  createEventUser: function createEventUser() {}
	};
	
	exports.default = SharingForm;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventStages = function (_Component) {
	  _inherits(EventStages, _Component);
	
	  function EventStages(props) {
	    _classCallCheck(this, EventStages);
	
	    var _this = _possibleConstructorReturn(this, (EventStages.__proto__ || Object.getPrototypeOf(EventStages)).call(this, props));
	
	    _this.state = {
	      hideStages: false
	    };
	    return _this;
	  }
	
	  _createClass(EventStages, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          event = _props.event,
	          stage = _props.stage;
	      var stages = event.stages;
	
	      var activeStage = stage;
	      var hideStages = this.state.hideStages;
	
	
	      var activeClassName = (0, _classnames2.default)({
	        'active': activeStage.id === undefined
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'event-stages' },
	        _react2.default.createElement(
	          _reactRouterDom.NavLink,
	          { className: 'button button-home button--primary', activeClassName: activeClassName, to: view.section ? '/event/' + event.id + '/' + view.section : '/event/' + event.id },
	          'Event'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          stages && stages.length > 0 ? stages.map(function (stage, index) {
	            return _react2.default.createElement(
	              'li',
	              { key: index },
	              _react2.default.createElement(
	                _reactRouterDom.NavLink,
	                { className: 'button button--flex button--primary', activeClassName: 'active', to: view.section ? '/event/' + event.id + '/stage/' + stage.id + '/' + view.section : '/event/' + event.id + '/stage/' + stage.id },
	                stage.title
	              )
	            );
	          }) : null
	        ),
	        view.editable ? _react2.default.createElement(
	          'button',
	          { className: 'button-view button--primary', onClick: function onClick() {
	              return _this2.props.setModal('EventStageCreateModal', { eventId: event.id });
	            } },
	          'Add a stage'
	        ) : null
	      );
	    }
	  }]);
	
	  return EventStages;
	}(_react.Component);
	
	EventStages.propTypes = {
	  view: _propTypes2.default.object,
	  event: _propTypes2.default.object,
	  stage: _propTypes2.default.object,
	  setModal: _propTypes2.default.func
	};
	
	EventStages.defaultProps = {
	  view: {},
	  event: {},
	  stage: {},
	  setModal: function setModal() {}
	};
	
	exports.default = EventStages;

/***/ },
/* 280 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.exportPDF = exportPDF;
	
	var _jspdf = __webpack_require__(449);
	
	var _jspdf2 = _interopRequireDefault(_jspdf);
	
	var _html2canvas = __webpack_require__(433);
	
	var _html2canvas2 = _interopRequireDefault(_html2canvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function exportPDF(selector) {
	  var pdf = new _jspdf2.default('portrait', 'mm', 'a4');
	  var a4 = { width: 210, height: 297 };
	  var scale = 2;
	
	  var element = document.getElementsByClassName(selector)[0];
	
	  var monochrome = function monochrome(original) {
	    var canvas = document.createElement('canvas');
	    canvas.setAttribute('width', original.width);
	    canvas.setAttribute('height', original.height);
	    var context = canvas.getContext('2d');
	    context.drawImage(original, 0, 0);
	    var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
	    var data = imageData.data;
	
	    // invert
	
	    for (var i = 0; i < data.length; i += 4) {
	      data[i] = 255 - data[i]; // red
	      data[i + 1] = 255 - data[i + 1]; // green
	      data[i + 2] = 255 - data[i + 2]; // blue
	    }
	    context.putImageData(imageData, 0, 0);
	
	    // grayscale
	    for (var _i = 0; _i < data.length; _i += 4) {
	      var avg = (data[_i] + data[_i + 1] + data[_i + 2]) / 3;
	      data[_i] = avg; // red
	      data[_i + 1] = avg; // green
	      data[_i + 2] = avg; // blue
	    }
	    context.putImageData(imageData, 0, 0);
	
	    return canvas;
	  };
	
	  return (0, _html2canvas2.default)(element, { backgroundColor: '#000000', logging: false, scale: scale }).then(function (canvas) {
	    canvas = monochrome(canvas);
	
	    var documentWidth = canvas.width / scale;
	    var documentHeight = canvas.height / scale;
	
	    var ratio = documentWidth / a4.width;
	    var height = documentHeight / ratio;
	
	    var pageBreaks = document.getElementsByClassName('page-break');
	
	    if (pageBreaks.length > 0) {
	      for (var i = 0; i <= pageBreaks.length; i++) {
	        var offsetTop = i > 0 ? pageBreaks[i - 1].offsetTop / ratio : 0;
	        var nextOffset = pageBreaks[i] ? pageBreaks[i].offsetTop / ratio : undefined;
	        var elementHeight = nextOffset ? nextOffset - offsetTop : undefined;
	
	        if (i > 0) pdf.addPage(a4.width, a4.height);
	
	        pdf.setPage(i + 1);
	        pdf.setFillColor('#ffffff');
	        if (elementHeight === undefined) pdf.rect(0, 0, a4.width, a4.height, 'F');
	        pdf.addImage(canvas.toDataURL('image/jpeg', 1.0), 0, -offsetTop, a4.width, height);
	        if (elementHeight) pdf.rect(0, elementHeight, a4.width, a4.height - elementHeight, 'F');
	      }
	    } else {
	      for (var _i2 = 0; _i2 < height / a4.height; _i2++) {
	        var _offsetTop = _i2 * a4.height;
	
	        if (_i2 > 0) pdf.addPage(a4.width, a4.height);
	
	        pdf.setPage(_i2 + 1);
	        pdf.addImage(canvas.toDataURL('image/jpeg', 1.0), 0, _i2 > 0 ? -_offsetTop : 0, a4.width, height);
	      }
	    }
	
	    pdf.save('test.pdf');
	
	    return {
	      status: 'success',
	      data: {
	        title: 'test.pdf'
	      }
	    };
	  });
	}

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventCreateModal = function (_Component) {
	  _inherits(EventCreateModal, _Component);
	
	  function EventCreateModal(props) {
	    _classCallCheck(this, EventCreateModal);
	
	    var _this = _possibleConstructorReturn(this, (EventCreateModal.__proto__ || Object.getPrototypeOf(EventCreateModal)).call(this, props));
	
	    _this.addNewEvent = function (e) {
	      e.preventDefault();
	
	      var title = _this.state.title;
	
	
	      if (!title) {
	        _this.setState({ errorMessage: "Please insert title" });
	      } else {
	        _this.props.createEvent({ title: title, start: '2018-05-05 10:00:00', end: '2018-05-05 15:00:00' });
	        _this.props.setModal(false);
	      }
	    };
	
	    _this.state = {
	      title: '',
	      errorMessage: ''
	    };
	
	    _this.input = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(EventCreateModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.input.current.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var title = this.state.title;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-content' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Create new event'
	        ),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.addNewEvent },
	          _react2.default.createElement(
	            'ul',
	            { 'data-error-msg': this.state.errorMessage },
	            _react2.default.createElement(
	              'li',
	              { 'data-title': 'Event\'s title' },
	              _react2.default.createElement('input', { ref: this.input,
	                type: 'text',
	                className: 'input--light',
	                value: title,
	                onChange: function onChange(e) {
	                  return _this2.setState({ title: e.target.value });
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'button--success', type: 'submit' },
	            'Create event'
	          )
	        )
	      );
	    }
	  }]);
	
	  return EventCreateModal;
	}(_react.Component);
	
	EventCreateModal.propTypes = {
	  createEvent: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	EventCreateModal.defaultProps = {
	  createEvent: function createEvent() {},
	  setModal: function setModal() {}
	};
	
	exports.default = EventCreateModal;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSelect = __webpack_require__(20);
	
	var _reactAutosizeTextarea = __webpack_require__(128);
	
	var _reactAutosizeTextarea2 = _interopRequireDefault(_reactAutosizeTextarea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventCreateRiderRequestModal = function (_Component) {
	  _inherits(EventCreateRiderRequestModal, _Component);
	
	  function EventCreateRiderRequestModal(props) {
	    _classCallCheck(this, EventCreateRiderRequestModal);
	
	    var _this = _possibleConstructorReturn(this, (EventCreateRiderRequestModal.__proto__ || Object.getPrototypeOf(EventCreateRiderRequestModal)).call(this, props));
	
	    _this.getOptions = function (input, callback) {
	      if (input.length >= 3) {
	        return _Api2.default.searchUsers(input).then(function (response) {
	          return { options: response.data.users };
	        }).catch(function (error) {
	          return { options: [] };
	        }); // no search results
	      } else {
	        callback(null, {
	          options: null // search not available
	        });
	      }
	    };
	
	    _this.onSubmit = function (e) {
	      e.preventDefault();
	
	      var _this$state = _this.state,
	          title = _this$state.title,
	          description = _this$state.description,
	          selectedUser = _this$state.selectedUser;
	
	
	      if (!title || !selectedUser) {
	        var credentials = 'details';
	        credentials = !title ? 'title' : credentials;
	        credentials = !selectedUser ? 'their email' : credentials;
	        credentials = !title && !selectedUser ? 'title and their email' : credentials;
	
	        _this.setState({ error: 'Please enter rider ' + credentials + '.' });
	      } else {
	        _this.setState({ error: null }, function () {
	          return _this.props.createRiderRequest({ title: title, description: description, email: _this.state.selectedUser.email });
	        });
	      }
	    };
	
	    _this.state = {
	      title: '',
	      description: null,
	      selectedUser: undefined,
	      error: null
	    };
	
	    _this.title = _react2.default.createRef();
	    _this.description = _react2.default.createRef();
	    _this.userSelector = _react2.default.createRef();
	    _this.submit = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(EventCreateRiderRequestModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.title.current.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          title = _state.title,
	          description = _state.description,
	          selectedUser = _state.selectedUser,
	          error = _state.error;
	
	
	      var value = selectedUser;
	
	      var descriptionClassName = (0, _classnames2.default)({
	        'textarea-autosize': true,
	        'textarea-autosize--focusable': true,
	        'description': true,
	        'placeholder': !description
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-content' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Ask for a rider'
	        ),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.onSubmit },
	          _react2.default.createElement(
	            'ul',
	            { className: 'group', 'data-error-msg': error },
	            _react2.default.createElement(
	              'li',
	              { 'data-title': 'Title' },
	              _react2.default.createElement('input', { ref: this.title,
	                type: 'text',
	                className: 'input--light',
	                value: title,
	                placeholder: 'Enter title, such as Avoid Dave',
	                onChange: function onChange(e) {
	                  return _this2.setState({ title: e.target.value });
	                } })
	            ),
	            _react2.default.createElement(
	              'li',
	              { 'data-title': 'Email' },
	              _react2.default.createElement(
	                'div',
	                { className: 'select-form' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'select-form-fields' },
	                  _react2.default.createElement(_reactSelect.AsyncCreatable, { ref: this.userSelector,
	                    cache: false,
	                    autoFocus: false,
	                    openOnFocus: true,
	                    className: 'select-form-field',
	                    value: value,
	                    valueKey: 'id',
	                    labelKey: 'email',
	                    clearable: true,
	                    placeholder: null,
	                    searchPromptText: 'Type to search or enter a new email',
	                    onChange: function onChange(selectedUser) {
	                      return _this2.setState({ selectedUser: selectedUser }, function () {
	                        return _this2.submit.current.focus();
	                      });
	                    },
	                    promptTextCreator: function promptTextCreator(email) {
	                      return 'Invite "' + email + '"';
	                    },
	                    onNewOptionClick: function onNewOptionClick(value) {
	                      return _this2.setState({ selectedUser: value }, function () {
	                        return _this2.submit.current.focus();
	                      });
	                    },
	                    loadOptions: this.getOptions })
	                )
	              )
	            ),
	            _react2.default.createElement(_reactAutosizeTextarea2.default, {
	              maxRows: 5,
	              value: description !== null ? description : 'Optionally you can click here and add some notes to the band',
	              className: descriptionClassName,
	              onClick: function onClick() {
	                if (description === null) _this2.setState({ description: '' });
	              },
	              onChange: function onChange(e) {
	                return _this2.setState({ description: e.target.value });
	              },
	              onBlur: function onBlur() {
	                if (!description) _this2.setState({ description: null });
	              } })
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: this.submit, className: 'button--primary', type: 'submit' },
	            'Send request'
	          )
	        )
	      );
	    }
	  }]);
	
	  return EventCreateRiderRequestModal;
	}(_react.Component);
	
	EventCreateRiderRequestModal.propTypes = {
	  createRiderRequest: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	EventCreateRiderRequestModal.defaultProps = {
	  createRiderRequest: function createRiderRequest() {},
	  setModal: function setModal() {}
	};
	
	exports.default = EventCreateRiderRequestModal;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventDeleteRiderRequestModal = function (_Component) {
	  _inherits(EventDeleteRiderRequestModal, _Component);
	
	  function EventDeleteRiderRequestModal() {
	    _classCallCheck(this, EventDeleteRiderRequestModal);
	
	    return _possibleConstructorReturn(this, (EventDeleteRiderRequestModal.__proto__ || Object.getPrototypeOf(EventDeleteRiderRequestModal)).apply(this, arguments));
	  }
	
	  _createClass(EventDeleteRiderRequestModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var riderRequest = this.props.riderRequest;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-content' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Rider request'
	        ),
	        riderRequest.user ? _react2.default.createElement(
	          'p',
	          null,
	          riderRequest.statusMessage,
	          ' (',
	          riderRequest.user.email,
	          ')'
	        ) : _react2.default.createElement(
	          'p',
	          null,
	          riderRequest.statusMessage,
	          ' (',
	          riderRequest.user_request.email,
	          ')'
	        ),
	        riderRequest.description ? _react2.default.createElement(
	          'p',
	          null,
	          'Description: ',
	          riderRequest.description
	        ) : null,
	        _react2.default.createElement(
	          'button',
	          { className: 'button--primary', onClick: function onClick() {
	              return _this2.props.deleteRiderRequest();
	            } },
	          'Remove request'
	        )
	      );
	    }
	  }]);
	
	  return EventDeleteRiderRequestModal;
	}(_react.Component);
	
	EventDeleteRiderRequestModal.propTypes = {
	  riderRequest: _propTypes2.default.object,
	  deleteRiderRequest: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	EventDeleteRiderRequestModal.defaultProps = {
	  riderRequest: {},
	  deleteRiderRequest: function deleteRiderRequest() {},
	  setModal: function setModal() {}
	};
	
	exports.default = EventDeleteRiderRequestModal;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(20);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventFulfillRiderRequestModal = function (_Component) {
	  _inherits(EventFulfillRiderRequestModal, _Component);
	
	  function EventFulfillRiderRequestModal(props) {
	    _classCallCheck(this, EventFulfillRiderRequestModal);
	
	    var _this = _possibleConstructorReturn(this, (EventFulfillRiderRequestModal.__proto__ || Object.getPrototypeOf(EventFulfillRiderRequestModal)).call(this, props));
	
	    _this.onSubmit = function (e) {
	      e.preventDefault();
	
	      var selectedRider = _this.state.selectedRider;
	
	
	      if (!selectedRider) {
	        _this.setState({ error: 'Please select your rider.' });
	      } else {
	        _this.setState({ error: null }, function () {
	          return _this.props.fulfillRiderRequest(selectedRider.id);
	        });
	      }
	    };
	
	    _this.state = {
	      selectedRider: undefined,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(EventFulfillRiderRequestModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          riderRequest = _props.riderRequest,
	          riders = _props.riders;
	      var _state = this.state,
	          selectedRider = _state.selectedRider,
	          error = _state.error;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-content' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Send a rider'
	        ),
	        riders.length > 0 ? _react2.default.createElement(
	          'form',
	          { onSubmit: this.onSubmit },
	          _react2.default.createElement(
	            'div',
	            { className: 'select-form' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'group', 'data-error-msg': error },
	              riderRequest.description ? _react2.default.createElement(
	                'li',
	                { 'data-title': 'Notes from event organizer' },
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  riderRequest.description
	                )
	              ) : null,
	              _react2.default.createElement(
	                'li',
	                { 'data-title': 'Select your rider' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'select-form-fields' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    cache: false,
	                    autoFocus: false,
	                    openOnFocus: true,
	                    className: 'select-form-field',
	                    value: selectedRider,
	                    valueKey: 'id',
	                    labelKey: 'title',
	                    clearable: false,
	                    placeholder: null,
	                    onChange: function onChange(selectedRider) {
	                      return _this2.setState({ selectedRider: selectedRider });
	                    },
	                    options: riders })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'button--primary', type: 'submit' },
	              'Send rider'
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Oops, seems like you doesn\'t have any riders yet.'
	          ),
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this2.props.setModal('RiderCreateModal');
	              } },
	            'Start by creating one now.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return EventFulfillRiderRequestModal;
	}(_react.Component);
	
	EventFulfillRiderRequestModal.propTypes = {
	  riderRequest: _propTypes2.default.object,
	  riders: _propTypes2.default.array,
	  fulfillRiderRequest: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	EventFulfillRiderRequestModal.defaultProps = {
	  riderRequest: {},
	  riders: [],
	  fulfillRiderRequest: function fulfillRiderRequest() {},
	  setModal: function setModal() {}
	};
	
	exports.default = EventFulfillRiderRequestModal;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventStageCreateModal = function (_Component) {
	  _inherits(EventStageCreateModal, _Component);
	
	  function EventStageCreateModal(props) {
	    _classCallCheck(this, EventStageCreateModal);
	
	    var _this = _possibleConstructorReturn(this, (EventStageCreateModal.__proto__ || Object.getPrototypeOf(EventStageCreateModal)).call(this, props));
	
	    _this.addNewEvent = function (e) {
	      e.preventDefault();
	
	      var title = _this.state.title;
	
	
	      if (!title) {
	        _this.setState({ errorMessage: "Please insert title" });
	      } else {
	        _this.props.createEventStage({ title: title });
	        _this.props.setModal(false);
	      }
	    };
	
	    _this.state = {
	      title: '',
	      errorMessage: ''
	    };
	
	    _this.input = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(EventStageCreateModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.input.current.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var title = this.state.title;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-content' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Add a stage'
	        ),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.addNewEvent },
	          _react2.default.createElement(
	            'ul',
	            { 'data-error-msg': this.state.errorMessage },
	            _react2.default.createElement(
	              'li',
	              { 'data-title': 'Stage name' },
	              _react2.default.createElement('input', { ref: this.input,
	                type: 'text',
	                className: 'input--light',
	                value: title,
	                onChange: function onChange(e) {
	                  return _this2.setState({ title: e.target.value });
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'button--success', type: 'submit' },
	            'Add stage'
	          )
	        )
	      );
	    }
	  }]);
	
	  return EventStageCreateModal;
	}(_react.Component);
	
	EventStageCreateModal.propTypes = {
	  createEventStage: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	EventStageCreateModal.defaultProps = {
	  createEventStage: function createEventStage() {},
	  setModal: function setModal() {}
	};
	
	exports.default = EventStageCreateModal;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _login = __webpack_require__(59);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginModal = function (_Component) {
	  _inherits(LoginModal, _Component);
	
	  function LoginModal() {
	    _classCallCheck(this, LoginModal);
	
	    return _possibleConstructorReturn(this, (LoginModal.__proto__ || Object.getPrototypeOf(LoginModal)).apply(this, arguments));
	  }
	
	  _createClass(LoginModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-content' },
	        _react2.default.createElement(_login2.default, {
	          modal: true,
	          setModal: this.props.setModal })
	      );
	    }
	  }]);
	
	  return LoginModal;
	}(_react.Component);
	
	LoginModal.propTypes = {
	  setModal: _propTypes2.default.func
	};
	
	LoginModal.defaultProps = {
	  setModal: function setModal() {}
	};
	
	exports.default = LoginModal;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RiderCreateModal = function (_Component) {
	  _inherits(RiderCreateModal, _Component);
	
	  function RiderCreateModal(props) {
	    _classCallCheck(this, RiderCreateModal);
	
	    var _this = _possibleConstructorReturn(this, (RiderCreateModal.__proto__ || Object.getPrototypeOf(RiderCreateModal)).call(this, props));
	
	    _this.addNewRider = function (e) {
	      e.preventDefault();
	
	      var title = _this.state.title;
	
	
	      if (!title) {
	        _this.setState({ errorMessage: "Please insert title" });
	      } else {
	        _this.props.createRider(_this.state.title);
	        _this.props.setModal(false);
	      }
	    };
	
	    _this.state = {
	      title: '',
	      errorMessage: ''
	    };
	
	    _this.input = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(RiderCreateModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.input.current.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-content' },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.addNewRider },
	          _react2.default.createElement(
	            'ul',
	            { className: 'group', 'data-error-msg': this.state.errorMessage },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Create new rider'
	            ),
	            _react2.default.createElement(
	              'li',
	              { 'data-title': 'Rider\'s title' },
	              _react2.default.createElement('input', { ref: this.input,
	                type: 'text',
	                className: 'input--light',
	                value: this.state.title,
	                onChange: function onChange(e) {
	                  return _this2.setState({ title: e.target.value });
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'button--success' },
	            'Create rider'
	          )
	        )
	      );
	    }
	  }]);
	
	  return RiderCreateModal;
	}(_react.Component);
	
	RiderCreateModal.propTypes = {
	  setModal: _propTypes2.default.func
	};
	
	RiderCreateModal.defaultProps = {
	  setModal: function setModal() {}
	};
	
	exports.default = RiderCreateModal;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RiderDeleteModal = function (_Component) {
	  _inherits(RiderDeleteModal, _Component);
	
	  function RiderDeleteModal() {
	    _classCallCheck(this, RiderDeleteModal);
	
	    return _possibleConstructorReturn(this, (RiderDeleteModal.__proto__ || Object.getPrototypeOf(RiderDeleteModal)).apply(this, arguments));
	  }
	
	  _createClass(RiderDeleteModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form' },
	          _react2.default.createElement(
	            'p',
	            { className: 'center' },
	            'Are you sure you want to delete ',
	            _react2.default.createElement(
	              'i',
	              null,
	              this.props.title
	            ),
	            ' ?'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn-danger', onClick: function onClick() {
	                return _this2.props.deleteRider();
	              } },
	            'Yes, delete rider'
	          )
	        )
	      );
	    }
	  }]);
	
	  return RiderDeleteModal;
	}(_react.Component);
	
	RiderDeleteModal.propTypes = {
	  title: _propTypes2.default.string,
	  deleteRider: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	RiderDeleteModal.defaultProps = {
	  title: 'This rider',
	  deleteRider: function deleteRider() {},
	  setModal: function setModal() {}
	};
	
	exports.default = RiderDeleteModal;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RiderRemoveShareModal = function (_Component) {
	  _inherits(RiderRemoveShareModal, _Component);
	
	  function RiderRemoveShareModal() {
	    _classCallCheck(this, RiderRemoveShareModal);
	
	    return _possibleConstructorReturn(this, (RiderRemoveShareModal.__proto__ || Object.getPrototypeOf(RiderRemoveShareModal)).apply(this, arguments));
	  }
	
	  _createClass(RiderRemoveShareModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal modal-sidebar' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Are you sure you want to remove ',
	          this.props.member,
	          '?'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn-danger', onClick: function onClick() {
	              _this2.props.removeRiderShare();
	              _this2.props.setModal(false);
	            } },
	          'Remove'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn-back', onClick: function onClick() {
	              return _this2.props.setModal(false);
	            } },
	          'Go back'
	        )
	      );
	    }
	  }]);
	
	  return RiderRemoveShareModal;
	}(_react.Component);
	
	RiderRemoveShareModal.propTypes = {
	  member: _propTypes2.default.string,
	  removeRiderShare: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	RiderRemoveShareModal.defaultProps = {
	  member: '',
	  removeRiderShare: function removeRiderShare() {},
	  setModal: function setModal() {}
	};
	
	exports.default = RiderRemoveShareModal;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RiderSharingModal = function (_Component) {
	  _inherits(RiderSharingModal, _Component);
	
	  function RiderSharingModal(props) {
	    _classCallCheck(this, RiderSharingModal);
	
	    var _this = _possibleConstructorReturn(this, (RiderSharingModal.__proto__ || Object.getPrototypeOf(RiderSharingModal)).call(this, props));
	
	    _this.state = {
	      roles: null,
	      email: null
	    };
	    return _this;
	  }
	
	  _createClass(RiderSharingModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var sharedWithMember = this.props.sharedWithMember;
	
	
	      var sharedMessage = sharedWithMember ? sharedWithMember.message : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal modal-sidebar' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'group', 'data-error-msg': sharedMessage },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Share with team member'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'unit', 'data-title': 'User\'s email' },
	              _react2.default.createElement('input', {
	                type: 'text',
	                value: this.state.email || '',
	                onChange: function onChange(e) {
	                  return _this2.setState({ email: e.target.value });
	                } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: function onClick() {
	              _this2.props.shareRider(_this2.state.roles, _this2.state.email);
	              // this.props.setModal(false)
	            } },
	          'Share'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn-back', onClick: function onClick() {
	              return _this2.props.setModal(false);
	            } },
	          'Go back'
	        )
	      );
	    }
	  }]);
	
	  return RiderSharingModal;
	}(_react.Component);
	
	RiderSharingModal.propTypes = {
	  sharedWithMember: _propTypes2.default.object,
	  shareRider: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	RiderSharingModal.defaultProps = {
	  sharedWithMember: {},
	  shareRider: function shareRider() {},
	  setModal: function setModal() {}
	};
	
	exports.default = RiderSharingModal;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RiderTableCreateModal = function (_Component) {
	  _inherits(RiderTableCreateModal, _Component);
	
	  function RiderTableCreateModal(props) {
	    _classCallCheck(this, RiderTableCreateModal);
	
	    var _this = _possibleConstructorReturn(this, (RiderTableCreateModal.__proto__ || Object.getPrototypeOf(RiderTableCreateModal)).call(this, props));
	
	    _this.state = {
	      title: "",
	      errorMessage: ""
	    };
	    return _this;
	  }
	
	  _createClass(RiderTableCreateModal, [{
	    key: 'addNewRider',
	    value: function addNewRider(e) {
	      e.preventDefault();
	
	      if (this.state.title) {
	        this.props.createRiderTable(this.state.title);
	        this.props.setModal(false);
	
	        this.setState({ title: "", errorMessage: "" });
	      } else {
	        this.setState({ errorMessage: "Please insert title" });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-content' },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.addNewRider.bind(this) },
	          _react2.default.createElement(
	            'ul',
	            { className: 'group', 'data-error-msg': this.state.errorMessage },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'unit', 'data-title': 'Table\'s title' },
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  value: this.state.title,
	                  onChange: function onChange(e) {
	                    return _this2.setState({ title: e.target.value });
	                  } })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit' },
	            'Add new table'
	          )
	        )
	      );
	    }
	  }]);
	
	  return RiderTableCreateModal;
	}(_react.Component);
	
	RiderTableCreateModal.propTypes = {
	  createRiderTable: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	RiderTableCreateModal.defaultProps = {
	  createRiderTable: function createRiderTable() {},
	  setModal: function setModal() {}
	};
	
	exports.default = RiderTableCreateModal;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RiderTableEmbeddingModal = function (_Component) {
	  _inherits(RiderTableEmbeddingModal, _Component);
	
	  function RiderTableEmbeddingModal(props) {
	    _classCallCheck(this, RiderTableEmbeddingModal);
	
	    var _this = _possibleConstructorReturn(this, (RiderTableEmbeddingModal.__proto__ || Object.getPrototypeOf(RiderTableEmbeddingModal)).call(this, props));
	
	    _this.state = {
	      roles: null,
	      email: null
	    };
	    return _this;
	  }
	
	  _createClass(RiderTableEmbeddingModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal modal-full' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Previewing ',
	          this.props.title
	        ),
	        _react2.default.createElement('iframe', { src: this.props.url, width: '100%', height: '60%', frameBorder: '0' }),
	        _react2.default.createElement(
	          'ul',
	          { className: 'group' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'unit', 'data-title': 'Use this on your website:' },
	              _react2.default.createElement('textarea', { rows: '2', defaultValue: '<iframe src="' + this.props.url + '" width="100%" height="100%" frameBorder="0" />' })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'button',
	              { onClick: function onClick() {
	                  return _this2.props.setModal(false);
	                } },
	              'Close'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RiderTableEmbeddingModal;
	}(_react.Component);
	
	RiderTableEmbeddingModal.propTypes = {
	  title: _propTypes2.default.string,
	  url: _propTypes2.default.string,
	  setModal: _propTypes2.default.func
	};
	
	RiderTableEmbeddingModal.defaultProps = {
	  title: '',
	  url: '',
	  setModal: function setModal() {}
	};
	
	exports.default = RiderTableEmbeddingModal;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RiderTableSharingModal = function (_Component) {
	  _inherits(RiderTableSharingModal, _Component);
	
	  function RiderTableSharingModal() {
	    _classCallCheck(this, RiderTableSharingModal);
	
	    return _possibleConstructorReturn(this, (RiderTableSharingModal.__proto__ || Object.getPrototypeOf(RiderTableSharingModal)).apply(this, arguments));
	  }
	
	  _createClass(RiderTableSharingModal, [{
	    key: 'copyToClipboard',
	    value: function copyToClipboard() {
	      var textField = document.createElement('textarea');
	      textField.innerText = this.props.url;
	      document.body.appendChild(textField);
	      textField.select();
	      document.execCommand('copy');
	      textField.remove();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-inner' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'group' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'unit', 'data-title': 'Your shareable URL:' },
	                _react2.default.createElement('input', {
	                  id: 'copy-url',
	                  type: 'text',
	                  value: this.props.url,
	                  disabled: true })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                _this2.copyToClipboard();
	                _this2.props.setModal(false);
	              } },
	            'Copy this URL'
	          )
	        )
	      );
	    }
	  }]);
	
	  return RiderTableSharingModal;
	}(_react.Component);
	
	RiderTableSharingModal.propTypes = {
	  setModal: _propTypes2.default.func
	};
	
	RiderTableSharingModal.defaultProps = {
	  setModal: function setModal() {}
	};
	
	exports.default = RiderTableSharingModal;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _riek = __webpack_require__(46);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input() {
	    _classCallCheck(this, Input);
	
	    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
	  }
	
	  _createClass(Input, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextProps.value !== this.props.value) return true;
	      if (nextProps.propName !== this.props.propName) return true;
	      if (nextProps.className !== this.props.className) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          propName = _props.propName,
	          className = _props.className;
	
	
	      return _react2.default.createElement(_riek.RIEInput, {
	        value: value,
	        propName: propName,
	        className: className,
	        classEditing: 'riek-editing',
	        change: function change(propValue) {
	          return _this2.props.change(propValue);
	        } });
	    }
	  }]);
	
	  return Input;
	}(_react.Component);
	
	var Contact = function (_Component2) {
	  _inherits(Contact, _Component2);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this3 = _possibleConstructorReturn(this, (Contact.__proto__ || Object.getPrototypeOf(Contact)).call(this, props));
	
	    _this3.state = {
	      title: '',
	      name: '',
	      description: '',
	      email: '',
	      phone: '',
	      showDropdown: false,
	      focus: false,
	      error: ''
	    };
	
	    _this3.input = _react2.default.createRef();
	    return _this3;
	  }
	
	  _createClass(Contact, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var contact = this.props.contact;
	      var title = contact.title,
	          name = contact.name,
	          description = contact.description,
	          email = contact.email,
	          phone = contact.phone;
	
	
	      this.setState({ title: title, name: name, description: description, email: email, phone: phone });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var contact = this.props.contact;
	
	
	      if (contact.id === undefined) this.input.current.startEditing();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var contact = nextProps.contact;
	
	
	      if (contact !== this.props.contact) {
	        var title = contact.title,
	            name = contact.name,
	            description = contact.description,
	            email = contact.email,
	            phone = contact.phone;
	
	
	        this.setState({ title: title, name: name, description: description, email: email, phone: phone });
	      }
	    }
	  }, {
	    key: 'contactIsUpdated',
	    value: function contactIsUpdated() {
	      var id = this.props.contact.id;
	      var _state = this.state,
	          title = _state.title,
	          name = _state.name,
	          description = _state.description,
	          email = _state.email,
	          phone = _state.phone;
	
	
	      if (id) {
	        this.props.editRiderContact({ id: id, title: title, name: name, description: description, email: email, phone: phone });
	      } else {
	        this.props.createRiderContact({ title: title, name: name, description: description, email: email, phone: phone });
	      }
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown(contact) {
	      var _this4 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this4.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this4.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this4.setState({ showDropdown: false }, function () {
	                  return _this4.props.deleteRiderContact(contact);
	                });
	              } },
	            'Remove this contact'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderContact',
	    value: function renderContact() {
	      var _this5 = this;
	
	      var _props2 = this.props,
	          view = _props2.view,
	          contact = _props2.contact,
	          position = _props2.position,
	          isDragging = _props2.isDragging,
	          stageElements = _props2.stageElements;
	      var _state2 = this.state,
	          title = _state2.title,
	          name = _state2.name,
	          description = _state2.description,
	          phone = _state2.phone,
	          showDropdown = _state2.showDropdown,
	          focus = _state2.focus,
	          error = _state2.error;
	
	
	      var className = (0, _classnames2.default)({
	        'card': true,
	        'card--focus': showDropdown || focus,
	        'contact': true
	      });
	
	      var nameClassName = (0, _classnames2.default)({
	        'riek': true,
	        'name': true,
	        'h4': true,
	        'placeholder': !name
	      });
	
	      var titleClassName = (0, _classnames2.default)({
	        'riek': true,
	        'title': true,
	        'placeholder': !title
	      });
	
	      var phoneClassName = (0, _classnames2.default)({
	        'riek': true,
	        'phone': true,
	        'placeholder': !phone
	      });
	
	      var droppableClassName = function droppableClassName(isDraggingOver) {
	        return (0, _classnames2.default)({
	          'contact--droppable': true,
	          'contact--droppable-dragging': isDragging,
	          'contact--droppable-dragging-over': isDraggingOver
	        });
	      };
	
	      return _react2.default.createElement(
	        'li',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-content', 'data-number': position, 'data-error': error },
	          view.editable ? this.renderDropdown(contact) : null,
	          view.editable ? _react2.default.createElement(Input, {
	            value: name || '',
	            propName: 'name',
	            className: nameClassName,
	            change: function change(_ref) {
	              var name = _ref.name;
	
	              name ? _this5.setState({ name: name }, function () {
	                return _this5.contactIsUpdated();
	              }) : _this5.setState({ name: contact.name });
	            } }) : _react2.default.createElement(
	            'div',
	            { className: nameClassName },
	            name
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'enter' },
	            'Enter'
	          ),
	          view.editable ? _react2.default.createElement(Input, {
	            value: title || 'Add a position',
	            propName: 'title',
	            className: titleClassName,
	            change: function change(_ref2) {
	              var title = _ref2.title;
	              return _this5.setState({ title: title }, function () {
	                return _this5.contactIsUpdated();
	              });
	            } }) : _react2.default.createElement(
	            'div',
	            { className: titleClassName },
	            title
	          ),
	          view.editable ? _react2.default.createElement(Input, {
	            value: phone || 'Add a phone number',
	            propName: 'phone',
	            className: phoneClassName,
	            change: function change(_ref3) {
	              var phone = _ref3.phone;
	              return _this5.setState({ phone: phone }, function () {
	                return _this5.contactIsUpdated();
	              });
	            } }) : _react2.default.createElement(
	            'div',
	            { className: phoneClassName },
	            phone
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEmptyContact',
	    value: function renderEmptyContact() {
	      var _this6 = this;
	
	      var _props3 = this.props,
	          view = _props3.view,
	          position = _props3.position;
	      var _state3 = this.state,
	          name = _state3.name,
	          error = _state3.error;
	
	
	      var className = (0, _classnames2.default)({
	        'card': true,
	        'card--focus': true
	      });
	
	      if (view.editable !== true) return null;
	
	      return _react2.default.createElement(
	        'li',
	        { className: className },
	        _react2.default.createElement('div', { className: 'card-escape', onClick: function onClick() {
	            return _this6.props.removeRiderContact(position - 1);
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-content', 'data-number': position, 'data-error': error, tabIndex: '0',
	            onKeyDown: function onKeyDown(e) {
	              return e.key === 'Enter' ? setTimeout(function () {
	                var name = _this6.state.name;
	
	
	                _this6.setState({
	                  error: !name ? 'Please insert a name' : null
	                }, function () {
	                  name ? _this6.contactIsUpdated() : _this6.input.current.startEditing();
	                });
	              }, 1) // add setTimeout as change and onKeyDown are fired asynchronously
	              : e.key === 'Escape' ? _this6.props.removeRiderContact(position - 1) : null;
	            } },
	          _react2.default.createElement('div', { className: 'riek-escape', onClick: function onClick() {
	              return _this6.props.removeRiderContact(position - 1);
	            } }),
	          _react2.default.createElement(_riek.RIEInput, {
	            ref: this.input,
	            value: name || '',
	            propName: 'name',
	            className: 'riek riek-editing name h4',
	            change: function change(_ref4) {
	              var name = _ref4.name;
	              return _this6.setState({ name: (0, _functions.capitalize)(name) });
	            } }),
	          _react2.default.createElement(
	            'label',
	            { className: 'enter', onClick: function onClick() {
	                _this6.setState({
	                  error: !name ? 'Please insert a name' : null
	                }, function () {
	                  name ? _this6.contactIsUpdated() : _this6.input.current.startEditing();
	                });
	              } },
	            'Enter'
	          ),
	          _react2.default.createElement('div', { className: 'remove-contact', onClick: function onClick() {
	              return _this6.props.removeRiderContact(position - 1);
	            } }),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Add new contact'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var contact = this.props.contact;
	
	
	      return contact.id !== undefined ? this.renderContact() : this.renderEmptyContact();
	    }
	  }]);
	
	  return Contact;
	}(_react.Component);
	
	Contact.propTypes = {
	  view: _propTypes2.default.object,
	  contact: _propTypes2.default.object,
	  position: _propTypes2.default.number,
	  isDragging: _propTypes2.default.bool,
	  createRiderItem: _propTypes2.default.func,
	  removeRiderContact: _propTypes2.default.func,
	  createRiderContact: _propTypes2.default.func,
	  editRiderContact: _propTypes2.default.func,
	  deleteRiderContact: _propTypes2.default.func,
	  availableItems: _propTypes2.default.array,
	  stageElements: _propTypes2.default.object,
	  searchResults: _propTypes2.default.array,
	  getSearchResults: _propTypes2.default.func,
	  setAlert: _propTypes2.default.func
	};
	
	Contact.defaultProps = {
	  view: {},
	  contact: {},
	  position: 0,
	  isDragging: false,
	  createRiderItem: function createRiderItem() {},
	  removeRiderContact: function removeRiderContact() {},
	  createRiderContact: function createRiderContact() {},
	  editRiderContact: function editRiderContact() {},
	  deleteRiderContact: function deleteRiderContact() {},
	  availableItems: [],
	  stageElements: {},
	  searchResults: undefined,
	  getSearchResults: function getSearchResults() {},
	  setAlert: function setAlert() {}
	};
	
	exports.default = Contact;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _riek = __webpack_require__(46);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _contact = __webpack_require__(295);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contacts = function (_Component) {
	  _inherits(Contacts, _Component);
	
	  function Contacts(props) {
	    _classCallCheck(this, Contacts);
	
	    var _this = _possibleConstructorReturn(this, (Contacts.__proto__ || Object.getPrototypeOf(Contacts)).call(this, props));
	
	    _this.state = {
	      isDragging: false,
	      sourceDroppableId: undefined
	    };
	    return _this;
	  }
	
	  _createClass(Contacts, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          contacts = _props.contacts;
	      var isDragging = this.state.isDragging;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'contacts' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section-head' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Contacts'
	          )
	        ),
	        _react2.default.createElement(
	          'ol',
	          { className: 'cards' },
	          contacts.map(function (contact, index) {
	            return _react2.default.createElement(_contact2.default, { key: index,
	              view: view,
	              contact: contact,
	              position: index + 1,
	              isDragging: isDragging,
	              removeRiderContact: _this2.props.removeRiderContact,
	              createRiderContact: _this2.props.createRiderContact,
	              editRiderContact: _this2.props.editRiderContact,
	              deleteRiderContact: _this2.props.deleteRiderContact,
	              setAlert: _this2.props.setAlert });
	          }),
	          view.editable ? _react2.default.createElement(
	            'li',
	            { className: 'card card--add', onClick: function onClick() {
	                _this2.props.addRiderContact({
	                  id: undefined,
	                  name: null,
	                  email: null,
	                  phone: null,
	                  items: []
	                });
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-content', 'data-number': contacts.length + 1 },
	              _react2.default.createElement(
	                'h1',
	                { className: 'add-contact' },
	                '+'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Add new contact'
	              )
	            )
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return Contacts;
	}(_react.Component);
	
	Contacts.propTypes = {
	  view: _propTypes2.default.object,
	  contacts: _propTypes2.default.array,
	  addRiderContact: _propTypes2.default.func,
	  removeRiderContact: _propTypes2.default.func,
	  createRiderContact: _propTypes2.default.func,
	  editRiderContact: _propTypes2.default.func,
	  moveRiderContact: _propTypes2.default.func,
	  deleteRiderContact: _propTypes2.default.func,
	  setAlert: _propTypes2.default.func
	};
	
	Contacts.defaultProps = {
	  view: {},
	  contacts: [],
	  addRiderContact: function addRiderContact() {},
	  removeRiderContact: function removeRiderContact() {},
	  createRiderContact: function createRiderContact() {},
	  editRiderContact: function editRiderContact() {},
	  moveRiderContact: function moveRiderContact() {},
	  deleteRiderContact: function deleteRiderContact() {},
	  setAlert: function setAlert() {}
	};
	
	exports.default = Contacts;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _riek = __webpack_require__(46);
	
	var _reactAutosizeTextarea = __webpack_require__(128);
	
	var _reactAutosizeTextarea2 = _interopRequireDefault(_reactAutosizeTextarea);
	
	var _switch = __webpack_require__(57);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _sharing = __webpack_require__(324);
	
	var _sharing2 = _interopRequireDefault(_sharing);
	
	var _sharingForm = __webpack_require__(323);
	
	var _sharingForm2 = _interopRequireDefault(_sharingForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var General = function (_Component) {
	  _inherits(General, _Component);
	
	  function General(props) {
	    _classCallCheck(this, General);
	
	    var _this = _possibleConstructorReturn(this, (General.__proto__ || Object.getPrototypeOf(General)).call(this, props));
	
	    _this.state = {
	      title: '',
	      description: '',
	      publicSharing: undefined,
	      linkSharing: undefined,
	      showDropdown: false,
	      showSharingDropdown: false
	    };
	
	    _this.title = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(General, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          title = _props.title,
	          description = _props.description,
	          publicSharing = _props.publicSharing,
	          linkSharing = _props.linkSharing;
	
	
	      this.setState({ title: title, description: description, publicSharing: publicSharing, linkSharing: linkSharing });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var title = nextProps.title,
	          description = nextProps.description,
	          publicSharing = nextProps.publicSharing,
	          linkSharing = nextProps.linkSharing;
	
	
	      if (title !== this.props.title) this.setState({ title: title });
	      if (description !== this.props.description) this.setState({ description: description });
	      if (publicSharing !== this.props.publicSharing) this.setState({ publicSharing: publicSharing });
	      if (linkSharing !== this.props.linkSharing) this.setState({ linkSharing: linkSharing });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var title = nextState.title,
	          description = nextState.description,
	          publicSharing = nextState.publicSharing,
	          linkSharing = nextState.linkSharing,
	          shares = nextState.shares;
	
	
	      if (title !== this.props.title) return true;
	      if (description !== this.props.description) return true;
	      if (publicSharing !== this.props.publicSharing) return true;
	      if (linkSharing !== this.props.linkSharing) return true;
	      if (shares !== this.props.shares) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	
	    // getSharingStatus(sharing) { // converts string value
	    //   return {
	    //     'public': 'Public',
	    //     'url': 'Link-only',
	    //     'private': 'Private'
	    //   }[sharing]
	    // }
	
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown() {
	      var _this2 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--main': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'ui-dropdown-handle', onClick: function onClick() {
	              return _this2.setState({ showDropdown: !showDropdown });
	            } },
	          _react2.default.createElement('div', { className: 'ui-dropdown-handle-ball' }),
	          _react2.default.createElement('div', { className: 'ui-dropdown-handle-ball' }),
	          _react2.default.createElement('div', { className: 'ui-dropdown-handle-ball' })
	        ),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  return _this2.title.current.startEditing();
	                });
	              } },
	            'Rename rider'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false, showSharingDropdown: true });
	              } },
	            'Share rider'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  return _this2.props.exportPDF('rider-document');
	                });
	              } },
	            'Export as PDF'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.props.deleteRider();
	              } },
	            'Delete rider'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderSharingDropdown',
	    value: function renderSharingDropdown(publicSharing, linkSharing) {
	      var _this3 = this;
	
	      var shares = this.props.shares;
	      var showSharingDropdown = this.state.showSharingDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--sharing': true,
	        'ui-dropdown--active': showSharingDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showSharingDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this3.setState({ showSharingDropdown: !showSharingDropdown });
	          } }) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'ui-dropdown-value', onClick: function onClick() {
	              return _this3.setState({ showSharingDropdown: !showSharingDropdown });
	            } },
	          publicSharing ? linkSharing ? "Public and shared with link" : "Public" : linkSharing ? "Shared with link" : "Private"
	        ),
	        showSharingDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(_switch2.default, {
	              required: publicSharing,
	              toggleSwitch: function toggleSwitch(required) {
	                return _this3.setState({ showSharingDropdown: false }, function () {
	                  return _this3.props.editRider({ publicSharing: !publicSharing });
	                });
	              } }),
	            _react2.default.createElement(
	              'span',
	              { className: 'title' },
	              'Public'
	            ),
	            _react2.default.createElement(
	              'small',
	              null,
	              'Your rider can be searched by all users.'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(_switch2.default, {
	              required: linkSharing,
	              toggleSwitch: function toggleSwitch(required) {
	                return _this3.setState({ showSharingDropdown: false }, function () {
	                  return _this3.props.editRider({ linkSharing: !linkSharing });
	                });
	              } }),
	            _react2.default.createElement(
	              'span',
	              { className: 'title' },
	              'Link sharing'
	            ),
	            _react2.default.createElement(
	              'small',
	              null,
	              'Anyone with a link can view this rider.'
	            )
	          ),
	          _react2.default.createElement('li', { className: 'hr' }),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'small',
	              null,
	              'Invite band member with write permissions:'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(_sharingForm2.default, {
	              shareRider: this.props.shareRider })
	          ),
	          shares.length > 0 ? _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'small',
	              null,
	              'Current collaborators:'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              shares.map(function (share, index) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: index, onClick: function onClick() {
	                      return _this3.props.removeRiderShare(share.id);
	                    } },
	                  '\u2014 ',
	                  share.email
	                );
	              })
	            )
	          ) : null
	        ) : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          view = _props2.view,
	          shares = _props2.shares;
	      var _state = this.state,
	          title = _state.title,
	          description = _state.description,
	          publicSharing = _state.publicSharing,
	          linkSharing = _state.linkSharing;
	
	
	      var titleClassName = (0, _classnames2.default)({
	        'riek': true,
	        'riek--focusable': view.editable,
	        'title': true,
	        'h1': true,
	        'placeholder': !title
	      });
	
	      var descriptionClassName = (0, _classnames2.default)({
	        'textarea-autosize': true,
	        'textarea-autosize--focusable': view.editable,
	        'description': true,
	        'placeholder': !description
	      });
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'general' },
	        _react2.default.createElement(
	          'div',
	          { className: 'heading' },
	          view.editable ? _react2.default.createElement(_riek.RIEInput, { ref: this.title,
	            value: title || 'Title - click to add',
	            propName: 'title',
	            className: titleClassName,
	            classEditing: 'riek-editing',
	            change: function change(_ref) {
	              var title = _ref.title;
	              return _this4.setState({ title: title }, function () {
	                return _this4.props.editRider({ title: title });
	              });
	            } }) : _react2.default.createElement(
	            'div',
	            { className: titleClassName },
	            title
	          ),
	          view.editable ? this.renderSharingDropdown(publicSharing, linkSharing) : null,
	          view.editable ? this.renderDropdown() : null
	        ),
	        view.editable ? _react2.default.createElement(_reactAutosizeTextarea2.default, {
	          value: description !== null ? description : 'Please click to add your rider description',
	          className: descriptionClassName,
	          onClick: function onClick() {
	            if (description === null) {
	              _this4.setState({
	                description: ''
	              });
	            }
	          },
	          onChange: function onChange(e) {
	            _this4.setState({
	              description: e.target.value
	            });
	          },
	          onBlur: function onBlur() {
	            if (description) {
	              _this4.props.editRider({ description: description });
	            } else {
	              _this4.setState({
	                description: null
	              });
	            }
	          } }) : _react2.default.createElement(
	          'div',
	          { className: 'textarea-autosize description' },
	          description
	        )
	      );
	    }
	  }]);
	
	  return General;
	}(_react.Component);
	
	General.propTypes = {
	  view: _propTypes2.default.object,
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  publicSharing: _propTypes2.default.bool,
	  linkSharing: _propTypes2.default.bool,
	  shares: _propTypes2.default.array,
	  editRider: _propTypes2.default.func,
	  shareRider: _propTypes2.default.func,
	  removeRiderShare: _propTypes2.default.func,
	  deleteRider: _propTypes2.default.func,
	  exportPDF: _propTypes2.default.func
	};
	
	General.defaultProps = {
	  view: {},
	  title: '',
	  description: '',
	  publicSharing: undefined,
	  linkSharing: undefined,
	  shares: [],
	  editRider: function editRider() {},
	  shareRider: function shareRider() {},
	  removeRiderShare: function removeRiderShare() {},
	  deleteRider: function deleteRider() {},
	  exportPDF: function exportPDF() {}
	};
	
	exports.default = General;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _restricted = __webpack_require__(94);
	
	var _restricted2 = _interopRequireDefault(_restricted);
	
	var _list = __webpack_require__(168);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Requirements = function (_Component) {
	  _inherits(Requirements, _Component);
	
	  function Requirements() {
	    _classCallCheck(this, Requirements);
	
	    return _possibleConstructorReturn(this, (Requirements.__proto__ || Object.getPrototypeOf(Requirements)).apply(this, arguments));
	  }
	
	  _createClass(Requirements, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          view = _props.view,
	          rider = _props.rider;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'requirements' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section-head' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Hospitality'
	          )
	        ),
	        view.loggedIn ? _react2.default.createElement(_list2.default, {
	          view: view,
	          requirements: {
	            group: 'hospitality',
	            class: 'requirement',
	            title: 'Hospitality requirement'
	          },
	          items: rider.hospitality,
	          addRiderItem: this.props.addRiderItem,
	          removeRiderItem: this.props.removeRiderItem,
	          createRiderItem: this.props.createRiderItem,
	          editRiderItem: this.props.editRiderItem,
	          moveRiderItem: this.props.moveRiderItem,
	          deleteRiderItem: this.props.deleteRiderItem }) : _react2.default.createElement(_restricted2.default, {
	          section: 'Hospitality',
	          setModal: this.props.setModal })
	      );
	    }
	  }]);
	
	  return Requirements;
	}(_react.Component);
	
	Requirements.propTypes = {
	  view: _propTypes2.default.object,
	  rider: _propTypes2.default.object,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	Requirements.defaultProps = {
	  view: {},
	  rider: {},
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  setModal: function setModal() {}
	};
	
	exports.default = Requirements;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _reactSelect = __webpack_require__(20);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _functions = __webpack_require__(6);
	
	var _selectForm = __webpack_require__(58);
	
	var _selectForm2 = _interopRequireDefault(_selectForm);
	
	var _switch = __webpack_require__(57);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListEquipment = function (_Component) {
	  _inherits(ListEquipment, _Component);
	
	  function ListEquipment(props) {
	    _classCallCheck(this, ListEquipment);
	
	    var _this = _possibleConstructorReturn(this, (ListEquipment.__proto__ || Object.getPrototypeOf(ListEquipment)).call(this, props));
	
	    _this.state = {
	      required: false,
	      showSelectForm: false,
	      showTypeSelectForm: false,
	      showDropdown: false
	    };
	    return _this;
	  }
	
	  _createClass(ListEquipment, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var required = this.props.required;
	
	
	      this.setState({ required: required });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var required = nextProps.required;
	
	
	      if (this.props.required !== required) {
	        this.setState({ required: required });
	      }
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown(item) {
	      var _this2 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showTypeSelectForm: true, showDropdown: false });
	              } },
	            'Change type'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showSelectForm: true, showDropdown: false });
	              } },
	            'Rename equipment'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  return _this2.props.deleteRiderItem(item.id);
	                });
	              } },
	            'Remove this equipment'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderEmptyEquipmentItem',
	    value: function renderEmptyEquipmentItem(item, parentId, stageElements) {
	      var _this3 = this;
	
	      var view = this.props.view;
	
	
	      if (view.editable !== true) return null;
	
	      return _react2.default.createElement(_selectForm2.default, {
	        group: this.props.group,
	        item: {
	          class: 'equipment',
	          parent: parentId
	        },
	        position: 0,
	        setFocus: true,
	        removeFocus: function removeFocus() {
	          return _this3.props.removeRiderItem(item);
	        },
	        createRiderColumn: this.props.createRiderColumn,
	        createRiderItem: this.props.createRiderItem,
	        editRiderItem: this.props.editRiderItem,
	        options: this.props.options,
	        categories: this.props.categories,
	        creatableCategory: true,
	        searchResults: (0, _functions.validateSearchResults)(stageElements),
	        getSearchResults: this.props.getSearchResults });
	    }
	  }, {
	    key: 'renderEquipmentItem',
	    value: function renderEquipmentItem(item, parentId, stageElements) {
	      var _this4 = this;
	
	      var view = this.props.view;
	
	
	      var renderSelectForm = function renderSelectForm(item, stageElements) {
	        return _react2.default.createElement(_selectForm2.default, {
	          group: _this4.props.group,
	          item: item,
	          position: item.children.length + 1,
	          setFocus: true,
	          removeFocus: function removeFocus() {
	            return _this4.setState({ showSelectForm: false });
	          },
	          createRiderColumn: _this4.props.createRiderColumn,
	          createRiderItem: _this4.props.createRiderItem,
	          editRiderItem: _this4.props.editRiderItem,
	          options: (0, _functions.getStageElementsByTypes)(['cable', 'insert', 'microphone', 'stand'], stageElements),
	          categories: (0, _functions.getStageElementsByTypes)(['cable', 'insert', 'microphone', 'stand'], stageElements.groups),
	          creatableCategory: true,
	          searchResults: (0, _functions.validateSearchResults)(stageElements),
	          getSearchResults: _this4.props.getSearchResults });
	      };
	
	      var renderTypeSelectForm = function renderTypeSelectForm(item, stageElements) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'select-form select-form--type' },
	          _react2.default.createElement('div', { className: 'select-form-escape', onClick: function onClick() {
	              return _this4.setState({ showTypeSelectForm: false });
	            } }),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-form-fields' },
	            _react2.default.createElement(_reactSelect2.default, {
	              autoFocus: true,
	              openOnFocus: true,
	              className: 'select-form-field',
	              name: 'item-type-selector-' + item.id,
	              value: undefined,
	              valueKey: 'id',
	              labelKey: 'title',
	              clearable: false,
	              onChange: function onChange(selectedItem) {
	                return _this4.setState({ showTypeSelectForm: false }, function () {
	                  return _this4.props.editRiderItem({ id: item.id, type: selectedItem.type.slug });
	                });
	              },
	              categories: (0, _functions.getStageElementsByTypes)(['cable', 'insert', 'microphone', 'stand'], stageElements.groups) })
	          )
	        );
	      };
	
	      var renderListEquipmentItem = function renderListEquipmentItem(item, stageElements) {
	        var _state = _this4.state,
	            required = _state.required,
	            showTypeSelectForm = _state.showTypeSelectForm;
	
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'list-equipment-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'list-equipment-item--title', onClick: function onClick() {
	                return _this4.setState({ showSelectForm: true });
	              } },
	            item.title
	          ),
	          !showTypeSelectForm && view.editable ? _this4.renderDropdown(item) : null,
	          view.editable ? !showTypeSelectForm ? _react2.default.createElement(
	            'div',
	            { className: 'list-equipment-item--type', onClick: function onClick() {
	                return _this4.setState({ showDropdown: !_this4.state.showDropdown });
	              } },
	            item.type.title
	          ) : renderTypeSelectForm(item, stageElements) : null,
	          view.editable ? _react2.default.createElement(_switch2.default, {
	            required: required,
	            toggleSwitch: function toggleSwitch(required) {
	              return _this4.setState({ required: required }, function () {
	                return _this4.props.editRiderItem({ id: item.id, required: required });
	              });
	            } }) : item.required ? _react2.default.createElement(
	            'div',
	            null,
	            'Required'
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            'Band brings'
	          )
	        );
	      };
	
	      var showSelectForm = this.state.showSelectForm;
	
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Draggable,
	        { draggableId: item.id, isDragDisabled: !view.editable, type: 'equipment-' + parentId },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              Object.assign({ className: 'list-equipment--draggable',
	                ref: provided.innerRef,
	                style: provided.draggableStyle
	              }, provided.dragHandleProps),
	              showSelectForm && view.editable ? renderSelectForm(item, parentId, stageElements) : renderListEquipmentItem(item, stageElements)
	            ),
	            provided.placeholder
	          );
	        }
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          item = _props.item,
	          parentId = _props.parentId,
	          stageElements = _props.stageElements;
	
	
	      return item.id !== undefined ? this.renderEquipmentItem(item, parentId, stageElements) : this.renderEmptyEquipmentItem(item, parentId, stageElements);
	    }
	  }]);
	
	  return ListEquipment;
	}(_react.Component);
	
	ListEquipment.propTypes = {
	  view: _propTypes2.default.object,
	  group: _propTypes2.default.string,
	  item: _propTypes2.default.object,
	  createRiderColumn: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  parentId: _propTypes2.default.string,
	  required: _propTypes2.default.bool,
	  stageElements: _propTypes2.default.object,
	  categories: _propTypes2.default.array,
	  options: _propTypes2.default.array,
	  getSearchResults: _propTypes2.default.func
	};
	
	ListEquipment.defaultProps = {
	  view: {},
	  group: '',
	  item: {},
	  createRiderColumn: function createRiderColumn() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  parentId: '',
	  required: false,
	  stageElements: {},
	  options: undefined,
	  categories: undefined,
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = ListEquipment;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _listEquipmentItem = __webpack_require__(299);
	
	var _listEquipmentItem2 = _interopRequireDefault(_listEquipmentItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListEquipment = function (_Component) {
	  _inherits(ListEquipment, _Component);
	
	  function ListEquipment(props) {
	    _classCallCheck(this, ListEquipment);
	
	    var _this = _possibleConstructorReturn(this, (ListEquipment.__proto__ || Object.getPrototypeOf(ListEquipment)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ListEquipment, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          columns = _props.columns,
	          itemId = _props.itemId,
	          items = _props.items,
	          stageElements = _props.stageElements;
	
	
	      var availableEquipmentTypes = (0, _functions.getAvailableEquipmentTypes)(columns, items);
	
	      var options = (0, _functions.getStageElementsByTypes)(availableEquipmentTypes.ids, stageElements);
	      var categories = availableEquipmentTypes.objects;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'list-equipment' },
	        _react2.default.createElement(
	          _reactBeautifulDnd.Droppable,
	          { droppableId: itemId, type: 'equipment-' + itemId },
	          function (provided, snapshot) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'list-equipment--droppable',
	                ref: provided.innerRef },
	              items.map(function (item, index) {
	                return item.class === 'equipment' ? _react2.default.createElement(_listEquipmentItem2.default, { key: item.id || index,
	                  view: view,
	                  group: _this2.props.group,
	                  item: item,
	                  parentId: itemId,
	                  required: item.required,
	                  createRiderColumn: _this2.props.createRiderColumn,
	                  removeRiderItem: _this2.props.removeRiderItem,
	                  createRiderItem: _this2.props.createRiderItem,
	                  editRiderItem: _this2.props.editRiderItem,
	                  deleteRiderItem: _this2.props.deleteRiderItem,
	                  stageElements: _this2.props.stageElements,
	                  options: options,
	                  categories: categories,
	                  getSearchResults: _this2.props.getSearchResults }) : null;
	              }),
	              provided.placeholder
	            );
	          }
	        ),
	        view.editable ? categories.length > 0 ? _react2.default.createElement(
	          'button',
	          { className: 'list--add-button button--inline', onClick: function onClick() {
	              _this2.props.addRiderItem({
	                class: "equipment",
	                position: items.length + 1,
	                parent: itemId,
	                indexes: _this2.props.parentItemIndex !== undefined ? [_this2.props.parentItemIndex, _this2.props.itemIndex, items.length] : [_this2.props.itemIndex, items.length]
	              });
	            } },
	          '+ Add equipment to this instrument'
	        ) : _react2.default.createElement(
	          'p',
	          null,
	          'For adding new equipment, please create additional column in Compact view.'
	        ) : null
	      );
	    }
	  }]);
	
	  return ListEquipment;
	}(_react.Component);
	
	ListEquipment.propTypes = {
	  view: _propTypes2.default.object,
	  group: _propTypes2.default.string,
	  columns: _propTypes2.default.array,
	  itemId: _propTypes2.default.string,
	  itemIndex: _propTypes2.default.number,
	  parentItemIndex: _propTypes2.default.number,
	  items: _propTypes2.default.array,
	  createRiderColumn: _propTypes2.default.func,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  getSearchResults: _propTypes2.default.func
	};
	
	ListEquipment.defaultProps = {
	  view: {},
	  group: '',
	  columns: [],
	  itemId: '',
	  itemIndex: undefined,
	  parentItemIndex: undefined,
	  items: [],
	  createRiderColumn: function createRiderColumn() {},
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  stageElements: {},
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = ListEquipment;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _listItem = __webpack_require__(164);
	
	var _listItem2 = _interopRequireDefault(_listItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListGroup = function (_Component) {
	  _inherits(ListGroup, _Component);
	
	  function ListGroup(props) {
	    _classCallCheck(this, ListGroup);
	
	    var _this = _possibleConstructorReturn(this, (ListGroup.__proto__ || Object.getPrototypeOf(ListGroup)).call(this, props));
	
	    _this.state = {
	      showEmptyListItem: false,
	      showDropdown: false
	    };
	    return _this;
	  }
	
	  _createClass(ListGroup, [{
	    key: 'matchGroupChildren',
	    value: function matchGroupChildren(children, drumElements) {
	      var onlyDrumElements = children.every(function (child) {
	        return child.title !== undefined ? drumElements.includes(child.title) : true;
	      });
	      var unusedDrumElements = [].concat(_toConsumableArray(drumElements));
	
	      children.forEach(function (child) {
	        var index = unusedDrumElements.indexOf(child.title);
	        unusedDrumElements = index !== -1 ? (0, _immutabilityHelper2.default)(unusedDrumElements, { $splice: [[index, 1]] }) : unusedDrumElements;
	      });
	
	      return onlyDrumElements && unusedDrumElements.length > 0;
	    }
	  }, {
	    key: 'addDefaultDrumSet',
	    value: function addDefaultDrumSet(item, children, drumElements) {
	      var _this2 = this;
	
	      var items = [];
	      var position = 0;
	
	      drumElements.forEach(function (element, index) {
	        var elementExists = children.map(function (child) {
	          return child.title;
	        }).includes(element);
	
	        if (!elementExists) {
	          position += 1;
	
	          items = (0, _immutabilityHelper2.default)(items, { $push: [{
	              class: 'instrument',
	              group: _this2.props.group,
	              type: 'drums',
	              title: element,
	              position: children.length + position,
	              parent: item.id
	            }] });
	        }
	      });
	
	      this.props.createRiderItems(null, items);
	    }
	  }, {
	    key: 'refuseDefaultDrumSet',
	    value: function refuseDefaultDrumSet(item, params) {
	      params = !params ? (0, _immutabilityHelper2.default)(params, { $set: {} }) : params;
	
	      this.props.editRiderItem({
	        id: item.id,
	        params: (0, _immutabilityHelper2.default)(params, {
	          $merge: { hideGroupInitialization: true }
	        })
	      });
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown(item, children, drumElements, showGroupInitialization) {
	      var _this3 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this3.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this3.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          showGroupInitialization ? _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this3.setState({ showDropdown: false }, function () {
	                  return _this3.addDefaultDrumSet(item, children, drumElements);
	                });
	              } },
	            'Add default drum set'
	          ) : null,
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this3.setState({ showDropdown: false }, function () {
	                  return _this3.props.deleteRiderItem(item.id);
	                });
	              } },
	            'Remove this instrument group'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          columns = _props.columns,
	          item = _props.item,
	          stageElements = _props.stageElements;
	      var children = item.children;
	      var params = item.params;
	
	
	      var drumElements = ['Kick drum', 'Snare drum', 'Rack tom', 'Floor tom', 'OH L', 'OH R'];
	      var showGroupInitialization = this.matchGroupChildren(children, drumElements);
	      var hideGroupInitialization = params && params.hideGroupInitialization || false;
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Draggable,
	        { key: item.id, draggableId: item.id, isDragDisabled: !view.editable, type: 'instrument' },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'list-group' },
	            _react2.default.createElement(
	              'div',
	              { className: 'list-group--draggable',
	                ref: provided.innerRef,
	                style: provided.draggableStyle },
	              _react2.default.createElement(
	                'div',
	                { className: 'list-group-head' },
	                view.editable ? _react2.default.createElement('div', Object.assign({ className: 'list-group-handle' }, provided.dragHandleProps)) : null,
	                view.editable ? _this4.renderDropdown(item, children, drumElements, showGroupInitialization) : null,
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'list-group-title' },
	                  item.title
	                ),
	                showGroupInitialization && !hideGroupInitialization && children.length > 0 ? _react2.default.createElement(
	                  'p',
	                  { className: 'group-initialization' },
	                  'Add all default drum elements to this Drum set',
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'button--success', onClick: function onClick() {
	                        return _this4.addDefaultDrumSet(item, children, drumElements);
	                      } },
	                    'Add'
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'button--default', onClick: function onClick() {
	                        return _this4.refuseDefaultDrumSet(item, params);
	                      } },
	                    'Hide'
	                  )
	                ) : null
	              ),
	              _react2.default.createElement(
	                _reactBeautifulDnd.Droppable,
	                { droppableId: item.id, isDropDisabled: !view.editable, type: _this4.props.dragDropType },
	                function (provided, snapshot) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'list-group--droppable',
	                      ref: provided.innerRef },
	                    children.length > 0 ? children.map(function (child, index) {
	                      return child.class === 'instrument' ? _react2.default.createElement(_listItem2.default, { key: child.id || index,
	                        view: view,
	                        dragDropType: _this4.props.dragDropType,
	                        group: _this4.props.group,
	                        columns: columns,
	                        item: child,
	                        itemIndex: index,
	                        parentItem: item,
	                        parentItemIndex: _this4.props.itemIndex,
	                        itemGroups: _this4.props.itemGroups,
	                        position: child.position,
	                        required: child.required,
	                        setFocus: child.title ? false : true,
	                        createRiderColumn: _this4.props.createRiderColumn,
	                        addRiderItem: _this4.props.addRiderItem,
	                        removeRiderItem: _this4.props.removeRiderItem,
	                        createRiderItem: _this4.props.createRiderItem,
	                        editRiderItem: _this4.props.editRiderItem,
	                        deleteRiderItem: _this4.props.deleteRiderItem,
	                        stageElements: stageElements,
	                        options: [],
	                        categories: (0, _functions.getStageElementsByTypes)(['drums'], stageElements.groups && stageElements.groups.instrument && stageElements.groups.instrument.groups),
	                        createStageElement: _this4.props.createStageElement,
	                        getSearchResults: _this4.props.getSearchResults }) : null;
	                    }) : null,
	                    provided.placeholder
	                  );
	                }
	              ),
	              showGroupInitialization && !hideGroupInitialization && children.length === 0 ? _react2.default.createElement(
	                'p',
	                { className: 'group-initialization' },
	                'You have created a ' + item.title + '.',
	                _react2.default.createElement('br', null),
	                'Start by typing in drum elements such as "Kick drum", "Snare drum" etc,',
	                _react2.default.createElement('br', null),
	                'or let us set up a default set for you',
	                _react2.default.createElement(
	                  'button',
	                  { className: 'button--success', onClick: function onClick() {
	                      return _this4.addDefaultDrumSet(item, children, drumElements);
	                    } },
	                  'Set up'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'button--default', onClick: function onClick() {
	                      return _this4.refuseDefaultDrumSet(item, params);
	                    } },
	                  'No thanks'
	                )
	              ) : null,
	              view.editable ? _react2.default.createElement(
	                'button',
	                { className: 'list--add-button button--link', onClick: function onClick() {
	                    _this4.props.addRiderItem({
	                      class: "instrument",
	                      position: children.length + 1,
	                      parent: item.id || null,
	                      type: item.type,
	                      indexes: [_this4.props.itemIndex, children.length]
	                    });
	                  } },
	                'Insert instrument to ',
	                item.title
	              ) : null
	            ),
	            provided.placeholder
	          );
	        }
	      );
	    }
	  }]);
	
	  return ListGroup;
	}(_react.Component);
	
	ListGroup.propTypes = {
	  view: _propTypes2.default.object,
	  dragDropType: _propTypes2.default.string,
	  group: _propTypes2.default.string,
	  columns: _propTypes2.default.array,
	  item: _propTypes2.default.object,
	  itemIndex: _propTypes2.default.number,
	  itemGroups: _propTypes2.default.array,
	  createRiderColumn: _propTypes2.default.func,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  createRiderItems: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  createStageElement: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func
	};
	
	ListGroup.defaultProps = {
	  view: {},
	  dragDropType: '',
	  group: '',
	  columns: [],
	  item: {},
	  itemIndex: undefined,
	  itemGroups: [],
	  createRiderColumn: function createRiderColumn() {},
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  createRiderItems: function createRiderItems() {},
	  editRiderItem: function editRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  stageElements: {},
	  createStageElement: function createStageElement() {},
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = ListGroup;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _listGroup = __webpack_require__(301);
	
	var _listGroup2 = _interopRequireDefault(_listGroup);
	
	var _listItem = __webpack_require__(164);
	
	var _listItem2 = _interopRequireDefault(_listItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List(props) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));
	
	    _this.reorderList = function (result) {
	      if (!result.destination) return null;
	
	      var items = (0, _functions.reorder)(_this.state.items, result.source.index, result.destination.index);
	
	      _this.setState({ items: items }, function () {
	        return _this.props.moveRiderItem({ id: result.draggableId, position: result.destination.index + 1 });
	      });
	    };
	
	    _this.state = {
	      items: []
	    };
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var items = this.props.items;
	
	
	      this.setState({ items: items });
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var items = nextProps.items;
	
	
	      if (items !== this.props.items) this.setState({ items: items });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          columns = _props.columns,
	          stageElements = _props.stageElements;
	      var items = this.state.items;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'list' },
	        _react2.default.createElement(
	          _reactBeautifulDnd.DragDropContext,
	          { onDragEnd: this.reorderList },
	          _react2.default.createElement(
	            _reactBeautifulDnd.Droppable,
	            { droppableId: 'list', isDropDisabled: !view.editable, type: 'instrument' },
	            function (provided, snapshot) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'list--droppable',
	                  ref: provided.innerRef },
	                items.length > 0 ? items.map(function (item, index) {
	                  // if (item.id === undefined) return <Loading key={index} className="list-item list-item--loading" />
	
	                  if (item.class.includes('instrument')) {
	                    return item.class === 'instrument-group' ? _react2.default.createElement(_listGroup2.default, { key: item.id || index,
	                      view: view,
	                      dragDropType: 'instrument-group-' + item.id,
	                      group: _this2.props.group,
	                      columns: columns,
	                      item: item,
	                      itemIndex: index,
	                      itemGroups: _this2.props.itemGroups,
	                      createRiderColumn: _this2.props.createRiderColumn,
	                      addRiderItem: _this2.props.addRiderItem,
	                      removeRiderItem: _this2.props.removeRiderItem,
	                      createRiderItem: _this2.props.createRiderItem,
	                      createRiderItems: _this2.props.createRiderItems,
	                      editRiderItem: _this2.props.editRiderItem,
	                      deleteRiderItem: _this2.props.deleteRiderItem,
	                      stageElements: stageElements,
	                      createStageElement: _this2.props.createStageElement,
	                      getSearchResults: _this2.props.getSearchResults }) : _react2.default.createElement(_listItem2.default, { key: item.id || index,
	                      view: view,
	                      dragDropType: 'instrument',
	                      group: _this2.props.group,
	                      columns: columns,
	                      item: item,
	                      itemIndex: index,
	                      itemGroups: _this2.props.itemGroups,
	                      position: item.position,
	                      required: item.required,
	                      createRiderColumn: _this2.props.createRiderColumn,
	                      addRiderItem: _this2.props.addRiderItem,
	                      removeRiderItem: _this2.props.removeRiderItem,
	                      createRiderItem: _this2.props.createRiderItem,
	                      editRiderItem: _this2.props.editRiderItem,
	                      deleteRiderItem: _this2.props.deleteRiderItem,
	                      stageElements: stageElements,
	                      createStageElement: _this2.props.createStageElement,
	                      getSearchResults: _this2.props.getSearchResults });
	                  } else {
	                    return null;
	                  }
	                }) : view.editable ? _react2.default.createElement(
	                  'p',
	                  null,
	                  'Start by adding your ',
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                        _this2.props.addRiderItem({
	                          class: "instrument",
	                          position: items.length + 1,
	                          indexes: [items.length]
	                        });
	                      } },
	                    'first instrument'
	                  ),
	                  '.'
	                ) : _react2.default.createElement(
	                  'p',
	                  null,
	                  'This rider has no instruments'
	                ),
	                provided.placeholder
	              );
	            }
	          )
	        ),
	        view.editable ? _react2.default.createElement(
	          'button',
	          { className: 'list--add-button button--link', onClick: function onClick() {
	              _this2.props.addRiderItem({
	                class: "instrument",
	                position: items.length + 1,
	                indexes: [items.length]
	              });
	            } },
	          'Insert instrument'
	        ) : null
	      );
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	List.propTypes = {
	  view: _propTypes2.default.object,
	  group: _propTypes2.default.string,
	  columns: _propTypes2.default.array,
	  items: _propTypes2.default.array,
	  itemGroups: _propTypes2.default.array,
	  createRiderColumn: _propTypes2.default.func,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  createRiderItems: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  createStageElement: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func
	};
	
	List.defaultProps = {
	  view: {},
	  group: '',
	  columns: [],
	  items: [],
	  itemGroups: [],
	  createRiderColumn: function createRiderColumn() {},
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  createRiderItems: function createRiderItems() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  stageElements: {},
	  createStageElement: function createStageElement() {},
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = List;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _functions = __webpack_require__(6);
	
	var _selectForm = __webpack_require__(58);
	
	var _selectForm2 = _interopRequireDefault(_selectForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableCell = function (_Component) {
	  _inherits(TableCell, _Component);
	
	  function TableCell(props) {
	    _classCallCheck(this, TableCell);
	
	    var _this = _possibleConstructorReturn(this, (TableCell.__proto__ || Object.getPrototypeOf(TableCell)).call(this, props));
	
	    _this.state = {
	      showSelectForm: false,
	      focusKey: undefined
	    };
	    return _this;
	  }
	
	  _createClass(TableCell, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props = this.props,
	          item = _props.item,
	          cellIndex = _props.cellIndex;
	      var focusKey = this.state.focusKey;
	
	
	      if (item.title !== prevProps.item.title) this.props.changeFocus({ preventDefault: function preventDefault() {}, key: focusKey || 'Tab' }, { cell: cellIndex + 1 });
	    }
	  }, {
	    key: 'clearSearchResults',
	    value: function clearSearchResults() {
	      this.props.getSearchResults([]);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          view = _props2.view,
	          channel = _props2.channel,
	          item = _props2.item,
	          cellIndex = _props2.cellIndex,
	          stageElements = _props2.stageElements,
	          options = _props2.options,
	          categories = _props2.categories;
	      var showSelectForm = this.state.showSelectForm;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-cell', id: 'ch' + channel + '-eq' + (cellIndex + 1),
	          onClick: function onClick() {
	            return _this2.setState({ showSelectForm: true });
	          },
	          style: { minWidth: 100 / this.props.paging.size + '%', maxWidth: 100 / this.props.paging.size + '%' } },
	        showSelectForm && view.editable ? _react2.default.createElement(_selectForm2.default, {
	          group: this.props.group,
	          item: item,
	          position: cellIndex,
	          placeholder: 'Enter ' + (item.class === 'instrument' ? "instrument" : item.type.title.toLowerCase()),
	          promptTextCreator: 'Add',
	          typeSelectorText: 'Specify it\'s category',
	          itemGroups: this.props.itemGroups,
	          itemGroupingText: 'We suggest grouping drum elements into',
	          setFocus: true,
	          setFocusKey: function setFocusKey(e) {
	            return _this2.setState({ focusKey: e.key });
	          },
	          changeFocus: function changeFocus(e) {
	            return _this2.props.changeFocus(e, { cell: cellIndex + 1 });
	          },
	          removeFocus: function removeFocus() {
	            return _this2.setState({ showSelectForm: false }, function () {
	              return _this2.clearSearchResults();
	            });
	          },
	          createRiderItem: this.props.createRiderItem,
	          editRiderItem: this.props.editRiderItem,
	          deleteRiderItem: this.props.deleteRiderItem,
	          options: item.class === 'instrument' ? (0, _functions.getStageElementsByTypes)(['instrument'], stageElements) : (0, _functions.getStageElementsByTypes)([item.type.slug], stageElements),
	          categories: item.class === 'instrument' ? (0, _functions.getStageElementsByTypes)(['children'], stageElements.groups && stageElements.groups.instrument) : stageElements.isFetching !== true ? [] : undefined,
	          createStageElement: this.props.createStageElement,
	          searchResults: (0, _functions.validateSearchResults)(stageElements),
	          getSearchResults: this.props.getSearchResults }) : _react2.default.createElement(
	          'div',
	          { className: 'title', 'data-value': item.title },
	          item.title
	        )
	      );
	    }
	  }]);
	
	  return TableCell;
	}(_react.Component);
	
	TableCell.propTypes = {
	  view: _propTypes2.default.object,
	  channel: _propTypes2.default.number,
	  item: _propTypes2.default.object,
	  cellIndex: _propTypes2.default.number,
	  paging: _propTypes2.default.object,
	  itemGroups: _propTypes2.default.array,
	  changeFocus: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  options: _propTypes2.default.array,
	  categories: _propTypes2.default.array,
	  createStageElement: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func
	};
	
	TableCell.defaultProps = {
	  view: {},
	  channel: undefined,
	  item: {},
	  cellIndex: undefined,
	  paging: {},
	  itemGroups: [],
	  changeFocus: function changeFocus() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  stageElements: {},
	  options: undefined,
	  categories: undefined,
	  createStageElement: function createStageElement() {},
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = TableCell;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _reactSelect = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableColumn = function (_Component) {
	  _inherits(TableColumn, _Component);
	
	  function TableColumn(props) {
	    _classCallCheck(this, TableColumn);
	
	    var _this = _possibleConstructorReturn(this, (TableColumn.__proto__ || Object.getPrototypeOf(TableColumn)).call(this, props));
	
	    _this.state = {
	      showDropdown: false
	    };
	    return _this;
	  }
	
	  _createClass(TableColumn, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var column = nextProps.column,
	          paging = nextProps.paging;
	
	
	      if (column !== this.props.column) return true;
	      if (paging !== this.props.paging) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown(column) {
	      var _this2 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  _this2.props.deleteRiderColumn(column.id);
	                });
	              } },
	            'Remove this column'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderEmptyTableColumn',
	    value: function renderEmptyTableColumn(column, paging, availableColumnTypes) {
	      var _this3 = this;
	
	      var view = this.props.view;
	
	
	      if (view.editable !== true) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-column', style: { minWidth: 100 / paging.size + '%', maxWidth: 100 / paging.size + '%' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'select-form' },
	          _react2.default.createElement('div', { className: 'select-form-escape', onClick: function onClick() {
	              return _this3.props.removeRiderColumn();
	            } }),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-form-fields' },
	            _react2.default.createElement(_reactSelect.Creatable, {
	              autoFocus: true,
	              openOnFocus: true,
	              className: 'select-form-field',
	              value: undefined,
	              valueKey: 'id',
	              labelKey: 'title',
	              clearable: false,
	              placeholder: 'Select or type for custom',
	              onChange: function onChange(selectedItem) {
	                return _this3.props.createRiderColumn({ title: selectedItem.title, type: selectedItem.type.slug, position: column.position });
	              },
	              promptTextCreator: function promptTextCreator(label) {
	                return 'Add custom "' + label + '"';
	              },
	              onNewOptionClick: function onNewOptionClick(value) {
	                return _this3.props.createRiderColumn({ title: value.title, type: 'custom', position: column.position });
	              },
	              noResultsText: 'Type to add custom',
	              options: availableColumnTypes })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTableColumn',
	    value: function renderTableColumn(column) {
	      var _this4 = this;
	
	      var view = this.props.view;
	
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Draggable,
	        { draggableId: column.id, isDragDisabled: !view.editable, type: 'column' },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'table-column', style: { minWidth: 100 / _this4.props.paging.size + '%', maxWidth: 100 / _this4.props.paging.size + '%' } },
	            _react2.default.createElement(
	              'div',
	              Object.assign({ className: 'table-column--draggable',
	                ref: provided.innerRef,
	                style: provided.draggableStyle
	              }, provided.dragHandleProps),
	              view.editable ? _react2.default.createElement('div', { className: 'table-column-handle' }) : null,
	              column.title,
	              view.editable ? _this4.renderDropdown(column) : null
	            ),
	            provided.placeholder
	          );
	        }
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          column = _props.column,
	          paging = _props.paging,
	          availableColumnTypes = _props.availableColumnTypes;
	
	
	      return column.id !== undefined ? this.renderTableColumn(column) : this.renderEmptyTableColumn(column, paging, availableColumnTypes);
	    }
	  }]);
	
	  return TableColumn;
	}(_react.Component);
	
	TableColumn.propTypes = {
	  view: _propTypes2.default.object,
	  column: _propTypes2.default.object,
	  paging: _propTypes2.default.object,
	  availableColumnTypes: _propTypes2.default.array,
	  removeRiderColumn: _propTypes2.default.func,
	  createRiderColumn: _propTypes2.default.func,
	  deleteRiderColumn: _propTypes2.default.func
	};
	
	TableColumn.defaultProps = {
	  view: {},
	  column: {},
	  paging: {},
	  availableColumnTypes: [],
	  removeRiderColumn: function removeRiderColumn() {},
	  createRiderColumn: function createRiderColumn() {},
	  deleteRiderColumn: function deleteRiderColumn() {}
	};
	
	exports.default = TableColumn;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _tableRow = __webpack_require__(165);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableGroup = function (_Component) {
	  _inherits(TableGroup, _Component);
	
	  function TableGroup(props) {
	    _classCallCheck(this, TableGroup);
	
	    var _this = _possibleConstructorReturn(this, (TableGroup.__proto__ || Object.getPrototypeOf(TableGroup)).call(this, props));
	
	    _this.state = {
	      showDropdown: false
	    };
	    return _this;
	  }
	
	  _createClass(TableGroup, [{
	    key: 'matchGroupChildren',
	    value: function matchGroupChildren(children, drumElements) {
	      var onlyDrumElements = children.every(function (child) {
	        return child.title !== undefined ? drumElements.includes(child.title) : true;
	      });
	      var unusedDrumElements = [].concat(_toConsumableArray(drumElements));
	
	      children.map(function (child) {
	        unusedDrumElements = (0, _immutabilityHelper2.default)(unusedDrumElements, { $splice: [[child.title, 1]] });
	
	        return child.title !== undefined ? drumElements.includes(child.title) : true;
	      });
	
	      return onlyDrumElements && unusedDrumElements.length > 0;
	    }
	  }, {
	    key: 'addDefaultDrumSet',
	    value: function addDefaultDrumSet(item, children, drumElements) {
	      var _this2 = this;
	
	      var items = [];
	      var position = 0;
	
	      drumElements.forEach(function (element, index) {
	        var elementExists = children.map(function (child) {
	          return child.title;
	        }).includes(element);
	
	        if (!elementExists) {
	          position += 1;
	
	          items = (0, _immutabilityHelper2.default)(items, { $push: [{
	              class: 'instrument',
	              group: _this2.props.group,
	              type: 'drums',
	              title: element,
	              position: children.length + position,
	              parent: item.id
	            }] });
	        }
	      });
	
	      this.props.createRiderItems(null, items);
	    }
	  }, {
	    key: 'refuseDefaultDrumSet',
	    value: function refuseDefaultDrumSet(item, params) {
	      params = !params ? (0, _immutabilityHelper2.default)(params, { $set: {} }) : params;
	
	      this.props.editRiderItem({
	        id: item.id,
	        params: (0, _immutabilityHelper2.default)(params, {
	          $merge: { hideGroupInitialization: true }
	        })
	      });
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown(item, children) {
	      var _this3 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this3.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this3.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this3.setState({ showDropdown: false }, function () {
	                  _this3.props.addRiderItem({
	                    class: "instrument",
	                    position: children.length + 1,
	                    parent: item.id || null,
	                    type: item.type,
	                    indexes: [_this3.props.rowIndex, children.length]
	                  });
	                });
	              } },
	            'Add instrument to ',
	            item.title
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this3.setState({ showDropdown: false }, function () {
	                  return _this3.props.deleteRiderItem(item.id);
	                });
	              } },
	            'Remove this instrument group'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          columns = _props.columns,
	          item = _props.item,
	          rowIndex = _props.rowIndex,
	          stageElements = _props.stageElements;
	      var children = item.children;
	      var params = item.params;
	
	
	      var drumElements = ['Kick drum', 'Snare drum', 'Rack tom', 'Floor tom', 'OH L', 'OH R'];
	      var showGroupInitialization = this.matchGroupChildren(children, drumElements);
	      var hideGroupInitialization = params && params.hideGroupInitialization || false;
	
	      var handleClassName = (0, _classnames2.default)({
	        'table-group-handle': true,
	        'table-group-handle--single': children.length <= 1
	      });
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Draggable,
	        { key: rowIndex, draggableId: item.id, isDragDisabled: !view.editable, type: 'instrument' },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'table-group' },
	            _react2.default.createElement(
	              'div',
	              { className: 'table-group--draggable',
	                ref: provided.innerRef,
	                style: provided.draggableStyle },
	              _react2.default.createElement(
	                'div',
	                Object.assign({ className: handleClassName }, provided.dragHandleProps, { tabIndex: '-1' }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  children.length > 1 ? item.title : 'Drums'
	                )
	              ),
	              view.editable ? _this4.renderDropdown(item, children) : null,
	              _react2.default.createElement(
	                _reactBeautifulDnd.Droppable,
	                { droppableId: item.id, type: _this4.props.dragDropType },
	                function (provided, snapshot) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'table-group--droppable',
	                      ref: provided.innerRef },
	                    children.length > 0 ? children.map(function (child, index) {
	                      if (child.class.includes('instrument')) {
	                        return _react2.default.createElement(_tableRow2.default, { key: index,
	                          view: view,
	                          dragDropType: _this4.props.dragDropType,
	                          group: _this4.props.group,
	                          columns: columns,
	                          item: child,
	                          rowIndex: index,
	                          parentItem: item,
	                          parentRowIndex: rowIndex,
	                          paging: _this4.props.paging,
	                          itemGroups: _this4.props.itemGroups,
	                          changeFocus: _this4.props.changeFocus,
	                          addRiderItem: function addRiderItem(item) {
	                            return _this4.props.addRiderItem(Object.assign({}, item, { type: child.type }));
	                          },
	                          removeRiderItem: _this4.props.removeRiderItem,
	                          createRiderItem: _this4.props.createRiderItem,
	                          editRiderItem: _this4.props.editRiderItem,
	                          deleteRiderItem: _this4.props.deleteRiderItem,
	                          stageElements: _this4.props.stageElements,
	                          options: stageElements.isFetching !== true ? [] : undefined,
	                          categories: (0, _functions.getStageElementsByTypes)(['drums'], stageElements.groups && stageElements.groups.instrument && stageElements.groups.instrument.groups),
	                          createStageElement: _this4.props.createStageElement,
	                          getSearchResults: _this4.props.getSearchResults });
	                      } else {
	                        return false;
	                      }
	                    }) : showGroupInitialization && !hideGroupInitialization ? _react2.default.createElement(
	                      'div',
	                      { className: 'table-row table-row--empty' },
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'group-initialization' },
	                        'You have created a ' + item.title + '. Would you like us to set up the default drum set?',
	                        _react2.default.createElement(
	                          'button',
	                          { className: 'button--success', onClick: function onClick() {
	                              return _this4.addDefaultDrumSet(item, children, drumElements);
	                            } },
	                          'Set up'
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          { className: 'button--default', onClick: function onClick() {
	                              return _this4.refuseDefaultDrumSet(item, params);
	                            } },
	                          'No thanks'
	                        )
	                      )
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'table-row table-row--empty', onClick: function onClick() {
	                          _this4.props.addRiderItem({
	                            class: "instrument",
	                            position: children.length + 1,
	                            parent: item.id || null,
	                            type: item.type,
	                            indexes: [_this4.props.rowIndex, children.length]
	                          });
	                        } },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Start by adding your ',
	                        _react2.default.createElement(
	                          'a',
	                          null,
	                          'first drum element'
	                        ),
	                        '.'
	                      )
	                    ),
	                    provided.placeholder
	                  );
	                }
	              )
	            ),
	            provided.placeholder
	          );
	        }
	      );
	    }
	  }]);
	
	  return TableGroup;
	}(_react.Component);
	
	TableGroup.propTypes = {
	  view: _propTypes2.default.object,
	  dragDropType: _propTypes2.default.string,
	  group: _propTypes2.default.string,
	  columns: _propTypes2.default.array,
	  item: _propTypes2.default.object,
	  rowIndex: _propTypes2.default.number,
	  paging: _propTypes2.default.object,
	  itemGroups: _propTypes2.default.array,
	  changeFocus: _propTypes2.default.func,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  createStageElement: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func
	};
	
	TableGroup.defaultProps = {
	  view: {},
	  dragDropType: '',
	  group: '',
	  columns: [],
	  item: {},
	  rowIndex: undefined,
	  paging: {},
	  itemGroups: [],
	  changeFocus: function changeFocus() {},
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  stageElements: {},
	  createStageElement: function createStageElement() {},
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = TableGroup;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _tableColumn = __webpack_require__(304);
	
	var _tableColumn2 = _interopRequireDefault(_tableColumn);
	
	var _tableGroup = __webpack_require__(305);
	
	var _tableGroup2 = _interopRequireDefault(_tableGroup);
	
	var _tableRow = __webpack_require__(165);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var previousPaging = function previousPaging(paging) {
	  return paging.offset > 0;
	};
	
	var nextPaging = function nextPaging(paging, columns) {
	  return columns.length > paging.offset + paging.size;
	};
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this.reorderList = function (result) {
	      if (!result.destination) return null;
	
	      if (result.type === 'column') {
	        var _this$state$paging = _this.state.paging,
	            stickyColumn = _this$state$paging.stickyColumn,
	            offset = _this$state$paging.offset;
	
	
	        var sourceIndex = result.source.index;
	        var destinationIndex = result.destination.index;
	
	        if (offset) {
	          sourceIndex += offset;
	          destinationIndex += offset;
	        }
	
	        var columns = (0, _functions.reorder)(_this.state.columns, stickyColumn ? sourceIndex + 1 : sourceIndex, stickyColumn ? destinationIndex + 1 : destinationIndex);
	
	        _this.setState({ columns: columns }, function () {
	          return _this.props.moveRiderColumn({
	            id: result.draggableId,
	            position: stickyColumn ? destinationIndex + 1 : destinationIndex
	          });
	        });
	      } else if (result.type === 'instrument') {
	        var items = (0, _functions.reorder)(_this.state.items, result.source.index, result.destination.index);
	
	        _this.setState({ items: items }, function () {
	          return _this.props.moveRiderItem({
	            id: result.draggableId,
	            position: result.destination.index + 1
	          });
	        });
	      } else if (result.type.includes('instrument-group')) {
	        var findIndex = result.type.split('-');
	        var index = findIndex[findIndex.length - 1];
	
	        var children = (0, _functions.reorder)(_this.state.items[index].children, result.source.index, result.destination.index);
	
	        _this.setState({
	          items: (0, _immutabilityHelper2.default)(_this.state.items, _defineProperty({}, index, {
	            children: { $set: children }
	          }))
	        }, function () {
	          return _this.props.moveRiderItem({
	            id: result.draggableId,
	            position: result.destination.index + 1
	          });
	        });
	      }
	    };
	
	    _this.state = {
	      columns: [],
	      items: [],
	      paging: {
	        stickyColumn: true,
	        hideFirstColumn: true,
	        offset: 0,
	        size: 4
	      },
	      showAddColumnButton: true,
	      focusCell: undefined
	    };
	
	    _this.component = _react2.default.createRef();
	    _this.addButton = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          columns = _props.columns,
	          items = _props.items;
	
	
	      this.setState({ columns: columns, items: items });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.calculateTableSize();
	    }
	  }, {
	    key: 'calculateTableSize',
	    value: function calculateTableSize() {
	      var offsetWidth = this.component.current.offsetWidth;
	
	      var channelWidth = 95;
	      var maxWidth = 180;
	
	      var size = Math.floor((offsetWidth - channelWidth) / maxWidth);
	      this.setState({
	        paging: (0, _immutabilityHelper2.default)(this.state.paging, {
	          size: { $set: size }
	        })
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var columns = nextProps.columns,
	          items = nextProps.items;
	
	
	      if (columns !== this.props.columns) this.setState({ columns: columns });
	      if (items !== this.props.items) this.setState({ items: items });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var fullView = nextProps.fullView,
	          columns = nextProps.columns,
	          items = nextProps.items,
	          stageElements = nextProps.stageElements;
	
	
	      if (fullView !== this.props.fullView) return true;
	      if (columns !== this.props.columns) return true;
	      if (items !== this.props.items) return true;
	      if (stageElements !== this.props.stageElements) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var fullView = prevProps.fullView;
	
	
	      if (fullView !== this.props.fullView) this.calculateTableSize();
	    }
	  }, {
	    key: 'changeFocus',
	    value: function changeFocus(e, current) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      var getElement = function getElement(current) {
	        var nextId = 'ch' + current.channel + '-eq' + current.cell;
	        var nextElement = document.getElementById(nextId);
	
	        if (nextElement) {
	          _this2.setState(undefined, function () {
	            return nextElement.click();
	          });
	          return nextElement;
	        }
	      };
	
	      if (e.shiftKey && e.key === 'Enter' || e.key === 'ArrowUp') {
	        current = Object.assign({}, current, { channel: current.channel - 1 });
	        var nextElement = getElement(current);
	
	        if (!nextElement) getElement(Object.assign({}, current, { channel: current.channel + 1 }));
	      } else if (e.key === 'Enter') {
	        current = Object.assign({}, current, { channel: current.channel + 1 });
	        var _nextElement = getElement(current);
	
	        if (!_nextElement) {
	          var items = this.props.items;
	
	
	          this.props.addRiderItem({
	            class: "instrument",
	            position: items.length + 1,
	            indexes: [items.length]
	          });
	        }
	      } else if (e.shiftKey && e.key === 'Tab' || e.key === 'ArrowLeft') {
	        current = Object.assign({}, current, { cell: current.cell - 1 });
	        var _nextElement2 = getElement(current);
	
	        if (!_nextElement2) {
	          var _state = this.state,
	              columns = _state.columns,
	              paging = _state.paging;
	
	
	          if (previousPaging(paging)) {
	            this.paginate(paging, 'previous');
	            this.setState(undefined, function () {
	              return getElement(current);
	            });
	          } else {
	            getElement(Object.assign({}, current, { cell: current.cell + 1 }));
	          }
	        }
	      } else if (e.key === 'Tab') {
	        current = Object.assign({}, current, { cell: current.cell + 1 });
	        var _nextElement3 = getElement(current);
	
	        if (!_nextElement3) {
	          var _state2 = this.state,
	              _columns = _state2.columns,
	              _paging = _state2.paging;
	
	
	          if (nextPaging(_paging, _columns)) {
	            this.paginate(_paging, 'next');
	            this.setState(undefined, function () {
	              var nextElement = getElement(current);
	
	              if (!nextElement) {
	                _this2.paginate(_paging, 0);
	                _this2.addButton.current.focus();
	              }
	            });
	          } else {
	            this.paginate(_paging, 0);
	            this.setState(undefined, function () {
	              var nextElement = getElement({ channel: current.channel + 1, cell: 1 });
	
	              if (!nextElement) {
	                var _items = _this2.props.items;
	
	
	                _this2.props.addRiderItem({
	                  class: "instrument",
	                  position: _items.length + 1,
	                  indexes: [_items.length]
	                });
	              }
	            });
	          }
	        }
	      } else if (e.key === 'ArrowRight') {
	        current = Object.assign({}, current, { cell: current.cell + 1 });
	        var _nextElement4 = getElement(current);
	
	        if (!_nextElement4) {
	          var _state3 = this.state,
	              _columns2 = _state3.columns,
	              _paging2 = _state3.paging;
	
	
	          if (nextPaging(_paging2, _columns2)) {
	            this.paginate(_paging2, 'next');
	            this.setState(undefined, function () {
	              return getElement(current);
	            });
	          } else {
	            getElement(Object.assign({}, current, { cell: current.cell - 1 }));
	          }
	        }
	      } else if (e.key === 'ArrowDown') {
	        current = Object.assign({}, current, { channel: current.channel + 1 });
	        var _nextElement5 = getElement(current);
	
	        if (!_nextElement5) this.setState({ focusCell: current.cell }, function () {
	          return _this2.addButton.current.focus();
	        });
	      }
	    }
	  }, {
	    key: 'paginate',
	    value: function paginate(paging, operator) {
	      this.setState({
	        paging: (0, _immutabilityHelper2.default)(paging, {
	          offset: {
	            $set: !isNaN(operator) ? operator : operator === 'next' ? paging.offset + 1 : paging.offset - 1
	          }
	        })
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          view = _props2.view,
	          stageElements = _props2.stageElements;
	      var _state4 = this.state,
	          columns = _state4.columns,
	          items = _state4.items,
	          paging = _state4.paging,
	          showAddColumnButton = _state4.showAddColumnButton;
	
	
	      if (!items) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { ref: this.component, className: 'table' },
	        _react2.default.createElement(
	          _reactBeautifulDnd.DragDropContext,
	          { onDragEnd: this.reorderList },
	          _react2.default.createElement(
	            'div',
	            { className: 'table-head' },
	            _react2.default.createElement(
	              'div',
	              { className: 'table-column table-column--channel' },
	              'Channel'
	            ),
	            _react2.default.createElement(
	              _reactBeautifulDnd.Droppable,
	              { droppableId: 'table-head', isDropDisabled: !view.editable, direction: 'horizontal', type: 'column' },
	              function (provided, snapshot) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'table-head--droppable',
	                    ref: provided.innerRef },
	                  paging.stickyColumn ? _react2.default.createElement(
	                    'div',
	                    { className: 'table-column table-column--instrument', style: { minWidth: 100 / paging.size + '%', maxWidth: 100 / paging.size + '%' } },
	                    'Instrument'
	                  ) : null,
	                  columns.map(function (column, index) {
	                    if (paging.stickyColumn) {
	                      if (column.type === 'instrument' || (0, _functions.hiddenInPaging)(paging, index)) return null;
	                    } else {
	                      if ((0, _functions.hiddenInPaging)(paging, index)) return null;
	                    }
	
	                    return _react2.default.createElement(_tableColumn2.default, { key: index,
	                      view: view,
	                      column: column,
	                      paging: paging,
	                      availableColumnTypes: stageElements.availableColumnTypes,
	                      removeRiderColumn: function removeRiderColumn() {
	                        _this3.setState({
	                          showAddColumnButton: true
	                        }, function () {
	                          _this3.paginate(paging, 'previous');
	                          _this3.props.removeRiderColumn(index);
	                        });
	                      },
	                      createRiderColumn: function createRiderColumn(column) {
	                        _this3.setState({
	                          showAddColumnButton: true
	                        }, function () {
	                          _this3.props.createRiderColumn(column);
	                        });
	                      },
	                      deleteRiderColumn: function deleteRiderColumn(columnId) {
	                        _this3.paginate(paging, 'previous');
	                        _this3.props.deleteRiderColumn(columnId);
	                      } });
	                  })
	                );
	              }
	            ),
	            showAddColumnButton && view.editable ? _react2.default.createElement(
	              'div',
	              { className: 'table--add-column-button', onClick: function onClick() {
	                  _this3.setState({
	                    showAddColumnButton: false
	                  }, function () {
	                    _this3.paginate(paging, columns.length - paging.size + 1);
	                    _this3.props.addRiderColumn({
	                      position: columns.length
	                    });
	                  });
	                } },
	              _react2.default.createElement('div', { className: 'oval-button oval-button--add' })
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'table-body' },
	            previousPaging(paging) ? _react2.default.createElement(
	              'div',
	              { className: 'table--fixed-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'table--previous-button', style: { left: 100 / paging.size + '%' }, onClick: function onClick() {
	                    return _this3.paginate(paging, 'previous');
	                  } },
	                _react2.default.createElement('div', { className: 'oval-button oval-button--previous' })
	              )
	            ) : null,
	            nextPaging(paging, columns) ? _react2.default.createElement(
	              'div',
	              { className: 'table--next-button', onClick: function onClick() {
	                  return _this3.paginate(paging, 'next');
	                } },
	              _react2.default.createElement('div', { className: 'oval-button oval-button--next' })
	            ) : null,
	            _react2.default.createElement(
	              _reactBeautifulDnd.Droppable,
	              { droppableId: 'table-body', isDropDisabled: !view.editable, type: 'instrument' },
	              function (provided, snapshot) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'table-body--droppable',
	                    ref: provided.innerRef },
	                  items.length > 0 ? items.map(function (item, index) {
	                    // if (item.id === undefined) return <Loading key={index} className="table-row table-row--loading" />
	
	                    if (item.class === 'instrument-group') {
	                      return _react2.default.createElement(_tableGroup2.default, { key: item.id || index,
	                        view: view,
	                        dragDropType: 'instrument-group-' + index,
	                        group: _this3.props.group,
	                        columns: columns,
	                        item: item,
	                        rowIndex: index,
	                        paging: paging,
	                        itemGroups: _this3.props.itemGroups,
	                        changeFocus: function changeFocus(e, current) {
	                          return _this3.changeFocus(e, current);
	                        },
	                        addRiderItem: _this3.props.addRiderItem,
	                        removeRiderItem: _this3.props.removeRiderItem,
	                        createRiderItem: _this3.props.createRiderItem,
	                        createRiderItems: _this3.props.createRiderItems,
	                        editRiderItem: _this3.props.editRiderItem,
	                        deleteRiderItem: _this3.props.deleteRiderItem,
	                        stageElements: stageElements,
	                        createStageElement: _this3.props.createStageElement,
	                        getSearchResults: _this3.props.getSearchResults });
	                    } else if (item.class === 'instrument') {
	                      return _react2.default.createElement(_tableRow2.default, { key: item.id || index,
	                        view: view,
	                        dragDropType: 'instrument',
	                        group: _this3.props.group,
	                        columns: columns,
	                        item: item,
	                        rowIndex: index,
	                        paging: paging,
	                        itemGroups: _this3.props.itemGroups,
	                        changeFocus: function changeFocus(e, current) {
	                          return _this3.changeFocus(e, current);
	                        },
	                        addRiderItem: _this3.props.addRiderItem,
	                        removeRiderItem: _this3.props.removeRiderItem,
	                        createRiderItem: _this3.props.createRiderItem,
	                        editRiderItem: _this3.props.editRiderItem,
	                        deleteRiderItem: _this3.props.deleteRiderItem,
	                        stageElements: stageElements,
	                        createStageElement: _this3.props.createStageElement,
	                        getSearchResults: _this3.props.getSearchResults });
	                    } else {
	                      return null;
	                    }
	                  }) : view.editable ? _react2.default.createElement(
	                    'p',
	                    null,
	                    'Start by adding your ',
	                    _react2.default.createElement(
	                      'a',
	                      { onClick: function onClick() {
	                          _this3.props.addRiderItem({
	                            class: "instrument",
	                            position: items.length + 1,
	                            indexes: [items.length]
	                          });
	                        } },
	                      'first instrument'
	                    ),
	                    '.'
	                  ) : _react2.default.createElement(
	                    'p',
	                    null,
	                    'This rider has no instruments'
	                  ),
	                  provided.placeholder
	                );
	              }
	            )
	          )
	        ),
	        view.editable ? _react2.default.createElement(
	          'button',
	          { ref: this.addButton, className: 'table--add-button button--link', onClick: function onClick() {
	              _this3.props.addRiderItem({
	                class: "instrument",
	                position: items.length + 1,
	                indexes: [items.length]
	              });
	            },
	            onKeyDown: function onKeyDown(e) {
	              if (e.key === 'ArrowUp') {
	                var focusCell = _this3.state.focusCell;
	
	
	                var item = items[items.length - 1];
	                var channel = item.channel;
	
	                if (isNaN(channel)) {
	                  var child = item.children[item.children.length - 1];
	                  channel = child.channel;
	                }
	
	                _this3.changeFocus(e, { channel: channel + 1, cell: focusCell || 1 });
	              }
	            },
	            tabIndex: '1' },
	          'Insert instrument'
	        ) : null
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.propTypes = {
	  view: _propTypes2.default.object,
	  fullView: _propTypes2.default.bool,
	  group: _propTypes2.default.string,
	  columns: _propTypes2.default.array,
	  addRiderColumn: _propTypes2.default.func,
	  removeRiderColumn: _propTypes2.default.func,
	  createRiderColumn: _propTypes2.default.func,
	  moveRiderColumn: _propTypes2.default.func,
	  deleteRiderColumn: _propTypes2.default.func,
	  items: _propTypes2.default.array,
	  itemGroups: _propTypes2.default.array,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  createRiderItems: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  createStageElement: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func
	};
	
	Table.defaultProps = {
	  view: {},
	  fullView: false,
	  group: '',
	  columns: [],
	  addRiderColumn: function addRiderColumn() {},
	  removeRiderColumn: function removeRiderColumn() {},
	  createRiderColumn: function createRiderColumn() {},
	  moveRiderColumn: function moveRiderColumn() {},
	  deleteRiderColumn: function deleteRiderColumn() {},
	  items: [],
	  itemGroups: [],
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  createRiderItems: function createRiderItems() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  stageElements: {},
	  createStageElement: function createStageElement() {},
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = Table;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _list = __webpack_require__(302);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _table = __webpack_require__(306);
	
	var _table2 = _interopRequireDefault(_table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input(props) {
	    _classCallCheck(this, Input);
	
	    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));
	
	    _this.state = {
	      listView: false,
	      fullView: false
	    };
	    return _this;
	  }
	
	  _createClass(Input, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var rider = nextProps.rider;
	
	
	      if (rider !== this.props.rider) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          rider = _props.rider,
	          stageElements = _props.stageElements;
	      var _state = this.state,
	          listView = _state.listView,
	          fullView = _state.fullView;
	
	
	      var className = (0, _classnames2.default)({
	        'input': true,
	        'input-list': listView === true,
	        'input-table': listView === false,
	        'section--full': fullView
	      });
	
	      var enlargeButtonClassName = (0, _classnames2.default)({
	        'button--success': true,
	        'enlarge-button': true,
	        'enlarge-button--active': fullView === true
	      });
	
	      return _react2.default.createElement(
	        'section',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: 'section-head' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Input ',
	            listView ? 'List' : 'Table'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'view-button button--success', onClick: function onClick() {
	                return _this2.setState({ listView: !listView, fullView: false });
	              } },
	            listView ? 'Switch to Table view' : 'Switch to List view'
	          ),
	          !listView ? _react2.default.createElement('button', { className: enlargeButtonClassName, onClick: function onClick() {
	              return _this2.setState({ fullView: !fullView });
	            } }) : null
	        ),
	        listView ? _react2.default.createElement(_list2.default, {
	          view: view,
	          group: this.props.group,
	          columns: rider.columns,
	          items: rider.items,
	          itemGroups: rider.itemGroups,
	          createRiderColumn: this.props.createRiderColumn,
	          addRiderItem: this.props.addRiderItem,
	          removeRiderItem: this.props.removeRiderItem,
	          createRiderItem: this.props.createRiderItem,
	          createRiderItems: this.props.createRiderItems,
	          editRiderItem: this.props.editRiderItem,
	          moveRiderItem: this.props.moveRiderItem,
	          deleteRiderItem: this.props.deleteRiderItem,
	          stageElements: stageElements,
	          createStageElement: this.props.createStageElement,
	          getSearchResults: this.props.getSearchResults }) : _react2.default.createElement(_table2.default, {
	          view: view,
	          fullView: fullView,
	          group: this.props.group,
	          columns: rider.columns,
	          addRiderColumn: this.props.addRiderColumn,
	          removeRiderColumn: this.props.removeRiderColumn,
	          createRiderColumn: this.props.createRiderColumn,
	          moveRiderColumn: this.props.moveRiderColumn,
	          deleteRiderColumn: this.props.deleteRiderColumn,
	          items: rider.items,
	          itemGroups: rider.itemGroups,
	          addRiderItem: this.props.addRiderItem,
	          removeRiderItem: this.props.removeRiderItem,
	          createRiderItem: this.props.createRiderItem,
	          createRiderItems: this.props.createRiderItems,
	          editRiderItem: this.props.editRiderItem,
	          moveRiderItem: this.props.moveRiderItem,
	          deleteRiderItem: this.props.deleteRiderItem,
	          stageElements: stageElements,
	          createStageElement: this.props.createStageElement,
	          getSearchResults: this.props.getSearchResults })
	      );
	    }
	  }]);
	
	  return Input;
	}(_react.Component);
	
	Input.propTypes = {
	  view: _propTypes2.default.object,
	  group: _propTypes2.default.string,
	  rider: _propTypes2.default.object,
	  addRiderColumn: _propTypes2.default.func,
	  removeRiderColumn: _propTypes2.default.func,
	  createRiderColumn: _propTypes2.default.func,
	  moveRiderColumn: _propTypes2.default.func,
	  deleteRiderColumn: _propTypes2.default.func,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  createRiderItems: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  createStageElement: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	Input.defaultProps = {
	  view: {},
	  group: '',
	  rider: { isFetching: true },
	  addRiderColumn: function addRiderColumn() {},
	  removeRiderColumn: function removeRiderColumn() {},
	  createRiderColumn: function createRiderColumn() {},
	  moveRiderColumn: function moveRiderColumn() {},
	  deleteRiderColumn: function deleteRiderColumn() {},
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  createRiderItems: function createRiderItems() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  stageElements: {},
	  createStageElement: function createStageElement() {},
	  getSearchResults: function getSearchResults() {},
	  setModal: function setModal() {}
	};
	
	exports.default = Input;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(20);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MemberItems = function (_Component) {
	  _inherits(MemberItems, _Component);
	
	  function MemberItems(props) {
	    _classCallCheck(this, MemberItems);
	
	    var _this = _possibleConstructorReturn(this, (MemberItems.__proto__ || Object.getPrototypeOf(MemberItems)).call(this, props));
	
	    _this.getOptions = function (input) {
	      if (_this.state.searchInputTimeout) clearTimeout(_this.state.searchInputTimeout);
	
	      var searchInputTimeout = setTimeout(function () {
	        var _this$props = _this.props,
	            options = _this$props.options,
	            searchResults = _this$props.searchResults;
	
	
	        _this.props.getSearchResults(options, input);
	
	        if (searchResults !== undefined) _this.setState({ itemSelectorIsLoading: false });
	      }, 500);
	
	      _this.setState({ itemSelectorIsLoading: input.length > 0 ? true : false, searchInputTimeout: searchInputTimeout });
	    };
	
	    _this.state = {
	      items: [],
	      showItemSelector: false,
	      itemSelectorValue: '',
	      itemSelectorIsLoading: false,
	      selectedItem: undefined,
	      showTypeSelector: false,
	      searchInputTimeout: null
	    };
	
	    _this.selector = _react2.default.createRef();
	    _this.typeSelector = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(MemberItems, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          items = _props.items,
	          options = _props.options,
	          categories = _props.categories,
	          searchResults = _props.searchResults;
	
	
	      this.setState({ items: items });
	      if (searchResults === undefined && (options || categories)) this.getInitialSearchResults(options, categories, searchResults);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var options = nextProps.options,
	          categories = nextProps.categories,
	          searchResults = nextProps.searchResults;
	
	
	      if (searchResults === undefined && (options && this.props.options === undefined || categories && this.props.categories === undefined)) this.getInitialSearchResults(options, categories, searchResults);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.searchInputTimeout) clearTimeout(this.state.searchInputTimeout);
	    }
	  }, {
	    key: 'getInitialSearchResults',
	    value: function getInitialSearchResults(options, categories, searchResults) {
	      var _this2 = this;
	
	      this.setState({ itemSelectorIsLoading: false }, function () {
	        _this2.props.getSearchResults(options && options.length > 0 ? options : categories, _this2.state.itemSelectorValue);
	      });
	    }
	  }, {
	    key: 'setSelectorFocus',
	    value: function setSelectorFocus(selector, value, searchResults) {
	      this.setState({
	        itemSelectorIsLoading: searchResults === undefined ? true : false
	      }, function () {
	        var select = selector.current.select;
	
	        if (select) selector.current.select.handleInputChange({ target: { value: value && value.title || '' } });
	      });
	    }
	  }, {
	    key: 'clearSearchResults',
	    value: function clearSearchResults() {
	      this.props.getSearchResults([]);
	    }
	  }, {
	    key: 'clearFocus',
	    value: function clearFocus() {
	      var _this3 = this;
	
	      this.setState({
	        showItemSelector: false,
	        selectedItem: undefined,
	        showTypeSelector: false
	      }, function () {
	        return _this3.props.setFocus(false);
	      });
	    }
	  }, {
	    key: 'renderSelectForm',
	    value: function renderSelectForm() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          items = _props2.items,
	          availableItems = _props2.availableItems,
	          categories = _props2.categories,
	          searchResults = _props2.searchResults;
	      var _state = this.state,
	          itemSelectorValue = _state.itemSelectorValue,
	          itemSelectorIsLoading = _state.itemSelectorIsLoading,
	          selectedItem = _state.selectedItem,
	          showTypeSelector = _state.showTypeSelector;
	
	
	      var value = selectedItem;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'select-form' },
	        _react2.default.createElement('div', { className: 'select-form-escape', onClick: function onClick() {
	            return _this4.clearFocus();
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'select-form-fields' },
	          _react2.default.createElement(
	            'label',
	            null,
	            itemSelectorValue.length > 0 || selectedItem ? 'Add new instrument to input list' : 'Select existing or type for new'
	          ),
	          _react2.default.createElement(_reactSelect.Creatable, { ref: this.selector,
	            cache: false,
	            autoFocus: true,
	            openOnFocus: true,
	            isLoading: itemSelectorIsLoading,
	            className: 'select-form-field',
	            value: value,
	            valueKey: 'id',
	            labelKey: 'title',
	            placeholder: null,
	            loadingPlaceholder: null,
	            searchPromptText: 'Search prompts',
	            promptTextCreator: function promptTextCreator(label) {
	              return 'Add "' + label + '"';
	            },
	            clearable: false,
	            onOpen: function onOpen() {
	              return _this4.setSelectorFocus(_this4.selector, value, searchResults);
	            },
	            onInputChange: function onInputChange(input) {
	              _this4.setState({ itemSelectorValue: input }, function () {
	                return _this4.getOptions(input);
	              });
	
	              return input;
	            },
	            onChange: function onChange(value) {
	              if (value) {
	                value.position === undefined ? _this4.props.createRiderItem(value) : _this4.setState({ items: (0, _immutabilityHelper2.default)(items, { $push: [value] }) }, function () {
	                  return _this4.props.updateMember(_this4.state.items);
	                });
	              }
	
	              _this4.clearSearchResults();
	              _this4.clearFocus();
	            },
	            onNewOptionClick: function onNewOptionClick(value) {
	              var selectedItem = { title: value.title, type: undefined };
	              _this4.setState({ selectedItem: selectedItem, showTypeSelector: true }, function () {
	                return _this4.typeSelector.current.focus();
	              });
	            },
	            onBlur: function onBlur() {
	              _this4.clearSearchResults();
	            },
	            noResultsText: searchResults !== undefined ? 'Add instruments by typing' : 'Loading results...',
	            options: itemSelectorValue.length > 0 || availableItems.length === 0 ? searchResults : availableItems }),
	          showTypeSelector ? _react2.default.createElement('hr', null) : null,
	          showTypeSelector ? _react2.default.createElement(_reactSelect2.default, {
	            ref: this.typeSelector,
	            openOnFocus: true,
	            className: 'select-form-field',
	            value: undefined,
	            valueKey: 'id',
	            labelKey: 'title',
	            clearable: false,
	            placeholder: 'Specify it\'s category',
	            noResultsText: categories.length > 0 ? 'Clear field to select an existing category' : 'Loading results...',
	            onChange: function onChange(value) {
	              _this4.props.createRiderItem({ title: selectedItem.title, type: value.type });
	              _this4.clearFocus();
	            },
	            options: categories }) : null
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props3 = this.props,
	          view = _props3.view,
	          items = _props3.items;
	      var showItemSelector = this.state.showItemSelector;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'member-items' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          items.map(function (item, index) {
	            return _react2.default.createElement(
	              _reactBeautifulDnd.Draggable,
	              { key: index, draggableId: item.id, isDragDisabled: true, type: 'member-items' },
	              function (provided, snapshot) {
	                return _react2.default.createElement(
	                  'li',
	                  { ref: provided.innerRef },
	                  _react2.default.createElement(
	                    'div',
	                    Object.assign({ className: 'member-item', style: provided.draggableStyle
	                    }, provided.dragHandleProps),
	                    view.editable ? _react2.default.createElement('span', { className: 'remove-item', onClick: function onClick() {
	                        items = (0, _immutabilityHelper2.default)(items, { $splice: [[index, 1]] });
	                        _this5.setState({ items: items }, function () {
	                          return _this5.props.updateMember(items);
	                        });
	                      } }) : null,
	                    item.title
	                  ),
	                  provided.placeholder
	                );
	              }
	            );
	          })
	        ),
	        view.editable ? showItemSelector ? this.renderSelectForm() : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'a',
	            { className: 'link--invert', onClick: function onClick() {
	                return _this5.setState({ showItemSelector: true }, function () {
	                  return _this5.props.setFocus(true);
	                });
	              } },
	            '+ Add instrument'
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return MemberItems;
	}(_react.Component);
	
	MemberItems.propTypes = {
	  view: _propTypes2.default.object,
	  items: _propTypes2.default.array,
	  setFocus: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  updateMember: _propTypes2.default.func,
	  createRiderMember: _propTypes2.default.func,
	  editRiderMember: _propTypes2.default.func,
	  availableItems: _propTypes2.default.array,
	  options: _propTypes2.default.array,
	  categories: _propTypes2.default.array,
	  searchResults: _propTypes2.default.array,
	  getSearchResults: function getSearchResults() {}
	};
	
	MemberItems.defaultProps = {
	  view: {},
	  items: [],
	  setFocus: function setFocus() {},
	  createRiderItem: function createRiderItem() {},
	  updateMember: function updateMember() {},
	  createRiderMember: function createRiderMember() {},
	  editRiderMember: function editRiderMember() {},
	  availableItems: [],
	  options: undefined,
	  categories: undefined,
	  searchResults: undefined,
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = MemberItems;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _riek = __webpack_require__(46);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _memberItems = __webpack_require__(308);
	
	var _memberItems2 = _interopRequireDefault(_memberItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input() {
	    _classCallCheck(this, Input);
	
	    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
	  }
	
	  _createClass(Input, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextProps.value !== this.props.value) return true;
	      if (nextProps.propName !== this.props.propName) return true;
	      if (nextProps.className !== this.props.className) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          propName = _props.propName,
	          className = _props.className;
	
	
	      return _react2.default.createElement(_riek.RIEInput, {
	        value: value,
	        propName: propName,
	        className: className,
	        classEditing: 'riek-editing',
	        change: function change(propValue) {
	          return _this2.props.change(propValue);
	        } });
	    }
	  }]);
	
	  return Input;
	}(_react.Component);
	
	var Member = function (_Component2) {
	  _inherits(Member, _Component2);
	
	  function Member(props) {
	    _classCallCheck(this, Member);
	
	    var _this3 = _possibleConstructorReturn(this, (Member.__proto__ || Object.getPrototypeOf(Member)).call(this, props));
	
	    _this3.state = {
	      name: '',
	      email: '',
	      phone: '',
	      showDropdown: false,
	      focus: false,
	      error: ''
	    };
	
	    _this3.input = _react2.default.createRef();
	    return _this3;
	  }
	
	  _createClass(Member, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var member = this.props.member;
	      var name = member.name,
	          email = member.email,
	          phone = member.phone;
	
	
	      this.setState({ name: name, email: email, phone: phone });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var member = this.props.member;
	
	
	      if (member.id === undefined) this.input.current.startEditing();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var member = nextProps.member;
	
	
	      if (member !== this.props.member) {
	        var name = member.name,
	            email = member.email,
	            phone = member.phone;
	
	
	        this.setState({ name: name, email: email, phone: phone });
	      }
	    }
	  }, {
	    key: 'memberIsUpdated',
	    value: function memberIsUpdated() {
	      var updatedItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	      var id = this.props.member.id;
	      var items = this.props.member.items;
	      var _state = this.state,
	          name = _state.name,
	          email = _state.email,
	          phone = _state.phone;
	
	
	      var itemIds = [];
	      items = updatedItems !== undefined ? updatedItems : items;
	      items.map(function (item) {
	        return itemIds.push(item.id);
	      });
	
	      if (id) {
	        this.props.editRiderMember({ id: id, name: name, email: email, phone: phone, items: itemIds });
	      } else {
	        this.props.createRiderMember({ name: name, email: email, phone: phone, items: itemIds });
	      }
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown(member) {
	      var _this4 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this4.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this4.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this4.setState({ showDropdown: false }, function () {
	                  return _this4.props.deleteRiderMember(member);
	                });
	              } },
	            'Remove this member'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderMember',
	    value: function renderMember() {
	      var _this5 = this;
	
	      var _props2 = this.props,
	          view = _props2.view,
	          member = _props2.member,
	          position = _props2.position,
	          isDragging = _props2.isDragging,
	          stageElements = _props2.stageElements;
	      // const { name, email, phone, showDropdown, focus, error } = this.state
	
	      var _state2 = this.state,
	          name = _state2.name,
	          phone = _state2.phone,
	          showDropdown = _state2.showDropdown,
	          focus = _state2.focus,
	          error = _state2.error;
	
	
	      var className = (0, _classnames2.default)({
	        'card': true,
	        'card--focus': showDropdown || focus,
	        'member': true
	      });
	
	      var nameClassName = (0, _classnames2.default)({
	        'riek': true,
	        'name': true,
	        'h4': true,
	        'placeholder': !name
	      });
	
	      // const emailClassName = classnames({
	      //   'riek': true,
	      //   'email': true,
	      //   'placeholder': !email
	      // })
	
	      var phoneClassName = (0, _classnames2.default)({
	        'riek': true,
	        'phone': true,
	        'placeholder': !phone
	      });
	
	      var droppableClassName = function droppableClassName(isDraggingOver) {
	        return (0, _classnames2.default)({
	          'member--droppable': true,
	          'member--droppable-dragging': isDragging,
	          'member--droppable-dragging-over': isDraggingOver
	        });
	      };
	
	      return _react2.default.createElement(
	        'li',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-content', 'data-number': position, 'data-error': error },
	          view.editable ? this.renderDropdown(member) : null,
	          _react2.default.createElement(
	            _reactBeautifulDnd.Droppable,
	            { droppableId: member.id, isDropDisabled: !view.editable, type: 'member-items' },
	            function (provided, snapshot) {
	              return _react2.default.createElement(
	                'div',
	                { className: droppableClassName(snapshot.isDraggingOver), ref: provided.innerRef },
	                view.editable ? _react2.default.createElement(Input, {
	                  value: name || '',
	                  propName: 'name',
	                  className: nameClassName,
	                  change: function change(_ref) {
	                    var name = _ref.name;
	
	                    name ? _this5.setState({ name: name }, function () {
	                      return _this5.memberIsUpdated();
	                    }) : _this5.setState({ name: member.name });
	                  } }) : _react2.default.createElement(
	                  'div',
	                  { className: nameClassName },
	                  name
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'enter' },
	                  'Enter'
	                ),
	                _react2.default.createElement(_memberItems2.default, {
	                  view: view,
	                  items: member.items,
	                  setFocus: function setFocus(state) {
	                    return _this5.setState({ focus: state });
	                  },
	                  createRiderItem: function createRiderItem(item) {
	                    _this5.props.createRiderItem(Object.assign({}, item, { member: member.id }));
	                    _this5.props.setAlert({ message: 'We have added "' + item.title + '" to input list and assigned it to ' + member.name + '.' });
	                  },
	                  updateMember: function updateMember(items) {
	                    return _this5.memberIsUpdated(items);
	                  },
	                  availableItems: _this5.props.availableItems,
	                  options: stageElements.instrument ? stageElements.groups && stageElements.groups.instrument && stageElements.groups.instrument.children // categories
	                  ? [].concat(_toConsumableArray(stageElements.instrument), _toConsumableArray(stageElements.groups.instrument.children)) : (0, _functions.getStageElementsByTypes)(['instrument'], stageElements) : undefined,
	                  categories: (0, _functions.getStageElementsByTypes)(['children'], stageElements && stageElements.groups && stageElements.groups.instrument),
	                  searchResults: _this5.props.searchResults,
	                  getSearchResults: _this5.props.getSearchResults }),
	                view.editable ? _react2.default.createElement(Input, {
	                  value: phone || 'Add a phone number',
	                  propName: 'phone',
	                  className: phoneClassName,
	                  change: function change(_ref2) {
	                    var phone = _ref2.phone;
	                    return _this5.setState({ phone: phone }, function () {
	                      return _this5.memberIsUpdated();
	                    });
	                  } }) : _react2.default.createElement(
	                  'div',
	                  { className: phoneClassName },
	                  phone
	                ),
	                provided.placeholder
	              );
	            }
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEmptyMember',
	    value: function renderEmptyMember() {
	      var _this6 = this;
	
	      var _props3 = this.props,
	          view = _props3.view,
	          position = _props3.position;
	      var _state3 = this.state,
	          name = _state3.name,
	          error = _state3.error;
	
	
	      var className = (0, _classnames2.default)({
	        'card': true,
	        'card--focus': true
	      });
	
	      if (view.editable !== true) return null;
	
	      return _react2.default.createElement(
	        'li',
	        { className: className },
	        _react2.default.createElement('div', { className: 'card-escape', onClick: function onClick() {
	            return _this6.props.removeRiderMember(position - 1);
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-content', 'data-number': position, 'data-error': error, tabIndex: '0',
	            onKeyDown: function onKeyDown(e) {
	              return e.key === 'Enter' ? setTimeout(function () {
	                var name = _this6.state.name;
	
	
	                _this6.setState({
	                  error: !name ? 'Please insert a name' : null
	                }, function () {
	                  name ? _this6.memberIsUpdated() : _this6.input.current.startEditing();
	                });
	              }, 1) // add setTimeout as change and onKeyDown are fired asynchronously
	              : e.key === 'Escape' ? _this6.props.removeRiderMember(position - 1) : null;
	            } },
	          _react2.default.createElement('div', { className: 'riek-escape', onClick: function onClick() {
	              return _this6.props.removeRiderMember(position - 1);
	            } }),
	          _react2.default.createElement(_riek.RIEInput, {
	            ref: this.input,
	            value: name || '',
	            propName: 'name',
	            className: 'riek riek-editing name h4',
	            change: function change(_ref3) {
	              var name = _ref3.name;
	              return _this6.setState({ name: (0, _functions.capitalize)(name) });
	            } }),
	          _react2.default.createElement(
	            'label',
	            { className: 'enter', onClick: function onClick() {
	                _this6.setState({
	                  error: !name ? 'Please insert a name' : null
	                }, function () {
	                  name ? _this6.memberIsUpdated() : _this6.input.current.startEditing();
	                });
	              } },
	            'Enter'
	          ),
	          _react2.default.createElement('div', { className: 'remove-member', onClick: function onClick() {
	              return _this6.props.removeRiderMember(position - 1);
	            } }),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Add new band member'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var member = this.props.member;
	
	
	      return member.id !== undefined ? this.renderMember() : this.renderEmptyMember();
	    }
	  }]);
	
	  return Member;
	}(_react.Component);
	
	Member.propTypes = {
	  view: _propTypes2.default.object,
	  member: _propTypes2.default.object,
	  position: _propTypes2.default.number,
	  isDragging: _propTypes2.default.bool,
	  createRiderItem: _propTypes2.default.func,
	  removeRiderMember: _propTypes2.default.func,
	  createRiderMember: _propTypes2.default.func,
	  editRiderMember: _propTypes2.default.func,
	  moveRiderMember: _propTypes2.default.func,
	  deleteRiderMember: _propTypes2.default.func,
	  availableItems: _propTypes2.default.array,
	  stageElements: _propTypes2.default.object,
	  searchResults: _propTypes2.default.array,
	  getSearchResults: _propTypes2.default.func,
	  setAlert: _propTypes2.default.func
	};
	
	Member.defaultProps = {
	  view: {},
	  member: {},
	  position: 0,
	  isDragging: false,
	  createRiderItem: function createRiderItem() {},
	  removeRiderMember: function removeRiderMember() {},
	  createRiderMember: function createRiderMember() {},
	  editRiderMember: function editRiderMember() {},
	  moveRiderMember: function moveRiderMember() {},
	  deleteRiderMember: function deleteRiderMember() {},
	  availableItems: [],
	  stageElements: {},
	  searchResults: undefined,
	  getSearchResults: function getSearchResults() {},
	  setAlert: function setAlert() {}
	};
	
	exports.default = Member;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _riek = __webpack_require__(46);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _member = __webpack_require__(309);
	
	var _member2 = _interopRequireDefault(_member);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Members = function (_Component) {
	  _inherits(Members, _Component);
	
	  function Members(props) {
	    _classCallCheck(this, Members);
	
	    var _this = _possibleConstructorReturn(this, (Members.__proto__ || Object.getPrototypeOf(Members)).call(this, props));
	
	    _this.state = {
	      artist: _this.props.artist,
	      isDragging: false,
	      sourceDroppableId: undefined
	    };
	    return _this;
	  }
	
	  _createClass(Members, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var artist = this.props.artist;
	
	
	      this.setState({ artist: artist });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var artist = nextProps.artist;
	
	
	      if (artist !== this.props.artist) this.setState({ artist: artist });
	    }
	
	    // addMemberItem({memberId, itemId, itemPosition}, members, items) {
	    //   const { sourceDroppableId } = this.state
	    //   const memberItemIds = []
	    //
	    //   if (memberId && memberId !== sourceDroppableId && itemId) {
	    //     const memberIndex = members.map(function(member) { return member.id }).indexOf(memberId)
	    //     const memberItems = members[memberIndex].items
	    //     const memberItemIndex = memberItems.map(function(item) { return item.id }).indexOf(itemId)
	    //
	    //     if (memberItemIndex === -1) {
	    //       const itemIndex = items.map(function(item) { return item.id }).indexOf(itemId)
	    //
	    //       members = update(members, {
	    //         [memberIndex]: {
	    //           items: {$splice: [[itemPosition, 0, items[itemIndex]]]}
	    //         }
	    //       })
	    //     }
	    //
	    //     members[memberIndex].items.map(item => memberItemIds.push(item.id))
	    //
	    //     this.props.editRiderMember({id: memberId, items: memberItemIds})
	    //
	    //     const memberExists = members.map(function(member) { return member.id }).indexOf(sourceDroppableId)
	    //     if (memberExists !== -1) this.removeMemberItem({memberId: sourceDroppableId, itemId}, members, items)
	    //   }
	    // }
	
	    // removeMemberItem({memberId, itemId}, members, items) {
	    //   let memberItemIds = []
	    //
	    //   const memberIndex = members.map(function(member) { return member.id }).indexOf(memberId)
	    //   const memberItems = members[memberIndex].items
	    //   const memberItemIndex = memberItems.map(function(item) { return item.id }).indexOf(itemId)
	    //
	    //   if (memberItemIndex !== -1) {
	    //     const itemIndex = items.map(function(item) { return item.id }).indexOf(itemId)
	    //
	    //     members = update(members, {
	    //       [memberIndex]: {
	    //         items: {$splice: [[items[itemIndex], 1]]}
	    //       }
	    //     })
	    //   }
	    //
	    //   members[memberIndex].items.map(item => memberItemIds.push(item.id))
	    //
	    //   this.props.editRiderMember({id: memberId, items: memberItemIds})
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          members = _props.members,
	          availableItems = _props.availableItems,
	          stageElements = _props.stageElements;
	      var _state = this.state,
	          artist = _state.artist,
	          isDragging = _state.isDragging;
	
	
	      var artistClassName = (0, _classnames2.default)({
	        'riek': true,
	        'artist': true,
	        'h3': true,
	        'placeholder': !artist
	      });
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'members' },
	        view.editable ? _react2.default.createElement(_riek.RIEInput, {
	          value: artist || 'Who\'s performing?',
	          propName: 'artist',
	          className: artistClassName,
	          classEditing: 'riek-editing',
	          change: function change(_ref) {
	            var artist = _ref.artist;
	            return _this2.setState({ artist: artist }, function () {
	              return _this2.props.editRider({ artist: artist });
	            });
	          } }) : _react2.default.createElement(
	          'div',
	          { className: artistClassName },
	          artist
	        ),
	        _react2.default.createElement(
	          _reactBeautifulDnd.DragDropContext,
	          {
	            onDragStart: function onDragStart(start, provided) {
	              return _this2.setState({
	                isDragging: true,
	                sourceDroppableId: start.source.droppableId
	              });
	            },
	            onDragEnd: function onDragEnd(result, provided) {
	              _this2.setState({ isDragging: false });
	              // this.addMemberItem({memberId: result && result.destination ? result.destination.droppableId : null, itemId: result.draggableId, itemPosition: result.destination.index}, members, items)
	            } },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'ol',
	              { className: 'cards' },
	              members.map(function (member, index) {
	                return _react2.default.createElement(_member2.default, { key: index,
	                  view: view,
	                  member: member,
	                  position: index + 1,
	                  isDragging: isDragging,
	                  createRiderItem: _this2.props.createRiderItem,
	                  removeRiderMember: _this2.props.removeRiderMember,
	                  createRiderMember: _this2.props.createRiderMember,
	                  editRiderMember: _this2.props.editRiderMember,
	                  moveRiderMember: _this2.props.moveRiderMember,
	                  deleteRiderMember: _this2.props.deleteRiderMember,
	                  availableItems: availableItems,
	                  stageElements: stageElements,
	                  searchResults: (0, _functions.validateSearchResults)(stageElements),
	                  getSearchResults: _this2.props.getSearchResults,
	                  setAlert: _this2.props.setAlert });
	              }),
	              view.editable ? _react2.default.createElement(
	                'li',
	                { className: 'card card--add', onClick: function onClick() {
	                    _this2.props.addRiderMember({
	                      id: undefined,
	                      name: null,
	                      email: null,
	                      phone: null,
	                      items: []
	                    });
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-content', 'data-number': members.length + 1 },
	                  _react2.default.createElement(
	                    'h1',
	                    { className: 'add-member' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Add new band member'
	                  )
	                )
	              ) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Members;
	}(_react.Component);
	
	Members.propTypes = {
	  view: _propTypes2.default.object,
	  artist: _propTypes2.default.string,
	  members: _propTypes2.default.array,
	  items: _propTypes2.default.array,
	  availableItems: _propTypes2.default.array,
	  editRider: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  addRiderMember: _propTypes2.default.func,
	  removeRiderMember: _propTypes2.default.func,
	  createRiderMember: _propTypes2.default.func,
	  editRiderMember: _propTypes2.default.func,
	  moveRiderMember: _propTypes2.default.func,
	  deleteRiderMember: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  getSearchResults: _propTypes2.default.func,
	  setAlert: _propTypes2.default.func
	};
	
	Members.defaultProps = {
	  view: {},
	  artist: null,
	  members: [],
	  items: [],
	  availableItems: [],
	  editRider: function editRider() {},
	  createRiderItem: function createRiderItem() {},
	  addRiderMember: function addRiderMember() {},
	  removeRiderMember: function removeRiderMember() {},
	  createRiderMember: function createRiderMember() {},
	  editRiderMember: function editRiderMember() {},
	  moveRiderMember: function moveRiderMember() {},
	  deleteRiderMember: function deleteRiderMember() {},
	  stageElements: {},
	  getSearchResults: function getSearchResults() {},
	  setAlert: function setAlert() {}
	};
	
	exports.default = Members;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RiderNavigation = function RiderNavigation(props) {
	  var sections = props.sections;
	
	
	  var className = function className(section) {
	    return (0, _classnames2.default)({
	      'active': section === props.activeSection
	    });
	  };
	
	  return _react2.default.createElement(
	    'nav',
	    { className: 'rider-navigation' },
	    _react2.default.createElement(
	      'ul',
	      null,
	      sections.map(function (section, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index },
	          _react2.default.createElement(
	            'a',
	            { className: className(section.slug), onClick: function onClick() {
	                return props.scrollTo(section.slug);
	              } },
	            section.title
	          )
	        );
	      })
	    )
	  );
	};
	
	RiderNavigation.propTypes = {
	  sections: _propTypes2.default.array,
	  riderId: _propTypes2.default.string,
	  activeSection: _propTypes2.default.string,
	  scrollTo: _propTypes2.default.func
	};
	
	RiderNavigation.defaultProps = {
	  sections: [],
	  riderId: '',
	  activeSection: undefined,
	  scrollTo: function scrollTo() {}
	};
	
	exports.default = RiderNavigation;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputSelectForm = function (_Component) {
	  _inherits(InputSelectForm, _Component);
	
	  function InputSelectForm(props) {
	    _classCallCheck(this, InputSelectForm);
	
	    var _this = _possibleConstructorReturn(this, (InputSelectForm.__proto__ || Object.getPrototypeOf(InputSelectForm)).call(this, props));
	
	    _this.state = {
	      itemSelectorValue: '',
	      showInputSelectForm: false
	    };
	
	    _this.selector = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(InputSelectForm, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var item = this.props.item;
	      var itemSelectorValue = this.state.itemSelectorValue;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'select-form' },
	        _react2.default.createElement('div', { className: 'select-form-escape', onClick: function onClick() {
	            return _this2.props.removeFocus();
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'select-form-fields' },
	          _react2.default.createElement(_reactSelect.Creatable, { ref: this.selector,
	            cache: false,
	            autoFocus: true,
	            openOnFocus: true,
	            className: 'select-form-field',
	            value: item,
	            valueKey: 'id',
	            labelKey: 'title',
	            clearable: false,
	            placeholder: 'Enter non-instrument',
	            promptTextCreator: function promptTextCreator(label) {
	              return 'Add "' + label + '"';
	            },
	            onOpen: function onOpen() {
	              var select = _this2.selector.current.select;
	
	              if (select) _this2.selector.current.select.handleInputChange({ target: { value: item && item.title || '' } });
	            },
	            onInputKeyDown: function onInputKeyDown(e) {
	              if (e.key === 'Backspace' && !itemSelectorValue) {
	                _this2.props.deleteRiderItem(item.id);
	                _this2.props.removeFocus();
	              } else if (e.key === 'Escape') {
	                _this2.props.removeFocus();
	              } else {
	                _this2.props.changeFocus(e);
	              }
	            },
	            onInputChange: function onInputChange(input) {
	              _this2.setState({ itemSelectorValue: input });
	
	              return input;
	            },
	            onChange: function onChange(item) {
	              _this2.props.itemIsSelected(Object.assign({}, item, { group: 'input' }));
	              _this2.props.removeFocus();
	            },
	            onNewOptionClick: function onNewOptionClick(_ref) {
	              var title = _ref.title;
	
	              _this2.props.itemIsSelected({ title: title, type: 'custom', class: 'non-instrument', group: 'input' });
	              _this2.props.removeFocus();
	            },
	            noResultsText: item.title ? 'Use backspace to remove' : 'No results',
	            options: [{
	              id: 1,
	              class: 'non-instrument',
	              type: 'custom',
	              title: 'echo'
	            }, {
	              id: 2,
	              class: 'non-instrument',
	              type: 'custom',
	              title: 'test'
	            }],
	            filterOptions: function filterOptions(options, filter) {
	              if (item.title && filter.length === 0) return null;
	
	              return options;
	            } })
	        )
	      );
	    }
	  }]);
	
	  return InputSelectForm;
	}(_react.Component);
	
	InputSelectForm.propTypes = {
	  item: _propTypes2.default.object,
	  setFocus: _propTypes2.default.bool,
	  changeFocus: _propTypes2.default.func,
	  removeFocus: _propTypes2.default.func,
	  itemIsSelected: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func
	};
	
	InputSelectForm.defaultProps = {
	  item: {},
	  setFocus: false,
	  changeFocus: function changeFocus() {},
	  removeFocus: function removeFocus() {},
	  itemIsSelected: function itemIsSelected() {},
	  deleteRiderItem: function deleteRiderItem() {}
	};
	
	exports.default = InputSelectForm;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _reactSelect = __webpack_require__(20);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _functions = __webpack_require__(6);
	
	var _selectForm = __webpack_require__(58);
	
	var _selectForm2 = _interopRequireDefault(_selectForm);
	
	var _switch = __webpack_require__(57);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItem = function (_Component) {
	  _inherits(ListItem, _Component);
	
	  function ListItem(props) {
	    _classCallCheck(this, ListItem);
	
	    var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));
	
	    _this.state = {
	      required: false,
	      showSelectForm: false,
	      showTypeSelectForm: false,
	      showDropdown: false,
	      showTypeDropdown: false
	    };
	    return _this;
	  }
	
	  _createClass(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var required = this.props.required;
	
	
	      this.setState({ required: required });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var required = nextProps.required;
	
	
	      if (this.props.required !== required) {
	        this.setState({ required: required });
	      }
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown(item, parentItem) {
	      var _this2 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  _this2.props.addRiderItem({
	                    class: "equipment",
	                    position: item.children.length + 1,
	                    parent: item.id,
	                    indexes: _this2.props.parentItemIndex !== undefined ? [_this2.props.parentItemIndex, _this2.props.itemIndex, item.children.length] : [_this2.props.itemIndex, item.children.length]
	                  });
	                });
	              } },
	            'Add equipment to this instrument'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showSelectForm: true, showDropdown: false });
	              } },
	            'Rename instrument'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  parentItem && parentItem.children && parentItem.children.length <= 1 ? _this2.props.deleteRiderItem(parentItem.id) : _this2.props.deleteRiderItem(item.id);
	                });
	              } },
	            'Remove this instrument'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderTypeDropdown',
	    value: function renderTypeDropdown(item) {
	      var _this3 = this;
	
	      var showTypeDropdown = this.state.showTypeDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showTypeDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showTypeDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this3.setState({ showTypeDropdown: !showTypeDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this3.setState({ showTypeDropdown: !showTypeDropdown });
	          } }),
	        showTypeDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this3.setState({ showTypeSelectForm: true, showTypeDropdown: false });
	              } },
	            'Change category'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderEmptyListItem',
	    value: function renderEmptyListItem(item, stageElements, options, categories) {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'list-item list-item--empty' },
	        _react2.default.createElement('div', { className: 'list-item-handle' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'list-item-channel' },
	          item.position
	        ),
	        _react2.default.createElement(_selectForm2.default, {
	          group: 'input',
	          item: {
	            class: 'instrument',
	            parent: item.parent,
	            type: item.type
	          },
	          itemGroups: this.props.itemGroups,
	          position: item.position,
	          setFocus: true,
	          removeFocus: function removeFocus() {
	            return _this4.props.removeRiderItem(item);
	          },
	          createRiderItem: this.props.createRiderItem,
	          editRiderItem: this.props.editRiderItem,
	          options: options ? options : [],
	          categories: categories ? categories : [],
	          createStageElement: this.props.createStageElement,
	          searchResults: (0, _functions.validateSearchResults)(stageElements),
	          getSearchResults: this.props.getSearchResults })
	      );
	    }
	  }, {
	    key: 'renderListItem',
	    value: function renderListItem() {
	      var _this5 = this;
	
	      var _props = this.props,
	          item = _props.item,
	          parentItem = _props.parentItem,
	          stageElements = _props.stageElements,
	          options = _props.options,
	          categories = _props.categories;
	      var showSelectForm = this.state.showSelectForm;
	
	
	      var renderSelectForm = function renderSelectForm(item, stageElements) {
	        return _react2.default.createElement(_selectForm2.default, {
	          group: _this5.props.group,
	          item: item,
	          itemGroups: _this5.props.itemGroups,
	          position: _this5.props.position,
	          setFocus: true,
	          removeFocus: function removeFocus() {
	            return _this5.setState({ showSelectForm: false });
	          },
	          createRiderItem: _this5.props.createRiderItem,
	          editRiderItem: _this5.props.editRiderItem,
	          options: options ? options : [],
	          categories: categories ? categories : [],
	          createStageElement: _this5.props.createStageElement,
	          searchResults: (0, _functions.validateSearchResults)(stageElements),
	          getSearchResults: _this5.props.getSearchResults });
	      };
	
	      var renderListMonitorItem = function renderListMonitorItem(item, stageElements) {
	        var _state = _this5.state,
	            required = _state.required,
	            showTypeSelectForm = _state.showTypeSelectForm;
	
	        var grouped = _this5.props.dragDropType.indexOf('instrument-group') !== -1;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'list-monitor-item' },
	          _this5.renderDropdown(item, parentItem),
	          _react2.default.createElement(
	            'div',
	            { className: 'list-monitor-item--title', onClick: function onClick() {
	                return _this5.setState({ showSelectForm: true });
	              } },
	            item.value || item.member && item.member.name
	          ),
	          !grouped && !showTypeSelectForm ? _this5.renderTypeDropdown(item) : null,
	          !grouped ? !showTypeSelectForm ? _react2.default.createElement(
	            'div',
	            { className: 'list-monitor-item--type', onClick: function onClick() {
	                return _this5.setState({ showTypeDropdown: !_this5.state.showTypeDropdown });
	              } },
	            item.type.title
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'select-form select-form--type' },
	            _react2.default.createElement('div', { className: 'select-form-escape', onClick: function onClick() {
	                return _this5.setState({ showTypeSelectForm: false });
	              } }),
	            _react2.default.createElement(
	              'div',
	              { className: 'select-form-fields' },
	              _react2.default.createElement(_reactSelect2.default, {
	                autoFocus: true,
	                openOnFocus: true,
	                className: 'select-form-field',
	                name: 'item-type-selector-' + item.id,
	                value: undefined,
	                valueKey: 'id',
	                labelKey: 'title',
	                clearable: false,
	                onChange: function onChange(selectedItem) {
	                  return _this5.setState({ showTypeSelectForm: false }, function () {
	                    return _this5.props.editRiderItem({ id: item.id, type: selectedItem.type.slug });
	                  });
	                },
	                categories: [] })
	            )
	          ) : null,
	          _react2.default.createElement(_switch2.default, {
	            required: required,
	            toggleSwitch: function toggleSwitch(required) {
	              return _this5.setState({ required: required }, function () {
	                return _this5.props.editRiderItem({ id: item.id, required: required });
	              });
	            } })
	        );
	      };
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Draggable,
	        { draggableId: item.id, type: this.props.dragDropType },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'list-item' },
	            _react2.default.createElement(
	              'div',
	              { className: 'list-item--draggable',
	                ref: provided.innerRef,
	                style: provided.draggableStyle },
	              _react2.default.createElement('div', Object.assign({ className: 'list-item-handle' }, provided.dragHandleProps)),
	              _react2.default.createElement(
	                'div',
	                { className: 'list-item-channel' },
	                item.position
	              ),
	              showSelectForm ? renderSelectForm(item, stageElements) : renderListMonitorItem(item, stageElements)
	            ),
	            provided.placeholder
	          );
	        }
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var item = this.props.item;
	
	
	      return item.id !== undefined ? this.renderListItem()
	      // : this.renderEmptyListItem(item, stageElements, options, categories)
	      : null;
	    }
	  }]);
	
	  return ListItem;
	}(_react.Component);
	
	ListItem.propTypes = {
	  dragDropType: _propTypes2.default.string,
	  group: _propTypes2.default.string,
	  item: _propTypes2.default.object,
	  itemIndex: _propTypes2.default.number,
	  parentItem: _propTypes2.default.object,
	  parentItemIndex: _propTypes2.default.number,
	  position: _propTypes2.default.number,
	  required: _propTypes2.default.bool,
	  setFocus: _propTypes2.default.bool,
	  itemGroups: _propTypes2.default.array,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  options: _propTypes2.default.array,
	  categories: _propTypes2.default.array,
	  createStageElement: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func
	};
	
	ListItem.defaultProps = {
	  dragDropType: '',
	  group: '',
	  item: {},
	  itemIndex: undefined,
	  parentItem: {},
	  parentItemIndex: undefined,
	  position: 0,
	  required: false,
	  setFocus: false,
	  itemGroups: [],
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  stageElements: {},
	  options: undefined,
	  categories: undefined,
	  createStageElement: function createStageElement() {},
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = ListItem;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _listItem = __webpack_require__(313);
	
	var _listItem2 = _interopRequireDefault(_listItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import ListGroup from './list-group'
	
	
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List(props) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));
	
	    _this.reorderList = function (result) {
	      if (!result.destination) return null;
	
	      var items = (0, _functions.reorder)(_this.state.items, result.source.index, result.destination.index);
	
	      _this.setState({ items: items }, function () {
	        return _this.props.moveRiderItem({ id: result.draggableId, position: result.destination.index + 1 });
	      });
	    };
	
	    _this.state = {
	      items: []
	    };
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var items = this.props.items;
	
	
	      this.setState({ items: items });
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var items = nextProps.items;
	
	
	      if (items !== this.props.items) this.setState({ items: items });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var stageElements = this.props.stageElements;
	      var items = this.state.items;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'list' },
	        _react2.default.createElement(
	          _reactBeautifulDnd.DragDropContext,
	          { onDragEnd: this.reorderList },
	          _react2.default.createElement(
	            _reactBeautifulDnd.Droppable,
	            { droppableId: 'list', type: 'instrument' },
	            function (provided, snapshot) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'list--droppable',
	                  ref: provided.innerRef },
	                items.length > 0 ? items.map(function (item, index) {
	                  // if (item.id === undefined) return <Loading key={index} className="list-item list-item--loading" />
	
	                  if (item.class.includes('monitor')) {
	                    return _react2.default.createElement(_listItem2.default, { key: item.id || index,
	                      dragDropType: 'instrument',
	                      group: _this2.props.group,
	                      item: item,
	                      itemIndex: index,
	                      itemGroups: _this2.props.itemGroups,
	                      position: item.position,
	                      required: item.required,
	                      addRiderItem: _this2.props.addRiderItem,
	                      removeRiderItem: _this2.props.removeRiderItem,
	                      createRiderItem: _this2.props.createRiderItem,
	                      editRiderItem: _this2.props.editRiderItem,
	                      deleteRiderItem: _this2.props.deleteRiderItem,
	                      stageElements: stageElements,
	                      createStageElement: _this2.props.createStageElement,
	                      getSearchResults: _this2.props.getSearchResults });
	                    /*return item.class === 'instrument-group'
	                    ? <ListGroup key={item.id || index}
	                        dragDropType={`instrument-group-${item.id}`}
	                        group={this.props.group}
	                        item={item}
	                        itemIndex={index}
	                        itemGroups={this.props.itemGroups}
	                        addRiderItem={this.props.addRiderItem}
	                        removeRiderItem={this.props.removeRiderItem}
	                        createRiderItem={this.props.createRiderItem}
	                        createRiderItems={this.props.createRiderItems}
	                        editRiderItem={this.props.editRiderItem}
	                        deleteRiderItem={this.props.deleteRiderItem}
	                        stageElements={stageElements}
	                        createStageElement={this.props.createStageElement}
	                        getSearchResults={this.props.getSearchResults} />
	                    : <ListItem key={item.id || index}
	                        dragDropType="instrument"
	                        group={this.props.group}
	                        item={item}
	                        itemIndex={index}
	                        itemGroups={this.props.itemGroups}
	                        position={item.position}
	                        required={item.required}
	                        addRiderItem={this.props.addRiderItem}
	                        removeRiderItem={this.props.removeRiderItem}
	                        createRiderItem={this.props.createRiderItem}
	                        editRiderItem={this.props.editRiderItem}
	                        deleteRiderItem={this.props.deleteRiderItem}
	                        stageElements={stageElements}
	                        createStageElement={this.props.createStageElement}
	                        getSearchResults={this.props.getSearchResults} />*/
	                  } else {
	                    return null;
	                  }
	                }) : _react2.default.createElement(
	                  'p',
	                  null,
	                  'Start by adding your ',
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                        _this2.props.addRiderItem({
	                          class: "instrument",
	                          position: items.length + 1,
	                          indexes: [items.length]
	                        });
	                      } },
	                    'first instrument'
	                  ),
	                  '.'
	                ),
	                provided.placeholder
	              );
	            }
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'list--add-button button--link', onClick: function onClick() {
	              _this2.props.addRiderItem({
	                class: "instrument",
	                position: items.length + 1,
	                indexes: [items.length]
	              });
	            } },
	          'Insert instrument'
	        )
	      );
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	List.propTypes = {
	  group: _propTypes2.default.string,
	  items: _propTypes2.default.array,
	  itemGroups: _propTypes2.default.array,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  createRiderItems: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  createStageElement: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func
	};
	
	List.defaultProps = {
	  group: '',
	  items: [],
	  itemGroups: [],
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  createRiderItems: function createRiderItems() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  stageElements: {},
	  createStageElement: function createStageElement() {},
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = List;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _rangeForm = __webpack_require__(166);
	
	var _rangeForm2 = _interopRequireDefault(_rangeForm);
	
	var _selectForm = __webpack_require__(167);
	
	var _selectForm2 = _interopRequireDefault(_selectForm);
	
	var _icons = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableGroup = function (_Component) {
	  _inherits(TableGroup, _Component);
	
	  function TableGroup(props) {
	    _classCallCheck(this, TableGroup);
	
	    var _this = _possibleConstructorReturn(this, (TableGroup.__proto__ || Object.getPrototypeOf(TableGroup)).call(this, props));
	
	    _this.state = {
	      showDropdown: false,
	      showSelectForm: false,
	      focusMemberSelector: false,
	      preventFaderUpdates: false
	    };
	    return _this;
	  }
	
	  _createClass(TableGroup, [{
	    key: 'renderDropdown',
	    value: function renderDropdown(item) {
	      var _this2 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showSelectForm: true, showDropdown: false });
	              } },
	            'Change monitor'
	          ),
	          item.member || item.value ? _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  return _this2.props.editRiderItem({ id: item.id, member: null, value: null });
	                });
	              } },
	            'Remove ',
	            item.member && item.member.name || item.value,
	            ' from this monitor'
	          ) : _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showSelectForm: true, focusMemberSelector: true, showDropdown: false });
	              } },
	            'Assign a member'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  return _this2.props.deleteRiderItem(item.id);
	                });
	              } },
	            'Remove this monitor'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'itemIsSelected',
	    value: function itemIsSelected(selectedItem) {
	      var _this3 = this;
	
	      var item = this.props.item;
	
	
	      if (item.id) {
	        if (selectedItem.type && selectedItem.type.includes('stereo')) {
	          this.props.editRiderItem(Object.assign({}, selectedItem, { id: item.id }));
	        } else {
	          this.setState({ preventFaderUpdates: true }, function () {
	            return _this3.props.editRiderItem(Object.assign({}, selectedItem, { id: item.id, class: 'monitor' }));
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          value = _props.value,
	          item = _props.item,
	          itemIndex = _props.itemIndex,
	          itemTypes = _props.itemTypes,
	          members = _props.members,
	          paging = _props.paging;
	      var _state = this.state,
	          showSelectForm = _state.showSelectForm,
	          focusMemberSelector = _state.focusMemberSelector,
	          preventFaderUpdates = _state.preventFaderUpdates;
	      var children = item.children;
	
	      var childItems = []; // TODO: Remove class: 'fader' items from children on stereo-pair (monitor-group) creation for correct indexes
	
	      children.forEach(function (child, index) {
	        if (child.class.includes('monitor')) childItems.push(child);
	      });
	
	      if ((0, _functions.hiddenInPaging)(paging, itemIndex) && (0, _functions.hiddenInPaging)(paging, itemIndex + 1)) return null;
	
	      var size = (0, _functions.hiddenInPaging)(paging, itemIndex) || (0, _functions.hiddenInPaging)(paging, itemIndex + 1) ? 1 : 2;
	      var isStereo = size === 2;
	
	      var className = (0, _classnames2.default)({
	        'table-group': true,
	        'table-group--stereo': true,
	        'table-group--stereo-split': !isStereo
	      });
	
	      var isIncrementing = (0, _functions.hiddenInPaging)(paging, itemIndex) === false && (0, _functions.hiddenInPaging)(paging, itemIndex + 1) === true;
	
	      var channelsClassName = (0, _classnames2.default)({
	        'table-group-channels': true,
	        'table-group-channels--next': isIncrementing === true,
	        'table-group-channels--previous': isIncrementing === false
	      });
	
	      var channelClassName = (0, _classnames2.default)({
	        'table-group-channel': true,
	        'table-group-channel--left': isIncrementing === true,
	        'table-group-channel--right': isIncrementing === false
	      });
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Draggable,
	        { draggableId: item.id, isDragDisabled: true, type: 'item' },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'div',
	            { className: className, style: { minWidth: 100 / paging.size * size + '%', maxWidth: 100 / paging.size * size + '%' } },
	            _react2.default.createElement(
	              'div',
	              Object.assign({ className: 'table-group--draggable',
	                ref: provided.innerRef,
	                style: provided.draggableStyle
	              }, provided.dragHandleProps),
	              _react2.default.createElement('div', { className: 'table-group-handle' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'table-group-head' },
	                view.editable ? _this4.renderDropdown(item) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: channelsClassName },
	                  _react2.default.createElement(_icons.LinkIcon, { className: 'table-group-channels-link-icon' }),
	                  isStereo ? childItems.map(function (childItem, index) {
	                    var channelClassName = (0, _classnames2.default)({
	                      'table-group-channel': true,
	                      'table-group-channel--left': index === 0,
	                      'table-group-channel--right': index === 1
	                    });
	
	                    return _react2.default.createElement(
	                      'div',
	                      { key: index, className: channelClassName },
	                      childItem.channel
	                    );
	                  }) : _react2.default.createElement(
	                    'div',
	                    { className: channelClassName },
	                    isIncrementing ? item.channel.split('-')[0] : item.channel.split('-')[1]
	                  )
	                ),
	                showSelectForm && view.editable ? _react2.default.createElement(_selectForm2.default, {
	                  item: item,
	                  value: value,
	                  itemTypes: [].concat(_toConsumableArray(itemTypes), [{ class: 'monitor', type: null, title: 'Assign member' }]),
	                  members: members,
	                  focusMemberSelector: focusMemberSelector,
	                  onItemSelect: function onItemSelect(selectedItem) {
	                    return _this4.setState({ showSelectForm: false, focusMemberSelector: false }, function () {
	                      return _this4.itemIsSelected(selectedItem);
	                    });
	                  },
	                  removeFocus: function removeFocus() {
	                    return _this4.setState({ showSelectForm: false, focusMemberSelector: false });
	                  } }) : _react2.default.createElement(
	                  'div',
	                  { className: 'name', onClick: function onClick() {
	                      return _this4.setState({ showSelectForm: true });
	                    } },
	                  value
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table-item' },
	                childItems.map(function (childItem, index) {
	                  if (childItem.class.includes('monitor')) {
	                    var faders = childItem.faders;
	
	
	                    if ((0, _functions.hiddenInPaging)(paging, itemIndex + index)) return null; // TODO: if {class: 'fader'} children are present, wrong index will be supplied to hiddenInPaging; could be replaced with position
	
	                    return _react2.default.createElement(
	                      'div',
	                      { key: childItem.id || index, className: 'table-item-body table-item-body--output' },
	                      faders && faders.length > 0 ? faders.map(function (fader, index) {
	                        return _react2.default.createElement(_rangeForm2.default, { key: index,
	                          view: view,
	                          child: fader,
	                          value: parseInt(fader.value, 10),
	                          createRiderItem: function createRiderItem(item) {
	                            return preventFaderUpdates !== true ? _this4.props.createRiderItem(item) : null;
	                          },
	                          editRiderItem: function editRiderItem(item) {
	                            return preventFaderUpdates !== true ? _this4.props.editRiderItem(item) : null;
	                          } });
	                      }) : null
	                    );
	                  } else {
	                    return null;
	                  }
	                })
	              )
	            ),
	            provided.placeholder
	          );
	        }
	      );
	    }
	  }]);
	
	  return TableGroup;
	}(_react.Component);
	
	TableGroup.propTypes = {
	  view: _propTypes2.default.object,
	  value: _propTypes2.default.string,
	  item: _propTypes2.default.object,
	  itemIndex: _propTypes2.default.number,
	  itemTypes: _propTypes2.default.array,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  deleteRiderItemGroup: _propTypes2.default.func,
	  members: _propTypes2.default.array,
	  paging: _propTypes2.default.object
	};
	
	TableGroup.defaultProps = {
	  view: {},
	  value: '',
	  item: {},
	  itemIndex: undefined,
	  itemTypes: [],
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  deleteRiderItemGroup: function deleteRiderItemGroup() {},
	  members: [],
	  paging: {}
	};
	
	exports.default = TableGroup;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _inputSelectForm = __webpack_require__(312);
	
	var _inputSelectForm2 = _interopRequireDefault(_inputSelectForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableInputItem = function (_Component) {
	  _inherits(TableInputItem, _Component);
	
	  function TableInputItem(props) {
	    _classCallCheck(this, TableInputItem);
	
	    var _this = _possibleConstructorReturn(this, (TableInputItem.__proto__ || Object.getPrototypeOf(TableInputItem)).call(this, props));
	
	    _this.state = {
	      showInputSelectForm: false
	    };
	    return _this;
	  }
	
	  _createClass(TableInputItem, [{
	    key: 'renderInputItem',
	    value: function renderInputItem() {
	      var _this2 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          item = _props.item;
	      var showInputSelectForm = this.state.showInputSelectForm;
	
	
	      var nonInstrument = item.class === 'non-instrument';
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Draggable,
	        { draggableId: item.id, isDragDisabled: !view.editable || !nonInstrument, type: 'input-item' },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'table-input-item' },
	            _react2.default.createElement(
	              'div',
	              { className: 'table-input-item--draggable',
	                ref: provided.innerRef,
	                style: provided.draggableStyle },
	              nonInstrument && showInputSelectForm !== true ? _react2.default.createElement('div', Object.assign({ className: 'table-input-item-handle' }, provided.dragHandleProps)) : null,
	              nonInstrument ? showInputSelectForm !== true ? _react2.default.createElement(
	                'div',
	                { className: 'title link link--invert', 'data-value': item.title, onClick: function onClick() {
	                    return _this2.setState({ showInputSelectForm: !showInputSelectForm });
	                  } },
	                item.title
	              ) : _react2.default.createElement(_inputSelectForm2.default, {
	                removeFocus: function removeFocus() {
	                  return _this2.setState({ showInputSelectForm: false });
	                },
	                item: item,
	                itemIsSelected: function itemIsSelected(selectedItem) {
	                  return _this2.props.editRiderItem(Object.assign({}, selectedItem, { id: item.id }));
	                },
	                deleteRiderItem: _this2.props.deleteRiderItem }) : _react2.default.createElement(
	                'div',
	                { className: 'title', 'data-value': item.title },
	                item.title
	              )
	            ),
	            provided.placeholder
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderEmptyInputItem',
	    value: function renderEmptyInputItem() {
	      var _this3 = this;
	
	      var item = this.props.item;
	
	
	      if (item.class !== 'non-instrument') return null;
	
	      return _react2.default.createElement(_inputSelectForm2.default, {
	        removeFocus: function removeFocus() {
	          return _this3.props.removeRiderItem(item);
	        },
	        item: undefined,
	        itemIsSelected: function itemIsSelected(selectedItem) {
	          return _this3.props.createRiderItem(selectedItem);
	        } });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var item = this.props.item;
	
	
	      return item.id ? this.renderInputItem() : this.renderEmptyInputItem();
	    }
	  }]);
	
	  return TableInputItem;
	}(_react.Component);
	
	TableInputItem.propTypes = {
	  view: _propTypes2.default.object,
	  item: _propTypes2.default.object,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func
	};
	
	TableInputItem.defaultProps = {
	  view: {},
	  item: {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {}
	};
	
	exports.default = TableInputItem;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _rangeForm = __webpack_require__(166);
	
	var _rangeForm2 = _interopRequireDefault(_rangeForm);
	
	var _selectForm = __webpack_require__(167);
	
	var _selectForm2 = _interopRequireDefault(_selectForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableItem = function (_Component) {
	  _inherits(TableItem, _Component);
	
	  function TableItem(props) {
	    _classCallCheck(this, TableItem);
	
	    var _this = _possibleConstructorReturn(this, (TableItem.__proto__ || Object.getPrototypeOf(TableItem)).call(this, props));
	
	    _this.state = {
	      showDropdown: false,
	      showSelectForm: false,
	      focusMemberSelector: false,
	      preventFaderUpdates: false
	    };
	    return _this;
	  }
	
	  _createClass(TableItem, [{
	    key: 'renderDropdown',
	    value: function renderDropdown(item) {
	      var _this2 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showSelectForm: true, showDropdown: false });
	              } },
	            'Change monitor'
	          ),
	          item.member || item.value ? _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  return _this2.props.editRiderItem({ id: item.id, member: null, value: null });
	                });
	              } },
	            'Remove ',
	            item.member && item.member.name || item.value,
	            ' from this monitor'
	          ) : _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showSelectForm: true, focusMemberSelector: true, showDropdown: false });
	              } },
	            'Assign a member'
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  return _this2.props.deleteRiderItem(item.id);
	                });
	              } },
	            'Remove this monitor'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'itemIsSelected',
	    value: function itemIsSelected(selectedItem) {
	      var _this3 = this;
	
	      var item = this.props.item;
	
	      var isStereo = selectedItem.type && selectedItem.type.includes('stereo');
	
	      if (item.id) {
	        if (isStereo) {
	          this.setState({ preventFaderUpdates: true }, function () {
	            return _this3.props.cloneRiderItem(Object.assign({}, item, { title: selectedItem.title, type: selectedItem.type }));
	          });
	        } else {
	          this.props.editRiderItem(Object.assign({}, selectedItem, { id: item.id }));
	        }
	      } else {
	        if (isStereo) {
	          this.props.createRiderItems(selectedItem);
	        } else {
	          this.props.createRiderItem(Object.assign({}, selectedItem, { class: 'monitor' }));
	        }
	      }
	    }
	  }, {
	    key: 'renderEmptyTableItem',
	    value: function renderEmptyTableItem() {
	      var _this4 = this;
	
	      var _props = this.props,
	          item = _props.item,
	          value = _props.value,
	          itemTypes = _props.itemTypes,
	          members = _props.members,
	          paging = _props.paging;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-item table-item--empty', style: { minWidth: 100 / paging.size + '%', maxWidth: 100 / paging.size + '%' } },
	        _react2.default.createElement('div', { className: 'table-item-handle' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'table-item-head' },
	          _react2.default.createElement(
	            'div',
	            { className: 'table-item-channel' },
	            item.channel
	          ),
	          _react2.default.createElement(_selectForm2.default, {
	            item: item,
	            value: value,
	            itemTypes: itemTypes,
	            members: members,
	            onItemSelect: function onItemSelect(selectedItem) {
	              return _this4.itemIsSelected(selectedItem);
	            },
	            removeFocus: function removeFocus() {
	              return _this4.props.removeRiderItem(item);
	            } })
	        )
	      );
	    }
	  }, {
	    key: 'renderTableItem',
	    value: function renderTableItem() {
	      var _this5 = this;
	
	      var _props2 = this.props,
	          view = _props2.view,
	          item = _props2.item,
	          value = _props2.value,
	          itemTypes = _props2.itemTypes,
	          members = _props2.members,
	          paging = _props2.paging;
	      var faders = item.faders;
	      var _state = this.state,
	          showSelectForm = _state.showSelectForm,
	          focusMemberSelector = _state.focusMemberSelector,
	          preventFaderUpdates = _state.preventFaderUpdates;
	
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Draggable,
	        { draggableId: item.id, isDragDisabled: true, type: 'item' },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'table-item', style: { minWidth: 100 / paging.size + '%', maxWidth: 100 / paging.size + '%' } },
	            _react2.default.createElement(
	              'div',
	              Object.assign({ className: 'table-item--draggable',
	                ref: provided.innerRef,
	                style: provided.draggableStyle
	              }, provided.dragHandleProps),
	              _react2.default.createElement('div', { className: 'table-item-handle' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'table-item-head' },
	                view.editable ? _this5.renderDropdown(item) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-item-channel' },
	                  item.channel
	                ),
	                showSelectForm ? _react2.default.createElement(_selectForm2.default, {
	                  item: item,
	                  value: value,
	                  itemTypes: [].concat(_toConsumableArray(itemTypes), [{ class: 'monitor', type: null, title: 'Assign member' }]),
	                  members: members,
	                  focusMemberSelector: focusMemberSelector,
	                  onItemSelect: function onItemSelect(selectedItem) {
	                    return _this5.setState({ showSelectForm: false, focusMemberSelector: false }, function () {
	                      return _this5.itemIsSelected(selectedItem);
	                    });
	                  },
	                  removeFocus: function removeFocus() {
	                    return _this5.setState({ showSelectForm: false, focusMemberSelector: false });
	                  } }) : _react2.default.createElement(
	                  'div',
	                  { className: 'name', onClick: function onClick() {
	                      return _this5.setState({ showSelectForm: true });
	                    } },
	                  value
	                )
	              ),
	              faders && faders.length > 0 ? _react2.default.createElement(
	                'div',
	                { className: 'table-item-body table-item-body--output' },
	                faders.map(function (fader, index) {
	                  return _react2.default.createElement(_rangeForm2.default, { key: index,
	                    view: view,
	                    child: fader,
	                    value: parseInt(fader.value, 10),
	                    createRiderItem: function createRiderItem(item) {
	                      return preventFaderUpdates !== true ? _this5.props.createRiderItem(item) : null;
	                    },
	                    editRiderItem: function editRiderItem(item) {
	                      return preventFaderUpdates !== true ? _this5.props.editRiderItem(item) : null;
	                    } });
	                })
	              ) : null
	            ),
	            provided.placeholder
	          );
	        }
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          item = _props3.item,
	          itemIndex = _props3.itemIndex,
	          paging = _props3.paging;
	
	
	      if ((0, _functions.hiddenInPaging)(paging, itemIndex)) return null;
	
	      return item.id ? this.renderTableItem() : this.renderEmptyTableItem();
	    }
	  }]);
	
	  return TableItem;
	}(_react.Component);
	
	TableItem.propTypes = {
	  view: _propTypes2.default.object,
	  value: _propTypes2.default.string,
	  item: _propTypes2.default.object,
	  itemIndex: _propTypes2.default.number,
	  itemTypes: _propTypes2.default.array,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  createRiderItems: _propTypes2.default.func,
	  cloneRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  members: _propTypes2.default.array,
	  paging: _propTypes2.default.object
	};
	
	TableItem.defaultProps = {
	  view: {},
	  value: '',
	  item: {},
	  itemIndex: 0,
	  itemTypes: [],
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  createRiderItems: function createRiderItems() {},
	  cloneRiderItem: function cloneRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  members: [],
	  paging: {}
	};
	
	exports.default = TableItem;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _tableInputItem = __webpack_require__(316);
	
	var _tableInputItem2 = _interopRequireDefault(_tableInputItem);
	
	var _tableGroup = __webpack_require__(315);
	
	var _tableGroup2 = _interopRequireDefault(_tableGroup);
	
	var _tableItem = __webpack_require__(317);
	
	var _tableItem2 = _interopRequireDefault(_tableItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this.reorderList = function (result) {
	      if (!result.destination) return null;
	
	      if (result.type === 'item') {
	        var items = (0, _functions.reorder)(_this.state.items, result.source.index, result.destination.index);
	
	        _this.setState({ items: items }, function () {
	          return _this.props.moveRiderItem({
	            id: result.draggableId,
	            position: result.destination.index + 1
	          });
	        });
	      } else if (result.type === 'input-item') {
	        var inputItems = (0, _functions.reorder)(_this.state.inputItems, result.source.index, result.destination.index);
	
	        _this.setState({ inputItems: inputItems }, function () {
	          return _this.props.moveRiderItem({
	            id: result.draggableId,
	            position: result.destination.index + 1
	          });
	        });
	      }
	    };
	
	    _this.state = {
	      items: undefined,
	      itemTypes: [{
	        id: '1',
	        class: 'monitor',
	        type: 'wedge-monitor',
	        title: 'Wedge monitor'
	      }, {
	        id: '2',
	        class: 'monitor',
	        type: 'in-ear-monitor',
	        title: 'In-Ear monitor'
	      }, {
	        id: '3',
	        class: 'monitor',
	        type: 'in-ear-monitor-stereo',
	        title: 'In-Ear monitor — stereo'
	      }],
	      inputItems: undefined,
	      paging: {
	        stickyColumn: true,
	        hideFirstColumn: false,
	        offset: 0,
	        size: 3
	      }
	    };
	
	    _this.component = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          items = _props.items,
	          inputItems = _props.inputItems;
	
	
	      this.setState({ items: items, inputItems: inputItems });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.calculateTableSize();
	    }
	  }, {
	    key: 'calculateTableSize',
	    value: function calculateTableSize() {
	      var offsetWidth = this.component.current.offsetWidth;
	
	      var channelWidth = 95;
	      var maxWidth = 180;
	
	      var size = Math.floor((offsetWidth - channelWidth) / maxWidth);
	      this.setState({
	        paging: (0, _immutabilityHelper2.default)(this.state.paging, {
	          size: { $set: size }
	        })
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var items = nextProps.items,
	          inputItems = nextProps.inputItems;
	
	
	      if (items !== this.props.items) this.setState({ items: items });
	      if (inputItems !== this.props.inputItems) this.setState({ inputItems: inputItems });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var fullView = nextProps.fullView,
	          items = nextProps.items,
	          inputItems = nextProps.inputItems;
	
	
	      if (fullView !== this.props.fullView) return true;
	      if (items !== this.props.items) return true;
	      if (inputItems !== this.props.inputItems) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var fullView = prevProps.fullView;
	
	
	      if (fullView !== this.props.fullView) this.calculateTableSize();
	    }
	  }, {
	    key: 'paginate',
	    value: function paginate(paging, operator) {
	      this.setState({
	        paging: (0, _immutabilityHelper2.default)(paging, {
	          offset: {
	            $set: !isNaN(operator) ? operator : operator === 'next' ? paging.offset + 1 : paging.offset - 1
	          }
	        })
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          view = _props2.view,
	          members = _props2.members;
	      var _state = this.state,
	          items = _state.items,
	          itemTypes = _state.itemTypes,
	          inputItems = _state.inputItems,
	          paging = _state.paging;
	
	
	      if (!items) return null;
	
	      var itemIndex = undefined;
	      var itemGroup = false;
	
	      var itemsLength = 0;
	      items.forEach(function (item) {
	        return itemsLength = item.class === 'monitor-group' ? itemsLength + 2 : itemsLength + 1;
	      });
	
	      var channelsClassName = (0, _classnames2.default)({
	        'table-item': true,
	        'table-item--channels': true,
	        'table-item--instruments': inputItems.length > 0
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { ref: this.component, className: 'table' },
	        _react2.default.createElement(
	          _reactBeautifulDnd.DragDropContext,
	          { onDragEnd: this.reorderList },
	          _react2.default.createElement(
	            'div',
	            { className: 'table-items' },
	            paging.offset > 0 ? _react2.default.createElement(
	              'div',
	              { className: 'table--fixed-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'table--previous-button', style: { left: 100 / paging.size + '%' }, onClick: function onClick() {
	                    return _this2.paginate(paging, 'previous');
	                  } },
	                _react2.default.createElement('div', { className: 'oval-button oval-button--previous' })
	              )
	            ) : null,
	            itemsLength > paging.offset - 1 + paging.size ? _react2.default.createElement(
	              'div',
	              { className: 'table--next-button', onClick: function onClick() {
	                  return _this2.paginate(paging, 'next');
	                } },
	              _react2.default.createElement('div', { className: 'oval-button oval-button--next' })
	            ) : null,
	            _react2.default.createElement(
	              _reactBeautifulDnd.Droppable,
	              { droppableId: 'table-items', isDropDisabled: !view.editable, direction: 'horizontal', type: 'item' },
	              function (provided, snapshot) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'table-items--droppable',
	                    ref: provided.innerRef },
	                  paging.stickyColumn ? _react2.default.createElement(
	                    'div',
	                    { className: channelsClassName, style: { minWidth: 100 / paging.size + '%', maxWidth: 100 / paging.size + '%' } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table-item-head' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'table-item-head--output' },
	                        'Output channels'
	                      ),
	                      inputItems.length > 0 ? _react2.default.createElement(
	                        'div',
	                        { className: 'table-item-head--input' },
	                        'Instruments'
	                      ) : null
	                    ),
	                    _react2.default.createElement(
	                      _reactBeautifulDnd.Droppable,
	                      { droppableId: 'table-input-items', isDropDisabled: !view.editable, type: 'input-item' },
	                      function (provided, snapshot) {
	                        return _react2.default.createElement(
	                          'div',
	                          { className: 'table-items--droppable',
	                            ref: provided.innerRef },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'table-item-body table-item-body--input' },
	                            inputItems.length > 0 ? inputItems.map(function (item, index) {
	                              return _react2.default.createElement(_tableInputItem2.default, { key: index,
	                                view: view,
	                                item: item,
	                                removeRiderItem: _this2.props.removeRiderItem,
	                                createRiderItem: _this2.props.createRiderItem,
	                                editRiderItem: _this2.props.editRiderItem,
	                                deleteRiderItem: _this2.props.deleteRiderItem });
	                            }) : null,
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'title link', onClick: function onClick() {
	                                  _this2.props.addRiderItem({
	                                    id: null,
	                                    group: 'input',
	                                    class: 'non-instrument',
	                                    type: 'custom',
	                                    title: '',
	                                    position: inputItems.length + 1,
	                                    indexes: [inputItems.length]
	                                  });
	                                } },
	                              'Add new non-instrument'
	                            )
	                          )
	                        );
	                      }
	                    )
	                  ) : null,
	                  items.length > 0 ? items.map(function (item, index) {
	                    itemIndex = itemIndex === undefined ? 0 : itemIndex + 1;
	
	                    if (itemGroup) {
	                      itemIndex += 1;
	                      itemGroup = false;
	                    }
	
	                    if (item.class.includes('monitor')) {
	                      if (item.class === 'monitor-group') itemGroup = true;
	
	                      var value = (0, _functions.getMonitorValue)(item);
	
	                      return item.class === 'monitor-group' ? _react2.default.createElement(_tableGroup2.default, { key: item.id || index,
	                        view: view,
	                        value: value,
	                        item: item,
	                        itemIndex: itemIndex,
	                        itemTypes: itemTypes,
	                        removeRiderItem: function removeRiderItem(item) {
	                          _this2.paginate(paging, 'previous');
	                          _this2.props.removeRiderItem(item);
	                        },
	                        createRiderItem: function createRiderItem(item) {
	                          return _this2.props.createRiderItem(Object.assign({}, item, { group: 'output' }));
	                        },
	                        editRiderItem: _this2.props.editRiderItem,
	                        deleteRiderItem: _this2.props.deleteRiderItem,
	                        deleteRiderItemGroup: _this2.props.deleteRiderItemGroup,
	                        members: members,
	                        paging: paging }) : _react2.default.createElement(_tableItem2.default, { key: item.id || index,
	                        view: view,
	                        value: value,
	                        item: item,
	                        itemIndex: itemIndex,
	                        itemTypes: itemTypes,
	                        removeRiderItem: function removeRiderItem(item) {
	                          _this2.paginate(paging, 'previous');
	                          _this2.props.removeRiderItem(item);
	                        },
	                        createRiderItem: function createRiderItem(item) {
	                          return _this2.props.createRiderItem(Object.assign({}, item, { group: 'output' }));
	                        },
	                        createRiderItems: _this2.props.createRiderItems,
	                        cloneRiderItem: _this2.props.cloneRiderItem,
	                        editRiderItem: _this2.props.editRiderItem,
	                        deleteRiderItem: _this2.props.deleteRiderItem,
	                        members: members,
	                        paging: paging });
	                    } else {
	                      return null;
	                    }
	                  }) : _react2.default.createElement(
	                    'div',
	                    { className: 'table-item table-item--add' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table-item-head' },
	                      'Start by adding your ',
	                      _react2.default.createElement(
	                        'a',
	                        { onClick: function onClick() {
	                            _this2.paginate(paging, itemsLength - paging.size + 2);
	                            _this2.props.addRiderItem({
	                              id: null,
	                              group: 'output',
	                              class: 'monitor', // monitor-group
	                              type: 'monitor',
	                              title: '',
	                              position: items.length + 1,
	                              indexes: [items.length]
	                            });
	                          } },
	                        'first output channel'
	                      ),
	                      '.'
	                    )
	                  )
	                );
	              }
	            ),
	            view.editable ? _react2.default.createElement(
	              'div',
	              { className: 'table--add-column-button', onClick: function onClick() {
	                  _this2.paginate(paging, itemsLength - paging.size + 2);
	                  _this2.props.addRiderItem({
	                    id: null,
	                    group: 'output',
	                    class: 'monitor', // monitor-group
	                    type: 'monitor',
	                    title: '',
	                    position: items.length + 1,
	                    indexes: [items.length]
	                  });
	                } },
	              _react2.default.createElement('div', { className: 'oval-button oval-button--add' })
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.propTypes = {
	  view: _propTypes2.default.object,
	  fullView: _propTypes2.default.bool,
	  group: _propTypes2.default.string,
	  items: _propTypes2.default.array,
	  inputItems: _propTypes2.default.array,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  createRiderItems: _propTypes2.default.func,
	  cloneRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  deleteRiderItemGroup: _propTypes2.default.func,
	  members: _propTypes2.default.array,
	  createStageElement: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func
	};
	
	Table.defaultProps = {
	  view: {},
	  fullView: false,
	  group: '',
	  items: [],
	  inputItems: [],
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  createRiderItems: function createRiderItems() {},
	  cloneRiderItem: function cloneRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  deleteRiderItemGroup: function deleteRiderItemGroup() {},
	  members: [],
	  createStageElement: function createStageElement() {},
	  getSearchResults: function getSearchResults() {}
	};
	
	exports.default = Table;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _restricted = __webpack_require__(94);
	
	var _restricted2 = _interopRequireDefault(_restricted);
	
	var _list = __webpack_require__(314);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _table = __webpack_require__(318);
	
	var _table2 = _interopRequireDefault(_table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Output = function (_Component) {
	  _inherits(Output, _Component);
	
	  function Output(props) {
	    _classCallCheck(this, Output);
	
	    var _this = _possibleConstructorReturn(this, (Output.__proto__ || Object.getPrototypeOf(Output)).call(this, props));
	
	    _this.state = {
	      listView: false,
	      fullView: false
	    };
	    return _this;
	  }
	
	  _createClass(Output, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var rider = nextProps.rider;
	
	
	      if (rider !== this.props.rider) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          rider = _props.rider,
	          stageElements = _props.stageElements;
	      var _state = this.state,
	          listView = _state.listView,
	          fullView = _state.fullView;
	
	
	      var className = (0, _classnames2.default)({
	        'output': true,
	        'output-list': listView === true,
	        'output-table': listView === false,
	        'section--full': fullView
	      });
	
	      var enlargeButtonClassName = (0, _classnames2.default)({
	        'button--success': true,
	        'enlarge-button': true,
	        'enlarge-button--active': fullView === true
	      });
	
	      return _react2.default.createElement(
	        'section',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: 'section-head' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Output ',
	            listView ? 'List' : 'Table'
	          ),
	          !listView ? _react2.default.createElement('button', { className: enlargeButtonClassName, onClick: function onClick() {
	              return _this2.setState({ fullView: !fullView });
	            } }) : null
	        ),
	        view.loggedIn ? listView ? _react2.default.createElement(_list2.default, {
	          group: this.props.group,
	          items: rider.items,
	          itemGroups: rider.itemGroups,
	          addRiderItem: this.props.addRiderItem,
	          removeRiderItem: this.props.removeRiderItem,
	          createRiderItem: this.props.createRiderItem,
	          editRiderItem: this.props.editRiderItem,
	          moveRiderItem: this.props.moveRiderItem,
	          stageElements: stageElements,
	          createStageElement: this.props.createStageElement,
	          getSearchResults: this.props.getSearchResults }) : _react2.default.createElement(_table2.default, {
	          view: view,
	          editable: true,
	          fullView: fullView,
	          group: this.props.group,
	          columns: rider.columns,
	          moveRiderColumn: this.props.moveRiderColumn,
	          items: rider.items,
	          itemGroups: rider.itemGroups,
	          inputItems: rider.input,
	          addRiderItem: this.props.addRiderItem,
	          removeRiderItem: this.props.removeRiderItem,
	          createRiderItem: this.props.createRiderItem,
	          createRiderItems: this.props.createRiderItems,
	          cloneRiderItem: this.props.cloneRiderItem,
	          editRiderItem: this.props.editRiderItem,
	          deleteRiderItem: this.props.deleteRiderItem,
	          deleteRiderItemGroup: this.props.deleteRiderItemGroup,
	          moveRiderItem: this.props.moveRiderItem,
	          members: rider.members,
	          stageElements: stageElements,
	          createStageElement: this.props.createStageElement,
	          getSearchResults: this.props.getSearchResults }) : _react2.default.createElement(_restricted2.default, {
	          section: 'Output List',
	          setModal: this.props.setModal })
	      );
	    }
	  }]);
	
	  return Output;
	}(_react.Component);
	
	Output.propTypes = {
	  view: _propTypes2.default.object,
	  group: _propTypes2.default.string,
	  rider: _propTypes2.default.object,
	  moveRiderColumn: _propTypes2.default.func,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  createRiderItems: _propTypes2.default.func,
	  cloneRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  deleteRiderItemGroup: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  createStageElement: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	Output.defaultProps = {
	  view: {},
	  group: '',
	  rider: { isFetching: true },
	  moveRiderColumn: function moveRiderColumn() {},
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  createRiderItems: function createRiderItems() {},
	  cloneRiderItem: function cloneRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  deleteRiderItemGroup: function deleteRiderItemGroup() {},
	  stageElements: {},
	  createStageElement: function createStageElement() {},
	  getSearchResults: function getSearchResults() {},
	  setModal: function setModal() {}
	};
	
	exports.default = Output;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _reactAutosizeTextarea = __webpack_require__(128);
	
	var _reactAutosizeTextarea2 = _interopRequireDefault(_reactAutosizeTextarea);
	
	var _switch = __webpack_require__(57);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import TextareaAutosize from 'react-textarea-autosize'
	
	
	var ListItem = function (_Component) {
	  _inherits(ListItem, _Component);
	
	  function ListItem(props) {
	    _classCallCheck(this, ListItem);
	
	    var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));
	
	    _this.state = {
	      item: undefined,
	      required: false,
	      showDropdown: false
	    };
	    return _this;
	  }
	
	  _createClass(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          item = _props.item,
	          required = _props.required;
	
	
	      this.setState({ item: item, required: required });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var item = nextProps.item,
	          required = nextProps.required;
	
	
	      if (this.props.item !== item) this.setState({ item: item });
	      if (this.props.required !== required) this.setState({ required: required });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var item = nextProps.item,
	          required = nextProps.required;
	
	
	      if (item !== this.props.item) return true;
	      if (required !== this.props.required) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown(item) {
	      var _this2 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  return _this2.props.deleteRiderItem(item.id);
	                });
	              } },
	            'Remove requirement'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderEmptyListItem',
	    value: function renderEmptyListItem(item) {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'list-item list-item--empty' },
	        _react2.default.createElement('div', { className: 'list-item-handle' }),
	        _react2.default.createElement('div', { className: 'riek-escape', onClick: function onClick() {
	            if (!item.content) _this3.props.removeRiderItem(item);
	          } }),
	        _react2.default.createElement(_reactAutosizeTextarea2.default, {
	          autoFocus: true,
	          value: item.content || '',
	          className: 'textarea-autosize',
	          onChange: function onChange(e) {
	            _this3.setState({
	              item: (0, _immutabilityHelper2.default)(item, {
	                content: { $set: e.target.value }
	              })
	            });
	          },
	          onBlur: function onBlur() {
	            if (item.content) _this3.props.createRiderItem(Object.assign({}, item, { type: 'requirement', content: item.content }));
	          } })
	      );
	    }
	  }, {
	    key: 'renderListItem',
	    value: function renderListItem(item) {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          view = _props2.view,
	          required = _props2.required;
	
	
	      var textareaClassName = (0, _classnames2.default)({
	        'textarea-autosize': true,
	        'placeholder': !item.content
	      });
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Draggable,
	        { draggableId: item.id, isDragDisabled: !view.editable, type: 'requirement' },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'list-item' },
	            view.editable ? _this4.renderDropdown(item) : null,
	            _react2.default.createElement(
	              'div',
	              { className: 'list-item--draggable',
	                ref: provided.innerRef,
	                style: provided.draggableStyle },
	              view.editable ? _react2.default.createElement('div', Object.assign({ className: 'list-item-handle' }, provided.dragHandleProps)) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'list-item-content' },
	                view.editable ? _react2.default.createElement(_reactAutosizeTextarea2.default, {
	                  value: item.content !== null ? item.content : 'Please click to add requirement',
	                  className: textareaClassName,
	                  onClick: function onClick() {
	                    if (item.content === null) {
	                      _this4.setState({
	                        item: (0, _immutabilityHelper2.default)(item, {
	                          content: { $set: '' }
	                        })
	                      });
	                    }
	                  },
	                  onChange: function onChange(e) {
	                    _this4.setState({
	                      item: (0, _immutabilityHelper2.default)(item, {
	                        content: { $set: e.target.value }
	                      })
	                    });
	                  },
	                  onBlur: function onBlur() {
	                    if (item.content) {
	                      _this4.props.editRiderItem({ id: item.id, content: item.content });
	                    } else {
	                      _this4.setState({
	                        item: (0, _immutabilityHelper2.default)(item, {
	                          content: { $set: null }
	                        })
	                      });
	                    }
	                  } }) : _react2.default.createElement(
	                  'div',
	                  { className: textareaClassName },
	                  item.content
	                ),
	                view.editable ? _react2.default.createElement(_switch2.default, {
	                  required: required,
	                  toggleSwitch: function toggleSwitch(required) {
	                    return _this4.setState({ required: required }, function () {
	                      return _this4.props.editRiderItem({ id: item.id, required: required });
	                    });
	                  } }) : item.required ? _react2.default.createElement(
	                  'div',
	                  null,
	                  'Required'
	                ) : _react2.default.createElement(
	                  'div',
	                  null,
	                  'Band brings'
	                )
	              )
	            ),
	            provided.placeholder
	          );
	        }
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var item = this.state.item;
	
	
	      return item.id !== undefined ? this.renderListItem(item) : this.renderEmptyListItem(item);
	    }
	  }]);
	
	  return ListItem;
	}(_react.Component);
	
	ListItem.propTypes = {
	  view: _propTypes2.default.object,
	  item: _propTypes2.default.object,
	  required: _propTypes2.default.bool,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func
	};
	
	ListItem.defaultProps = {
	  view: {},
	  item: {},
	  required: false,
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {}
	};
	
	exports.default = ListItem;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _restricted = __webpack_require__(94);
	
	var _restricted2 = _interopRequireDefault(_restricted);
	
	var _list = __webpack_require__(168);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Requirements = function (_Component) {
	  _inherits(Requirements, _Component);
	
	  function Requirements() {
	    _classCallCheck(this, Requirements);
	
	    return _possibleConstructorReturn(this, (Requirements.__proto__ || Object.getPrototypeOf(Requirements)).apply(this, arguments));
	  }
	
	  _createClass(Requirements, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          view = _props.view,
	          rider = _props.rider;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'requirements' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section-head' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Requirements'
	          )
	        ),
	        view.loggedIn ? _react2.default.createElement(
	          'div',
	          { className: 'subsection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section-head' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Technical Requirements'
	            )
	          ),
	          _react2.default.createElement(_list2.default, {
	            view: view,
	            requirements: {
	              group: 'tech_requirements',
	              class: 'requirement',
	              title: 'Technical requirement'
	            },
	            items: rider.tech_requirements,
	            addRiderItem: this.props.addRiderItem,
	            removeRiderItem: this.props.removeRiderItem,
	            createRiderItem: this.props.createRiderItem,
	            editRiderItem: this.props.editRiderItem,
	            moveRiderItem: this.props.moveRiderItem,
	            deleteRiderItem: this.props.deleteRiderItem })
	        ) : _react2.default.createElement(_restricted2.default, {
	          section: 'Requirements',
	          setModal: this.props.setModal }),
	        view.loggedIn ? _react2.default.createElement(
	          'div',
	          { className: 'subsection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section-head' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Non-Technical Requirements'
	            )
	          ),
	          _react2.default.createElement(_list2.default, {
	            view: view,
	            requirements: {
	              group: 'non_tech_requirements',
	              class: 'requirement',
	              title: 'Non-technical requirement'
	            },
	            items: rider.non_tech_requirements,
	            addRiderItem: this.props.addRiderItem,
	            removeRiderItem: this.props.removeRiderItem,
	            createRiderItem: this.props.createRiderItem,
	            editRiderItem: this.props.editRiderItem,
	            moveRiderItem: this.props.moveRiderItem,
	            deleteRiderItem: this.props.deleteRiderItem })
	        ) : null
	      );
	    }
	  }]);
	
	  return Requirements;
	}(_react.Component);
	
	Requirements.propTypes = {
	  view: _propTypes2.default.object,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	Requirements.defaultProps = {
	  view: {},
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  setModal: function setModal() {}
	};
	
	exports.default = Requirements;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RiderSharing = function (_Component) {
	  _inherits(RiderSharing, _Component);
	
	  function RiderSharing(props) {
	    _classCallCheck(this, RiderSharing);
	
	    var _this = _possibleConstructorReturn(this, (RiderSharing.__proto__ || Object.getPrototypeOf(RiderSharing)).call(this, props));
	
	    _this.state = {
	      showDropdown: false
	    };
	    return _this;
	  }
	
	  _createClass(RiderSharing, [{
	    key: 'renderDropdown',
	    value: function renderDropdown(share) {
	      var _this2 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  return _this2.props.removeRiderShare(share.email);
	                });
	              } },
	            'Remove share'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var share = this.props.share;
	
	
	      return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'collaborator', 'data-name': share.email, onClick: function onClick() {
	              return _this3.setState({ showDropdown: true });
	            } },
	          share.email.substring(0, 2)
	        ),
	        this.renderDropdown(share)
	      );
	    }
	  }]);
	
	  return RiderSharing;
	}(_react.Component);
	
	RiderSharing.propTypes = {
	  share: _propTypes2.default.object,
	  removeRiderShare: _propTypes2.default.func
	};
	
	RiderSharing.defaultProps = {
	  share: {},
	  removeRiderShare: function removeRiderShare() {}
	};
	
	exports.default = RiderSharing;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SharingForm = function (_Component) {
	  _inherits(SharingForm, _Component);
	
	  function SharingForm(props) {
	    _classCallCheck(this, SharingForm);
	
	    var _this = _possibleConstructorReturn(this, (SharingForm.__proto__ || Object.getPrototypeOf(SharingForm)).call(this, props));
	
	    _this.state = {
	      email: ''
	    };
	
	    _this.email = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(SharingForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.email.current.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var email = this.state.email;
	
	
	      var buttonClassName = (0, _classnames2.default)({
	        'button--primary': true,
	        'button--success': email.indexOf('@') !== -1
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sharing-form' },
	        _react2.default.createElement('input', { ref: this.email,
	          type: 'text',
	          className: 'input--light',
	          value: email || '',
	          placeholder: 'Band member\'s email',
	          onChange: function onChange(e) {
	            return _this2.setState({ email: e.target.value });
	          } }),
	        _react2.default.createElement(
	          'button',
	          { className: buttonClassName, onClick: function onClick() {
	              _this2.props.shareRider(_this2.state.email);
	            } },
	          'Invite'
	        )
	      );
	    }
	  }]);
	
	  return SharingForm;
	}(_react.Component);
	
	SharingForm.propTypes = {
	  shareRider: _propTypes2.default.func
	};
	
	SharingForm.defaultProps = {
	  shareRider: function shareRider() {}
	};
	
	exports.default = SharingForm;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _share = __webpack_require__(322);
	
	var _share2 = _interopRequireDefault(_share);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RiderSharing = function (_Component) {
	  _inherits(RiderSharing, _Component);
	
	  function RiderSharing() {
	    _classCallCheck(this, RiderSharing);
	
	    return _possibleConstructorReturn(this, (RiderSharing.__proto__ || Object.getPrototypeOf(RiderSharing)).apply(this, arguments));
	  }
	
	  _createClass(RiderSharing, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var shares = this.props.shares;
	
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'sharing' },
	        shares.map(function (share, index) {
	          return _react2.default.createElement(_share2.default, { key: index,
	            share: share,
	            removeRiderShare: _this2.props.removeRiderShare });
	        })
	      );
	    }
	  }]);
	
	  return RiderSharing;
	}(_react.Component);
	
	RiderSharing.propTypes = {
	  shares: _propTypes2.default.array,
	  removeRiderShare: _propTypes2.default.func
	};
	
	RiderSharing.defaultProps = {
	  shares: [],
	  removeRiderShare: function removeRiderShare() {}
	};
	
	exports.default = RiderSharing;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Rotate = function (_Component) {
	  _inherits(Rotate, _Component);
	
	  function Rotate(props) {
	    _classCallCheck(this, Rotate);
	
	    var _this = _possibleConstructorReturn(this, (Rotate.__proto__ || Object.getPrototypeOf(Rotate)).call(this, props));
	
	    _this.handleMouseMove = function () {
	      if (_this.state.isResizing) {
	        var delta_x_global = event.movementX;
	        var delta_y_global = event.movementY;
	
	        _this.onResizing({ x: delta_x_global, y: delta_y_global });
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      var isResizing = _this.state.isResizing;
	
	
	      if (isResizing) _this.setState({ isResizing: false }, function () {
	        _this.props.editRiderStageplanItem();
	        _this.props.onResizeEnd();
	      });
	    };
	
	    _this.onResizing = function (dimensions) {
	      var attributes = _this.props.attributes;
	
	
	      var currentRotation = -attributes.radians;
	
	      var currentLocalTopLeft = {
	        top: -attributes.height / 2,
	        left: -attributes.width / 2
	      };
	
	      var currentRotatedTopLeft = {
	        left: currentLocalTopLeft.left * Math.cos(currentRotation) - currentLocalTopLeft.top * Math.sin(currentRotation),
	        top: currentLocalTopLeft.left * Math.sin(currentRotation) + currentLocalTopLeft.top * Math.cos(currentRotation)
	      };
	
	      var currentTopLeftDelta = {
	        x: currentRotatedTopLeft.left - currentLocalTopLeft.left,
	        y: currentRotatedTopLeft.top - currentLocalTopLeft.top
	      };
	
	      var currentGlobalRotatedTopLeft = {
	        top: attributes.y + currentTopLeftDelta.y,
	        left: attributes.x + currentTopLeftDelta.x
	      };
	
	      var delta_mouse = Math.sqrt(Math.pow(dimensions.x, 2) + Math.pow(dimensions.y, 2));
	
	      var theta_global = Math.atan2(dimensions.y, dimensions.x);
	
	      var theta_local = currentRotation - theta_global;
	
	      var delta_x_local = Math.cos(theta_local) * delta_mouse;
	      var delta_y_local = -Math.sin(theta_local) * delta_mouse;
	
	      var newWidth = attributes.width + delta_x_local;
	      var newHeight = attributes.height + delta_y_local;
	
	      var newLocalTopLeft = {
	        top: -newHeight / 2,
	        left: -newWidth / 2
	      };
	
	      var newRotatedTopLeft = {
	        top: newLocalTopLeft.left * Math.sin(currentRotation) + newLocalTopLeft.top * Math.cos(currentRotation),
	        left: newLocalTopLeft.left * Math.cos(currentRotation) - newLocalTopLeft.top * Math.sin(currentRotation)
	      };
	
	      var newTopLeftDelta = {
	        x: newRotatedTopLeft.left - newLocalTopLeft.left,
	        y: newRotatedTopLeft.top - newLocalTopLeft.top
	      };
	
	      var newGlobalTopLeft = {
	        top: currentGlobalRotatedTopLeft.top - newTopLeftDelta.y,
	        left: currentGlobalRotatedTopLeft.left - newTopLeftDelta.x
	      };
	
	      _this.props.onResize({
	        y: newGlobalTopLeft.top,
	        x: newGlobalTopLeft.left,
	        pxWidth: newWidth,
	        pxHeight: newHeight
	      });
	    };
	
	    _this.state = {
	      isResizing: false
	    };
	    return _this;
	  }
	
	  _createClass(Rotate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('mousemove', this.handleMouseMove);
	      window.addEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('mousemove', this.handleMouseMove);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className },
	        _react2.default.createElement('div', { className: 'resize-handle', onMouseDown: function onMouseDown(e) {
	            return _this2.setState({ isResizing: true }, _this2.props.onResizeStart());
	          } })
	      );
	    }
	  }]);
	
	  return Rotate;
	}(_react.Component);
	
	exports.default = Rotate;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Rotate = function (_Component) {
	  _inherits(Rotate, _Component);
	
	  function Rotate(props) {
	    _classCallCheck(this, Rotate);
	
	    var _this = _possibleConstructorReturn(this, (Rotate.__proto__ || Object.getPrototypeOf(Rotate)).call(this, props));
	
	    _this.handleMouseMove = function () {
	      if (_this.state.isRotating) {
	        var rotation = _this.calculateDegrees(_this.getRelativeCoordinates(event));
	        _this.onRotating({ degrees: rotation.degrees, radians: rotation.radians });
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      var isRotating = _this.state.isRotating;
	
	
	      if (isRotating) _this.setState({ isRotating: false }, function () {
	        _this.props.editRiderStageplanItem();
	        _this.props.onRotateEnd();
	      });
	    };
	
	    _this.onRotating = function (rotation) {
	      _this.props.onRotate(rotation);
	    };
	
	    _this.state = {
	      isRotating: false
	    };
	    return _this;
	  }
	
	  _createClass(Rotate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('mousemove', this.handleMouseMove);
	      window.addEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('mousemove', this.handleMouseMove);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'getRelativeCoordinates',
	    value: function getRelativeCoordinates(event) {
	      var clientRect = _reactDom2.default.findDOMNode(this).getBoundingClientRect();
	
	      return {
	        mousex: event.clientX - clientRect.left - clientRect.width / 2,
	        mousey: event.clientY - clientRect.top - clientRect.height / 2
	      };
	    }
	  }, {
	    key: 'calculateDegrees',
	    value: function calculateDegrees(coordinates) {
	      var radians = Math.atan2(coordinates.mousex, coordinates.mousey);
	      var degrees = radians * (180 / Math.PI) * -1;
	
	      return { degrees: degrees, radians: radians };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className },
	        _react2.default.createElement('div', { className: 'rotate-handle', onMouseDown: function onMouseDown(e) {
	            return _this2.setState({ isRotating: true }, _this2.props.onRotateStart());
	          } })
	      );
	    }
	  }]);
	
	  return Rotate;
	}(_react.Component);
	
	exports.default = Rotate;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _classnames3 = __webpack_require__(3);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _reactRnd = __webpack_require__(567);
	
	var _reactRnd2 = _interopRequireDefault(_reactRnd);
	
	var _riek = __webpack_require__(46);
	
	var _functions = __webpack_require__(6);
	
	var _rotate = __webpack_require__(326);
	
	var _rotate2 = _interopRequireDefault(_rotate);
	
	var _resize = __webpack_require__(325);
	
	var _resize2 = _interopRequireDefault(_resize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageplanItem = function (_Component) {
	  _inherits(StageplanItem, _Component);
	
	  function StageplanItem(props) {
	    _classCallCheck(this, StageplanItem);
	
	    var _this = _possibleConstructorReturn(this, (StageplanItem.__proto__ || Object.getPrototypeOf(StageplanItem)).call(this, props));
	
	    _this.onDragStop = function (e, d, item) {
	      item = (0, _immutabilityHelper2.default)(item, {
	        x: { $set: d.x },
	        y: { $set: d.y }
	      });
	
	      _this.setState({ item: item }, function () {
	        if (item.id) _this.editStageplanItem(item);
	      });
	    };
	
	    _this.state = {
	      item: undefined,
	      showControlHandles: false,
	      isDragging: false,
	      isRotating: false,
	      isResizing: false
	    };
	
	    _this.dragItem = _react2.default.createRef();
	    _this.input = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(StageplanItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var canvas = this.props.canvas;
	      var item = this.props.item;
	
	
	      item = this.convertPercentageToPixels(item, canvas);
	      this.setState({ item: item });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var item = nextProps.item,
	          canvas = nextProps.canvas;
	
	
	      if (item !== this.props.item || canvas !== this.props.canvas) {
	        var convertedItem = this.convertPercentageToPixels(item, canvas);
	        this.setState({ item: convertedItem });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var item = nextProps.item,
	          itemIsFocused = nextProps.itemIsFocused,
	          canvas = nextProps.canvas;
	
	
	      if (itemIsFocused !== this.props.itemIsFocused) return true;
	      if (item !== this.props.item) return true;
	      if (canvas !== this.props.canvas) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var isDragging = nextState.isDragging;
	
	
	      if (isDragging !== this.state.isDragging) this.props.setDragState(isDragging);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var input = this.input.current;
	
	      if (input && !input.props.value) input.startEditing();
	    }
	  }, {
	    key: 'convertPercentageToPixels',
	    value: function convertPercentageToPixels(item, canvas) {
	      var pxWidth = item.width * canvas.ratio;
	      var pxHeight = item.height * canvas.ratio;
	
	      item = (0, _immutabilityHelper2.default)(item, {
	        pxWidth: { $set: pxWidth },
	        pxHeight: { $set: pxHeight },
	        x: { $set: canvas.width * (item.left / 100) - pxWidth / 2 },
	        y: { $set: canvas.height * (item.top / 100) - pxHeight / 2 }
	      });
	
	      return item;
	    }
	  }, {
	    key: 'convertPixelsToPercentage',
	    value: function convertPixelsToPercentage(item, canvas) {
	      item = (0, _immutabilityHelper2.default)(item, {
	        width: { $set: item.pxWidth / canvas.ratio },
	        height: { $set: item.pxHeight / canvas.ratio },
	        top: { $set: (item.y + item.pxHeight / 2) / canvas.height * 100 },
	        left: { $set: (item.x + item.pxWidth / 2) / canvas.width * 100 }
	      });
	
	      return item;
	    }
	  }, {
	    key: 'createStageplanItem',
	    value: function createStageplanItem(item) {
	      var canvas = this.props.canvas;
	
	
	      item = this.convertPixelsToPercentage(item, canvas);
	      this.props.createRiderStageplanItem(item);
	    }
	  }, {
	    key: 'editStageplanItem',
	    value: function editStageplanItem(item) {
	      var canvas = this.props.canvas;
	
	
	      item = this.convertPixelsToPercentage(item, canvas);
	      this.props.editRiderStageplanItem(item);
	    }
	  }, {
	    key: 'renderStageplanItem',
	    value: function renderStageplanItem() {
	      var _classnames,
	          _this2 = this;
	
	      var _props = this.props,
	          itemIsFocused = _props.itemIsFocused,
	          view = _props.view,
	          fontSize = _props.fontSize;
	      var _state = this.state,
	          item = _state.item,
	          showControlHandles = _state.showControlHandles,
	          isDragging = _state.isDragging,
	          isRotating = _state.isRotating,
	          isResizing = _state.isResizing;
	      var pxWidth = item.pxWidth,
	          pxHeight = item.pxHeight,
	          x = item.x,
	          y = item.y;
	
	
	      var colorNumber = (0, _functions.calculateColorNumber)(item.color, 5);
	      var shape = item.shape || item.params && item.params.shape;
	
	      var className = (0, _classnames4.default)((_classnames = {
	        'stageplan-item': true
	      }, _defineProperty(_classnames, 'stageplan-item--color-' + colorNumber, item.color !== null), _defineProperty(_classnames, 'stageplan-item--focus', itemIsFocused === true), _defineProperty(_classnames, 'stageplan-item--dragging', isDragging || isRotating || isResizing), _defineProperty(_classnames, 'stageplan-item--hidden', item.hidden), _defineProperty(_classnames, 'stageplan-item--shape-' + shape, shape), _classnames));
	
	      var rotateClassName = (0, _classnames4.default)({
	        'resize': true,
	        'rotate--visible': showControlHandles && !isRotating && !isResizing || isRotating
	      });
	
	      var resizeClassName = (0, _classnames4.default)({
	        'resize': true,
	        'resize--visible': showControlHandles && !isRotating && !isResizing || isResizing
	      });
	
	      return _react2.default.createElement(
	        _reactRnd2.default,
	        {
	          size: { width: pxWidth, height: pxHeight },
	          position: { x: x, y: y },
	          enableResizing: false,
	          disableDragging: !view.editable,
	          bounds: '.stageplan-droppable-area',
	          cancel: '.rotate-handle, .resize-handle',
	          dragHandleClassName: '.stageplan-item',
	          onDragStart: function onDragStart(e) {
	            return view.editable ? _this2.setState({ isDragging: true }) : null;
	          },
	          onDragStop: function onDragStop(e, d) {
	            if (view.editable) {
	              if (e.target.className === 'stageplan-remove-item-overlay') {
	                _this2.setState({
	                  isDragging: false,
	                  item: (0, _immutabilityHelper2.default)(item, {
	                    hidden: { $set: true // https://github.com/bokuweb/react-rnd/issues/216
	                    } })
	                }, function () {
	                  return _this2.props.deleteRiderStageplanItem(item.id, item.index);
	                });
	              } else {
	                _this2.setState({ isDragging: false }, function () {
	                  return _this2.onDragStop(e, d, item);
	                });
	              }
	            }
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: className, style: { transform: 'rotateZ(' + item.rotation.degrees + 'deg)' },
	            onMouseEnter: function onMouseEnter() {
	              return view.editable ? _this2.setState({ showControlHandles: true }) : null;
	            },
	            onMouseLeave: function onMouseLeave() {
	              return view.editable ? _this2.setState({ showControlHandles: false }) : null;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'title', style: { fontSize: fontSize } },
	            item.channel ? _react2.default.createElement(
	              'span',
	              { className: 'channel', style: { fontSize: fontSize * 1.1 } },
	              item.channel
	            ) : null,
	            item.title
	          ),
	          view.editable ? _react2.default.createElement(_rotate2.default, { className: rotateClassName,
	            onRotateStart: function onRotateStart() {
	              return _this2.setState({ isRotating: true });
	            },
	            onRotateEnd: function onRotateEnd() {
	              return _this2.setState({ isRotating: false });
	            },
	            onRotate: function onRotate(rotation) {
	              _this2.setState({
	                item: (0, _immutabilityHelper2.default)(item, {
	                  $merge: { rotation: rotation }
	                })
	              });
	            },
	            editRiderStageplanItem: function editRiderStageplanItem() {
	              return _this2.editStageplanItem(item);
	            } }) : null,
	          view.editable ? _react2.default.createElement(_resize2.default, { className: resizeClassName,
	            attributes: {
	              x: item.x,
	              y: item.y,
	              width: item.pxWidth,
	              height: item.pxHeight,
	              radians: item.rotation.radians
	            },
	            onResizeStart: function onResizeStart() {
	              return _this2.setState({ isResizing: true });
	            },
	            onResizeEnd: function onResizeEnd() {
	              return _this2.setState({ isResizing: false });
	            },
	            onResize: function onResize(attributes) {
	              _this2.setState({
	                item: (0, _immutabilityHelper2.default)(item, {
	                  $merge: attributes
	                })
	              });
	            },
	            editRiderStageplanItem: function editRiderStageplanItem() {
	              return _this2.editStageplanItem(item);
	            } }) : null
	        )
	      );
	    }
	  }, {
	    key: 'renderEmptyStageplanItem',
	    value: function renderEmptyStageplanItem() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          view = _props2.view,
	          canvas = _props2.canvas,
	          fontSize = _props2.fontSize;
	      var _state2 = this.state,
	          item = _state2.item,
	          isDragging = _state2.isDragging;
	      var pxWidth = item.pxWidth,
	          pxHeight = item.pxHeight,
	          x = item.x,
	          y = item.y;
	
	
	      var shape = item.shape || item.params && item.params.shape;
	
	      var className = (0, _classnames4.default)(_defineProperty({
	        'stageplan-item': true,
	        'stageplan-item--focus': !item.title,
	        'stageplan-item--hidden': item.hidden,
	        'stageplan-item--dragging': isDragging
	      }, 'stageplan-item--shape-' + shape, shape));
	
	      if (view.editable !== true) return null;
	
	      return _react2.default.createElement(
	        _reactRnd2.default,
	        { ref: this.dragItem,
	          size: { width: pxWidth, height: pxHeight },
	          position: { x: x, y: y },
	          enableResizing: false,
	          bounds: '.stageplan-droppable-area',
	          cancel: '.rotate-handle, .resize-handle',
	          dragHandleClassName: '.stageplan-item',
	          onDragStart: function onDragStart(e) {
	            return _this3.setState({ isDragging: true });
	          },
	          onDragStop: function onDragStop(e, d) {
	            if (e.target.className === 'stageplan-remove-item-overlay') {
	              _this3.setState({
	                isDragging: false,
	                item: (0, _immutabilityHelper2.default)(item, {
	                  hidden: { $set: true // https://github.com/bokuweb/react-rnd/issues/216
	                  } })
	              }, function () {
	                return setTimeout(function () {
	                  return _this3.props.removeRiderStageplanItem();
	                }, 1);
	              }); // https://github.com/bokuweb/react-rnd/issues/216
	            } else {
	              _this3.setState({ isDragging: false }, function () {
	                return _this3.onDragStop(e, d, item);
	              });
	            }
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: className, style: { transform: 'rotateZ(' + item.rotation.degrees + 'deg)' } },
	          item.title ? _react2.default.createElement(
	            'div',
	            { className: 'title', style: { fontSize: fontSize } },
	            item.channel ? _react2.default.createElement(
	              'span',
	              { className: 'channel', style: { fontSize: fontSize * 1.1 } },
	              item.channel
	            ) : null,
	            item.title
	          ) : _react2.default.createElement(_riek.RIEInput, { ref: this.input,
	            value: item.title || '',
	            propName: 'title',
	            className: 'riek title',
	            defaultProps: { style: { fontSize: fontSize } },
	            editProps: { style: { fontSize: fontSize } },
	            change: function change(_ref) {
	              var title = _ref.title;
	              return _this3.createStageplanItem(Object.assign({}, item, { title: title }));
	            } })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var item = this.props.item;
	
	
	      return item.id !== null ? this.renderStageplanItem() : this.renderEmptyStageplanItem();
	    }
	  }]);
	
	  return StageplanItem;
	}(_react.Component);
	
	StageplanItem.propTypes = {
	  view: _propTypes2.default.object,
	  item: _propTypes2.default.object,
	  itemIsFocused: _propTypes2.default.bool,
	  canvas: _propTypes2.default.object,
	  fontSize: _propTypes2.default.number,
	  setDragState: _propTypes2.default.func,
	  removeRiderStageplanItem: _propTypes2.default.func,
	  createRiderStageplanItem: _propTypes2.default.func,
	  editRiderStageplanItem: _propTypes2.default.func,
	  deleteRiderStageplanItem: _propTypes2.default.func
	};
	
	StageplanItem.defaultProps = {
	  view: {},
	  item: {},
	  itemIsFocused: false,
	  canvas: {
	    ratio: 1,
	    width: undefined,
	    height: undefined
	  },
	  fontSize: 12,
	  setDragState: function setDragState() {},
	  removeRiderStageplanItem: function removeRiderStageplanItem() {},
	  createRiderStageplanItem: function createRiderStageplanItem() {},
	  editRiderStageplanItem: function editRiderStageplanItem() {},
	  deleteRiderStageplanItem: function deleteRiderStageplanItem() {}
	};
	
	exports.default = StageplanItem;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _stageplanSidebarItem = __webpack_require__(169);
	
	var _stageplanSidebarItem2 = _interopRequireDefault(_stageplanSidebarItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageplanSidebarGroup = function (_Component) {
	  _inherits(StageplanSidebarGroup, _Component);
	
	  function StageplanSidebarGroup() {
	    _classCallCheck(this, StageplanSidebarGroup);
	
	    return _possibleConstructorReturn(this, (StageplanSidebarGroup.__proto__ || Object.getPrototypeOf(StageplanSidebarGroup)).apply(this, arguments));
	  }
	
	  _createClass(StageplanSidebarGroup, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          item = _props.item,
	          itemIndex = _props.itemIndex;
	      var children = item.children;
	
	
	      return _react2.default.createElement(
	        'li',
	        { className: 'stageplan-sidebar-group' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          item.title
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          children.length > 0 ? children.map(function (child, index) {
	            return item.id !== undefined ? _react2.default.createElement(_stageplanSidebarItem2.default, { key: child.id || index,
	              item: child,
	              itemIndex: index,
	              parentItemIndex: itemIndex,
	              existingItem: child.stageplan_item,
	              fontSize: _this2.props.fontSize,
	              hideAnimation: _this2.props.hideAnimation,
	              setDragStartOffset: _this2.props.setDragStartOffset,
	              setRiderStageplanItemFocus: _this2.props.setRiderStageplanItemFocus,
	              createRiderStageplanItem: _this2.props.createRiderStageplanItem }) : null;
	          }) : null
	        )
	      );
	    }
	  }]);
	
	  return StageplanSidebarGroup;
	}(_react.Component);
	
	StageplanSidebarGroup.propTypes = {
	  item: _propTypes2.default.object,
	  itemIndex: _propTypes2.default.number,
	  fontSize: _propTypes2.default.number,
	  hideAnimation: _propTypes2.default.bool,
	  setDragStartOffset: _propTypes2.default.func,
	  setRiderStageplanItemFocus: _propTypes2.default.func,
	  createRiderStageplanItem: _propTypes2.default.func
	};
	
	StageplanSidebarGroup.defaultProps = {
	  item: {},
	  itemIndex: undefined,
	  fontSize: 12,
	  hideAnimation: false,
	  setDragStartOffset: function setDragStartOffset() {},
	  setRiderStageplanItemFocus: function setRiderStageplanItemFocus() {},
	  createRiderStageplanItem: function createRiderStageplanItem() {}
	};
	
	exports.default = StageplanSidebarGroup;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _functions = __webpack_require__(6);
	
	var _stageplanSidebarGroup = __webpack_require__(328);
	
	var _stageplanSidebarGroup2 = _interopRequireDefault(_stageplanSidebarGroup);
	
	var _stageplanSidebarItem = __webpack_require__(169);
	
	var _stageplanSidebarItem2 = _interopRequireDefault(_stageplanSidebarItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageplanSidebar = function (_Component) {
	  _inherits(StageplanSidebar, _Component);
	
	  function StageplanSidebar(props) {
	    _classCallCheck(this, StageplanSidebar);
	
	    var _this = _possibleConstructorReturn(this, (StageplanSidebar.__proto__ || Object.getPrototypeOf(StageplanSidebar)).call(this, props));
	
	    _this.state = {
	      selectedCategory: null
	    };
	    return _this;
	  }
	
	  _createClass(StageplanSidebar, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          isDragging = _props.isDragging;
	      var selectedCategory = this.state.selectedCategory;
	
	
	      return _react2.default.createElement(
	        _reactBeautifulDnd.Droppable,
	        { droppableId: selectedCategory || 'sidebar', type: 'stageplan' },
	        function (provided, snapshot) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'stageplan-sidebar', style: style,
	              ref: provided.innerRef },
	            selectedCategory ? _react2.default.createElement(
	              'h5',
	              null,
	              'Add ',
	              selectedCategory,
	              ' to stage plan'
	            ) : _react2.default.createElement(
	              'h5',
	              null,
	              'Select a category'
	            ),
	            selectedCategory ? _react2.default.createElement(
	              'ul',
	              { style: { maxHeight: style.height - 50 + 'px' } },
	              _react2.default.createElement(
	                'li',
	                { className: 'stageplan-sidebar-link stageplan-sidebar-link--sticky' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'back', onClick: function onClick() {
	                      return _this2.setState({ selectedCategory: '' });
	                    } },
	                  'Back to categories'
	                )
	              ),
	              _this2.props.categories[selectedCategory].map(function (item, index) {
	                if (item.id === undefined) return null;
	
	                if (selectedCategory === 'misc' && item.children) {
	                  return _react2.default.createElement(_stageplanSidebarGroup2.default, { key: item.id || index,
	                    item: item,
	                    itemIndex: index,
	                    fontSize: _this2.props.fontSize,
	                    hideAnimation: _this2.props.hideAnimation,
	                    setDragStartOffset: _this2.props.setDragStartOffset,
	                    setRiderStageplanItemFocus: _this2.props.setRiderStageplanItemFocus,
	                    createRiderStageplanItem: _this2.props.createRiderStageplanItem });
	                } else {
	                  return _react2.default.createElement(_stageplanSidebarItem2.default, { key: item.id || index,
	                    item: selectedCategory !== 'monitors' ? item : Object.assign({}, item, { title: (0, _functions.getMonitorValue)(item) }),
	                    itemIndex: index,
	                    existingItem: item.stageplan_item,
	                    fontSize: _this2.props.fontSize,
	                    hideAnimation: _this2.props.hideAnimation,
	                    setDragStartOffset: _this2.props.setDragStartOffset,
	                    setRiderStageplanItemFocus: _this2.props.setRiderStageplanItemFocus,
	                    createRiderStageplanItem: _this2.props.createRiderStageplanItem });
	                }
	              })
	            ) : _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                { className: 'stageplan-sidebar-link' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'forward', onClick: function onClick() {
	                      return _this2.setState({ selectedCategory: 'members' });
	                    } },
	                  'Members'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'stageplan-sidebar-link' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'forward', onClick: function onClick() {
	                      return _this2.setState({ selectedCategory: 'instruments' });
	                    } },
	                  'Instruments'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'stageplan-sidebar-link' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'forward', onClick: function onClick() {
	                      return _this2.setState({ selectedCategory: 'monitors' });
	                    } },
	                  'Monitors'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'stageplan-sidebar-link' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'forward', onClick: function onClick() {
	                      return _this2.setState({ selectedCategory: 'misc' });
	                    } },
	                  'Miscellaneous'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'stageplan-sidebar-link' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'forward', onClick: function onClick() {
	                      return _this2.props.addRiderStageplanItem();
	                    } },
	                  'Custom'
	                )
	              )
	            ),
	            isDragging ? _react2.default.createElement(
	              'div',
	              { className: 'stageplan-remove-item' },
	              _react2.default.createElement('div', { className: 'stageplan-remove-item-overlay' }),
	              _react2.default.createElement('div', { className: 'stageplan-remove-item-drop h5', style: { padding: style.padding } })
	            ) : null,
	            provided.placeholder
	          );
	        }
	      );
	    }
	  }]);
	
	  return StageplanSidebar;
	}(_react.Component);
	
	StageplanSidebar.propTypes = {
	  style: _propTypes2.default.object,
	  fontSize: _propTypes2.default.number,
	  categories: _propTypes2.default.object,
	  isDragging: _propTypes2.default.bool,
	  hideAnimation: _propTypes2.default.bool,
	  setDragStartOffset: _propTypes2.default.func,
	  setRiderStageplanItemFocus: _propTypes2.default.func,
	  addRiderStageplanItem: _propTypes2.default.func,
	  createRiderStageplanItem: _propTypes2.default.func
	};
	
	StageplanSidebar.defaultProps = {
	  style: {
	    width: undefined,
	    height: undefined,
	    padding: undefined
	  },
	  fontSize: 12,
	  categories: {},
	  isDragging: false,
	  hideAnimation: false,
	  setDragStartOffset: function setDragStartOffset() {},
	  setRiderStageplanItemFocus: function setRiderStageplanItemFocus() {},
	  addRiderStageplanItem: function addRiderStageplanItem() {},
	  createRiderStageplanItem: function createRiderStageplanItem() {}
	};
	
	exports.default = StageplanSidebar;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBeautifulDnd = __webpack_require__(5);
	
	var _reactSelect = __webpack_require__(20);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _functions = __webpack_require__(6);
	
	var _stageplanItem = __webpack_require__(327);
	
	var _stageplanItem2 = _interopRequireDefault(_stageplanItem);
	
	var _stageplanSidebar = __webpack_require__(329);
	
	var _stageplanSidebar2 = _interopRequireDefault(_stageplanSidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Stageplan = function (_Component) {
	  _inherits(Stageplan, _Component);
	
	  function Stageplan(props) {
	    _classCallCheck(this, Stageplan);
	
	    var _this = _possibleConstructorReturn(this, (Stageplan.__proto__ || Object.getPrototypeOf(Stageplan)).call(this, props));
	
	    _this.calculateStageplanCanvas = function (stageplan, origin) {
	      var view = _this.props.view;
	
	      var offset = view.editable ? _this.state.offset : 0;
	      var _this$state = _this.state,
	          spacing = _this$state.spacing,
	          itemDefaults = _this$state.itemDefaults;
	
	
	      var clientRect = _reactDom2.default.findDOMNode(_this).getBoundingClientRect();
	
	      var ratio = (clientRect.width - offset - spacing * 2) / stageplan.width;
	      var width = Math.ceil(ratio * 100) * (stageplan.width / 100);
	      var height = Math.ceil(ratio * 100) * (stageplan.height / 100);
	
	      var sidebarWidth = clientRect.width - width - spacing;
	
	      _this.setState({
	        fontSize: itemDefaults.fontSize * ratio,
	        canvas: {
	          ratio: ratio,
	          width: width,
	          height: height
	        },
	        sidebar: {
	          width: sidebarWidth,
	          height: height
	        }
	      });
	    };
	
	    _this.state = {
	      offset: 300,
	      spacing: 18,
	      gridSize: 6,
	      stageplan: undefined,
	      items: undefined,
	      itemDefaults: {
	        fontSize: 15,
	        width: 150,
	        height: 50,
	        rotation: {
	          degrees: 0,
	          radians: 0
	        }
	      },
	      focusItem: undefined,
	      fontSize: undefined,
	      canvas: {
	        ratio: 1,
	        width: undefined,
	        height: undefined
	      },
	      sidebar: {
	        width: undefined,
	        height: undefined
	      },
	      showDropdown: false,
	      showDropArea: false,
	      dragObject: undefined,
	      dragStartOffset: {
	        width: 280,
	        height: 48,
	        x: 0,
	        y: 0
	      },
	      isDragging: false,
	      hideAnimation: false
	    };
	    return _this;
	  }
	
	  _createClass(Stageplan, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          stageplan = _props.stageplan,
	          items = _props.items;
	
	
	      this.setState({ stageplan: stageplan, items: items });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var stageplan = this.state.stageplan;
	
	
	      this.calculateStageplanCanvas(stageplan, 'componentDidMount');
	
	      window.addEventListener('resize', function () {
	        return _this2.calculateStageplanCanvas(_this2.props.stageplan, 'addEventListener');
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var view = nextProps.view,
	          stageplan = nextProps.stageplan,
	          items = nextProps.items;
	
	
	      if (stageplan !== this.props.stageplan) this.setState({ stageplan: stageplan });
	      if (items !== this.props.items) this.setState({ items: items });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var view = this.props.view;
	      var stageplan = this.state.stageplan;
	
	
	      if (view.editable !== prevProps.view.editable) this.calculateStageplanCanvas(stageplan, 'componentDidUpdate'); // update component when switched to view_only view (also used for PDF export)
	      if (stageplan !== prevState.stageplan) this.calculateStageplanCanvas(stageplan, 'componentDidUpdate');
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      window.removeEventListener('resize', function () {
	        return _this3.calculateStageplanCanvas(_this3.props.stageplan, 'removeEventListener');
	      });
	    }
	  }, {
	    key: 'addStageplanItem',
	    value: function addStageplanItem() {
	      var view = this.props.view;
	      var itemDefaults = this.state.itemDefaults;
	
	
	      if (view.editable) {
	        this.props.addRiderStageplanItem({
	          id: null,
	          type: 'custom',
	          title: '',
	          top: 50,
	          left: 50,
	          width: itemDefaults.width,
	          height: itemDefaults.height,
	          rotation: itemDefaults.rotation
	        });
	      }
	    }
	  }, {
	    key: 'createStageplanItem',
	    value: function createStageplanItem(sidebarItem, position) {
	      var _this4 = this;
	
	      var _state = this.state,
	          items = _state.items,
	          itemDefaults = _state.itemDefaults,
	          canvas = _state.canvas,
	          dragStartOffset = _state.dragStartOffset;
	
	
	      if (sidebarItem !== undefined) {
	        var item = {
	          id: null,
	          top: position !== undefined ? (position.y + dragStartOffset.y) / canvas.height * 100 : 50,
	          left: position !== undefined ? (position.x + dragStartOffset.x) / canvas.width * 100 : 50,
	          width: sidebarItem.width || dragStartOffset.width / canvas.ratio,
	          height: sidebarItem.height || dragStartOffset.height / canvas.ratio,
	          rotation: sidebarItem.rotation || itemDefaults.rotation,
	          params: { shape: sidebarItem.shape }
	        };
	
	        if (sidebarItem.id && sidebarItem.name) {
	          item = (0, _immutabilityHelper2.default)(item, {
	            $merge: {
	              type: 'rider_member',
	              riderMemberId: sidebarItem.id,
	              title: sidebarItem.name,
	              width: 100,
	              height: 100,
	              params: {
	                shape: 'oval'
	              }
	            }
	          });
	        } else if (sidebarItem.id) {
	          item = (0, _immutabilityHelper2.default)(item, {
	            $merge: {
	              type: 'rider_item',
	              riderItemId: sidebarItem.id,
	              channel: sidebarItem.channel,
	              title: sidebarItem.title
	            }
	          });
	        } else {
	          item = (0, _immutabilityHelper2.default)(item, {
	            $merge: {
	              type: 'custom',
	              title: sidebarItem.title
	            }
	          });
	        }
	
	        this.setState({
	          items: (0, _immutabilityHelper2.default)(items, { $push: [item] })
	        }, function () {
	          return _this4.props.createRiderStageplanItem(item);
	        });
	      }
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown(item, parentItem) {
	      var _this5 = this;
	
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this5.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        _react2.default.createElement('div', { className: 'ui-dropdown-handle', onClick: function onClick() {
	            return _this5.setState({ showDropdown: !showDropdown });
	          } }),
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this5.props.deleteRiderStageplan(_this5.props.stageplan.id);
	              } },
	            'Remove'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props2 = this.props,
	          view = _props2.view,
	          categories = _props2.categories;
	      var _state2 = this.state,
	          spacing = _state2.spacing,
	          gridSize = _state2.gridSize,
	          stageplan = _state2.stageplan,
	          items = _state2.items,
	          itemDefaults = _state2.itemDefaults,
	          focusItem = _state2.focusItem,
	          fontSize = _state2.fontSize,
	          canvas = _state2.canvas,
	          sidebar = _state2.sidebar,
	          showDropArea = _state2.showDropArea,
	          isDragging = _state2.isDragging,
	          hideAnimation = _state2.hideAnimation;
	
	
	      var stageSizes = [];
	      for (var value = 1; value <= 40; value++) {
	        stageSizes.push({ value: value });
	      }var className = function className(snapshot) {
	        return (0, _classnames2.default)({
	          'stageplan-canvas': true,
	          'stageplan-canvas--hover': snapshot.isDraggingOver || showDropArea
	        });
	      };
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'stageplan section--full', style: { width: '100%', height: 'auto', backgroundSize: gridSize + 'px ' + gridSize + 'px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'section-head' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Stageplan'
	          ),
	          view.editable ? _react2.default.createElement(
	            'div',
	            { className: 'stage-size' },
	            'Stage size:',
	            _react2.default.createElement(_reactSelect2.default, {
	              openOnFocus: true,
	              className: 'react-select',
	              value: { value: parseInt(stageplan.width / 100, 10) },
	              valueKey: 'value',
	              labelKey: 'value',
	              clearable: false,
	              placeholder: 'Width',
	              noResultsText: null,
	              onChange: function onChange(_ref) {
	                var value = _ref.value;
	                return _this6.setState({
	                  stageplan: (0, _immutabilityHelper2.default)(stageplan, {
	                    width: { $set: value * 100 }
	                  })
	                }, function () {
	                  _this6.props.editRiderStageplan({
	                    id: stageplan.id,
	                    width: value * 100
	                  });
	                });
	              },
	              options: stageSizes }),
	            'x',
	            _react2.default.createElement(_reactSelect2.default, {
	              openOnFocus: true,
	              className: 'react-select',
	              value: { value: parseInt(stageplan.height / 100, 10) },
	              valueKey: 'value',
	              labelKey: 'value',
	              clearable: false,
	              placeholder: 'Height',
	              onChange: function onChange(_ref2) {
	                var value = _ref2.value;
	                return _this6.setState({
	                  stageplan: (0, _immutabilityHelper2.default)(stageplan, {
	                    height: { $set: value * 100 }
	                  })
	                }, function () {
	                  _this6.props.editRiderStageplan({
	                    id: stageplan.id,
	                    height: value * 100
	                  });
	                });
	              },
	              options: stageSizes }),
	            'metres'
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section-content', style: {
	              width: '100%',
	              height: 'auto'
	            } },
	          _react2.default.createElement(
	            _reactBeautifulDnd.DragDropContext,
	            {
	              onDragStart: function onDragStart(start, provided) {
	                var index = start.draggableId;
	                var category = start.source.droppableId;
	
	                var dragObject = undefined;
	
	                if (category === 'misc') {
	                  var categoryIndex = index.split('-')[0];
	                  var childIndex = index.split('-')[1];
	
	                  dragObject = _this6.props.categories[category][categoryIndex].children[childIndex];
	                } else {
	                  dragObject = _this6.props.categories[category][index];
	                }
	
	                _this6.setState({
	                  dragObject: dragObject,
	                  showDropArea: true,
	                  hideAnimation: false
	                });
	              },
	              onDragUpdate: function onDragUpdate(update, provided) {
	                return console.log({ update: update, provided: provided });
	              },
	              onDragEnd: function onDragEnd(result, provided, e) {
	                return _this6.setState({ dragObject: undefined, showDropArea: false });
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'stageplan-droppable-area', style: { margin: spacing + 'px' } },
	              _react2.default.createElement(
	                _reactBeautifulDnd.Droppable,
	                { droppableId: 'canvas', isDropDisabled: !view.editable, type: 'stageplan' },
	                function (provided, snapshot) {
	                  return _react2.default.createElement(
	                    'div',
	                    { ref: provided.innerRef, className: className(snapshot),
	                      style: {
	                        backgroundSize: Math.ceil(canvas.ratio * 100) + 'px ' + Math.ceil(canvas.ratio * 100) + 'px',
	                        width: canvas.width + 1 + 'px',
	                        height: canvas.height + 1 + 'px'
	                      },
	                      onDoubleClick: function onDoubleClick(e) {
	                        if (view.editable) {
	                          if (e.nativeEvent.target.className === 'stageplan-canvas') {
	                            var x = e.nativeEvent.offsetX;
	                            var y = e.nativeEvent.offsetY;
	
	                            _this6.props.addRiderStageplanItem({
	                              id: null,
	                              type: 'custom',
	                              title: '',
	                              top: y / canvas.height * 100,
	                              left: x / canvas.width * 100,
	                              width: itemDefaults.width,
	                              height: itemDefaults.height,
	                              rotation: {
	                                degrees: '0',
	                                radians: '0'
	                              }
	                            });
	                          }
	                        }
	                      },
	                      onMouseUp: function onMouseUp(e) {
	                        var dragObject = _this6.state.dragObject;
	
	
	                        if (view.editable && dragObject) {
	                          _this6.setState({
	                            hideAnimation: true
	                          });
	
	                          var position = {
	                            x: e.nativeEvent.offsetX,
	                            y: e.nativeEvent.offsetY
	                          };
	
	                          _this6.setState({ dragObject: undefined }, function () {
	                            return _this6.createStageplanItem(Object.assign({}, dragObject, { title: (0, _functions.getMonitorValue)(dragObject) }), position);
	                          });
	                        }
	                      } },
	                    _react2.default.createElement('div', { className: 'stageplan-scale', style: {
	                        fontSize: 10 * canvas.ratio + 'px',
	                        width: Math.ceil(canvas.ratio * 100) + 'px',
	                        height: Math.ceil(canvas.ratio * 100) + 'px',
	                        position: 'absolute'
	                      } }),
	                    items.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'div',
	                        { key: item.id || index },
	                        item.id === null && !item.title ? _react2.default.createElement('div', { className: 'riek-escape riek-escape--overlay', onClick: function onClick() {
	                            return _this6.props.removeRiderStageplanItem(index);
	                          } }) : null,
	                        _react2.default.createElement(_stageplanItem2.default, {
	                          view: view,
	                          item: item,
	                          itemIsFocused: item.id === focusItem ? true : false,
	                          canvas: canvas,
	                          fontSize: fontSize,
	                          setDragState: function setDragState(state) {
	                            return _this6.setState({ isDragging: state });
	                          },
	                          removeRiderStageplanItem: function removeRiderStageplanItem() {
	                            return _this6.props.removeRiderStageplanItem(index);
	                          },
	                          createRiderStageplanItem: function createRiderStageplanItem(item) {
	                            return _this6.setState({
	                              items: (0, _immutabilityHelper2.default)(items, _defineProperty({}, index, { $set: item }))
	                            }, function () {
	                              _this6.props.createRiderStageplanItem({
	                                type: 'custom',
	                                title: item.title,
	                                top: item.top,
	                                left: item.left,
	                                width: item.width,
	                                height: item.height,
	                                rotation: {
	                                  degrees: '0',
	                                  radians: '0'
	                                }
	                              });
	                            });
	                          },
	                          editRiderStageplanItem: function editRiderStageplanItem(item) {
	                            return _this6.props.editRiderStageplanItem(item, index);
	                          },
	                          deleteRiderStageplanItem: _this6.props.deleteRiderStageplanItem })
	                      );
	                    }),
	                    provided.placeholder
	                  );
	                }
	              ),
	              view.editable ? _react2.default.createElement(_stageplanSidebar2.default, { style: Object.assign({}, sidebar, { padding: '0 ' + spacing + 'px' }),
	                fontSize: fontSize,
	                categories: categories,
	                isDragging: isDragging,
	                hideAnimation: hideAnimation,
	                setDragStartOffset: function setDragStartOffset(dragStartOffset) {
	                  return _this6.setState({ dragStartOffset: dragStartOffset });
	                },
	                setRiderStageplanItemFocus: function setRiderStageplanItemFocus(focusItem) {
	                  return _this6.setState({ focusItem: focusItem });
	                },
	                addRiderStageplanItem: function addRiderStageplanItem(item) {
	                  return _this6.addStageplanItem(item);
	                },
	                createRiderStageplanItem: function createRiderStageplanItem(item) {
	                  return _this6.createStageplanItem(item);
	                } }) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Stageplan;
	}(_react.Component);
	
	Stageplan.propTypes = {
	  view: _propTypes2.default.object,
	  stageplan: _propTypes2.default.object,
	  items: _propTypes2.default.array,
	  categories: _propTypes2.default.object,
	  editRiderStageplan: _propTypes2.default.func,
	  addRiderStageplanItem: _propTypes2.default.func,
	  removeRiderStageplanItem: _propTypes2.default.func,
	  createRiderStageplanItem: _propTypes2.default.func,
	  editRiderStageplanItem: _propTypes2.default.func,
	  deleteRiderStageplanItem: _propTypes2.default.func
	};
	
	Stageplan.defaultProps = {
	  view: {},
	  stageplan: {},
	  items: [],
	  categories: {},
	  editRiderStageplan: function editRiderStageplan() {},
	  addRiderStageplanItem: function addRiderStageplanItem() {},
	  removeRiderStageplanItem: function removeRiderStageplanItem() {},
	  createRiderStageplanItem: function createRiderStageplanItem() {},
	  editRiderStageplanItem: function editRiderStageplanItem() {},
	  deleteRiderStageplanItem: function deleteRiderStageplanItem() {}
	};
	
	exports.default = Stageplan;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _stageplan = __webpack_require__(330);
	
	var _stageplan2 = _interopRequireDefault(_stageplan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Stageplans = function (_Component) {
	  _inherits(Stageplans, _Component);
	
	  function Stageplans() {
	    _classCallCheck(this, Stageplans);
	
	    return _possibleConstructorReturn(this, (Stageplans.__proto__ || Object.getPrototypeOf(Stageplans)).apply(this, arguments));
	  }
	
	  _createClass(Stageplans, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          view = _props.view,
	          stageplans = _props.stageplans,
	          categories = _props.categories;
	
	
	      return stageplans && stageplans.length > 0 ? stageplans.map(function (stageplan, index) {
	        return _react2.default.createElement(_stageplan2.default, { key: index,
	          view: view,
	          stageplan: stageplan,
	          items: stageplan.items,
	          categories: categories,
	          editRiderStageplan: _this2.props.editRiderStageplan,
	          addRiderStageplanItem: _this2.props.addRiderStageplanItem,
	          removeRiderStageplanItem: _this2.props.removeRiderStageplanItem,
	          createRiderStageplanItem: function createRiderStageplanItem(item) {
	            return _this2.props.createRiderStageplanItem(stageplan.id, item);
	          },
	          editRiderStageplanItem: _this2.props.editRiderStageplanItem,
	          deleteRiderStageplanItem: _this2.props.deleteRiderStageplanItem });
	      }) : view.editable ? _react2.default.createElement(
	        'section',
	        { className: 'stageplan' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section-head' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Stageplan'
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return _this2.props.createRiderStageplan({
	                  title: 'minu stageplan',
	                  description: 'stageplani kirjeldus',
	                  width: '1000',
	                  height: '500'
	                });
	              } },
	            'Create a stageplan'
	          )
	        )
	      ) : null;
	    }
	  }]);
	
	  return Stageplans;
	}(_react.Component);
	
	Stageplans.propTypes = {
	  view: _propTypes2.default.object,
	  stageplans: _propTypes2.default.array,
	  categories: _propTypes2.default.object,
	  createRiderStageplan: _propTypes2.default.func,
	  editRiderStageplan: _propTypes2.default.func,
	  deleteRiderStageplan: _propTypes2.default.func,
	  addRiderStageplanItem: _propTypes2.default.func,
	  removeRiderStageplanItem: _propTypes2.default.func,
	  createRiderStageplanItem: _propTypes2.default.func,
	  editRiderStageplanItem: _propTypes2.default.func,
	  deleteRiderStageplanItem: _propTypes2.default.func
	};
	
	Stageplans.defaultProps = {
	  view: {},
	  stageplans: [],
	  categories: {},
	  createRiderStageplan: function createRiderStageplan() {},
	  editRiderStageplan: function editRiderStageplan() {},
	  deleteRiderStageplan: function deleteRiderStageplan() {},
	  addRiderStageplanItem: function addRiderStageplanItem() {},
	  removeRiderStageplanItem: function removeRiderStageplanItem() {},
	  createRiderStageplanItem: function createRiderStageplanItem() {},
	  editRiderStageplanItem: function editRiderStageplanItem() {},
	  deleteRiderStageplanItem: function deleteRiderStageplanItem() {}
	};
	
	exports.default = Stageplans;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _dashboard = __webpack_require__(154);
	
	var _modal = __webpack_require__(33);
	
	var _loading = __webpack_require__(47);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard(props) {
	    _classCallCheck(this, Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	
	    _this.state = {
	      enableEvents: true,
	      selectedRider: undefined
	    };
	    return _this;
	  }
	
	  _createClass(Dashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchDashboard();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var event = nextProps.event,
	          rider = nextProps.rider;
	
	
	      if (event.createdEventId !== this.props.event.createdEventId) {
	        this.props.history.replace({ pathname: '/event/' + event.createdEventId });
	      }
	
	      if (rider.createdRiderId !== this.props.rider.createdRiderId) {
	        this.props.history.replace({ pathname: '/rider/' + rider.createdRiderId });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var dashboard = nextProps.dashboard;
	
	
	      if (dashboard !== this.props.dashboard) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'mapRiderRequests',
	    value: function mapRiderRequests(items) {
	      var _this2 = this;
	
	      var dashboard = this.props.dashboard;
	      var riders = dashboard.riders;
	      var selectedRider = this.state.selectedRider;
	
	
	      return items.map(function (item, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index, onClick: function onClick() {
	              return _this2.props.setModal('EventFulfillRiderRequestModal', { riderRequest: item, riders: riders });
	            } },
	          _react2.default.createElement(
	            'a',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'title' },
	              item.title
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'description' },
	              _react2.default.createElement(
	                'small',
	                null,
	                'Event: ',
	                item.event.title
	              ),
	              _react2.default.createElement(
	                'small',
	                null,
	                'Stage: ',
	                item.stage.title
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'mapItems',
	    value: function mapItems(items, type) {
	      return items.map(function (item, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/' + type + '/' + item.id },
	            _react2.default.createElement(
	              'span',
	              { className: 'title' },
	              item.title
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'description' },
	              _react2.default.createElement(
	                'small',
	                null,
	                'Artist: ',
	                item.artist
	              ),
	              _react2.default.createElement(
	                'small',
	                null,
	                'Owner: ',
	                item.owner
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderRiderRequests',
	    value: function renderRiderRequests(requests) {
	      if (requests.length === 0) return null;
	
	      return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Rider requests'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'library-list library-list--riders' },
	          this.mapRiderRequests(requests)
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Events'
	        )
	      );
	    }
	  }, {
	    key: 'renderEvents',
	    value: function renderEvents(events, riderRequests) {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Events'
	        ),
	        this.renderRiderRequests(riderRequests),
	        _react2.default.createElement(
	          'ul',
	          { className: 'library-list' },
	          this.mapItems(events, 'event'),
	          _react2.default.createElement(
	            'li',
	            { className: 'add', onClick: function onClick() {
	                return _this3.props.setModal('EventCreateModal');
	              } },
	            _react2.default.createElement(
	              'h1',
	              null,
	              '+'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderRiders',
	    value: function renderRiders(riders) {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Riders'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'library-list library-list--riders' },
	          this.mapItems(riders, 'rider'),
	          _react2.default.createElement(
	            'li',
	            { className: 'add', onClick: function onClick() {
	                return _this4.props.setModal('RiderCreateModal');
	              } },
	            _react2.default.createElement(
	              'h1',
	              null,
	              '+'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dashboard = this.props.dashboard;
	      var events = dashboard.events,
	          riders = dashboard.riders,
	          riderRequests = dashboard.riderRequests;
	
	
	      if (Object.keys(dashboard).length === 0 || dashboard.isFetching === true) return _react2.default.createElement(_loading2.default, {
	        className: 'library',
	        message: 'We are loading up your riders and events' });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'library' },
	        this.state.enableEvents ? this.renderEvents(events, riderRequests) : null,
	        this.renderRiders(riders)
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react.Component);
	
	Dashboard.propTypes = {
	  dashboard: _propTypes2.default.object,
	  fetchDashboard: _propTypes2.default.func,
	  event: _propTypes2.default.object,
	  rider: _propTypes2.default.object,
	  setModal: _propTypes2.default.func
	};
	
	Dashboard.defaultProps = {
	  dashboard: {},
	  fetchDashboard: function fetchDashboard() {},
	  event: {},
	  rider: {},
	  setModal: function setModal() {}
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    dashboard: state.dashboard,
	    event: state.event,
	    rider: state.rider
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    fetchDashboard: _dashboard.fetchDashboard,
	    setModal: _modal.setModal
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Dashboard);

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _event = __webpack_require__(90);
	
	var _eventUser = __webpack_require__(156);
	
	var _eventRiderRequest = __webpack_require__(89);
	
	var _modal = __webpack_require__(33);
	
	var _loading = __webpack_require__(47);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _notFound = __webpack_require__(93);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	var _eventNavigation = __webpack_require__(276);
	
	var _eventNavigation2 = _interopRequireDefault(_eventNavigation);
	
	var _eventBreadcrumbs = __webpack_require__(275);
	
	var _eventBreadcrumbs2 = _interopRequireDefault(_eventBreadcrumbs);
	
	var _riders = __webpack_require__(277);
	
	var _riders2 = _interopRequireDefault(_riders);
	
	var _eventStages = __webpack_require__(279);
	
	var _eventStages2 = _interopRequireDefault(_eventStages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Event = function (_Component) {
	  _inherits(Event, _Component);
	
	  function Event() {
	    _classCallCheck(this, Event);
	
	    return _possibleConstructorReturn(this, (Event.__proto__ || Object.getPrototypeOf(Event)).apply(this, arguments));
	  }
	
	  _createClass(Event, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var eventId = this.props.match.params.eventId;
	      var event = this.props.event;
	
	
	      if (eventId && eventId !== event.id) this.props.fetchEvent(eventId);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var event = nextProps.event;
	
	
	      if (event.deletedEventId) this.props.history.replace({ pathname: '/library' });
	      if (event.createdStageId !== this.props.event.createdStageId) this.props.history.replace({ pathname: '/event/' + event.id + '/stage/' + event.createdStageId });
	      if (event.deletedStageId) this.props.history.replace({ pathname: '/event/' + event.id });
	    }
	  }, {
	    key: 'navigateTo',
	    value: function navigateTo(section) {
	      var domElement = this[section] && _reactDom2.default.findDOMNode(this[section].current);
	      var offsetTop = domElement ? domElement.offsetTop : 0;
	
	      window.scroll({
	        top: offsetTop,
	        behavior: 'smooth'
	      });
	    }
	  }, {
	    key: 'getStage',
	    value: function getStage() {
	      var _props$match$params = this.props.match.params,
	          eventId = _props$match$params.eventId,
	          stageId = _props$match$params.stageId;
	      var event = this.props.event;
	
	
	      if (stageId !== undefined) {
	        var stageIndex = event.stages.map(function (stage) {
	          return stage.id;
	        }).indexOf(stageId);
	
	        return event.stages[stageIndex];
	      } else {
	        return undefined;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$match$params2 = this.props.match.params,
	          eventId = _props$match$params2.eventId,
	          stageId = _props$match$params2.stageId,
	          section = _props$match$params2.section;
	      var url = this.props.match.url;
	      var _props = this.props,
	          userSession = _props.userSession,
	          event = _props.event;
	
	
	      if (event.error) {
	        return _react2.default.createElement(_notFound2.default, null);
	      } else if (Object.keys(event).length === 0 || event.createdEventId || event.isFetching === true) return (// TODO: Check at what stage createdEventId gets replaced
	        _react2.default.createElement(_loading2.default, {
	          className: 'event',
	          message: 'We are loading up your event' })
	      );
	
	      var view = {
	        loggedIn: userSession.loggedIn,
	        editable: event.editable,
	        section: section,
	        user: userSession.user // TODO: Setting user inside view a good practice?
	      };
	
	      var stage = this.getStage();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'event' },
	        _react2.default.createElement(
	          'div',
	          { className: 'event-header' },
	          _react2.default.createElement(_eventBreadcrumbs2.default, {
	            view: view,
	            event: event,
	            stage: stage,
	            editEvent: function editEvent(data) {
	              return _this2.props.editEvent(event.id, data);
	            },
	            deleteEvent: function deleteEvent() {
	              return _this2.props.deleteEvent(event.id);
	            },
	            deleteEventStage: function deleteEventStage(stageId) {
	              return _this2.props.deleteEventStage(stageId);
	            },
	            createEventUser: function createEventUser(user) {
	              return _this2.props.createEventUser(event.id, user);
	            },
	            deleteEventUser: function deleteEventUser(userId) {
	              return _this2.props.deleteEventUser(event.id, userId);
	            } }),
	          _react2.default.createElement(_eventStages2.default, {
	            view: view,
	            event: event,
	            stage: stage,
	            setModal: function setModal(name, data) {
	              return _this2.props.setModal(name, Object.assign({}, data, { eventId: eventId }));
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'event-document' },
	          _react2.default.createElement(_eventNavigation2.default, {
	            url: section ? url.substring(0, url.indexOf('/' + section)) : url,
	            eventId: eventId,
	            navigateTo: function navigateTo(section) {
	              return _this2.navigateTo(section);
	            } }),
	          _react2.default.createElement(_riders2.default, {
	            view: view,
	            eventId: event.id,
	            stage: stage,
	            stages: event.stages,
	            deleteRiderRequest: function deleteRiderRequest(requestId) {
	              return _this2.props.deleteRiderRequest(requestId);
	            },
	            setModal: function setModal(name, data) {
	              return _this2.props.setModal(name, Object.assign({}, data, { eventId: eventId }));
	            } })
	        )
	      );
	    }
	  }]);
	
	  return Event;
	}(_react.Component);
	
	Event.propTypes = {
	  match: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired,
	  userSession: _propTypes2.default.object,
	  event: _propTypes2.default.object,
	  fetchEvent: _propTypes2.default.func,
	  editEvent: _propTypes2.default.func,
	  deleteEvent: _propTypes2.default.func,
	  deleteEventStage: _propTypes2.default.func,
	  createEventUser: _propTypes2.default.func,
	  deleteEventUser: _propTypes2.default.func,
	  deleteRiderRequest: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	Event.defaultProps = {
	  match: {},
	  location: {},
	  history: {},
	  userSession: {},
	  event: {},
	  fetchEvent: function fetchEvent() {},
	  editEvent: function editEvent() {},
	  deleteEvent: function deleteEvent() {},
	  deleteEventStage: function deleteEventStage() {},
	  createEventUser: function createEventUser() {},
	  deleteEventUser: function deleteEventUser() {},
	  deleteRiderRequest: function deleteRiderRequest() {},
	  setModal: function setModal() {}
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    event: state.event
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    fetchEvent: _event.fetchEvent,
	    editEvent: _event.editEvent,
	    deleteEvent: _event.deleteEvent,
	    deleteEventStage: _event.deleteEventStage,
	    createEventUser: _eventUser.createEventUser,
	    deleteEventUser: _eventUser.deleteEventUser,
	    deleteRiderRequest: _eventRiderRequest.deleteRiderRequest,
	    setModal: _modal.setModal
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Event);

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _userSession = __webpack_require__(34);
	
	var _loading = __webpack_require__(47);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _register = __webpack_require__(96);
	
	var _register2 = _interopRequireDefault(_register);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Join = function (_Component) {
	  _inherits(Join, _Component);
	
	  function Join(props) {
	    _classCallCheck(this, Join);
	
	    var _this = _possibleConstructorReturn(this, (Join.__proto__ || Object.getPrototypeOf(Join)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Join, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var joinCode = this.props.match.params.joinCode;
	      var userSession = this.props.userSession;
	
	
	      if (joinCode && !userSession.registrationRequest && !userSession.registration) this.props.getUserRequestInfo(joinCode);
	      if (userSession.loggedIn) this.props.removeUserSession;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var userSession = nextProps.userSession;
	
	
	      if (userSession.verification && userSession.verification.required) this.props.history.replace({ pathname: '/register' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var userSession = this.props.userSession;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'join' },
	        userSession && userSession.registration ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'You have joined event'
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/login' },
	            'Log in \u2192'
	          )
	        ) : userSession && userSession.registrationRequest ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Join event'
	          ),
	          _react2.default.createElement(_register2.default, { email: userSession.registrationRequest.email, requestCode: userSession.registrationRequest.code })
	        ) : userSession.error ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            userSession.error.message
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Looking up the event'
	          ),
	          _react2.default.createElement(_loading2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Join;
	}(_react.Component);
	
	Join.propTypes = {
	  userSession: _propTypes2.default.object,
	  getUserRequestInfo: _propTypes2.default.func
	};
	
	Join.defaultProps = {
	  userSession: {},
	  getUserRequestInfo: function getUserRequestInfo() {}
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    userSession: state.userSession
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    getUserRequestInfo: _userSession.getUserRequestInfo
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Join);

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _library = __webpack_require__(157);
	
	var _modal = __webpack_require__(33);
	
	var _loading = __webpack_require__(47);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Library = function (_Component) {
	  _inherits(Library, _Component);
	
	  function Library(props) {
	    _classCallCheck(this, Library);
	
	    var _this = _possibleConstructorReturn(this, (Library.__proto__ || Object.getPrototypeOf(Library)).call(this, props));
	
	    _this.state = {
	      showEvents: true
	    };
	    return _this;
	  }
	
	  _createClass(Library, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.state.showEvents) this.props.fetchEventList();
	      this.props.fetchRiderList();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var event = nextProps.event,
	          rider = nextProps.rider;
	
	
	      if (event.createdEventId !== this.props.event.createdEventId) {
	        this.props.history.replace({ pathname: '/event/' + event.createdEventId });
	      }
	
	      if (rider.createdRiderId !== this.props.rider.createdRiderId) {
	        this.props.history.replace({ pathname: '/rider/' + rider.createdRiderId });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var library = nextProps.library;
	
	
	      if (library !== this.props.library) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'mapItems',
	    value: function mapItems(items, type) {
	      if (items === undefined || items.length === 0) return _react2.default.createElement(
	        'div',
	        null,
	        'Seems like we did not find any ' + type + 's. ',
	        _react2.default.createElement(
	          'a',
	          null,
	          'Start by creating one.'
	        )
	      );
	
	      return items.map(function (item, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/' + type + '/' + item.id },
	            _react2.default.createElement(
	              'span',
	              { className: 'title' },
	              item.title
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'description' },
	              _react2.default.createElement(
	                'small',
	                null,
	                'Artist: ',
	                item.artist
	              ),
	              _react2.default.createElement(
	                'small',
	                null,
	                'Owner: ',
	                item.owner
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderEvents',
	    value: function renderEvents(event) {
	      var _this2 = this;
	
	      var eventHasLoaded = Object.keys(event).length === 0 || event.isFetching === true;
	
	      return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Events'
	        ),
	        eventHasLoaded ? _react2.default.createElement(_loading2.default, { className: 'library' }) : event.items && event.items.length > 0 ? _react2.default.createElement(
	          'ul',
	          { className: 'library-list' },
	          this.mapItems(event.items, 'event'),
	          _react2.default.createElement(
	            'li',
	            { className: 'add', onClick: function onClick() {
	                return _this2.props.setModal('EventCreateModal');
	              } },
	            _react2.default.createElement(
	              'h1',
	              null,
	              '+'
	            )
	          )
	        ) : _react2.default.createElement(
	          'ul',
	          { className: 'library-list' },
	          _react2.default.createElement(
	            'li',
	            { className: 'add', onClick: function onClick() {
	                return _this2.props.setModal('EventCreateModal');
	              } },
	            _react2.default.createElement(
	              'h1',
	              null,
	              '+'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderRiders',
	    value: function renderRiders(rider) {
	      var _this3 = this;
	
	      var riderHasLoaded = Object.keys(rider).length === 0 || rider.isFetching === true;
	
	      return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Riders'
	        ),
	        riderHasLoaded ? _react2.default.createElement(_loading2.default, { className: 'library' }) : rider.items && rider.items.length > 0 ? _react2.default.createElement(
	          'ul',
	          { className: 'library-list library-list--riders' },
	          this.mapItems(rider.items, 'rider'),
	          _react2.default.createElement(
	            'li',
	            { className: 'add', onClick: function onClick() {
	                return _this3.props.setModal('RiderCreateModal');
	              } },
	            _react2.default.createElement(
	              'h1',
	              null,
	              '+'
	            )
	          )
	        ) : _react2.default.createElement(
	          'ul',
	          { className: 'library-list library-list--riders' },
	          _react2.default.createElement(
	            'li',
	            { className: 'add', onClick: function onClick() {
	                return _this3.props.setModal('RiderCreateModal');
	              } },
	            _react2.default.createElement(
	              'h1',
	              null,
	              '+'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var library = this.props.library;
	      var event = library.event,
	          rider = library.rider;
	      var showEvents = this.state.showEvents;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'library' },
	        showEvents ? this.renderEvents(event) : null,
	        this.renderRiders(rider)
	      );
	    }
	  }]);
	
	  return Library;
	}(_react.Component);
	
	Library.propTypes = {
	  match: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired,
	  userSession: _propTypes2.default.object,
	  library: _propTypes2.default.object,
	  fetchEventList: _propTypes2.default.func,
	  fetchRiderList: _propTypes2.default.func,
	  event: _propTypes2.default.object,
	  rider: _propTypes2.default.object,
	  setModal: _propTypes2.default.func
	};
	
	Library.defaultProps = {
	  match: {},
	  location: {},
	  history: {},
	  userSession: {},
	  library: {},
	  fetchEventList: function fetchEventList() {},
	  fetchRiderList: function fetchRiderList() {},
	  event: {},
	  rider: {},
	  setModal: function setModal() {}
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    library: state.library,
	    event: state.event,
	    rider: state.rider
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    fetchEventList: _library.fetchEventList,
	    fetchRiderList: _library.fetchRiderList,
	    setModal: _modal.setModal
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Library);

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _event = __webpack_require__(90);
	
	var _eventStage = __webpack_require__(155);
	
	var _eventRiderRequest = __webpack_require__(89);
	
	var _rider = __webpack_require__(21);
	
	var _modal = __webpack_require__(33);
	
	var _loginModal = __webpack_require__(287);
	
	var _loginModal2 = _interopRequireDefault(_loginModal);
	
	var _riderDeleteModal = __webpack_require__(289);
	
	var _riderDeleteModal2 = _interopRequireDefault(_riderDeleteModal);
	
	var _riderSharingModal = __webpack_require__(291);
	
	var _riderSharingModal2 = _interopRequireDefault(_riderSharingModal);
	
	var _riderRemoveShareModal = __webpack_require__(290);
	
	var _riderRemoveShareModal2 = _interopRequireDefault(_riderRemoveShareModal);
	
	var _eventCreateModal = __webpack_require__(282);
	
	var _eventCreateModal2 = _interopRequireDefault(_eventCreateModal);
	
	var _eventStageCreateModal = __webpack_require__(286);
	
	var _eventStageCreateModal2 = _interopRequireDefault(_eventStageCreateModal);
	
	var _eventCreateRiderRequestModal = __webpack_require__(283);
	
	var _eventCreateRiderRequestModal2 = _interopRequireDefault(_eventCreateRiderRequestModal);
	
	var _eventDeleteRiderRequestModal = __webpack_require__(284);
	
	var _eventDeleteRiderRequestModal2 = _interopRequireDefault(_eventDeleteRiderRequestModal);
	
	var _eventFulfillRiderRequestModal = __webpack_require__(285);
	
	var _eventFulfillRiderRequestModal2 = _interopRequireDefault(_eventFulfillRiderRequestModal);
	
	var _riderCreateModal = __webpack_require__(288);
	
	var _riderCreateModal2 = _interopRequireDefault(_riderCreateModal);
	
	var _riderTableCreateModal = __webpack_require__(292);
	
	var _riderTableCreateModal2 = _interopRequireDefault(_riderTableCreateModal);
	
	var _riderTableEmbeddingModal = __webpack_require__(293);
	
	var _riderTableEmbeddingModal2 = _interopRequireDefault(_riderTableEmbeddingModal);
	
	var _riderTableSharingModal = __webpack_require__(294);
	
	var _riderTableSharingModal2 = _interopRequireDefault(_riderTableSharingModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import RiderSettingsModal from '../components/modals/rider-settings-modal'
	
	// import RiderTableSettingsModal from '../components/modals/rider-table-settings-modal'
	
	
	var Modals = function (_Component) {
	  _inherits(Modals, _Component);
	
	  function Modals() {
	    _classCallCheck(this, Modals);
	
	    return _possibleConstructorReturn(this, (Modals.__proto__ || Object.getPrototypeOf(Modals)).apply(this, arguments));
	  }
	
	  _createClass(Modals, [{
	    key: 'renderModals',
	    value: function renderModals(modal) {
	      var _this2 = this;
	
	      var name = modal.name,
	          data = modal.data;
	      var rider = this.props.rider;
	
	
	      switch (name) {
	        case 'LoginModal':
	          return _react2.default.createElement(_loginModal2.default, {
	            setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        case 'EventCreateModal':
	          return _react2.default.createElement(_eventCreateModal2.default, {
	            createEvent: function createEvent(event) {
	              return _this2.props.createEvent(event);
	            },
	            setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        case 'EventStageCreateModal':
	          return _react2.default.createElement(_eventStageCreateModal2.default, {
	            createEventStage: function createEventStage(stage) {
	              return _this2.props.createEventStage(data.eventId, stage);
	            },
	            setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        case 'EventCreateRiderRequestModal':
	          return _react2.default.createElement(_eventCreateRiderRequestModal2.default, {
	            createRiderRequest: function createRiderRequest(request) {
	              return _this2.props.createRiderRequest(data.eventId, Object.assign({}, request, { stage: data.stage && data.stage.id || null }));
	            },
	            setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        case 'EventDeleteRiderRequestModal':
	          return _react2.default.createElement(_eventDeleteRiderRequestModal2.default, {
	            riderRequest: data.riderRequest,
	            deleteRiderRequest: function deleteRiderRequest() {
	              return _this2.props.deleteRiderRequest(data.riderRequest.id);
	            },
	            setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        case 'EventFulfillRiderRequestModal':
	          return _react2.default.createElement(_eventFulfillRiderRequestModal2.default, {
	            riderRequest: data.riderRequest,
	            riders: data.riders,
	            fulfillRiderRequest: function fulfillRiderRequest(rider) {
	              return _this2.props.fulfillRiderRequest(data.riderRequest.id, rider);
	            },
	            setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        case 'RiderCreateModal':
	          return _react2.default.createElement(_riderCreateModal2.default, {
	            createRider: function createRider(title) {
	              return _this2.props.createRider(title);
	            },
	            setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        case 'RiderDeleteModal':
	          return _react2.default.createElement(_riderDeleteModal2.default, {
	            title: data.title,
	            deleteRider: function deleteRider() {
	              return _this2.props.deleteRider(data.id);
	            },
	            setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        // case 'RiderSettingsModal':
	        //   return (
	        //     <RiderSettingsModal
	        //       rider={data.rider}
	        //       editRider={(title, description, artist) => this.props.editRider(title, description, artist)}
	        //       deleteRider={() => this.props.deleteRider(data.id)}
	        //       setModal={(status) => this.props.setModal(status)} />
	        //   )
	
	        case 'RiderSharingModal':
	          return _react2.default.createElement(_riderSharingModal2.default, {
	            sharedWithMember: rider.sharedWithMember,
	            shareRider: function shareRider(roles, email) {
	              return _this2.props.shareRider(data.id, roles, email);
	            },
	            setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        case 'RiderRemoveShareModal':
	          return _react2.default.createElement(_riderRemoveShareModal2.default, {
	            member: data.email,
	            removeRiderShare: function removeRiderShare() {
	              return _this2.props.removeRiderShare(data.id, data.email);
	            },
	            setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        case 'RiderTableCreateModal':
	          return _react2.default.createElement(_riderTableCreateModal2.default
	          // createRiderTable={(title) => this.props.createRiderTable(data.riderId, title, data.type)}
	          , { setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        case 'RiderTableEmbeddingModal':
	          return _react2.default.createElement(_riderTableEmbeddingModal2.default, {
	            title: data.title,
	            url: data.url,
	            setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        // case 'RiderTableSettingsModal':
	        //   return (
	        //     <RiderTableSettingsModal
	        //       title={data.title}
	        //       updateRiderTable={(object) => this.props.updateRiderTable(object)}
	        //       deleteRiderTable={() => this.props.deleteRiderTable(data.riderId, data.id)}
	        //       setModal={(status) => this.props.setModal(status)} />
	        //   )
	
	        case 'RiderTableSharingModal':
	          return _react2.default.createElement(_riderTableSharingModal2.default, {
	            url: data.url,
	            setModal: function setModal(status) {
	              return _this2.props.setModal(status);
	            } });
	
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (!this.props.modal.name) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal' },
	        _react2.default.createElement('div', { className: 'modal-escape', onClick: function onClick() {
	            return _this3.props.setModal(false);
	          } }),
	        this.renderModals(this.props.modal)
	      );
	    }
	  }]);
	
	  return Modals;
	}(_react.Component);
	
	Modals.propTypes = {
	  modal: _propTypes2.default.object,
	  setModal: _propTypes2.default.func,
	  rider: _propTypes2.default.object,
	  createEvent: _propTypes2.default.func,
	  createEventStage: _propTypes2.default.func,
	  createRiderRequest: _propTypes2.default.func,
	  fulfillRiderRequest: _propTypes2.default.func,
	  deleteRiderRequest: _propTypes2.default.func,
	  createRider: _propTypes2.default.func,
	  editRider: _propTypes2.default.func,
	  shareRider: _propTypes2.default.func,
	  removeRiderShare: _propTypes2.default.func,
	  deleteRider: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object
	};
	
	Modals.defaultProps = {
	  modal: {},
	  setModal: function setModal() {},
	  rider: {},
	  createEvent: function createEvent() {},
	  createEventStage: function createEventStage() {},
	  createRiderRequest: function createRiderRequest() {},
	  fulfillRiderRequest: function fulfillRiderRequest() {},
	  deleteRiderRequest: function deleteRiderRequest() {},
	  createRider: function createRider() {},
	  editRider: function editRider() {},
	  shareRider: function shareRider() {},
	  removeRiderShare: function removeRiderShare() {},
	  deleteRider: function deleteRider() {},
	  stageElements: {}
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    modal: state.modal,
	    rider: state.rider,
	    stageElements: state.stageElements
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    setModal: _modal.setModal,
	    createEvent: _event.createEvent,
	    createEventStage: _eventStage.createEventStage,
	    createRiderRequest: _eventRiderRequest.createRiderRequest,
	    fulfillRiderRequest: _eventRiderRequest.fulfillRiderRequest,
	    deleteRiderRequest: _eventRiderRequest.deleteRiderRequest,
	    createRider: _rider.createRider,
	    editRider: _rider.editRider,
	    shareRider: _rider.shareRider,
	    removeRiderShare: _rider.removeRiderShare,
	    deleteRider: _rider.deleteRider
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Modals);

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapStateToProps = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Navigation = function Navigation(props) {
	  var location = props.location,
	      rider = props.rider,
	      event = props.event;
	  var pathname = location.pathname;
	
	
	  if (pathname.includes('/rider/')) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'navigation' },
	      _react2.default.createElement(_reactRouterDom.Link, { to: '/library', className: 'back-arrow' }),
	      rider && rider.isFetching !== true ? rider.title : _react2.default.createElement('div', { className: 'ui-loading' })
	    );
	  } else if (pathname.includes('/event/')) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'navigation' },
	      _react2.default.createElement(_reactRouterDom.Link, { to: '/library', className: 'back-arrow' }),
	      event && event.isFetching !== true ? event.title : _react2.default.createElement('div', { className: 'ui-loading' })
	    );
	  } else {
	    return null;
	  }
	};
	
	Navigation.propTypes = {
	  match: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired,
	  rider: _propTypes2.default.object,
	  event: _propTypes2.default.object
	};
	
	Navigation.defaultProps = {
	  match: {},
	  location: {},
	  history: {},
	  rider: {},
	  event: {}
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    rider: state.rider,
	    event: state.event
	  };
	};
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, undefined)(Navigation));

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _rider = __webpack_require__(21);
	
	var _riderContact = __webpack_require__(160);
	
	var _riderMember = __webpack_require__(161);
	
	var _riderColumn = __webpack_require__(159);
	
	var _riderItem = __webpack_require__(91);
	
	var _riderStageplan = __webpack_require__(92);
	
	var _riderStageplanItem = __webpack_require__(162);
	
	var _stageElements = __webpack_require__(163);
	
	var _alerts = __webpack_require__(13);
	
	var _modal = __webpack_require__(33);
	
	var _loading = __webpack_require__(47);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _notFound = __webpack_require__(93);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	var _login = __webpack_require__(59);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _riderNavigation = __webpack_require__(311);
	
	var _riderNavigation2 = _interopRequireDefault(_riderNavigation);
	
	var _contacts = __webpack_require__(296);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	var _general = __webpack_require__(297);
	
	var _general2 = _interopRequireDefault(_general);
	
	var _hospitality = __webpack_require__(298);
	
	var _hospitality2 = _interopRequireDefault(_hospitality);
	
	var _input = __webpack_require__(307);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _members = __webpack_require__(310);
	
	var _members2 = _interopRequireDefault(_members);
	
	var _output = __webpack_require__(319);
	
	var _output2 = _interopRequireDefault(_output);
	
	var _requirements = __webpack_require__(321);
	
	var _requirements2 = _interopRequireDefault(_requirements);
	
	var _stageplans = __webpack_require__(331);
	
	var _stageplans2 = _interopRequireDefault(_stageplans);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import RiderEmbedSharing from '../components/rider/rider-embed-sharing'
	
	var sections = [{
	  title: 'General',
	  slug: 'general'
	}, {
	  title: 'Members',
	  slug: 'members'
	}, {
	  title: 'Requirements',
	  slug: 'requirements'
	}, {
	  title: 'Input List',
	  slug: 'input'
	}, {
	  title: 'Output List',
	  slug: 'output'
	}, {
	  title: 'Stage Plan',
	  slug: 'stageplan'
	}, {
	  title: 'Hospitality',
	  slug: 'hospitality'
	}, {
	  title: 'Contacts',
	  slug: 'contacts'
	}];
	
	var Rider = function (_Component) {
	  _inherits(Rider, _Component);
	
	  function Rider(props) {
	    _classCallCheck(this, Rider);
	
	    var _this = _possibleConstructorReturn(this, (Rider.__proto__ || Object.getPrototypeOf(Rider)).call(this, props));
	
	    _this.handleScroll = function () {
	      var rider = _this.props.rider;
	      var section = _this.props.match.params.section;
	      var scrollTop = document.documentElement.scrollTop;
	
	
	      var activeSection = undefined;
	
	      sections.every(function (section) {
	        var domElement = _this[section.slug] && _reactDom2.default.findDOMNode(_this[section.slug].current);
	        var offsetTop = domElement ? domElement.offsetTop : 0;
	
	        if (scrollTop >= offsetTop) {
	          activeSection = section.slug;
	
	          return true;
	        }
	
	        return false;
	      });
	
	      if (rider.isFetching !== true && activeSection && activeSection !== section) _this.setState({ activeSection: activeSection });
	    };
	
	    _this.state = {
	      activeSection: undefined,
	      activeSectionTimeout: undefined
	    };
	
	    sections.forEach(function (section) {
	      return _this[section.slug] = _react2.default.createRef();
	    });
	    return _this;
	  }
	
	  _createClass(Rider, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var riderId = this.props.match.params.riderId;
	
	
	      if (riderId) this.props.fetchRider(riderId);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var rider = nextProps.rider;
	
	
	      if (rider.deletedRiderId) this.props.history.replace({ pathname: '/library' });
	
	      if (rider.createChildren && rider.createChildren !== this.props.rider.createChildren) {
	        if (rider.createChildren.length > 0) {
	          var createChildren = rider.createChildren;
	
	
	          createChildren.forEach(function (item, index) {
	            // TODO: Replace with createMultiItem call
	            if (item.id) {
	              _this2.props.editRiderItem(rider.id, item);
	            } else {
	              _this2.props.createRiderItem(rider.id, item);
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var rider = nextProps.rider,
	          stageElements = nextProps.stageElements,
	          match = nextProps.match;
	
	
	      if (rider !== this.props.rider) return true;
	      if (stageElements !== this.props.stageElements) return true;
	      if (match.params !== this.props.match.params) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var rider = nextProps.rider,
	          stageElements = nextProps.stageElements;
	      var activeSectionTimeout = nextState.activeSectionTimeout;
	
	
	      if (Object.keys(rider).length > 0 && rider.isFetching !== true && rider.editable && !rider.error) {
	        if (Object.keys(stageElements).length === 0) {
	          this.props.fetchStageElements();
	        }
	      }
	
	      if (activeSectionTimeout !== this.state.activeSectionTimeout) clearTimeout(this.state.activeSectionTimeout);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this3 = this;
	
	      var rider = this.props.rider;
	      var _props$match$params = this.props.match.params,
	          riderId = _props$match$params.riderId,
	          section = _props$match$params.section;
	      var activeSection = this.state.activeSection;
	
	
	      if (rider.isFetching !== true && prevProps.rider.isFetching === true) {
	        this.setState({ activeSection: section || 'general' }, function () {
	          return _this3.scrollTo(section, 'auto');
	        });
	      }
	
	      if (rider.isFetching !== true && activeSection !== prevState.activeSection) {
	        var activeSectionTimeout = setTimeout(function () {
	          return _this3.props.history.replace({ pathname: '/rider/' + riderId + '/' + activeSection });
	        }, 500);
	
	        this.setState({ activeSectionTimeout: activeSectionTimeout });
	      }
	
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.activeSectionTimeout) clearTimeout(this.state.activeSectionTimeout);
	
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'scrollTo',
	    value: function scrollTo(section, behavior) {
	      var domElement = this[section] && _reactDom2.default.findDOMNode(this[section].current);
	      var offsetTop = domElement ? domElement.offsetTop : 0;
	
	      window.scroll({
	        top: offsetTop,
	        behavior: behavior
	      });
	    }
	  }, {
	    key: 'renderExportModal',
	    value: function renderExportModal() {
	      var rider = this.props.rider;
	
	
	      if (rider.isExporting !== true) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal' },
	        _react2.default.createElement('div', { className: 'modal-escape' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement(_loading2.default, {
	            className: 'rider-export',
	            message: 'We are exporting your rider' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          userSession = _props.userSession,
	          rider = _props.rider,
	          stageElements = _props.stageElements;
	      var section = this.props.match.params.section;
	
	
	      if (rider.error) {
	        return rider.error.code === 403 ? _react2.default.createElement(_login2.default, null) : _react2.default.createElement(_notFound2.default, null);
	      } else if (Object.keys(rider).length === 0 || rider.isFetching === true) return _react2.default.createElement(_loading2.default, {
	        className: 'rider',
	        message: 'We are loading up your rider' });
	
	      var view = {
	        loggedIn: userSession.loggedIn,
	        editable: rider.editable,
	        sharing: rider.sharing
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'rider' },
	        this.renderExportModal(),
	        _react2.default.createElement(_riderNavigation2.default, {
	          sections: sections,
	          riderId: rider.id,
	          activeSection: this.state.activeSection,
	          scrollTo: function scrollTo(section) {
	            return _this4.scrollTo(section, 'smooth');
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'rider-document' },
	          _react2.default.createElement(_general2.default, { ref: this.general,
	            view: view,
	            title: rider.title,
	            description: rider.description,
	            publicSharing: rider.public,
	            linkSharing: rider.link_sharing,
	            shares: rider.shares,
	            editRider: function editRider(data) {
	              return _this4.props.editRider(rider.id, data);
	            },
	            shareRider: function shareRider(email) {
	              return _this4.props.shareRider(rider.id, email);
	            },
	            removeRiderShare: function removeRiderShare(shareId) {
	              return _this4.props.removeRiderShare(shareId);
	            },
	            deleteRider: function deleteRider() {
	              return _this4.props.deleteRider(rider.id);
	            },
	            exportPDF: function exportPDF(selector) {
	              return _this4.props.exportRider(selector);
	            } }),
	          _react2.default.createElement(_members2.default, { ref: this.members,
	            view: view,
	            artist: rider.artist,
	            members: rider.members,
	            items: rider.items,
	            availableItems: rider.availableItems,
	            editRider: function editRider(data) {
	              return _this4.props.editRider(rider.id, data);
	            },
	            createRiderItem: function createRiderItem(item) {
	              return _this4.props.createRiderItem(rider.id, {
	                group: 'input',
	                class: item.type.slug === 'drums' ? 'instrument-group' : 'instrument',
	                title: item.title,
	                type: item.type.slug,
	                member: item.member
	              });
	            },
	            addRiderMember: function addRiderMember(member) {
	              return _this4.props.addRiderMember(member);
	            },
	            removeRiderMember: function removeRiderMember(index) {
	              return _this4.props.removeRiderMember(index);
	            },
	            createRiderMember: function createRiderMember(member) {
	              return _this4.props.createRiderMember(rider.id, member);
	            },
	            editRiderMember: function editRiderMember(member) {
	              return _this4.props.editRiderMember(member);
	            },
	            moveRiderMember: function moveRiderMember(_ref) {
	              var id = _ref.id,
	                  position = _ref.position;
	              return _this4.props.moveRiderMember(id, position);
	            },
	            deleteRiderMember: function deleteRiderMember(member) {
	              return _this4.props.deleteRiderMember(member);
	            },
	            stageElements: stageElements,
	            getSearchResults: function getSearchResults(array, term) {
	              return _this4.props.getSearchResults(array, term);
	            },
	            setAlert: function setAlert(_ref2) {
	              var message = _ref2.message,
	                  link = _ref2.link;
	              return _this4.props.setAlert(message, link);
	            } }),
	          _react2.default.createElement('div', { className: 'page-break' }),
	          _react2.default.createElement(_requirements2.default, { ref: this.requirements,
	            view: view,
	            rider: rider,
	            addRiderItem: function addRiderItem(item) {
	              return _this4.props.addRiderItem(item);
	            },
	            removeRiderItem: function removeRiderItem(item) {
	              return _this4.props.removeRiderItem(item);
	            },
	            createRiderItem: function createRiderItem(item) {
	              return _this4.props.createRiderItem(rider.id, item);
	            },
	            editRiderItem: function editRiderItem(item) {
	              return _this4.props.editRiderItem(rider.id, item);
	            },
	            moveRiderItem: function moveRiderItem(_ref3) {
	              var id = _ref3.id,
	                  position = _ref3.position;
	              return _this4.props.moveRiderItem(id, position);
	            },
	            deleteRiderItem: function deleteRiderItem(id) {
	              return _this4.props.deleteRiderItem(id);
	            },
	            setModal: function setModal(name, data) {
	              return _this4.props.setModal(name, data);
	            } }),
	          _react2.default.createElement('div', { className: 'page-break' }),
	          _react2.default.createElement(_input2.default, { ref: this.input,
	            view: view,
	            group: 'input',
	            rider: {
	              id: rider.id,
	              items: rider.input,
	              itemGroups: rider.itemGroups,
	              columns: rider.columns
	              // editable: rider.editable
	            },
	            addRiderColumn: function addRiderColumn(column) {
	              _this4.props.getAvailableEquipmentTypes(stageElements.equipmentTypes, rider.columns);
	              _this4.props.addRiderColumn(column);
	            },
	            removeRiderColumn: function removeRiderColumn(index) {
	              return _this4.props.removeRiderColumn(index);
	            },
	            createRiderColumn: function createRiderColumn(column) {
	              return _this4.props.createRiderColumn(rider.id, column);
	            },
	            moveRiderColumn: function moveRiderColumn(column) {
	              return _this4.props.moveRiderColumn(column);
	            },
	            deleteRiderColumn: function deleteRiderColumn(id) {
	              return _this4.props.deleteRiderColumn(id);
	            },
	            stageElements: stageElements,
	            createStageElement: function createStageElement(stageElement) {
	              return _this4.props.createStageElement(stageElement);
	            },
	            getSearchResults: function getSearchResults(array, term) {
	              return _this4.props.getSearchResults(array, term);
	            },
	            addRiderItem: function addRiderItem(item) {
	              return _this4.props.addRiderItem(Object.assign({}, item, { group: 'input' }));
	            },
	            removeRiderItem: function removeRiderItem(item) {
	              return _this4.props.removeRiderItem(Object.assign({}, item, { group: 'input' }));
	            },
	            createRiderItem: function createRiderItem(item) {
	              return _this4.props.createRiderItem(rider.id, item);
	            },
	            createRiderItems: function createRiderItems(parent, items) {
	              return _this4.props.createRiderItems(rider.id, parent, items);
	            },
	            editRiderItem: function editRiderItem(item) {
	              return _this4.props.editRiderItem(rider.id, item);
	            },
	            moveRiderItem: function moveRiderItem(_ref4) {
	              var id = _ref4.id,
	                  position = _ref4.position;
	              return _this4.props.moveRiderItem(id, position);
	            },
	            deleteRiderItem: function deleteRiderItem(id) {
	              return _this4.props.deleteRiderItem(id);
	            },
	            setModal: function setModal(name, data) {
	              return _this4.props.setModal(name, data);
	            } }),
	          _react2.default.createElement('div', { className: 'page-break' }),
	          _react2.default.createElement(_output2.default, { ref: this.output,
	            view: view,
	            group: 'output',
	            rider: {
	              id: rider.id,
	              items: rider.output,
	              // itemGroups: rider.itemGroups,
	              input: rider.input,
	              columns: rider.output,
	              // editable: rider.editable,
	              members: rider.members
	            },
	            moveRiderColumn: function moveRiderColumn(column) {
	              return _this4.props.moveRiderColumn(column);
	            },
	            stageElements: stageElements,
	            createStageElement: function createStageElement(stageElement) {
	              return _this4.props.createStageElement(stageElement);
	            },
	            getSearchResults: function getSearchResults(array, term) {
	              return _this4.props.getSearchResults(array, term);
	            },
	            addRiderItem: function addRiderItem(item) {
	              return _this4.props.addRiderItem(item);
	            },
	            removeRiderItem: function removeRiderItem(item) {
	              return _this4.props.removeRiderItem(item);
	            },
	            createRiderItem: function createRiderItem(item) {
	              return _this4.props.createRiderItem(rider.id, item);
	            },
	            createRiderItems: function createRiderItems(item) {
	              var parentItem = (0, _immutabilityHelper2.default)(item, {
	                $merge: {
	                  type: item.type,
	                  group: 'output',
	                  class: 'monitor-group',
	                  member: item.member,
	                  value: item.value
	                }
	              });
	
	              var childItem = (0, _immutabilityHelper2.default)(item, {
	                $merge: {
	                  type: item.type,
	                  group: 'output',
	                  class: 'monitor'
	                }
	              });
	
	              _this4.props.createRiderItems(rider.id, parentItem, [childItem, childItem]);
	            },
	            cloneRiderItem: function cloneRiderItem(item) {
	              var parentItem = {
	                type: item.type,
	                group: 'output',
	                class: 'monitor-group',
	                position: item.position,
	                title: item.title,
	                member: item.member && item.member.id,
	                value: item.value
	              };
	
	              _this4.props.cloneRiderItem(rider.id, {
	                parent_create: parentItem,
	                parent: null,
	                clone_item: item.id,
	                clone_count: 2,
	                delete_cloned: true
	              });
	            },
	            editRiderItem: function editRiderItem(item) {
	              return _this4.props.editRiderItem(rider.id, item);
	            },
	            moveRiderItem: function moveRiderItem(_ref5) {
	              var id = _ref5.id,
	                  position = _ref5.position;
	              return _this4.props.moveRiderItem(id, position);
	            },
	            deleteRiderItem: function deleteRiderItem(id) {
	              return _this4.props.deleteRiderItem(id);
	            },
	            deleteRiderItemGroup: function deleteRiderItemGroup(item) {
	              return _this4.props.deleteRiderItemGroup(item);
	            },
	            setModal: function setModal(name, data) {
	              return _this4.props.setModal(name, data);
	            } }),
	          _react2.default.createElement('div', { className: 'page-break' }),
	          _react2.default.createElement(_stageplans2.default, { ref: this.stageplan,
	            view: view,
	            stageplans: rider.stageplans,
	            categories: {
	              members: rider.members,
	              instruments: rider.input,
	              monitors: rider.output,
	              misc: stageElements.stageplanItems
	            },
	            createRiderStageplan: function createRiderStageplan(stageplan) {
	              return _this4.props.createRiderStageplan(rider.id, stageplan);
	            },
	            editRiderStageplan: function editRiderStageplan(stageplan) {
	              return _this4.props.editRiderStageplan(stageplan);
	            },
	            deleteRiderStageplan: function deleteRiderStageplan(id) {
	              return _this4.props.deleteRiderStageplan(id);
	            },
	            addRiderStageplanItem: function addRiderStageplanItem(item) {
	              return _this4.props.addRiderStageplanItem(item);
	            },
	            removeRiderStageplanItem: function removeRiderStageplanItem(index) {
	              return _this4.props.removeRiderStageplanItem(index);
	            },
	            createRiderStageplanItem: function createRiderStageplanItem(id, item) {
	              return _this4.props.createRiderStageplanItem(id, item);
	            },
	            editRiderStageplanItem: function editRiderStageplanItem(item, index) {
	              return _this4.props.editRiderStageplanItem(item, index);
	            },
	            deleteRiderStageplanItem: function deleteRiderStageplanItem(id, index) {
	              return _this4.props.deleteRiderStageplanItem(id, index);
	            } }),
	          _react2.default.createElement('div', { className: 'page-break' }),
	          _react2.default.createElement(_hospitality2.default, { ref: this.hospitality,
	            view: view,
	            rider: rider,
	            addRiderItem: function addRiderItem(item) {
	              return _this4.props.addRiderItem(item);
	            },
	            removeRiderItem: function removeRiderItem(item) {
	              return _this4.props.removeRiderItem(item);
	            },
	            createRiderItem: function createRiderItem(item) {
	              return _this4.props.createRiderItem(rider.id, item);
	            },
	            editRiderItem: function editRiderItem(item) {
	              return _this4.props.editRiderItem(rider.id, item);
	            },
	            moveRiderItem: function moveRiderItem(_ref6) {
	              var id = _ref6.id,
	                  position = _ref6.position;
	              return _this4.props.moveRiderItem(id, position);
	            },
	            deleteRiderItem: function deleteRiderItem(id) {
	              return _this4.props.deleteRiderItem(id);
	            },
	            setModal: function setModal(name, data) {
	              return _this4.props.setModal(name, data);
	            } }),
	          _react2.default.createElement('div', { className: 'page-break' }),
	          _react2.default.createElement(_contacts2.default, { ref: this.contacts,
	            view: view,
	            contacts: rider.contacts,
	            addRiderContact: function addRiderContact(contact) {
	              return _this4.props.addRiderContact(contact);
	            },
	            removeRiderContact: function removeRiderContact(index) {
	              return _this4.props.removeRiderContact(index);
	            },
	            createRiderContact: function createRiderContact(contact) {
	              return _this4.props.createRiderContact(rider.id, contact);
	            },
	            editRiderContact: function editRiderContact(contact) {
	              return _this4.props.editRiderContact(contact);
	            },
	            deleteRiderContact: function deleteRiderContact(contact) {
	              return _this4.props.deleteRiderContact(contact);
	            } })
	        )
	      );
	    }
	  }]);
	
	  return Rider;
	}(_react.Component);
	
	Rider.propTypes = {
	  match: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired,
	  userSession: _propTypes2.default.object,
	  rider: _propTypes2.default.object,
	  fetchRider: _propTypes2.default.func,
	  editRider: _propTypes2.default.func,
	  shareRider: _propTypes2.default.func,
	  removeRiderShare: _propTypes2.default.func,
	  exportRider: _propTypes2.default.func,
	  deleteRider: _propTypes2.default.func,
	  addRiderContact: _propTypes2.default.func,
	  removeRiderContact: _propTypes2.default.func,
	  createRiderContact: _propTypes2.default.func,
	  editRiderContact: _propTypes2.default.func,
	  deleteRiderContact: _propTypes2.default.func,
	  addRiderMember: _propTypes2.default.func,
	  removeRiderMember: _propTypes2.default.func,
	  createRiderMember: _propTypes2.default.func,
	  editRiderMember: _propTypes2.default.func,
	  moveRiderMember: _propTypes2.default.func,
	  deleteRiderMember: _propTypes2.default.func,
	  addRiderColumn: _propTypes2.default.func,
	  removeRiderColumn: _propTypes2.default.func,
	  createRiderColumn: _propTypes2.default.func,
	  moveRiderColumn: _propTypes2.default.func,
	  addRiderItem: _propTypes2.default.func,
	  removeRiderItem: _propTypes2.default.func,
	  createRiderItem: _propTypes2.default.func,
	  createRiderItems: _propTypes2.default.func,
	  cloneRiderItem: _propTypes2.default.func,
	  editRiderItem: _propTypes2.default.func,
	  moveRiderItem: _propTypes2.default.func,
	  deleteRiderItem: _propTypes2.default.func,
	  deleteRiderItemGroup: _propTypes2.default.func,
	  stageplans: _propTypes2.default.array,
	  createRiderStageplan: _propTypes2.default.func,
	  editRiderStageplan: _propTypes2.default.func,
	  deleteRiderStageplan: _propTypes2.default.func,
	  addRiderStageplanItem: _propTypes2.default.func,
	  removeRiderStageplanItem: _propTypes2.default.func,
	  createRiderStageplanItem: _propTypes2.default.func,
	  editRiderStageplanItem: _propTypes2.default.func,
	  deleteRiderStageplanItem: _propTypes2.default.func,
	  stageElements: _propTypes2.default.object,
	  fetchStageElements: _propTypes2.default.func,
	  createStageElement: _propTypes2.default.func,
	  getAvailableEquipmentTypes: _propTypes2.default.func,
	  getSearchResults: _propTypes2.default.func,
	  setModal: _propTypes2.default.func
	};
	
	Rider.defaultProps = {
	  match: {},
	  location: {},
	  history: {},
	  userSession: {},
	  rider: {},
	  fetchRider: function fetchRider() {},
	  editRider: function editRider() {},
	  shareRider: function shareRider() {},
	  removeRiderShare: function removeRiderShare() {},
	  exportRider: function exportRider() {},
	  deleteRider: function deleteRider() {},
	  addRiderContact: function addRiderContact() {},
	  removeRiderContact: function removeRiderContact() {},
	  createRiderContact: function createRiderContact() {},
	  editRiderContact: function editRiderContact() {},
	  deleteRiderContact: function deleteRiderContact() {},
	  addRiderMember: function addRiderMember() {},
	  removeRiderMember: function removeRiderMember() {},
	  createRiderMember: function createRiderMember() {},
	  editRiderMember: function editRiderMember() {},
	  moveRiderMember: function moveRiderMember() {},
	  deleteRiderMember: function deleteRiderMember() {},
	  addRiderColumn: function addRiderColumn() {},
	  removeRiderColumn: function removeRiderColumn() {},
	  createRiderColumn: function createRiderColumn() {},
	  moveRiderColumn: function moveRiderColumn() {},
	  deleteRiderColumn: function deleteRiderColumn() {},
	  addRiderItem: function addRiderItem() {},
	  removeRiderItem: function removeRiderItem() {},
	  createRiderItem: function createRiderItem() {},
	  createRiderItems: function createRiderItems() {},
	  cloneRiderItem: function cloneRiderItem() {},
	  editRiderItem: function editRiderItem() {},
	  moveRiderItem: function moveRiderItem() {},
	  deleteRiderItem: function deleteRiderItem() {},
	  deleteRiderItemGroup: function deleteRiderItemGroup() {},
	  stageplans: [],
	  createRiderStageplan: function createRiderStageplan() {},
	  editRiderStageplan: function editRiderStageplan() {},
	  deleteRiderStageplan: function deleteRiderStageplan() {},
	  addRiderStageplanItem: function addRiderStageplanItem() {},
	  removeRiderStageplanItem: function removeRiderStageplanItem() {},
	  createRiderStageplanItem: function createRiderStageplanItem() {},
	  editRiderStageplanItem: function editRiderStageplanItem() {},
	  deleteRiderStageplanItem: function deleteRiderStageplanItem() {},
	  stageElements: {},
	  fetchStageElements: function fetchStageElements() {},
	  createStageElement: function createStageElement() {},
	  getAvailableEquipmentTypes: function getAvailableEquipmentTypes() {},
	  getSearchResults: function getSearchResults() {},
	  setModal: function setModal() {}
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    rider: state.rider,
	    stageElements: state.stageElements
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    fetchRider: _rider.fetchRider,
	    editRider: _rider.editRider,
	    shareRider: _rider.shareRider,
	    removeRiderShare: _rider.removeRiderShare,
	    exportRider: _rider.exportRider,
	    deleteRider: _rider.deleteRider,
	    addRiderContact: _riderContact.addRiderContact,
	    removeRiderContact: _riderContact.removeRiderContact,
	    createRiderContact: _riderContact.createRiderContact,
	    editRiderContact: _riderContact.editRiderContact,
	    deleteRiderContact: _riderContact.deleteRiderContact,
	    addRiderMember: _riderMember.addRiderMember,
	    removeRiderMember: _riderMember.removeRiderMember,
	    createRiderMember: _riderMember.createRiderMember,
	    editRiderMember: _riderMember.editRiderMember,
	    moveRiderMember: _riderMember.moveRiderMember,
	    deleteRiderMember: _riderMember.deleteRiderMember,
	    addRiderColumn: _riderColumn.addRiderColumn,
	    removeRiderColumn: _riderColumn.removeRiderColumn,
	    createRiderColumn: _riderColumn.createRiderColumn,
	    moveRiderColumn: _riderColumn.moveRiderColumn,
	    deleteRiderColumn: _riderColumn.deleteRiderColumn,
	    addRiderItem: _riderItem.addRiderItem,
	    removeRiderItem: _riderItem.removeRiderItem,
	    createRiderItem: _riderItem.createRiderItem,
	    createRiderItems: _riderItem.createRiderItems,
	    cloneRiderItem: _riderItem.cloneRiderItem,
	    editRiderItem: _riderItem.editRiderItem,
	    moveRiderItem: _riderItem.moveRiderItem,
	    deleteRiderItem: _riderItem.deleteRiderItem,
	    deleteRiderItemGroup: _riderItem.deleteRiderItemGroup,
	    createRiderStageplan: _riderStageplan.createRiderStageplan,
	    editRiderStageplan: _riderStageplan.editRiderStageplan,
	    deleteRiderStageplan: _riderStageplan.deleteRiderStageplan,
	    addRiderStageplanItem: _riderStageplanItem.addRiderStageplanItem,
	    removeRiderStageplanItem: _riderStageplanItem.removeRiderStageplanItem,
	    createRiderStageplanItem: _riderStageplanItem.createRiderStageplanItem,
	    editRiderStageplanItem: _riderStageplanItem.editRiderStageplanItem,
	    deleteRiderStageplanItem: _riderStageplanItem.deleteRiderStageplanItem,
	    createStageElement: _stageElements.createStageElement,
	    fetchStageElements: _stageElements.fetchStageElements,
	    getAvailableEquipmentTypes: _stageElements.getAvailableEquipmentTypes,
	    getSearchResults: _stageElements.getSearchResults,
	    setModal: _modal.setModal,
	    setAlert: _alerts.setAlert
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Rider);

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(8);
	
	var _savingIndicator = __webpack_require__(274);
	
	var _savingIndicator2 = _interopRequireDefault(_savingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Saving = function (_Component) {
	  _inherits(Saving, _Component);
	
	  function Saving() {
	    _classCallCheck(this, Saving);
	
	    return _possibleConstructorReturn(this, (Saving.__proto__ || Object.getPrototypeOf(Saving)).apply(this, arguments));
	  }
	
	  _createClass(Saving, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          pathname = _props.pathname,
	          event = _props.event,
	          rider = _props.rider;
	
	
	      return _react2.default.createElement(_savingIndicator2.default, { savingInstance: pathname.includes('event') ? { saving: event.isSaving } : { saving: rider.saving } });
	    }
	  }]);
	
	  return Saving;
	}(_react.Component);
	
	Saving.propTypes = {
	  pathanme: _propTypes2.default.string,
	  state: _propTypes2.default.object,
	  rider: _propTypes2.default.object
	};
	
	Saving.defaultProps = {
	  pathanme: '',
	  state: {},
	  rider: {}
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    event: state.event,
	    rider: state.rider
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, undefined)(Saving);

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _userSession = __webpack_require__(34);
	
	var _alerts = __webpack_require__(13);
	
	var _layout = __webpack_require__(272);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _login = __webpack_require__(59);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSession = function UserSession(WrappedComponent, props) {
	  var Authorize = function (_Component) {
	    _inherits(Authorize, _Component);
	
	    function Authorize(props) {
	      _classCallCheck(this, Authorize);
	
	      var _this = _possibleConstructorReturn(this, (Authorize.__proto__ || Object.getPrototypeOf(Authorize)).call(this, props));
	
	      _this.state = {
	        refreshTimeout: undefined
	      };
	      return _this;
	    }
	
	    _createClass(Authorize, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var userSession = this.props.userSession;
	
	
	        if (userSession.loggedIn === undefined) this.props.checkUserSession();
	        if (userSession.loggedIn) this.setUserSessionRefresh();
	        if (userSession.loggedIn && !userSession.user) this.props.getUserData();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var userSession = nextProps.userSession;
	        var refreshTimeout = this.state.refreshTimeout;
	
	
	        if (userSession.loggedIn && refreshTimeout === undefined) this.setUserSessionRefresh();
	        if (userSession.loggedIn && !userSession.user) this.props.getUserData();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var refreshTimeout = this.state.refreshTimeout;
	
	
	        if (refreshTimeout) clearTimeout(refreshTimeout);
	      }
	    }, {
	      key: 'setUserSessionRefresh',
	      value: function setUserSessionRefresh() {
	        var _this2 = this;
	
	        var refreshPeriod = _Api2.default.getTokenRefreshPeriod();
	
	        var timeout = function timeout() {
	          _Api2.default.refresh().then(function (success) {
	            return _this2.setUserSessionRefresh();
	          }).catch(function (error) {
	            _this2.props.setAlert('We could not refresh your session. Please log in again.', null, 'error');
	            _Api2.default.logout();
	          });
	        };
	
	        if (refreshPeriod) {
	          var refreshTimeout = setTimeout(timeout, refreshPeriod);
	
	          this.setState({ refreshTimeout: refreshTimeout });
	        } else {
	          this.setState({ refreshTimeout: undefined });
	        }
	      }
	    }, {
	      key: 'renderDecoratedComponent',
	      value: function renderDecoratedComponent() {
	        var _props = this.props,
	            match = _props.match,
	            location = _props.location,
	            history = _props.history,
	            userSession = _props.userSession;
	
	
	        return _react2.default.createElement(WrappedComponent, {
	          match: match,
	          location: location,
	          history: history,
	          userSession: userSession });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props2 = this.props,
	            location = _props2.location,
	            userSession = _props2.userSession;
	        var pathname = location.pathname;
	
	
	        var userAuthorized = userSession.loggedIn;
	
	        var publicComponents = pathname.indexOf('/rider') === 0 || pathname.indexOf('/login') === 0 || pathname.indexOf('/register') === 0;
	
	        return _react2.default.createElement(
	          _layout2.default,
	          { userSession: userSession, pathname: pathname },
	          userAuthorized === true || publicComponents ? this.renderDecoratedComponent() : _react2.default.createElement(_login2.default, null)
	        );
	      }
	    }]);
	
	    return Authorize;
	  }(_react.Component);
	
	  Authorize.propTypes = {
	    match: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    history: _propTypes2.default.object.isRequired,
	    userSession: _propTypes2.default.object,
	    checkUserSession: _propTypes2.default.func,
	    getUserData: _propTypes2.default.func,
	    setAlert: _propTypes2.default.func
	  };
	
	  Authorize.defaultProps = {
	    match: {},
	    location: {},
	    history: {},
	    userSession: {},
	    checkUserSession: function checkUserSession() {},
	    getUserData: function getUserData() {},
	    setAlert: function setAlert() {}
	  };
	
	  var mapStateToProps = function mapStateToProps(state) {
	    return {
	      userSession: state.userSession
	    };
	  };
	
	  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return (0, _redux.bindActionCreators)({
	      checkUserSession: _userSession.checkUserSession,
	      getUserData: _userSession.getUserData,
	      setAlert: _alerts.setAlert
	    }, dispatch);
	  };
	
	  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Authorize);
	};
	
	exports.default = UserSession;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(8);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _notifications = __webpack_require__(158);
	
	var _userSession = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var User = function (_Component) {
	  _inherits(User, _Component);
	
	  function User(props) {
	    _classCallCheck(this, User);
	
	    var _this = _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).call(this, props));
	
	    _this.state = {
	      showDropdown: false,
	      showNotificationsDropdown: false
	    };
	    return _this;
	  }
	
	  _createClass(User, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchNotifications();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var notifications = nextProps.notifications,
	          userSession = nextProps.userSession;
	
	
	      if (notifications !== this.props.notifications) return true;
	      if (userSession !== this.props.userSession) return true;
	      if (nextState !== this.state) return true;
	      return false;
	    }
	  }, {
	    key: 'removeUserSession',
	    value: function removeUserSession() {
	      this.props.removeUserSession(false);
	      this.props.history.replace({ pathname: '/' });
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown() {
	      var _this2 = this;
	
	      var userSession = this.props.userSession;
	      var user = userSession.user;
	      var showDropdown = this.state.showDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--main': true,
	        'ui-dropdown--active': showDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this2.setState({ showDropdown: !showDropdown });
	          } }) : null,
	        showDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            null,
	            user && user.email
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.setState({ showDropdown: false }, function () {
	                  return _this2.removeUserSession();
	                });
	              } },
	            'Log out'
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderNotificationsDropdown',
	    value: function renderNotificationsDropdown() {
	      var _this3 = this;
	
	      var _props = this.props,
	          notifications = _props.notifications,
	          userSession = _props.userSession;
	      var user = userSession.user;
	      var showNotificationsDropdown = this.state.showNotificationsDropdown;
	
	
	      var className = (0, _classnames2.default)({
	        'ui-dropdown': true,
	        'ui-dropdown--notifications': true,
	        'ui-dropdown--active': showNotificationsDropdown
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showNotificationsDropdown === true ? _react2.default.createElement('div', { className: 'ui-dropdown-escape', onClick: function onClick() {
	            return _this3.setState({ showNotificationsDropdown: !showNotificationsDropdown });
	          } }) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'ui-dropdown-value', onClick: function onClick() {
	              return _this3.setState({ showNotificationsDropdown: !showNotificationsDropdown });
	            } },
	          notifications.total_unseen
	        ),
	        showNotificationsDropdown === true ? _react2.default.createElement(
	          'ul',
	          { className: 'ui-dropdown-content' },
	          _react2.default.createElement(
	            'li',
	            { className: 'logout', onClick: function onClick() {
	                return _this3.setState({ showNotificationsDropdown: false }, function () {
	                  return _this3.removeUserSession();
	                });
	              } },
	            'Log out'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Recent notifications (',
	            notifications.items.length,
	            '/',
	            notifications.total_unseen,
	            ')'
	          ),
	          notifications.items.length > 0 ? notifications.items.map(function (notification, index) {
	            return _react2.default.createElement(
	              'li',
	              { key: index },
	              _react2.default.createElement(
	                'small',
	                null,
	                notification.title
	              )
	            );
	          }) : null
	        ) : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          notifications = _props2.notifications,
	          userSession = _props2.userSession;
	      var user = userSession.user;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'user' },
	        _react2.default.createElement(
	          'span',
	          { onClick: function onClick() {
	              return _this4.setState({ showNotificationsDropdown: true });
	            } },
	          user && user.email
	        ),
	        Object.keys(notifications).length > 0 && notifications.isFetching !== true ? this.renderNotificationsDropdown() : null,
	        this.renderDropdown()
	      );
	    }
	  }]);
	
	  return User;
	}(_react.Component);
	
	User.propTypes = {
	  match: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired,
	  notifications: _propTypes2.default.object,
	  fetchNotifications: _propTypes2.default.func,
	  userSession: _propTypes2.default.object,
	  removeUserSession: _propTypes2.default.func
	};
	
	User.defaultProps = {
	  match: {},
	  location: {},
	  history: {},
	  notifications: {},
	  fetchNotifications: function fetchNotifications() {},
	  userSession: {},
	  removeUserSession: function removeUserSession() {}
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    notifications: state.notifications,
	    userSession: state.userSession
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    fetchNotifications: _notifications.fetchNotifications,
	    removeUserSession: _userSession.removeUserSession
	  }, dispatch);
	};
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(User));

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapDispatchToProps = exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _userSession = __webpack_require__(34);
	
	var _loading = __webpack_require__(47);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _icons = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Verify = function (_Component) {
	  _inherits(Verify, _Component);
	
	  function Verify() {
	    _classCallCheck(this, Verify);
	
	    return _possibleConstructorReturn(this, (Verify.__proto__ || Object.getPrototypeOf(Verify)).apply(this, arguments));
	  }
	
	  _createClass(Verify, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var verificationCode = this.props.match.params.verificationCode;
	      var userSession = this.props.userSession;
	
	
	      if (verificationCode && !userSession.verification) this.props.verifyUserEmail(verificationCode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var userSession = this.props.userSession;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'verify' },
	        _react2.default.createElement('div', null),
	        userSession && userSession.verification ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_icons.SuccessIcon, null),
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Your account is all set up'
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/login' },
	            'Log in \u2192'
	          )
	        ) : userSession.error ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            userSession.error.message
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'We are verifying your account'
	          ),
	          _react2.default.createElement(_loading2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Verify;
	}(_react.Component);
	
	Verify.propTypes = {
	  userSession: _propTypes2.default.object,
	  verifyUserEmail: _propTypes2.default.func
	};
	
	Verify.defaultProps = {
	  userSession: {},
	  verifyUserEmail: function verifyUserEmail() {}
	};
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	  return {
	    userSession: state.userSession
	  };
	};
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    verifyUserEmail: _userSession.verifyUserEmail
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Verify);

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(268);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _reactRedux = __webpack_require__(8);
	
	var _redux = __webpack_require__(11);
	
	var _reduxThunk = __webpack_require__(243);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(348);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxLogger = __webpack_require__(594);
	
	var _reduxPromise = __webpack_require__(595);
	
	var _reduxPromise2 = _interopRequireDefault(_reduxPromise);
	
	var _reactGa = __webpack_require__(547);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _alerts = __webpack_require__(13);
	
	var _functions = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactGa2.default.initialize('UA-88246678-1');
	_reactGa2.default.pageview(window.location.pathname + window.location.search);
	
	var errorHandlingMiddleware = function errorHandlingMiddleware(store) {
	  return function (next) {
	    return function (action) {
	      if (action.payload && action.payload instanceof Error && action.payload.response) {
	        var _action$payload$respo = action.payload.response,
	            status = _action$payload$respo.status,
	            data = _action$payload$respo.data;
	
	        var errorMessage = data.errors ? (0, _functions.extractStrings)(data.errors) : data.message;
	
	        store.dispatch((0, _alerts.setAlert)(errorMessage || 'Sorry, we were unable to process your request at this time.', undefined, 'error'));
	      } else {
	        next(action);
	      }
	    };
	  };
	};
	
	var logger = (0, _reduxLogger.createLogger)();
	var store = (0, _redux.createStore)(_reducers2.default, (0, _redux.applyMiddleware)(_reduxThunk2.default, _reduxPromise2.default, errorHandlingMiddleware, logger));
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_App2.default, null)
	), document.getElementById('root'));

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _reduxActions = __webpack_require__(4);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _alerts = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _alerts.SET_ALERT, function (state, action) {
	  var _action$payload = action.payload,
	      message = _action$payload.message,
	      link = _action$payload.link,
	      type = _action$payload.type,
	      status = _action$payload.status;
	
	
	  return (0, _immutabilityHelper2.default)(state, { $push: [{ message: message, link: link, type: type, status: status }] });
	}), _defineProperty(_handleActions, _alerts.CLEAR_ALERT, function (state, action) {
	  var index = action.payload.index;
	
	
	  return (0, _immutabilityHelper2.default)(state, _defineProperty({}, index, {
	    $merge: { status: 'resolved' }
	  }));
	}), _defineProperty(_handleActions, _alerts.CLEAR_ALL_ALERTS, function (state, action) {
	  return [];
	}), _handleActions), []);

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _reduxActions = __webpack_require__(4);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _comments = __webpack_require__(269);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _comments.RECEIVE_COMMENTS, function (state, action) {
	  return action.payload;
	}), _defineProperty(_handleActions, _comments.ADD_COMMENT, function (state, action) {
	  return (0, _immutabilityHelper2.default)(state, {
	    items: {
	      $push: [action.payload]
	    }
	  });
	}), _defineProperty(_handleActions, _comments.CACHE_COMMENT, function (state, action) {
	  return (0, _immutabilityHelper2.default)(state, {
	    cache: { $set: action.payload }
	  });
	}), _handleActions), {});

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _reduxActions = __webpack_require__(4);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _dashboard = __webpack_require__(154);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _dashboard.REQUEST_DASHBOARD, function (state, action) {
	  return { isFetching: true };
	}), _defineProperty(_handleActions, _dashboard.RECEIVE_DASHBOARD, function (state, action) {
	  var dashboard = action.payload.data.dashboard;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    $set: {
	      events: dashboard.events,
	      riders: dashboard.riders,
	      riderRequests: dashboard.rider_requests
	    }
	  });
	
	  return state;
	}), _handleActions), {});

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _reduxActions = __webpack_require__(4);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _event = __webpack_require__(90);
	
	var _eventStage = __webpack_require__(155);
	
	var _eventUser = __webpack_require__(156);
	
	var _eventRiderRequest = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var finishSaving = function finishSaving(state) {
	  return (0, _immutabilityHelper2.default)(state, { isSaving: { $set: false } });
	};
	
	var errorHandler = function errorHandler(action_payload) {
	  var data = action_payload.data;
	
	
	  if (data.status === 'error') {
	    return {
	      error: {
	        code: action_payload.status,
	        message: data.message
	      }
	    };
	  }
	};
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _event.REQUEST_EVENT, function (state, action) {
	  return { isFetching: true };
	}), _defineProperty(_handleActions, _event.RECEIVE_EVENT, function (state, action) {
	  var error = errorHandler(action.payload);
	  if (error) return error;
	
	  var event = action.payload.data.event;
	
	
	  state = (0, _immutabilityHelper2.default)(state, { $set: event });
	
	  return state;
	}), _defineProperty(_handleActions, _event.CREATE_EVENT, function (state, action) {
	  var id = action.payload.data.id;
	
	
	  state = (0, _immutabilityHelper2.default)(state, { $set: { createdEventId: id } });
	
	  return state;
	}), _defineProperty(_handleActions, _event.EDIT_EVENT, function (state, action) {
	  var event = action.payload.data.event;
	
	
	  state = (0, _immutabilityHelper2.default)(state, { $set: event });
	
	  return state;
	}), _defineProperty(_handleActions, _event.DELETE_EVENT, function (state, action) {
	  var id = action.payload.data.id;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    deletedEventId: { $set: id }
	  });
	
	  return state;
	}), _defineProperty(_handleActions, _eventStage.UPDATE_EVENT_STAGE, function (state, action) {
	  return (0, _immutabilityHelper2.default)(state, {
	    isSaving: { $set: true }
	  });
	}), _defineProperty(_handleActions, _eventStage.CREATE_EVENT_STAGE, function (state, action) {
	  var _action$payload$data = action.payload.data,
	      event = _action$payload$data.event,
	      stage = _action$payload$data.stage;
	
	
	  state = (0, _immutabilityHelper2.default)(state, { $set: event });
	  state = (0, _immutabilityHelper2.default)(state, { createdStageId: { $set: stage.id } });
	
	  return finishSaving(state);
	}), _defineProperty(_handleActions, _event.DELETE_EVENT_STAGE, function (state, action) {
	  var _action$payload$data2 = action.payload.data,
	      id = _action$payload$data2.id,
	      event = _action$payload$data2.event;
	
	
	  state = (0, _immutabilityHelper2.default)(state, { $set: event });
	  state = (0, _immutabilityHelper2.default)(state, { deletedStageId: { $set: { id: id } } });
	
	  return state;
	}), _defineProperty(_handleActions, _eventUser.CREATE_EVENT_USER, function (state, action) {
	  var event = action.payload.data.event;
	
	
	  state = (0, _immutabilityHelper2.default)(state, { $set: event });
	
	  return finishSaving(state);
	}), _defineProperty(_handleActions, _eventUser.DELETE_EVENT_USER, function (state, action) {
	  var event = action.payload.data.event;
	
	
	  state = (0, _immutabilityHelper2.default)(state, { $set: event });
	
	  return finishSaving(state);
	}), _defineProperty(_handleActions, _eventRiderRequest.CREATE_RIDER_REQUEST, function (state, action) {
	  var event = action.payload.data.event;
	
	
	  state = (0, _immutabilityHelper2.default)(state, { $set: event });
	
	  return state;
	}), _defineProperty(_handleActions, _eventRiderRequest.FULFILL_RIDER_REQUEST, function (state, action) {
	  var event = action.payload.data.event;
	
	
	  state = (0, _immutabilityHelper2.default)(state, { $set: { createdEventId: event.id } });
	
	  return state;
	}), _defineProperty(_handleActions, _eventRiderRequest.DELETE_RIDER_REQUEST, function (state, action) {
	  var event = action.payload.data.event;
	
	
	  state = (0, _immutabilityHelper2.default)(state, { $set: event });
	
	  return state;
	}), _handleActions), {});

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(11);
	
	var _userSession = __webpack_require__(354);
	
	var _userSession2 = _interopRequireDefault(_userSession);
	
	var _notifications = __webpack_require__(351);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	var _dashboard = __webpack_require__(346);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _library = __webpack_require__(349);
	
	var _library2 = _interopRequireDefault(_library);
	
	var _rider = __webpack_require__(352);
	
	var _rider2 = _interopRequireDefault(_rider);
	
	var _event = __webpack_require__(347);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _stageElements = __webpack_require__(353);
	
	var _stageElements2 = _interopRequireDefault(_stageElements);
	
	var _alerts = __webpack_require__(344);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _modal = __webpack_require__(350);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _comments = __webpack_require__(345);
	
	var _comments2 = _interopRequireDefault(_comments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
	  userSession: _userSession2.default,
	  notifications: _notifications2.default,
	  dashboard: _dashboard2.default,
	  library: _library2.default,
	  rider: _rider2.default,
	  event: _event2.default,
	  stageElements: _stageElements2.default,
	  alerts: _alerts2.default,
	  modal: _modal2.default,
	  comments: _comments2.default
	});
	
	exports.default = rootReducer;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _reduxActions = __webpack_require__(4);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _library = __webpack_require__(157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _library.REQUEST_EVENT_LIST, function (state, action) {
	  var _state = state,
	      event = _state.event;
	
	
	  if (event && Object.keys(event).length === 0) {
	    state = (0, _immutabilityHelper2.default)(state, {
	      event: { $set: {
	          isFetching: true
	        } }
	    });
	  }
	
	  return state;
	}), _defineProperty(_handleActions, _library.RECEIVE_EVENT_LIST, function (state, action) {
	  var event_items = action.payload.data.events;
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    event: { $set: {
	        items: event_items
	      } }
	  });
	
	  return state;
	}), _defineProperty(_handleActions, _library.REQUEST_RIDER_LIST, function (state, action) {
	  var _state2 = state,
	      rider = _state2.rider;
	
	
	  if (rider && Object.keys(rider).length === 0) {
	    state = (0, _immutabilityHelper2.default)(state, {
	      rider: { $set: {
	          isFetching: true
	        } }
	    });
	  }
	
	  return state;
	}), _defineProperty(_handleActions, _library.RECEIVE_RIDER_LIST, function (state, action) {
	  var rider_items = action.payload.data.riders;
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    rider: { $set: {
	        items: rider_items
	      } }
	  });
	
	  return state;
	}), _handleActions), {
	  event: {},
	  rider: {}
	});

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _reduxActions = __webpack_require__(4);
	
	var _modal = __webpack_require__(33);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _modal.SET_MODAL, function (state, action) {
	  return (0, _immutabilityHelper2.default)(state, {
	    $set: {
	      name: action.payload.name,
	      data: action.payload.data
	    }
	  });
	}), _defineProperty(_handleActions, _modal.CLEAR_MODAL, function (state, action) {
	  return (0, _immutabilityHelper2.default)(state, {
	    $set: {}
	  });
	}), _handleActions), {});

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _reduxActions = __webpack_require__(4);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _notifications = __webpack_require__(158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _notifications.REQUEST_NOTIFICATIONS, function (state, action) {
	  return { isFetching: true };
	}), _defineProperty(_handleActions, _notifications.RECEIVE_NOTIFICATIONS, function (state, action) {
	  var _action$payload$data = action.payload.data,
	      total_unseen = _action$payload$data.total_unseen,
	      notifications = _action$payload$data.notifications;
	
	
	  return {
	    total_unseen: total_unseen,
	    items: notifications
	  };
	}), _handleActions), {});

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _reduxActions = __webpack_require__(4);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _rider = __webpack_require__(21);
	
	var _riderContact = __webpack_require__(160);
	
	var _riderMember = __webpack_require__(161);
	
	var _riderColumn = __webpack_require__(159);
	
	var _riderItem = __webpack_require__(91);
	
	var _riderStageplan = __webpack_require__(92);
	
	var _riderStageplanItem = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getAvailableItems = function getAvailableItems(items, members) {
	  var availableItems = [].concat(_toConsumableArray(items)); // duplicate in order not to mutate data
	
	  members.forEach(function (member, index) {
	    member.items.forEach(function (memberItem, index) {
	      var itemIndex = availableItems.map(function (item) {
	        return item.id;
	      }).indexOf(memberItem.id);
	
	      if (itemIndex !== -1) availableItems.splice(itemIndex, 1);
	    });
	  });
	
	  return availableItems;
	};
	
	var mapChildrenToRow = function mapChildrenToRow(item, columns) {
	  var row = [];
	
	  if (columns && columns.length > 0) {
	    columns.forEach(function (column) {
	      if (column.type === 'instrument') {
	        row = (0, _immutabilityHelper2.default)(row, { $push: [item] });
	      } else {
	        var children = item.children;
	
	
	        var childIndex = column.type === 'custom' ? children.map(function (equipment) {
	          return equipment.params && equipment.params.columnId;
	        }).indexOf(column.id) : children.map(function (equipment) {
	          return equipment.type.slug;
	        }).indexOf(column.type);
	
	        if (childIndex !== -1) {
	          row = (0, _immutabilityHelper2.default)(row, { $push: [children[childIndex]] });
	        } else {
	          row = (0, _immutabilityHelper2.default)(row, {
	            $push: [{
	              class: 'equipment',
	              type: {
	                title: column.title,
	                slug: column.type
	              },
	              parent: item.id,
	              params: {
	                columnId: column.id
	              }
	            }]
	          });
	        }
	      }
	    });
	  }
	
	  return row;
	};
	
	var mapChildrenToRows = function mapChildrenToRows(items, columns) {
	  items.forEach(function (item, index) {
	    if (item.class === 'instrument') {
	      var row = mapChildrenToRow(item, columns);
	
	      items = (0, _immutabilityHelper2.default)(items, _defineProperty({}, index, {
	        row: { $set: row }
	      }));
	    } else if (item.class === 'instrument-group') {
	      var children = item.children;
	
	
	      children.forEach(function (child, childIndex) {
	        if (child.class === 'instrument') {
	          var _row = mapChildrenToRow(child, columns);
	
	          items = (0, _immutabilityHelper2.default)(items, _defineProperty({}, index, {
	            children: _defineProperty({}, childIndex, {
	              row: { $set: _row }
	            })
	          }));
	        }
	      });
	    }
	  });
	
	  return items;
	};
	
	var mapInstrumentsToMonitor = function mapInstrumentsToMonitor(instruments, monitor) {
	  var faders = [];
	
	  instruments.forEach(function (instrument) {
	    if (instrument.class.includes('instrument')) {
	      var children = monitor.children;
	
	      var childIndex = children.map(function (fader) {
	        return fader.relation;
	      }).indexOf(instrument.id);
	
	      if (childIndex !== -1) {
	        faders = (0, _immutabilityHelper2.default)(faders, { $push: [children[childIndex]] });
	      } else {
	        faders = (0, _immutabilityHelper2.default)(faders, {
	          $push: [{
	            class: 'fader',
	            // type: {
	            //   title: column.title,
	            //   slug: column.type
	            // },
	            value: 5,
	            parent: monitor.id,
	            relation: instrument.id
	          }]
	        });
	      }
	    }
	  });
	
	  return faders;
	};
	
	var mapInstrumentsToMonitors = function mapInstrumentsToMonitors(instruments, monitors) {
	  monitors.forEach(function (monitor, index) {
	    if (monitor.class === 'monitor') {
	      var faders = mapInstrumentsToMonitor(instruments, monitor);
	
	      monitors = (0, _immutabilityHelper2.default)(monitors, _defineProperty({}, index, {
	        faders: { $set: faders }
	      }));
	    } else if (monitor.class === 'monitor-group') {
	      var children = monitor.children;
	
	
	      children.forEach(function (child, childIndex) {
	        if (child.class === 'monitor') {
	          var _faders = mapInstrumentsToMonitor(instruments, child);
	
	          monitors = (0, _immutabilityHelper2.default)(monitors, _defineProperty({}, index, {
	            children: _defineProperty({}, childIndex, {
	              faders: { $set: _faders }
	            })
	          }));
	        }
	      });
	    }
	  });
	
	  return monitors;
	};
	
	var mapItemsToGroups = function mapItemsToGroups(items) {
	  var itemGroups = [];
	
	  items.forEach(function (item) {
	    if (item.class === 'instrument-group') {
	      itemGroups = (0, _immutabilityHelper2.default)(itemGroups, { $push: [item] });
	    }
	  });
	
	  return itemGroups;
	};
	
	var saveRider = function saveRider(state) {
	  return (0, _immutabilityHelper2.default)(state, { saving: { $set: false } });
	};
	
	// const errorHandler = (action_payload) => {
	//   if (action_payload instanceof Error) {
	//     const { status, data } = action_payload.response
	//     const { message } = data
	//
	//     return {
	//       error: {
	//         status,
	//         message
	//       }
	//     }
	//   }
	// }
	
	var errorHandler = function errorHandler(action_payload) {
	  var data = action_payload.data;
	
	
	  if (data.status === 'error') {
	    return {
	      error: {
	        code: action_payload.status,
	        message: data.message
	      }
	    };
	  }
	};
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _rider.SAVE_RIDER, function (state, action) {
	  return (0, _immutabilityHelper2.default)(state, {
	    saving: { $set: true }
	    // error: {$set: false}
	  });
	}), _defineProperty(_handleActions, _rider.RIDER_SAVING, function (state, action) {
	  var saving = action.payload;
	
	  // if (saving && saving.type === 'error') {
	  //   state = update(state, {
	  //     error: {$set: true}
	  //   })
	  // }
	
	  return (0, _immutabilityHelper2.default)(state, { saving: { $set: false } });
	}), _defineProperty(_handleActions, _rider.REQUEST_RIDER, function (state, action) {
	  return { isFetching: true };
	}), _defineProperty(_handleActions, _rider.RECEIVE_RIDER, function (state, action) {
	  var error = errorHandler(action.payload);
	  if (error) return error;
	
	  var rider = action.payload.data.rider;
	
	
	  return (0, _immutabilityHelper2.default)(rider, {
	    availableItems: { $set: getAvailableItems(rider.input, rider.members) },
	    itemGroups: { $set: mapItemsToGroups(rider.input) },
	    input: { $set: mapChildrenToRows(rider.input, rider.columns) },
	    output: { $set: mapInstrumentsToMonitors(rider.input, rider.output) },
	    stageplans: { $set: rider.stageplans }
	  });
	}), _defineProperty(_handleActions, _rider.CREATE_RIDER, function (state, action) {
	  state = (0, _immutabilityHelper2.default)(state, {
	    $merge: { createdRiderId: action.payload.data.id }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _rider.EDIT_RIDER, function (state, action) {
	  var rider = action.payload.data.rider;
	
	
	  state = (0, _immutabilityHelper2.default)(rider, {
	    availableItems: { $set: getAvailableItems(rider.input, rider.members) },
	    itemGroups: { $set: mapItemsToGroups(rider.input) },
	    input: { $set: mapChildrenToRows(rider.input, rider.columns) },
	    output: { $set: mapInstrumentsToMonitors(rider.input, rider.output) },
	    stageplans: { $set: rider.stageplans }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _rider.SHARE_RIDER, function (state, action) {
	  state = (0, _immutabilityHelper2.default)(state, {
	    shares: { $set: action.payload.data.shares }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _rider.REMOVE_RIDER_SHARE, function (state, action) {
	  state = (0, _immutabilityHelper2.default)(state, {
	    shares: { $set: action.payload.data.shares }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _rider.REQUEST_RIDER_EXPORT, function (state, action) {
	  return state = (0, _immutabilityHelper2.default)(state, {
	    editable: { $set: false },
	    isExporting: { $set: true }
	  });
	}), _defineProperty(_handleActions, _rider.RECEIVE_RIDER_EXPORT, function (state, action) {
	  return state = (0, _immutabilityHelper2.default)(state, {
	    editable: { $set: true },
	    isExporting: { $set: false }
	  });
	}), _defineProperty(_handleActions, _rider.DELETE_RIDER, function (state, action) {
	  if (action.payload instanceof Error || action.payload.data.status !== 'success') {
	    // TODO
	  }
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    deletedRiderId: { $set: action.payload.data.id }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderContact.ADD_RIDER_CONTACT, function (state, action) {
	  var _state = state,
	      contacts = _state.contacts;
	
	  var contactsLength = contacts.length;
	
	  if (contactsLength === 0 || contacts[contactsLength - 1].id !== undefined) {
	    var contact = action.payload.contact;
	
	
	    state = (0, _immutabilityHelper2.default)(state, {
	      contacts: { $push: [contact] }
	    });
	  }
	
	  return state;
	}), _defineProperty(_handleActions, _riderContact.REMOVE_RIDER_CONTACT, function (state, action) {
	  var index = action.payload.index;
	
	
	  if (index !== undefined) {
	    state = (0, _immutabilityHelper2.default)(state, {
	      contacts: { $splice: [[index, 1]] }
	    });
	  }
	
	  return state;
	}), _defineProperty(_handleActions, _riderContact.CREATE_RIDER_CONTACT, function (state, action) {
	  var contacts = action.payload.data.rider_contacts;
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    contacts: { $set: contacts }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderContact.EDIT_RIDER_CONTACT, function (state, action) {
	  var contacts = action.payload.data.rider_contacts;
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    contacts: { $set: contacts }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderContact.DELETE_RIDER_CONTACT, function (state, action) {
	  var contacts = action.payload.data.rider_contacts;
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    contacts: { $set: contacts }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderMember.ADD_RIDER_MEMBER, function (state, action) {
	  var _state2 = state,
	      members = _state2.members;
	
	  var membersLength = members.length;
	
	  if (membersLength === 0 || members[membersLength - 1].id !== undefined) {
	    var member = action.payload.member;
	
	
	    state = (0, _immutabilityHelper2.default)(state, {
	      members: { $push: [member] }
	    });
	  }
	
	  return state;
	}), _defineProperty(_handleActions, _riderMember.REMOVE_RIDER_MEMBER, function (state, action) {
	  var index = action.payload.index;
	
	
	  if (index !== undefined) {
	    state = (0, _immutabilityHelper2.default)(state, {
	      members: { $splice: [[index, 1]] }
	    });
	  }
	
	  return state;
	}), _defineProperty(_handleActions, _riderMember.CREATE_RIDER_MEMBER, function (state, action) {
	  var members = action.payload.data.rider_members;
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    members: { $set: members }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderMember.EDIT_RIDER_MEMBER, function (state, action) {
	  var _action$payload$data = action.payload.data,
	      rider_items = _action$payload$data.rider_items,
	      rider_input = _action$payload$data.rider_input,
	      rider_output = _action$payload$data.rider_output,
	      rider_members = _action$payload$data.rider_members;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    availableItems: { $set: getAvailableItems(rider_input, rider_members) },
	    items: { $set: rider_items },
	    input: { $set: mapChildrenToRows(rider_input, state.columns) },
	    output: { $set: mapInstrumentsToMonitors(rider_input, rider_output) },
	    members: { $set: rider_members }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderMember.MOVE_RIDER_MEMBER, function (state, action) {
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderMember.DELETE_RIDER_MEMBER, function (state, action) {
	  var members = action.payload.data.rider_members;
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    members: { $set: members }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderColumn.ADD_RIDER_COLUMN, function (state, action) {
	  var column = action.payload.column;
	
	
	  var columns = (0, _immutabilityHelper2.default)(state.columns, { $push: [column] });
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    columns: { $set: columns },
	    input: { $set: mapChildrenToRows(state.input, columns) }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderColumn.REMOVE_RIDER_COLUMN, function (state, action) {
	  var index = action.payload.index;
	
	
	  var columns = (0, _immutabilityHelper2.default)(state.columns, { $splice: [[index, 1]] });
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    columns: { $set: columns },
	    input: { $set: mapChildrenToRows(state.input, columns) }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderColumn.CREATE_RIDER_COLUMN, function (state, action) {
	  var rider_columns = action.payload.data.rider_columns;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    columns: { $set: rider_columns },
	    input: { $set: mapChildrenToRows(state.input, rider_columns) }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderColumn.MOVE_RIDER_COLUMN, function (state, action) {
	  var columns = action.payload.data.columns;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    columns: { $set: columns },
	    input: { $set: mapChildrenToRows(state.input, columns) }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderColumn.DELETE_RIDER_COLUMN, function (state, action) {
	  var columns = action.payload.data.columns;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    columns: { $set: columns },
	    input: { $set: mapChildrenToRows(state.input, columns) }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderItem.ADD_RIDER_ITEM, function (state, action) {
	  var item = action.payload.item;
	  var group = item.group,
	      indexes = item.indexes;
	
	
	  if (indexes[2] !== undefined) {
	    return (0, _immutabilityHelper2.default)(state, _defineProperty({}, group, _defineProperty({}, indexes[0], {
	      children: _defineProperty({}, indexes[1], {
	        children: { $splice: [[indexes[2], 0, item]] }
	      })
	    })));
	  } else if (indexes[1] !== undefined) {
	    return (0, _immutabilityHelper2.default)(state, _defineProperty({}, group, _defineProperty({}, indexes[0], {
	      children: { $splice: [[indexes[1], 0, item]] }
	    })));
	  } else if (indexes[0] !== undefined) {
	    return (0, _immutabilityHelper2.default)(state, _defineProperty({}, group, { $splice: [[indexes[0], 0, item]] }));
	  }
	
	  return state;
	}), _defineProperty(_handleActions, _riderItem.REMOVE_RIDER_ITEM, function (state, action) {
	  var item = action.payload.item;
	  var group = item.group,
	      indexes = item.indexes;
	
	
	  if (indexes[2] !== undefined) {
	    return (0, _immutabilityHelper2.default)(state, _defineProperty({}, group, _defineProperty({}, indexes[0], {
	      children: _defineProperty({}, indexes[1], {
	        children: { $splice: [[indexes[2], 1]] }
	      })
	    })));
	  } else if (indexes[1] !== undefined) {
	    return (0, _immutabilityHelper2.default)(state, _defineProperty({}, group, _defineProperty({}, indexes[0], {
	      children: { $splice: [[indexes[1], 1]] }
	    })));
	  } else if (indexes[0] !== undefined) {
	    return (0, _immutabilityHelper2.default)(state, _defineProperty({}, group, { $splice: [[indexes[0], 1]] }));
	  }
	
	  return state;
	}), _defineProperty(_handleActions, _riderItem.CREATE_RIDER_ITEM, function (state, action) {
	  var _action$payload$data2 = action.payload.data,
	      item = _action$payload$data2.item,
	      rider_items = _action$payload$data2.rider_items,
	      rider_input = _action$payload$data2.rider_input,
	      rider_output = _action$payload$data2.rider_output,
	      rider_members = _action$payload$data2.rider_members,
	      rider_tech_requirements = _action$payload$data2.rider_tech_requirements,
	      rider_non_tech_requirements = _action$payload$data2.rider_non_tech_requirements,
	      rider_hospitality = _action$payload$data2.rider_hospitality;
	
	
	  var createChildren = [];
	  if (item.params && item.params.createChildren && item.params.createChildren.length > 0) {
	    createChildren = item.params.createChildren;
	
	    createChildren.forEach(function (value, index) {
	      createChildren = (0, _immutabilityHelper2.default)(createChildren, _defineProperty({}, index, {
	        group: { $set: item.group },
	        class: { $set: "instrument" },
	        position: { $set: index + 1 },
	        parent: { $set: item.id }
	      }));
	    });
	  }
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    createChildren: { $set: createChildren },
	    items: { $set: rider_items },
	    availableItems: { $set: getAvailableItems(rider_input, rider_members) },
	    itemGroups: { $set: mapItemsToGroups(rider_input) },
	    input: { $set: mapChildrenToRows(rider_input, state.columns) },
	    output: { $set: mapInstrumentsToMonitors(rider_input, rider_output) },
	    members: { $set: rider_members },
	    tech_requirements: { $set: rider_tech_requirements },
	    non_tech_requirements: { $set: rider_non_tech_requirements },
	    hospitality: { $set: rider_hospitality }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderItem.CREATE_RIDER_ITEMS, function (state, action) {
	  var _action$payload$data3 = action.payload.data,
	      rider_items = _action$payload$data3.rider_items,
	      rider_input = _action$payload$data3.rider_input,
	      rider_output = _action$payload$data3.rider_output,
	      rider_members = _action$payload$data3.rider_members,
	      rider_tech_requirements = _action$payload$data3.rider_tech_requirements,
	      rider_non_tech_requirements = _action$payload$data3.rider_non_tech_requirements,
	      rider_hospitality = _action$payload$data3.rider_hospitality;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    items: { $set: rider_items },
	    availableItems: { $set: getAvailableItems(rider_input, rider_members) },
	    itemGroups: { $set: mapItemsToGroups(rider_input) },
	    input: { $set: mapChildrenToRows(rider_input, state.columns) },
	    output: { $set: mapInstrumentsToMonitors(rider_input, rider_output) },
	    tech_requirements: { $set: rider_tech_requirements },
	    non_tech_requirements: { $set: rider_non_tech_requirements },
	    hospitality: { $set: rider_hospitality }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderItem.CLONE_RIDER_ITEM, function (state, action) {
	  var _action$payload$data4 = action.payload.data,
	      rider_items = _action$payload$data4.rider_items,
	      rider_input = _action$payload$data4.rider_input,
	      rider_output = _action$payload$data4.rider_output,
	      rider_members = _action$payload$data4.rider_members,
	      rider_tech_requirements = _action$payload$data4.rider_tech_requirements,
	      rider_non_tech_requirements = _action$payload$data4.rider_non_tech_requirements,
	      rider_hospitality = _action$payload$data4.rider_hospitality;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    items: { $set: rider_items },
	    availableItems: { $set: getAvailableItems(rider_input, rider_members) },
	    itemGroups: { $set: mapItemsToGroups(rider_input) },
	    input: { $set: mapChildrenToRows(rider_input, state.columns) },
	    output: { $set: mapInstrumentsToMonitors(rider_input, rider_output) },
	    tech_requirements: { $set: rider_tech_requirements },
	    non_tech_requirements: { $set: rider_non_tech_requirements },
	    hospitality: { $set: rider_hospitality }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderItem.EDIT_RIDER_ITEM, function (state, action) {
	  var _action$payload$data5 = action.payload.data,
	      rider_items = _action$payload$data5.rider_items,
	      rider_input = _action$payload$data5.rider_input,
	      rider_output = _action$payload$data5.rider_output,
	      rider_members = _action$payload$data5.rider_members,
	      rider_tech_requirements = _action$payload$data5.rider_tech_requirements,
	      rider_non_tech_requirements = _action$payload$data5.rider_non_tech_requirements,
	      rider_hospitality = _action$payload$data5.rider_hospitality;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    items: { $set: rider_items },
	    availableItems: { $set: getAvailableItems(rider_input, rider_members) },
	    itemGroups: { $set: mapItemsToGroups(rider_input) },
	    input: { $set: mapChildrenToRows(rider_input, state.columns) },
	    output: { $set: mapInstrumentsToMonitors(rider_input, rider_output) },
	    members: { $set: rider_members },
	    tech_requirements: { $set: rider_tech_requirements },
	    non_tech_requirements: { $set: rider_non_tech_requirements },
	    hospitality: { $set: rider_hospitality }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderItem.MOVE_RIDER_ITEM, function (state, action) {
	  var _action$payload$data6 = action.payload.data,
	      rider_items = _action$payload$data6.rider_items,
	      rider_input = _action$payload$data6.rider_input,
	      rider_output = _action$payload$data6.rider_output,
	      rider_members = _action$payload$data6.rider_members,
	      rider_tech_requirements = _action$payload$data6.rider_tech_requirements,
	      rider_non_tech_requirements = _action$payload$data6.rider_non_tech_requirements,
	      rider_hospitality = _action$payload$data6.rider_hospitality;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    items: { $set: rider_items },
	    availableItems: { $set: getAvailableItems(rider_input, rider_members) },
	    itemGroups: { $set: mapItemsToGroups(rider_input) },
	    input: { $set: mapChildrenToRows(rider_input, state.columns) },
	    output: { $set: mapInstrumentsToMonitors(rider_input, rider_output) },
	    tech_requirements: { $set: rider_tech_requirements },
	    non_tech_requirements: { $set: rider_non_tech_requirements },
	    hospitality: { $set: rider_hospitality }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderItem.DELETE_RIDER_ITEM, function (state, action) {
	  var _action$payload$data7 = action.payload.data,
	      rider_items = _action$payload$data7.rider_items,
	      rider_input = _action$payload$data7.rider_input,
	      rider_output = _action$payload$data7.rider_output,
	      rider_members = _action$payload$data7.rider_members,
	      rider_tech_requirements = _action$payload$data7.rider_tech_requirements,
	      rider_non_tech_requirements = _action$payload$data7.rider_non_tech_requirements,
	      rider_hospitality = _action$payload$data7.rider_hospitality;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    items: { $set: rider_items },
	    availableItems: { $set: getAvailableItems(rider_input, rider_members) },
	    itemGroups: { $set: mapItemsToGroups(rider_input) },
	    input: { $set: mapChildrenToRows(rider_input, state.columns) },
	    output: { $set: mapInstrumentsToMonitors(rider_input, rider_output) },
	    tech_requirements: { $set: rider_tech_requirements },
	    non_tech_requirements: { $set: rider_non_tech_requirements },
	    hospitality: { $set: rider_hospitality }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderStageplan.CREATE_RIDER_STAGEPLAN, function (state, action) {
	  var rider_stageplans = action.payload.data.rider_stageplans;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    stageplans: { $set: rider_stageplans }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderStageplan.EDIT_RIDER_STAGEPLAN, function (state, action) {
	  var rider_stageplans = action.payload.data.rider_stageplans;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    stageplans: { $set: rider_stageplans }
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderStageplan.DELETE_RIDER_STAGEPLAN, function (state, action) {
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderStageplanItem.ADD_RIDER_STAGEPLAN_ITEM, function (state, action) {
	  var item = action.payload.item;
	  var items = state.stageplans[0].items;
	
	
	  items = (0, _immutabilityHelper2.default)(items, { $push: [item] });
	
	  return (0, _immutabilityHelper2.default)(state, {
	    stageplans: _defineProperty({}, 0, {
	      items: { $set: items }
	    })
	  });
	}), _defineProperty(_handleActions, _riderStageplanItem.REMOVE_RIDER_STAGEPLAN_ITEM, function (state, action) {
	  var index = action.payload.index;
	
	
	  return (0, _immutabilityHelper2.default)(state, {
	    stageplans: _defineProperty({}, 0, {
	      items: { $splice: [[index, 1]] }
	    })
	  });
	}), _defineProperty(_handleActions, _riderStageplanItem.CREATE_RIDER_STAGEPLAN_ITEM, function (state, action) {
	  var _action$payload$data8 = action.payload.data,
	      rider_input = _action$payload$data8.rider_input,
	      rider_output = _action$payload$data8.rider_output,
	      rider_members = _action$payload$data8.rider_members,
	      stageplan_items = _action$payload$data8.stageplan_items;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    input: { $set: mapChildrenToRows(rider_input, state.columns) },
	    output: { $set: mapInstrumentsToMonitors(rider_input, rider_output) },
	    members: { $set: rider_members },
	    stageplans: _defineProperty({}, 0, {
	      items: { $set: stageplan_items }
	    })
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderStageplanItem.EDIT_RIDER_STAGEPLAN_ITEM, function (state, action) {
	  var _action$payload = action.payload,
	      data = _action$payload.data,
	      index = _action$payload.index;
	
	  var stageplanItem = data.item;
	  // const {
	  //   rider_input,
	  //   rider_output,
	  //   rider_members
	  // } = action.payload.data
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    // input: {$set: mapChildrenToRows(rider_input, state.columns)},
	    // output: {$set: mapInstrumentsToMonitors(rider_input, rider_output)},
	    // members: {$set: rider_members},
	    stageplans: _defineProperty({}, 0, {
	      items: _defineProperty({}, index, { $set: stageplanItem })
	    })
	  });
	
	  return saveRider(state);
	}), _defineProperty(_handleActions, _riderStageplanItem.DELETE_RIDER_STAGEPLAN_ITEM, function (state, action) {
	  // const { index } = action.payload
	  var _action$payload$data9 = action.payload.data,
	      rider_input = _action$payload$data9.rider_input,
	      rider_output = _action$payload$data9.rider_output,
	      rider_members = _action$payload$data9.rider_members,
	      stageplan_items = _action$payload$data9.stageplan_items;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    input: { $set: mapChildrenToRows(rider_input, state.columns) },
	    output: { $set: mapInstrumentsToMonitors(rider_input, rider_output) },
	    members: { $set: rider_members },
	    stageplans: _defineProperty({}, 0, {
	      items: { $set: stageplan_items }
	    })
	  });
	
	  return saveRider(state);
	}), _handleActions), {});

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _reduxActions = __webpack_require__(4);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _stageElements = __webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _stageElements.REQUEST_STAGE_ELEMENTS, function (state, action) {
	  return (0, _immutabilityHelper2.default)(state, {
	    isFetching: { $set: true }
	  });
	}), _defineProperty(_handleActions, _stageElements.RECEIVE_STAGE_ELEMENTS, function (state, action) {
	  var list = action.payload.data.list;
	
	
	  var drums = [{ id: 'kickdrum', title: 'Kick drum', type: { title: 'Drums', slug: 'drums' } }, { id: 'snaredrum', title: 'Snare drum', type: { title: 'Drums', slug: 'drums' } }, { id: 'racktom', title: 'Rack tom', type: { title: 'Drums', slug: 'drums' } }, { id: 'floortom', title: 'Floor tom', type: { title: 'Drums', slug: 'drums' } }, { id: 'ohl', title: 'OH L', type: { title: 'Drums', slug: 'drums' } }, { id: 'overheadleft', title: 'Overhead - left', type: { title: 'Drums', slug: 'drums' } }, { id: 'ohr', title: 'OH R', type: { title: 'Drums', slug: 'drums' } }, { id: 'overheadr', title: 'Overhead - right', type: { title: 'Drums', slug: 'drums' } }];
	
	  var stageplanItems = [{
	    id: null,
	    title: "Stage elements",
	    type: {
	      title: "Custom",
	      slug: "custom"
	    },
	    children: [{
	      id: null,
	      title: "Piano Chair",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 50,
	      height: 50
	    }, {
	      id: null,
	      title: "Carpet",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 150,
	      height: 150
	    }, {
	      id: null,
	      title: "Risers",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 150,
	      height: 100
	    }, {
	      id: null,
	      title: "Notestand",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 100,
	      height: 25,
	      rotation: {
	        degrees: '-90',
	        radians: '-1.57'
	      }
	    }, {
	      id: null,
	      title: "Chair",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 50,
	      height: 50
	    }]
	  }, {
	    id: null,
	    title: "Electricity",
	    type: {
	      title: "Custom",
	      slug: "custom"
	    },
	    children: [{
	      id: null,
	      title: "220V",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 100,
	      height: 25,
	      rotation: {
	        degrees: '-90',
	        radians: '-1.57'
	      }
	    }, {
	      id: null,
	      title: "110V",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 100,
	      height: 25,
	      rotation: {
	        degrees: '-90',
	        radians: '-1.57'
	      }
	    }, {
	      id: null,
	      title: "Di-box",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 100,
	      height: 25,
	      rotation: {
	        degrees: '-90',
	        radians: '-1.57'
	      }
	    }]
	  }, {
	    id: null,
	    title: "Accessories",
	    type: {
	      title: "Custom",
	      slug: "custom"
	    },
	    children: [{
	      id: null,
	      title: "Cable",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 200,
	      height: 25,
	      rotation: {
	        degrees: '-90',
	        radians: '-1.57'
	      }
	    }, {
	      id: null,
	      title: "Stand/Boom",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 25,
	      height: 100,
	      rotation: {
	        degrees: '-90',
	        radians: '-1.57'
	      }
	    }, {
	      id: null,
	      title: "Snake",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 25,
	      height: 25
	    }]
	  }, {
	    id: null,
	    title: "Character",
	    type: {
	      title: "Custom",
	      slug: "custom"
	    },
	    children: [{
	      id: null,
	      title: "Artist",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 100,
	      height: 100,
	      shape: 'oval'
	    }, {
	      id: null,
	      title: "Conductor",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 100,
	      height: 100,
	      shape: 'oval'
	    }, {
	      id: null,
	      title: "Dancer",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 100,
	      height: 100,
	      shape: 'oval'
	    }]
	  }, {
	    id: null,
	    title: "Cabinets/Amps",
	    type: {
	      title: "Custom",
	      slug: "custom"
	    },
	    children: [{
	      id: null,
	      title: "Leslie Cabinet",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 100,
	      height: 25,
	      rotation: {
	        degrees: '-90',
	        radians: '-1.57'
	      }
	    }, {
	      id: null,
	      title: "Keyboard Amp",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 100,
	      height: 25,
	      rotation: {
	        degrees: '-90',
	        radians: '-1.57'
	      }
	    }, {
	      id: null,
	      title: "Guitar Amp",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 100,
	      height: 25,
	      rotation: {
	        degrees: '-90',
	        radians: '-1.57'
	      }
	    }, {
	      id: null,
	      title: "Bass Amp",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 100,
	      height: 25,
	      rotation: {
	        degrees: '-90',
	        radians: '-1.57'
	      }
	    }, {
	      id: null,
	      title: "Cabinet",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 100,
	      height: 25,
	      rotation: {
	        degrees: '-90',
	        radians: '-1.57'
	      }
	    }]
	  }, {
	    id: null,
	    title: "Electronics",
	    type: {
	      title: "Custom",
	      slug: "custom"
	    },
	    children: [{
	      id: null,
	      title: "Computer",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 50,
	      height: 50
	    }, {
	      id: null,
	      title: "Head Unit",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 50,
	      height: 50
	    }, {
	      id: null,
	      title: "Microphone",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 50,
	      height: 50
	    }, {
	      id: null,
	      title: "Headphones",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 50,
	      height: 50
	    }, {
	      id: null,
	      title: "Earphones",
	      type: {
	        title: "Custom",
	        slug: "custom"
	      },
	      width: 50,
	      height: 50
	    }]
	  }];
	
	  var mapGroupsToEquipmentTypes = function mapGroupsToEquipmentTypes(groups) {
	    var equipmentTypes = [];
	
	    Object.keys(groups).forEach(function (equipmentType) {
	      if (equipmentType !== 'instrument') equipmentTypes.push(groups[equipmentType]);
	    });
	
	    return equipmentTypes;
	  };
	
	  state = (0, _immutabilityHelper2.default)(state, { $merge: list });
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    isFetching: { $set: false },
	    groups: {
	      instrument: {
	        $merge: { groups: { drums: drums } }
	      }
	    },
	    instrument: {
	      $push: drums
	    },
	    equipmentTypes: { $set: mapGroupsToEquipmentTypes(list.groups) },
	    stageplanItems: { $set: stageplanItems }
	  });
	
	  return state;
	}), _defineProperty(_handleActions, _stageElements.CREATE_STAGE_ELEMENT, function (state, action) {
	  return state;
	}), _defineProperty(_handleActions, _stageElements.GET_AVAILABLE_EQUIPMENT_TYPES, function (state, action) {
	  var availableColumnTypes = action.payload.availableColumnTypes;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    availableColumnTypes: { $set: availableColumnTypes }
	  });
	
	  return state;
	}), _defineProperty(_handleActions, _stageElements.REQUEST_SEARCH_RESULTS, function (state, action) {
	  var term = action.payload.term;
	
	
	  return (0, _immutabilityHelper2.default)(state, {
	    search: { $set: {
	        results: undefined,
	        term: term
	      } }
	  });
	}), _defineProperty(_handleActions, _stageElements.RECEIVE_SEARCH_RESULTS, function (state, action) {
	  var _action$payload = action.payload,
	      term = _action$payload.term,
	      results = _action$payload.results;
	
	
	  return (0, _immutabilityHelper2.default)(state, {
	    search: { $set: {
	        results: results,
	        term: term
	      } }
	  });
	}), _handleActions), {});

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _Api = __webpack_require__(9);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reduxActions = __webpack_require__(4);
	
	var _immutabilityHelper = __webpack_require__(7);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _userSession = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var errorHandler = function errorHandler(action_payload) {
	  var data = action_payload.data;
	
	
	  if (data.status === 'error') {
	    return {
	      error: {
	        code: action_payload.status,
	        message: data.message
	      }
	    };
	  }
	};
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _userSession.REQUEST_USER_SESSION, function (state, action) {
	  return (0, _immutabilityHelper2.default)(state, {
	    $merge: {
	      isLoggingIn: true,
	      loggedIn: false,
	      loginToken: null,
	      user: undefined,
	      registrationRequest: undefined,
	      registration: undefined,
	      verification: undefined
	    }
	  });
	}), _defineProperty(_handleActions, _userSession.RECEIVE_USER_SESSION, function (state, action) {
	  var token = action.payload.data.token;
	
	
	  return (0, _immutabilityHelper2.default)(state, {
	    $merge: {
	      isLoggingIn: false,
	      loggedIn: !!token,
	      loginToken: token
	    }
	  });
	}), _defineProperty(_handleActions, _userSession.CHECK_USER_SESSION, function (state, action) {
	  var token = action.payload.data.token;
	
	
	  return (0, _immutabilityHelper2.default)(state, {
	    $merge: {
	      loggedIn: !!token,
	      loginToken: token
	    }
	  });
	}), _defineProperty(_handleActions, _userSession.REMOVE_USER_SESSION, function (state, action) {
	  return (0, _immutabilityHelper2.default)(state, {
	    $merge: {
	      loggedIn: false,
	      loginToken: null,
	      user: undefined
	    }
	  });
	}), _defineProperty(_handleActions, _userSession.RECEIVE_USER_REQUEST_INFO, function (state, action) {
	  var error = errorHandler(action.payload);
	  if (error) return error;
	
	  var _action$payload$data = action.payload.data,
	      email = _action$payload$data.email,
	      code = _action$payload$data.code;
	
	
	  return (0, _immutabilityHelper2.default)(state, {
	    $merge: {
	      registrationRequest: {
	        email: email,
	        code: code
	      }
	    }
	  });
	}), _defineProperty(_handleActions, _userSession.REGISTER_USER, function (state, action) {
	  var _action$payload$data2 = action.payload.data,
	      token = _action$payload$data2.token,
	      user = _action$payload$data2.user,
	      userstatus = _action$payload$data2.userstatus;
	
	
	  state = (0, _immutabilityHelper2.default)(state, {
	    $merge: {
	      loggedIn: userstatus === 'active' ? !!token : false,
	      loginToken: userstatus === 'active' ? token : null,
	      user: undefined,
	      registration: {
	        email: user && user.email
	      }
	    }
	  });
	
	  if (state.registrationRequest && state.registrationRequest.email !== user.email) {
	    state = (0, _immutabilityHelper2.default)(state, {
	      $merge: {
	        verification: {
	          required: true
	        }
	      }
	    });
	  }
	
	  return state;
	}), _defineProperty(_handleActions, _userSession.VERIFY_USER_EMAIL, function (state, action) {
	  var error = errorHandler(action.payload);
	  if (error) return error;
	
	  var _action$payload$data3 = action.payload.data,
	      token = _action$payload$data3.token,
	      user = _action$payload$data3.user;
	
	
	  return (0, _immutabilityHelper2.default)(state, {
	    $merge: {
	      loggedIn: !!token,
	      loginToken: token,
	      user: undefined,
	      verification: {
	        email: user && user.email
	      }
	    }
	  });
	}), _defineProperty(_handleActions, _userSession.REQUEST_USER_DATA, function (state, action) {
	  return (0, _immutabilityHelper2.default)(state, {
	    $merge: {
	      user: {
	        isFetching: true
	      }
	    }
	  });
	}), _defineProperty(_handleActions, _userSession.RECEIVE_USER_DATA, function (state, action) {
	  var user = action.payload.data.user;
	
	
	  return (0, _immutabilityHelper2.default)(state, {
	    $merge: {
	      user: user
	    }
	  });
	}), _handleActions), {
	  loggedIn: undefined,
	  loginToken: undefined
	});

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(362), __esModule: true };

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(363), __esModule: true };

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(364), __esModule: true };

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(368), __esModule: true };

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(369), __esModule: true };

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(370), __esModule: true };

/***/ },
/* 361 */
/***/ function(module, exports) {

	// This code has been refactored for 140 bytes
	// You can see the original here: https://github.com/twolfson/computedStyle/blob/04cd1da2e30fa45844f95f5cb1ac898e9b9ef050/lib/computedStyle.js
	var computedStyle = function (el, prop, getComputedStyle) {
	  getComputedStyle = window.getComputedStyle;
	
	  // In one fell swoop
	  return (
	    // If we have getComputedStyle
	    getComputedStyle ?
	      // Query it
	      // TODO: From CSS-Query notes, we might need (node, null) for FF
	      getComputedStyle(el) :
	
	    // Otherwise, we are in IE and use currentStyle
	      el.currentStyle
	  )[
	    // Switch to camelCase for CSSOM
	    // DEV: Grabbed from jQuery
	    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
	    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
	    prop.replace(/-(\w)/gi, function (word, letter) {
	      return letter.toUpperCase();
	    })
	  ];
	};
	
	module.exports = computedStyle;


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(182);
	__webpack_require__(392);
	module.exports = __webpack_require__(17).Array.from;


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(394);
	module.exports = __webpack_require__(17).Object.assign;


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(395);
	var $Object = __webpack_require__(17).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(396);
	var $Object = __webpack_require__(17).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(397);
	module.exports = __webpack_require__(17).Object.getPrototypeOf;


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(398);
	module.exports = __webpack_require__(17).Object.keys;


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(399);
	module.exports = __webpack_require__(17).Object.setPrototypeOf;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(401);
	__webpack_require__(400);
	__webpack_require__(402);
	__webpack_require__(403);
	module.exports = __webpack_require__(17).Symbol;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(182);
	__webpack_require__(404);
	module.exports = __webpack_require__(112).f('iterator');


/***/ },
/* 371 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 372 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(52);
	var toLength = __webpack_require__(181);
	var toAbsoluteIndex = __webpack_require__(390);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(99);
	var TAG = __webpack_require__(22)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(30);
	var createDesc = __webpack_require__(63);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(62);
	var gOPS = __webpack_require__(105);
	var pIE = __webpack_require__(74);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(29).document;
	module.exports = document && document.documentElement;


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(61);
	var ITERATOR = __webpack_require__(22)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(99);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(48);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(104);
	var descriptor = __webpack_require__(63);
	var setToStringTag = __webpack_require__(106);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(50)(IteratorPrototype, __webpack_require__(22)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(22)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 383 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(75)('meta');
	var isObject = __webpack_require__(51);
	var has = __webpack_require__(38);
	var setDesc = __webpack_require__(30).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(49)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(62);
	var gOPS = __webpack_require__(105);
	var pIE = __webpack_require__(74);
	var toObject = __webpack_require__(64);
	var IObject = __webpack_require__(173);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(49)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(30);
	var anObject = __webpack_require__(48);
	var getKeys = __webpack_require__(62);
	
	module.exports = __webpack_require__(37) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(52);
	var gOPN = __webpack_require__(176).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(51);
	var anObject = __webpack_require__(48);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(100)(Function.call, __webpack_require__(175).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(109);
	var defined = __webpack_require__(101);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(109);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(374);
	var ITERATOR = __webpack_require__(22)('iterator');
	var Iterators = __webpack_require__(61);
	module.exports = __webpack_require__(17).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(100);
	var $export = __webpack_require__(28);
	var toObject = __webpack_require__(64);
	var call = __webpack_require__(380);
	var isArrayIter = __webpack_require__(378);
	var toLength = __webpack_require__(181);
	var createProperty = __webpack_require__(375);
	var getIterFn = __webpack_require__(391);
	
	$export($export.S + $export.F * !__webpack_require__(382)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(372);
	var step = __webpack_require__(383);
	var Iterators = __webpack_require__(61);
	var toIObject = __webpack_require__(52);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(174)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(28);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(385) });


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(28);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(104) });


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(28);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(37), 'Object', { defineProperty: __webpack_require__(30).f });


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(64);
	var $getPrototypeOf = __webpack_require__(177);
	
	__webpack_require__(179)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(64);
	var $keys = __webpack_require__(62);
	
	__webpack_require__(179)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(28);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(388).set });


/***/ },
/* 400 */
/***/ function(module, exports) {



/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(29);
	var has = __webpack_require__(38);
	var DESCRIPTORS = __webpack_require__(37);
	var $export = __webpack_require__(28);
	var redefine = __webpack_require__(180);
	var META = __webpack_require__(384).KEY;
	var $fails = __webpack_require__(49);
	var shared = __webpack_require__(108);
	var setToStringTag = __webpack_require__(106);
	var uid = __webpack_require__(75);
	var wks = __webpack_require__(22);
	var wksExt = __webpack_require__(112);
	var wksDefine = __webpack_require__(111);
	var enumKeys = __webpack_require__(376);
	var isArray = __webpack_require__(379);
	var anObject = __webpack_require__(48);
	var isObject = __webpack_require__(51);
	var toIObject = __webpack_require__(52);
	var toPrimitive = __webpack_require__(110);
	var createDesc = __webpack_require__(63);
	var _create = __webpack_require__(104);
	var gOPNExt = __webpack_require__(387);
	var $GOPD = __webpack_require__(175);
	var $DP = __webpack_require__(30);
	var $keys = __webpack_require__(62);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(176).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(74).f = $propertyIsEnumerable;
	  __webpack_require__(105).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(103)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(50)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(111)('asyncIterator');


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(111)('observable');


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(393);
	var global = __webpack_require__(29);
	var hide = __webpack_require__(50);
	var Iterators = __webpack_require__(61);
	var TO_STRING_TAG = __webpack_require__(22)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LineBreaker = exports.inlineBreakOpportunities = exports.lineBreakAtIndex = exports.codePointsToCharacterClasses = exports.UnicodeTrie = exports.BREAK_ALLOWED = exports.BREAK_NOT_ALLOWED = exports.BREAK_MANDATORY = exports.classes = exports.LETTER_NUMBER_MODIFIER = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Trie = __webpack_require__(406);
	
	var _linebreakTrie = __webpack_require__(408);
	
	var _linebreakTrie2 = _interopRequireDefault(_linebreakTrie);
	
	var _Util = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LETTER_NUMBER_MODIFIER = exports.LETTER_NUMBER_MODIFIER = 50;
	
	// Non-tailorable Line Breaking Classes
	var BK = 1; //  Cause a line break (after)
	var CR = 2; //  Cause a line break (after), except between CR and LF
	var LF = 3; //  Cause a line break (after)
	var CM = 4; //  Prohibit a line break between the character and the preceding character
	var NL = 5; //  Cause a line break (after)
	var SG = 6; //  Do not occur in well-formed text
	var WJ = 7; //  Prohibit line breaks before and after
	var ZW = 8; //  Provide a break opportunity
	var GL = 9; //  Prohibit line breaks before and after
	var SP = 10; // Enable indirect line breaks
	var ZWJ = 11; // Prohibit line breaks within joiner sequences
	// Break Opportunities
	var B2 = 12; //  Provide a line break opportunity before and after the character
	var BA = 13; //  Generally provide a line break opportunity after the character
	var BB = 14; //  Generally provide a line break opportunity before the character
	var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
	var CB = 16; //   Provide a line break opportunity contingent on additional information
	// Characters Prohibiting Certain Breaks
	var CL = 17; //  Prohibit line breaks before
	var CP = 18; //  Prohibit line breaks before
	var EX = 19; //  Prohibit line breaks before
	var IN = 20; //  Allow only indirect line breaks between pairs
	var NS = 21; //  Allow only indirect line breaks before
	var OP = 22; //  Prohibit line breaks after
	var QU = 23; //  Act like they are both opening and closing
	// Numeric Context
	var IS = 24; //  Prevent breaks after any and before numeric
	var NU = 25; //  Form numeric expressions for line breaking purposes
	var PO = 26; //  Do not break following a numeric expression
	var PR = 27; //  Do not break in front of a numeric expression
	var SY = 28; //  Prevent a break before; and allow a break after
	// Other Characters
	var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
	var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
	var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
	var EB = 32; //  Do not break from following Emoji Modifier
	var EM = 33; //  Do not break from preceding Emoji Base
	var H2 = 34; //  Form Korean syllable blocks
	var H3 = 35; //  Form Korean syllable blocks
	var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
	var ID = 37; //  Break before or after; except in some numeric context
	var JL = 38; //  Form Korean syllable blocks
	var JV = 39; //  Form Korean syllable blocks
	var JT = 40; //  Form Korean syllable blocks
	var RI = 41; //  Keep pairs together. For pairs; break before and after other classes
	var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
	var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
	
	var classes = exports.classes = {
	    BK: BK,
	    CR: CR,
	    LF: LF,
	    CM: CM,
	    NL: NL,
	    SG: SG,
	    WJ: WJ,
	    ZW: ZW,
	    GL: GL,
	    SP: SP,
	    ZWJ: ZWJ,
	    B2: B2,
	    BA: BA,
	    BB: BB,
	    HY: HY,
	    CB: CB,
	    CL: CL,
	    CP: CP,
	    EX: EX,
	    IN: IN,
	    NS: NS,
	    OP: OP,
	    QU: QU,
	    IS: IS,
	    NU: NU,
	    PO: PO,
	    PR: PR,
	    SY: SY,
	    AI: AI,
	    AL: AL,
	    CJ: CJ,
	    EB: EB,
	    EM: EM,
	    H2: H2,
	    H3: H3,
	    HL: HL,
	    ID: ID,
	    JL: JL,
	    JV: JV,
	    JT: JT,
	    RI: RI,
	    SA: SA,
	    XX: XX
	};
	
	var BREAK_MANDATORY = exports.BREAK_MANDATORY = '!';
	var BREAK_NOT_ALLOWED = exports.BREAK_NOT_ALLOWED = '×';
	var BREAK_ALLOWED = exports.BREAK_ALLOWED = '÷';
	var UnicodeTrie = exports.UnicodeTrie = (0, _Trie.createTrieFromBase64)(_linebreakTrie2.default);
	
	var ALPHABETICS = [AL, HL];
	var HARD_LINE_BREAKS = [BK, CR, LF, NL];
	var SPACE = [SP, ZW];
	var PREFIX_POSTFIX = [PR, PO];
	var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE);
	var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
	var HYPHEN = [HY, BA];
	
	var codePointsToCharacterClasses = exports.codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints) {
	    var lineBreak = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'strict';
	
	    var types = [];
	    var indicies = [];
	    var categories = [];
	    codePoints.forEach(function (codePoint, index) {
	        var classType = UnicodeTrie.get(codePoint);
	        if (classType > LETTER_NUMBER_MODIFIER) {
	            categories.push(true);
	            classType -= LETTER_NUMBER_MODIFIER;
	        } else {
	            categories.push(false);
	        }
	
	        if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
	            // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
	            if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
	                indicies.push(index);
	                return types.push(CB);
	            }
	        }
	
	        if (classType === CM || classType === ZWJ) {
	            // LB10 Treat any remaining combining mark or ZWJ as AL.
	            if (index === 0) {
	                indicies.push(index);
	                return types.push(AL);
	            }
	
	            // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
	            // the base character in all of the following rules. Treat ZWJ as if it were CM.
	            var prev = types[index - 1];
	            if (LINE_BREAKS.indexOf(prev) === -1) {
	                indicies.push(indicies[index - 1]);
	                return types.push(prev);
	            }
	            indicies.push(index);
	            return types.push(AL);
	        }
	
	        indicies.push(index);
	
	        if (classType === CJ) {
	            return types.push(lineBreak === 'strict' ? NS : ID);
	        }
	
	        if (classType === SA) {
	            return types.push(AL);
	        }
	
	        if (classType === AI) {
	            return types.push(AL);
	        }
	
	        // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
	        // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
	        // to take into account the actual line breaking properties for these characters.
	        if (classType === XX) {
	            if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) {
	                return types.push(ID);
	            } else {
	                return types.push(AL);
	            }
	        }
	
	        types.push(classType);
	    });
	
	    return [indicies, types, categories];
	};
	
	var isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {
	    var current = classTypes[currentIndex];
	    if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
	        var i = currentIndex;
	        while (i <= classTypes.length) {
	            i++;
	            var next = classTypes[i];
	
	            if (next === b) {
	                return true;
	            }
	
	            if (next !== SP) {
	                break;
	            }
	        }
	    }
	
	    if (current === SP) {
	        var _i = currentIndex;
	
	        while (_i > 0) {
	            _i--;
	            var prev = classTypes[_i];
	
	            if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
	                var n = currentIndex;
	                while (n <= classTypes.length) {
	                    n++;
	                    var _next = classTypes[n];
	
	                    if (_next === b) {
	                        return true;
	                    }
	
	                    if (_next !== SP) {
	                        break;
	                    }
	                }
	            }
	
	            if (prev !== SP) {
	                break;
	            }
	        }
	    }
	    return false;
	};
	
	var previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {
	    var i = currentIndex;
	    while (i >= 0) {
	        var type = classTypes[i];
	        if (type === SP) {
	            i--;
	        } else {
	            return type;
	        }
	    }
	    return 0;
	};
	
	var _lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {
	    if (indicies[index] === 0) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    var currentIndex = index - 1;
	    if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    var beforeIndex = currentIndex - 1;
	    var afterIndex = currentIndex + 1;
	    var current = classTypes[currentIndex];
	
	    // LB4 Always break after hard line breaks.
	    // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
	    var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
	    var next = classTypes[afterIndex];
	
	    if (current === CR && next === LF) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
	        return BREAK_MANDATORY;
	    }
	
	    // LB6 Do not break before hard line breaks.
	    if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB7 Do not break before spaces or zero width space.
	    if (SPACE.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
	    if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
	        return BREAK_ALLOWED;
	    }
	
	    // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.
	    if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ && (next === ID || next === EB || next === EM)) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB11 Do not break before or after Word joiner and related characters.
	    if (current === WJ || next === WJ) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB12 Do not break after NBSP and related characters.
	    if (current === GL) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
	    if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
	    if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB14 Do not break after ‘[’, even after spaces.
	    if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB15 Do not break within ‘”[’, even with intervening spaces.
	    if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
	    if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB17 Do not break within ‘——’, even with intervening spaces.
	    if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB18 Break after spaces.
	    if (current === SP) {
	        return BREAK_ALLOWED;
	    }
	
	    // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
	    if (current === QU || next === QU) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB20 Break before and after unresolved CB.
	    if (next === CB || current === CB) {
	        return BREAK_ALLOWED;
	    }
	
	    // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
	    if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB21a Don't break after Hebrew + Hyphen.
	    if (before === HL && HYPHEN.indexOf(current) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB21b Don’t break between Solidus and Hebrew letters.
	    if (current === SY && next === HL) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.
	    if (next === IN && ALPHABETICS.concat(IN, EX, NU, ID, EB, EM).indexOf(current) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB23 Do not break between digits and letters.
	    if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
	    if (current === PR && [ID, EB, EM].indexOf(next) !== -1 || [ID, EB, EM].indexOf(current) !== -1 && next === PO) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
	    if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB25 Do not break between the following pairs of classes relevant to numbers:
	    if (
	    // (PR | PO) × ( OP | HY )? NU
	    [PR, PO].indexOf(current) !== -1 && (next === NU || [OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) ||
	    // ( OP | HY ) × NU
	    [OP, HY].indexOf(current) !== -1 && next === NU ||
	    // NU ×	(NU | SY | IS)
	    current === NU && [NU, SY, IS].indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
	    if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
	        var prevIndex = currentIndex;
	        while (prevIndex >= 0) {
	            var type = classTypes[prevIndex];
	            if (type === NU) {
	                return BREAK_NOT_ALLOWED;
	            } else if ([SY, IS].indexOf(type) !== -1) {
	                prevIndex--;
	            } else {
	                break;
	            }
	        }
	    }
	
	    // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
	    if ([PR, PO].indexOf(next) !== -1) {
	        var _prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
	        while (_prevIndex >= 0) {
	            var _type = classTypes[_prevIndex];
	            if (_type === NU) {
	                return BREAK_NOT_ALLOWED;
	            } else if ([SY, IS].indexOf(_type) !== -1) {
	                _prevIndex--;
	            } else {
	                break;
	            }
	        }
	    }
	
	    // LB26 Do not break a Korean syllable.
	    if (JL === current && [JL, JV, H2, H3].indexOf(next) !== -1 || [JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1 || [JT, H3].indexOf(current) !== -1 && next === JT) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB27 Treat a Korean Syllable Block the same as ID.
	    if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB28 Do not break between alphabetics (“at”).
	    if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
	    if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
	    if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
	    // indicators preceding the position of the break.
	    if (current === RI && next === RI) {
	        var i = indicies[currentIndex];
	        var count = 1;
	        while (i > 0) {
	            i--;
	            if (classTypes[i] === RI) {
	                count++;
	            } else {
	                break;
	            }
	        }
	        if (count % 2 !== 0) {
	            return BREAK_NOT_ALLOWED;
	        }
	    }
	
	    // LB30b Do not break between an emoji base and an emoji modifier.
	    if (current === EB && next === EM) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    return BREAK_ALLOWED;
	};
	
	var lineBreakAtIndex = exports.lineBreakAtIndex = function lineBreakAtIndex(codePoints, index) {
	    // LB2 Never break at the start of text.
	    if (index === 0) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB3 Always break at the end of text.
	    if (index >= codePoints.length) {
	        return BREAK_MANDATORY;
	    }
	
	    var _codePointsToCharacte = codePointsToCharacterClasses(codePoints),
	        _codePointsToCharacte2 = _slicedToArray(_codePointsToCharacte, 2),
	        indicies = _codePointsToCharacte2[0],
	        classTypes = _codePointsToCharacte2[1];
	
	    return _lineBreakAtIndex(codePoints, classTypes, indicies, index);
	};
	
	var cssFormattedClasses = function cssFormattedClasses(codePoints, options) {
	    if (!options) {
	        options = { lineBreak: 'normal', wordBreak: 'normal' };
	    }
	
	    var _codePointsToCharacte3 = codePointsToCharacterClasses(codePoints, options.lineBreak),
	        _codePointsToCharacte4 = _slicedToArray(_codePointsToCharacte3, 3),
	        indicies = _codePointsToCharacte4[0],
	        classTypes = _codePointsToCharacte4[1],
	        isLetterNumber = _codePointsToCharacte4[2];
	
	    if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
	        classTypes = classTypes.map(function (type) {
	            return [NU, AL, SA].indexOf(type) !== -1 ? ID : type;
	        });
	    }
	
	    var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function (isLetterNumber, i) {
	        return isLetterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
	    }) : null;
	
	    return [indicies, classTypes, forbiddenBreakpoints];
	};
	
	var inlineBreakOpportunities = exports.inlineBreakOpportunities = function inlineBreakOpportunities(str, options) {
	    var codePoints = (0, _Util.toCodePoints)(str);
	    var output = BREAK_NOT_ALLOWED;
	
	    var _cssFormattedClasses = cssFormattedClasses(codePoints, options),
	        _cssFormattedClasses2 = _slicedToArray(_cssFormattedClasses, 3),
	        indicies = _cssFormattedClasses2[0],
	        classTypes = _cssFormattedClasses2[1],
	        forbiddenBreakpoints = _cssFormattedClasses2[2];
	
	    codePoints.forEach(function (codePoint, i) {
	        output += (0, _Util.fromCodePoint)(codePoint) + (i >= codePoints.length - 1 ? BREAK_MANDATORY : _lineBreakAtIndex(codePoints, classTypes, indicies, i + 1, forbiddenBreakpoints));
	    });
	
	    return output;
	};
	
	var Break = function () {
	    function Break(codePoints, lineBreak, start, end) {
	        _classCallCheck(this, Break);
	
	        this._codePoints = codePoints;
	        this.required = lineBreak === BREAK_MANDATORY;
	        this.start = start;
	        this.end = end;
	    }
	
	    _createClass(Break, [{
	        key: 'slice',
	        value: function slice() {
	            return _Util.fromCodePoint.apply(undefined, _toConsumableArray(this._codePoints.slice(this.start, this.end)));
	        }
	    }]);
	
	    return Break;
	}();
	
	var LineBreaker = exports.LineBreaker = function LineBreaker(str, options) {
	    var codePoints = (0, _Util.toCodePoints)(str);
	
	    var _cssFormattedClasses3 = cssFormattedClasses(codePoints, options),
	        _cssFormattedClasses4 = _slicedToArray(_cssFormattedClasses3, 3),
	        indicies = _cssFormattedClasses4[0],
	        classTypes = _cssFormattedClasses4[1],
	        forbiddenBreakpoints = _cssFormattedClasses4[2];
	
	    var length = codePoints.length;
	    var lastEnd = 0;
	    var nextIndex = 0;
	
	    return {
	        next: function next() {
	            if (nextIndex >= length) {
	                return { done: true };
	            }
	            var lineBreak = BREAK_NOT_ALLOWED;
	            while (nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED) {}
	
	            if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {
	                var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
	                lastEnd = nextIndex;
	                return { value: value, done: false };
	            }
	
	            return { done: true };
	        }
	    };
	};

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Trie = exports.createTrieFromBase64 = exports.UTRIE2_INDEX_2_MASK = exports.UTRIE2_INDEX_2_BLOCK_LENGTH = exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = exports.UTRIE2_INDEX_1_OFFSET = exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = exports.UTRIE2_INDEX_2_BMP_LENGTH = exports.UTRIE2_LSCP_INDEX_2_LENGTH = exports.UTRIE2_DATA_MASK = exports.UTRIE2_DATA_BLOCK_LENGTH = exports.UTRIE2_LSCP_INDEX_2_OFFSET = exports.UTRIE2_SHIFT_1_2 = exports.UTRIE2_INDEX_SHIFT = exports.UTRIE2_SHIFT_1 = exports.UTRIE2_SHIFT_2 = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Util = __webpack_require__(113);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** Shift size for getting the index-2 table offset. */
	var UTRIE2_SHIFT_2 = exports.UTRIE2_SHIFT_2 = 5;
	
	/** Shift size for getting the index-1 table offset. */
	var UTRIE2_SHIFT_1 = exports.UTRIE2_SHIFT_1 = 6 + 5;
	
	/**
	 * Shift size for shifting left the index array values.
	 * Increases possible data size with 16-bit index values at the cost
	 * of compactability.
	 * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
	 */
	var UTRIE2_INDEX_SHIFT = exports.UTRIE2_INDEX_SHIFT = 2;
	
	/**
	 * Difference between the two shift sizes,
	 * for getting an index-1 offset from an index-2 offset. 6=11-5
	 */
	var UTRIE2_SHIFT_1_2 = exports.UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
	
	/**
	 * The part of the index-2 table for U+D800..U+DBFF stores values for
	 * lead surrogate code _units_ not code _points_.
	 * Values for lead surrogate code _points_ are indexed with this portion of the table.
	 * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
	 */
	var UTRIE2_LSCP_INDEX_2_OFFSET = exports.UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
	
	/** Number of entries in a data block. 32=0x20 */
	var UTRIE2_DATA_BLOCK_LENGTH = exports.UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
	/** Mask for getting the lower bits for the in-data-block offset. */
	var UTRIE2_DATA_MASK = exports.UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
	
	var UTRIE2_LSCP_INDEX_2_LENGTH = exports.UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
	/** Count the lengths of both BMP pieces. 2080=0x820 */
	var UTRIE2_INDEX_2_BMP_LENGTH = exports.UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
	/**
	 * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
	 * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
	 */
	var UTRIE2_UTF8_2B_INDEX_2_OFFSET = exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
	var UTRIE2_UTF8_2B_INDEX_2_LENGTH = exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
	/**
	 * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
	 * Variable length, for code points up to highStart, where the last single-value range starts.
	 * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
	 * (For 0x100000 supplementary code points U+10000..U+10ffff.)
	 *
	 * The part of the index-2 table for supplementary code points starts
	 * after this index-1 table.
	 *
	 * Both the index-1 table and the following part of the index-2 table
	 * are omitted completely if there is only BMP data.
	 */
	var UTRIE2_INDEX_1_OFFSET = exports.UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
	
	/**
	 * Number of index-1 entries for the BMP. 32=0x20
	 * This part of the index-1 table is omitted from the serialized form.
	 */
	var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
	
	/** Number of entries in an index-2 block. 64=0x40 */
	var UTRIE2_INDEX_2_BLOCK_LENGTH = exports.UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
	/** Mask for getting the lower bits for the in-index-2-block offset. */
	var UTRIE2_INDEX_2_MASK = exports.UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
	
	var createTrieFromBase64 = exports.createTrieFromBase64 = function createTrieFromBase64(base64) {
	    var buffer = (0, _Util.decode)(base64);
	    var view32 = Array.isArray(buffer) ? (0, _Util.polyUint32Array)(buffer) : new Uint32Array(buffer);
	    var view16 = Array.isArray(buffer) ? (0, _Util.polyUint16Array)(buffer) : new Uint16Array(buffer);
	    var headerLength = 24;
	
	    var index = view16.slice(headerLength / 2, view32[4] / 2);
	    var data = view32[5] === 2 ? view16.slice((headerLength + view32[4]) / 2) : view32.slice(Math.ceil((headerLength + view32[4]) / 4));
	
	    return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
	};
	
	var Trie = exports.Trie = function () {
	    function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
	        _classCallCheck(this, Trie);
	
	        this.initialValue = initialValue;
	        this.errorValue = errorValue;
	        this.highStart = highStart;
	        this.highValueIndex = highValueIndex;
	        this.index = index;
	        this.data = data;
	    }
	
	    /**
	     * Get the value for a code point as stored in the Trie.
	     *
	     * @param codePoint the code point
	     * @return the value
	     */
	
	
	    _createClass(Trie, [{
	        key: 'get',
	        value: function get(codePoint) {
	            var ix = void 0;
	            if (codePoint >= 0) {
	                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
	                    // Ordinary BMP code point, excluding leading surrogates.
	                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
	                    // 16 bit data is stored in the index array itself.
	                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	
	                if (codePoint <= 0xffff) {
	                    // Lead Surrogate Code Point.  A Separate index section is stored for
	                    // lead surrogate code units and code points.
	                    //   The main index has the code unit data.
	                    //   For this function, we need the code point data.
	                    // Note: this expression could be refactored for slightly improved efficiency, but
	                    //       surrogate code points will be so rare in practice that it's not worth it.
	                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	
	                if (codePoint < this.highStart) {
	                    // Supplemental code point, use two-level lookup.
	                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
	                    ix = this.index[ix];
	                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
	                    ix = this.index[ix];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	                if (codePoint <= 0x10ffff) {
	                    return this.data[this.highValueIndex];
	                }
	            }
	
	            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
	            return this.errorValue;
	        }
	    }]);
	
	    return Trie;
	}();

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Util = __webpack_require__(113);
	
	Object.defineProperty(exports, 'toCodePoints', {
	  enumerable: true,
	  get: function get() {
	    return _Util.toCodePoints;
	  }
	});
	Object.defineProperty(exports, 'fromCodePoint', {
	  enumerable: true,
	  get: function get() {
	    return _Util.fromCodePoint;
	  }
	});
	
	var _LineBreak = __webpack_require__(405);
	
	Object.defineProperty(exports, 'LineBreaker', {
	  enumerable: true,
	  get: function get() {
	    return _LineBreak.LineBreaker;
	  }
	});

/***/ },
/* 408 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = 'KwAAAAAAAAAACA4AIDoAAPAfAAACAAAAAAAIABAAGABAAEgAUABYAF4AZgBeAGYAYABoAHAAeABeAGYAfACEAIAAiACQAJgAoACoAK0AtQC9AMUAXgBmAF4AZgBeAGYAzQDVAF4AZgDRANkA3gDmAOwA9AD8AAQBDAEUARoBIgGAAIgAJwEvATcBPwFFAU0BTAFUAVwBZAFsAXMBewGDATAAiwGTAZsBogGkAawBtAG8AcIBygHSAdoB4AHoAfAB+AH+AQYCDgIWAv4BHgImAi4CNgI+AkUCTQJTAlsCYwJrAnECeQKBAk0CiQKRApkCoQKoArACuALAAsQCzAIwANQC3ALkAjAA7AL0AvwCAQMJAxADGAMwACADJgMuAzYDPgOAAEYDSgNSA1IDUgNaA1oDYANiA2IDgACAAGoDgAByA3YDfgOAAIQDgACKA5IDmgOAAIAAogOqA4AAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAK8DtwOAAIAAvwPHA88D1wPfAyAD5wPsA/QD/AOAAIAABAQMBBIEgAAWBB4EJgQuBDMEIAM7BEEEXgBJBCADUQRZBGEEaQQwADAAcQQ+AXkEgQSJBJEEgACYBIAAoASoBK8EtwQwAL8ExQSAAIAAgACAAIAAgACgAM0EXgBeAF4AXgBeAF4AXgBeANUEXgDZBOEEXgDpBPEE+QQBBQkFEQUZBSEFKQUxBTUFPQVFBUwFVAVcBV4AYwVeAGsFcwV7BYMFiwWSBV4AmgWgBacFXgBeAF4AXgBeAKsFXgCyBbEFugW7BcIFwgXIBcIFwgXQBdQF3AXkBesF8wX7BQMGCwYTBhsGIwYrBjMGOwZeAD8GRwZNBl4AVAZbBl4AXgBeAF4AXgBeAF4AXgBeAF4AXgBeAGMGXgBqBnEGXgBeAF4AXgBeAF4AXgBeAF4AXgB5BoAG4wSGBo4GkwaAAIADHgR5AF4AXgBeAJsGgABGA4AAowarBrMGswagALsGwwbLBjAA0wbaBtoG3QbaBtoG2gbaBtoG2gblBusG8wb7BgMHCwcTBxsHCwcjBysHMAc1BzUHOgdCB9oGSgdSB1oHYAfaBloHaAfaBlIH2gbaBtoG2gbaBtoG2gbaBjUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHbQdeAF4ANQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQd1B30HNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1B4MH2gaKB68EgACAAIAAgACAAIAAgACAAI8HlwdeAJ8HpweAAIAArwe3B14AXgC/B8UHygcwANAH2AfgB4AA6AfwBz4B+AcACFwBCAgPCBcIogEYAR8IJwiAAC8INwg/CCADRwhPCFcIXwhnCEoDGgSAAIAAgABvCHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIhAiLCI4IMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlggwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAANQc1BzUHNQc1BzUHNQc1BzUHNQc1B54INQc1B6II2gaqCLIIugiAAIAAvgjGCIAAgACAAIAAgACAAIAAgACAAIAAywiHAYAA0wiAANkI3QjlCO0I9Aj8CIAAgACAAAIJCgkSCRoJIgknCTYHLwk3CZYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiAAIAAAAFAAXgBeAGAAcABeAHwAQACQAKAArQC9AJ4AXgBeAE0A3gBRAN4A7AD8AMwBGgEAAKcBNwEFAUwBXAF4QkhCmEKnArcCgAHHAsABz4LAAcABwAHAAd+C6ABoAG+C/4LAAcABwAHAAc+DF4MAAcAB54M3gweDV4Nng3eDaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAEeDqABVg6WDqABoQ6gAaABoAHXDvcONw/3DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DncPAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcAB7cPPwlGCU4JMACAAIAAgABWCV4JYQmAAGkJcAl4CXwJgAkwADAAMAAwAIgJgACLCZMJgACZCZ8JowmrCYAAswkwAF4AXgB8AIAAuwkABMMJyQmAAM4JgADVCTAAMAAwADAAgACAAIAAgACAAIAAgACAAIAAqwYWBNkIMAAwADAAMADdCeAJ6AnuCR4E9gkwAP4JBQoNCjAAMACAABUK0wiAAB0KJAosCjQKgAAwADwKQwqAAEsKvQmdCVMKWwowADAAgACAALcEMACAAGMKgABrCjAAMAAwADAAMAAwADAAMAAwADAAMAAeBDAAMAAwADAAMAAwADAAMAAwADAAMAAwAIkEPQFzCnoKiQSCCooKkAqJBJgKoAqkCokEGAGsCrQKvArBCjAAMADJCtEKFQHZCuEK/gHpCvEKMAAwADAAMACAAIwE+QowAIAAPwEBCzAAMAAwADAAMACAAAkLEQswAIAAPwEZCyELgAAOCCkLMAAxCzkLMAAwADAAMAAwADAAXgBeAEELMAAwADAAMAAwADAAMAAwAEkLTQtVC4AAXAtkC4AAiQkwADAAMAAwADAAMAAwADAAbAtxC3kLgAuFC4sLMAAwAJMLlwufCzAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAApwswADAAMACAAIAAgACvC4AAgACAAIAAgACAALcLMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAvwuAAMcLgACAAIAAgACAAIAAyguAAIAAgACAAIAA0QswADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAANkLgACAAIAA4AswADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACJCR4E6AswADAAhwHwC4AA+AsADAgMEAwwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMACAAIAAGAwdDCUMMAAwAC0MNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQw1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHPQwwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADUHNQc1BzUHNQc1BzUHNQc2BzAAMAA5DDUHNQc1BzUHNQc1BzUHNQc1BzUHNQdFDDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAgACAAIAATQxSDFoMMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAF4AXgBeAF4AXgBeAF4AYgxeAGoMXgBxDHkMfwxeAIUMXgBeAI0MMAAwADAAMAAwAF4AXgCVDJ0MMAAwADAAMABeAF4ApQxeAKsMswy7DF4Awgy9DMoMXgBeAF4AXgBeAF4AXgBeAF4AXgDRDNkMeQBqCeAM3Ax8AOYM7Az0DPgMXgBeAF4AXgBeAF4AXgBeAF4AXgBeAF4AXgBeAF4AXgCgAAANoAAHDQ4NFg0wADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAeDSYNMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIAAgACAAIAAgACAAC4NMABeAF4ANg0wADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAD4NRg1ODVYNXg1mDTAAbQ0wADAAMAAwADAAMAAwADAA2gbaBtoG2gbaBtoG2gbaBnUNeg3CBYANwgWFDdoGjA3aBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gaUDZwNpA2oDdoG2gawDbcNvw3HDdoG2gbPDdYN3A3fDeYN2gbsDfMN2gbaBvoN/g3aBgYODg7aBl4AXgBeABYOXgBeACUG2gYeDl4AJA5eACwO2w3aBtoGMQ45DtoG2gbaBtoGQQ7aBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gZJDjUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1B1EO2gY1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQdZDjUHNQc1BzUHNQc1B2EONQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHaA41BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1B3AO2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gY1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1B2EO2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gZJDtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBkkOeA6gAKAAoAAwADAAMAAwAKAAoACgAKAAoACgAKAAgA4wADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAD//wQABAAEAAQABAAEAAQABAAEAA0AAwABAAEAAgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAKABMAFwAeABsAGgAeABcAFgASAB4AGwAYAA8AGAAcAEsASwBLAEsASwBLAEsASwBLAEsAGAAYAB4AHgAeABMAHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAFgAbABIAHgAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABYADQARAB4ABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAUABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAkAFgAaABsAGwAbAB4AHQAdAB4ATwAXAB4ADQAeAB4AGgAbAE8ATwAOAFAAHQAdAB0ATwBPABcATwBPAE8AFgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAB4AUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAFAATwBAAE8ATwBPAEAATwBQAFAATwBQAB4AHgAeAB4AHgAeAB0AHQAdAB0AHgAdAB4ADgBQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgBQAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAkACQAJAAkACQAJAAkABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAFAAHgAeAB4AKwArAFAAUABQAFAAGABQACsAKwArACsAHgAeAFAAHgBQAFAAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUAAeAB4AHgAeAB4AHgArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAYAA0AKwArAB4AHgAbACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAB4ABAAEAB4ABAAEABMABAArACsAKwArACsAKwArACsAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAKwArACsAKwArAFYAVgBWAB4AHgArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AGgAaABoAGAAYAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQAEwAEACsAEwATAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABLAEsASwBLAEsASwBLAEsASwBLABoAGQAZAB4AUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABMAUAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABABQAFAABAAEAB4ABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUAAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAFAABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQAUABQAB4AHgAYABMAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAFAABAAEAAQABAAEAFAABAAEAAQAUAAEAAQABAAEAAQAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArACsAHgArAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAAQABAANAA0ASwBLAEsASwBLAEsASwBLAEsASwAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQAKwBQAFAAUABQAFAAUABQAFAAKwArAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAKwArACsAUABQAFAAUAArACsABABQAAQABAAEAAQABAAEAAQAKwArAAQABAArACsABAAEAAQAUAArACsAKwArACsAKwArACsABAArACsAKwArAFAAUAArAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAGgAaAFAAUABQAFAAUABMAB4AGwBQAB4AKwArACsABAAEAAQAKwBQAFAAUABQAFAAUAArACsAKwArAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUAArAFAAUAArAFAAUAArACsABAArAAQABAAEAAQABAArACsAKwArAAQABAArACsABAAEAAQAKwArACsABAArACsAKwArACsAKwArAFAAUABQAFAAKwBQACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwAEAAQAUABQAFAABAArACsAKwArACsAKwArACsAKwArACsABAAEAAQAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUAArAFAAUABQAFAAUAArACsABABQAAQABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQAKwArAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwAeABsAKwArACsAKwArACsAKwBQAAQABAAEAAQABAAEACsABAAEAAQAKwBQAFAAUABQAFAAUABQAFAAKwArAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAKwArAAQABAArACsABAAEAAQAKwArACsAKwArACsAKwArAAQABAArACsAKwArAFAAUAArAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwAeAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwAEAFAAKwBQAFAAUABQAFAAUAArACsAKwBQAFAAUAArAFAAUABQAFAAKwArACsAUABQACsAUAArAFAAUAArACsAKwBQAFAAKwArACsAUABQAFAAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAAQABAAEAAQAKwArACsABAAEAAQAKwAEAAQABAAEACsAKwBQACsAKwArACsAKwArAAQAKwArACsAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAB4AHgAeAB4AHgAeABsAHgArACsAKwArACsABAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABAArACsAKwArACsAKwArAAQABAArAFAAUABQACsAKwArACsAKwBQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAB4AUAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABAArACsAKwArACsAKwArAAQABAArACsAKwArACsAKwArAFAAKwBQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABABQAB4AKwArACsAKwBQAFAAUAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQABoAUABQAFAAUABQAFAAKwArAAQABAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQACsAUAArACsAUABQAFAAUABQAFAAUAArACsAKwAEACsAKwArACsABAAEAAQABAAEAAQAKwAEACsABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArAAQABAAeACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAXAAqACoAKgAqACoAKgAqACsAKwArACsAGwBcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAeAEsASwBLAEsASwBLAEsASwBLAEsADQANACsAKwArACsAKwBcAFwAKwBcACsAKwBcAFwAKwBcACsAKwBcACsAKwArACsAKwArAFwAXABcAFwAKwBcAFwAXABcAFwAXABcACsAXABcAFwAKwBcACsAXAArACsAXABcACsAXABcAFwAXAAqAFwAXAAqACoAKgAqACoAKgArACoAKgBcACsAKwBcAFwAXABcAFwAKwBcACsAKgAqACoAKgAqACoAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArAFwAXABcAFwAUAAOAA4ADgAOAB4ADgAOAAkADgAOAA0ACQATABMAEwATABMACQAeABMAHgAeAB4ABAAEAB4AHgAeAB4AHgAeAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUAANAAQAHgAEAB4ABAAWABEAFgARAAQABABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAANAAQABAAEAAQABAANAAQABABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsADQANAB4AHgAeAB4AHgAeAAQAHgAeAB4AHgAeAB4AKwAeAB4ADgAOAA0ADgAeAB4AHgAeAB4ACQAJACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqAFwASwBLAEsASwBLAEsASwBLAEsASwANAA0AHgAeAB4AHgBcAFwAXABcAFwAXAAqACoAKgAqAFwAXABcAFwAKgAqACoAXAAqACoAKgBcAFwAKgAqACoAKgAqACoAKgBcAFwAXAAqACoAKgAqAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgAqACoAXAAqAEsASwBLAEsASwBLAEsASwBLAEsAKgAqACoAKgAqACoAUABQAFAAUABQAFAAKwBQACsAKwArACsAKwBQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQACsAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwAEAAQABAAeAA0AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQACsAKwANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABYAEQArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAADQANAA0AUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAABAAEAAQAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAA0ADQArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQACsABAAEACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoADQANABUAXAANAB4ADQAbAFwAKgArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArAB4AHgATABMADQANAA4AHgATABMAHgAEAAQABAAJACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAUABQAFAAUABQAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABABQACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwAeACsAKwArABMAEwBLAEsASwBLAEsASwBLAEsASwBLAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAKwBcAFwAXABcAFwAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBcACsAKwArACoAKgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEACsAKwAeAB4AXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgArACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgArACsABABLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKgAqACoAKgAqACoAKgBcACoAKgAqACoAKgAqACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAUABQAFAAUABQAFAAUAArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsADQANAB4ADQANAA0ADQAeAB4AHgAeAB4AHgAeAB4AHgAeAAQABAAEAAQABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAUABQAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAHgAeAB4AHgBQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwANAA0ADQANAA0ASwBLAEsASwBLAEsASwBLAEsASwArACsAKwBQAFAAUABLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAA0AUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsABAAEAAQAHgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAUABQAFAABABQAFAAUABQAAQABAAEAFAAUAAEAAQABAArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwAEAAQABAAEAAQAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUAArAFAAKwBQACsAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAHgAeAB4AHgAeAB4AHgAeAFAAHgAeAB4AUABQAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAKwArAB4AHgAeAB4AHgAeACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAUABQAFAAKwAeAB4AHgAeAB4AHgAeAA4AHgArAA0ADQANAA0ADQANAA0ACQANAA0ADQAIAAQACwAEAAQADQAJAA0ADQAMAB0AHQAeABcAFwAWABcAFwAXABYAFwAdAB0AHgAeABQAFAAUAA0AAQABAAQABAAEAAQABAAJABoAGgAaABoAGgAaABoAGgAeABcAFwAdABUAFQAeAB4AHgAeAB4AHgAYABYAEQAVABUAFQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgANAB4ADQANAA0ADQAeAA0ADQANAAcAHgAeAB4AHgArAAQABAAEAAQABAAEAAQABAAEAAQAUABQACsAKwBPAFAAUABQAFAAUAAeAB4AHgAWABEATwBQAE8ATwBPAE8AUABQAFAAUABQAB4AHgAeABYAEQArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAGwAbABsAGwAbABsAGwAaABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAaABsAGwAbABsAGgAbABsAGgAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgBQABoAHgAdAB4AUAAeABoAHgAeAB4AHgAeAB4AHgAeAB4ATwAeAFAAGwAeAB4AUABQAFAAUABQAB4AHgAeAB0AHQAeAFAAHgBQAB4AUAAeAFAATwBQAFAAHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AUABQAFAAUABPAE8AUABQAFAAUABQAE8AUABQAE8AUABPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBQAFAAUABQAE8ATwBPAE8ATwBPAE8ATwBPAE8AUABQAFAAUABQAFAAUABQAFAAHgAeAFAAUABQAFAATwAeAB4AKwArACsAKwAdAB0AHQAdAB0AHQAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAeAB0AHQAeAB4AHgAdAB0AHgAeAB0AHgAeAB4AHQAeAB0AGwAbAB4AHQAeAB4AHgAeAB0AHgAeAB0AHQAdAB0AHgAeAB0AHgAdAB4AHQAdAB0AHQAdAB0AHgAdAB4AHgAeAB4AHgAdAB0AHQAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAdAB4AHgAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB4AHgAdAB0AHQAdAB4AHgAdAB0AHgAeAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAeAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHQAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABQAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAlACUAHgAeAB4AHgAeAB4AHgAeAB4AFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBQAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB4AHgAeAB4AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAdAB0AHQAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAeAB0AHQAeAB4AHgAeAB0AHQAeAB4AHgAeAB0AHQAdAB4AHgAdAB4AHgAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB0AHQAeAB4AHQAeAB4AHgAeAB0AHQAeAB4AHgAeACUAJQAdAB0AJQAeACUAJQAlACAAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAHgAeAB4AHgAdAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB4AHQAdAB0AHgAdACUAHQAdAB4AHQAdAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAHQAdAB0AHQAlAB4AJQAlACUAHQAlACUAHQAdAB0AJQAlAB0AHQAlAB0AHQAlACUAJQAeAB0AHgAeAB4AHgAdAB0AJQAdAB0AHQAdAB0AHQAlACUAJQAlACUAHQAlACUAIAAlAB0AHQAlACUAJQAlACUAJQAlACUAHgAeAB4AJQAlACAAIAAgACAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeABcAFwAXABcAFwAXAB4AEwATACUAHgAeAB4AFgARABYAEQAWABEAFgARABYAEQAWABEAFgARAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARABYAEQAWABEAFgARABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAEAAQABAAeAB4AKwArACsAKwArABMADQANAA0AUAATAA0AUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUAANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAA0ADQANAA0ADQANAA0ADQAeAA0AFgANAB4AHgAXABcAHgAeABcAFwAWABEAFgARABYAEQAWABEADQANAA0ADQATAFAADQANAB4ADQANAB4AHgAeAB4AHgAMAAwADQANAA0AHgANAA0AFgANAA0ADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArAA0AEQARACUAJQBHAFcAVwAWABEAFgARABYAEQAWABEAFgARACUAJQAWABEAFgARABYAEQAWABEAFQAWABEAEQAlAFcAVwBXAFcAVwBXAFcAVwBXAAQABAAEAAQABAAEACUAVwBXAFcAVwA2ACUAJQBXAFcAVwBHAEcAJQAlACUAKwBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBRAFcAUQBXAFEAVwBXAFcAVwBXAFcAUQBXAFcAVwBXAFcAVwBRAFEAKwArAAQABAAVABUARwBHAFcAFQBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBRAFcAVwBXAFcAVwBXAFEAUQBXAFcAVwBXABUAUQBHAEcAVwArACsAKwArACsAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwArACUAJQBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAKwArACUAJQAlACUAKwArACsAKwArACsAKwArACsAKwArACsAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAE8ATwBPAE8ATwBPAE8ATwAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADQATAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABLAEsASwBLAEsASwBLAEsASwBLAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAABAAEAAQABAAeAAQABAAEAAQABAAEAAQABAAEAAQAHgBQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAeAA0ADQANAA0ADQArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAAQAUABQAFAABABQAFAAUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAeAB4AHgAeACsAKwArACsAUABQAFAAUABQAFAAHgAeABoAHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADgAOABMAEwArACsAKwArACsAKwArACsABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwANAA0ASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUAAeAB4AHgBQAA4AUAArACsAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArAB4AWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYACsAKwArAAQAHgAeAB4AHgAeAB4ADQANAA0AHgAeAB4AHgArAFAASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArAB4AHgBcAFwAXABcAFwAKgBcAFwAXABcAFwAXABcAFwAXABcAEsASwBLAEsASwBLAEsASwBLAEsAXABcAFwAXABcACsAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAFAAUABQAAQAUABQAFAAUABQAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAHgANAA0ADQBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAXAAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAKgAqACoAXABcACoAKgBcAFwAXABcAFwAKgAqAFwAKgBcACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcACoAKgBQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAA0ADQBQAFAAUAAEAAQAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQADQAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAVABVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBUAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVACsAKwArACsAKwArACsAKwArACsAKwArAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAKwArACsAKwBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAKwArACsAKwAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAKwArACsAKwArAFYABABWAFYAVgBWAFYAVgBWAFYAVgBWAB4AVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgArAFYAVgBWAFYAVgArAFYAKwBWAFYAKwBWAFYAKwBWAFYAVgBWAFYAVgBWAFYAVgBWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAEQAWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAaAB4AKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAGAARABEAGAAYABMAEwAWABEAFAArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACUAJQAlACUAJQAWABEAFgARABYAEQAWABEAFgARABYAEQAlACUAFgARACUAJQAlACUAJQAlACUAEQAlABEAKwAVABUAEwATACUAFgARABYAEQAWABEAJQAlACUAJQAlACUAJQAlACsAJQAbABoAJQArACsAKwArAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAcAKwATACUAJQAbABoAJQAlABYAEQAlACUAEQAlABEAJQBXAFcAVwBXAFcAVwBXAFcAVwBXABUAFQAlACUAJQATACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXABYAJQARACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAWACUAEQAlABYAEQARABYAEQARABUAVwBRAFEAUQBRAFEAUQBRAFEAUQBRAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcARwArACsAVwBXAFcAVwBXAFcAKwArAFcAVwBXAFcAVwBXACsAKwBXAFcAVwBXAFcAVwArACsAVwBXAFcAKwArACsAGgAbACUAJQAlABsAGwArAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAAQAB0AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsADQANAA0AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsADQBQAFAAUABQACsAKwArACsAUABQAFAAUABQAFAAUABQAA0AUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAArACsAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQACsAKwArAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgBQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwBQAFAAUABQAFAABAAEAAQAKwAEAAQAKwArACsAKwArAAQABAAEAAQAUABQAFAAUAArAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsABAAEAAQAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsADQANAA0ADQANAA0ADQANAB4AKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AUABQAFAAUABQAFAAUABQAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwArACsAUABQAFAAUABQAA0ADQANAA0ADQANABQAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwANAA0ADQANAA0ADQANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAA0ADQAeAB4AHgAeAB4AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsASwBLAEsASwBLAEsASwBLAEsASwANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAeAA4AUAArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAADQANAB4ADQAeAAQABAAEAB4AKwArAEsASwBLAEsASwBLAEsASwBLAEsAUAAOAFAADQANAA0AKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAANAA0AHgANAA0AHgAEACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAA0AKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsABAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAUAArACsAKwArACsAKwAEACsAKwArACsAKwBQAFAAUABQAFAABAAEACsAKwAEAAQABAAEAAQABAAEACsAKwArAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABABQAFAAUABQAA0ADQANAA0AHgBLAEsASwBLAEsASwBLAEsASwBLACsADQArAB4AKwArAAQABAAEAAQAUABQAB4AUAArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEACsAKwAEAAQABAAEAAQABAAEAAQABAAOAA0ADQATABMAHgAeAB4ADQANAA0ADQANAA0ADQANAA0ADQANAA0ADQANAA0AUABQAFAAUAAEAAQAKwArAAQADQANAB4AUAArACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAKwAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAXABcAA0ADQANACoASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAFAABAAEAAQABAAOAB4ADQANAA0ADQAOAB4ABAArACsAKwArACsAKwArACsAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAUABQAFAAUAArACsAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAA0ADQANACsADgAOAA4ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAAQABAAEAFAADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAOABMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAArACsAKwAEACsABAAEACsABAAEAAQABAAEAAQABABQAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABIAEgAQwBDAEMAUABQAFAAUABDAFAAUABQAEgAQwBIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABDAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwANAA0AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAANACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAA0ADQANAB4AHgAeAB4AHgAeAFAAUABQAFAADQAeACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAEcARwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwArACsAKwArACsAKwArACsAKwArACsAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQACsAKwAeAAQABAANAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAB4AHgAeAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAHgAeAAQABAAEAAQABAAEAAQAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAEAAQABAAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUAArACsAUAArACsAUABQACsAKwBQAFAAUABQACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQACsAUABQAFAAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwAeAB4AUABQAFAAUABQACsAUAArACsAKwBQAFAAUABQAFAAUABQACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AKwArAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAEAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAeAB4ADQANAA0ADQAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABAArAAQABAArAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAEAAQABAAEAAQABAAEACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAFgAWAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArAFAAKwArAFAAKwBQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArAFAAKwBQACsAKwArACsAKwArAFAAKwArACsAKwBQACsAUAArAFAAKwBQAFAAUAArAFAAUAArAFAAKwArAFAAKwBQACsAUAArAFAAKwBQACsAUABQACsAUAArACsAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQACsAUABQAFAAUAArAFAAKwBQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwBQAFAAUAArAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAlACUAJQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeACUAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeACUAJQAlACUAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeACUAJQAlACUAJQAeACUAJQAlACUAJQAgACAAIAAlACUAIAAlACUAIAAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIQAhACEAIQAhACUAJQAgACAAJQAlACAAIAAgACAAIAAgACAAIAAgACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIAAgACAAIAAlACUAJQAlACAAJQAgACAAIAAgACAAIAAgACAAIAAlACUAJQAgACUAJQAlACUAIAAgACAAJQAgACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeACUAHgAlAB4AJQAlACUAJQAlACAAJQAlACUAJQAeACUAHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIAAgACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIAAlACUAJQAlACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAIAAgACAAJQAlACUAIAAgACAAIAAgAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFwAXABcAFQAVABUAHgAeAB4AHgAlACUAJQAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIAAgACAAJQAlACUAJQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAlACAAIAAlACUAJQAlACUAJQAgACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAIAAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsA';

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(492);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 410 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 411 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(417);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 413 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 415 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 416 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(416);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 418 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isFSA = isFSA;
	exports.isError = isError;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashIsplainobject = __webpack_require__(453);
	
	var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);
	
	var validKeys = ['type', 'payload', 'error', 'meta'];
	
	function isValidKey(key) {
	  return validKeys.indexOf(key) > -1;
	}
	
	function isFSA(action) {
	  return _lodashIsplainobject2['default'](action) && typeof action.type !== 'undefined' && Object.keys(action).every(isValidKey);
	}
	
	function isError(action) {
	  return action.error === true;
	}

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(77);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(53);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(184);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(185);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(186);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 421 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ANGLE = /([+-]?\d*\.?\d+)(deg|grad|rad|turn)/i;
	
	var parseAngle = exports.parseAngle = function parseAngle(angle) {
	    var match = angle.match(ANGLE);
	
	    if (match) {
	        var value = parseFloat(match[1]);
	        switch (match[2].toLowerCase()) {
	            case 'deg':
	                return Math.PI * value / 180;
	            case 'grad':
	                return Math.PI / 200 * value;
	            case 'rad':
	                return value;
	            case 'turn':
	                return Math.PI * 2 * value;
	        }
	    }
	
	    return null;
	};

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cloneWindow = exports.DocumentCloner = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Bounds = __webpack_require__(39);
	
	var _Proxy = __webpack_require__(191);
	
	var _ResourceLoader = __webpack_require__(427);
	
	var _ResourceLoader2 = _interopRequireDefault(_ResourceLoader);
	
	var _Util = __webpack_require__(55);
	
	var _background = __webpack_require__(65);
	
	var _CanvasRenderer = __webpack_require__(198);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _PseudoNodeContent = __webpack_require__(425);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
	
	var DocumentCloner = exports.DocumentCloner = function () {
	    function DocumentCloner(element, options, logger, copyInline, renderer) {
	        _classCallCheck(this, DocumentCloner);
	
	        this.referenceElement = element;
	        this.scrolledElements = [];
	        this.copyStyles = copyInline;
	        this.inlineImages = copyInline;
	        this.logger = logger;
	        this.options = options;
	        this.renderer = renderer;
	        this.resourceLoader = new _ResourceLoader2.default(options, logger, window);
	        this.pseudoContentData = {
	            counters: {},
	            quoteDepth: 0
	        };
	        // $FlowFixMe
	        this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
	    }
	
	    _createClass(DocumentCloner, [{
	        key: 'inlineAllImages',
	        value: function inlineAllImages(node) {
	            var _this = this;
	
	            if (this.inlineImages && node) {
	                var style = node.style;
	                Promise.all((0, _background.parseBackgroundImage)(style.backgroundImage).map(function (backgroundImage) {
	                    if (backgroundImage.method === 'url') {
	                        return _this.resourceLoader.inlineImage(backgroundImage.args[0]).then(function (img) {
	                            return img && typeof img.src === 'string' ? 'url("' + img.src + '")' : 'none';
	                        }).catch(function (e) {
	                            if (false) {
	                                _this.logger.log('Unable to load image', e);
	                            }
	                        });
	                    }
	                    return Promise.resolve('' + backgroundImage.prefix + backgroundImage.method + '(' + backgroundImage.args.join(',') + ')');
	                })).then(function (backgroundImages) {
	                    if (backgroundImages.length > 1) {
	                        // TODO Multiple backgrounds somehow broken in Chrome
	                        style.backgroundColor = '';
	                    }
	                    style.backgroundImage = backgroundImages.join(',');
	                });
	
	                if (node instanceof HTMLImageElement) {
	                    this.resourceLoader.inlineImage(node.src).then(function (img) {
	                        if (img && node instanceof HTMLImageElement && node.parentNode) {
	                            var parentNode = node.parentNode;
	                            var clonedChild = (0, _Util.copyCSSStyles)(node.style, img.cloneNode(false));
	                            parentNode.replaceChild(clonedChild, node);
	                        }
	                    }).catch(function (e) {
	                        if (false) {
	                            _this.logger.log('Unable to load image', e);
	                        }
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'inlineFonts',
	        value: function inlineFonts(document) {
	            var _this2 = this;
	
	            return Promise.all(Array.from(document.styleSheets).map(function (sheet) {
	                if (sheet.href) {
	                    return fetch(sheet.href).then(function (res) {
	                        return res.text();
	                    }).then(function (text) {
	                        return createStyleSheetFontsFromText(text, sheet.href);
	                    }).catch(function (e) {
	                        if (false) {
	                            _this2.logger.log('Unable to load stylesheet', e);
	                        }
	                        return [];
	                    });
	                }
	                return getSheetFonts(sheet, document);
	            })).then(function (fonts) {
	                return fonts.reduce(function (acc, font) {
	                    return acc.concat(font);
	                }, []);
	            }).then(function (fonts) {
	                return Promise.all(fonts.map(function (font) {
	                    return fetch(font.formats[0].src).then(function (response) {
	                        return response.blob();
	                    }).then(function (blob) {
	                        return new Promise(function (resolve, reject) {
	                            var reader = new FileReader();
	                            reader.onerror = reject;
	                            reader.onload = function () {
	                                // $FlowFixMe
	                                var result = reader.result;
	                                resolve(result);
	                            };
	                            reader.readAsDataURL(blob);
	                        });
	                    }).then(function (dataUri) {
	                        font.fontFace.setProperty('src', 'url("' + dataUri + '")');
	                        return '@font-face {' + font.fontFace.cssText + ' ';
	                    });
	                }));
	            }).then(function (fontCss) {
	                var style = document.createElement('style');
	                style.textContent = fontCss.join('\n');
	                _this2.documentElement.appendChild(style);
	            });
	        }
	    }, {
	        key: 'createElementClone',
	        value: function createElementClone(node) {
	            var _this3 = this;
	
	            if (this.copyStyles && node instanceof HTMLCanvasElement) {
	                var img = node.ownerDocument.createElement('img');
	                try {
	                    img.src = node.toDataURL();
	                    return img;
	                } catch (e) {
	                    if (false) {
	                        this.logger.log('Unable to clone canvas contents, canvas is tainted');
	                    }
	                }
	            }
	
	            if (node instanceof HTMLIFrameElement) {
	                var tempIframe = node.cloneNode(false);
	                var iframeKey = generateIframeKey();
	                tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);
	
	                var _parseBounds = (0, _Bounds.parseBounds)(node, 0, 0),
	                    width = _parseBounds.width,
	                    height = _parseBounds.height;
	
	                this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(node, this.options).then(function (documentElement) {
	                    return _this3.renderer(documentElement, {
	                        async: _this3.options.async,
	                        allowTaint: _this3.options.allowTaint,
	                        backgroundColor: '#ffffff',
	                        canvas: null,
	                        imageTimeout: _this3.options.imageTimeout,
	                        logging: _this3.options.logging,
	                        proxy: _this3.options.proxy,
	                        removeContainer: _this3.options.removeContainer,
	                        scale: _this3.options.scale,
	                        foreignObjectRendering: _this3.options.foreignObjectRendering,
	                        useCORS: _this3.options.useCORS,
	                        target: new _CanvasRenderer2.default(),
	                        width: width,
	                        height: height,
	                        x: 0,
	                        y: 0,
	                        windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
	                        windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
	                        scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
	                        scrollY: documentElement.ownerDocument.defaultView.pageYOffset
	                    }, _this3.logger.child(iframeKey));
	                }).then(function (canvas) {
	                    return new Promise(function (resolve, reject) {
	                        var iframeCanvas = document.createElement('img');
	                        iframeCanvas.onload = function () {
	                            return resolve(canvas);
	                        };
	                        iframeCanvas.onerror = reject;
	                        iframeCanvas.src = canvas.toDataURL();
	                        if (tempIframe.parentNode) {
	                            tempIframe.parentNode.replaceChild((0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node), iframeCanvas), tempIframe);
	                        }
	                    });
	                });
	                return tempIframe;
	            }
	
	            if (node instanceof HTMLStyleElement && node.sheet && node.sheet.cssRules) {
	                var css = [].slice.call(node.sheet.cssRules, 0).reduce(function (css, rule) {
	                    try {
	                        if (rule && rule.cssText) {
	                            return css + rule.cssText;
	                        }
	                        return css;
	                    } catch (err) {
	                        _this3.logger.log('Unable to access cssText property', rule.name);
	                        return css;
	                    }
	                }, '');
	                var style = node.cloneNode(false);
	                style.textContent = css;
	                return style;
	            }
	
	            return node.cloneNode(false);
	        }
	    }, {
	        key: 'cloneNode',
	        value: function cloneNode(node) {
	            var clone = node.nodeType === Node.TEXT_NODE ? document.createTextNode(node.nodeValue) : this.createElementClone(node);
	
	            var window = node.ownerDocument.defaultView;
	            var style = node instanceof window.HTMLElement ? window.getComputedStyle(node) : null;
	            var styleBefore = node instanceof window.HTMLElement ? window.getComputedStyle(node, ':before') : null;
	            var styleAfter = node instanceof window.HTMLElement ? window.getComputedStyle(node, ':after') : null;
	
	            if (this.referenceElement === node && clone instanceof window.HTMLElement) {
	                this.clonedReferenceElement = clone;
	            }
	
	            if (clone instanceof window.HTMLBodyElement) {
	                createPseudoHideStyles(clone);
	            }
	
	            var counters = (0, _PseudoNodeContent.parseCounterReset)(style, this.pseudoContentData);
	            var contentBefore = (0, _PseudoNodeContent.resolvePseudoContent)(node, styleBefore, this.pseudoContentData);
	
	            for (var child = node.firstChild; child; child = child.nextSibling) {
	                if (child.nodeType !== Node.ELEMENT_NODE || child.nodeName !== 'SCRIPT' &&
	                // $FlowFixMe
	                !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' ||
	                // $FlowFixMe
	                !this.options.ignoreElements(child))) {
	                    if (!this.copyStyles || child.nodeName !== 'STYLE') {
	                        clone.appendChild(this.cloneNode(child));
	                    }
	                }
	            }
	
	            var contentAfter = (0, _PseudoNodeContent.resolvePseudoContent)(node, styleAfter, this.pseudoContentData);
	            (0, _PseudoNodeContent.popCounters)(counters, this.pseudoContentData);
	
	            if (node instanceof window.HTMLElement && clone instanceof window.HTMLElement) {
	                if (styleBefore) {
	                    this.inlineAllImages(inlinePseudoElement(node, clone, styleBefore, contentBefore, PSEUDO_BEFORE));
	                }
	                if (styleAfter) {
	                    this.inlineAllImages(inlinePseudoElement(node, clone, styleAfter, contentAfter, PSEUDO_AFTER));
	                }
	                if (style && this.copyStyles && !(node instanceof HTMLIFrameElement)) {
	                    (0, _Util.copyCSSStyles)(style, clone);
	                }
	                this.inlineAllImages(clone);
	                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
	                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
	                }
	                switch (node.nodeName) {
	                    case 'CANVAS':
	                        if (!this.copyStyles) {
	                            cloneCanvasContents(node, clone);
	                        }
	                        break;
	                    case 'TEXTAREA':
	                    case 'SELECT':
	                        clone.value = node.value;
	                        break;
	                }
	            }
	            return clone;
	        }
	    }]);
	
	    return DocumentCloner;
	}();
	
	var getSheetFonts = function getSheetFonts(sheet, document) {
	    // $FlowFixMe
	    return (sheet.cssRules ? Array.from(sheet.cssRules) : []).filter(function (rule) {
	        return rule.type === CSSRule.FONT_FACE_RULE;
	    }).map(function (rule) {
	        var src = (0, _background.parseBackgroundImage)(rule.style.getPropertyValue('src'));
	        var formats = [];
	        for (var i = 0; i < src.length; i++) {
	            if (src[i].method === 'url' && src[i + 1] && src[i + 1].method === 'format') {
	                var a = document.createElement('a');
	                a.href = src[i].args[0];
	                if (document.body) {
	                    document.body.appendChild(a);
	                }
	
	                var font = {
	                    src: a.href,
	                    format: src[i + 1].args[0]
	                };
	                formats.push(font);
	            }
	        }
	
	        return {
	            // TODO select correct format for browser),
	
	            formats: formats.filter(function (font) {
	                return (/^woff/i.test(font.format)
	                );
	            }),
	            fontFace: rule.style
	        };
	    }).filter(function (font) {
	        return font.formats.length;
	    });
	};
	
	var createStyleSheetFontsFromText = function createStyleSheetFontsFromText(text, baseHref) {
	    var doc = document.implementation.createHTMLDocument('');
	    var base = document.createElement('base');
	    // $FlowFixMe
	    base.href = baseHref;
	    var style = document.createElement('style');
	
	    style.textContent = text;
	    if (doc.head) {
	        doc.head.appendChild(base);
	    }
	    if (doc.body) {
	        doc.body.appendChild(style);
	    }
	
	    return style.sheet ? getSheetFonts(style.sheet, doc) : [];
	};
	
	var restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
	    if (ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
	        ownerDocument.defaultView.scrollTo(x, y);
	    }
	};
	
	var cloneCanvasContents = function cloneCanvasContents(canvas, clonedCanvas) {
	    try {
	        if (clonedCanvas) {
	            clonedCanvas.width = canvas.width;
	            clonedCanvas.height = canvas.height;
	            var ctx = canvas.getContext('2d');
	            var clonedCtx = clonedCanvas.getContext('2d');
	            if (ctx) {
	                clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
	            } else {
	                clonedCtx.drawImage(canvas, 0, 0);
	            }
	        }
	    } catch (e) {}
	};
	
	var inlinePseudoElement = function inlinePseudoElement(node, clone, style, contentItems, pseudoElt) {
	    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') {
	        return;
	    }
	
	    var anonymousReplacedElement = clone.ownerDocument.createElement('html2canvaspseudoelement');
	    (0, _Util.copyCSSStyles)(style, anonymousReplacedElement);
	
	    if (contentItems) {
	        var len = contentItems.length;
	        for (var i = 0; i < len; i++) {
	            var item = contentItems[i];
	            switch (item.type) {
	                case _PseudoNodeContent.PSEUDO_CONTENT_ITEM_TYPE.IMAGE:
	                    var img = clone.ownerDocument.createElement('img');
	                    img.src = (0, _background.parseBackgroundImage)('url(' + item.value + ')')[0].args[0];
	                    img.style.opacity = '1';
	                    anonymousReplacedElement.appendChild(img);
	                    break;
	                case _PseudoNodeContent.PSEUDO_CONTENT_ITEM_TYPE.TEXT:
	                    anonymousReplacedElement.appendChild(clone.ownerDocument.createTextNode(item.value));
	                    break;
	            }
	        }
	    }
	
	    anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
	    clone.className += pseudoElt === PSEUDO_BEFORE ? ' ' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
	    if (pseudoElt === PSEUDO_BEFORE) {
	        clone.insertBefore(anonymousReplacedElement, clone.firstChild);
	    } else {
	        clone.appendChild(anonymousReplacedElement);
	    }
	
	    return anonymousReplacedElement;
	};
	
	var URL_REGEXP = /^url\((.+)\)$/i;
	var PSEUDO_BEFORE = ':before';
	var PSEUDO_AFTER = ':after';
	var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
	var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
	
	var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
	
	var createPseudoHideStyles = function createPseudoHideStyles(body) {
	    createStyles(body, '.' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + '\n         .' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
	};
	
	var createStyles = function createStyles(body, styles) {
	    var style = body.ownerDocument.createElement('style');
	    style.innerHTML = styles;
	    body.appendChild(style);
	};
	
	var initNode = function initNode(_ref) {
	    var _ref2 = _slicedToArray(_ref, 3),
	        element = _ref2[0],
	        x = _ref2[1],
	        y = _ref2[2];
	
	    element.scrollLeft = x;
	    element.scrollTop = y;
	};
	
	var generateIframeKey = function generateIframeKey() {
	    return Math.ceil(Date.now() + Math.random() * 10000000).toString(16);
	};
	
	var DATA_URI_REGEXP = /^data:text\/(.+);(base64)?,(.*)$/i;
	
	var getIframeDocumentElement = function getIframeDocumentElement(node, options) {
	    try {
	        return Promise.resolve(node.contentWindow.document.documentElement);
	    } catch (e) {
	        return options.proxy ? (0, _Proxy.Proxy)(node.src, options).then(function (html) {
	            var match = html.match(DATA_URI_REGEXP);
	            if (!match) {
	                return Promise.reject();
	            }
	
	            return match[2] === 'base64' ? window.atob(decodeURIComponent(match[3])) : decodeURIComponent(match[3]);
	        }).then(function (html) {
	            return createIframeContainer(node.ownerDocument, (0, _Bounds.parseBounds)(node, 0, 0)).then(function (cloneIframeContainer) {
	                var cloneWindow = cloneIframeContainer.contentWindow;
	                var documentClone = cloneWindow.document;
	
	                documentClone.open();
	                documentClone.write(html);
	                var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {
	                    return documentClone.documentElement;
	                });
	
	                documentClone.close();
	                return iframeLoad;
	            });
	        }) : Promise.reject();
	    }
	};
	
	var createIframeContainer = function createIframeContainer(ownerDocument, bounds) {
	    var cloneIframeContainer = ownerDocument.createElement('iframe');
	
	    cloneIframeContainer.className = 'html2canvas-container';
	    cloneIframeContainer.style.visibility = 'hidden';
	    cloneIframeContainer.style.position = 'fixed';
	    cloneIframeContainer.style.left = '-10000px';
	    cloneIframeContainer.style.top = '0px';
	    cloneIframeContainer.style.border = '0';
	    cloneIframeContainer.width = bounds.width.toString();
	    cloneIframeContainer.height = bounds.height.toString();
	    cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
	    cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
	    if (!ownerDocument.body) {
	        return Promise.reject( false ? 'Body element not found in Document that is getting rendered' : '');
	    }
	
	    ownerDocument.body.appendChild(cloneIframeContainer);
	
	    return Promise.resolve(cloneIframeContainer);
	};
	
	var iframeLoader = function iframeLoader(cloneIframeContainer) {
	    var cloneWindow = cloneIframeContainer.contentWindow;
	    var documentClone = cloneWindow.document;
	
	    return new Promise(function (resolve, reject) {
	        cloneWindow.onload = cloneIframeContainer.onload = documentClone.onreadystatechange = function () {
	            var interval = setInterval(function () {
	                if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
	                    clearInterval(interval);
	                    resolve(cloneIframeContainer);
	                }
	            }, 50);
	        };
	    });
	};
	
	var cloneWindow = exports.cloneWindow = function cloneWindow(ownerDocument, bounds, referenceElement, options, logger, renderer) {
	    var cloner = new DocumentCloner(referenceElement, options, logger, false, renderer);
	    var scrollX = ownerDocument.defaultView.pageXOffset;
	    var scrollY = ownerDocument.defaultView.pageYOffset;
	
	    return createIframeContainer(ownerDocument, bounds).then(function (cloneIframeContainer) {
	        var cloneWindow = cloneIframeContainer.contentWindow;
	        var documentClone = cloneWindow.document;
	
	        /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
	             if window url is about:blank, we can assign the url to current by writing onto the document
	             */
	
	        var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {
	            cloner.scrolledElements.forEach(initNode);
	            cloneWindow.scrollTo(bounds.left, bounds.top);
	            if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== bounds.top || cloneWindow.scrollX !== bounds.left)) {
	                documentClone.documentElement.style.top = -bounds.top + 'px';
	                documentClone.documentElement.style.left = -bounds.left + 'px';
	                documentClone.documentElement.style.position = 'absolute';
	            }
	
	            var result = Promise.resolve([cloneIframeContainer, cloner.clonedReferenceElement, cloner.resourceLoader]);
	
	            var onclone = options.onclone;
	
	            return cloner.clonedReferenceElement instanceof cloneWindow.HTMLElement || cloner.clonedReferenceElement instanceof ownerDocument.defaultView.HTMLElement || cloner.clonedReferenceElement instanceof HTMLElement ? typeof onclone === 'function' ? Promise.resolve().then(function () {
	                return onclone(documentClone);
	            }).then(function () {
	                return result;
	            }) : result : Promise.reject( false ? 'Error finding the ' + referenceElement.nodeName + ' in the cloned document' : '');
	        });
	
	        documentClone.open();
	        documentClone.write(serializeDoctype(document.doctype) + '<html></html>');
	        // Chrome scrolls the parent document for some reason after the write to the cloned window???
	        restoreOwnerScroll(referenceElement.ownerDocument, scrollX, scrollY);
	        documentClone.replaceChild(documentClone.adoptNode(cloner.documentElement), documentClone.documentElement);
	        documentClone.close();
	
	        return iframeLoad;
	    });
	};
	
	var serializeDoctype = function serializeDoctype(doctype) {
	    var str = '';
	    if (doctype) {
	        str += '<!DOCTYPE ';
	        if (doctype.name) {
	            str += doctype.name;
	        }
	
	        if (doctype.internalSubset) {
	            str += doctype.internalSubset;
	        }
	
	        if (doctype.publicId) {
	            str += '"' + doctype.publicId + '"';
	        }
	
	        if (doctype.systemId) {
	            str += '"' + doctype.systemId + '"';
	        }
	
	        str += '>';
	    }
	
	    return str;
	};

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.transformWebkitRadialGradientArgs = exports.parseGradient = exports.RadialGradient = exports.LinearGradient = exports.RADIAL_GRADIENT_SHAPE = exports.GRADIENT_TYPE = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _NodeContainer = __webpack_require__(54);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _Angle = __webpack_require__(421);
	
	var _Color = __webpack_require__(31);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Length = __webpack_require__(40);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	var _Util = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SIDE_OR_CORNER = /^(to )?(left|top|right|bottom)( (left|top|right|bottom))?$/i;
	var PERCENTAGE_ANGLES = /^([+-]?\d*\.?\d+)% ([+-]?\d*\.?\d+)%$/i;
	var ENDS_WITH_LENGTH = /(px)|%|( 0)$/i;
	var FROM_TO_COLORSTOP = /^(from|to|color-stop)\((?:([\d.]+)(%)?,\s*)?(.+?)\)$/i;
	var RADIAL_SHAPE_DEFINITION = /^\s*(circle|ellipse)?\s*((?:([\d.]+)(px|r?em|%)\s*(?:([\d.]+)(px|r?em|%))?)|closest-side|closest-corner|farthest-side|farthest-corner)?\s*(?:at\s*(?:(left|center|right)|([\d.]+)(px|r?em|%))\s+(?:(top|center|bottom)|([\d.]+)(px|r?em|%)))?(?:\s|$)/i;
	
	var GRADIENT_TYPE = exports.GRADIENT_TYPE = {
	    LINEAR_GRADIENT: 0,
	    RADIAL_GRADIENT: 1
	};
	
	var RADIAL_GRADIENT_SHAPE = exports.RADIAL_GRADIENT_SHAPE = {
	    CIRCLE: 0,
	    ELLIPSE: 1
	};
	
	var LENGTH_FOR_POSITION = {
	    left: new _Length2.default('0%'),
	    top: new _Length2.default('0%'),
	    center: new _Length2.default('50%'),
	    right: new _Length2.default('100%'),
	    bottom: new _Length2.default('100%')
	};
	
	var LinearGradient = exports.LinearGradient = function LinearGradient(colorStops, direction) {
	    _classCallCheck(this, LinearGradient);
	
	    this.type = GRADIENT_TYPE.LINEAR_GRADIENT;
	    this.colorStops = colorStops;
	    this.direction = direction;
	};
	
	var RadialGradient = exports.RadialGradient = function RadialGradient(colorStops, shape, center, radius) {
	    _classCallCheck(this, RadialGradient);
	
	    this.type = GRADIENT_TYPE.RADIAL_GRADIENT;
	    this.colorStops = colorStops;
	    this.shape = shape;
	    this.center = center;
	    this.radius = radius;
	};
	
	var parseGradient = exports.parseGradient = function parseGradient(container, _ref, bounds) {
	    var args = _ref.args,
	        method = _ref.method,
	        prefix = _ref.prefix;
	
	    if (method === 'linear-gradient') {
	        return parseLinearGradient(args, bounds, !!prefix);
	    } else if (method === 'gradient' && args[0] === 'linear') {
	        // TODO handle correct angle
	        return parseLinearGradient(['to bottom'].concat(transformObsoleteColorStops(args.slice(3))), bounds, !!prefix);
	    } else if (method === 'radial-gradient') {
	        return parseRadialGradient(container, prefix === '-webkit-' ? transformWebkitRadialGradientArgs(args) : args, bounds);
	    } else if (method === 'gradient' && args[0] === 'radial') {
	        return parseRadialGradient(container, transformObsoleteColorStops(transformWebkitRadialGradientArgs(args.slice(1))), bounds);
	    }
	};
	
	var parseColorStops = function parseColorStops(args, firstColorStopIndex, lineLength) {
	    var colorStops = [];
	
	    for (var i = firstColorStopIndex; i < args.length; i++) {
	        var value = args[i];
	        var HAS_LENGTH = ENDS_WITH_LENGTH.test(value);
	        var lastSpaceIndex = value.lastIndexOf(' ');
	        var _color = new _Color2.default(HAS_LENGTH ? value.substring(0, lastSpaceIndex) : value);
	        var _stop = HAS_LENGTH ? new _Length2.default(value.substring(lastSpaceIndex + 1)) : i === firstColorStopIndex ? new _Length2.default('0%') : i === args.length - 1 ? new _Length2.default('100%') : null;
	        colorStops.push({ color: _color, stop: _stop });
	    }
	
	    var absoluteValuedColorStops = colorStops.map(function (_ref2) {
	        var color = _ref2.color,
	            stop = _ref2.stop;
	
	        var absoluteStop = lineLength === 0 ? 0 : stop ? stop.getAbsoluteValue(lineLength) / lineLength : null;
	
	        return {
	            color: color,
	            // $FlowFixMe
	            stop: absoluteStop
	        };
	    });
	
	    var previousColorStop = absoluteValuedColorStops[0].stop;
	    for (var _i = 0; _i < absoluteValuedColorStops.length; _i++) {
	        if (previousColorStop !== null) {
	            var _stop2 = absoluteValuedColorStops[_i].stop;
	            if (_stop2 === null) {
	                var n = _i;
	                while (absoluteValuedColorStops[n].stop === null) {
	                    n++;
	                }
	                var steps = n - _i + 1;
	                var nextColorStep = absoluteValuedColorStops[n].stop;
	                var stepSize = (nextColorStep - previousColorStop) / steps;
	                for (; _i < n; _i++) {
	                    previousColorStop = absoluteValuedColorStops[_i].stop = previousColorStop + stepSize;
	                }
	            } else {
	                previousColorStop = _stop2;
	            }
	        }
	    }
	
	    return absoluteValuedColorStops;
	};
	
	var parseLinearGradient = function parseLinearGradient(args, bounds, hasPrefix) {
	    var angle = (0, _Angle.parseAngle)(args[0]);
	    var HAS_SIDE_OR_CORNER = SIDE_OR_CORNER.test(args[0]);
	    var HAS_DIRECTION = HAS_SIDE_OR_CORNER || angle !== null || PERCENTAGE_ANGLES.test(args[0]);
	    var direction = HAS_DIRECTION ? angle !== null ? calculateGradientDirection(
	    // if there is a prefix, the 0° angle points due East (instead of North per W3C)
	    hasPrefix ? angle - Math.PI * 0.5 : angle, bounds) : HAS_SIDE_OR_CORNER ? parseSideOrCorner(args[0], bounds) : parsePercentageAngle(args[0], bounds) : calculateGradientDirection(Math.PI, bounds);
	    var firstColorStopIndex = HAS_DIRECTION ? 1 : 0;
	
	    // TODO: Fix some inaccuracy with color stops with px values
	    var lineLength = Math.min((0, _Util.distance)(Math.abs(direction.x0) + Math.abs(direction.x1), Math.abs(direction.y0) + Math.abs(direction.y1)), bounds.width * 2, bounds.height * 2);
	
	    return new LinearGradient(parseColorStops(args, firstColorStopIndex, lineLength), direction);
	};
	
	var parseRadialGradient = function parseRadialGradient(container, args, bounds) {
	    var m = args[0].match(RADIAL_SHAPE_DEFINITION);
	    var shape = m && (m[1] === 'circle' || // explicit shape specification
	    m[3] !== undefined && m[5] === undefined) // only one radius coordinate
	    ? RADIAL_GRADIENT_SHAPE.CIRCLE : RADIAL_GRADIENT_SHAPE.ELLIPSE;
	    var radius = {};
	    var center = {};
	
	    if (m) {
	        // Radius
	        if (m[3] !== undefined) {
	            radius.x = (0, _Length.calculateLengthFromValueWithUnit)(container, m[3], m[4]).getAbsoluteValue(bounds.width);
	        }
	
	        if (m[5] !== undefined) {
	            radius.y = (0, _Length.calculateLengthFromValueWithUnit)(container, m[5], m[6]).getAbsoluteValue(bounds.height);
	        }
	
	        // Position
	        if (m[7]) {
	            center.x = LENGTH_FOR_POSITION[m[7].toLowerCase()];
	        } else if (m[8] !== undefined) {
	            center.x = (0, _Length.calculateLengthFromValueWithUnit)(container, m[8], m[9]);
	        }
	
	        if (m[10]) {
	            center.y = LENGTH_FOR_POSITION[m[10].toLowerCase()];
	        } else if (m[11] !== undefined) {
	            center.y = (0, _Length.calculateLengthFromValueWithUnit)(container, m[11], m[12]);
	        }
	    }
	
	    var gradientCenter = {
	        x: center.x === undefined ? bounds.width / 2 : center.x.getAbsoluteValue(bounds.width),
	        y: center.y === undefined ? bounds.height / 2 : center.y.getAbsoluteValue(bounds.height)
	    };
	    var gradientRadius = calculateRadius(m && m[2] || 'farthest-corner', shape, gradientCenter, radius, bounds);
	
	    return new RadialGradient(parseColorStops(args, m ? 1 : 0, Math.min(gradientRadius.x, gradientRadius.y)), shape, gradientCenter, gradientRadius);
	};
	
	var calculateGradientDirection = function calculateGradientDirection(radian, bounds) {
	    var width = bounds.width;
	    var height = bounds.height;
	    var HALF_WIDTH = width * 0.5;
	    var HALF_HEIGHT = height * 0.5;
	    var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
	    var HALF_LINE_LENGTH = lineLength / 2;
	
	    var x0 = HALF_WIDTH + Math.sin(radian) * HALF_LINE_LENGTH;
	    var y0 = HALF_HEIGHT - Math.cos(radian) * HALF_LINE_LENGTH;
	    var x1 = width - x0;
	    var y1 = height - y0;
	
	    return { x0: x0, x1: x1, y0: y0, y1: y1 };
	};
	
	var parseTopRight = function parseTopRight(bounds) {
	    return Math.acos(bounds.width / 2 / ((0, _Util.distance)(bounds.width, bounds.height) / 2));
	};
	
	var parseSideOrCorner = function parseSideOrCorner(side, bounds) {
	    switch (side) {
	        case 'bottom':
	        case 'to top':
	            return calculateGradientDirection(0, bounds);
	        case 'left':
	        case 'to right':
	            return calculateGradientDirection(Math.PI / 2, bounds);
	        case 'right':
	        case 'to left':
	            return calculateGradientDirection(3 * Math.PI / 2, bounds);
	        case 'top right':
	        case 'right top':
	        case 'to bottom left':
	        case 'to left bottom':
	            return calculateGradientDirection(Math.PI + parseTopRight(bounds), bounds);
	        case 'top left':
	        case 'left top':
	        case 'to bottom right':
	        case 'to right bottom':
	            return calculateGradientDirection(Math.PI - parseTopRight(bounds), bounds);
	        case 'bottom left':
	        case 'left bottom':
	        case 'to top right':
	        case 'to right top':
	            return calculateGradientDirection(parseTopRight(bounds), bounds);
	        case 'bottom right':
	        case 'right bottom':
	        case 'to top left':
	        case 'to left top':
	            return calculateGradientDirection(2 * Math.PI - parseTopRight(bounds), bounds);
	        case 'top':
	        case 'to bottom':
	        default:
	            return calculateGradientDirection(Math.PI, bounds);
	    }
	};
	
	var parsePercentageAngle = function parsePercentageAngle(angle, bounds) {
	    var _angle$split$map = angle.split(' ').map(parseFloat),
	        _angle$split$map2 = _slicedToArray(_angle$split$map, 2),
	        left = _angle$split$map2[0],
	        top = _angle$split$map2[1];
	
	    var ratio = left / 100 * bounds.width / (top / 100 * bounds.height);
	
	    return calculateGradientDirection(Math.atan(isNaN(ratio) ? 1 : ratio) + Math.PI / 2, bounds);
	};
	
	var findCorner = function findCorner(bounds, x, y, closest) {
	    var corners = [{ x: 0, y: 0 }, { x: 0, y: bounds.height }, { x: bounds.width, y: 0 }, { x: bounds.width, y: bounds.height }];
	
	    // $FlowFixMe
	    return corners.reduce(function (stat, corner) {
	        var d = (0, _Util.distance)(x - corner.x, y - corner.y);
	        if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
	            return {
	                optimumCorner: corner,
	                optimumDistance: d
	            };
	        }
	
	        return stat;
	    }, {
	        optimumDistance: closest ? Infinity : -Infinity,
	        optimumCorner: null
	    }).optimumCorner;
	};
	
	var calculateRadius = function calculateRadius(extent, shape, center, radius, bounds) {
	    var x = center.x;
	    var y = center.y;
	    var rx = 0;
	    var ry = 0;
	
	    switch (extent) {
	        case 'closest-side':
	            // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
	            // If the shape is an ellipse, it exactly meets the closest side in each dimension.
	            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
	                rx = ry = Math.min(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
	            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
	                rx = Math.min(Math.abs(x), Math.abs(x - bounds.width));
	                ry = Math.min(Math.abs(y), Math.abs(y - bounds.height));
	            }
	            break;
	
	        case 'closest-corner':
	            // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
	            // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
	            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
	                rx = ry = Math.min((0, _Util.distance)(x, y), (0, _Util.distance)(x, y - bounds.height), (0, _Util.distance)(x - bounds.width, y), (0, _Util.distance)(x - bounds.width, y - bounds.height));
	            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
	                // Compute the ratio ry/rx (which is to be the same as for "closest-side")
	                var c = Math.min(Math.abs(y), Math.abs(y - bounds.height)) / Math.min(Math.abs(x), Math.abs(x - bounds.width));
	                var corner = findCorner(bounds, x, y, true);
	                rx = (0, _Util.distance)(corner.x - x, (corner.y - y) / c);
	                ry = c * rx;
	            }
	            break;
	
	        case 'farthest-side':
	            // Same as closest-side, except the ending shape is sized based on the farthest side(s)
	            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
	                rx = ry = Math.max(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
	            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
	                rx = Math.max(Math.abs(x), Math.abs(x - bounds.width));
	                ry = Math.max(Math.abs(y), Math.abs(y - bounds.height));
	            }
	            break;
	
	        case 'farthest-corner':
	            // Same as closest-corner, except the ending shape is sized based on the farthest corner.
	            // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
	            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
	                rx = ry = Math.max((0, _Util.distance)(x, y), (0, _Util.distance)(x, y - bounds.height), (0, _Util.distance)(x - bounds.width, y), (0, _Util.distance)(x - bounds.width, y - bounds.height));
	            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
	                // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
	                var _c = Math.max(Math.abs(y), Math.abs(y - bounds.height)) / Math.max(Math.abs(x), Math.abs(x - bounds.width));
	                var _corner = findCorner(bounds, x, y, false);
	                rx = (0, _Util.distance)(_corner.x - x, (_corner.y - y) / _c);
	                ry = _c * rx;
	            }
	            break;
	
	        default:
	            // pixel or percentage values
	            rx = radius.x || 0;
	            ry = radius.y !== undefined ? radius.y : rx;
	            break;
	    }
	
	    return {
	        x: rx,
	        y: ry
	    };
	};
	
	var transformWebkitRadialGradientArgs = exports.transformWebkitRadialGradientArgs = function transformWebkitRadialGradientArgs(args) {
	    var shape = '';
	    var radius = '';
	    var extent = '';
	    var position = '';
	    var idx = 0;
	
	    var POSITION = /^(left|center|right|\d+(?:px|r?em|%)?)(?:\s+(top|center|bottom|\d+(?:px|r?em|%)?))?$/i;
	    var SHAPE_AND_EXTENT = /^(circle|ellipse)?\s*(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)?$/i;
	    var RADIUS = /^\d+(px|r?em|%)?(?:\s+\d+(px|r?em|%)?)?$/i;
	
	    var matchStartPosition = args[idx].match(POSITION);
	    if (matchStartPosition) {
	        idx++;
	    }
	
	    var matchShapeExtent = args[idx].match(SHAPE_AND_EXTENT);
	    if (matchShapeExtent) {
	        shape = matchShapeExtent[1] || '';
	        extent = matchShapeExtent[2] || '';
	        if (extent === 'contain') {
	            extent = 'closest-side';
	        } else if (extent === 'cover') {
	            extent = 'farthest-corner';
	        }
	        idx++;
	    }
	
	    var matchStartRadius = args[idx].match(RADIUS);
	    if (matchStartRadius) {
	        idx++;
	    }
	
	    var matchEndPosition = args[idx].match(POSITION);
	    if (matchEndPosition) {
	        idx++;
	    }
	
	    var matchEndRadius = args[idx].match(RADIUS);
	    if (matchEndRadius) {
	        idx++;
	    }
	
	    var matchPosition = matchEndPosition || matchStartPosition;
	    if (matchPosition && matchPosition[1]) {
	        position = matchPosition[1] + (/^\d+$/.test(matchPosition[1]) ? 'px' : '');
	        if (matchPosition[2]) {
	            position += ' ' + matchPosition[2] + (/^\d+$/.test(matchPosition[2]) ? 'px' : '');
	        }
	    }
	
	    var matchRadius = matchEndRadius || matchStartRadius;
	    if (matchRadius) {
	        radius = matchRadius[0];
	        if (!matchRadius[1]) {
	            radius += 'px';
	        }
	    }
	
	    if (position && !shape && !radius && !extent) {
	        radius = position;
	        position = '';
	    }
	
	    if (position) {
	        position = 'at ' + position;
	    }
	
	    return [[shape, extent, radius, position].filter(function (s) {
	        return !!s;
	    }).join(' ')].concat(args.slice(idx));
	};
	
	var transformObsoleteColorStops = function transformObsoleteColorStops(args) {
	    return args.map(function (color) {
	        return color.match(FROM_TO_COLORSTOP);
	    })
	    // $FlowFixMe
	    .map(function (v, index) {
	        if (!v) {
	            return args[index];
	        }
	
	        switch (v[1]) {
	            case 'from':
	                return v[4] + ' 0%';
	            case 'to':
	                return v[4] + ' 100%';
	            case 'color-stop':
	                if (v[3] === '%') {
	                    return v[4] + ' ' + v[2];
	                }
	                return v[4] + ' ' + parseFloat(v[2]) * 100 + '%';
	        }
	    });
	};

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NodeParser = undefined;
	
	var _StackingContext = __webpack_require__(428);
	
	var _StackingContext2 = _interopRequireDefault(_StackingContext);
	
	var _NodeContainer = __webpack_require__(54);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _TextContainer = __webpack_require__(79);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _Input = __webpack_require__(189);
	
	var _ListItem = __webpack_require__(115);
	
	var _listStyle = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NodeParser = exports.NodeParser = function NodeParser(node, resourceLoader, logger) {
	    if (false) {
	        logger.log('Starting node parsing');
	    }
	
	    var index = 0;
	
	    var container = new _NodeContainer2.default(node, null, resourceLoader, index++);
	    var stack = new _StackingContext2.default(container, null, true);
	
	    parseNodeTree(node, container, stack, resourceLoader, index);
	
	    if (false) {
	        logger.log('Finished parsing node tree');
	    }
	
	    return stack;
	};
	
	var IGNORED_NODE_NAMES = ['SCRIPT', 'HEAD', 'TITLE', 'OBJECT', 'BR', 'OPTION'];
	
	var parseNodeTree = function parseNodeTree(node, parent, stack, resourceLoader, index) {
	    if (false) {
	        throw new Error('Recursion error while parsing node tree');
	    }
	
	    for (var childNode = node.firstChild, nextNode; childNode; childNode = nextNode) {
	        nextNode = childNode.nextSibling;
	        var defaultView = childNode.ownerDocument.defaultView;
	        if (childNode instanceof defaultView.Text || childNode instanceof Text || defaultView.parent && childNode instanceof defaultView.parent.Text) {
	            if (childNode.data.trim().length > 0) {
	                parent.childNodes.push(_TextContainer2.default.fromTextNode(childNode, parent));
	            }
	        } else if (childNode instanceof defaultView.HTMLElement || childNode instanceof HTMLElement || defaultView.parent && childNode instanceof defaultView.parent.HTMLElement) {
	            if (IGNORED_NODE_NAMES.indexOf(childNode.nodeName) === -1) {
	                var container = new _NodeContainer2.default(childNode, parent, resourceLoader, index++);
	                if (container.isVisible()) {
	                    if (childNode.tagName === 'INPUT') {
	                        // $FlowFixMe
	                        (0, _Input.inlineInputElement)(childNode, container);
	                    } else if (childNode.tagName === 'TEXTAREA') {
	                        // $FlowFixMe
	                        (0, _Input.inlineTextAreaElement)(childNode, container);
	                    } else if (childNode.tagName === 'SELECT') {
	                        // $FlowFixMe
	                        (0, _Input.inlineSelectElement)(childNode, container);
	                    } else if (container.style.listStyle && container.style.listStyle.listStyleType !== _listStyle.LIST_STYLE_TYPE.NONE) {
	                        (0, _ListItem.inlineListItemElement)(childNode, container, resourceLoader);
	                    }
	
	                    var SHOULD_TRAVERSE_CHILDREN = childNode.tagName !== 'TEXTAREA';
	                    var treatAsRealStackingContext = createsRealStackingContext(container, childNode);
	                    if (treatAsRealStackingContext || createsStackingContext(container)) {
	                        // for treatAsRealStackingContext:false, any positioned descendants and descendants
	                        // which actually create a new stacking context should be considered part of the parent stacking context
	                        var parentStack = treatAsRealStackingContext || container.isPositioned() ? stack.getRealParentStackingContext() : stack;
	                        var childStack = new _StackingContext2.default(container, parentStack, treatAsRealStackingContext);
	                        parentStack.contexts.push(childStack);
	                        if (SHOULD_TRAVERSE_CHILDREN) {
	                            parseNodeTree(childNode, container, childStack, resourceLoader, index);
	                        }
	                    } else {
	                        stack.children.push(container);
	                        if (SHOULD_TRAVERSE_CHILDREN) {
	                            parseNodeTree(childNode, container, stack, resourceLoader, index);
	                        }
	                    }
	                }
	            }
	        } else if (childNode instanceof defaultView.SVGSVGElement || childNode instanceof SVGSVGElement || defaultView.parent && childNode instanceof defaultView.parent.SVGSVGElement) {
	            var _container = new _NodeContainer2.default(childNode, parent, resourceLoader, index++);
	            var _treatAsRealStackingContext = createsRealStackingContext(_container, childNode);
	            if (_treatAsRealStackingContext || createsStackingContext(_container)) {
	                // for treatAsRealStackingContext:false, any positioned descendants and descendants
	                // which actually create a new stacking context should be considered part of the parent stacking context
	                var _parentStack = _treatAsRealStackingContext || _container.isPositioned() ? stack.getRealParentStackingContext() : stack;
	                var _childStack = new _StackingContext2.default(_container, _parentStack, _treatAsRealStackingContext);
	                _parentStack.contexts.push(_childStack);
	            } else {
	                stack.children.push(_container);
	            }
	        }
	    }
	};
	
	var createsRealStackingContext = function createsRealStackingContext(container, node) {
	    return container.isRootElement() || container.isPositionedWithZIndex() || container.style.opacity < 1 || container.isTransformed() || isBodyWithTransparentRoot(container, node);
	};
	
	var createsStackingContext = function createsStackingContext(container) {
	    return container.isPositioned() || container.isFloating();
	};
	
	var isBodyWithTransparentRoot = function isBodyWithTransparentRoot(container, node) {
	    return node.nodeName === 'BODY' && container.parent instanceof _NodeContainer2.default && container.parent.style.background.backgroundColor.isTransparent();
	};

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseContent = exports.resolvePseudoContent = exports.popCounters = exports.parseCounterReset = exports.TOKEN_TYPE = exports.PSEUDO_CONTENT_ITEM_TYPE = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _ListItem = __webpack_require__(115);
	
	var _listStyle = __webpack_require__(82);
	
	var PSEUDO_CONTENT_ITEM_TYPE = exports.PSEUDO_CONTENT_ITEM_TYPE = {
	    TEXT: 0,
	    IMAGE: 1
	};
	
	var TOKEN_TYPE = exports.TOKEN_TYPE = {
	    STRING: 0,
	    ATTRIBUTE: 1,
	    URL: 2,
	    COUNTER: 3,
	    COUNTERS: 4,
	    OPENQUOTE: 5,
	    CLOSEQUOTE: 6
	};
	
	var parseCounterReset = exports.parseCounterReset = function parseCounterReset(style, data) {
	    if (!style || !style.counterReset || style.counterReset === 'none') {
	        return [];
	    }
	
	    var counterNames = [];
	    var counterResets = style.counterReset.split(/\s*,\s*/);
	    var lenCounterResets = counterResets.length;
	
	    for (var i = 0; i < lenCounterResets; i++) {
	        var _counterResets$i$spli = counterResets[i].split(/\s+/),
	            _counterResets$i$spli2 = _slicedToArray(_counterResets$i$spli, 2),
	            counterName = _counterResets$i$spli2[0],
	            initialValue = _counterResets$i$spli2[1];
	
	        counterNames.push(counterName);
	        var counter = data.counters[counterName];
	        if (!counter) {
	            counter = data.counters[counterName] = [];
	        }
	        counter.push(parseInt(initialValue || 0, 10));
	    }
	
	    return counterNames;
	};
	
	var popCounters = exports.popCounters = function popCounters(counterNames, data) {
	    var lenCounters = counterNames.length;
	    for (var i = 0; i < lenCounters; i++) {
	        data.counters[counterNames[i]].pop();
	    }
	};
	
	var resolvePseudoContent = exports.resolvePseudoContent = function resolvePseudoContent(node, style, data) {
	    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') {
	        return null;
	    }
	
	    var tokens = parseContent(style.content);
	
	    var len = tokens.length;
	    var contentItems = [];
	    var s = '';
	
	    // increment the counter (if there is a "counter-increment" declaration)
	    var counterIncrement = style.counterIncrement;
	    if (counterIncrement && counterIncrement !== 'none') {
	        var _counterIncrement$spl = counterIncrement.split(/\s+/),
	            _counterIncrement$spl2 = _slicedToArray(_counterIncrement$spl, 2),
	            counterName = _counterIncrement$spl2[0],
	            incrementValue = _counterIncrement$spl2[1];
	
	        var counter = data.counters[counterName];
	        if (counter) {
	            counter[counter.length - 1] += incrementValue === undefined ? 1 : parseInt(incrementValue, 10);
	        }
	    }
	
	    // build the content string
	    for (var i = 0; i < len; i++) {
	        var token = tokens[i];
	        switch (token.type) {
	            case TOKEN_TYPE.STRING:
	                s += token.value || '';
	                break;
	
	            case TOKEN_TYPE.ATTRIBUTE:
	                if (node instanceof HTMLElement && token.value) {
	                    s += node.getAttribute(token.value) || '';
	                }
	                break;
	
	            case TOKEN_TYPE.COUNTER:
	                var _counter = data.counters[token.name || ''];
	                if (_counter) {
	                    s += formatCounterValue([_counter[_counter.length - 1]], '', token.format);
	                }
	                break;
	
	            case TOKEN_TYPE.COUNTERS:
	                var _counters = data.counters[token.name || ''];
	                if (_counters) {
	                    s += formatCounterValue(_counters, token.glue, token.format);
	                }
	                break;
	
	            case TOKEN_TYPE.OPENQUOTE:
	                s += getQuote(style, true, data.quoteDepth);
	                data.quoteDepth++;
	                break;
	
	            case TOKEN_TYPE.CLOSEQUOTE:
	                data.quoteDepth--;
	                s += getQuote(style, false, data.quoteDepth);
	                break;
	
	            case TOKEN_TYPE.URL:
	                if (s) {
	                    contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.TEXT, value: s });
	                    s = '';
	                }
	                contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.IMAGE, value: token.value || '' });
	                break;
	        }
	    }
	
	    if (s) {
	        contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.TEXT, value: s });
	    }
	
	    return contentItems;
	};
	
	var parseContent = exports.parseContent = function parseContent(content, cache) {
	    if (cache && cache[content]) {
	        return cache[content];
	    }
	
	    var tokens = [];
	    var len = content.length;
	
	    var isString = false;
	    var isEscaped = false;
	    var isFunction = false;
	    var str = '';
	    var functionName = '';
	    var args = [];
	
	    for (var i = 0; i < len; i++) {
	        var c = content.charAt(i);
	
	        switch (c) {
	            case "'":
	            case '"':
	                if (isEscaped) {
	                    str += c;
	                } else {
	                    isString = !isString;
	                    if (!isFunction && !isString) {
	                        tokens.push({ type: TOKEN_TYPE.STRING, value: str });
	                        str = '';
	                    }
	                }
	                break;
	
	            case '\\':
	                if (isEscaped) {
	                    str += c;
	                    isEscaped = false;
	                } else {
	                    isEscaped = true;
	                }
	                break;
	
	            case '(':
	                if (isString) {
	                    str += c;
	                } else {
	                    isFunction = true;
	                    functionName = str;
	                    str = '';
	                    args = [];
	                }
	                break;
	
	            case ')':
	                if (isString) {
	                    str += c;
	                } else if (isFunction) {
	                    if (str) {
	                        args.push(str);
	                    }
	
	                    switch (functionName) {
	                        case 'attr':
	                            if (args.length > 0) {
	                                tokens.push({ type: TOKEN_TYPE.ATTRIBUTE, value: args[0] });
	                            }
	                            break;
	
	                        case 'counter':
	                            if (args.length > 0) {
	                                var counter = {
	                                    type: TOKEN_TYPE.COUNTER,
	                                    name: args[0]
	                                };
	                                if (args.length > 1) {
	                                    counter.format = args[1];
	                                }
	                                tokens.push(counter);
	                            }
	                            break;
	
	                        case 'counters':
	                            if (args.length > 0) {
	                                var _counters2 = {
	                                    type: TOKEN_TYPE.COUNTERS,
	                                    name: args[0]
	                                };
	                                if (args.length > 1) {
	                                    _counters2.glue = args[1];
	                                }
	                                if (args.length > 2) {
	                                    _counters2.format = args[2];
	                                }
	                                tokens.push(_counters2);
	                            }
	                            break;
	
	                        case 'url':
	                            if (args.length > 0) {
	                                tokens.push({ type: TOKEN_TYPE.URL, value: args[0] });
	                            }
	                            break;
	                    }
	
	                    isFunction = false;
	                    str = '';
	                }
	                break;
	
	            case ',':
	                if (isString) {
	                    str += c;
	                } else if (isFunction) {
	                    args.push(str);
	                    str = '';
	                }
	                break;
	
	            case ' ':
	            case '\t':
	                if (isString) {
	                    str += c;
	                } else if (str) {
	                    addOtherToken(tokens, str);
	                    str = '';
	                }
	                break;
	
	            default:
	                str += c;
	        }
	
	        if (c !== '\\') {
	            isEscaped = false;
	        }
	    }
	
	    if (str) {
	        addOtherToken(tokens, str);
	    }
	
	    if (cache) {
	        cache[content] = tokens;
	    }
	
	    return tokens;
	};
	
	var addOtherToken = function addOtherToken(tokens, identifier) {
	    switch (identifier) {
	        case 'open-quote':
	            tokens.push({ type: TOKEN_TYPE.OPENQUOTE });
	            break;
	        case 'close-quote':
	            tokens.push({ type: TOKEN_TYPE.CLOSEQUOTE });
	            break;
	    }
	};
	
	var getQuote = function getQuote(style, isOpening, quoteDepth) {
	    var quotes = style.quotes ? style.quotes.split(/\s+/) : ["'\"'", "'\"'"];
	    var idx = quoteDepth * 2;
	    if (idx >= quotes.length) {
	        idx = quotes.length - 2;
	    }
	    if (!isOpening) {
	        ++idx;
	    }
	    return quotes[idx].replace(/^["']|["']$/g, '');
	};
	
	var formatCounterValue = function formatCounterValue(counter, glue, format) {
	    var len = counter.length;
	    var result = '';
	
	    for (var i = 0; i < len; i++) {
	        if (i > 0) {
	            result += glue || '';
	        }
	        result += (0, _ListItem.createCounterText)(counter[i], (0, _listStyle.parseListStyleType)(format || 'decimal'), false);
	    }
	
	    return result;
	};

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Bounds = __webpack_require__(39);
	
	var _Font = __webpack_require__(188);
	
	var _Gradient = __webpack_require__(423);
	
	var _TextContainer = __webpack_require__(79);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _background = __webpack_require__(65);
	
	var _border = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Renderer = function () {
	    function Renderer(target, options) {
	        _classCallCheck(this, Renderer);
	
	        this.target = target;
	        this.options = options;
	        target.render(options);
	    }
	
	    _createClass(Renderer, [{
	        key: 'renderNode',
	        value: function renderNode(container) {
	            if (container.isVisible()) {
	                this.renderNodeBackgroundAndBorders(container);
	                this.renderNodeContent(container);
	            }
	        }
	    }, {
	        key: 'renderNodeContent',
	        value: function renderNodeContent(container) {
	            var _this = this;
	
	            var callback = function callback() {
	                if (container.childNodes.length) {
	                    container.childNodes.forEach(function (child) {
	                        if (child instanceof _TextContainer2.default) {
	                            var style = child.parent.style;
	                            _this.target.renderTextNode(child.bounds, style.color, style.font, style.textDecoration, style.textShadow);
	                        } else {
	                            _this.target.drawShape(child, container.style.color);
	                        }
	                    });
	                }
	
	                if (container.image) {
	                    var _image = _this.options.imageStore.get(container.image);
	                    if (_image) {
	                        var contentBox = (0, _Bounds.calculateContentBox)(container.bounds, container.style.padding, container.style.border);
	                        var _width = typeof _image.width === 'number' && _image.width > 0 ? _image.width : contentBox.width;
	                        var _height = typeof _image.height === 'number' && _image.height > 0 ? _image.height : contentBox.height;
	                        if (_width > 0 && _height > 0) {
	                            _this.target.clip([(0, _Bounds.calculatePaddingBoxPath)(container.curvedBounds)], function () {
	                                _this.target.drawImage(_image, new _Bounds.Bounds(0, 0, _width, _height), contentBox);
	                            });
	                        }
	                    }
	                }
	            };
	            var paths = container.getClipPaths();
	            if (paths.length) {
	                this.target.clip(paths, callback);
	            } else {
	                callback();
	            }
	        }
	    }, {
	        key: 'renderNodeBackgroundAndBorders',
	        value: function renderNodeBackgroundAndBorders(container) {
	            var _this2 = this;
	
	            var HAS_BACKGROUND = !container.style.background.backgroundColor.isTransparent() || container.style.background.backgroundImage.length;
	
	            var hasRenderableBorders = container.style.border.some(function (border) {
	                return border.borderStyle !== _border.BORDER_STYLE.NONE && !border.borderColor.isTransparent();
	            });
	
	            var callback = function callback() {
	                var backgroundPaintingArea = (0, _background.calculateBackgroungPaintingArea)(container.curvedBounds, container.style.background.backgroundClip);
	
	                if (HAS_BACKGROUND) {
	                    _this2.target.clip([backgroundPaintingArea], function () {
	                        if (!container.style.background.backgroundColor.isTransparent()) {
	                            _this2.target.fill(container.style.background.backgroundColor);
	                        }
	
	                        _this2.renderBackgroundImage(container);
	                    });
	                }
	
	                container.style.border.forEach(function (border, side) {
	                    if (border.borderStyle !== _border.BORDER_STYLE.NONE && !border.borderColor.isTransparent()) {
	                        _this2.renderBorder(border, side, container.curvedBounds);
	                    }
	                });
	            };
	
	            if (HAS_BACKGROUND || hasRenderableBorders) {
	                var paths = container.parent ? container.parent.getClipPaths() : [];
	                if (paths.length) {
	                    this.target.clip(paths, callback);
	                } else {
	                    callback();
	                }
	            }
	        }
	    }, {
	        key: 'renderBackgroundImage',
	        value: function renderBackgroundImage(container) {
	            var _this3 = this;
	
	            container.style.background.backgroundImage.slice(0).reverse().forEach(function (backgroundImage) {
	                if (backgroundImage.source.method === 'url' && backgroundImage.source.args.length) {
	                    _this3.renderBackgroundRepeat(container, backgroundImage);
	                } else if (/gradient/i.test(backgroundImage.source.method)) {
	                    _this3.renderBackgroundGradient(container, backgroundImage);
	                }
	            });
	        }
	    }, {
	        key: 'renderBackgroundRepeat',
	        value: function renderBackgroundRepeat(container, background) {
	            var image = this.options.imageStore.get(background.source.args[0]);
	            if (image) {
	                var backgroundPositioningArea = (0, _background.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
	                var backgroundImageSize = (0, _background.calculateBackgroundSize)(background, image, backgroundPositioningArea);
	                var position = (0, _background.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
	                var _path = (0, _background.calculateBackgroundRepeatPath)(background, position, backgroundImageSize, backgroundPositioningArea, container.bounds);
	
	                var _offsetX = Math.round(backgroundPositioningArea.left + position.x);
	                var _offsetY = Math.round(backgroundPositioningArea.top + position.y);
	                this.target.renderRepeat(_path, image, backgroundImageSize, _offsetX, _offsetY);
	            }
	        }
	    }, {
	        key: 'renderBackgroundGradient',
	        value: function renderBackgroundGradient(container, background) {
	            var backgroundPositioningArea = (0, _background.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
	            var backgroundImageSize = (0, _background.calculateGradientBackgroundSize)(background, backgroundPositioningArea);
	            var position = (0, _background.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
	            var gradientBounds = new _Bounds.Bounds(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y), backgroundImageSize.width, backgroundImageSize.height);
	
	            var gradient = (0, _Gradient.parseGradient)(container, background.source, gradientBounds);
	            if (gradient) {
	                switch (gradient.type) {
	                    case _Gradient.GRADIENT_TYPE.LINEAR_GRADIENT:
	                        // $FlowFixMe
	                        this.target.renderLinearGradient(gradientBounds, gradient);
	                        break;
	                    case _Gradient.GRADIENT_TYPE.RADIAL_GRADIENT:
	                        // $FlowFixMe
	                        this.target.renderRadialGradient(gradientBounds, gradient);
	                        break;
	                }
	            }
	        }
	    }, {
	        key: 'renderBorder',
	        value: function renderBorder(border, side, curvePoints) {
	            this.target.drawShape((0, _Bounds.parsePathForBorder)(curvePoints, side), border.borderColor);
	        }
	    }, {
	        key: 'renderStack',
	        value: function renderStack(stack) {
	            var _this4 = this;
	
	            if (stack.container.isVisible()) {
	                var _opacity = stack.getOpacity();
	                if (_opacity !== this._opacity) {
	                    this.target.setOpacity(stack.getOpacity());
	                    this._opacity = _opacity;
	                }
	
	                var _transform = stack.container.style.transform;
	                if (_transform !== null) {
	                    this.target.transform(stack.container.bounds.left + _transform.transformOrigin[0].value, stack.container.bounds.top + _transform.transformOrigin[1].value, _transform.transform, function () {
	                        return _this4.renderStackContent(stack);
	                    });
	                } else {
	                    this.renderStackContent(stack);
	                }
	            }
	        }
	    }, {
	        key: 'renderStackContent',
	        value: function renderStackContent(stack) {
	            var _splitStackingContext = splitStackingContexts(stack),
	                _splitStackingContext2 = _slicedToArray(_splitStackingContext, 5),
	                negativeZIndex = _splitStackingContext2[0],
	                zeroOrAutoZIndexOrTransformedOrOpacity = _splitStackingContext2[1],
	                positiveZIndex = _splitStackingContext2[2],
	                nonPositionedFloats = _splitStackingContext2[3],
	                nonPositionedInlineLevel = _splitStackingContext2[4];
	
	            var _splitDescendants = splitDescendants(stack),
	                _splitDescendants2 = _slicedToArray(_splitDescendants, 2),
	                inlineLevel = _splitDescendants2[0],
	                nonInlineLevel = _splitDescendants2[1];
	
	            // https://www.w3.org/TR/css-position-3/#painting-order
	            // 1. the background and borders of the element forming the stacking context.
	
	
	            this.renderNodeBackgroundAndBorders(stack.container);
	            // 2. the child stacking contexts with negative stack levels (most negative first).
	            negativeZIndex.sort(sortByZIndex).forEach(this.renderStack, this);
	            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
	            this.renderNodeContent(stack.container);
	            nonInlineLevel.forEach(this.renderNode, this);
	            // 4. All non-positioned floating descendants, in tree order. For each one of these,
	            // treat the element as if it created a new stacking context, but any positioned descendants and descendants
	            // which actually create a new stacking context should be considered part of the parent stacking context,
	            // not this new one.
	            nonPositionedFloats.forEach(this.renderStack, this);
	            // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.
	            nonPositionedInlineLevel.forEach(this.renderStack, this);
	            inlineLevel.forEach(this.renderNode, this);
	            // 6. All positioned, opacity or transform descendants, in tree order that fall into the following categories:
	            //  All positioned descendants with 'z-index: auto' or 'z-index: 0', in tree order.
	            //  For those with 'z-index: auto', treat the element as if it created a new stacking context,
	            //  but any positioned descendants and descendants which actually create a new stacking context should be
	            //  considered part of the parent stacking context, not this new one. For those with 'z-index: 0',
	            //  treat the stacking context generated atomically.
	            //
	            //  All opacity descendants with opacity less than 1
	            //
	            //  All transform descendants with transform other than none
	            zeroOrAutoZIndexOrTransformedOrOpacity.forEach(this.renderStack, this);
	            // 7. Stacking contexts formed by positioned descendants with z-indices greater than or equal to 1 in z-index
	            // order (smallest first) then tree order.
	            positiveZIndex.sort(sortByZIndex).forEach(this.renderStack, this);
	        }
	    }, {
	        key: 'render',
	        value: function render(stack) {
	            var _this5 = this;
	
	            if (this.options.backgroundColor) {
	                this.target.rectangle(this.options.x, this.options.y, this.options.width, this.options.height, this.options.backgroundColor);
	            }
	            this.renderStack(stack);
	            var target = this.target.getTarget();
	            if (false) {
	                return target.then(function (output) {
	                    _this5.options.logger.log('Render completed');
	                    return output;
	                });
	            }
	            return target;
	        }
	    }]);
	
	    return Renderer;
	}();
	
	exports.default = Renderer;
	
	
	var splitDescendants = function splitDescendants(stack) {
	    var inlineLevel = [];
	    var nonInlineLevel = [];
	
	    var length = stack.children.length;
	    for (var i = 0; i < length; i++) {
	        var child = stack.children[i];
	        if (child.isInlineLevel()) {
	            inlineLevel.push(child);
	        } else {
	            nonInlineLevel.push(child);
	        }
	    }
	    return [inlineLevel, nonInlineLevel];
	};
	
	var splitStackingContexts = function splitStackingContexts(stack) {
	    var negativeZIndex = [];
	    var zeroOrAutoZIndexOrTransformedOrOpacity = [];
	    var positiveZIndex = [];
	    var nonPositionedFloats = [];
	    var nonPositionedInlineLevel = [];
	    var length = stack.contexts.length;
	    for (var i = 0; i < length; i++) {
	        var child = stack.contexts[i];
	        if (child.container.isPositioned() || child.container.style.opacity < 1 || child.container.isTransformed()) {
	            if (child.container.style.zIndex.order < 0) {
	                negativeZIndex.push(child);
	            } else if (child.container.style.zIndex.order > 0) {
	                positiveZIndex.push(child);
	            } else {
	                zeroOrAutoZIndexOrTransformedOrOpacity.push(child);
	            }
	        } else {
	            if (child.container.isFloating()) {
	                nonPositionedFloats.push(child);
	            } else {
	                nonPositionedInlineLevel.push(child);
	            }
	        }
	    }
	    return [negativeZIndex, zeroOrAutoZIndexOrTransformedOrOpacity, positiveZIndex, nonPositionedFloats, nonPositionedInlineLevel];
	};
	
	var sortByZIndex = function sortByZIndex(a, b) {
	    if (a.container.style.zIndex.order > b.container.style.zIndex.order) {
	        return 1;
	    } else if (a.container.style.zIndex.order < b.container.style.zIndex.order) {
	        return -1;
	    }
	
	    return a.container.index > b.container.index ? 1 : -1;
	};

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResourceStore = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Feature = __webpack_require__(78);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _Proxy = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResourceLoader = function () {
	    function ResourceLoader(options, logger, window) {
	        _classCallCheck(this, ResourceLoader);
	
	        this.options = options;
	        this._window = window;
	        this.origin = this.getOrigin(window.location.href);
	        this.cache = {};
	        this.logger = logger;
	        this._index = 0;
	    }
	
	    _createClass(ResourceLoader, [{
	        key: 'loadImage',
	        value: function loadImage(src) {
	            var _this = this;
	
	            if (this.hasResourceInCache(src)) {
	                return src;
	            }
	            if (isBlobImage(src)) {
	                this.cache[src] = _loadImage(src, this.options.imageTimeout || 0);
	                return src;
	            }
	
	            if (!isSVG(src) || _Feature2.default.SUPPORT_SVG_DRAWING) {
	                if (this.options.allowTaint === true || isInlineImage(src) || this.isSameOrigin(src)) {
	                    return this.addImage(src, src, false);
	                } else if (!this.isSameOrigin(src)) {
	                    if (typeof this.options.proxy === 'string') {
	                        this.cache[src] = (0, _Proxy.Proxy)(src, this.options).then(function (src) {
	                            return _loadImage(src, _this.options.imageTimeout || 0);
	                        });
	                        return src;
	                    } else if (this.options.useCORS === true && _Feature2.default.SUPPORT_CORS_IMAGES) {
	                        return this.addImage(src, src, true);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'inlineImage',
	        value: function inlineImage(src) {
	            var _this2 = this;
	
	            if (isInlineImage(src)) {
	                return _loadImage(src, this.options.imageTimeout || 0);
	            }
	            if (this.hasResourceInCache(src)) {
	                return this.cache[src];
	            }
	            if (!this.isSameOrigin(src) && typeof this.options.proxy === 'string') {
	                return this.cache[src] = (0, _Proxy.Proxy)(src, this.options).then(function (src) {
	                    return _loadImage(src, _this2.options.imageTimeout || 0);
	                });
	            }
	
	            return this.xhrImage(src);
	        }
	    }, {
	        key: 'xhrImage',
	        value: function xhrImage(src) {
	            var _this3 = this;
	
	            this.cache[src] = new Promise(function (resolve, reject) {
	                var xhr = new XMLHttpRequest();
	                xhr.onreadystatechange = function () {
	                    if (xhr.readyState === 4) {
	                        if (xhr.status !== 200) {
	                            reject('Failed to fetch image ' + src.substring(0, 256) + ' with status code ' + xhr.status);
	                        } else {
	                            var reader = new FileReader();
	                            reader.addEventListener('load', function () {
	                                // $FlowFixMe
	                                var result = reader.result;
	                                resolve(result);
	                            }, false);
	                            reader.addEventListener('error', function (e) {
	                                return reject(e);
	                            }, false);
	                            reader.readAsDataURL(xhr.response);
	                        }
	                    }
	                };
	                xhr.responseType = 'blob';
	                if (_this3.options.imageTimeout) {
	                    var timeout = _this3.options.imageTimeout;
	                    xhr.timeout = timeout;
	                    xhr.ontimeout = function () {
	                        return reject( false ? 'Timed out (' + timeout + 'ms) fetching ' + src.substring(0, 256) : '');
	                    };
	                }
	                xhr.open('GET', src, true);
	                xhr.send();
	            }).then(function (src) {
	                return _loadImage(src, _this3.options.imageTimeout || 0);
	            });
	
	            return this.cache[src];
	        }
	    }, {
	        key: 'loadCanvas',
	        value: function loadCanvas(node) {
	            var key = String(this._index++);
	            this.cache[key] = Promise.resolve(node);
	            return key;
	        }
	    }, {
	        key: 'hasResourceInCache',
	        value: function hasResourceInCache(key) {
	            return typeof this.cache[key] !== 'undefined';
	        }
	    }, {
	        key: 'addImage',
	        value: function addImage(key, src, useCORS) {
	            var _this4 = this;
	
	            if (false) {
	                this.logger.log('Added image ' + key.substring(0, 256));
	            }
	
	            var imageLoadHandler = function imageLoadHandler(supportsDataImages) {
	                return new Promise(function (resolve, reject) {
	                    var img = new Image();
	                    img.onload = function () {
	                        return resolve(img);
	                    };
	                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
	                    if (!supportsDataImages || useCORS) {
	                        img.crossOrigin = 'anonymous';
	                    }
	
	                    img.onerror = reject;
	                    img.src = src;
	                    if (img.complete === true) {
	                        // Inline XML images may fail to parse, throwing an Error later on
	                        setTimeout(function () {
	                            resolve(img);
	                        }, 500);
	                    }
	                    if (_this4.options.imageTimeout) {
	                        var timeout = _this4.options.imageTimeout;
	                        setTimeout(function () {
	                            return reject( false ? 'Timed out (' + timeout + 'ms) fetching ' + src.substring(0, 256) : '');
	                        }, timeout);
	                    }
	                });
	            };
	
	            this.cache[key] = isInlineBase64Image(src) && !isSVG(src) ? // $FlowFixMe
	            _Feature2.default.SUPPORT_BASE64_DRAWING(src).then(imageLoadHandler) : imageLoadHandler(true);
	            return key;
	        }
	    }, {
	        key: 'isSameOrigin',
	        value: function isSameOrigin(url) {
	            return this.getOrigin(url) === this.origin;
	        }
	    }, {
	        key: 'getOrigin',
	        value: function getOrigin(url) {
	            var link = this._link || (this._link = this._window.document.createElement('a'));
	            link.href = url;
	            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
	            return link.protocol + link.hostname + link.port;
	        }
	    }, {
	        key: 'ready',
	        value: function ready() {
	            var _this5 = this;
	
	            var keys = Object.keys(this.cache);
	            var values = keys.map(function (str) {
	                return _this5.cache[str].catch(function (e) {
	                    if (false) {
	                        _this5.logger.log('Unable to load image', e);
	                    }
	                    return null;
	                });
	            });
	            return Promise.all(values).then(function (images) {
	                if (false) {
	                    _this5.logger.log('Finished loading ' + images.length + ' images', images);
	                }
	                return new ResourceStore(keys, images);
	            });
	        }
	    }]);
	
	    return ResourceLoader;
	}();
	
	exports.default = ResourceLoader;
	
	var ResourceStore = exports.ResourceStore = function () {
	    function ResourceStore(keys, resources) {
	        _classCallCheck(this, ResourceStore);
	
	        this._keys = keys;
	        this._resources = resources;
	    }
	
	    _createClass(ResourceStore, [{
	        key: 'get',
	        value: function get(key) {
	            var index = this._keys.indexOf(key);
	            return index === -1 ? null : this._resources[index];
	        }
	    }]);
	
	    return ResourceStore;
	}();
	
	var INLINE_SVG = /^data:image\/svg\+xml/i;
	var INLINE_BASE64 = /^data:image\/.*;base64,/i;
	var INLINE_IMG = /^data:image\/.*/i;
	
	var isInlineImage = function isInlineImage(src) {
	    return INLINE_IMG.test(src);
	};
	var isInlineBase64Image = function isInlineBase64Image(src) {
	    return INLINE_BASE64.test(src);
	};
	var isBlobImage = function isBlobImage(src) {
	    return src.substr(0, 4) === 'blob';
	};
	
	var isSVG = function isSVG(src) {
	    return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
	};
	
	var _loadImage = function _loadImage(src, timeout) {
	    return new Promise(function (resolve, reject) {
	        var img = new Image();
	        img.onload = function () {
	            return resolve(img);
	        };
	        img.onerror = reject;
	        img.src = src;
	        if (img.complete === true) {
	            // Inline XML images may fail to parse, throwing an Error later on
	            setTimeout(function () {
	                resolve(img);
	            }, 500);
	        }
	        if (timeout) {
	            setTimeout(function () {
	                return reject( false ? 'Timed out (' + timeout + 'ms) loading image' : '');
	            }, timeout);
	        }
	    });
	};

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _NodeContainer = __webpack_require__(54);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _position = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StackingContext = function () {
	    function StackingContext(container, parent, treatAsRealStackingContext) {
	        _classCallCheck(this, StackingContext);
	
	        this.container = container;
	        this.parent = parent;
	        this.contexts = [];
	        this.children = [];
	        this.treatAsRealStackingContext = treatAsRealStackingContext;
	    }
	
	    _createClass(StackingContext, [{
	        key: 'getOpacity',
	        value: function getOpacity() {
	            return this.parent ? this.container.style.opacity * this.parent.getOpacity() : this.container.style.opacity;
	        }
	    }, {
	        key: 'getRealParentStackingContext',
	        value: function getRealParentStackingContext() {
	            return !this.parent || this.treatAsRealStackingContext ? this : this.parent.getRealParentStackingContext();
	        }
	    }]);
	
	    return StackingContext;
	}();
	
	exports.default = StackingContext;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.renderElement = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Logger = __webpack_require__(190);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _NodeParser = __webpack_require__(424);
	
	var _Renderer = __webpack_require__(426);
	
	var _Renderer2 = _interopRequireDefault(_Renderer);
	
	var _ForeignObjectRenderer = __webpack_require__(199);
	
	var _ForeignObjectRenderer2 = _interopRequireDefault(_ForeignObjectRenderer);
	
	var _Feature = __webpack_require__(78);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _Bounds = __webpack_require__(39);
	
	var _Clone = __webpack_require__(422);
	
	var _Font = __webpack_require__(188);
	
	var _Color = __webpack_require__(31);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderElement = exports.renderElement = function renderElement(element, options, logger) {
	    var ownerDocument = element.ownerDocument;
	
	    var windowBounds = new _Bounds.Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);
	
	    // http://www.w3.org/TR/css3-background/#special-backgrounds
	    var documentBackgroundColor = ownerDocument.documentElement ? new _Color2.default(getComputedStyle(ownerDocument.documentElement).backgroundColor) : _Color.TRANSPARENT;
	    var bodyBackgroundColor = ownerDocument.body ? new _Color2.default(getComputedStyle(ownerDocument.body).backgroundColor) : _Color.TRANSPARENT;
	
	    var backgroundColor = element === ownerDocument.documentElement ? documentBackgroundColor.isTransparent() ? bodyBackgroundColor.isTransparent() ? options.backgroundColor ? new _Color2.default(options.backgroundColor) : null : bodyBackgroundColor : documentBackgroundColor : options.backgroundColor ? new _Color2.default(options.backgroundColor) : null;
	
	    return (options.foreignObjectRendering ? // $FlowFixMe
	    _Feature2.default.SUPPORT_FOREIGNOBJECT_DRAWING : Promise.resolve(false)).then(function (supportForeignObject) {
	        return supportForeignObject ? function (cloner) {
	            if (false) {
	                logger.log('Document cloned, using foreignObject rendering');
	            }
	
	            return cloner.inlineFonts(ownerDocument).then(function () {
	                return cloner.resourceLoader.ready();
	            }).then(function () {
	                var renderer = new _ForeignObjectRenderer2.default(cloner.documentElement);
	
	                var defaultView = ownerDocument.defaultView;
	                var scrollX = defaultView.pageXOffset;
	                var scrollY = defaultView.pageYOffset;
	
	                var isDocument = element.tagName === 'HTML' || element.tagName === 'BODY';
	
	                var _ref = isDocument ? (0, _Bounds.parseDocumentSize)(ownerDocument) : (0, _Bounds.parseBounds)(element, scrollX, scrollY),
	                    width = _ref.width,
	                    height = _ref.height,
	                    left = _ref.left,
	                    top = _ref.top;
	
	                return renderer.render({
	                    backgroundColor: backgroundColor,
	                    logger: logger,
	                    scale: options.scale,
	                    x: typeof options.x === 'number' ? options.x : left,
	                    y: typeof options.y === 'number' ? options.y : top,
	                    width: typeof options.width === 'number' ? options.width : Math.ceil(width),
	                    height: typeof options.height === 'number' ? options.height : Math.ceil(height),
	                    windowWidth: options.windowWidth,
	                    windowHeight: options.windowHeight,
	                    scrollX: options.scrollX,
	                    scrollY: options.scrollY
	                });
	            });
	        }(new _Clone.DocumentCloner(element, options, logger, true, renderElement)) : (0, _Clone.cloneWindow)(ownerDocument, windowBounds, element, options, logger, renderElement).then(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 3),
	                container = _ref3[0],
	                clonedElement = _ref3[1],
	                resourceLoader = _ref3[2];
	
	            if (false) {
	                logger.log('Document cloned, using computed rendering');
	            }
	
	            var stack = (0, _NodeParser.NodeParser)(clonedElement, resourceLoader, logger);
	            var clonedDocument = clonedElement.ownerDocument;
	
	            if (backgroundColor === stack.container.style.background.backgroundColor) {
	                stack.container.style.background.backgroundColor = _Color.TRANSPARENT;
	            }
	
	            return resourceLoader.ready().then(function (imageStore) {
	                var fontMetrics = new _Font.FontMetrics(clonedDocument);
	                if (false) {
	                    logger.log('Starting renderer');
	                }
	
	                var defaultView = clonedDocument.defaultView;
	                var scrollX = defaultView.pageXOffset;
	                var scrollY = defaultView.pageYOffset;
	
	                var isDocument = clonedElement.tagName === 'HTML' || clonedElement.tagName === 'BODY';
	
	                var _ref4 = isDocument ? (0, _Bounds.parseDocumentSize)(ownerDocument) : (0, _Bounds.parseBounds)(clonedElement, scrollX, scrollY),
	                    width = _ref4.width,
	                    height = _ref4.height,
	                    left = _ref4.left,
	                    top = _ref4.top;
	
	                var renderOptions = {
	                    backgroundColor: backgroundColor,
	                    fontMetrics: fontMetrics,
	                    imageStore: imageStore,
	                    logger: logger,
	                    scale: options.scale,
	                    x: typeof options.x === 'number' ? options.x : left,
	                    y: typeof options.y === 'number' ? options.y : top,
	                    width: typeof options.width === 'number' ? options.width : Math.ceil(width),
	                    height: typeof options.height === 'number' ? options.height : Math.ceil(height)
	                };
	
	                if (Array.isArray(options.target)) {
	                    return Promise.all(options.target.map(function (target) {
	                        var renderer = new _Renderer2.default(target, renderOptions);
	                        return renderer.render(stack);
	                    }));
	                } else {
	                    var renderer = new _Renderer2.default(options.target, renderOptions);
	                    var canvas = renderer.render(stack);
	                    if (options.removeContainer === true) {
	                        if (container.parentNode) {
	                            container.parentNode.removeChild(container);
	                        } else if (false) {
	                            logger.log('Cannot detach cloned iframe as it is not in the DOM anymore');
	                        }
	                    }
	
	                    return canvas;
	                }
	            });
	        });
	    });
	};

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Path = __webpack_require__(80);
	
	var _Vector = __webpack_require__(81);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var lerp = function lerp(a, b, t) {
	    return new _Vector2.default(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
	};
	
	var BezierCurve = function () {
	    function BezierCurve(start, startControl, endControl, end) {
	        _classCallCheck(this, BezierCurve);
	
	        this.type = _Path.PATH.BEZIER_CURVE;
	        this.start = start;
	        this.startControl = startControl;
	        this.endControl = endControl;
	        this.end = end;
	    }
	
	    _createClass(BezierCurve, [{
	        key: 'subdivide',
	        value: function subdivide(t, firstHalf) {
	            var ab = lerp(this.start, this.startControl, t);
	            var bc = lerp(this.startControl, this.endControl, t);
	            var cd = lerp(this.endControl, this.end, t);
	            var abbc = lerp(ab, bc, t);
	            var bccd = lerp(bc, cd, t);
	            var dest = lerp(abbc, bccd, t);
	            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
	        }
	    }, {
	        key: 'reverse',
	        value: function reverse() {
	            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
	        }
	    }]);
	
	    return BezierCurve;
	}();
	
	exports.default = BezierCurve;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Path = __webpack_require__(80);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Circle = function Circle(x, y, radius) {
	    _classCallCheck(this, Circle);
	
	    this.type = _Path.PATH.CIRCLE;
	    this.x = x;
	    this.y = y;
	    this.radius = radius;
	    if (false) {
	        if (isNaN(x)) {
	            console.error('Invalid x value given for Circle');
	        }
	        if (isNaN(y)) {
	            console.error('Invalid y value given for Circle');
	        }
	        if (isNaN(radius)) {
	            console.error('Invalid radius value given for Circle');
	        }
	    }
	};
	
	exports.default = Circle;

/***/ },
/* 432 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Size = function Size(width, height) {
	    _classCallCheck(this, Size);
	
	    this.width = width;
	    this.height = height;
	};
	
	exports.default = Size;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _CanvasRenderer = __webpack_require__(198);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _Logger = __webpack_require__(190);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _Window = __webpack_require__(429);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html2canvas = function html2canvas(element, conf) {
	    var config = conf || {};
	    var logger = new _Logger2.default(typeof config.logging === 'boolean' ? config.logging : true);
	    logger.log('html2canvas ' + "$npm_package_version");
	
	    if (false) {
	        logger.error('onrendered option is deprecated, html2canvas returns a Promise with the canvas as the value');
	    }
	
	    var ownerDocument = element.ownerDocument;
	    if (!ownerDocument) {
	        return Promise.reject('Provided element is not within a Document');
	    }
	    var defaultView = ownerDocument.defaultView;
	
	    var defaultOptions = {
	        async: true,
	        allowTaint: false,
	        backgroundColor: '#ffffff',
	        imageTimeout: 15000,
	        logging: true,
	        proxy: null,
	        removeContainer: true,
	        foreignObjectRendering: false,
	        scale: defaultView.devicePixelRatio || 1,
	        target: new _CanvasRenderer2.default(config.canvas),
	        useCORS: false,
	        windowWidth: defaultView.innerWidth,
	        windowHeight: defaultView.innerHeight,
	        scrollX: defaultView.pageXOffset,
	        scrollY: defaultView.pageYOffset
	    };
	
	    var result = (0, _Window.renderElement)(element, _extends({}, defaultOptions, config), logger);
	
	    if (false) {
	        return result.catch(function (e) {
	            logger.error(e);
	            throw e;
	        });
	    }
	    return result;
	};
	
	html2canvas.CanvasRenderer = _CanvasRenderer2.default;
	
	module.exports = html2canvas;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseBorderRadius = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Length = __webpack_require__(40);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SIDES = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];
	
	var parseBorderRadius = exports.parseBorderRadius = function parseBorderRadius(style) {
	    return SIDES.map(function (side) {
	        var value = style.getPropertyValue('border-' + side + '-radius');
	
	        var _value$split$map = value.split(' ').map(_Length2.default.create),
	            _value$split$map2 = _slicedToArray(_value$split$map, 2),
	            horizontal = _value$split$map2[0],
	            vertical = _value$split$map2[1];
	
	        return typeof vertical === 'undefined' ? [horizontal, horizontal] : [horizontal, vertical];
	    });
	};

/***/ },
/* 435 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DISPLAY = exports.DISPLAY = {
	    NONE: 1 << 0,
	    BLOCK: 1 << 1,
	    INLINE: 1 << 2,
	    RUN_IN: 1 << 3,
	    FLOW: 1 << 4,
	    FLOW_ROOT: 1 << 5,
	    TABLE: 1 << 6,
	    FLEX: 1 << 7,
	    GRID: 1 << 8,
	    RUBY: 1 << 9,
	    SUBGRID: 1 << 10,
	    LIST_ITEM: 1 << 11,
	    TABLE_ROW_GROUP: 1 << 12,
	    TABLE_HEADER_GROUP: 1 << 13,
	    TABLE_FOOTER_GROUP: 1 << 14,
	    TABLE_ROW: 1 << 15,
	    TABLE_CELL: 1 << 16,
	    TABLE_COLUMN_GROUP: 1 << 17,
	    TABLE_COLUMN: 1 << 18,
	    TABLE_CAPTION: 1 << 19,
	    RUBY_BASE: 1 << 20,
	    RUBY_TEXT: 1 << 21,
	    RUBY_BASE_CONTAINER: 1 << 22,
	    RUBY_TEXT_CONTAINER: 1 << 23,
	    CONTENTS: 1 << 24,
	    INLINE_BLOCK: 1 << 25,
	    INLINE_LIST_ITEM: 1 << 26,
	    INLINE_TABLE: 1 << 27,
	    INLINE_FLEX: 1 << 28,
	    INLINE_GRID: 1 << 29
	};
	
	var parseDisplayValue = function parseDisplayValue(display) {
	    switch (display) {
	        case 'block':
	            return DISPLAY.BLOCK;
	        case 'inline':
	            return DISPLAY.INLINE;
	        case 'run-in':
	            return DISPLAY.RUN_IN;
	        case 'flow':
	            return DISPLAY.FLOW;
	        case 'flow-root':
	            return DISPLAY.FLOW_ROOT;
	        case 'table':
	            return DISPLAY.TABLE;
	        case 'flex':
	            return DISPLAY.FLEX;
	        case 'grid':
	            return DISPLAY.GRID;
	        case 'ruby':
	            return DISPLAY.RUBY;
	        case 'subgrid':
	            return DISPLAY.SUBGRID;
	        case 'list-item':
	            return DISPLAY.LIST_ITEM;
	        case 'table-row-group':
	            return DISPLAY.TABLE_ROW_GROUP;
	        case 'table-header-group':
	            return DISPLAY.TABLE_HEADER_GROUP;
	        case 'table-footer-group':
	            return DISPLAY.TABLE_FOOTER_GROUP;
	        case 'table-row':
	            return DISPLAY.TABLE_ROW;
	        case 'table-cell':
	            return DISPLAY.TABLE_CELL;
	        case 'table-column-group':
	            return DISPLAY.TABLE_COLUMN_GROUP;
	        case 'table-column':
	            return DISPLAY.TABLE_COLUMN;
	        case 'table-caption':
	            return DISPLAY.TABLE_CAPTION;
	        case 'ruby-base':
	            return DISPLAY.RUBY_BASE;
	        case 'ruby-text':
	            return DISPLAY.RUBY_TEXT;
	        case 'ruby-base-container':
	            return DISPLAY.RUBY_BASE_CONTAINER;
	        case 'ruby-text-container':
	            return DISPLAY.RUBY_TEXT_CONTAINER;
	        case 'contents':
	            return DISPLAY.CONTENTS;
	        case 'inline-block':
	            return DISPLAY.INLINE_BLOCK;
	        case 'inline-list-item':
	            return DISPLAY.INLINE_LIST_ITEM;
	        case 'inline-table':
	            return DISPLAY.INLINE_TABLE;
	        case 'inline-flex':
	            return DISPLAY.INLINE_FLEX;
	        case 'inline-grid':
	            return DISPLAY.INLINE_GRID;
	    }
	
	    return DISPLAY.NONE;
	};
	
	var setDisplayBit = function setDisplayBit(bit, display) {
	    return bit | parseDisplayValue(display);
	};
	
	var parseDisplay = exports.parseDisplay = function parseDisplay(display) {
	    return display.split(' ').reduce(setDisplayBit, 0);
	};

/***/ },
/* 436 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var FLOAT = exports.FLOAT = {
	    NONE: 0,
	    LEFT: 1,
	    RIGHT: 2,
	    INLINE_START: 3,
	    INLINE_END: 4
	};
	
	var parseCSSFloat = exports.parseCSSFloat = function parseCSSFloat(float) {
	    switch (float) {
	        case 'left':
	            return FLOAT.LEFT;
	        case 'right':
	            return FLOAT.RIGHT;
	        case 'inline-start':
	            return FLOAT.INLINE_START;
	        case 'inline-end':
	            return FLOAT.INLINE_END;
	    }
	    return FLOAT.NONE;
	};

/***/ },
/* 437 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var parseFontWeight = function parseFontWeight(weight) {
	    switch (weight) {
	        case 'normal':
	            return 400;
	        case 'bold':
	            return 700;
	    }
	
	    var value = parseInt(weight, 10);
	    return isNaN(value) ? 400 : value;
	};
	
	var parseFont = exports.parseFont = function parseFont(style) {
	    var fontFamily = style.fontFamily;
	    var fontSize = style.fontSize;
	    var fontStyle = style.fontStyle;
	    var fontVariant = style.fontVariant;
	    var fontWeight = parseFontWeight(style.fontWeight);
	
	    return {
	        fontFamily: fontFamily,
	        fontSize: fontSize,
	        fontStyle: fontStyle,
	        fontVariant: fontVariant,
	        fontWeight: fontWeight
	    };
	};

/***/ },
/* 438 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var parseLetterSpacing = exports.parseLetterSpacing = function parseLetterSpacing(letterSpacing) {
	    if (letterSpacing === 'normal') {
	        return 0;
	    }
	    var value = parseFloat(letterSpacing);
	    return isNaN(value) ? 0 : value;
	};

/***/ },
/* 439 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var LINE_BREAK = exports.LINE_BREAK = {
	    NORMAL: 'normal',
	    STRICT: 'strict'
	};
	
	var parseLineBreak = exports.parseLineBreak = function parseLineBreak(wordBreak) {
	    switch (wordBreak) {
	        case 'strict':
	            return LINE_BREAK.STRICT;
	        case 'normal':
	        default:
	            return LINE_BREAK.NORMAL;
	    }
	};

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseMargin = undefined;
	
	var _Length = __webpack_require__(40);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SIDES = ['top', 'right', 'bottom', 'left'];
	
	var parseMargin = exports.parseMargin = function parseMargin(style) {
	    return SIDES.map(function (side) {
	        return new _Length2.default(style.getPropertyValue('margin-' + side));
	    });
	};

/***/ },
/* 441 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var OVERFLOW = exports.OVERFLOW = {
	    VISIBLE: 0,
	    HIDDEN: 1,
	    SCROLL: 2,
	    AUTO: 3
	};
	
	var parseOverflow = exports.parseOverflow = function parseOverflow(overflow) {
	    switch (overflow) {
	        case 'hidden':
	            return OVERFLOW.HIDDEN;
	        case 'scroll':
	            return OVERFLOW.SCROLL;
	        case 'auto':
	            return OVERFLOW.AUTO;
	        case 'visible':
	        default:
	            return OVERFLOW.VISIBLE;
	    }
	};

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTextShadow = undefined;
	
	var _Color = __webpack_require__(31);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NUMBER = /^([+-]|\d|\.)$/i;
	
	var parseTextShadow = exports.parseTextShadow = function parseTextShadow(textShadow) {
	    if (textShadow === 'none' || typeof textShadow !== 'string') {
	        return null;
	    }
	
	    var currentValue = '';
	    var isLength = false;
	    var values = [];
	    var shadows = [];
	    var numParens = 0;
	    var color = null;
	
	    var appendValue = function appendValue() {
	        if (currentValue.length) {
	            if (isLength) {
	                values.push(parseFloat(currentValue));
	            } else {
	                color = new _Color2.default(currentValue);
	            }
	        }
	        isLength = false;
	        currentValue = '';
	    };
	
	    var appendShadow = function appendShadow() {
	        if (values.length && color !== null) {
	            shadows.push({
	                color: color,
	                offsetX: values[0] || 0,
	                offsetY: values[1] || 0,
	                blur: values[2] || 0
	            });
	        }
	        values.splice(0, values.length);
	        color = null;
	    };
	
	    for (var i = 0; i < textShadow.length; i++) {
	        var c = textShadow[i];
	        switch (c) {
	            case '(':
	                currentValue += c;
	                numParens++;
	                break;
	            case ')':
	                currentValue += c;
	                numParens--;
	                break;
	            case ',':
	                if (numParens === 0) {
	                    appendValue();
	                    appendShadow();
	                } else {
	                    currentValue += c;
	                }
	                break;
	            case ' ':
	                if (numParens === 0) {
	                    appendValue();
	                } else {
	                    currentValue += c;
	                }
	                break;
	            default:
	                if (currentValue.length === 0 && NUMBER.test(c)) {
	                    isLength = true;
	                }
	                currentValue += c;
	        }
	    }
	
	    appendValue();
	    appendShadow();
	
	    if (shadows.length === 0) {
	        return null;
	    }
	
	    return shadows;
	};

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTransform = undefined;
	
	var _Length = __webpack_require__(40);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toFloat = function toFloat(s) {
	    return parseFloat(s.trim());
	};
	
	var MATRIX = /(matrix|matrix3d)\((.+)\)/;
	
	var parseTransform = exports.parseTransform = function parseTransform(style) {
	    var transform = parseTransformMatrix(style.transform || style.webkitTransform || style.mozTransform ||
	    // $FlowFixMe
	    style.msTransform ||
	    // $FlowFixMe
	    style.oTransform);
	    if (transform === null) {
	        return null;
	    }
	
	    return {
	        transform: transform,
	        transformOrigin: parseTransformOrigin(style.transformOrigin || style.webkitTransformOrigin || style.mozTransformOrigin ||
	        // $FlowFixMe
	        style.msTransformOrigin ||
	        // $FlowFixMe
	        style.oTransformOrigin)
	    };
	};
	
	// $FlowFixMe
	var parseTransformOrigin = function parseTransformOrigin(origin) {
	    if (typeof origin !== 'string') {
	        var v = new _Length2.default('0');
	        return [v, v];
	    }
	    var values = origin.split(' ').map(_Length2.default.create);
	    return [values[0], values[1]];
	};
	
	// $FlowFixMe
	var parseTransformMatrix = function parseTransformMatrix(transform) {
	    if (transform === 'none' || typeof transform !== 'string') {
	        return null;
	    }
	
	    var match = transform.match(MATRIX);
	    if (match) {
	        if (match[1] === 'matrix') {
	            var matrix = match[2].split(',').map(toFloat);
	            return [matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]];
	        } else {
	            var matrix3d = match[2].split(',').map(toFloat);
	            return [matrix3d[0], matrix3d[1], matrix3d[4], matrix3d[5], matrix3d[12], matrix3d[13]];
	        }
	    }
	    return null;
	};

/***/ },
/* 444 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var VISIBILITY = exports.VISIBILITY = {
	    VISIBLE: 0,
	    HIDDEN: 1,
	    COLLAPSE: 2
	};
	
	var parseVisibility = exports.parseVisibility = function parseVisibility(visibility) {
	    switch (visibility) {
	        case 'hidden':
	            return VISIBILITY.HIDDEN;
	        case 'collapse':
	            return VISIBILITY.COLLAPSE;
	        case 'visible':
	        default:
	            return VISIBILITY.VISIBLE;
	    }
	};

/***/ },
/* 445 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var WORD_BREAK = exports.WORD_BREAK = {
	    NORMAL: 'normal',
	    BREAK_ALL: 'break-all',
	    KEEP_ALL: 'keep-all'
	};
	
	var parseWordBreak = exports.parseWordBreak = function parseWordBreak(wordBreak) {
	    switch (wordBreak) {
	        case 'break-all':
	            return WORD_BREAK.BREAK_ALL;
	        case 'keep-all':
	            return WORD_BREAK.KEEP_ALL;
	        case 'normal':
	        default:
	            return WORD_BREAK.NORMAL;
	    }
	};

/***/ },
/* 446 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var parseZIndex = exports.parseZIndex = function parseZIndex(zIndex) {
	    var auto = zIndex === 'auto';
	    return {
	        auto: auto,
	        order: auto ? 0 : parseInt(zIndex, 10)
	    };
	};

/***/ },
/* 447 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var debug = __webpack_require__(76)('jsonp');
	
	/**
	 * Module exports.
	 */
	
	module.exports = jsonp;
	
	/**
	 * Callback index.
	 */
	
	var count = 0;
	
	/**
	 * Noop function.
	 */
	
	function noop(){}
	
	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */
	
	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};
	
	  var prefix = opts.prefix || '__jp';
	
	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + (count++));
	
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;
	
	
	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }
	
	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }
	
	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }
	
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };
	
	  // add qs component
	  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
	  url = url.replace('?&', '?');
	
	  debug('jsonp req "%s"', url);
	
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  target.parentNode.insertBefore(script, target);
	
	  return cancel;
	}


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function(global, process) {!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.jsPDF=e()}(this,function(){"use strict";var t,y,e,I,i,o,a,h,C,T,d,p,F,n,r,s,c,P,E,q,g,m,w,l,v,b,x,S,u,k,_,f,A,O,B,R,j,D,M,U,N,z,L,H,W,G,V,Y,X,J,K,Q,Z,vt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},$=function(pt){var gt="1.3",mt={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};function wt(o){var a={};this.subscribe=function(t,e,n){if("function"!=typeof e)return!1;a.hasOwnProperty(t)||(a[t]={});var r=Math.random().toString(35);return a[t][r]=[e,!!n],r},this.unsubscribe=function(t){for(var e in a)if(a[e][t])return delete a[e][t],!0;return!1},this.publish=function(t){if(a.hasOwnProperty(t)){var e=Array.prototype.slice.call(arguments,1),n=[];for(var r in a[t]){var i=a[t][r];try{i[0].apply(o,e)}catch(t){pt.console&&console.error("jsPDF PubSub Error",t.message,t)}i[1]&&n.push(r)}n.length&&n.forEach(this.unsubscribe)}}}function yt(t,e,n,r){var i={};"object"===(void 0===t?"undefined":vt(t))&&(t=(i=t).orientation,e=i.unit||e,n=i.format||n,r=i.compress||i.compressPdf||r),e=e||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();(""+n).toLowerCase();var K,w,y,o,u,v,a,s,h,c,l,f=!!r&&"function"==typeof Uint8Array,Q=i.textColor||"0 g",d=i.drawColor||"0 G",Z=i.fontSize||16,$=i.charSpace||0,tt=i.R2L||!1,et=i.lineHeight||1.15,p=i.lineWidth||.200025,g="00000000000000000000000000000000",m=2,b=!1,x=[],nt={},S={},k=0,_=[],A=[],I=[],C=[],T=[],F=0,P=0,E=0,q={title:"",subject:"",author:"",keywords:"",creator:""},O={},rt=new wt(O),B=i.hotfixes||[],R=function(t){var e,n=t.ch1,r=t.ch2,i=t.ch3,o=t.ch4,a=(t.precision,"draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"]);if("string"==typeof n&&"#"!==n.charAt(0)){var s=new RGBColor(n);s.ok&&(n=s.toHex())}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var h=parseInt(n.substr(1),16);n=h>>16&255,r=h>>8&255,i=255&h}if(void 0===r||void 0===o&&n===r&&r===i)if("string"==typeof n)e=n+" "+a[0];else switch(t.precision){case 2:e=N(n/255)+" "+a[0];break;case 3:default:e=z(n/255)+" "+a[0]}else if(void 0===o||"object"===(void 0===o?"undefined":vt(o))){if("string"==typeof n)e=[n,r,i,a[1]].join(" ");else switch(t.precision){case 2:e=[N(n/255),N(r/255),N(i/255),a[1]].join(" ");break;default:case 3:e=[z(n/255),z(r/255),z(i/255),a[1]].join(" ")}o&&0===o.a&&(e=["255","255","255",a[1]].join(" "))}else if("string"==typeof n)e=[n,r,i,o,a[2]].join(" ");else switch(t.precision){case 2:e=[N(n),N(r),N(i),N(o),a[2]].join(" ");break;case 3:default:e=[z(n),z(r),z(i),z(o),a[2]].join(" ")}return e},j=function(t){var e=function(t){return("0"+parseInt(t)).slice(-2)},n=t.getTimezoneOffset(),r=n<0?"+":"-",i=Math.floor(Math.abs(n/60)),o=Math.abs(n%60),a=[r,e(i),"'",e(o),"'"].join("");return["D:",t.getFullYear(),e(t.getMonth()+1),e(t.getDate()),e(t.getHours()),e(t.getMinutes()),e(t.getSeconds()),a].join("")},D=function(t){var e;return void 0===(void 0===t?"undefined":vt(t))&&(t=new Date),e="object"===(void 0===t?"undefined":vt(t))&&"[object Date]"===Object.prototype.toString.call(t)?j(t):/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t)?t:j(new Date),c=e},M=function(t){var e=c;return"jsDate"===t&&(e=function(t){var e=parseInt(t.substr(2,4),10),n=parseInt(t.substr(6,2),10)-1,r=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),o=parseInt(t.substr(12,2),10),a=parseInt(t.substr(14,2),10);parseInt(t.substr(16,2),10),parseInt(t.substr(20,2),10);return new Date(e,n,r,i,o,a,0)}(c)),e},U=function(t){return t=t||"12345678901234567890123456789012".split("").map(function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))}).join(""),g=t},N=function(t){return t.toFixed(2)},z=function(t){return t.toFixed(3)},it=function(t){t="string"==typeof t?t:t.toString(),b?_[o].push(t):(E+=t.length+1,C.push(t))},L=function(){return x[++m]=E,it(m+" 0 obj"),m},H=function(t){it("stream"),it(t),it("endstream")},W=function(){for(var t in it("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),it("/Font <<"),nt)nt.hasOwnProperty(t)&&it("/"+t+" "+nt[t].objectNumber+" 0 R");it(">>"),it("/XObject <<"),rt.publish("putXobjectDict"),it(">>")},G=function(){!function(){for(var t in nt)nt.hasOwnProperty(t)&&(e=nt[t],rt.publish("putFont",{font:e,out:it,newObject:L}),!0!==e.isAlreadyPutted&&(e.objectNumber=L(),it("<<"),it("/Type /Font"),it("/BaseFont /"+e.postScriptName),it("/Subtype /Type1"),"string"==typeof e.encoding&&it("/Encoding /"+e.encoding),it("/FirstChar 32"),it("/LastChar 255"),it(">>"),it("endobj")));var e}(),rt.publish("putResources"),x[2]=E,it("2 0 obj"),it("<<"),W(),it(">>"),it("endobj"),rt.publish("postPutResources")},V=function(t,e,n){S.hasOwnProperty(e)||(S[e]={}),S[e][n]=t},Y=function(t,e,n,r){var i="F"+(Object.keys(nt).length+1).toString(10),o=nt[i]={id:i,postScriptName:t,fontName:e,fontStyle:n,encoding:r,metadata:{}};return V(i,e,n),rt.publish("addFont",o),i},ot=function(t,e){return function(t,e){var n,r,i,o,a,s,h,c,l;if(i=(e=e||{}).sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&nt[K].metadata&&nt[K].metadata[i]&&nt[K].metadata[i].encoding&&(o=nt[K].metadata[i].encoding,!a&&nt[K].encoding&&(a=nt[K].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(h=!1,s=[],n=0,r=t.length;n<r;n++)(c=a[t.charCodeAt(n)])?s.push(String.fromCharCode(c)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(h=!0);t=s.join("")}for(n=t.length;void 0===h&&0!==n;)t.charCodeAt(n-1)>>8&&(h=!0),n--;if(!h)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if((l=(c=t.charCodeAt(n))>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(l),s.push(c-(l<<8))}return String.fromCharCode.apply(void 0,s)}(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},X=function(){(function(t,e){var n="string"==typeof e&&e.toLowerCase();if("string"==typeof t){var r=t.toLowerCase();mt.hasOwnProperty(r)&&(t=mt[r][0]/w,e=mt[r][1]/w)}if(Array.isArray(t)&&(e=t[1],t=t[0]),n){switch(n.substr(0,1)){case"l":t<e&&(n="s");break;case"p":e<t&&(n="s")}"s"===n&&(y=t,t=e,e=y)}b=!0,_[++k]=[],I[k]={width:Number(t)||u,height:Number(e)||v},A[k]={},J(k)}).apply(this,arguments),it(N(p*w)+" w"),it(d),0!==F&&it(F+" J"),0!==P&&it(P+" j"),rt.publish("addPage",{pageNumber:k})},J=function(t){0<t&&t<=k&&(u=I[o=t].width,v=I[t].height)},at=function(t,e,n){var r,i=void 0;return n=n||{},t=void 0!==t?t:nt[K].fontName,e=void 0!==e?e:nt[K].fontStyle,r=t.toLowerCase(),void 0!==S[r]&&void 0!==S[r][e]?i=S[r][e]:void 0!==S[t]&&void 0!==S[t][e]?i=S[t][e]:!1===n.disableWarning&&console.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||n.noFallback||null==(i=S.times[e])&&(i=S.times.normal),i},st=function(){b=!1,m=2,E=0,C=[],x=[],T=[],rt.publish("buildDocument"),it("%PDF-"+gt),it("%ºß¬à"),function(){var t,e,n,r,i,o,a,s,h,c=[];for(a=pt.adler32cs||yt.API.adler32cs,f&&void 0===a&&(f=!1),t=1;t<=k;t++){if(c.push(L()),s=(u=I[t].width)*w,h=(v=I[t].height)*w,it("<</Type /Page"),it("/Parent 1 0 R"),it("/Resources 2 0 R"),it("/MediaBox [0 0 "+N(s)+" "+N(h)+"]"),rt.publish("putPage",{pageNumber:t,page:_[t]}),it("/Contents "+(m+1)+" 0 R"),it(">>"),it("endobj"),e=_[t].join("\n"),L(),f){for(n=[],r=e.length;r--;)n[r]=e.charCodeAt(r);o=a.from(e),(i=new Deflater(6)).append(new Uint8Array(n)),e=i.flush(),(n=new Uint8Array(e.length+6)).set(new Uint8Array([120,156])),n.set(e,2),n.set(new Uint8Array([255&o,o>>8&255,o>>16&255,o>>24&255]),e.length+2),e=String.fromCharCode.apply(null,n),it("<</Length "+e.length+" /Filter [/FlateDecode]>>")}else it("<</Length "+e.length+">>");H(e),it("endobj")}x[1]=E,it("1 0 obj"),it("<</Type /Pages");var l="/Kids [";for(r=0;r<k;r++)l+=c[r]+" 0 R ";it(l+"]"),it("/Count "+k),it(">>"),it("endobj"),rt.publish("postPutPages")}(),function(){rt.publish("putAdditionalObjects");for(var t=0;t<T.length;t++){var e=T[t];x[e.objId]=E,it(e.objId+" 0 obj"),it(e.content),it("endobj")}m+=T.length,rt.publish("postPutAdditionalObjects")}(),G(),L(),it("<<"),function(){for(var t in it("/Producer (jsPDF "+yt.version+")"),q)q.hasOwnProperty(t)&&q[t]&&it("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+ot(q[t])+")");it("/CreationDate ("+c+")")}(),it(">>"),it("endobj"),L(),it("<<"),function(){switch(it("/Type /Catalog"),it("/Pages 1 0 R"),s||(s="fullwidth"),s){case"fullwidth":it("/OpenAction [3 0 R /FitH null]");break;case"fullheight":it("/OpenAction [3 0 R /FitV null]");break;case"fullpage":it("/OpenAction [3 0 R /Fit]");break;case"original":it("/OpenAction [3 0 R /XYZ null null 1]");break;default:var t=""+s;"%"===t.substr(t.length-1)&&(s=parseInt(s)/100),"number"==typeof s&&it("/OpenAction [3 0 R /XYZ null null "+N(s)+"]")}switch(h||(h="continuous"),h){case"continuous":it("/PageLayout /OneColumn");break;case"single":it("/PageLayout /SinglePage");break;case"two":case"twoleft":it("/PageLayout /TwoColumnLeft");break;case"tworight":it("/PageLayout /TwoColumnRight")}a&&it("/PageMode /"+a),rt.publish("putCatalog")}(),it(">>"),it("endobj");var t,e=E,n="0000000000";for(it("xref"),it("0 "+(m+1)),it(n+" 65535 f "),t=1;t<=m;t++){var r=x[t];it("function"==typeof r?(n+x[t]()).slice(-10)+" 00000 n ":(n+x[t]).slice(-10)+" 00000 n ")}return it("trailer"),it("<<"),it("/Size "+(m+1)),it("/Root "+m+" 0 R"),it("/Info "+(m-1)+" 0 R"),it("/ID [ <"+g+"> <"+g+"> ]"),it(">>"),it("startxref"),it(""+e),it("%%EOF"),b=!0,C.join("\n")},ht=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e},ct=function(){for(var t=st(),e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},lt=function(){return new Blob([ct()],{type:"application/pdf"})},ut=((l=function(t,e){var n="dataur"===(""+t).substr(0,6)?"data:application/pdf;base64,"+btoa(st()):0;switch(t){case void 0:return st();case"save":if("object"===("undefined"==typeof navigator?"undefined":vt(navigator))&&navigator.getUserMedia&&(void 0===pt.URL||void 0===pt.URL.createObjectURL))return O.output("dataurlnewwindow");bt(lt(),e),"function"==typeof bt.unload&&pt.setTimeout&&setTimeout(bt.unload,911);break;case"arraybuffer":return ct();case"blob":return lt();case"bloburi":case"bloburl":return pt.URL&&pt.URL.createObjectURL(lt())||void 0;case"datauristring":case"dataurlstring":return n;case"dataurlnewwindow":var r=pt.open(n);if(r||"undefined"==typeof safari)return r;case"datauri":case"dataurl":return pt.document.location.href=n;default:throw new Error('Output type "'+t+'" is not supported.')}}).foo=function(){try{return l.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!pt.console)throw new Error(n);pt.console.error(n,t),pt.alert&&alert(n)}},(l.foo.bar=l).foo),ft=function(t){return!0===Array.isArray(B)&&-1<B.indexOf(t)};switch(e){case"pt":w=1;break;case"mm":w=72/25.4;break;case"cm":w=72/2.54;break;case"in":w=72;break;case"px":w=1==ft("px_scaling")?.75:96/72;break;case"pc":case"em":w=12;break;case"ex":w=6;break;default:throw"Invalid unit: "+e}for(var dt in D(),U(),O.internal={pdfEscape:ot,getStyle:ht,getFont:function(){return nt[at.apply(O,arguments)]},getFontSize:function(){return Z},getCharSpace:function(){return $},getTextColor:function(){var t=Q.split(" ");if(2===t.length&&"g"===t[1]){var e=parseFloat(t[0]);t=[e,e,e,"r"]}for(var n="#",r=0;r<3;r++)n+=("0"+Math.floor(255*parseFloat(t[r])).toString(16)).slice(-2);return n},getLineHeight:function(){return Z*et},write:function(t){it(1===arguments.length?t:Array.prototype.join.call(arguments," "))},getCoordinateString:function(t){return N(t*w)},getVerticalCoordinateString:function(t){return N((v-t)*w)},collections:{},newObject:L,newAdditionalObject:function(){var t=2*_.length+1,e={objId:t+=T.length,content:""};return T.push(e),e},newObjectDeferred:function(){return x[++m]=function(){return E},m},newObjectDeferredBegin:function(t){x[t]=E},putStream:H,events:rt,scaleFactor:w,pageSize:{getWidth:function(){return u},getHeight:function(){return v}},output:function(t,e){return ut(t,e)},getNumberOfPages:function(){return _.length-1},pages:_,out:it,f2:N,getPageInfo:function(t){return{objId:2*(t-1)+3,pageNumber:t,pageContext:A[t]}},getCurrentPageInfo:function(){return{objId:2*(o-1)+3,pageNumber:o,pageContext:A[o]}},getPDFVersion:function(){return gt},hasHotfix:ft},O.addPage=function(){return X.apply(this,arguments),this},O.setPage=function(){return J.apply(this,arguments),this},O.insertPage=function(t){return this.addPage(),this.movePage(o,t),this},O.movePage=function(t,e){if(e<t){for(var n=_[t],r=I[t],i=A[t],o=t;e<o;o--)_[o]=_[o-1],I[o]=I[o-1],A[o]=A[o-1];_[e]=n,I[e]=r,A[e]=i,this.setPage(e)}else if(t<e){for(n=_[t],r=I[t],i=A[t],o=t;o<e;o++)_[o]=_[o+1],I[o]=I[o+1],A[o]=A[o+1];_[e]=n,I[e]=r,A[e]=i,this.setPage(e)}return this},O.deletePage=function(){return function(t){0<t&&t<=k&&(_.splice(t,1),I.splice(t,1),--k<o&&(o=k),this.setPage(o))}.apply(this,arguments),this},O.setCreationDate=function(t){return D(t),this},O.getCreationDate=function(t){return M(t)},O.setFileId=function(t){return U(t),this},O.getFileId=function(){return g},O.setDisplayMode=function(t,e,n){if(s=t,h=e,-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(a=n))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+n+'" is not recognized.');return this},O.text=function(t,e,n,i){var r,o,a="",s=et,h=this;function c(t){for(var e,n=t.concat(),r=[],i=n.length;i--;)"string"==typeof(e=n.shift())?r.push(e):"[object Array]"===Object.prototype.toString.call(t)&&1===e.length?r.push(e[0]):r.push([e[0],e[1],e[2]]);return r}function l(t,e){var n;if("string"==typeof t)n=e(t)[0];else if("[object Array]"===Object.prototype.toString.call(t)){for(var r,i,o=t.concat(),a=[],s=o.length;s--;)"string"==typeof(r=o.shift())?a.push(e(r)[0]):"[object Array]"===Object.prototype.toString.call(r)&&"string"===r[0]&&(i=e(r[0],r[1],r[2]),a.push([i[0],i[1],i[2]]));n=a}return n}"number"==typeof t&&(o=n,n=e,e=t,t=o);var u=i,f=arguments[4],d=arguments[5];"object"===(void 0===u?"undefined":vt(u))&&null!==u||("string"==typeof f&&(d=f,f=null),"string"==typeof u&&(d=u,u=null),"number"==typeof u&&(f=u,u=null),i={flags:u,angle:f,align:d});var p=!1,g=!0;if("string"==typeof t)p=!0;else if("[object Array]"===Object.prototype.toString.call(t)){for(var m,w=t.concat(),y=[],v=w.length;v--;)("string"!=typeof(m=w.shift())||"[object Array]"===Object.prototype.toString.call(m)&&"string"!=typeof m[0])&&(g=!1);p=g}if(!1===p)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');var b=nt[K].encoding;"WinAnsiEncoding"!==b&&"StandardEncoding"!==b||(t=l(t,function(t,e,n){return[(r=t,r=r.split("\t").join(Array(i.TabLen||9).join(" ")),ot(r,u)),e,n];var r})),"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]),0<(j=i.maxWidth||0)&&("string"==typeof t?t=h.splitTextToSize(t,j):"[object Array]"===Object.prototype.toString.call(t)&&(t=h.splitTextToSize(t.join(" "),j)));var x={text:t,x:e,y:n,options:i,mutex:{pdfEscape:ot,activeFontKey:K,fonts:nt,activeFontSize:Z}};rt.publish("preProcessText",x),t=x.text;f=(i=x.options).angle;var S=h.internal.scaleFactor,k=(h.internal.pageSize.getHeight(),[]);if(f){f*=Math.PI/180;var _=Math.cos(f),A=Math.sin(f),I=function(t){return t.toFixed(2)};k=[I(_),I(A),I(-1*A),I(_)]}void 0!==(R=i.charSpace)&&(a+=R+" Tc\n");i.lang;var C=-1,T=i.renderingMode||i.stroke,F=h.internal.getCurrentPageInfo().pageContext;switch(T){case 0:case!1:case"fill":C=0;break;case 1:case!0:case"stroke":C=1;break;case 2:case"fillThenStroke":C=2;break;case 3:case"invisible":C=3;break;case 4:case"fillAndAddForClipping":C=4;break;case 5:case"strokeAndAddPathForClipping":C=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":C=6;break;case 7:case"addToPathForClipping":C=7}var P=F.usedRenderingMode||-1;-1!==C?a+=C+" Tr\n":-1!==P&&(a+="0 Tr\n"),-1!==C&&(F.usedRenderingMode=C);d=i.align||"left";var E=Z*s,q=h.internal.pageSize.getHeight(),O=h.internal.pageSize.getWidth(),B=(S=h.internal.scaleFactor,nt[K]),R=i.charSpace||$,j=i.maxWidth||0,D=(u={},[]);if("[object Array]"===Object.prototype.toString.call(t)){var M,U;y=c(t);"left"!==d&&(U=y.map(function(t){return h.getStringUnitWidth(t,{font:B,charSpace:R,fontSize:Z})*Z/S}));var N,z=Math.max.apply(Math,U),L=0;if("right"===d){e-=U[0],t=[];var H=0;for(v=y.length;H<v;H++)z-U[H],0===H?(N=e*S,M=(q-n)*S):(N=(L-U[H])*S,M=-E),t.push([y[H],N,M]),L=U[H]}else if("center"===d){e-=U[0]/2,t=[];for(H=0,v=y.length;H<v;H++)(z-U[H])/2,0===H?(N=e*S,M=(q-n)*S):(N=(L-U[H])/2*S,M=-E),t.push([y[H],N,M]),L=U[H]}else if("left"===d){t=[];for(H=0,v=y.length;H<v;H++)M=0===H?(q-n)*S:-E,N=0===H?e*S:0,t.push(y[H])}else{if("justify"!==d)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[];for(j=0!==j?j:O,H=0,v=y.length;H<v;H++)M=0===H?(q-n)*S:-E,N=0===H?e*S:0,H<v-1&&D.push(((j-U[H])/(y[H].split(" ").length-1)*S).toFixed(2)),t.push([y[H],N,M])}}!0===("boolean"==typeof i.R2L?i.R2L:tt)&&(t=l(t,function(t,e,n){return[t.split("").reverse().join(""),e,n]}));x={text:t,x:e,y:n,options:i,mutex:{pdfEscape:ot,activeFontKey:K,fonts:nt,activeFontSize:Z}};rt.publish("postProcessText",x),t=x.text,r=x.mutex.isHex;y=c(t);t=[];var W,G,V,Y=0,X=(v=y.length,"");for(H=0;H<v;H++)X="","[object Array]"!==Object.prototype.toString.call(y[H])?(W=parseFloat(e*S).toFixed(2),G=parseFloat((q-n)*S).toFixed(2),V=(r?"<":"(")+y[H]+(r?">":")")):"[object Array]"===Object.prototype.toString.call(y[H])&&(W=parseFloat(y[H][1]).toFixed(2),G=parseFloat(y[H][2]).toFixed(2),V=(r?"<":"(")+y[H][0]+(r?">":")"),Y=1),void 0!==D&&void 0!==D[H]&&(X=D[H]+" Tw\n"),0!==k.length&&0===H?t.push(X+k.join(" ")+" "+W+" "+G+" Tm\n"+V):1===Y||0===Y&&0===H?t.push(X+W+" "+G+" Td\n"+V):t.push(X+V);t=0===Y?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var J="BT\n/"+K+" "+Z+" Tf\n"+(Z*s).toFixed(2)+" TL\n"+Q+"\n";return J+=a,J+=t,it(J+="ET"),h},O.lstext=function(t,e,n,r){console.warn("jsPDF.lstext is deprecated");for(var i=0,o=t.length;i<o;i++,e+=r)this.text(t[i],e,n);return this},O.line=function(t,e,n,r){return this.lines([[n-t,r-e]],t,e)},O.clip=function(){it("W"),it("S")},O.clip_fixed=function(t){it("evenodd"===t?"W*":"W"),it("n")},O.lines=function(t,e,n,r,i,o){var a,s,h,c,l,u,f,d,p,g,m;for("number"==typeof t&&(y=n,n=e,e=t,t=y),r=r||[1,1],it(z(e*w)+" "+z((v-n)*w)+" m "),a=r[0],s=r[1],c=t.length,g=e,m=n,h=0;h<c;h++)2===(l=t[h]).length?(g=l[0]*a+g,m=l[1]*s+m,it(z(g*w)+" "+z((v-m)*w)+" l")):(u=l[0]*a+g,f=l[1]*s+m,d=l[2]*a+g,p=l[3]*s+m,g=l[4]*a+g,m=l[5]*s+m,it(z(u*w)+" "+z((v-f)*w)+" "+z(d*w)+" "+z((v-p)*w)+" "+z(g*w)+" "+z((v-m)*w)+" c"));return o&&it(" h"),null!==i&&it(ht(i)),this},O.rect=function(t,e,n,r,i){ht(i);return it([N(t*w),N((v-e)*w),N(n*w),N(-r*w),"re"].join(" ")),null!==i&&it(ht(i)),this},O.triangle=function(t,e,n,r,i,o,a){return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},O.roundedRect=function(t,e,n,r,i,o,a){var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},O.ellipse=function(t,e,n,r,i){var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return it([N((t+n)*w),N((v-e)*w),"m",N((t+n)*w),N((v-(e-a))*w),N((t+o)*w),N((v-(e-r))*w),N(t*w),N((v-(e-r))*w),"c"].join(" ")),it([N((t-o)*w),N((v-(e-r))*w),N((t-n)*w),N((v-(e-a))*w),N((t-n)*w),N((v-e)*w),"c"].join(" ")),it([N((t-n)*w),N((v-(e+a))*w),N((t-o)*w),N((v-(e+r))*w),N(t*w),N((v-(e+r))*w),"c"].join(" ")),it([N((t+o)*w),N((v-(e+r))*w),N((t+n)*w),N((v-(e+a))*w),N((t+n)*w),N((v-e)*w),"c"].join(" ")),null!==i&&it(ht(i)),this},O.circle=function(t,e,n,r){return this.ellipse(t,e,n,n,r)},O.setProperties=function(t){for(var e in q)q.hasOwnProperty(e)&&t[e]&&(q[e]=t[e]);return this},O.setFontSize=function(t){return Z=t,this},O.setFont=function(t,e){return K=at(t,e),this},O.setFontStyle=O.setFontType=function(t){return K=at(void 0,t),this},O.getFontList=function(){var t,e,n,r={};for(t in S)if(S.hasOwnProperty(t))for(e in r[t]=n=[],S[t])S[t].hasOwnProperty(e)&&n.push(e);return r},O.addFont=function(t,e,n,r){Y(t,e,n,r=r||"Identity-H")},O.setLineWidth=function(t){return it((t*w).toFixed(2)+" w"),this},O.setDrawColor=function(t,e,n,r){return it(R({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"draw",precision:2})),this},O.setFillColor=function(t,e,n,r){return it(R({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"fill",precision:2})),this},O.setTextColor=function(t,e,n,r){return Q=R({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"text",precision:3}),this},O.setCharSpace=function(t){return $=t,this},O.setR2L=function(t){return tt=t,this},O.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},O.setLineCap=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return it((F=e)+" J"),this},O.setLineJoin=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return it((P=e)+" j"),this},O.output=ut,O.save=function(t){O.output("save",t)},yt.API)yt.API.hasOwnProperty(dt)&&("events"===dt&&yt.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(rt,yt.API.events):O[dt]=yt.API[dt]);return function(){for(var t="helvetica",e="times",n="courier",r="normal",i="bold",o="italic",a="bolditalic",s=[["Helvetica",t,r,"WinAnsiEncoding"],["Helvetica-Bold",t,i,"WinAnsiEncoding"],["Helvetica-Oblique",t,o,"WinAnsiEncoding"],["Helvetica-BoldOblique",t,a,"WinAnsiEncoding"],["Courier",n,r,"WinAnsiEncoding"],["Courier-Bold",n,i,"WinAnsiEncoding"],["Courier-Oblique",n,o,"WinAnsiEncoding"],["Courier-BoldOblique",n,a,"WinAnsiEncoding"],["Times-Roman",e,r,"WinAnsiEncoding"],["Times-Bold",e,i,"WinAnsiEncoding"],["Times-Italic",e,o,"WinAnsiEncoding"],["Times-BoldItalic",e,a,"WinAnsiEncoding"],["ZapfDingbats","zapfdingbats",r,null],["Symbol","symbol",r,null]],h=0,c=s.length;h<c;h++){var l=Y(s[h][0],s[h][1],s[h][2],s[h][3]),u=s[h][0].split("-");V(l,u[0],u[1]||"")}rt.publish("addFonts",{fonts:nt,dictionary:S})}(),K="F1",X(n,t),rt.publish("initialized"),O}return yt.API={events:[]},yt.version="0.0.0", true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return yt}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?(module.exports=yt,module.exports.jsPDF=yt):pt.jsPDF=yt,yt}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());
	/** @preserve
	   * jsPDF - PDF Document creation from JavaScript
	   * Version 1.4.1 Built on 2018-06-06T07:49:34.040Z
	   *                           CommitID 3233f44044
	   *
	   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
	   *               2010 Aaron Spike, https://github.com/acspike
	   *               2012 Willow Systems Corporation, willow-systems.com
	   *               2012 Pablo Hess, https://github.com/pablohess
	   *               2012 Florian Jenett, https://github.com/fjenett
	   *               2013 Warren Weckesser, https://github.com/warrenweckesser
	   *               2013 Youssef Beddad, https://github.com/lifof
	   *               2013 Lee Driscoll, https://github.com/lsdriscoll
	   *               2013 Stefan Slonevskiy, https://github.com/stefslon
	   *               2013 Jeremy Morel, https://github.com/jmorel
	   *               2013 Christoph Hartmann, https://github.com/chris-rock
	   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	   *               2014 James Makes, https://github.com/dollaruw
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *               2014 Steven Spungin, https://github.com/Flamenco
	   *               2014 Kenneth Glassey, https://github.com/Gavvers
	   *
	   * Licensed under the MIT License
	   *
	   * Contributor(s):
	   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
	   *    kim3er, mfo, alnorth, Flamenco
	   */
	/**
	   * jsPDF AcroForm Plugin Copyright (c) 2016 Alexander Weidt,
	   * https://github.com/BiggA94
	   * 
	   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
	   */
	!function(n,t){var l,a,e=1,r=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},s=function(t){return t*(e/1)},h=function(t){var e=new I,n=N.internal.getHeight(t)||0,r=N.internal.getWidth(t)||0;return e.BBox=[0,0,r.toFixed(2),n.toFixed(2)],e},i=function(t,e,n){t=t||0;var r=1;if(r<<=e-1,1==(n=n||1))t=t|r;else t=t&~r;return t},o=function(t,e,n){n=n||1.3,t=t||0;return 1==e.readOnly&&(t=i(t,1)),1==e.required&&(t=i(t,2)),1==e.noExport&&(t=i(t,3)),1==e.multiline&&(t=i(t,13)),e.password&&(t=i(t,14)),e.noToggleToOff&&(t=i(t,15)),e.radio&&(t=i(t,16)),e.pushbutton&&(t=i(t,17)),e.combo&&(t=i(t,18)),e.edit&&(t=i(t,19)),e.sort&&(t=i(t,20)),e.fileSelect&&1.4<=n&&(t=i(t,21)),e.multiSelect&&1.4<=n&&(t=i(t,22)),e.doNotSpellCheck&&1.4<=n&&(t=i(t,23)),1==e.doNotScroll&&1.4<=n&&(t=i(t,24)),e.richText&&1.4<=n&&(t=i(t,25)),t},u=function(t){var e=t[0],n=t[1],r=t[2],i=t[3],o={};return Array.isArray(e)?(e[0]=s(e[0]),e[1]=s(e[1]),e[2]=s(e[2]),e[3]=s(e[3])):(e=s(e),n=s(n),r=s(r),i=s(i)),o.lowerLeft_X=e||0,o.lowerLeft_Y=s(a)-n-i||0,o.upperRight_X=e+r||0,o.upperRight_Y=s(a)-n||0,[o.lowerLeft_X.toFixed(2),o.lowerLeft_Y.toFixed(2),o.upperRight_X.toFixed(2),o.upperRight_Y.toFixed(2)]},f=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],n=t.V||t.DV,r=c(t,n);e.push("/Tx BMC"),e.push("q"),e.push("/F1 "+r.fontSize.toFixed(2)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push("BT"),e.push(r.text),e.push("ET"),e.push("Q"),e.push("EMC");var i=new h(t);return i.stream=e.join("\n"),i}},c=function(t,e,i,n){n=n||12,i=i||"helvetica";var r={text:"",fontSize:""},o=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" "),a=n,s=N.internal.getHeight(t)||0;s=s<0?-s:s;var h=N.internal.getWidth(t)||0;h=h<0?-h:h;var c=function(t,e,n){if(t+1<o.length){var r=e+" "+o[t+1];return A(r,n+"px",i).width<=h-4}return!1};a++;t:for(;;){e="";var l=A("3",--a+"px",i).height,u=t.multiline?s-a:(s-l)/2,f=-2,d=u+=2,p=0,g=0,m=0;if(a<=0){a=12,e="(...) Tj\n",e+="% Width of Text: "+A(e,"1px").width+", FieldWidth:"+h+"\n";break}m=A(o[0]+" ",a+"px",i).width;var w="",y=0;for(var v in o){w=" "==(w+=o[v]+" ").substr(w.length-1)?w.substr(0,w.length-1):w;var b=parseInt(v);m=A(w+" ",a+"px",i).width;var x=c(b,w,a),S=v>=o.length-1;if(!x||S){if(x||S){if(S)g=b;else if(t.multiline&&s<(l+2)*(y+2)+2)continue t}else{if(!t.multiline)continue t;if(s<(l+2)*(y+2)+2)continue t;g=b}for(var k="",_=p;_<=g;_++)k+=o[_]+" ";switch(k=" "==k.substr(k.length-1)?k.substr(0,k.length-1):k,m=A(k,a+"px",i).width,t.Q){case 2:f=h-m-2;break;case 1:f=(h-m)/2;break;case 0:default:f=2}e+=f.toFixed(2)+" "+d.toFixed(2)+" Td\n",e+="("+k+") Tj\n",e+=-f.toFixed(2)+" 0 Td\n",d=-(a+2),m=0,p=g+1,y++,w=""}else w+=" "}break}return r.text=e,r.fontSize=a,r},A=function(t,e,n){n=n||"helvetica";var r=l.internal.getFont(n),i=l.getStringUnitWidth(t,{font:r,fontSize:parseFloat(e),charSpace:0})*parseFloat(e);return{height:l.getStringUnitWidth("3",{font:r,fontSize:parseFloat(e),charSpace:0})*parseFloat(e)*1.5,width:i}},d={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},p=function(){for(var t in l.internal.acroformPlugin.acroFormDictionaryRoot.Fields){var e=l.internal.acroformPlugin.acroFormDictionaryRoot.Fields[t];e.hasAnnotation&&m.call(l,e)}},g=function(t){l.internal.acroformPlugin.printedOut&&(l.internal.acroformPlugin.printedOut=!1,l.internal.acroformPlugin.acroFormDictionaryRoot=null),l.internal.acroformPlugin.acroFormDictionaryRoot||x.call(l),l.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)},m=function(t){var e={type:"reference",object:t};l.annotationPlugin.annotations[l.internal.getPageInfo(t.page).pageNumber].push(e)},w=function(){void 0!==l.internal.acroformPlugin.acroFormDictionaryRoot?l.internal.write("/AcroForm "+l.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R"):console.log("Root missing...")},y=function(){l.internal.events.unsubscribe(l.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete l.internal.acroformPlugin.acroFormDictionaryRoot._eventID,l.internal.acroformPlugin.printedOut=!0},v=function(t){var e=!t;t||(l.internal.newObjectDeferredBegin(l.internal.acroformPlugin.acroFormDictionaryRoot.objId),l.internal.out(l.internal.acroformPlugin.acroFormDictionaryRoot.getString()));t=t||l.internal.acroformPlugin.acroFormDictionaryRoot.Kids;for(var n in t){var r=t[n],i=r.Rect;r.Rect&&(r.Rect=u.call(this,r.Rect)),l.internal.newObjectDeferredBegin(r.objId);var o=r.objId+" 0 obj\n<<\n";if("object"===(void 0===r?"undefined":vt(r))&&"function"==typeof r.getContent&&(o+=r.getContent()),r.Rect=i,r.hasAppearanceStream&&!r.appearanceStreamContent){var a=f.call(this,r);o+="/AP << /N "+a+" >>\n",l.internal.acroformPlugin.xForms.push(a)}if(r.appearanceStreamContent){for(var s in o+="/AP << ",r.appearanceStreamContent){var h=r.appearanceStreamContent[s];if(o+="/"+s+" ",o+="<< ",1<=Object.keys(h).length||Array.isArray(h))for(var n in h){var c;"function"==typeof(c=h[n])&&(c=c.call(this,r)),o+="/"+n+" "+c+" ",0<=l.internal.acroformPlugin.xForms.indexOf(c)||l.internal.acroformPlugin.xForms.push(c)}else"function"==typeof(c=h)&&(c=c.call(this,r)),o+="/"+n+" "+c+" \n",0<=l.internal.acroformPlugin.xForms.indexOf(c)||l.internal.acroformPlugin.xForms.push(c);o+=" >>\n"}o+=">>\n"}o+=">>\nendobj\n",l.internal.out(o)}e&&b.call(this,l.internal.acroformPlugin.xForms)},b=function(t){for(var e in t){var n=e,r=t[e];l.internal.newObjectDeferredBegin(r&&r.objId);var i="";"object"===(void 0===r?"undefined":vt(r))&&"function"==typeof r.getString&&(i=r.getString()),l.internal.out(i),delete t[n]}},x=function(){if(void 0!==this.internal&&(void 0===this.internal.acroformPlugin||!1===this.internal.acroformPlugin.isInitialized)){if(l=this,T.FieldNum=0,this.internal.acroformPlugin=JSON.parse(JSON.stringify(d)),this.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");e=l.internal.scaleFactor,a=l.internal.pageSize.getHeight(),l.internal.acroformPlugin.acroFormDictionaryRoot=new C,l.internal.acroformPlugin.acroFormDictionaryRoot._eventID=l.internal.events.subscribe("postPutResources",y),l.internal.events.subscribe("buildDocument",p),l.internal.events.subscribe("putCatalog",w),l.internal.events.subscribe("postPutPages",v),l.internal.acroformPlugin.isInitialized=!0}},S=function(t){if(Array.isArray(t)){var e=" [";for(var n in t){e+=t[n].toString(),e+=n<t.length-1?" ":""}return e+="]"}},k=function(t){return 0!==(t=t||"").indexOf("(")&&(t="("+t),")"!=t.substring(t.length-1)&&(t+=")"),t},_=function(){var t;Object.defineProperty(this,"objId",{get:function(){return t||(t=l.internal.newObjectDeferred()),t||console.log("Couldn't create Object ID"),t},configurable:!1})};_.prototype.toString=function(){return this.objId+" 0 R"},_.prototype.getString=function(){var t=this.objId+" 0 obj\n<<";return t+=this.getContent()+">>\n",this.stream&&(t+="stream\n",t+=this.stream,t+="\nendstream\n"),t+="endobj\n"},_.prototype.getContent=function(){var t="";return t+=function(t){var e="",n=Object.keys(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var r in n){var i=n[r],o=t[i];o&&(Array.isArray(o)?e+="/"+i+" "+S(o)+"\n":e+=o instanceof _?"/"+i+" "+o.objId+" 0 R\n":"/"+i+" "+o+"\n")}return e}(this)};var I=function(){var e;_.call(this),this.Type="/XObject",this.Subtype="/Form",this.FormType=1,this.BBox,this.Matrix,this.Resources="2 0 R",this.PieceInfo,Object.defineProperty(this,"Length",{enumerable:!0,get:function(){return void 0!==e?e.length:0}}),Object.defineProperty(this,"stream",{enumerable:!1,set:function(t){e=t.trim()},get:function(){return e||null}})};r(I,_);var C=function(){_.call(this);var t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return 0<t.length?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!0,configurable:!0,get:function(){return t}}),this.DA};r(C,_);var T=function t(){var e;_.call(this),Object.defineProperty(this,"Rect",{enumerable:!0,configurable:!1,get:function(){if(e)return e},set:function(t){e=t}});var n,r,i,o,a="";Object.defineProperty(this,"FT",{enumerable:!0,set:function(t){a=t},get:function(){return a}}),Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,set:function(t){n=t},get:function(){if(!n||n.length<1){if(this instanceof j)return;return"(FieldObject"+t.FieldNum+++")"}return"("==n.substring(0,1)&&n.substring(n.length-1)?n:"("+n+")"}}),Object.defineProperty(this,"DA",{enumerable:!0,get:function(){if(r)return"("+r+")"},set:function(t){r=t}}),Object.defineProperty(this,"DV",{enumerable:!0,configurable:!0,get:function(){if(i)return i},set:function(t){i=t}}),Object.defineProperty(this,"V",{enumerable:!0,configurable:!0,get:function(){if(o)return o},set:function(t){o=t}}),Object.defineProperty(this,"Type",{enumerable:!0,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,get:function(){return this.hasAnnotation?"/Widget":null}}),this.BG,Object.defineProperty(this,"hasAnnotation",{enumerable:!1,get:function(){return!!(this.Rect||this.BC||this.BG)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,configurable:!0,writable:!0}),Object.defineProperty(this,"page",{enumerable:!1,configurable:!0,writable:!0})};r(T,_);var F=function(){T.call(this),this.FT="/Ch",this.Opt=[],this.V="()",this.TI=0;var e=!1;Object.defineProperty(this,"combo",{enumerable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"edit",{enumerable:!0,set:function(t){1==t?(this._edit=!0,this.combo=!0):this._edit=!1},get:function(){return!!this._edit&&this._edit},configurable:!1}),this.hasAppearanceStream=!0};r(F,T);var P=function(){F.call(this),this.combo=!1};r(P,F);var E=function(){P.call(this),this.combo=!0};r(E,P);var q=function(){E.call(this),this.edit=!0};r(q,E);var O=function(){T.call(this),this.FT="/Btn"};r(O,T);var B=function(){O.call(this);var e=!0;Object.defineProperty(this,"pushbutton",{enumerable:!1,get:function(){return e},set:function(t){e=t}})};r(B,O);var R=function(){O.call(this);var e=!0;Object.defineProperty(this,"radio",{enumerable:!1,get:function(){return e},set:function(t){e=t}});var n,t=[];Object.defineProperty(this,"Kids",{enumerable:!0,get:function(){if(0<t.length)return t}}),Object.defineProperty(this,"__Kids",{get:function(){return t}}),Object.defineProperty(this,"noToggleToOff",{enumerable:!1,get:function(){return n},set:function(t){n=t}})};r(R,O);var j=function(t,e){T.call(this),this.Parent=t,this._AppearanceType=N.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(e),this.F=i(this.F,3,1),this.MK=this._AppearanceType.createMK(),this.AS="/Off",this._Name=e};r(j,T),R.prototype.setAppearance=function(t){if("createAppearanceStream"in t&&"createMK"in t)for(var e in this.__Kids){var n=this.__Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n._Name),n.MK=t.createMK()}else console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!")},R.prototype.createOption=function(t){this.__Kids.length;var e=new j(this,t);return this.__Kids.push(e),n.addField(e),e};var D=function(){O.call(this),this.appearanceStreamContent=N.CheckBox.createAppearanceStream(),this.MK=N.CheckBox.createMK(),this.AS="/On",this.V="/On"};r(D,O);var M=function(){var e,n;T.call(this),this.DA=N.createDefaultAppearanceStream(),this.F=4,Object.defineProperty(this,"V",{get:function(){return e?k(e):e},enumerable:!0,set:function(t){e=t}}),Object.defineProperty(this,"DV",{get:function(){return n?k(n):n},enumerable:!0,set:function(t){n=t}});var r=!1;Object.defineProperty(this,"multiline",{enumerable:!1,get:function(){return r},set:function(t){r=t}});var i=!1;Object.defineProperty(this,"fileSelect",{enumerable:!1,get:function(){return i},set:function(t){i=t}});var o=!1;Object.defineProperty(this,"doNotSpellCheck",{enumerable:!1,get:function(){return o},set:function(t){o=t}});var a=!1;Object.defineProperty(this,"doNotScroll",{enumerable:!1,get:function(){return a},set:function(t){a=t}});var s=!1;Object.defineProperty(this,"MaxLen",{enumerable:!0,get:function(){return s},set:function(t){s=t}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,get:function(){return this.V||this.DV}})};r(M,T);var U=function(){M.call(this);var e=!0;Object.defineProperty(this,"password",{enumerable:!1,get:function(){return e},set:function(t){e=t}})};r(U,M);var N={CheckBox:{createAppearanceStream:function(){return{N:{On:N.CheckBox.YesNormal},D:{On:N.CheckBox.YesPushDown,Off:N.CheckBox.OffPushDown}}},createMK:function(){return"<< /CA (3)>>"},YesPushDown:function(t){var e=h(t),n=[],r=l.internal.getFont("zapfdingbats","normal").id;t.Q=1;var i=c(t,"3","ZapfDingbats",50);return n.push("0.749023 g"),n.push("0 0 "+N.internal.getWidth(t).toFixed(2)+" "+N.internal.getHeight(t).toFixed(2)+" re"),n.push("f"),n.push("BMC"),n.push("q"),n.push("0 0 1 rg"),n.push("/"+r+" "+i.fontSize.toFixed(2)+" Tf 0 g"),n.push("BT"),n.push(i.text),n.push("ET"),n.push("Q"),n.push("EMC"),e.stream=n.join("\n"),e},YesNormal:function(t){var e=h(t),n=l.internal.getFont("zapfdingbats","normal").id,r=[];t.Q=1;var i=N.internal.getHeight(t),o=N.internal.getWidth(t),a=c(t,"3","ZapfDingbats",.9*i);return r.push("1 g"),r.push("0 0 "+o.toFixed(2)+" "+i.toFixed(2)+" re"),r.push("f"),r.push("q"),r.push("0 0 1 rg"),r.push("0 0 "+(o-1).toFixed(2)+" "+(i-1).toFixed(2)+" re"),r.push("W"),r.push("n"),r.push("0 g"),r.push("BT"),r.push("/"+n+" "+a.fontSize.toFixed(2)+" Tf 0 g"),r.push(a.text),r.push("ET"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=h(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+N.internal.getWidth(t).toFixed(2)+" "+N.internal.getHeight(t).toFixed(2)+" re"),n.push("f"),e.stream=n.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:N.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=N.RadioButton.Circle.YesNormal,e.D[t]=N.RadioButton.Circle.YesPushDown,e},createMK:function(){return"<< /CA (l)>>"},YesNormal:function(t){var e=h(t),n=[],r=N.internal.getWidth(t)<=N.internal.getHeight(t)?N.internal.getWidth(t)/4:N.internal.getHeight(t)/4;r*=.9;var i=N.internal.Bezier_C;return n.push("q"),n.push("1 0 0 1 "+N.internal.getWidth(t)/2+" "+N.internal.getHeight(t)/2+" cm"),n.push(r+" 0 m"),n.push(r+" "+r*i+" "+r*i+" "+r+" 0 "+r+" c"),n.push("-"+r*i+" "+r+" -"+r+" "+r*i+" -"+r+" 0 c"),n.push("-"+r+" -"+r*i+" -"+r*i+" -"+r+" 0 -"+r+" c"),n.push(r*i+" -"+r+" "+r+" -"+r*i+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=h(t),n=[],r=N.internal.getWidth(t)<=N.internal.getHeight(t)?N.internal.getWidth(t)/4:N.internal.getHeight(t)/4,i=2*(r*=.9),o=i*N.internal.Bezier_C,a=r*N.internal.Bezier_C;return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+(N.internal.getWidth(t)/2).toFixed(2)+" "+(N.internal.getHeight(t)/2).toFixed(2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),n.push("0 g"),n.push("q"),n.push("1 0 0 1 "+(N.internal.getWidth(t)/2).toFixed(2)+" "+(N.internal.getHeight(t)/2).toFixed(2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+a+" "+a+" "+r+" 0 "+r+" c"),n.push("-"+a+" "+r+" -"+r+" "+a+" -"+r+" 0 c"),n.push("-"+r+" -"+a+" -"+a+" -"+r+" 0 -"+r+" c"),n.push(a+" -"+r+" "+r+" -"+a+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=h(t),n=[],r=N.internal.getWidth(t)<=N.internal.getHeight(t)?N.internal.getWidth(t)/4:N.internal.getHeight(t)/4,i=2*(r*=.9),o=i*N.internal.Bezier_C;return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+(N.internal.getWidth(t)/2).toFixed(2)+" "+(N.internal.getHeight(t)/2).toFixed(2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:N.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=N.RadioButton.Cross.YesNormal,e.D[t]=N.RadioButton.Cross.YesPushDown,e},createMK:function(){return"<< /CA (8)>>"},YesNormal:function(t){var e=h(t),n=[],r=N.internal.calculateCross(t);return n.push("q"),n.push("1 1 "+(N.internal.getWidth(t)-2).toFixed(2)+" "+(N.internal.getHeight(t)-2).toFixed(2)+" re"),n.push("W"),n.push("n"),n.push(r.x1.x.toFixed(2)+" "+r.x1.y.toFixed(2)+" m"),n.push(r.x2.x.toFixed(2)+" "+r.x2.y.toFixed(2)+" l"),n.push(r.x4.x.toFixed(2)+" "+r.x4.y.toFixed(2)+" m"),n.push(r.x3.x.toFixed(2)+" "+r.x3.y.toFixed(2)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=h(t),n=N.internal.calculateCross(t),r=[];return r.push("0.749023 g"),r.push("0 0 "+N.internal.getWidth(t).toFixed(2)+" "+N.internal.getHeight(t).toFixed(2)+" re"),r.push("f"),r.push("q"),r.push("1 1 "+(N.internal.getWidth(t)-2).toFixed(2)+" "+(N.internal.getHeight(t)-2).toFixed(2)+" re"),r.push("W"),r.push("n"),r.push(n.x1.x.toFixed(2)+" "+n.x1.y.toFixed(2)+" m"),r.push(n.x2.x.toFixed(2)+" "+n.x2.y.toFixed(2)+" l"),r.push(n.x4.x.toFixed(2)+" "+n.x4.y.toFixed(2)+" m"),r.push(n.x3.x.toFixed(2)+" "+n.x3.y.toFixed(2)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=h(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+N.internal.getWidth(t).toFixed(2)+" "+N.internal.getHeight(t).toFixed(2)+" re"),n.push("f"),e.stream=n.join("\n"),e}}},createDefaultAppearanceStream:function(t){return"/F1 0 Tf 0 g"}};N.internal={Bezier_C:.551915024494,calculateCross:function(t){var e,n,r=N.internal.getWidth(t),i=N.internal.getHeight(t),o=(n=i)<(e=r)?n:e;return{x1:{x:(r-o)/2,y:(i-o)/2+o},x2:{x:(r-o)/2+o,y:(i-o)/2},x3:{x:(r-o)/2,y:(i-o)/2},x4:{x:(r-o)/2+o,y:(i-o)/2+o}}}},N.internal.getWidth=function(t){var e=0;return"object"===(void 0===t?"undefined":vt(t))&&(e=s(t.Rect[2])),e},N.internal.getHeight=function(t){var e=0;return"object"===(void 0===t?"undefined":vt(t))&&(e=s(t.Rect[3])),e},n.addField=function(t){return x.call(this),t instanceof M?this.addTextField.call(this,t):t instanceof F?this.addChoiceField.call(this,t):t instanceof O?this.addButton.call(this,t):t instanceof j?g.call(this,t):t&&g.call(this,t),t.page=l.internal.getCurrentPageInfo().pageNumber,this},n.addButton=function(t){x.call(this);var e=t||new T;e.FT="/Btn",e.Ff=o(e.Ff,t,l.internal.getPDFVersion()),g.call(this,e)},n.addTextField=function(t){x.call(this);var e=t||new T;e.FT="/Tx",e.Ff=o(e.Ff,t,l.internal.getPDFVersion()),g.call(this,e)},n.addChoiceField=function(t){x.call(this);var e=t||new T;e.FT="/Ch",e.Ff=o(e.Ff,t,l.internal.getPDFVersion()),g.call(this,e)},"object"==(void 0===t?"undefined":vt(t))&&(t.ChoiceField=F,t.ListBox=P,t.ComboBox=E,t.EditBox=q,t.Button=O,t.PushButton=B,t.RadioButton=R,t.CheckBox=D,t.TextField=M,t.PasswordField=U,t.AcroForm={Appearance:N}),n.AcroFormChoiceField=F,n.AcroFormListBox=P,n.AcroFormComboBox=E,n.AcroFormEditBox=q,n.AcroFormButton=O,n.AcroFormPushButton=B,n.AcroFormRadioButton=R,n.AcroFormCheckBox=D,n.AcroFormTextField=M,n.AcroFormPasswordField=U,n.AcroForm={ChoiceField:F,ListBox:P,ComboBox:E,EditBox:q,Button:O,PushButton:B,RadioButton:R,CheckBox:D,TextField:M,PasswordField:U}}($.API,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),$.API.addHTML=function(t,p,g,s,m){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof p&&(s=p,m=g),"function"==typeof s&&(m=s,s=null),"function"!=typeof m&&(m=function(){});var e=this.internal,w=e.scaleFactor,y=e.pageSize.getWidth(),v=e.pageSize.getHeight();if((s=s||{}).onrendered=function(h){p=parseInt(p)||0,g=parseInt(g)||0;var t=s.dim||{},c=Object.assign({top:0,right:0,bottom:0,left:0,useFor:"content"},s.margin),e=t.h||Math.min(v,h.height/w),l=t.w||Math.min(y,h.width/w)-p,u=s.format||"JPEG",f=s.imageCompression||"SLOW";if(h.height>v-c.top-c.bottom&&s.pagesplit){var d=function(t,e,n,r,i){var o=document.createElement("canvas");o.height=i,o.width=r;var a=o.getContext("2d");return a.mozImageSmoothingEnabled=!1,a.webkitImageSmoothingEnabled=!1,a.msImageSmoothingEnabled=!1,a.imageSmoothingEnabled=!1,a.fillStyle=s.backgroundColor||"#ffffff",a.fillRect(0,0,r,i),a.drawImage(t,e,n,r,i,0,0,r,i),o},n=function(){for(var t,e,n=0,r=0,i={},o=!1;;){var a;if(r=0,i.top=0!==n?c.top:g,i.left=0!==n?c.left:p,o=(y-c.left-c.right)*w<h.width,"content"===c.useFor?0===n?(t=Math.min((y-c.left)*w,h.width),e=Math.min((v-c.top)*w,h.height-n)):(t=Math.min(y*w,h.width),e=Math.min(v*w,h.height-n),i.top=0):(t=Math.min((y-c.left-c.right)*w,h.width),e=Math.min((v-c.bottom-c.top)*w,h.height-n)),o)for(;;){"content"===c.useFor&&(0===r?t=Math.min((y-c.left)*w,h.width):(t=Math.min(y*w,h.width-r),i.left=0));var s=[a=d(h,r,n,t,e),i.left,i.top,a.width/w,a.height/w,u,null,f];if(this.addImage.apply(this,s),(r+=t)>=h.width)break;this.addPage()}else s=[a=d(h,0,n,t,e),i.left,i.top,a.width/w,a.height/w,u,null,f],this.addImage.apply(this,s);if((n+=e)>=h.height)break;this.addPage()}m(l,n,null,s)}.bind(this);if("CANVAS"===h.nodeName){var r=new Image;r.onload=n,r.src=h.toDataURL("image/png"),h=r}else n()}else{var i=Math.random().toString(35),o=[h,p,g,l,e,u,i,f];this.addImage.apply(this,o),m(l,e,i,o)}}.bind(this),"undefined"!=typeof html2canvas&&!s.rstz)return html2canvas(t,s);if("undefined"!=typeof rasterizeHTML){var n="drawDocument";return"string"==typeof t&&(n=/^http/.test(t)?"drawURL":"drawHTML"),s.width=s.width||y*w,rasterizeHTML[n](t,void 0,s).then(function(t){s.onrendered(t.image)},function(t){m(null,t)})}return null},
	/** @preserve
	   * jsPDF addImage plugin
	   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
	   *               2013 Chris Dowling, https://github.com/gingerchris
	   *               2013 Trinh Ho, https://github.com/ineedfat
	   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
	   *               2013 Norah Smith, https://github.com/burnburnrocket
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *               2014 James Robb, https://github.com/jamesbrobb
	   *
	   * 
	   */
	function(b){var x="addImage_",h={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]};b.getImageFileTypeByImageData=function(t,e){var n,r;e=e||"UNKNOWN";var i,o,a,s="UNKNOWN";for(a in h)for(i=h[a],n=0;n<i.length;n+=1){for(o=!0,r=0;r<i[n].length;r+=1)if(void 0!==i[n][r]&&i[n][r]!==t.charCodeAt(r)){o=!1;break}if(!0===o){s=a;break}}return"UNKOWN"===s&&"UNKNOWN"!==e&&(console.warn('FileType of Image not recognized. Processing image as "'+e+'".'),s=e),s};var n=function t(e){var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream;if(e.n=n,r("<</Type /XObject"),r("/Subtype /Image"),r("/Width "+e.w),r("/Height "+e.h),e.cs===this.color_spaces.INDEXED?r("/ColorSpace [/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"):(r("/ColorSpace /"+e.cs),e.cs===this.color_spaces.DEVICE_CMYK&&r("/Decode [1 0 1 0 1 0 1 0]")),r("/BitsPerComponent "+e.bpc),"f"in e&&r("/Filter /"+e.f),"dp"in e&&r("/DecodeParms <<"+e.dp+">>"),"trns"in e&&e.trns.constructor==Array){for(var o="",a=0,s=e.trns.length;a<s;a++)o+=e.trns[a]+" "+e.trns[a]+" ";r("/Mask ["+o+"]")}if("smask"in e&&r("/SMask "+(n+1)+" 0 R"),r("/Length "+e.data.length+">>"),i(e.data),r("endobj"),"smask"in e){var h="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,c={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:h,data:e.smask};"f"in e&&(c.f=e.f),t.call(this,c)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),r("<< /Length "+e.pal.length+">>"),i(this.arrayBufferToBinaryString(new Uint8Array(e.pal))),r("endobj"))},S=function(){var t=this.internal.collections[x+"images"];for(var e in t)n.call(this,t[e])},k=function(){var t,e=this.internal.collections[x+"images"],n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},_=function(t){return"function"==typeof b["process"+t.toUpperCase()]},A=function(t){return"object"===(void 0===t?"undefined":vt(t))&&1===t.nodeType},I=function(t,e){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return n;!e&&/\.png(?:[?#].*)?$/i.test(n)&&(e="png")}if("CANVAS"===t.nodeName)var r=t;else{(r=document.createElement("canvas")).width=t.clientWidth||t.width,r.height=t.clientHeight||t.height;var i=r.getContext("2d");if(!i)throw"addImage requires canvas to be supported by browser.";i.drawImage(t,0,0,r.width,r.height)}return r.toDataURL("png"==(""+e).toLowerCase()?"image/png":"image/jpeg")},C=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n};b.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},b.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},b.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},b.sHashCode=function(t){return t=t||"",Array.prototype.reduce&&t.split("").reduce(function(t,e){return(t=(t<<5)-t+e.charCodeAt(0))&t},0)},b.isString=function(t){return"string"==typeof t},b.validateStringAsBase64=function(t){var e=!0;return(t=t||"").length%4!=0&&(e=!1),!1===/[A-Za-z0-9\/]+/.test(t.substr(0,t.length-2))&&(e=!1),!1===/[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==/.test(t.substr(-2))&&(e=!1),e},b.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));base64,(.+)$/g.exec(t)},b.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},b.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},b.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},b.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},b.arrayBufferToBinaryString=function(t){if("function"==typeof atob)return atob(this.arrayBufferToBase64(t));if("function"==typeof TextDecoder){var e=new TextDecoder("ascii");if("ascii"===e.encoding)return e.decode(t)}for(var n=this.isArrayBuffer(t)?t:new Uint8Array(t),r=20480,i="",o=Math.ceil(n.byteLength/r),a=0;a<o;a++)i+=String.fromCharCode.apply(null,n.slice(a*r,a*r+r));return i},b.arrayBufferToBase64=function(t){for(var e,n="",r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=new Uint8Array(t),o=i.byteLength,a=o%3,s=o-a,h=0;h<s;h+=3)n+=r[(16515072&(e=i[h]<<16|i[h+1]<<8|i[h+2]))>>18]+r[(258048&e)>>12]+r[(4032&e)>>6]+r[63&e];return 1==a?n+=r[(252&(e=i[s]))>>2]+r[(3&e)<<4]+"==":2==a&&(n+=r[(64512&(e=i[s]<<8|i[s+1]))>>10]+r[(1008&e)>>4]+r[(15&e)<<2]+"="),n},b.createImageInfo=function(t,e,n,r,i,o,a,s,h,c,l,u,f){var d={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(d.f=o),h&&(d.dp=h),c&&(d.trns=c),l&&(d.pal=l),u&&(d.smask=u),f&&(d.p=f),d},b.addImage=function(t,e,n,r,i,o,a,s,h){var c="";if("string"!=typeof e){var l=o;o=i,i=r,r=n,n=e,e=l}if("object"===(void 0===t?"undefined":vt(t))&&!A(t)&&"imageData"in t){var u=t;t=u.imageData,e=u.format||e,n=u.x||n||0,r=u.y||r||0,i=u.w||i,o=u.h||o,a=u.alias||a,s=u.compression||s,h=u.rotation||u.angle||h}if(isNaN(n)||isNaN(r))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var f,d,p,g,m,w,y,v=function(){var t=this.internal.collections[x+"images"];return t||(this.internal.collections[x+"images"]=t={},this.internal.events.subscribe("putResources",S),this.internal.events.subscribe("putXobjectDict",k)),t}.call(this);if(!(f=C(t,v))&&(A(t)&&(t=I(t,e)),(null==(y=a)||0===y.length)&&(a="string"==typeof(w=t)&&b.sHashCode(w)),!(f=C(a,v)))){if(this.isString(t)&&(""!==(c=this.convertStringToImageData(t))?t=c:void 0!==(c=this.loadImageFile(t))&&(t=c)),e=this.getImageFileTypeByImageData(t,e),!_(e))throw new Error("addImage does not support files of type '"+e+"', please ensure that a plugin for '"+e+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(d=t,t=this.binaryStringToUint8Array(t))),!(f=this["process"+e.toUpperCase()](t,(m=0,(g=v)&&(m=Object.keys?Object.keys(g).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(g)),m),a,((p=s)&&"string"==typeof p&&(p=p.toUpperCase()),p in b.image_compression?p:b.image_compression.NONE),d)))throw new Error("An unkwown error occurred whilst processing the image")}return function(t,e,n,r,i,o,a,s){var h=function(t,e,n){return t||e||(e=t=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]}.call(this,n,r,i),c=this.internal.getCoordinateString,l=this.internal.getVerticalCoordinateString;if(n=h[0],r=h[1],a[o]=i,s){s*=Math.PI/180;var u=Math.cos(s),f=Math.sin(s),d=function(t){return t.toFixed(4)},p=[d(u),d(f),d(-1*f),d(u),0,0,"cm"]}this.internal.write("q"),s?(this.internal.write([1,"0","0",1,c(t),l(e+r),"cm"].join(" ")),this.internal.write(p.join(" ")),this.internal.write([c(n),"0","0",c(r),"0","0","cm"].join(" "))):this.internal.write([c(n),"0","0",c(r),c(t),l(e+r),"cm"].join(" ")),this.internal.write("/I"+i.i+" Do"),this.internal.write("Q")}.call(this,n,r,i,o,f,f.i,v,h),this},b.convertStringToImageData=function(t){var e,n="";this.isString(t)&&(null!==(e=this.extractInfoFromBase64DataURI(t))?b.validateStringAsBase64(e[3])&&(n=atob(e[3])):b.validateStringAsBase64(t)&&(n=atob(t)));return n};var c=function(t,e){return t.subarray(e,e+5)};b.processJPEG=function(t,e,n,r,i,o){var a,s=this.decode.DCT_DECODE;if(!this.isString(t)&&!this.isArrayBuffer(t)&&!this.isArrayBufferView(t))return null;if(this.isString(t)&&(a=function(t){var e;if(255===!t.charCodeAt(0)||216===!t.charCodeAt(1)||255===!t.charCodeAt(2)||224===!t.charCodeAt(3)||!t.charCodeAt(6)==="J".charCodeAt(0)||!t.charCodeAt(7)==="F".charCodeAt(0)||!t.charCodeAt(8)==="I".charCodeAt(0)||!t.charCodeAt(9)==="F".charCodeAt(0)||0===!t.charCodeAt(10))throw new Error("getJpegSize requires a binary string jpeg file");for(var n=256*t.charCodeAt(4)+t.charCodeAt(5),r=4,i=t.length;r<i;){if(r+=n,255!==t.charCodeAt(r))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(r+1)||193===t.charCodeAt(r+1)||194===t.charCodeAt(r+1)||195===t.charCodeAt(r+1)||196===t.charCodeAt(r+1)||197===t.charCodeAt(r+1)||198===t.charCodeAt(r+1)||199===t.charCodeAt(r+1))return e=256*t.charCodeAt(r+5)+t.charCodeAt(r+6),[256*t.charCodeAt(r+7)+t.charCodeAt(r+8),e,t.charCodeAt(r+9)];r+=2,n=256*t.charCodeAt(r)+t.charCodeAt(r+1)}}(t)),this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)&&(a=function(t){if(65496!=(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n=t.length,r=(t[4]<<8)+t[5],i=4;i<n;){if(r=((e=c(t,i+=r))[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&7<r)return{width:((e=c(t,i+5))[2]<<8)+e[3],height:(e[0]<<8)+e[1],numcomponents:e[4]};i+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")}(t),t=i||this.arrayBufferToBinaryString(t)),void 0===o)switch(a.numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;default:case 3:o=this.color_spaces.DEVICE_RGB}return this.createImageInfo(t,a.width,a.height,o,8,s,e,n)},b.processJPG=function(){return this.processJPEG.apply(this,arguments)},b.loadImageFile=function(t,e,n){e=e||!0,n=n||function(){};Object.prototype.toString.call("undefined"!=typeof process?process:0);if(void 0!==("undefined"==typeof window?"undefined":vt(window))&&"object"===("undefined"==typeof location?"undefined":vt(location))&&"http"===location.protocol.substr(0,4))return function(t,e,n){var r=new XMLHttpRequest,i=[],o=0,a=function(t){var e=t.length,n=String.fromCharCode;for(o=0;o<e;o+=1)i.push(n(255&t.charCodeAt(o)));return i.join("")};if(r.open("GET",t,!e),r.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(r.onload=function(){return a(this.responseText)}),r.send(null),200===r.status)return e?a(r.responseText):void 0;console.warn('Unable to load file "'+t+'"')}(t,e)},b.getImageProperties=function(t){var e,n,r="";if(A(t)&&(t=I(t)),this.isString(t)&&(""!==(r=this.convertStringToImageData(t))?t=r:void 0!==(r=this.loadImageFile(t))&&(t=r)),n=this.getImageFileTypeByImageData(t),!_(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(t=this.binaryStringToUint8Array(t))),!(e=this["process"+n.toUpperCase()](t)))throw new Error("An unkwown error occurred whilst processing the image");return{fileType:n,width:e.w,height:e.h,colorSpace:e.cs,compressionMode:e.f,bitsPerComponent:e.bpc}}}($.API),
	/**
	   * jsPDF Annotations PlugIn
	   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	t=$.API,y={annotations:[],f2:function(t){return t.toFixed(2)},notEmpty:function(t){if(void 0!==t&&""!=t)return!0}},$.API.annotationPlugin=y,$.API.events.push(["addPage",function(t){this.annotationPlugin.annotations[t.pageNumber]=[]}]),t.events.push(["putPage",function(t){for(var e=this.annotationPlugin.annotations[t.pageNumber],n=!1,r=0;r<e.length&&!n;r++)switch((h=e[r]).type){case"link":if(y.notEmpty(h.options.url)||y.notEmpty(h.options.pageNumber)){n=!0;break}case"reference":case"text":case"freetext":n=!0}if(0!=n){this.internal.write("/Annots [");var i=this.annotationPlugin.f2,o=this.internal.scaleFactor,a=this.internal.pageSize.getHeight(),s=this.internal.getPageInfo(t.pageNumber);for(r=0;r<e.length;r++){var h;switch((h=e[r]).type){case"reference":this.internal.write(" "+h.object.objId+" 0 R ");break;case"text":var c=this.internal.newAdditionalObject(),l=this.internal.newAdditionalObject(),u=h.title||"Note";m="<</Type /Annot /Subtype /Text "+(d="/Rect ["+i(h.bounds.x*o)+" "+i(a-(h.bounds.y+h.bounds.h)*o)+" "+i((h.bounds.x+h.bounds.w)*o)+" "+i((a-h.bounds.y)*o)+"] ")+"/Contents ("+h.contents+")",m+=" /Popup "+l.objId+" 0 R",m+=" /P "+s.objId+" 0 R",m+=" /T ("+u+") >>",c.content=m;var f=c.objId+" 0 R";m="<</Type /Annot /Subtype /Popup "+(d="/Rect ["+i((h.bounds.x+30)*o)+" "+i(a-(h.bounds.y+h.bounds.h)*o)+" "+i((h.bounds.x+h.bounds.w+30)*o)+" "+i((a-h.bounds.y)*o)+"] ")+" /Parent "+f,h.open&&(m+=" /Open true"),m+=" >>",l.content=m,this.internal.write(c.objId,"0 R",l.objId,"0 R");break;case"freetext":var d="/Rect ["+i(h.bounds.x*o)+" "+i((a-h.bounds.y)*o)+" "+i(h.bounds.x+h.bounds.w*o)+" "+i(a-(h.bounds.y+h.bounds.h)*o)+"] ",p=h.color||"#000000";m="<</Type /Annot /Subtype /FreeText "+d+"/Contents ("+h.contents+")",m+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+p+")",m+=" /Border [0 0 0]",m+=" >>",this.internal.write(m);break;case"link":if(h.options.name){var g=this.annotations._nameMap[h.options.name];h.options.pageNumber=g.page,h.options.top=g.y}else h.options.top||(h.options.top=0);d="/Rect ["+i(h.x*o)+" "+i((a-h.y)*o)+" "+i((h.x+h.w)*o)+" "+i((a-(h.y+h.h))*o)+"] ";var m="";if(h.options.url)m="<</Type /Annot /Subtype /Link "+d+"/Border [0 0 0] /A <</S /URI /URI ("+h.options.url+") >>";else if(h.options.pageNumber)switch(m="<</Type /Annot /Subtype /Link "+d+"/Border [0 0 0] /Dest ["+(t=this.internal.getPageInfo(h.options.pageNumber)).objId+" 0 R",h.options.magFactor=h.options.magFactor||"XYZ",h.options.magFactor){case"Fit":m+=" /Fit]";break;case"FitH":m+=" /FitH "+h.options.top+"]";break;case"FitV":h.options.left=h.options.left||0,m+=" /FitV "+h.options.left+"]";break;case"XYZ":default:var w=i((a-h.options.top)*o);h.options.left=h.options.left||0,void 0===h.options.zoom&&(h.options.zoom=0),m+=" /XYZ "+h.options.left+" "+w+" "+h.options.zoom+"]"}""!=m&&(m+=" >>",this.internal.write(m))}}this.internal.write("]")}}]),t.createAnnotation=function(t){switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(t)}},t.link=function(t,e,n,r,i){this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},t.getLineHeight=function(){return this.internal.getLineHeight()},function(t){var a=Object.keys({ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",fa:"Persian","fa-IR":"Persian/Iran",ur:"Urdu"}),u={1569:[65152],1570:[65153,65154,65153,65154],1571:[65155,65156,65155,65156],1572:[65157,65158],1573:[65159,65160,65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166,65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194,65193],1584:[65195,65196,65195],1585:[65197,65198,65197],1586:[65199,65200,65199],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262,65261],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395,64394],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},f={1570:[65269,65270,65269,65270],1571:[65271,65272,65271,65272],1573:[65273,65274,65273,65274],1575:[65275,65276,65275,65276]},d={1570:[65153,65154,65153,65154],1571:[65155,65156,65155,65156],1573:[65159,65160,65159,65160],1575:[65165,65166,65165,65166]},p={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},e=[1570,1571,1573,1575],n=[1569,1570,1571,1572,1573,1575,1577,1583,1584,1585,1586,1608,1688],o=0,s=1,h=2,c=3;function g(t){return void 0!==t&&void 0!==u[t.charCodeAt(0)]}function l(t){return void 0!==t&&0<=n.indexOf(t.charCodeAt(0))}function m(t){return void 0!==t&&0<=e.indexOf(t.charCodeAt(0))}function w(t){return g(t)&&2<=u[t.charCodeAt(0)].length}function y(t,e,n,r){return g(t)?(r=r||{},u=Object.assign(u,r),!w(t)||!g(e)&&!g(n)||!g(n)&&l(e)||l(t)&&!g(e)||l(t)&&m(e)||l(t)&&l(e)?(u=Object.assign(u,d),o):g(i=t)&&4==u[i.charCodeAt(0)].length&&g(e)&&!l(e)&&g(n)&&w(n)?(u=Object.assign(u,d),c):l(t)||!g(n)?(u=Object.assign(u,d),s):(u=Object.assign(u,d),h)):-1;var i}var v=t.processArabic=function(t,e){t=t||"",e=e||!1;var n,r,i,o="",a=0,s=0,h="",c="",l="";for(a=0;a<t.length;a+=1)h=t[a],c=t[a-1],l=t[a+1],g(h)?void 0!==c&&1604===c.charCodeAt(0)&&m(h)?(s=y(h,t[a-2],t[a+1],f),n=String.fromCharCode(f[h.charCodeAt(0)][s]),o=o.substr(0,o.length-1)+n):void 0!==c&&1617===c.charCodeAt(0)&&(void 0!==(r=h)&&void 0!==p[r.charCodeAt(0)])?(s=y(h,t[a-2],t[a+1],d),n=String.fromCharCode(p[h.charCodeAt(0)][s]),o=o.substr(0,o.length-1)+n):(s=y(h,c,l,d),o+=String.fromCharCode(u[h.charCodeAt(0)][s])):o+=e?{"(":")",")":"("}[i=h]||i:h;return e?o.split("").reverse().join(""):o};t.events.push(["preProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang),i=[];if(0<=a.indexOf(r)){if("[object Array]"===Object.prototype.toString.call(e)){var o=0;for(i=[],o=0;o<e.length;o+=1)"[object Array]"===Object.prototype.toString.call(e[o])?i.push([v(e[o][0],!0),e[o][1],e[o][2]]):i.push([v(e[o],!0)]);t.text=i}else t.text=v(e,!0);void 0===n.charSpace&&(t.options.charSpace=0),!0===n.R2L&&(t.options.R2L=!1)}}])}($.API),$.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.out("/OpenAction "+e+" 0 R")})}return this},(
	/**
	   * jsPDF Canvas PlugIn
	   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	e=$.API).events.push(["initialized",function(){this.canvas.pdf=this}]),e.canvas={getContext:function(t){return(this.pdf.context2d._canvas=this).pdf.context2d},childNodes:[]},Object.defineProperty(e.canvas,"width",{get:function(){return this._width},set:function(t){this._width=t,this.getContext("2d").pageWrapX=t+1}}),Object.defineProperty(e.canvas,"height",{get:function(){return this._height},set:function(t){this._height=t,this.getContext("2d").pageWrapY=t+1}}),
	/** ====================================================================
	   * jsPDF Cell plugin
	   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	   *               2013 Lee Driscoll, https://github.com/lsdriscoll
	   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	   *               2014 James Hall, james@parall.ax
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *
	   * 
	   * ====================================================================
	   */
	I=$.API,C={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},T=1,d=function(t,e,n,r,i){C={x:t,y:e,w:n,h:r,ln:i}},p=function(){return C},F={left:0,top:0,bottom:0},I.setHeaderFunction=function(t){h=t},I.getTextDimensions=function(e){i=this.internal.getFont().fontName,o=this.table_font_size||this.internal.getFontSize(),a=this.internal.getFont().fontStyle;var t,n,r=19.049976/25.4;(n=document.createElement("font")).id="jsPDFCell";try{n.style.fontStyle=a}catch(t){n.style.fontWeight=a}n.style.fontSize=o+"pt",n.style.fontFamily=i;try{n.textContent=e}catch(t){n.innerText=e}return document.body.appendChild(n),t={w:(n.offsetWidth+1)*r,h:(n.offsetHeight+1)*r},document.body.removeChild(n),t},I.cellAddPage=function(){var t=this.margins||F;this.addPage(),d(t.left,t.top,void 0,void 0),T+=1},I.cellInitialize=function(){C={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},T=1},I.cell=function(t,e,n,r,i,o,a){var s=p(),h=!1;if(void 0!==s.ln)if(s.ln===o)t=s.x+s.w,e=s.y;else{var c=this.margins||F;s.y+s.h+r+13>=this.internal.pageSize.getHeight()-c.bottom&&(this.cellAddPage(),h=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=p().y+p().h,h&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var l=0;l<i.length;l++){var u=i[l],f=this.getStringUnitWidth(u)*this.internal.getFontSize();this.text(u,t+n-f-3,e+this.internal.getLineHeight()*(l+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return d(t,e,n,r,o),this},I.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):o<i&&(o=i);return o},I.table=function(t,e,n,r,i){if(!n)throw"No data for PDF table";var o,a,s,h,c,l,u,f,d,p,g=[],m=[],w={},y={},v=[],b=[],x=!1,S=!0,k=12,_=F;if(_.width=this.internal.pageSize.getWidth(),i&&(!0===i.autoSize&&(x=!0),!1===i.printHeaders&&(S=!1),i.fontSize&&(k=i.fontSize),i.css&&void 0!==i.css["font-size"]&&(k=16*i.css["font-size"]),i.margins&&(_=i.margins)),this.lnMod=0,C={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},T=1,this.printHeaders=S,this.margins=_,this.setFontSize(k),this.table_font_size=k,null==r)g=Object.keys(n[0]);else if(r[0]&&"string"!=typeof r[0])for(a=0,s=r.length;a<s;a+=1)o=r[a],g.push(o.name),m.push(o.prompt),y[o.name]=o.width*(19.049976/25.4);else g=r;if(x)for(p=function(t){return t[o]},a=0,s=g.length;a<s;a+=1){for(w[o=g[a]]=n.map(p),v.push(this.getTextDimensions(m[a]||o).w),u=0,h=(l=w[o]).length;u<h;u+=1)c=l[u],v.push(this.getTextDimensions(c).w);y[o]=I.arrayMax(v),v=[]}if(S){var A=this.calculateLineHeight(g,y,m.length?m:g);for(a=0,s=g.length;a<s;a+=1)o=g[a],b.push([t,e,y[o],A,String(m.length?m[a]:o)]);this.setTableHeaderRow(b),this.printHeaderRow(1,!1)}for(a=0,s=n.length;a<s;a+=1)for(f=n[a],A=this.calculateLineHeight(g,y,f),u=0,d=g.length;u<d;u+=1)o=g[u],this.cell(t,e,y[o],A,f[o],a+2,o.align);return this.lastCellPos=C,this.table_x=t,this.table_y=e,this},I.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;i<a&&(i=a)}return i},I.setTableHeaderRow=function(t){this.tableHeaderRow=t},I.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,i,o;if(this.printingHeaderRow=!0,void 0!==h){var a=h(this,T);d(a[0],a[1],a[2],a[3],-1)}this.setFontStyle("bold");var s=[];for(i=0,o=this.tableHeaderRow.length;i<o;i+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[i],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,s.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));0<s.length&&this.setTableHeaderRow(s),this.setFontStyle("normal"),this.printingHeaderRow=!1},
	/**
	   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
	   *
	   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
	   */
	function(t){t.events.push(["initialized",function(){((this.context2d.pdf=this).context2d.internal.pdf=this).context2d.ctx=new e,this.context2d.ctxStack=[],this.context2d.path=[]}]),t.context2d={pageWrapXEnabled:!1,pageWrapYEnabled:!1,pageWrapX:9999999,pageWrapY:9999999,ctx:new e,f2:function(t){return t.toFixed(2)},fillRect:function(t,e,n,r){if(!this._isFillTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"f")}},strokeRect:function(t,e,n,r){if(!this._isStrokeTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"s")}},clearRect:function(t,e,n,r){if(!this.ctx.ignoreClearRect){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.save(),this.setFillStyle("#ffffff"),this.pdf.rect(i.x,i.y,i.w,i.h,"f"),this.restore()}},save:function(){this.ctx._fontSize=this.pdf.internal.getFontSize();var t=new e;t.copy(this.ctx),this.ctxStack.push(this.ctx),this.ctx=t},restore:function(){this.ctx=this.ctxStack.pop(),this.setFillStyle(this.ctx.fillStyle),this.setStrokeStyle(this.ctx.strokeStyle),this.setFont(this.ctx.font),this.pdf.setFontSize(this.ctx._fontSize),this.setLineCap(this.ctx.lineCap),this.setLineWidth(this.ctx.lineWidth),this.setLineJoin(this.ctx.lineJoin)},rect:function(t,e,n,r){this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.closePath()},beginPath:function(){this.path=[]},closePath:function(){this.path.push({type:"close"})},_getRGBA:function(t){var e,n,r,i,o=new RGBColor(t);if(!t)return{r:0,g:0,b:0,a:0,style:t};if(this.internal.rxTransparent.test(t))i=r=n=e=0;else{var a=this.internal.rxRgb.exec(t);null!=a?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),i=1):null!=(a=this.internal.rxRgba.exec(t))?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),i=parseFloat(a[4])):(i=1,"#"!=t.charAt(0)&&(t=o.ok?o.toHex():"#000000"),4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16))}return{r:e,g:n,b:r,a:i,style:t}},setFillStyle:function(t){var e=this._getRGBA(t);this.ctx.fillStyle=t,this.ctx._isFillTransparent=0===e.a,this.ctx._fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})},setStrokeStyle:function(t){var e=this._getRGBA(t);this.ctx.strokeStyle=e.style,this.ctx._isStrokeTransparent=0===e.a,this.ctx._strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))},fillText:function(t,e,n,r){if(!this._isFillTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(0<this.ctx._clip_path.length){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var h=1;try{h=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(h<.01)this.pdf.text(t,e,this._getBaseline(n),null,o);else{var c=this.pdf.internal.getFontSize();this.pdf.setFontSize(c*h),this.pdf.text(t,e,this._getBaseline(n),null,o),this.pdf.setFontSize(c)}0<this.ctx._clip_path.length&&a.push("Q")}},strokeText:function(t,e,n,r){if(!this._isStrokeTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(0<this.ctx._clip_path.length){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var h=1;try{h=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(1===h)this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o);else{var c=this.pdf.internal.getFontSize();this.pdf.setFontSize(c*h),this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o),this.pdf.setFontSize(c)}0<this.ctx._clip_path.length&&a.push("Q")}},setFont:function(t){if(this.ctx.font=t,null!=(c=/\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/.exec(t))){var e=c[1],n=(c[2],c[3]),r=c[4],i=c[5],o=c[6];r="px"===i?Math.floor(parseFloat(r)):"em"===i?Math.floor(parseFloat(r)*this.pdf.getFontSize()):Math.floor(parseFloat(r)),this.pdf.setFontSize(r),"bold"===n||"700"===n?this.pdf.setFontStyle("bold"):"italic"===e?this.pdf.setFontStyle("italic"):this.pdf.setFontStyle("normal"),l="bold"===n||"700"===n?"italic"===e?"bolditalic":"bold":"italic"===e?"italic":"normal";for(var a=o.toLowerCase().split(/\s*,\s*/),s="Times",h=0;h<a.length;h++){if(void 0!==this.pdf.internal.getFont(a[h],l,{noFallback:!0,disableWarning:!0})){s=a[h];break}if("bolditalic"===l&&void 0!==this.pdf.internal.getFont(a[h],"bold",{noFallback:!0,disableWarning:!0}))s=a[h],l="bold";else if(void 0!==this.pdf.internal.getFont(a[h],"normal",{noFallback:!0,disableWarning:!0})){s=a[h],l="normal";break}}this.pdf.setFont(s,l)}else{var c=/\s*(\d+)(pt|px|em)\s+([\w "]+)\s*([\w "]+)?/.exec(t);if(null!=c){var l,u=c[1],f=(c[2],c[3]);(l=c[4])||(l="normal"),u="em"===i?Math.floor(parseFloat(r)*this.pdf.getFontSize()):Math.floor(parseFloat(u)),this.pdf.setFontSize(u),this.pdf.setFont(f,l)}}},setTextBaseline:function(t){this.ctx.textBaseline=t},getTextBaseline:function(){return this.ctx.textBaseline},setTextAlign:function(t){this.ctx.textAlign=t},getTextAlign:function(){return this.ctx.textAlign},setLineWidth:function(t){this.ctx.lineWidth=t,this.pdf.setLineWidth(t)},setLineCap:function(t){this.ctx.lineCap=t,this.pdf.setLineCap(t)},setLineJoin:function(t){this.ctx.lineJoin=t,this.pdf.setLineJoin(t)},moveTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"mt",x:t=n[0],y:e=n[1]};this.path.push(r)},_wrapX:function(t){return this.pageWrapXEnabled?t%this.pageWrapX:t},_wrapY:function(t){return this.pageWrapYEnabled?(this._gotoPage(this._page(t)),(t-this.lastBreak)%this.pageWrapY):t},transform:function(t,e,n,r,i,o){this.ctx._transform=this._matrix_multiply(this.ctx._transform,[t,e,n,r,i,o])},setTransform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},_getTransform:function(){return this.ctx._transform},lastBreak:0,pageBreaks:[],_page:function(t){if(this.pageWrapYEnabled){for(var e=this.lastBreak=0,n=0,r=0;r<this.pageBreaks.length;r++)if(t>=this.pageBreaks[r]){e++,0===this.lastBreak&&n++;var i=this.pageBreaks[r]-this.lastBreak;this.lastBreak=this.pageBreaks[r],n+=Math.floor(i/this.pageWrapY)}if(0===this.lastBreak)n+=Math.floor(t/this.pageWrapY)+1;return n+e}return this.pdf.internal.getCurrentPageInfo().pageNumber},_gotoPage:function(t){},lineTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"lt",x:t=n[0],y:e=n[1]};this.path.push(r)},bezierCurveTo:function(t,e,n,r,i,o){var a;t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r),i=this._wrapX(i),o=this._wrapY(o),i=(a=this._matrix_map_point(this.ctx._transform,[i,o]))[0],o=a[1];var s={type:"bct",x1:t=(a=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=a[1],x2:n=(a=this._matrix_map_point(this.ctx._transform,[n,r]))[0],y2:r=a[1],x:i,y:o};this.path.push(s)},quadraticCurveTo:function(t,e,n,r){var i;t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r),n=(i=this._matrix_map_point(this.ctx._transform,[n,r]))[0],r=i[1];var o={type:"qct",x1:t=(i=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=i[1],x:n,y:r};this.path.push(o)},arc:function(t,e,n,r,i,o){if(t=this._wrapX(t),e=this._wrapY(e),!this._matrix_is_identity(this.ctx._transform)){var a=this._matrix_map_point(this.ctx._transform,[t,e]);t=a[0],e=a[1];var s=this._matrix_map_point(this.ctx._transform,[0,0]),h=this._matrix_map_point(this.ctx._transform,[0,n]);n=Math.sqrt(Math.pow(h[0]-s[0],2)+Math.pow(h[1]-s[1],2))}var c={type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,anticlockwise:o};this.path.push(c)},drawImage:function(t,e,n,r,i,o,a,s,h){void 0!==o&&(e=o,n=a,r=s,i=h),e=this._wrapX(e),n=this._wrapY(n);var c,l=this._matrix_map_rect(this.ctx._transform,{x:e,y:n,w:r,h:i}),u=(this._matrix_map_rect(this.ctx._transform,{x:o,y:a,w:s,h:h}),/data:image\/(\w+).*/i.exec(t));c=null!=u?u[1]:"png",this.pdf.addImage(t,c,l.x,l.y,l.w,l.h)},_matrix_multiply:function(t,e){var n=e[0],r=e[1],i=e[2],o=e[3],a=e[4],s=e[5],h=n*t[0]+r*t[2],c=i*t[0]+o*t[2],l=a*t[0]+s*t[2]+t[4];return r=n*t[1]+r*t[3],o=i*t[1]+o*t[3],s=a*t[1]+s*t[3]+t[5],[n=h,r,i=c,o,a=l,s]},_matrix_rotation:function(t){return Math.atan2(t[2],t[0])},_matrix_decompose:function(t){var e=t[0],n=t[1],r=t[2],i=t[3],o=Math.sqrt(e*e+n*n),a=(e/=o)*r+(n/=o)*i;r-=e*a,i-=n*a;var s=Math.sqrt(r*r+i*i);return a/=s,e*(i/=s)<n*(r/=s)&&(e=-e,n=-n,a=-a,o=-o),{scale:[o,0,0,s,0,0],translate:[1,0,0,1,t[4],t[5]],rotate:[e,n,-n,e,0,0],skew:[1,0,a,1,0,0]}},_matrix_map_point:function(t,e){var n=t[0],r=t[1],i=t[2],o=t[3],a=t[4],s=t[5],h=e[0],c=e[1];return[h*n+c*i+a,h*r+c*o+s]},_matrix_map_point_obj:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]);return{x:n[0],y:n[1]}},_matrix_map_rect:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]),r=this._matrix_map_point(t,[e.x+e.w,e.y+e.h]);return{x:n[0],y:n[1],w:r[0]-n[0],h:r[1]-n[1]}},_matrix_is_identity:function(t){return 1==t[0]&&(0==t[1]&&(0==t[2]&&(1==t[3]&&(0==t[4]&&0==t[5]))))},rotate:function(t){var e=[Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,e)},scale:function(t,e){var n=[t,0,0,e,0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},translate:function(t,e){var n=[1,0,0,1,t,e];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},stroke:function(){if(0<this.ctx._clip_path.length){var t;(t=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var e=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._stroke(!0),this.ctx._clip_path=this.path,this.path=e,this._stroke(!1),t.push("Q")}else this._stroke(!1)},_stroke:function(t){if(t||!this._isStrokeTransparent()){for(var e=[],n=this.path,r=0;r<n.length;r++){var i=n[r];switch(i.type){case"mt":e.push({start:i,deltas:[],abs:[]});break;case"lt":var o=[i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(o),e[e.length-1].abs.push(i);break;case"bct":o=[i.x1-n[r-1].x,i.y1-n[r-1].y,i.x2-n[r-1].x,i.y2-n[r-1].y,i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(o);break;case"qct":var a=n[r-1].x+2/3*(i.x1-n[r-1].x),s=n[r-1].y+2/3*(i.y1-n[r-1].y),h=i.x+2/3*(i.x1-i.x),c=i.y+2/3*(i.y1-i.y),l=i.x,u=i.y;o=[a-n[r-1].x,s-n[r-1].y,h-n[r-1].x,c-n[r-1].y,l-n[r-1].x,u-n[r-1].y];e[e.length-1].deltas.push(o);break;case"arc":0==e.length&&e.push({start:{x:0,y:0},deltas:[],abs:[]}),e[e.length-1].arc=!0,Array.isArray(e[e.length-1].abs)&&e[e.length-1].abs.push(i)}}for(r=0;r<e.length;r++){var f;if(f=r==e.length-1?"s":null,e[r].arc)for(var d=e[r].abs,p=0;p<d.length;p++){var g=d[p],m=360*g.startAngle/(2*Math.PI),w=360*g.endAngle/(2*Math.PI),y=g.x,v=g.y;this.internal.arc2(this,y,v,g.radius,m,w,g.anticlockwise,f,t)}else{y=e[r].start.x,v=e[r].start.y;t?(this.pdf.lines(e[r].deltas,y,v,null,null),this.pdf.clip_fixed()):this.pdf.lines(e[r].deltas,y,v,null,f)}}}},_isFillTransparent:function(){return this.ctx._isFillTransparent||0==this.globalAlpha},_isStrokeTransparent:function(){return this.ctx._isStrokeTransparent||0==this.globalAlpha},fill:function(t){if(0<this.ctx._clip_path.length){var e;(e=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var n=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(t,!0),this.ctx._clip_path=this.path,this.path=n,this._fill(t,!1),e.push("Q")}else this._fill(t,!1)},_fill:function(t,e){if(!this._isFillTransparent()){var n,r="function"==typeof this.pdf.internal.newObject2;n=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage();var i=[],o=window.outIntercept;if(r)switch(this.ctx.globalCompositeOperation){case"normal":case"source-over":break;case"destination-in":case"destination-out":var a=this.pdf.internal.newStreamObject(),s=this.pdf.internal.newObject2();s.push("<</Type /ExtGState"),s.push("/SMask <</S /Alpha /G "+a.objId+" 0 R>>"),s.push(">>");var h="MASK"+s.objId;this.pdf.internal.addGraphicsState(h,s.objId);var c="/"+h+" gs";n.splice(0,0,"q"),n.splice(1,0,c),n.push("Q"),window.outIntercept=a;break;default:var l="/"+this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];l&&this.pdf.internal.out(l+" gs")}var u=this.ctx.globalAlpha;if(this.ctx._fillOpacity<1&&(u=this.ctx._fillOpacity),r){var f=this.pdf.internal.newObject2();f.push("<</Type /ExtGState"),f.push("/CA "+u),f.push("/ca "+u),f.push(">>");h="GS_O_"+f.objId;this.pdf.internal.addGraphicsState(h,f.objId),this.pdf.internal.out("/"+h+" gs")}for(var d=this.path,p=0;p<d.length;p++){var g=d[p];switch(g.type){case"mt":i.push({start:g,deltas:[],abs:[]});break;case"lt":var m=[g.x-d[p-1].x,g.y-d[p-1].y];i[i.length-1].deltas.push(m),i[i.length-1].abs.push(g);break;case"bct":m=[g.x1-d[p-1].x,g.y1-d[p-1].y,g.x2-d[p-1].x,g.y2-d[p-1].y,g.x-d[p-1].x,g.y-d[p-1].y];i[i.length-1].deltas.push(m);break;case"qct":var w=d[p-1].x+2/3*(g.x1-d[p-1].x),y=d[p-1].y+2/3*(g.y1-d[p-1].y),v=g.x+2/3*(g.x1-g.x),b=g.y+2/3*(g.y1-g.y),x=g.x,S=g.y;m=[w-d[p-1].x,y-d[p-1].y,v-d[p-1].x,b-d[p-1].y,x-d[p-1].x,S-d[p-1].y];i[i.length-1].deltas.push(m);break;case"arc":0===i.length&&i.push({deltas:[],abs:[]}),i[i.length-1].arc=!0,Array.isArray(i[i.length-1].abs)&&i[i.length-1].abs.push(g);break;case"close":i.push({close:!0})}}for(p=0;p<i.length;p++){var k;if(p==i.length-1?(k="f","evenodd"===t&&(k+="*")):k=null,i[p].close)this.pdf.internal.out("h"),k&&this.pdf.internal.out(k);else if(i[p].arc){i[p].start&&this.internal.move2(this,i[p].start.x,i[p].start.y);for(var _=i[p].abs,A=0;A<_.length;A++){var I=_[A];if(void 0!==I.startAngle){var C=360*I.startAngle/(2*Math.PI),T=360*I.endAngle/(2*Math.PI),F=I.x,P=I.y;if(0===A&&this.internal.move2(this,F,P),this.internal.arc2(this,F,P,I.radius,C,T,I.anticlockwise,null,e),A===_.length-1&&i[p].start){F=i[p].start.x,P=i[p].start.y;this.internal.line2(E,F,P)}}else this.internal.line2(E,I.x,I.y)}}else{F=i[p].start.x,P=i[p].start.y;e?(this.pdf.lines(i[p].deltas,F,P,null,null),this.pdf.clip_fixed()):this.pdf.lines(i[p].deltas,F,P,null,k)}}window.outIntercept=o}},pushMask:function(){if("function"==typeof this.pdf.internal.newObject2){var t=this.pdf.internal.newStreamObject(),e=this.pdf.internal.newObject2();e.push("<</Type /ExtGState"),e.push("/SMask <</S /Alpha /G "+t.objId+" 0 R>>"),e.push(">>");var n="MASK"+e.objId;this.pdf.internal.addGraphicsState(n,e.objId);var r="/"+n+" gs";this.pdf.internal.out(r)}else console.log("jsPDF v2 not enabled")},clip:function(){if(0<this.ctx._clip_path.length)for(var t=0;t<this.path.length;t++)this.ctx._clip_path.push(this.path[t]);else this.ctx._clip_path=this.path;this.path=[]},measureText:function(n){var r=this.pdf;return{getWidth:function(){var t=r.internal.getFontSize(),e=r.getStringUnitWidth(n)*t/r.internal.scaleFactor;return e*=1.3333},get width(){return this.getWidth(n)}}},_getBaseline:function(t){var e=parseInt(this.pdf.internal.getFontSize()),n=.25*e;switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e;case"hanging":return t+e-n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}}};var E=t.context2d;function e(){this._isStrokeTransparent=!1,this._strokeOpacity=1,this.strokeStyle="#000000",this.fillStyle="#000000",this._isFillTransparent=!1,this._fillOpacity=1,this.font="12pt times",this.textBaseline="alphabetic",this.textAlign="start",this.lineWidth=1,this.lineJoin="miter",this.lineCap="butt",this._transform=[1,0,0,1,0,0],this.globalCompositeOperation="normal",this.globalAlpha=1,this._clip_path=[],this.ignoreClearRect=!1,this.copy=function(t){this._isStrokeTransparent=t._isStrokeTransparent,this._strokeOpacity=t._strokeOpacity,this.strokeStyle=t.strokeStyle,this._isFillTransparent=t._isFillTransparent,this._fillOpacity=t._fillOpacity,this.fillStyle=t.fillStyle,this.font=t.font,this.lineWidth=t.lineWidth,this.lineJoin=t.lineJoin,this.lineCap=t.lineCap,this.textBaseline=t.textBaseline,this.textAlign=t.textAlign,this._fontSize=t._fontSize,this._transform=t._transform.slice(0),this.globalCompositeOperation=t.globalCompositeOperation,this.globalAlpha=t.globalAlpha,this._clip_path=t._clip_path.slice(0),this.ignoreClearRect=t.ignoreClearRect}}Object.defineProperty(E,"fillStyle",{set:function(t){this.setFillStyle(t)},get:function(){return this.ctx.fillStyle}}),Object.defineProperty(E,"strokeStyle",{set:function(t){this.setStrokeStyle(t)},get:function(){return this.ctx.strokeStyle}}),Object.defineProperty(E,"lineWidth",{set:function(t){this.setLineWidth(t)},get:function(){return this.ctx.lineWidth}}),Object.defineProperty(E,"lineCap",{set:function(t){this.setLineCap(t)},get:function(){return this.ctx.lineCap}}),Object.defineProperty(E,"lineJoin",{set:function(t){this.setLineJoin(t)},get:function(){return this.ctx.lineJoin}}),Object.defineProperty(E,"miterLimit",{set:function(t){this.ctx.miterLimit=t},get:function(){return this.ctx.miterLimit}}),Object.defineProperty(E,"textBaseline",{set:function(t){this.setTextBaseline(t)},get:function(){return this.getTextBaseline()}}),Object.defineProperty(E,"textAlign",{set:function(t){this.setTextAlign(t)},get:function(){return this.getTextAlign()}}),Object.defineProperty(E,"font",{set:function(t){this.setFont(t)},get:function(){return this.ctx.font}}),Object.defineProperty(E,"globalCompositeOperation",{set:function(t){this.ctx.globalCompositeOperation=t},get:function(){return this.ctx.globalCompositeOperation}}),Object.defineProperty(E,"globalAlpha",{set:function(t){this.ctx.globalAlpha=t},get:function(){return this.ctx.globalAlpha}}),Object.defineProperty(E,"canvas",{get:function(){return{parentNode:!1,style:!1}}}),Object.defineProperty(E,"ignoreClearRect",{set:function(t){this.ctx.ignoreClearRect=t},get:function(){return this.ctx.ignoreClearRect}}),E.internal={},E.internal.rxRgb=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/,E.internal.rxRgba=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/,E.internal.rxTransparent=/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/,E.internal.arc=function(t,e,n,r,i,o,a,s){for(var h=this.pdf.internal.scaleFactor,c=this.pdf.internal.pageSize.getHeight(),l=this.pdf.internal.f2,u=i*(Math.PI/180),f=o*(Math.PI/180),d=this.createArc(r,u,f,a),p=0;p<d.length;p++){var g=d[p];0===p?this.pdf.internal.out([l((g.x1+e)*h),l((c-(g.y1+n))*h),"m",l((g.x2+e)*h),l((c-(g.y2+n))*h),l((g.x3+e)*h),l((c-(g.y3+n))*h),l((g.x4+e)*h),l((c-(g.y4+n))*h),"c"].join(" ")):this.pdf.internal.out([l((g.x2+e)*h),l((c-(g.y2+n))*h),l((g.x3+e)*h),l((c-(g.y3+n))*h),l((g.x4+e)*h),l((c-(g.y4+n))*h),"c"].join(" ")),t._lastPoint={x:e,y:n}}null!==s&&this.pdf.internal.out(this.pdf.internal.getStyle(s))},E.internal.arc2=function(t,e,n,r,i,o,a,s,h){var c=e,l=n;h?(this.arc(t,c,l,r,i,o,a,null),this.pdf.clip_fixed()):this.arc(t,c,l,r,i,o,a,s)},E.internal.move2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.getHeight(),o=this.pdf.internal.f2;this.pdf.internal.out([o(e*r),o((i-n)*r),"m"].join(" ")),t._lastPoint={x:e,y:n}},E.internal.line2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.getHeight(),o=this.pdf.internal.f2,a={x:e,y:n};this.pdf.internal.out([o(a.x*r),o((i-a.y)*r),"l"].join(" ")),t._lastPoint=a},E.internal.createArc=function(t,e,n,r){var i=2*Math.PI,o=Math.PI/2,a=e;for((a<i||i<a)&&(a%=i),a<0&&(a=i+a);n<e;)e-=i;var s=Math.abs(n-e);s<i&&r&&(s=i-s);for(var h=[],c=r?-1:1,l=a;1e-5<s;){var u=l+c*Math.min(s,o);h.push(this.createSmallArc(t,l,u)),s-=Math.abs(u-l),l=u}return h},E.internal.getCurrentPage=function(){return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber]},E.internal.createSmallArc=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,h=a*a+s*s,c=h+a*i+s*o,l=4/3*(Math.sqrt(2*h*c)-c)/(a*o-s*i),u=a-l*s,f=s+l*a,d=u,p=-f,g=r+e,m=Math.cos(g),w=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:u*m-f*w,y2:u*w+f*m,x3:d*m-p*w,y3:d*w+p*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}}}($.API,"undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
	/** @preserve
	   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
	   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *               2014 Daniel Husar, https://github.com/danielhusar
	   *               2014 Wolfgang Gassler, https://github.com/woolfg
	   *               2014 Steven Spungin, https://github.com/flamenco
	   *
	   * 
	   * ====================================================================
	   */
	function(t){var T,F,i,a,s,h,c,l,P,v,f,u,d,n,E,q,p,g,m,O;T=function(){return function(t){return e.prototype=t,new e};function e(){}}(),v=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,a=i=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},u=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},d=function(t){var e;return-1<(t="auto"===t?"0px":t).indexOf("em")&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),-1<t.indexOf("pt")&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px"),void 0,16,(e=n[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[t])?n[t]=e/16:(e=parseFloat(t))?n[t]=e/16:(e=t.match(/([\d\.]+)(px)/),Array.isArray(e)&&3===e.length?n[t]=parseFloat(e[1])/16:n[t]=1)},P=function(t){var e,n,r,i,o;return o=t,i=document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(o,null):o.currentStyle?o.currentStyle:o.style,n=void 0,(e={})["font-family"]=u((r=function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),i[t]})("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=h[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=d(r("font-size"))||1,e["line-height"]=d(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&d(r("margin-top"))||0,e["margin-bottom"]=n&&d(r("margin-bottom"))||0,e["padding-top"]=n&&d(r("padding-top"))||0,e["padding-bottom"]=n&&d(r("padding-bottom"))||0,e["margin-left"]=n&&d(r("margin-left"))||0,e["margin-right"]=n&&d(r("margin-right"))||0,e["padding-left"]=n&&d(r("padding-left"))||0,e["padding-right"]=n&&d(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=c[r("cssFloat")]||"none",e.clear=l[r("clear")]||"none",e.color=r("color"),e},E=function(t,e,n){var r,i,o,a,s;if(o=!1,a=i=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s="string"==typeof t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},O=function(t,e){var n,r,i,o,a,s,h,c,l;for(n=[],r=[],i=0,l=t.rows[0].cells.length,h=t.clientWidth;i<l;)c=t.rows[0].cells[i],r[i]={name:c.textContent.toLowerCase().replace(/\s+/g,""),prompt:c.textContent.replace(/\r?\n/g,""),width:c.clientWidth/h*e.pdf.internal.pageSize.getWidth()},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var B={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},R=1;F=function(t,i,e){var n,r,o,a,s,h,c,l;for(r=t.childNodes,n=void 0,(s="block"===(o=P(t)).display)&&(i.setBlockBoundary(),i.setBlockStyle(o)),a=0,h=r.length;a<h;){if("object"===(void 0===(n=r[a])?"undefined":vt(n))){if(i.executeWatchFunctions(n),1===n.nodeType&&"HEADER"===n.nodeName){var u=n,f=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=f,F(u,i,e),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===n.nodeType&&"#comment"===n.nodeName)~n.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==n.nodeType||B[n.nodeName])if(3===n.nodeType){var d=n.nodeValue;if(n.nodeValue&&"LI"===n.parentNode.nodeName)if("OL"===n.parentNode.parentNode.nodeName)d=R+++". "+d;else{var p=o["font-size"],g=(3-.75*p)*i.pdf.internal.scaleFactor,m=.75*p*i.pdf.internal.scaleFactor,w=1.74*p/i.pdf.internal.scaleFactor;l=function(t,e){this.pdf.circle(t+g,e+m,w,"FD")}}16&n.ownerDocument.body.compareDocumentPosition(n)&&i.addText(d,o)}else"string"==typeof n&&i.addText(n,o);else{var y;if("IMG"===n.nodeName){var v=n.getAttribute("src");y=q[i.pdf.sHashCode(v)||v]}if(y){i.pdf.internal.pageSize.getHeight()-i.pdf.margins_doc.bottom<i.y+n.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(n));var b=P(n),x=i.x,S=12/i.pdf.internal.scaleFactor,k=(b["margin-left"]+b["padding-left"])*S,_=(b["margin-right"]+b["padding-right"])*S,A=(b["margin-top"]+b["padding-top"])*S,I=(b["margin-bottom"]+b["padding-bottom"])*S;void 0!==b.float&&"right"===b.float?x+=i.settings.width-n.width-_:x+=k,i.pdf.addImage(y,x,i.y+A,n.width,n.height),y=void 0,"right"===b.float||"left"===b.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!B[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===b.float?-n.width-k-_:0,i.y+n.height+A+I,n.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===P(n).clear&&(i.y=t,!0)}.bind(this,i.y+n.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=n.width+k+_,"left"===b.float&&(i.x+=n.width+k+_)):i.y+=n.height+A+I}else if("TABLE"===n.nodeName)c=O(n,i),i.y+=10,i.pdf.table(i.x,i.y,c.rows,c.headers,{autoSize:!1,printHeaders:e.printHeaders,margins:i.pdf.margins_doc,css:P(n)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===n.nodeName||"UL"===n.nodeName)R=1,E(n,i,e)||F(n,i,e),i.y+=10;else if("LI"===n.nodeName){var C=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,E(n,i,e)||F(n,i,e),i.x=C}else"BR"===n.nodeName?(i.y+=o["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",T(o))):E(n,i,e)||F(n,i,e)}}a++}if(e.outY=i.y,s)return i.setBlockBoundary(l)},q={},p=function(t,o,e,n){var a,r=t.getElementsByTagName("img"),i=r.length,s=0;function h(){o.pdf.internal.events.publish("imagesLoaded"),n(a)}function c(e,n,r){if(e){var i=new Image;a=++s,i.crossOrigin="",i.onerror=i.onload=function(){if(i.complete&&(0===i.src.indexOf("data:image/")&&(i.width=n||i.width||0,i.height=r||i.height||0),i.width+i.height)){var t=o.pdf.sHashCode(e)||e;q[t]=q[t]||i}--s||h()},i.src=e}}for(;i--;)c(r[i].getAttribute("src"),r[i].width,r[i].height);return s||h()},g=function(t,o,a){var s=t.getElementsByTagName("footer");if(0<s.length){s=s[0];var e=o.pdf.internal.write,n=o.y;o.pdf.internal.write=function(){},F(s,o,a);var h=Math.ceil(o.y-n)+5;o.y=n,o.pdf.internal.write=e,o.pdf.margins_doc.bottom+=h;for(var r=function(t){var e=void 0!==t?t.pageNumber:1,n=o.y;o.y=o.pdf.internal.pageSize.getHeight()-o.pdf.margins_doc.bottom,o.pdf.margins_doc.bottom-=h;for(var r=s.getElementsByTagName("span"),i=0;i<r.length;++i)-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")&&(r[i].innerHTML=e),-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&(r[i].innerHTML="###jsPDFVarTotalPages###");F(s,o,a),o.pdf.margins_doc.bottom+=h,o.y=n},i=s.getElementsByTagName("span"),c=0;c<i.length;++c)-1<(" "+i[c].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&o.pdf.internal.events.subscribe("htmlRenderingFinished",o.pdf.putTotalPages.bind(o.pdf,"###jsPDFVarTotalPages###"),!0);o.pdf.internal.events.subscribe("addPage",r,!1),r(),B.FOOTER=1}},m=function(t,e,n,r,i,o){if(!e)return!1;var a,s,h,c;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(a=e.replace(/<\/?script[^>]*?>/gi,""),c="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),(h=document.createElement("div")).style.cssText="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",h.innerHTML='<iframe style="height:1px;width:1px" name="'+c+'" />',document.body.appendChild(h),(s=window.frames[c]).document.open(),s.document.writeln(a),s.document.close(),e=s.document.body);var l,u=new f(t,n,r,i);return p.call(this,e,u,i.elementHandlers,function(t){g(e,u,i.elementHandlers),F(e,u,i.elementHandlers),u.pdf.internal.events.publish("htmlRenderingFinished"),l=u.dispose(),"function"==typeof o?o(l):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),l||{x:u.x,y:u.y}},(f=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},f.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},f.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(0<this.watchFunctions.length){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},f.prototype.splitFragmentsIntoLines=function(t,e){var n,r,i,o,a,s,h,c,l,u,f,d,p,g;for(12,u=this.pdf.internal.scaleFactor,o={},s=h=c=g=a=i=l=r=void 0,d=[f=[]],n=0,p=this.settings.width;t.length;)if(a=t.shift(),g=e.shift(),a)if((i=o[(r=g["font-family"])+(l=g["font-style"])])||(i=this.pdf.internal.getFont(r,l).metadata.Unicode,o[r+l]=i),c={widths:i.widths,kerning:i.kerning,fontSize:12*g["font-size"],textIndent:n},h=this.pdf.getStringUnitWidth(a,c)*c.fontSize/u,"\u2028"==a)f=[],d.push(f);else if(p<n+h){for(s=this.pdf.splitTextToSize(a,p,c),f.push([s.shift(),g]);s.length;)f=[[s.shift(),g]],d.push(f);n=this.pdf.getStringUnitWidth(f[0][0],c)*c.fontSize/u}else f.push([a,g]),n+=h;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var m=0;m<d.length;++m){var w=this.pdf.getStringUnitWidth(d[m][0][0],c)*c.fontSize/u;0<m&&(d[m][0][1]=T(d[m][0][1]));var y=p-w;if("right"===g["text-align"])d[m][0][1]["margin-left"]=y;else if("center"===g["text-align"])d[m][0][1]["margin-left"]=y/2;else if("justify"===g["text-align"]){var v=d[m][0][0].split(" ").length-1;d[m][0][1]["word-spacing"]=y/v,m===d.length-1&&(d[m][0][1]["word-spacing"]=0)}}return d},f.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.getHeight()-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT",this.getPdfColor(e.color),this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&0<e["word-spacing"]&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},f.prototype.getPdfColor=function(t){var e,n,r,i=new RGBColor(t),o=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=o?(e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3])):("#"!=t.charAt(0)&&(t=i.ok?i.toHex():"#000000"),e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)),"string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},f.prototype.f3=function(t){return t.toFixed(3)},f.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,h,c,l,u,f,d;if(r=v(this.paragraph.text),f=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph.priorblockstyle||{},this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,f),h=a=void 0,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,u=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,l=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,u=((e["margin-top"]||0)+(e["padding-top"]||0))*n),c=this.pdf.internal.write,o=i=void 0,this.y+=u,c("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var p=0;s.length;){for(i=h=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(h=Math.max(h,a[i][1]["line-height"],a[i][1]["font-size"]),d=7*a[i][1]["font-size"]),i++;var g=0,m=0;for(void 0!==a[0][1]["margin-left"]&&0<a[0][1]["margin-left"]&&(g=(m=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-p,p=m),c(g+Math.max(e["margin-left"]||0,0)*n,(-12*h).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=h*n,this.executeWatchFunctions(a[0][1])&&0<s.length){var w=[],y=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(w.push(t[e][0]+" "),y.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(v(w),y),c("ET","Q"),c("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-d/2),c("ET","Q"),this.y+=l}},f.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},f.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},f.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},h={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},c={none:"none",right:"right",left:"left"},l={none:"none",both:"both"},n={normal:1},t.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),m(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}($.API),$.API.addJS=function(t){return s=t,this.internal.events.subscribe("postPutResources",function(t){n=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(n+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),r=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+s+")"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==n&&void 0!==r&&this.internal.out("/Names <</JavaScript "+n+" 0 R>>")}),this},(
	/**
	   * jsPDF Outline PlugIn
	   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	c=$.API).events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(0<this.outline.root.children.length)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a)}t.internal.write(i)}if(this.outline.createNamedDestinations){var s=this.internal.pages.length,h=[];for(r=0;r<s;r++){var c=t.internal.newObject();h.push(c);var l=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+l.objId+" 0 R /XYZ null null null]>> endobj")}var u=t.internal.newObject();for(t.internal.write("<< /Names [ "),r=0;r<h.length;r++)t.internal.write("(page_"+(r+1)+")"+h[r]+" 0 R");t.internal.write(" ] >>","endobj"),t.internal.newObject(),t.internal.write("<< /Dests "+u+" 0 R"),t.internal.write(">>","endobj")}}]),c.events.push(["putCatalog",function(){0<this.outline.root.children.length&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+namesOid+" 0 R"))}]),c.events.push(["initialized",function(){var o=this;o.outline={createNamedDestinations:!1,root:{children:[]}},o.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},o.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=o,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},o.outline.genIds_r=function(t){t.id=o.internal.newObjectDeferred();for(var e=0;e<t.children.length;e++)this.genIds_r(t.children[e])},o.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),0<t.children.length&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},o.outline.renderItems=function(t){for(var e=0;e<t.children.length;e++){var n=t.children[e];this.objStart(n),this.line("/Title "+this.makeString(n.title)),this.line("/Parent "+this.makeRef(t)),0<e&&this.line("/Prev "+this.makeRef(t.children[e-1])),e<t.children.length-1&&this.line("/Next "+this.makeRef(t.children[e+1])),0<n.children.length&&(this.line("/First "+this.makeRef(n.children[0])),this.line("/Last "+this.makeRef(n.children[n.children.length-1])));var r=this.count=this.count_r({count:0},n);if(0<r&&this.line("/Count "+r),n.options&&n.options.pageNumber){var i=o.internal.getPageInfo(n.options.pageNumber);this.line("/Dest ["+i.objId+" 0 R /XYZ 0 "+this.ctx.pdf.internal.pageSize.getHeight()*this.ctx.pdf.internal.scaleFactor+" 0]")}this.objEnd()}for(e=0;e<t.children.length;e++)n=t.children[e],this.renderItems(n)},o.outline.line=function(t){this.ctx.val+=t+"\r\n"},o.outline.makeRef=function(t){return t.id+" 0 R"},o.outline.makeString=function(t){return"("+o.internal.pdfEscape(t)+")"},o.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},o.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},o.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),
	/**@preserve
	   *  ====================================================================
	   * jsPDF PNG PlugIn
	   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
	   *
	   * 
	   * ====================================================================
	   */
	P=$.API,E=function(){var t="function"==typeof Deflater;if(!t)throw new Error("requires deflate.js for compression");return t},q=function(t,e,n,r){var i=5,o=b;switch(r){case P.image_compression.FAST:i=3,o=v;break;case P.image_compression.MEDIUM:i=6,o=x;break;case P.image_compression.SLOW:i=9,o=S}t=w(t,e,n,o);var a=new Uint8Array(g(i)),s=m(t),h=new Deflater(i),c=h.append(t),l=h.flush(),u=a.length+c.length+l.length,f=new Uint8Array(u+4);return f.set(a),f.set(c,a.length),f.set(l,a.length+c.length),f[u++]=s>>>24&255,f[u++]=s>>>16&255,f[u++]=s>>>8&255,f[u++]=255&s,P.arrayBufferToBinaryString(f)},g=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,[n,255&(r+=31-r%31)]},m=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;0<o;){for(o-=n=e<o?e:o;i+=r+=t[a++],--n;);r%=65521,i%=65521}return(i<<16|r)>>>0},w=function(t,e,n,r){for(var i,o,a,s=t.length/e,h=new Uint8Array(t.length+s),c=k(),l=0;l<s;l++){if(a=l*e,i=t.subarray(a,a+e),r)h.set(r(i,n,o),a+l);else{for(var u=0,f=c.length,d=[];u<f;u++)d[u]=c[u](i,n,o);var p=_(d.concat());h.set(d[p],a+l)}o=i}return h},l=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},v=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},b=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},x=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},S=function(t,e,n){var r,i,o,a,s=[],h=0,c=t.length;for(s[0]=4;h<c;h++)r=t[h-e]||0,i=n&&n[h]||0,o=n&&n[h-e]||0,a=u(r,i,o),s[h+1]=t[h]-a+256&255;return s},u=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},k=function(){return[l,v,b,x,S]},_=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=f(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},f=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},P.processPNG=function(t,e,n,r,i){var o,a,s,h,c,l,u=this.color_spaces.DEVICE_RGB,f=this.decode.FLATE_DECODE,d=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if("function"!=typeof PNG||"function"!=typeof kt)throw new Error("PNG support requires png.js and zlib.js");if(t=(o=new PNG(t)).imgData,d=o.bits,u=o.colorSpace,h=o.colors,-1!==[4,6].indexOf(o.colorType)){if(8===o.bits)for(var p,g=(I=32==o.pixelBitlength?new Uint32Array(o.decodePixels().buffer):16==o.pixelBitlength?new Uint16Array(o.decodePixels().buffer):new Uint8Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*o.colors),w=new Uint8Array(g),y=o.pixelBitlength-o.bits,v=0,b=0;v<g;v++){for(x=I[v],p=0;p<y;)m[b++]=x>>>p&255,p+=o.bits;w[v]=x>>>p&255}if(16===o.bits){g=(I=new Uint32Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*(32/o.pixelBitlength)*o.colors),w=new Uint8Array(g*(32/o.pixelBitlength));for(var x,S=1<o.colors,k=b=v=0;v<g;)x=I[v++],m[b++]=x>>>0&255,S&&(m[b++]=x>>>16&255,x=I[v++],m[b++]=x>>>0&255),w[k++]=x>>>16&255;d=8}r!==P.image_compression.NONE&&E()?(t=q(m,o.width*o.colors,o.colors,r),l=q(w,o.width,1,r)):(t=m,l=w,f=null)}if(3===o.colorType&&(u=this.color_spaces.INDEXED,c=o.palette,o.transparency.indexed)){var _=o.transparency.indexed,A=0;for(v=0,g=_.length;v<g;++v)A+=_[v];if((A/=255)==g-1&&-1!==_.indexOf(0))s=[_.indexOf(0)];else if(A!==g){var I=o.decodePixels();for(w=new Uint8Array(I.length),v=0,g=I.length;v<g;v++)w[v]=_[I[v]];l=q(w,o.width,1)}}var C=function(t){var e;switch(t){case P.image_compression.FAST:e=11;break;case P.image_compression.MEDIUM:e=13;break;case P.image_compression.SLOW:e=14;break;default:e=12}return e}(r);return a=f===this.decode.FLATE_DECODE?"/Predictor "+C+" /Colors "+h+" /BitsPerComponent "+d+" /Columns "+o.width:"/Colors "+h+" /BitsPerComponent "+d+" /Columns "+o.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(l&&this.isArrayBuffer(l)||this.isArrayBufferView(l))&&(l=this.arrayBufferToBinaryString(l)),this.createImageInfo(t,o.width,o.height,u,d,f,e,n,a,s,c,l,C)}throw new Error("Unsupported PNG image data, try using JPEG instead.")},(
	/**
	   * jsPDF gif Support PlugIn
	   * Copyright (c) 2017 Aras Abbasi 
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	A=$.API).processGIF89A=function(t,e,n,r,i){var o=new mt(t),a=o.width,s=o.height,h=[];o.decodeAndBlitFrameRGBA(0,h);var c={data:h,width:a,height:s},l=new yt(100).encode(c,100);return A.processJPEG.call(this,l,e,n,r)},A.processGIF87A=A.processGIF89A,(
	/**
	   * jsPDF bmp Support PlugIn
	   * Copyright (c) 2018 Aras Abbasi 
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	O=$.API).processBMP=function(t,e,n,r,i){var o=new xt(t,!1),a=o.width,s=o.height,h={data:o.getData(),width:a,height:s},c=new yt(100).encode(h,100);return O.processJPEG.call(this,c,e,n,r)},$.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")}),this.internal.languageSettings.isSubscribed=!0)),this},
	/** @preserve
	   * jsPDF split_text_to_size plugin - MIT license.
	   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	   *               2014 Diego Casorran, https://github.com/diegocr
	   */
	B=$.API,R=B.getCharWidthsArray=function(t,e){var n,r,i,o=(e=e||{}).font||this.internal.getFont(),a=e.fontSize||this.internal.getFontSize(),s=e.charSpace||this.internal.getCharSpace(),h=e.widths?e.widths:o.metadata.Unicode.widths,c=h.fof?h.fof:1,l=e.kerning?e.kerning:o.metadata.Unicode.kerning,u=l.fof?l.fof:1,f=0,d=h[0]||c,p=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),"function"==typeof o.metadata.widthOfString?p.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i))+s*(1e3/a)||0)/1e3):p.push((h[i]||d)/c+(l[i]&&l[i][f]||0)/u),f=i;return p},j=B.getArraySum=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},D=B.getStringUnitWidth=function(t,e){var n=(e=e||{}).fontSize||this.internal.getFontSize(),r=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return"function"==typeof r.metadata.widthOfString?r.metadata.widthOfString(t,n,i)/n:j(R.apply(this,arguments))},M=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var h=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(h,o)),s=0,h=o),s+=e[o],o++;return h!==o&&i.push(t.slice(h,o)),i},U=function(t,e,n){n||(n={});var r,i,o,a,s,h,c=[],l=[c],u=n.textIndent||0,f=0,d=0,p=t.split(" "),g=R.apply(this,[" ",n])[0];if(h=-1===n.lineIndent?p[0].length+2:n.lineIndent||0){var m=Array(h).join(" "),w=[];p.map(function(t){1<(t=t.split(/\s*\n/)).length?w=w.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):w.push(t[0])}),p=w,h=D.apply(this,[m,n])}for(o=0,a=p.length;o<a;o++){var y=0;if(r=p[o],h&&"\n"==r[0]&&(r=r.substr(1),y=1),i=R.apply(this,[r,n]),e<u+f+(d=j(i))||y){if(e<d){for(s=M.apply(this,[r,i,e-(u+f),e]),c.push(s.shift()),c=[s.pop()];s.length;)l.push([s.shift()]);d=j(i.slice(r.length-(c[0]?c[0].length:0)))}else c=[r];l.push(c),u=d+h,f=g}else c.push(r),u+=f+d,f=g}if(h)var v=function(t,e){return(e?m:"")+t.join(" ")};else v=function(t){return t.join(" ")};return l.map(v)},B.splitTextToSize=function(t,e,n){var r,i=(n=n||{}).fontSize||this.internal.getFontSize(),o=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle),i="Unicode";return r.metadata[i]?{widths:r.metadata[i].widths||e,kerning:r.metadata[i].kerning||n}:{font:r.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var a=1*this.internal.scaleFactor*e/i;o.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,o.lineIndent=n.lineIndent;var s,h,c=[];for(s=0,h=r.length;s<h;s++)c=c.concat(U.apply(this,[r[s],a,o]));return c},
	/** @preserve 
	  jsPDF standard_fonts_metrics plugin
	  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	  MIT license.
	  */
	N=$.API,L={codePages:["WinAnsiEncoding"],WinAnsiEncoding:(z=function(t){for(var e="klmnopqrstuvwxyz",n={},r=0;r<e.length;r++)n[e[r]]="0123456789abcdef"[r];var i,o,a,s,h,c={},l=1,u=c,f=[],d="",p="",g=t.length-1;for(r=1;r!=g;)h=t[r],r+=1,"'"==h?o?(s=o.join(""),o=i):o=[]:o?o.push(h):"{"==h?(f.push([u,s]),u={},s=i):"}"==h?((a=f.pop())[0][a[1]]=u,s=i,u=a[0]):"-"==h?l=-1:s===i?n.hasOwnProperty(h)?(d+=n[h],s=parseInt(d,16)*l,l=1,d=""):d+=h:n.hasOwnProperty(h)?(p+=n[h],u[s]=parseInt(p,16)*l,l=1,s=i,p=""):p+=h;return c})("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},H={Unicode:{Courier:L,"Courier-Bold":L,"Courier-BoldOblique":L,"Courier-Oblique":L,Helvetica:L,"Helvetica-Bold":L,"Helvetica-BoldOblique":L,"Helvetica-Oblique":L,"Times-Roman":L,"Times-Bold":L,"Times-BoldItalic":L,"Times-Italic":L}
	/** 
	    Resources:
	    Font metrics data is reprocessed derivative of contents of
	    "Font Metrics for PDF Core 14 Fonts" package, which exhibits the following copyright and license:
	    
	    Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated. All Rights Reserved.
	    
	    This file and the 14 PostScript(R) AFM files it accompanies may be used,
	    copied, and distributed for any purpose and without charge, with or without
	    modification, provided that all copyright notices are retained; that the AFM
	    files are not distributed without this file; that all modifications to this
	    file or any of the AFM files are prominently noted in the modified file(s);
	    and that this paragraph is not modified. Adobe Systems has no responsibility
	    or obligation to support the use of the AFM files.
	    
	    */},W={Unicode:{"Courier-Oblique":z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":z("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":z("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:z("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:z("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":z("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":z("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}},N.events.push(["addFont",function(t){var e,n,r,i="Unicode";(e=W[i][t.postScriptName])&&((n=t.metadata[i]?t.metadata[i]:t.metadata[i]={}).widths=e.widths,n.kerning=e.kerning),(r=H[i][t.postScriptName])&&((n=t.metadata[i]?t.metadata[i]:t.metadata[i]={}).encoding=r).codePages&&r.codePages.length&&(t.encoding=r.codePages[0])}]),G=$,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")(),G.API.events.push(["addFont",function(t){G.API.existsFileInVFS(t.postScriptName)?(t.metadata=G.API.TTFFont.open(t.postScriptName,t.fontName,G.API.getFileFromVFS(t.postScriptName),t.encoding),t.metadata.Unicode=t.metadata.Unicode||{encoding:{},kerning:{},widths:[]}):14<t.id.slice(1)&&console.error("Font does not exist in FileInVFS, import fonts or remove declaration doc.addFont('"+t.postScriptName+"').")}]),(
	/** @preserve
	  jsPDF SVG plugin
	  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	  */
	V=$.API).addSvg=function(t,e,n,r,i){if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");function o(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var a,s,h,c,l,u,f,d,p=(c=document,d=c.createElement("iframe"),l=".jsPDF_sillysvg_iframe {display:none;position:absolute;}",(f=(u=c).createElement("style")).type="text/css",f.styleSheet?f.styleSheet.cssText=l:f.appendChild(u.createTextNode(l)),u.getElementsByTagName("head")[0].appendChild(f),d.name="childframe",d.setAttribute("width",0),d.setAttribute("height",0),d.setAttribute("frameborder","0"),d.setAttribute("scrolling","no"),d.setAttribute("seamless","seamless"),d.setAttribute("class","jsPDF_sillysvg_iframe"),c.body.appendChild(d),d),g=(a=t,(h=((s=p).contentWindow||s.contentDocument).document).write(a),h.close(),h.getElementsByTagName("svg")[0]),m=[1,1],w=parseFloat(g.getAttribute("width")),y=parseFloat(g.getAttribute("height"));w&&y&&(r&&i?m=[r/w,i/y]:r?m=[r/w,r/w]:i&&(m=[i/y,i/y]));var v,b,x,S,k=g.childNodes;for(v=0,b=k.length;v<b;v++)(x=k[v]).tagName&&"PATH"===x.tagName.toUpperCase()&&((S=o(x.getAttribute("d").split(" ")))[0]=S[0]*m[0]+e,S[1]=S[1]*m[1]+n,this.lines.call(this,S[2],S[0],S[1],m));return this},V.addSVG=V.addSvg,V.addSvgAsImage=function(t,e,n,r,i,o,a,s){if(isNaN(e)||isNaN(n))throw console.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(r)||isNaN(i))throw console.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var h=document.createElement("canvas");h.width=r,h.height=i;var c=h.getContext("2d");return c.fillStyle="#fff",c.fillRect(0,0,h.width,h.height),canvg(h,t,{ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0,ignoreClear:!0}),this.addImage(h.toDataURL("image/jpeg",1),e,n,r,i,a,s),this},$.API.putTotalPages=function(t){for(var e=new RegExp(t,"g"),n=1;n<=this.internal.getNumberOfPages();n++)for(var r=0;r<this.internal.pages[n].length;r++)this.internal.pages[n][r]=this.internal.pages[n][r].replace(e,this.internal.getNumberOfPages());return this},$.API.viewerPreferences=function(t,e){var n;t=t||{},e=e||!1;var r,i,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},a=Object.keys(o),s=[],h=0,c=0,l=0,u=!0;function f(t,e){var n,r=!1;for(n=0;n<t.length;n+=1)t[n]===e&&(r=!0);return r}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var d=a.length;for(l=0;l<d;l+=1)n[a[l]].value=n[a[l]].defaultValue,n[a[l]].explicitSet=!1}if("object"===(void 0===t?"undefined":vt(t)))for(r in t)if(i=t[r],f(a,r)&&void 0!==i){if("boolean"===n[r].type&&"boolean"==typeof i)n[r].value=i;else if("name"===n[r].type&&f(n[r].valueSet,i))n[r].value=i;else if("integer"===n[r].type&&Number.isInteger(i))n[r].value=i;else if("array"===n[r].type){for(h=0;h<i.length;h+=1)if(u=!0,1===i[h].length&&"number"==typeof i[h][0])s.push(String(i[h]));else if(1<i[h].length){for(c=0;c<i[h].length;c+=1)"number"!=typeof i[h][c]&&(u=!1);!0===u&&s.push(String(i[h].join("-")))}n[r].value=String(s)}else n[r].value=n[r].defaultValue;n[r].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")}),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
	/** ==================================================================== 
	   * jsPDF XMP metadata plugin
	   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
	   * 
	   * 
	   * ====================================================================
	   */
	Y=$.API,K=J=X="",Y.addMetadata=function(t,e){return J=e||"http://jspdf.default.namespaceuri/",X=t,this.internal.events.subscribe("postPutResources",function(){if(X){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+J+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),n=unescape(encodeURIComponent(t)),r=unescape(encodeURIComponent(X)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),o=unescape(encodeURIComponent("</x:xmpmeta>")),a=n.length+r.length+i.length+e.length+o.length;K=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+a+" >>"),this.internal.write("stream"),this.internal.write(e+n+r+i+o),this.internal.write("endstream"),this.internal.write("endobj")}else K=""}),this.internal.events.subscribe("putCatalog",function(){K&&this.internal.write("/Metadata "+K+" 0 R")}),this},function(l,t){var e=l.API,m=[0];e.events.push(["putFont",function(t){!function(t,e,n){if(t.metadata instanceof l.API.TTFFont&&"Identity-H"===t.encoding){for(var r=t.metadata.Unicode.widths,i=t.metadata.subset.encode(m),o="",a=0;a<i.length;a++)o+=String.fromCharCode(i[a]);var s=n();e("<<"),e("/Length "+o.length),e("/Length1 "+o.length),e(">>"),e("stream"),e(o),e("endstream"),e("endobj");var h=n();e("<<"),e("/Type /FontDescriptor"),e("/FontName /"+t.fontName),e("/FontFile2 "+s+" 0 R"),e("/FontBBox "+l.API.PDFObject.convert(t.metadata.bbox)),e("/Flags "+t.metadata.flags),e("/StemV "+t.metadata.stemV),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e(">>"),e("endobj");var c=n();e("<<"),e("/Type /Font"),e("/BaseFont /"+t.fontName),e("/FontDescriptor "+h+" 0 R"),e("/W "+l.API.PDFObject.convert(r)),e("/CIDToGIDMap /Identity"),e("/DW 1000"),e("/Subtype /CIDFontType2"),e("/CIDSystemInfo"),e("<<"),e("/Supplement 0"),e("/Registry (Adobe)"),e("/Ordering ("+t.encoding+")"),e(">>"),e(">>"),e("endobj"),t.objectNumber=n(),e("<<"),e("/Type /Font"),e("/Subtype /Type0"),e("/BaseFont /"+t.fontName),e("/Encoding /"+t.encoding),e("/DescendantFonts ["+c+" 0 R]"),e(">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject)}]);e.events.push(["putFont",function(t){!function(t,e,n){if(t.metadata instanceof l.API.TTFFont&&"WinAnsiEncoding"===t.encoding){t.metadata.Unicode.widths;for(var r=t.metadata.rawData,i="",o=0;o<r.length;o++)i+=String.fromCharCode(r[o]);var a=n();e("<<"),e("/Length "+i.length),e("/Length1 "+i.length),e(">>"),e("stream"),e(i),e("endstream"),e("endobj");var s=n();for(e("<<"),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e("/StemV "+t.metadata.stemV),e("/Type /FontDescriptor"),e("/FontFile2 "+a+" 0 R"),e("/Flags 96"),e("/FontBBox "+l.API.PDFObject.convert(t.metadata.bbox)),e("/FontName /"+t.fontName),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e(">>"),e("endobj"),t.objectNumber=n(),o=0;o<t.metadata.hmtx.widths.length;o++)t.metadata.hmtx.widths[o]=parseInt(t.metadata.hmtx.widths[o]*(1e3/t.metadata.head.unitsPerEm));e("<</Subtype/TrueType/Type/Font/BaseFont/"+t.fontName+"/FontDescriptor "+s+" 0 R/Encoding/"+t.encoding+" /FirstChar 29 /LastChar 255 /Widths "+l.API.PDFObject.convert(t.metadata.hmtx.widths)+">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject)}]);var c=function(t){var e,n,r=t.text||"",i=t.x,o=t.y,a=t.options||{},s=t.mutex||{},h=s.pdfEscape,c=s.activeFontKey,l=s.fonts,u=(s.activeFontSize,""),f=0,d="",p=l[n=c].encoding;if("Identity-H"!==l[n].encoding)return{text:r,x:i,y:o,options:a,mutex:s};for(d=r,n=c,"[object Array]"===Object.prototype.toString.call(r)&&(d=r[0]),f=0;f<d.length;f+=1)l[n].metadata.hasOwnProperty("cmap")&&(e=l[n].metadata.cmap.unicode.codeMap[d[f].charCodeAt(0)]),e?u+=d[f]:d[f].charCodeAt(0)<256&&l[n].metadata.hasOwnProperty("Unicode")?u+=d[f]:u+="";var g="";return parseInt(n.slice(1))<14||"WinAnsiEncoding"===p?g=function(t){for(var e="",n=0;n<t.length;n++)e+=""+t.charCodeAt(n).toString(16);return e}(h(u,n)):"Identity-H"===p&&(g=function(t,e){for(var n,r=e.metadata.Unicode.widths,i=["","0","00","000","0000"],o=[""],a=0,s=t.length;a<s;++a){if(n=e.metadata.characterToGlyph(t.charCodeAt(a)),m.push(n),-1==r.indexOf(n)&&(r.push(n),r.push([parseInt(e.metadata.widthOfGlyph(n),10)])),"0"==n)return o.join("");n=n.toString(16),o.push(i[4-n.length],n)}return o.join("")}(u,l[n])),s.isHex=!0,{text:g,x:i,y:o,options:a,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",n=t.x,r=t.y,i=t.options,o=t.mutex,a=(i.lang,[]),s={text:e,x:n,y:r,options:i,mutex:o};if("[object Array]"===Object.prototype.toString.call(e)){var h=0;for(h=0;h<e.length;h+=1)"[object Array]"===Object.prototype.toString.call(e[h])&&3===e[h].length?a.push([c(Object.assign({},s,{text:e[h][0]})).text,e[h][1],e[h][2]]):a.push(c(Object.assign({},s,{text:e[h]})).text);t.text=a}else t.text=c(Object.assign({},s,{text:e})).text}])}($,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")()),Q=$.API,Z={},Q.existsFileInVFS=function(t){return Z.hasOwnProperty(t)},Q.addFileToVFS=function(t,e){return Z[t]=e,this},Q.getFileFromVFS=function(t){return Z.hasOwnProperty(t)?Z[t]:null},function(t){if(t.URL=t.URL||t.webkitURL,t.Blob&&t.URL)try{return new Blob}catch(t){}var s=t.BlobBuilder||t.WebKitBlobBuilder||t.MozBlobBuilder||function(t){var s=function(t){return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1]},e=function(){this.data=[]},h=function(t,e,n){this.data=t,this.size=t.length,this.type=e,this.encoding=n},n=e.prototype,r=h.prototype,c=t.FileReaderSync,l=function(t){this.code=this[this.name=t]},i="NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "),o=i.length,a=t.URL||t.webkitURL||t,u=a.createObjectURL,f=a.revokeObjectURL,d=a,p=t.btoa,g=t.atob,m=t.ArrayBuffer,w=t.Uint8Array,y=/^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;for(h.fake=r.fake=!0;o--;)l.prototype[i[o]]=o+1;return a.createObjectURL||(d=t.URL=function(t){var e,n=document.createElementNS("http://www.w3.org/1999/xhtml","a");return n.href=t,"origin"in n||("data:"===n.protocol.toLowerCase()?n.origin=null:(e=t.match(y),n.origin=e&&e[1])),n}),d.createObjectURL=function(t){var e,n=t.type;return null===n&&(n="application/octet-stream"),t instanceof h?(e="data:"+n,"base64"===t.encoding?e+";base64,"+t.data:"URI"===t.encoding?e+","+decodeURIComponent(t.data):p?e+";base64,"+p(t.data):e+","+encodeURIComponent(t.data)):u?u.call(a,t):void 0},d.revokeObjectURL=function(t){"data:"!==t.substring(0,5)&&f&&f.call(a,t)},n.append=function(t){var e=this.data;if(w&&(t instanceof m||t instanceof w)){for(var n="",r=new w(t),i=0,o=r.length;i<o;i++)n+=String.fromCharCode(r[i]);e.push(n)}else if("Blob"===s(t)||"File"===s(t)){if(!c)throw new l("NOT_READABLE_ERR");var a=new c;e.push(a.readAsBinaryString(t))}else t instanceof h?"base64"===t.encoding&&g?e.push(g(t.data)):"URI"===t.encoding?e.push(decodeURIComponent(t.data)):"raw"===t.encoding&&e.push(t.data):("string"!=typeof t&&(t+=""),e.push(unescape(encodeURIComponent(t))))},n.getBlob=function(t){return arguments.length||(t=null),new h(this.data.join(""),t,"raw")},n.toString=function(){return"[object BlobBuilder]"},r.slice=function(t,e,n){var r=arguments.length;return r<3&&(n=null),new h(this.data.slice(t,1<r?e:this.data.length),n,this.encoding)},r.toString=function(){return"[object Blob]"},r.close=function(){this.size=0,delete this.data},e}(t);t.Blob=function(t,e){var n=e&&e.type||"",r=new s;if(t)for(var i=0,o=t.length;i<o;i++)Uint8Array&&t[i]instanceof Uint8Array?r.append(t[i].buffer):r.append(t[i]);var a=r.getBlob(n);return!a.slice&&a.webkitSlice&&(a.slice=a.webkitSlice),a};var e=Object.getPrototypeOf||function(t){return t.__proto__};t.Blob.prototype=e(new t.Blob)}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||window.content||window);var tt,et,nt,rt,it,ot,at,st,ht,ct,lt,ut,ft,dt,pt,gt,bt=bt||function(s){if(!(void 0===s||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var t=s.document,h=function(){return s.URL||s.webkitURL||s},c=t.createElementNS("http://www.w3.org/1999/xhtml","a"),l="download"in c,u=/constructor/i.test(s.HTMLElement)||s.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),d=function(t){(s.setImmediate||s.setTimeout)(function(){throw t},0)},p=function(t){setTimeout(function(){"string"==typeof t?h().revokeObjectURL(t):t.remove()},4e4)},g=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},r=function(t,n,e){e||(t=g(t));var r,i=this,o="application/octet-stream"===t.type,a=function(){!function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){d(t)}}}(i,"writestart progress write writeend".split(" "))};if(i.readyState=i.INIT,l)return r=h().createObjectURL(t),void setTimeout(function(){var t,e;c.href=r,c.download=n,t=c,e=new MouseEvent("click"),t.dispatchEvent(e),a(),p(r),i.readyState=i.DONE});!function(){if((f||o&&u)&&s.FileReader){var e=new FileReader;return e.onloadend=function(){var t=f?e.result:e.result.replace(/^data:[^;]*;/,"data:attachment/file;");s.open(t,"_blank")||(s.location.href=t),t=void 0,i.readyState=i.DONE,a()},e.readAsDataURL(t),i.readyState=i.INIT}r||(r=h().createObjectURL(t)),o?s.location.href=r:s.open(r,"_blank")||(s.location.href=r);i.readyState=i.DONE,a(),p(r)}()},e=r.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=g(t)),navigator.msSaveOrOpenBlob(t,e)}:(e.abort=function(){},e.readyState=e.INIT=0,e.WRITING=1,e.DONE=2,e.error=e.onwritestart=e.onprogress=e.onwrite=e.onabort=e.onerror=e.onwriteend=null,function(t,e,n){return new r(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||window.content);function mt(x){var t=0;if(71!==x[t++]||73!==x[t++]||70!==x[t++]||56!==x[t++]||56!=(x[t++]+1&253)||97!==x[t++])throw"Invalid GIF 87a/89a header.";var S=x[t++]|x[t++]<<8,e=x[t++]|x[t++]<<8,n=x[t++],r=n>>7,i=1<<(7&n)+1;x[t++];x[t++];var o=null;r&&(o=t,t+=3*i);var a=!0,s=[],h=0,c=null,l=0,u=null;for(this.width=S,this.height=e;a&&t<x.length;)switch(x[t++]){case 33:switch(x[t++]){case 255:if(11!==x[t]||78==x[t+1]&&69==x[t+2]&&84==x[t+3]&&83==x[t+4]&&67==x[t+5]&&65==x[t+6]&&80==x[t+7]&&69==x[t+8]&&50==x[t+9]&&46==x[t+10]&&48==x[t+11]&&3==x[t+12]&&1==x[t+13]&&0==x[t+16])t+=14,u=x[t++]|x[t++]<<8,t++;else for(t+=12;;){if(0===(_=x[t++]))break;t+=_}break;case 249:if(4!==x[t++]||0!==x[t+4])throw"Invalid graphics extension block.";var f=x[t++];h=x[t++]|x[t++]<<8,c=x[t++],0==(1&f)&&(c=null),l=f>>2&7,t++;break;case 254:for(;;){if(0===(_=x[t++]))break;t+=_}break;default:throw"Unknown graphic control label: 0x"+x[t-1].toString(16)}break;case 44:var d=x[t++]|x[t++]<<8,p=x[t++]|x[t++]<<8,g=x[t++]|x[t++]<<8,m=x[t++]|x[t++]<<8,w=x[t++],y=w>>6&1,v=o,b=!1;if(w>>7){b=!0;v=t,t+=3*(1<<(7&w)+1)}var k=t;for(t++;;){var _;if(0===(_=x[t++]))break;t+=_}s.push({x:d,y:p,width:g,height:m,has_local_palette:b,palette_offset:v,data_offset:k,data_length:t-k,transparent_index:c,interlaced:!!y,delay:h,disposal:l});break;case 59:a=!1;break;default:throw"Unknown gif block: 0x"+x[t-1].toString(16)}this.numFrames=function(){return s.length},this.loopCount=function(){return u},this.frameInfo=function(t){if(t<0||t>=s.length)throw"Frame index out of range.";return s[t]},this.decodeAndBlitFrameBGRA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);wt(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,h=S-s,c=s,l=4*(n.y*S+n.x),u=4*((n.y+n.height)*S+n.x),f=l,d=4*h;!0===n.interlaced&&(d+=4*(s+h)*7);for(var p=8,g=0,m=i.length;g<m;++g){var w=i[g];if(0===c&&(c=s,u<=(f+=d)&&(d=h+4*(s+h)*(p-1),f=l+(s+h)*(p<<1),p>>=1)),w===a)f+=4;else{var y=x[o+3*w],v=x[o+3*w+1],b=x[o+3*w+2];e[f++]=b,e[f++]=v,e[f++]=y,e[f++]=255}--c}},this.decodeAndBlitFrameRGBA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);wt(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,h=S-s,c=s,l=4*(n.y*S+n.x),u=4*((n.y+n.height)*S+n.x),f=l,d=4*h;!0===n.interlaced&&(d+=4*(s+h)*7);for(var p=8,g=0,m=i.length;g<m;++g){var w=i[g];if(0===c&&(c=s,u<=(f+=d)&&(d=h+4*(s+h)*(p-1),f=l+(s+h)*(p<<1),p>>=1)),w===a)f+=4;else{var y=x[o+3*w],v=x[o+3*w+1],b=x[o+3*w+2];e[f++]=y,e[f++]=v,e[f++]=b,e[f++]=255}--c}}}function wt(t,e,n,r){for(var i=t[e++],o=1<<i,a=o+1,s=a+1,h=i+1,c=(1<<h)-1,l=0,u=0,f=0,d=t[e++],p=new Int32Array(4096),g=null;;){for(;l<16&&0!==d;)u|=t[e++]<<l,l+=8,1===d?d=t[e++]:--d;if(l<h)break;var m=u&c;if(u>>=h,l-=h,m!==o){if(m===a)break;for(var w=m<s?m:g,y=0,v=w;o<v;)v=p[v]>>8,++y;var b=v;if(r<f+y+(w!==m?1:0))return void console.log("Warning, gif stream longer than expected.");n[f++]=b;var x=f+=y;for(w!==m&&(n[f++]=b),v=w;y--;)v=p[v],n[--x]=255&v,v>>=8;null!==g&&s<4096&&(p[s++]=g<<8|b,c+1<=s&&h<12&&(++h,c=c<<1|1)),g=m}else s=a+1,c=(1<<(h=i+1))-1,g=null}return f!==r&&console.log("Warning, gif stream shorter than expected."),n}"undefined"!=typeof module&&module.exports?module.exports.saveAs=bt:"undefined"!="function"&&null!==__webpack_require__(614)&&null!==__webpack_require__(615)&&!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return bt}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	/*
	   * Copyright (c) 2012 chick307 <chick307@gmail.com>
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */,$.API.adler32cs=(ot="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,at=null,st=function(){if(!ot)return function(){return!1};try{var t={};"function"==typeof t.Buffer&&(at=t.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==at&&t instanceof at}}(),ht=null!==at?function(t){return new at(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},ct=65521,lt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+(255&e.charCodeAt(i)))%ct,r=(r+n)%ct;return(r<<16|n)>>>0},ut=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+e[i])%ct,r=(r+n)%ct;return(r<<16|n)>>>0},dt=(ft={}).Adler32=(((it=(rt=function(t){if(!(this instanceof rt))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0}).prototype={}).constructor=rt).from=((tt=function(t){if(!(this instanceof rt))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=lt(1,t.toString())}).prototype=it,tt),rt.fromUtf8=((et=function(t){if(!(this instanceof rt))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var e=ht(t.toString());this.checksum=lt(1,e)}).prototype=it,et),ot&&(rt.fromBuffer=((nt=function(t){if(!(this instanceof rt))throw new TypeError("Constructor cannot called be as a function.");if(!st(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=ut(1,e)}).prototype=it,nt)),it.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=lt(this.checksum,t)},it.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=ht(t.toString());return this.checksum=lt(this.checksum,e)},ot&&(it.updateBuffer=function(t){if(!st(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=ut(this.checksum,e)}),it.clone=function(){return new dt(this.checksum)},rt),ft.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return lt(1,t.toString())},ft.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=ht(t.toString());return lt(1,e)},ot&&(ft.fromBuffer=function(t){if(!st(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return ut(1,e)}),ft);try{exports.GifWriter=function(w,t,e,n){var y=0,r=void 0===(n=void 0===n?{}:n).loop?null:n.loop,v=void 0===n.palette?null:n.palette;if(t<=0||e<=0||65535<t||65535<e)throw"Width/Height invalid.";function b(t){var e=t.length;if(e<2||256<e||e&e-1)throw"Invalid code/color length, must be power of 2 and 2 .. 256.";return e}w[y++]=71,w[y++]=73,w[y++]=70,w[y++]=56,w[y++]=57,w[y++]=97;var i=0,o=0;if(null!==v){for(var a=b(v);a>>=1;)++i;if(a=1<<i,--i,void 0!==n.background){if(a<=(o=n.background))throw"Background index out of range.";if(0===o)throw"Background index explicitly passed as 0."}}if(w[y++]=255&t,w[y++]=t>>8&255,w[y++]=255&e,w[y++]=e>>8&255,w[y++]=(null!==v?128:0)|i,w[y++]=o,w[y++]=0,null!==v)for(var s=0,h=v.length;s<h;++s){var c=v[s];w[y++]=c>>16&255,w[y++]=c>>8&255,w[y++]=255&c}if(null!==r){if(r<0||65535<r)throw"Loop count invalid.";w[y++]=33,w[y++]=255,w[y++]=11,w[y++]=78,w[y++]=69,w[y++]=84,w[y++]=83,w[y++]=67,w[y++]=65,w[y++]=80,w[y++]=69,w[y++]=50,w[y++]=46,w[y++]=48,w[y++]=3,w[y++]=1,w[y++]=255&r,w[y++]=r>>8&255,w[y++]=0}var x=!1;this.addFrame=function(t,e,n,r,i,o){if(!0===x&&(--y,x=!1),o=void 0===o?{}:o,t<0||e<0||65535<t||65535<e)throw"x/y invalid.";if(n<=0||r<=0||65535<n||65535<r)throw"Width/Height invalid.";if(i.length<n*r)throw"Not enough pixels for the frame size.";var a=!0,s=o.palette;if(null==s&&(a=!1,s=v),null==s)throw"Must supply either a local or global palette.";for(var h=b(s),c=0;h>>=1;)++c;h=1<<c;var l=void 0===o.delay?0:o.delay,u=void 0===o.disposal?0:o.disposal;if(u<0||3<u)throw"Disposal out of range.";var f=!1,d=0;if(void 0!==o.transparent&&null!==o.transparent&&(f=!0,(d=o.transparent)<0||h<=d))throw"Transparent color index.";if((0!==u||f||0!==l)&&(w[y++]=33,w[y++]=249,w[y++]=4,w[y++]=u<<2|(!0===f?1:0),w[y++]=255&l,w[y++]=l>>8&255,w[y++]=d,w[y++]=0),w[y++]=44,w[y++]=255&t,w[y++]=t>>8&255,w[y++]=255&e,w[y++]=e>>8&255,w[y++]=255&n,w[y++]=n>>8&255,w[y++]=255&r,w[y++]=r>>8&255,w[y++]=!0===a?128|c-1:0,!0===a)for(var p=0,g=s.length;p<g;++p){var m=s[p];w[y++]=m>>16&255,w[y++]=m>>8&255,w[y++]=255&m}y=function(e,n,t,r){e[n++]=t;var i=n++,o=1<<t,a=o-1,s=o+1,h=s+1,c=t+1,l=0,u=0;function f(t){for(;t<=l;)e[n++]=255&u,u>>=8,l-=8,n===i+256&&(e[i]=255,i=n++)}function d(t){u|=t<<l,l+=c,f(8)}var p=r[0]&a,g={};d(o);for(var m=1,w=r.length;m<w;++m){var y=r[m]&a,v=p<<8|y,b=g[v];if(void 0===b){for(u|=p<<l,l+=c;8<=l;)e[n++]=255&u,u>>=8,l-=8,n===i+256&&(e[i]=255,i=n++);4096===h?(d(o),h=s+1,c=t+1,g={}):(1<<c<=h&&++c,g[v]=h++),p=y}else p=b}return d(p),d(s),f(1),i+1===n?e[i]=0:(e[i]=n-i-1,e[n++]=0),n}(w,y,c<2?2:c,i)},this.end=function(){return!1===x&&(w[y++]=59,x=!0),y}},exports.GifReader=mt}catch(t){}
	/*
	    Copyright (c) 2008, Adobe Systems Incorporated
	    All rights reserved.
	
	    Redistribution and use in source and binary forms, with or without 
	    modification, are permitted provided that the following conditions are
	    met:
	
	    * Redistributions of source code must retain the above copyright notice, 
	      this list of conditions and the following disclaimer.
	    
	    * Redistributions in binary form must reproduce the above copyright
	      notice, this list of conditions and the following disclaimer in the 
	      documentation and/or other materials provided with the distribution.
	    
	    * Neither the name of Adobe Systems Incorporated nor the names of its 
	      contributors may be used to endorse or promote products derived from 
	      this software without specific prior written permission.
	
	    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
	    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
	    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
	    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
	    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
	    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	  */function yt(t){var S,k,_,A,e,u=Math.floor,I=new Array(64),C=new Array(64),T=new Array(64),F=new Array(64),w=new Array(65535),y=new Array(65535),Q=new Array(64),v=new Array(64),P=[],E=0,q=7,O=new Array(64),B=new Array(64),R=new Array(64),n=new Array(256),j=new Array(2048),b=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],D=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],M=[0,1,2,3,4,5,6,7,8,9,10,11],U=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],N=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],z=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],L=[0,1,2,3,4,5,6,7,8,9,10,11],H=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],W=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function r(t,e){for(var n=0,r=0,i=new Array,o=1;o<=16;o++){for(var a=1;a<=t[o];a++)i[e[r]]=[],i[e[r]][0]=n,i[e[r]][1]=o,r++,n++;n*=2}return i}function G(t){for(var e=t[0],n=t[1]-1;0<=n;)e&1<<n&&(E|=1<<q),n--,--q<0&&(255==E?(V(255),V(0)):V(E),q=7,E=0)}function V(t){P.push(t)}function Y(t){V(t>>8&255),V(255&t)}function X(t,e,n,r,i){for(var o,a=i[0],s=i[240],h=function(t,e){var n,r,i,o,a,s,h,c,l,u,f=0;for(l=0;l<8;++l){n=t[f],r=t[f+1],i=t[f+2],o=t[f+3],a=t[f+4],s=t[f+5],h=t[f+6];var d=n+(c=t[f+7]),p=n-c,g=r+h,m=r-h,w=i+s,y=i-s,v=o+a,b=o-a,x=d+v,S=d-v,k=g+w,_=g-w;t[f]=x+k,t[f+4]=x-k;var A=.707106781*(_+S);t[f+2]=S+A,t[f+6]=S-A;var I=.382683433*((x=b+y)-(_=m+p)),C=.5411961*x+I,T=1.306562965*_+I,F=.707106781*(k=y+m),P=p+F,E=p-F;t[f+5]=E+C,t[f+3]=E-C,t[f+1]=P+T,t[f+7]=P-T,f+=8}for(l=f=0;l<8;++l){n=t[f],r=t[f+8],i=t[f+16],o=t[f+24],a=t[f+32],s=t[f+40],h=t[f+48];var q=n+(c=t[f+56]),O=n-c,B=r+h,R=r-h,j=i+s,D=i-s,M=o+a,U=o-a,N=q+M,z=q-M,L=B+j,H=B-j;t[f]=N+L,t[f+32]=N-L;var W=.707106781*(H+z);t[f+16]=z+W,t[f+48]=z-W;var G=.382683433*((N=U+D)-(H=R+O)),V=.5411961*N+G,Y=1.306562965*H+G,X=.707106781*(L=D+R),J=O+X,K=O-X;t[f+40]=K+V,t[f+24]=K-V,t[f+8]=J+Y,t[f+56]=J-Y,f++}for(l=0;l<64;++l)u=t[l]*e[l],Q[l]=0<u?u+.5|0:u-.5|0;return Q}(t,e),c=0;c<64;++c)v[b[c]]=h[c];var l=v[0]-n;n=v[0],0==l?G(r[0]):(G(r[y[o=32767+l]]),G(w[o]));for(var u=63;0<u&&0==v[u];u--);if(0==u)return G(a),n;for(var f,d=1;d<=u;){for(var p=d;0==v[d]&&d<=u;++d);var g=d-p;if(16<=g){f=g>>4;for(var m=1;m<=f;++m)G(s);g&=15}o=32767+v[d],G(i[(g<<4)+y[o]]),G(w[o]),d++}return 63!=u&&G(a),n}function J(t){if(t<=0&&(t=1),100<t&&(t=100),e!=t){(function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],n=0;n<64;n++){var r=u((e[n]*t+50)/100);r<1?r=1:255<r&&(r=255),I[b[n]]=r}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],o=0;o<64;o++){var a=u((i[o]*t+50)/100);a<1?a=1:255<a&&(a=255),C[b[o]]=a}for(var s=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],h=0,c=0;c<8;c++)for(var l=0;l<8;l++)T[h]=1/(I[b[h]]*s[c]*s[l]*8),F[h]=1/(C[b[h]]*s[c]*s[l]*8),h++})(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),e=t}}this.encode=function(t,e){var n,r;(new Date).getTime();e&&J(e),P=new Array,E=0,q=7,Y(65496),Y(65504),Y(16),V(74),V(70),V(73),V(70),V(0),V(1),V(1),V(0),Y(1),Y(1),V(0),V(0),function(){Y(65499),Y(132),V(0);for(var t=0;t<64;t++)V(I[t]);V(1);for(var e=0;e<64;e++)V(C[e])}(),n=t.width,r=t.height,Y(65472),Y(17),V(8),Y(r),Y(n),V(3),V(1),V(17),V(0),V(2),V(17),V(1),V(3),V(17),V(1),function(){Y(65476),Y(418),V(0);for(var t=0;t<16;t++)V(D[t+1]);for(var e=0;e<=11;e++)V(M[e]);V(16);for(var n=0;n<16;n++)V(U[n+1]);for(var r=0;r<=161;r++)V(N[r]);V(1);for(var i=0;i<16;i++)V(z[i+1]);for(var o=0;o<=11;o++)V(L[o]);V(17);for(var a=0;a<16;a++)V(H[a+1]);for(var s=0;s<=161;s++)V(W[s])}(),Y(65498),Y(12),V(3),V(1),V(0),V(2),V(17),V(3),V(17),V(0),V(63),V(0);var i=0,o=0,a=0;E=0,q=7,this.encode.displayName="_encode_";for(var s,h,c,l,u,f,d,p,g,m=t.data,w=t.width,y=t.height,v=4*w,b=0;b<y;){for(s=0;s<v;){for(f=u=v*b+s,d=-1,g=p=0;g<64;g++)f=u+(p=g>>3)*v+(d=4*(7&g)),y<=b+p&&(f-=v*(b+1+p-y)),v<=s+d&&(f-=s+d-v+4),h=m[f++],c=m[f++],l=m[f++],O[g]=(j[h]+j[c+256>>0]+j[l+512>>0]>>16)-128,B[g]=(j[h+768>>0]+j[c+1024>>0]+j[l+1280>>0]>>16)-128,R[g]=(j[h+1280>>0]+j[c+1536>>0]+j[l+1792>>0]>>16)-128;i=X(O,T,i,S,_),o=X(B,F,o,k,A),a=X(R,F,a,k,A),s+=32}b+=8}if(0<=q){var x=[];x[1]=q+1,x[0]=(1<<q+1)-1,G(x)}return Y(65497),new Uint8Array(P)},function(){(new Date).getTime();t||(t=50),function(){for(var t=String.fromCharCode,e=0;e<256;e++)n[e]=t(e)}(),S=r(D,M),k=r(z,L),_=r(U,N),A=r(H,W),function(){for(var t=1,e=2,n=1;n<=15;n++){for(var r=t;r<e;r++)y[32767+r]=n,w[32767+r]=[],w[32767+r][1]=n,w[32767+r][0]=r;for(var i=-(e-1);i<=-t;i++)y[32767+i]=n,w[32767+i]=[],w[32767+i][1]=n,w[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)j[t]=19595*t,j[t+256>>0]=38470*t,j[t+512>>0]=7471*t+32768,j[t+768>>0]=-11059*t,j[t+1024>>0]=-21709*t,j[t+1280>>0]=32768*t+8421375,j[t+1536>>0]=-27439*t,j[t+1792>>0]=-5329*t}(),J(t),(new Date).getTime()}()}try{module.exports=yt}catch(t){}function xt(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}xt.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var n=this.datav.getUint8(this.pos++,!0),r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:r,blue:n,quad:o}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},xt.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){console.log("bit decode error:"+t)}},xt.prototype.bit1=function(){var t=Math.ceil(this.width/8),e=t%4,n=0<=this.height?this.height-1:-this.height;for(n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++)for(var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var h=this.palette[o>>7-s&1];this.data[a+4*s]=h.blue,this.data[a+4*s+1]=h.green,this.data[a+4*s+2]=h.red,this.data[a+4*s+3]=255}0!=e&&(this.pos+=4-e)}},xt.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++){var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+2*i*4,s=o>>4,h=15&o,c=this.palette[s];if(this.data[a]=c.blue,this.data[a+1]=c.green,this.data[a+2]=c.red,this.data[a+3]=255,2*i+1>=this.width)break;c=this.palette[h],this.data[a+4]=c.blue,this.data[a+4+1]=c.green,this.data[a+4+2]=c.red,this.data[a+4+3]=255}0!=e&&(this.pos+=4-e)}},xt.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;0<=e;e--){for(var n=this.bottom_up?e:this.height-1-e,r=0;r<this.width;r++){var i=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+4*r;if(i<this.palette.length){var a=this.palette[i];this.data[o]=a.red,this.data[o+1]=a.green,this.data[o+2]=a.blue,this.data[o+3]=255}else this.data[o]=255,this.data[o+1]=255,this.data[o+2]=255,this.data[o+3]=255}0!=t&&(this.pos+=4-t)}},xt.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<this.width;i++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var a=(o&e)/e*255|0,s=(o>>5&e)/e*255|0,h=(o>>10&e)/e*255|0,c=o>>15?255:0,l=r*this.width*4+4*i;this.data[l]=h,this.data[l+1]=s,this.data[l+2]=a,this.data[l+3]=c}this.pos+=t}},xt.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),n=parseInt("111111",2),r=this.height-1;0<=r;r--){for(var i=this.bottom_up?r:this.height-1-r,o=0;o<this.width;o++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(a&e)/e*255|0,h=(a>>5&n)/n*255|0,c=(a>>11)/e*255|0,l=i*this.width*4+4*o;this.data[l]=c,this.data[l+1]=h,this.data[l+2]=s,this.data[l+3]=255}this.pos+=t}},xt.prototype.bit24=function(){for(var t=this.height-1;0<=t;t--){for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=e*this.width*4+4*n;this.data[a]=o,this.data[a+1]=i,this.data[a+2]=r,this.data[a+3]=255}this.pos+=this.width%4}},xt.prototype.bit32=function(){for(var t=this.height-1;0<=t;t--)for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*n;this.data[s]=o,this.data[s+1]=i,this.data[s+2]=r,this.data[s+3]=a}},xt.prototype.getData=function(){return this.data};try{module.exports=function(t){var e=new xt(t);return{data:e.getData(),width:e.width,height:e.height}}}catch(t){}
	/*
	   Copyright (c) 2013 Gildas Lormeau. All rights reserved.
	
	   Redistribution and use in source and binary forms, with or without
	   modification, are permitted provided that the following conditions are met:
	
	   1. Redistributions of source code must retain the above copyright notice,
	   this list of conditions and the following disclaimer.
	
	   2. Redistributions in binary form must reproduce the above copyright 
	   notice, this list of conditions and the following disclaimer in 
	   the documentation and/or other materials provided with the distribution.
	
	   3. The names of the authors may not be used to endorse or promote products
	   derived from this software without specific prior written permission.
	
	   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
	   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
	   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
	   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
	   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
	   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	   */
	/*
	   Copyright (c) 2013 Gildas Lormeau. All rights reserved.
	
	   Redistribution and use in source and binary forms, with or without
	   modification, are permitted provided that the following conditions are met:
	
	   1. Redistributions of source code must retain the above copyright notice,
	   this list of conditions and the following disclaimer.
	
	   2. Redistributions in binary form must reproduce the above copyright 
	   notice, this list of conditions and the following disclaimer in 
	   the documentation and/or other materials provided with the distribution.
	
	   3. The names of the authors may not be used to endorse or promote products
	   derived from this software without specific prior written permission.
	
	   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
	   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
	   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
	   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
	   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
	   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	   */
	!function(t){var p=15,g=573,e=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function ut(){var d=this;function h(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,0<--e;);return n>>>1}d.build_tree=function(t){var e,n,r,i=d.dyn_tree,o=d.stat_desc.static_tree,a=d.stat_desc.elems,s=-1;for(t.heap_len=0,t.heap_max=g,e=0;e<a;e++)0!==i[2*e]?(t.heap[++t.heap_len]=s=e,t.depth[e]=0):i[2*e+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=s<2?++s:0)]=1,t.depth[r]=0,t.opt_len--,o&&(t.static_len-=o[2*r+1]);for(d.max_code=s,e=Math.floor(t.heap_len/2);1<=e;e--)t.pqdownheap(i,e);for(r=a;e=t.heap[1],t.heap[1]=t.heap[t.heap_len--],t.pqdownheap(i,1),n=t.heap[1],t.heap[--t.heap_max]=e,t.heap[--t.heap_max]=n,i[2*r]=i[2*e]+i[2*n],t.depth[r]=Math.max(t.depth[e],t.depth[n])+1,i[2*e+1]=i[2*n+1]=r,t.heap[1]=r++,t.pqdownheap(i,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t){var e,n,r,i,o,a,s=d.dyn_tree,h=d.stat_desc.static_tree,c=d.stat_desc.extra_bits,l=d.stat_desc.extra_base,u=d.stat_desc.max_length,f=0;for(i=0;i<=p;i++)t.bl_count[i]=0;for(s[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<g;e++)u<(i=s[2*s[2*(n=t.heap[e])+1]+1]+1)&&(i=u,f++),s[2*n+1]=i,n>d.max_code||(t.bl_count[i]++,o=0,l<=n&&(o=c[n-l]),a=s[2*n],t.opt_len+=a*(i+o),h&&(t.static_len+=a*(h[2*n+1]+o)));if(0!==f){do{for(i=u-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[u]--,f-=2}while(0<f);for(i=u;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--e])>d.max_code||(s[2*r+1]!=i&&(t.opt_len+=(i-s[2*r+1])*s[2*r],s[2*r+1]=i),n--)}}(t),function(t,e,n){var r,i,o,a=[],s=0;for(r=1;r<=p;r++)a[r]=s=s+n[r-1]<<1;for(i=0;i<=e;i++)0!==(o=t[2*i+1])&&(t[2*i]=h(a[o]++,o))}(i,d.max_code,t.bl_count)}}function ft(t,e,n,r,i){var o=this;o.static_tree=t,o.extra_bits=e,o.extra_base=n,o.elems=r,o.max_length=i}ut._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],ut.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],ut.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],ut.d_code=function(t){return t<256?e[t]:e[256+(t>>>7)]},ut.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],ut.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],ut.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],ut.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],ft.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],ft.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],ft.static_l_desc=new ft(ft.static_ltree,ut.extra_lbits,257,286,p),ft.static_d_desc=new ft(ft.static_dtree,ut.extra_dbits,0,30,p),ft.static_bl_desc=new ft(null,ut.extra_blbits,0,19,7);function n(t,e,n,r,i){var o=this;o.good_length=t,o.max_lazy=e,o.nice_length=n,o.max_chain=r,o.func=i}var dt=[new n(0,0,0,0,0),new n(4,4,8,4,1),new n(4,5,16,8,1),new n(4,6,32,32,1),new n(4,4,16,16,2),new n(8,16,32,32,2),new n(8,16,128,128,2),new n(8,32,128,256,2),new n(32,128,258,1024,2),new n(32,258,258,4096,2)],pt=["need dictionary","stream end","","","stream error","data error","","buffer error","",""],gt=262;function mt(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function r(){var h,c,l,u,f,d,p,g,i,m,w,y,v,a,b,x,S,k,_,A,I,C,T,F,P,E,q,O,B,R,s,j,D,M,U,N,z,o,L,H,W,G=this,V=new ut,Y=new ut,X=new ut;function J(){var t;for(t=0;t<286;t++)s[2*t]=0;for(t=0;t<30;t++)j[2*t]=0;for(t=0;t<19;t++)D[2*t]=0;s[512]=1,G.opt_len=G.static_len=0,N=o=0}function K(t,e){var n,r,i=-1,o=t[1],a=0,s=7,h=4;for(0===o&&(s=138,h=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<h?D[2*r]+=a:0!==r?(r!=i&&D[2*r]++,D[32]++):a<=10?D[34]++:D[36]++,i=r,(a=0)===o?(s=138,h=3):r==o?(s=6,h=3):(s=7,h=4))}function Q(t){G.pending_buf[G.pending++]=t}function Z(t){Q(255&t),Q(t>>>8&255)}function $(t,e){var n,r=e;16-r<W?(Z(H|=(n=t)<<W&65535),H=n>>>16-W,W+=r-16):(H|=t<<W&65535,W+=r)}function tt(t,e){var n=2*t;$(65535&e[n],65535&e[n+1])}function et(t,e){var n,r,i=-1,o=t[1],a=0,s=7,h=4;for(0===o&&(s=138,h=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<h)for(;tt(r,D),0!=--a;);else 0!==r?(r!=i&&(tt(r,D),a--),tt(16,D),$(a-3,2)):a<=10?(tt(17,D),$(a-3,3)):(tt(18,D),$(a-11,7));i=r,(a=0)===o?(s=138,h=3):r==o?(s=6,h=3):(s=7,h=4)}}function nt(){16==W?(Z(H),W=H=0):8<=W&&(Q(255&H),H>>>=8,W-=8)}function rt(t,e){var n,r,i;if(G.pending_buf[z+2*N]=t>>>8&255,G.pending_buf[z+2*N+1]=255&t,G.pending_buf[M+N]=255&e,N++,0===t?s[2*e]++:(o++,t--,s[2*(ut._length_code[e]+256+1)]++,j[2*ut.d_code(t)]++),0==(8191&N)&&2<q){for(n=8*N,r=I-S,i=0;i<30;i++)n+=j[2*i]*(5+ut.extra_dbits[i]);if(n>>>=3,o<Math.floor(N/2)&&n<Math.floor(r/2))return!0}return N==U-1}function it(t,e){var n,r,i,o,a=0;if(0!==N)for(;n=G.pending_buf[z+2*a]<<8&65280|255&G.pending_buf[z+2*a+1],r=255&G.pending_buf[M+a],a++,0===n?tt(r,t):(tt((i=ut._length_code[r])+256+1,t),0!==(o=ut.extra_lbits[i])&&$(r-=ut.base_length[i],o),tt(i=ut.d_code(--n),e),0!==(o=ut.extra_dbits[i])&&$(n-=ut.base_dist[i],o)),a<N;);tt(256,t),L=t[513]}function ot(){8<W?Z(H):0<W&&Q(255&H),W=H=0}function at(t,e,n){var r,i,o;$(0+(n?1:0),3),r=t,i=e,o=!0,ot(),L=8,o&&(Z(i),Z(~i)),G.pending_buf.set(g.subarray(r,r+i),G.pending),G.pending+=i}function e(t,e,n){var r,i,o=0;0<q?(V.build_tree(G),Y.build_tree(G),o=function(){var t;for(K(s,V.max_code),K(j,Y.max_code),X.build_tree(G),t=18;3<=t&&0===D[2*ut.bl_order[t]+1];t--);return G.opt_len+=3*(t+1)+5+5+4,t}(),r=G.opt_len+3+7>>>3,(i=G.static_len+3+7>>>3)<=r&&(r=i)):r=i=e+5,e+4<=r&&-1!=t?at(t,e,n):i==r?($(2+(n?1:0),3),it(ft.static_ltree,ft.static_dtree)):($(4+(n?1:0),3),function(t,e,n){var r;for($(t-257,5),$(e-1,5),$(n-4,4),r=0;r<n;r++)$(D[2*ut.bl_order[r]+1],3);et(s,t-1),et(j,e-1)}(V.max_code+1,Y.max_code+1,o+1),it(s,j)),J(),n&&ot()}function st(t){e(0<=S?S:-1,I-S,t),S=I,h.flush_pending()}function ht(){var t,e,n,r;do{if(0===(r=i-T-I)&&0===I&&0===T)r=f;else if(-1==r)r--;else if(f+f-gt<=I){for(g.set(g.subarray(f,f+f),0),C-=f,I-=f,S-=f,n=t=v;e=65535&w[--n],w[n]=f<=e?e-f:0,0!=--t;);for(n=t=f;e=65535&m[--n],m[n]=f<=e?e-f:0,0!=--t;);r+=f}if(0===h.avail_in)return;t=h.read_buf(g,I+T,r),3<=(T+=t)&&(y=((y=255&g[I])<<x^255&g[I+1])&b)}while(T<gt&&0!==h.avail_in)}function ct(t){var e,n,r=P,i=I,o=F,a=f-gt<I?I-(f-gt):0,s=R,h=p,c=I+258,l=g[i+o-1],u=g[i+o];B<=F&&(r>>=2),T<s&&(s=T);do{if(g[(e=t)+o]==u&&g[e+o-1]==l&&g[e]==g[i]&&g[++e]==g[i+1]){i+=2,e++;do{}while(g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&i<c);if(n=258-(c-i),i=c-258,o<n){if(C=t,s<=(o=n))break;l=g[i+o-1],u=g[i+o]}}}while((t=65535&m[t&h])>a&&0!=--r);return o<=T?o:T}function lt(t){return t.total_in=t.total_out=0,t.msg=null,G.pending=0,G.pending_out=0,c=113,u=0,V.dyn_tree=s,V.stat_desc=ft.static_l_desc,Y.dyn_tree=j,Y.stat_desc=ft.static_d_desc,X.dyn_tree=D,X.stat_desc=ft.static_bl_desc,W=H=0,L=8,J(),function(){var t;for(i=2*f,t=w[v-1]=0;t<v-1;t++)w[t]=0;E=dt[q].max_lazy,B=dt[q].good_length,R=dt[q].nice_length,P=dt[q].max_chain,k=F=2,y=A=T=S=I=0}(),0}G.depth=[],G.bl_count=[],G.heap=[],s=[],j=[],D=[],G.pqdownheap=function(t,e){for(var n=G.heap,r=n[e],i=e<<1;i<=G.heap_len&&(i<G.heap_len&&mt(t,n[i+1],n[i],G.depth)&&i++,!mt(t,r,n[i],G.depth));)n[e]=n[i],e=i,i<<=1;n[e]=r},G.deflateInit=function(t,e,n,r,i,o){return r||(r=8),i||(i=8),o||(o=0),t.msg=null,-1==e&&(e=6),i<1||9<i||8!=r||n<9||15<n||e<0||9<e||o<0||2<o?-2:(t.dstate=G,p=(f=1<<(d=n))-1,b=(v=1<<(a=i+7))-1,x=Math.floor((a+3-1)/3),g=new Uint8Array(2*f),m=[],w=[],U=1<<i+6,G.pending_buf=new Uint8Array(4*U),l=4*U,z=Math.floor(U/2),M=3*U,q=e,O=o,lt(t))},G.deflateEnd=function(){return 42!=c&&113!=c&&666!=c?-2:(G.pending_buf=null,g=m=w=null,G.dstate=null,113==c?-3:0)},G.deflateParams=function(t,e,n){var r=0;return-1==e&&(e=6),e<0||9<e||n<0||2<n?-2:(dt[q].func!=dt[e].func&&0!==t.total_in&&(r=t.deflate(1)),q!=e&&(E=dt[q=e].max_lazy,B=dt[q].good_length,R=dt[q].nice_length,P=dt[q].max_chain),O=n,r)},G.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||42!=c)return-2;if(i<3)return 0;for(f-gt<i&&(o=n-(i=f-gt)),g.set(e.subarray(o,o+i),0),S=I=i,y=((y=255&g[0])<<x^255&g[1])&b,r=0;r<=i-3;r++)y=(y<<x^255&g[r+2])&b,m[r&p]=w[y],w[y]=r;return 0},G.deflate=function(t,e){var n,r,i,o,a,s;if(4<e||e<0)return-2;if(!t.next_out||!t.next_in&&0!==t.avail_in||666==c&&4!=e)return t.msg=pt[4],-2;if(0===t.avail_out)return t.msg=pt[7],-5;if(h=t,o=u,u=e,42==c&&(r=8+(d-8<<4)<<8,3<(i=(q-1&255)>>1)&&(i=3),r|=i<<6,0!==I&&(r|=32),c=113,Q((s=r+=31-r%31)>>8&255),Q(255&s)),0!==G.pending){if(h.flush_pending(),0===h.avail_out)return u=-1,0}else if(0===h.avail_in&&e<=o&&4!=e)return h.msg=pt[7],-5;if(666==c&&0!==h.avail_in)return t.msg=pt[7],-5;if(0!==h.avail_in||0!==T||0!=e&&666!=c){switch(a=-1,dt[q].func){case 0:a=function(t){var e,n=65535;for(l-5<n&&(n=l-5);;){if(T<=1){if(ht(),0===T&&0==t)return 0;if(0===T)break}if(I+=T,e=S+n,((T=0)===I||e<=I)&&(T=I-e,I=e,st(!1),0===h.avail_out))return 0;if(f-gt<=I-S&&(st(!1),0===h.avail_out))return 0}return st(4==t),0===h.avail_out?4==t?2:0:4==t?3:1}(e);break;case 1:a=function(t){for(var e,n=0;;){if(T<gt){if(ht(),T<gt&&0==t)return 0;if(0===T)break}if(3<=T&&(y=(y<<x^255&g[I+2])&b,n=65535&w[y],m[I&p]=w[y],w[y]=I),0!==n&&(I-n&65535)<=f-gt&&2!=O&&(k=ct(n)),3<=k)if(e=rt(I-C,k-3),T-=k,k<=E&&3<=T){for(k--;y=(y<<x^255&g[++I+2])&b,n=65535&w[y],m[I&p]=w[y],w[y]=I,0!=--k;);I++}else I+=k,k=0,y=((y=255&g[I])<<x^255&g[I+1])&b;else e=rt(0,255&g[I]),T--,I++;if(e&&(st(!1),0===h.avail_out))return 0}return st(4==t),0===h.avail_out?4==t?2:0:4==t?3:1}(e);break;case 2:a=function(t){for(var e,n,r=0;;){if(T<gt){if(ht(),T<gt&&0==t)return 0;if(0===T)break}if(3<=T&&(y=(y<<x^255&g[I+2])&b,r=65535&w[y],m[I&p]=w[y],w[y]=I),F=k,_=C,k=2,0!==r&&F<E&&(I-r&65535)<=f-gt&&(2!=O&&(k=ct(r)),k<=5&&(1==O||3==k&&4096<I-C)&&(k=2)),3<=F&&k<=F){for(n=I+T-3,e=rt(I-1-_,F-3),T-=F-1,F-=2;++I<=n&&(y=(y<<x^255&g[I+2])&b,r=65535&w[y],m[I&p]=w[y],w[y]=I),0!=--F;);if(A=0,k=2,I++,e&&(st(!1),0===h.avail_out))return 0}else if(0!==A){if((e=rt(0,255&g[I-1]))&&st(!1),I++,T--,0===h.avail_out)return 0}else A=1,I++,T--}return 0!==A&&(e=rt(0,255&g[I-1]),A=0),st(4==t),0===h.avail_out?4==t?2:0:4==t?3:1}(e)}if(2!=a&&3!=a||(c=666),0==a||2==a)return 0===h.avail_out&&(u=-1),0;if(1==a){if(1==e)$(2,3),tt(256,ft.static_ltree),nt(),1+L+10-W<9&&($(2,3),tt(256,ft.static_ltree),nt()),L=7;else if(at(0,0,!1),3==e)for(n=0;n<v;n++)w[n]=0;if(h.flush_pending(),0===h.avail_out)return u=-1,0}}return 4!=e?0:1}}function i(){var t=this;t.next_in_index=0,t.next_out_index=0,t.avail_in=0,t.total_in=0,t.avail_out=0,t.total_out=0}i.prototype={deflateInit:function(t,e){return this.dstate=new r,e||(e=p),this.dstate.deflateInit(this,t,e)},deflate:function(t){return this.dstate?this.dstate.deflate(this,t):-2},deflateEnd:function(){if(!this.dstate)return-2;var t=this.dstate.deflateEnd();return this.dstate=null,t},deflateParams:function(t,e){return this.dstate?this.dstate.deflateParams(this,t,e):-2},deflateSetDictionary:function(t,e){return this.dstate?this.dstate.deflateSetDictionary(this,t,e):-2},read_buf:function(t,e,n){var r=this,i=r.avail_in;return n<i&&(i=n),0===i?0:(r.avail_in-=i,t.set(r.next_in.subarray(r.next_in_index,r.next_in_index+i),e),r.next_in_index+=i,r.total_in+=i,i)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}};var o=t.zip||t;o.Deflater=o._jzlib_Deflater=function(t){var s=new i,h=new Uint8Array(512),e=t?t.level:-1;void 0===e&&(e=-1),s.deflateInit(e),s.next_out=h,this.append=function(t,e){var n,r=[],i=0,o=0,a=0;if(t.length){s.next_in_index=0,s.next_in=t,s.avail_in=t.length;do{if(s.next_out_index=0,s.avail_out=512,0!=s.deflate(0))throw new Error("deflating: "+s.msg);s.next_out_index&&(512==s.next_out_index?r.push(new Uint8Array(h)):r.push(new Uint8Array(h.subarray(0,s.next_out_index)))),a+=s.next_out_index,e&&0<s.next_in_index&&s.next_in_index!=i&&(e(s.next_in_index),i=s.next_in_index)}while(0<s.avail_in||0===s.avail_out);return n=new Uint8Array(a),r.forEach(function(t){n.set(t,o),o+=t.length}),n}},this.flush=function(){var t,e,n=[],r=0,i=0;do{if(s.next_out_index=0,s.avail_out=512,1!=(t=s.deflate(4))&&0!=t)throw new Error("deflating: "+s.msg);0<512-s.avail_out&&n.push(new Uint8Array(h.subarray(0,s.next_out_index))),i+=s.next_out_index}while(0<s.avail_in||0===s.avail_out);return s.deflateEnd(),e=new Uint8Array(i),n.forEach(function(t){e.set(t,r),r+=t.length}),e}}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
	/**
	   * A class to parse color values
	   * @author Stoyan Stefanov <sstoo@gmail.com>
	   * @link   http://www.phpied.com/rgb-color-parser-in-javascript/
	   * @license Use it if you like it
	   */
	function(t){function f(t){var e;this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6)),t=(t=t.replace(/ /g,"")).toLowerCase();var l={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"};for(var n in l)t==n&&(t=l[n]);for(var u=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],r=0;r<u.length;r++){var i=u[r].re,o=u[r].process,a=i.exec(t);a&&(e=o(a),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:255<this.r?255:this.r,this.g=this.g<0||isNaN(this.g)?0:255<this.g?255:this.g,this.b=this.b<0||isNaN(this.b)?0:255<this.b?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),n=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==n.length&&(n="0"+n),"#"+t+e+n},this.getHelpXML=function(){for(var t=new Array,e=0;e<u.length;e++)for(var n=u[e].example,r=0;r<n.length;r++)t[t.length]=n[r];for(var i in l)t[t.length]=i;var o=document.createElement("ul");o.setAttribute("id","rgbcolor-examples");for(e=0;e<t.length;e++)try{var a=document.createElement("li"),s=new f(t[e]),h=document.createElement("div");h.style.cssText="margin: 3px; border: 1px solid black; background:"+s.toHex()+"; color:"+s.toHex(),h.appendChild(document.createTextNode("test"));var c=document.createTextNode(" "+t[e]+" -> "+s.toRGB()+" -> "+s.toHex());a.appendChild(h),a.appendChild(c),o.appendChild(a)}catch(t){}return o}} true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return f}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports&&(module.exports=f),t.RGBColor=f}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),function(t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.html2canvas=t()}}(function(){return function o(a,s,h){function c(n,t){if(!s[n]){if(!a[n]){var e="function"==typeof require&&require;if(!t&&e)return require(n,!0);if(l)return l(n,!0);var r=new Error("Cannot find module '"+n+"'");throw r.code="MODULE_NOT_FOUND",r}var i=s[n]={exports:{}};a[n][0].call(i.exports,function(t){var e=a[n][1][t];return c(e||t)},i,i.exports,o,a,s,h)}return s[n].exports}for(var l="function"==typeof require&&require,t=0;t<h.length;t++)c(h[t]);return c}({1:[function(t,q,O){(function(E){!function(t){var e="object"==typeof O&&O,n="object"==typeof q&&q&&q.exports==e&&q,r="object"==typeof E&&E;r.global!==r&&r.window!==r||(t=r);var i,o,w=2147483647,y=36,v=1,b=26,a=38,s=700,x=72,S=128,k="-",h=/^xn--/,c=/[^ -~]/,l=/\x2E|\u3002|\uFF0E|\uFF61/g,u={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},f=y-v,_=Math.floor,A=String.fromCharCode;function I(t){throw RangeError(u[t])}function d(t,e){for(var n=t.length;n--;)t[n]=e(t[n]);return t}function p(t,e){return d(t.split(l),e).join(".")}function C(t){for(var e,n,r=[],i=0,o=t.length;i<o;)55296<=(e=t.charCodeAt(i++))&&e<=56319&&i<o?56320==(64512&(n=t.charCodeAt(i++)))?r.push(((1023&e)<<10)+(1023&n)+65536):(r.push(e),i--):r.push(e);return r}function T(t){return d(t,function(t){var e="";return 65535<t&&(e+=A((t-=65536)>>>10&1023|55296),t=56320|1023&t),e+=A(t)}).join("")}function F(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function P(t,e,n){var r=0;for(t=n?_(t/s):t>>1,t+=_(t/e);f*b>>1<t;r+=y)t=_(t/f);return _(r+(f+1)*t/(t+a))}function g(t){var e,n,r,i,o,a,s,h,c,l,u,f=[],d=t.length,p=0,g=S,m=x;for((n=t.lastIndexOf(k))<0&&(n=0),r=0;r<n;++r)128<=t.charCodeAt(r)&&I("not-basic"),f.push(t.charCodeAt(r));for(i=0<n?n+1:0;i<d;){for(o=p,a=1,s=y;d<=i&&I("invalid-input"),u=t.charCodeAt(i++),(y<=(h=u-48<10?u-22:u-65<26?u-65:u-97<26?u-97:y)||h>_((w-p)/a))&&I("overflow"),p+=h*a,!(h<(c=s<=m?v:m+b<=s?b:s-m));s+=y)a>_(w/(l=y-c))&&I("overflow"),a*=l;m=P(p-o,e=f.length+1,0==o),_(p/e)>w-g&&I("overflow"),g+=_(p/e),p%=e,f.splice(p++,0,g)}return T(f)}function m(t){var e,n,r,i,o,a,s,h,c,l,u,f,d,p,g,m=[];for(f=(t=C(t)).length,e=S,o=x,a=n=0;a<f;++a)(u=t[a])<128&&m.push(A(u));for(r=i=m.length,i&&m.push(k);r<f;){for(s=w,a=0;a<f;++a)e<=(u=t[a])&&u<s&&(s=u);for(s-e>_((w-n)/(d=r+1))&&I("overflow"),n+=(s-e)*d,e=s,a=0;a<f;++a)if((u=t[a])<e&&++n>w&&I("overflow"),u==e){for(h=n,c=y;!(h<(l=c<=o?v:o+b<=c?b:c-o));c+=y)g=h-l,p=y-l,m.push(A(F(l+g%p,0))),h=_(g/p);m.push(A(F(h,0))),o=P(n,d,r==i),n=0,++r}++n,++e}return m.join("")}if(i={version:"1.2.4",ucs2:{decode:C,encode:T},decode:g,encode:m,toASCII:function(t){return p(t,function(t){return c.test(t)?"xn--"+m(t):t})},toUnicode:function(t){return p(t,function(t){return h.test(t)?g(t.slice(4).toLowerCase()):t})}},e&&!e.nodeType)if(n)n.exports=i;else for(o in i)i.hasOwnProperty(o)&&(e[o]=i[o]);else t.punycode=i}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],2:[function(t,e,n){var i=t("./log");function u(t,e){for(var n=3===t.nodeType?document.createTextNode(t.nodeValue):t.cloneNode(!1),r=t.firstChild;r;)!0!==e&&1===r.nodeType&&"SCRIPT"===r.nodeName||n.appendChild(u(r,e)),r=r.nextSibling;return 1===t.nodeType&&(n._scrollTop=t.scrollTop,n._scrollLeft=t.scrollLeft,"CANVAS"===t.nodeName?function(e,t){try{t&&(t.width=e.width,t.height=e.height,t.getContext("2d").putImageData(e.getContext("2d").getImageData(0,0,e.width,e.height),0,0))}catch(t){i("Unable to copy canvas content from",e,t)}}(t,n):"TEXTAREA"!==t.nodeName&&"SELECT"!==t.nodeName||(n.value=t.value)),n}e.exports=function(o,t,e,n,a,s,h){var c=u(o.documentElement,a.javascriptEnabled),l=t.createElement("iframe");return l.className="html2canvas-container",l.style.visibility="hidden",l.style.position="fixed",l.style.left="-10000px",l.style.top="0px",l.style.border="0",l.width=e,l.height=n,l.scrolling="no",t.body.appendChild(l),new Promise(function(e){var t,n,r,i=l.contentWindow.document;l.contentWindow.onload=l.onload=function(){var t=setInterval(function(){0<i.body.childNodes.length&&(!function t(e){if(1===e.nodeType){e.scrollTop=e._scrollTop,e.scrollLeft=e._scrollLeft;for(var n=e.firstChild;n;)t(n),n=n.nextSibling}}(i.documentElement),clearInterval(t),"view"===a.type&&(l.contentWindow.scrollTo(s,h),!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)||l.contentWindow.scrollY===h&&l.contentWindow.scrollX===s||(i.documentElement.style.top=-h+"px",i.documentElement.style.left=-s+"px",i.documentElement.style.position="absolute")),e(l))},50)},i.open(),i.write("<!DOCTYPE html><html></html>"),n=s,r=h,!(t=o).defaultView||n===t.defaultView.pageXOffset&&r===t.defaultView.pageYOffset||t.defaultView.scrollTo(n,r),i.replaceChild(i.adoptNode(c),i.documentElement),i.close()})}},{"./log":13}],3:[function(t,e,n){function r(t){this.r=0,this.g=0,this.b=0,this.a=null;this.fromArray(t)||this.namedColor(t)||this.rgb(t)||this.rgba(t)||this.hex6(t)||this.hex3(t)}r.prototype.darken=function(t){var e=1-t;return new r([Math.round(this.r*e),Math.round(this.g*e),Math.round(this.b*e),this.a])},r.prototype.isTransparent=function(){return 0===this.a},r.prototype.isBlack=function(){return 0===this.r&&0===this.g&&0===this.b},r.prototype.fromArray=function(t){return Array.isArray(t)&&(this.r=Math.min(t[0],255),this.g=Math.min(t[1],255),this.b=Math.min(t[2],255),3<t.length&&(this.a=t[3])),Array.isArray(t)};var i=/^#([a-f0-9]{3})$/i;r.prototype.hex3=function(t){var e;return null!==(e=t.match(i))&&(this.r=parseInt(e[1][0]+e[1][0],16),this.g=parseInt(e[1][1]+e[1][1],16),this.b=parseInt(e[1][2]+e[1][2],16)),null!==e};var o=/^#([a-f0-9]{6})$/i;r.prototype.hex6=function(t){var e=null;return null!==(e=t.match(o))&&(this.r=parseInt(e[1].substring(0,2),16),this.g=parseInt(e[1].substring(2,4),16),this.b=parseInt(e[1].substring(4,6),16)),null!==e};var a=/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;r.prototype.rgb=function(t){var e;return null!==(e=t.match(a))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3])),null!==e};var s=/^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;r.prototype.rgba=function(t){var e;return null!==(e=t.match(s))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3]),this.a=Number(e[4])),null!==e},r.prototype.toString=function(){return null!==this.a&&1!==this.a?"rgba("+[this.r,this.g,this.b,this.a].join(",")+")":"rgb("+[this.r,this.g,this.b].join(",")+")"},r.prototype.namedColor=function(t){t=t.toLowerCase();var e=h[t];if(e)this.r=e[0],this.g=e[1],this.b=e[2];else if("transparent"===t)return this.r=this.g=this.b=this.a=0,!0;return!!e},r.prototype.isColor=!0;var h={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]};e.exports=r},{}],4:[function(t,e,n){var p=t("./support"),d=t("./renderers/canvas"),g=t("./imageloader"),m=t("./nodeparser"),r=t("./nodecontainer"),w=t("./log"),i=t("./utils"),y=t("./clone"),v=t("./proxy").loadUrlDocument,b=i.getBounds,x="data-html2canvas-node",S=0;function o(t,e){var n,r,i=S++;if((e=e||{}).logging&&(w.options.logging=!0,w.options.start=Date.now()),e.async=void 0===e.async||e.async,e.allowTaint=void 0!==e.allowTaint&&e.allowTaint,e.removeContainer=void 0===e.removeContainer||e.removeContainer,e.javascriptEnabled=void 0!==e.javascriptEnabled&&e.javascriptEnabled,e.imageTimeout=void 0===e.imageTimeout?1e4:e.imageTimeout,e.renderer="function"==typeof e.renderer?e.renderer:d,e.strict=!!e.strict,"string"==typeof t){if("string"!=typeof e.proxy)return Promise.reject("Proxy must be used when rendering url");var o=null!=e.width?e.width:window.innerWidth,a=null!=e.height?e.height:window.innerHeight;return v((n=t,r=document.createElement("a"),r.href=n,r.href=r.href,r),e.proxy,document,o,a,e).then(function(t){return k(t.contentWindow.document.documentElement,t,e,o,a)})}var s,h,c,l,u,f=(void 0===t?[document.documentElement]:t.length?t:[t])[0];return f.setAttribute(x+i,i),(s=f.ownerDocument,h=e,c=f.ownerDocument.defaultView.innerWidth,l=f.ownerDocument.defaultView.innerHeight,u=i,y(s,s,c,l,h,s.defaultView.pageXOffset,s.defaultView.pageYOffset).then(function(t){w("Document cloned");var e=x+u,n="["+e+"='"+u+"']";s.querySelector(n).removeAttribute(e);var r=t.contentWindow,i=r.document.querySelector(n),o="function"==typeof h.onclone?Promise.resolve(h.onclone(r.document)):Promise.resolve(!0);return o.then(function(){return k(i,t,h,c,l)})})).then(function(t){return"function"==typeof e.onrendered&&(w("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas"),e.onrendered(t)),t})}o.CanvasRenderer=d,o.NodeContainer=r,o.log=w,o.utils=i;var a="undefined"==typeof document||"function"!=typeof Object.create||"function"!=typeof document.createElement("canvas").getContext?function(){return Promise.reject("No canvas support")}:o;function k(n,r,i,t,e){var o,a,s=r.contentWindow,h=new p(s.document),c=new g(i,h),l=b(n),u="view"===i.type?t:(o=s.document,Math.max(Math.max(o.body.scrollWidth,o.documentElement.scrollWidth),Math.max(o.body.offsetWidth,o.documentElement.offsetWidth),Math.max(o.body.clientWidth,o.documentElement.clientWidth))),f="view"===i.type?e:(a=s.document,Math.max(Math.max(a.body.scrollHeight,a.documentElement.scrollHeight),Math.max(a.body.offsetHeight,a.documentElement.offsetHeight),Math.max(a.body.clientHeight,a.documentElement.clientHeight))),d=new i.renderer(u,f,c,i,document);return new m(n,d,h,c,i).ready.then(function(){var t,e;return w("Finished rendering"),t="view"===i.type?_(d.canvas,{width:d.canvas.width,height:d.canvas.height,top:0,left:0,x:0,y:0}):n===s.document.body||n===s.document.documentElement||null!=i.canvas?d.canvas:_(d.canvas,{width:null!=i.width?i.width:l.width,height:null!=i.height?i.height:l.height,top:l.top,left:l.left,x:0,y:0}),e=r,i.removeContainer&&(e.parentNode.removeChild(e),w("Cleaned up container")),t})}function _(t,e){var n=document.createElement("canvas"),r=Math.min(t.width-1,Math.max(0,e.left)),i=Math.min(t.width,Math.max(1,e.left+e.width)),o=Math.min(t.height-1,Math.max(0,e.top)),a=Math.min(t.height,Math.max(1,e.top+e.height));n.width=e.width,n.height=e.height;var s=i-r,h=a-o;return w("Cropping canvas at:","left:",e.left,"top:",e.top,"width:",s,"height:",h),w("Resulting crop with width",e.width,"and height",e.height,"with x",r,"and y",o),n.getContext("2d").drawImage(t,r,o,s,h,e.x,e.y,s,h),n}e.exports=a},{"./clone":2,"./imageloader":11,"./log":13,"./nodecontainer":14,"./nodeparser":15,"./proxy":16,"./renderers/canvas":20,"./support":22,"./utils":26}],5:[function(t,e,n){var r=t("./log"),i=t("./utils").smallImage;e.exports=function t(e){if(this.src=e,r("DummyImageContainer for",e),!this.promise||!this.image){r("Initiating DummyImageContainer"),t.prototype.image=new Image;var n=this.image;t.prototype.promise=new Promise(function(t,e){n.onload=t,n.onerror=e,n.src=i(),!0===n.complete&&t(n)})}}},{"./log":13,"./utils":26}],6:[function(t,e,n){var h=t("./utils").smallImage;e.exports=function(t,e){var n,r,i=document.createElement("div"),o=document.createElement("img"),a=document.createElement("span"),s="Hidden Text";i.style.visibility="hidden",i.style.fontFamily=t,i.style.fontSize=e,i.style.margin=0,i.style.padding=0,document.body.appendChild(i),o.src=h(),o.width=1,o.height=1,o.style.margin=0,o.style.padding=0,o.style.verticalAlign="baseline",a.style.fontFamily=t,a.style.fontSize=e,a.style.margin=0,a.style.padding=0,a.appendChild(document.createTextNode(s)),i.appendChild(a),i.appendChild(o),n=o.offsetTop-a.offsetTop+1,i.removeChild(a),i.appendChild(document.createTextNode(s)),i.style.lineHeight="normal",o.style.verticalAlign="super",r=o.offsetTop-i.offsetTop+1,document.body.removeChild(i),this.baseline=n,this.lineWidth=1,this.middle=r}},{"./utils":26}],7:[function(t,e,n){var r=t("./font");function i(){this.data={}}i.prototype.getMetrics=function(t,e){return void 0===this.data[t+"-"+e]&&(this.data[t+"-"+e]=new r(t,e)),this.data[t+"-"+e]},e.exports=i},{"./font":6}],8:[function(o,t,e){var a=o("./utils").getBounds,i=o("./proxy").loadUrlDocument;function n(e,t,n){this.image=null,this.src=e;var r=this,i=a(e);this.promise=(t?new Promise(function(t){"about:blank"===e.contentWindow.document.URL||null==e.contentWindow.document.documentElement?e.contentWindow.onload=e.onload=function(){t(e)}:t(e)}):this.proxyLoad(n.proxy,i,n)).then(function(t){return o("./core")(t.contentWindow.document.documentElement,{type:"view",width:t.width,height:t.height,proxy:n.proxy,javascriptEnabled:n.javascriptEnabled,removeContainer:n.removeContainer,allowTaint:n.allowTaint,imageTimeout:n.imageTimeout/2})}).then(function(t){return r.image=t})}n.prototype.proxyLoad=function(t,e,n){var r=this.src;return i(r.src,t,r.ownerDocument,e.width,e.height,n)},t.exports=n},{"./core":4,"./proxy":16,"./utils":26}],9:[function(t,e,n){function r(t){this.src=t.value,this.colorStops=[],this.type=null,this.x0=.5,this.y0=.5,this.x1=.5,this.y1=.5,this.promise=Promise.resolve(!0)}r.TYPES={LINEAR:1,RADIAL:2},r.REGEXP_COLORSTOP=/^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i,e.exports=r},{}],10:[function(t,e,n){e.exports=function(n,r){this.src=n,this.image=new Image;var i=this;this.tainted=null,this.promise=new Promise(function(t,e){i.image.onload=t,i.image.onerror=e,r&&(i.image.crossOrigin="anonymous"),i.image.src=n,!0===i.image.complete&&t(i.image)})}},{}],11:[function(t,e,n){var o=t("./log"),r=t("./imagecontainer"),i=t("./dummyimagecontainer"),a=t("./proxyimagecontainer"),s=t("./framecontainer"),h=t("./svgcontainer"),c=t("./svgnodecontainer"),l=t("./lineargradientcontainer"),u=t("./webkitgradientcontainer"),f=t("./utils").bind;function d(t,e){this.link=null,this.options=t,this.support=e,this.origin=this.getOrigin(window.location.href)}d.prototype.findImages=function(t){var e=[];return t.reduce(function(t,e){switch(e.node.nodeName){case"IMG":return t.concat([{args:[e.node.src],method:"url"}]);case"svg":case"IFRAME":return t.concat([{args:[e.node],method:e.node.nodeName}])}return t},[]).forEach(this.addImage(e,this.loadImage),this),e},d.prototype.findBackgroundImage=function(t,e){return e.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(t,this.loadImage),this),t},d.prototype.addImage=function(n,r){return function(e){e.args.forEach(function(t){this.imageExists(n,t)||(n.splice(0,0,r.call(this,e)),o("Added image #"+n.length,"string"==typeof t?t.substring(0,100):t))},this)}},d.prototype.hasImageBackground=function(t){return"none"!==t.method},d.prototype.loadImage=function(t){if("url"===t.method){var e=t.args[0];return!this.isSVG(e)||this.support.svg||this.options.allowTaint?e.match(/data:image\/.*;base64,/i)?new r(e.replace(/url\(['"]{0,}|['"]{0,}\)$/gi,""),!1):this.isSameOrigin(e)||!0===this.options.allowTaint||this.isSVG(e)?new r(e,!1):this.support.cors&&!this.options.allowTaint&&this.options.useCORS?new r(e,!0):this.options.proxy?new a(e,this.options.proxy):new i(e):new h(e)}return"linear-gradient"===t.method?new l(t):"gradient"===t.method?new u(t):"svg"===t.method?new c(t.args[0],this.support.svg):"IFRAME"===t.method?new s(t.args[0],this.isSameOrigin(t.args[0].src),this.options):new i(t)},d.prototype.isSVG=function(t){return"svg"===t.substring(t.length-3).toLowerCase()||h.prototype.isInline(t)},d.prototype.imageExists=function(t,e){return t.some(function(t){return t.src===e})},d.prototype.isSameOrigin=function(t){return this.getOrigin(t)===this.origin},d.prototype.getOrigin=function(t){var e=this.link||(this.link=document.createElement("a"));return e.href=t,e.href=e.href,e.protocol+e.hostname+e.port},d.prototype.getPromise=function(e){return this.timeout(e,this.options.imageTimeout).catch(function(){return new i(e.src).promise.then(function(t){e.image=t})})},d.prototype.get=function(e){var n=null;return this.images.some(function(t){return(n=t).src===e})?n:null},d.prototype.fetch=function(t){return this.images=t.reduce(f(this.findBackgroundImage,this),this.findImages(t)),this.images.forEach(function(e,n){e.promise.then(function(){o("Succesfully loaded image #"+(n+1),e)},function(t){o("Failed loading image #"+(n+1),e,t)})}),this.ready=Promise.all(this.images.map(this.getPromise,this)),o("Finished searching images"),this},d.prototype.timeout=function(n,r){var i,t=Promise.race([n.promise,new Promise(function(t,e){i=setTimeout(function(){o("Timed out loading image",n),e(n)},r)})]).then(function(t){return clearTimeout(i),t});return t.catch(function(){clearTimeout(i)}),t},e.exports=d},{"./dummyimagecontainer":5,"./framecontainer":8,"./imagecontainer":10,"./lineargradientcontainer":12,"./log":13,"./proxyimagecontainer":17,"./svgcontainer":23,"./svgnodecontainer":24,"./utils":26,"./webkitgradientcontainer":27}],12:[function(t,e,n){var i=t("./gradientcontainer"),o=t("./color");function r(t){i.apply(this,arguments),this.type=i.TYPES.LINEAR;var e=r.REGEXP_DIRECTION.test(t.args[0])||!i.REGEXP_COLORSTOP.test(t.args[0]);e?t.args[0].split(/\s+/).reverse().forEach(function(t,e){switch(t){case"left":this.x0=0,this.x1=1;break;case"top":this.y0=0,this.y1=1;break;case"right":this.x0=1,this.x1=0;break;case"bottom":this.y0=1,this.y1=0;break;case"to":var n=this.y0,r=this.x0;this.y0=this.y1,this.x0=this.x1,this.x1=r,this.y1=n;break;case"center":break;default:var i=.01*parseFloat(t,10);if(isNaN(i))break;0===e?(this.y0=i,this.y1=1-this.y0):(this.x0=i,this.x1=1-this.x0)}},this):(this.y0=0,this.y1=1),this.colorStops=t.args.slice(e?1:0).map(function(t){var e=t.match(i.REGEXP_COLORSTOP),n=+e[2],r=0===n?"%":e[3];return{color:new o(e[1]),stop:"%"===r?n/100:null}}),null===this.colorStops[0].stop&&(this.colorStops[0].stop=0),null===this.colorStops[this.colorStops.length-1].stop&&(this.colorStops[this.colorStops.length-1].stop=1),this.colorStops.forEach(function(n,r){null===n.stop&&this.colorStops.slice(r).some(function(t,e){return null!==t.stop&&(n.stop=(t.stop-this.colorStops[r-1].stop)/(e+1)+this.colorStops[r-1].stop,!0)},this)},this)}r.prototype=Object.create(i.prototype),r.REGEXP_DIRECTION=/^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i,e.exports=r},{"./color":3,"./gradientcontainer":9}],13:[function(t,e,n){var r=function(){r.options.logging&&window.console&&window.console.log&&Function.prototype.bind.call(window.console.log,window.console).apply(window.console,[Date.now()-r.options.start+"ms","html2canvas:"].concat([].slice.call(arguments,0)))};r.options={logging:!1},e.exports=r},{}],14:[function(t,e,n){var o=t("./color"),r=t("./utils"),i=r.getBounds,a=r.parseBackgrounds,s=r.offsetBounds;function h(t,e){this.node=t,this.parent=e,this.stack=null,this.bounds=null,this.borders=null,this.clip=[],this.backgroundClip=[],this.offsetBounds=null,this.visible=null,this.computedStyles=null,this.colors={},this.styles={},this.backgroundImages=null,this.transformData=null,this.transformMatrix=null,this.isPseudoElement=!1,this.opacity=null}function c(t){return-1!==t.toString().indexOf("%")}function l(t){return t.replace("px","")}function u(t){return parseFloat(t)}h.prototype.cloneTo=function(t){t.visible=this.visible,t.borders=this.borders,t.bounds=this.bounds,t.clip=this.clip,t.backgroundClip=this.backgroundClip,t.computedStyles=this.computedStyles,t.styles=this.styles,t.backgroundImages=this.backgroundImages,t.opacity=this.opacity},h.prototype.getOpacity=function(){return null===this.opacity?this.opacity=this.cssFloat("opacity"):this.opacity},h.prototype.assignStack=function(t){(this.stack=t).children.push(this)},h.prototype.isElementVisible=function(){return this.node.nodeType===Node.TEXT_NODE?this.parent.visible:"none"!==this.css("display")&&"hidden"!==this.css("visibility")&&!this.node.hasAttribute("data-html2canvas-ignore")&&("INPUT"!==this.node.nodeName||"hidden"!==this.node.getAttribute("type"))},h.prototype.css=function(t){return this.computedStyles||(this.computedStyles=this.isPseudoElement?this.parent.computedStyle(this.before?":before":":after"):this.computedStyle(null)),this.styles[t]||(this.styles[t]=this.computedStyles[t])},h.prototype.prefixedCss=function(e){var n=this.css(e);return void 0===n&&["webkit","moz","ms","o"].some(function(t){return void 0!==(n=this.css(t+e.substr(0,1).toUpperCase()+e.substr(1)))},this),void 0===n?null:n},h.prototype.computedStyle=function(t){return this.node.ownerDocument.defaultView.getComputedStyle(this.node,t)},h.prototype.cssInt=function(t){var e=parseInt(this.css(t),10);return isNaN(e)?0:e},h.prototype.color=function(t){return this.colors[t]||(this.colors[t]=new o(this.css(t)))},h.prototype.cssFloat=function(t){var e=parseFloat(this.css(t));return isNaN(e)?0:e},h.prototype.fontWeight=function(){var t=this.css("fontWeight");switch(parseInt(t,10)){case 401:t="bold";break;case 400:t="normal"}return t},h.prototype.parseClip=function(){var t=this.css("clip").match(this.CLIP);return t?{top:parseInt(t[1],10),right:parseInt(t[2],10),bottom:parseInt(t[3],10),left:parseInt(t[4],10)}:null},h.prototype.parseBackgroundImages=function(){return this.backgroundImages||(this.backgroundImages=a(this.css("backgroundImage")))},h.prototype.cssList=function(t,e){var n=(this.css(t)||"").split(",");return 1===(n=(n=n[e||0]||n[0]||"auto").trim().split(" ")).length&&(n=[n[0],c(n[0])?"auto":n[0]]),n},h.prototype.parseBackgroundSize=function(t,e,n){var r,i,o=this.cssList("backgroundSize",n);if(c(o[0]))r=t.width*parseFloat(o[0])/100;else{if(/contain|cover/.test(o[0])){var a=t.width/t.height,s=e.width/e.height;return a<s^"contain"===o[0]?{width:t.height*s,height:t.height}:{width:t.width,height:t.width/s}}r=parseInt(o[0],10)}return i="auto"===o[0]&&"auto"===o[1]?e.height:"auto"===o[1]?r/e.width*e.height:c(o[1])?t.height*parseFloat(o[1])/100:parseInt(o[1],10),"auto"===o[0]&&(r=i/e.height*e.width),{width:r,height:i}},h.prototype.parseBackgroundPosition=function(t,e,n,r){var i,o,a=this.cssList("backgroundPosition",n);return i=c(a[0])?(t.width-(r||e).width)*(parseFloat(a[0])/100):parseInt(a[0],10),o="auto"===a[1]?i/e.width*e.height:c(a[1])?(t.height-(r||e).height)*parseFloat(a[1])/100:parseInt(a[1],10),"auto"===a[0]&&(i=o/e.height*e.width),{left:i,top:o}},h.prototype.parseBackgroundRepeat=function(t){return this.cssList("backgroundRepeat",t)[0]},h.prototype.parseTextShadows=function(){var t=this.css("textShadow"),e=[];if(t&&"none"!==t)for(var n=t.match(this.TEXT_SHADOW_PROPERTY),r=0;n&&r<n.length;r++){var i=n[r].match(this.TEXT_SHADOW_VALUES);e.push({color:new o(i[0]),offsetX:i[1]?parseFloat(i[1].replace("px","")):0,offsetY:i[2]?parseFloat(i[2].replace("px","")):0,blur:i[3]?i[3].replace("px",""):0})}return e},h.prototype.parseTransform=function(){if(!this.transformData)if(this.hasTransform()){var t=this.parseBounds(),e=this.prefixedCss("transformOrigin").split(" ").map(l).map(u);e[0]+=t.left,e[1]+=t.top,this.transformData={origin:e,matrix:this.parseTransformMatrix()}}else this.transformData={origin:[0,0],matrix:[1,0,0,1,0,0]};return this.transformData},h.prototype.parseTransformMatrix=function(){if(!this.transformMatrix){var t=this.prefixedCss("transform"),e=t?function(t){{if(t&&"matrix"===t[1])return t[2].split(",").map(function(t){return parseFloat(t.trim())});if(t&&"matrix3d"===t[1]){var e=t[2].split(",").map(function(t){return parseFloat(t.trim())});return[e[0],e[1],e[4],e[5],e[12],e[13]]}}}(t.match(this.MATRIX_PROPERTY)):null;this.transformMatrix=e||[1,0,0,1,0,0]}return this.transformMatrix},h.prototype.parseBounds=function(){return this.bounds||(this.bounds=this.hasTransform()?s(this.node):i(this.node))},h.prototype.hasTransform=function(){return"1,0,0,1,0,0"!==this.parseTransformMatrix().join(",")||this.parent&&this.parent.hasTransform()},h.prototype.getValue=function(){var t,e,n=this.node.value||"";return"SELECT"===this.node.tagName?(t=this.node,n=(e=t.options[t.selectedIndex||0])&&e.text||""):"password"===this.node.type&&(n=Array(n.length+1).join("•")),0===n.length?this.node.placeholder||"":n},h.prototype.MATRIX_PROPERTY=/(matrix|matrix3d)\((.+)\)/,h.prototype.TEXT_SHADOW_PROPERTY=/((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g,h.prototype.TEXT_SHADOW_VALUES=/(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g,h.prototype.CLIP=/^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/,e.exports=h},{"./color":3,"./utils":26}],15:[function(t,e,n){var s=t("./log"),h=t("punycode"),c=t("./nodecontainer"),f=t("./textcontainer"),d=t("./pseudoelementcontainer"),l=t("./fontmetrics"),u=t("./color"),p=t("./stackingcontext"),r=t("./utils"),g=r.bind,a=r.getBounds,m=r.parseBackgrounds,w=r.offsetBounds;function i(t,e,n,r,i){s("Starting NodeParser"),this.renderer=e,this.options=i,this.range=null,this.support=n,this.renderQueue=[],this.stack=new p(!0,1,t.ownerDocument,null);var o=new c(t,null);if(i.background&&e.rectangle(0,0,e.width,e.height,new u(i.background)),t===t.ownerDocument.documentElement){var a=new c(o.color("backgroundColor").isTransparent()?t.ownerDocument.body:t.ownerDocument.documentElement,null);e.rectangle(0,0,e.width,e.height,a.color("backgroundColor"))}o.visibile=o.isElementVisible(),this.createPseudoHideStyles(t.ownerDocument),this.disableAnimations(t.ownerDocument),this.nodes=L([o].concat(this.getChildren(o)).filter(function(t){return t.visible=t.isElementVisible()}).map(this.getPseudoElements,this)),this.fontMetrics=new l,s("Fetched nodes, total:",this.nodes.length),s("Calculate overflow clips"),this.calculateOverflowClips(),s("Start fetching images"),this.images=r.fetch(this.nodes.filter(j)),this.ready=this.images.ready.then(g(function(){return s("Images loaded, starting parsing"),s("Creating stacking contexts"),this.createStackingContexts(),s("Sorting stacking contexts"),this.sortStackingContexts(this.stack),this.parse(this.stack),s("Render queue created with "+this.renderQueue.length+" items"),new Promise(g(function(t){i.async?"function"==typeof i.async?i.async.call(this,this.renderQueue,t):0<this.renderQueue.length?(this.renderIndex=0,this.asyncRenderer(this.renderQueue,t)):t():(this.renderQueue.forEach(this.paint,this),t())},this))},this))}function o(t){return t.parent&&t.parent.clip.length}function y(){}i.prototype.calculateOverflowClips=function(){this.nodes.forEach(function(t){if(j(t)){D(t)&&t.appendToDOM(),t.borders=this.parseBorders(t);var e="hidden"===t.css("overflow")?[t.borders.clip]:[],n=t.parseClip();n&&-1!==["absolute","fixed"].indexOf(t.css("position"))&&e.push([["rect",t.bounds.left+n.left,t.bounds.top+n.top,n.right-n.left,n.bottom-n.top]]),t.clip=o(t)?t.parent.clip.concat(e):e,t.backgroundClip="hidden"!==t.css("overflow")?t.clip.concat([t.borders.clip]):t.clip,D(t)&&t.cleanDOM()}else M(t)&&(t.clip=o(t)?t.parent.clip:[]);D(t)||(t.bounds=null)},this)},i.prototype.asyncRenderer=function(t,e,n){n=n||Date.now(),this.paint(t[this.renderIndex++]),t.length===this.renderIndex?e():n+20>Date.now()?this.asyncRenderer(t,e,n):setTimeout(g(function(){this.asyncRenderer(t,e)},this),0)},i.prototype.createPseudoHideStyles=function(t){this.createStyles(t,"."+d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+':before { content: "" !important; display: none !important; }.'+d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER+':after { content: "" !important; display: none !important; }')},i.prototype.disableAnimations=function(t){this.createStyles(t,"* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; -webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}")},i.prototype.createStyles=function(t,e){var n=t.createElement("style");n.innerHTML=e,t.body.appendChild(n)},i.prototype.getPseudoElements=function(t){var e=[[t]];if(t.node.nodeType===Node.ELEMENT_NODE){var n=this.getPseudoElement(t,":before"),r=this.getPseudoElement(t,":after");n&&e.push(n),r&&e.push(r)}return L(e)},i.prototype.getPseudoElement=function(t,e){var n=t.computedStyle(e);if(!n||!n.content||"none"===n.content||"-moz-alt-content"===n.content||"none"===n.display)return null;for(var r,i,o=(r=n.content,(i=r.substr(0,1))===r.substr(r.length-1)&&i.match(/'|"/)?r.substr(1,r.length-2):r),a="url"===o.substr(0,3),s=document.createElement(a?"img":"html2canvaspseudoelement"),h=new d(s,t,e),c=n.length-1;0<=c;c--){var l=n.item(c).replace(/(\-[a-z])/g,function(t){return t.toUpperCase().replace("-","")});s.style[l]=n[l]}if(s.className=d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+" "+d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER,a)return s.src=m(o)[0].args[0],[h];var u=document.createTextNode(o);return s.appendChild(u),[h,new f(u,h)]},i.prototype.getChildren=function(n){return L([].filter.call(n.node.childNodes,q).map(function(t){var e=[t.nodeType===Node.TEXT_NODE?new f(t,n):new c(t,n)].filter(z);return t.nodeType===Node.ELEMENT_NODE&&e.length&&"TEXTAREA"!==t.tagName?e[0].isElementVisible()?e.concat(this.getChildren(e[0])):[]:e},this))},i.prototype.newStackingContext=function(t,e){var n=new p(e,t.getOpacity(),t.node,t.parent);t.cloneTo(n),(e?n.getParentStack(this):n.parent.stack).contexts.push(n),t.stack=n},i.prototype.createStackingContexts=function(){this.nodes.forEach(function(t){var e,n;j(t)&&(this.isRootElement(t)||t.getOpacity()<1||(n=(e=t).css("position"),"auto"!==(-1!==["absolute","relative","fixed"].indexOf(n)?e.css("zIndex"):"auto"))||this.isBodyWithTransparentRoot(t)||t.hasTransform())?this.newStackingContext(t,!0):j(t)&&(O(t)&&T(t)||-1!==["inline-block","inline-table"].indexOf(t.css("display"))||B(t))?this.newStackingContext(t,!1):t.assignStack(t.parent.stack)},this)},i.prototype.isBodyWithTransparentRoot=function(t){return"BODY"===t.node.nodeName&&t.parent.color("backgroundColor").isTransparent()},i.prototype.isRootElement=function(t){return null===t.parent},i.prototype.sortStackingContexts=function(t){var n;t.contexts.sort((n=t.contexts.slice(0),function(t,e){return t.cssInt("zIndex")+n.indexOf(t)/n.length-(e.cssInt("zIndex")+n.indexOf(e)/n.length)})),t.contexts.forEach(this.sortStackingContexts,this)},i.prototype.parseTextBounds=function(a){return function(t,e,n){if("none"!==a.parent.css("textDecoration").substr(0,4)||0!==t.trim().length){if(this.support.rangeBounds&&!a.parent.hasTransform()){var r=n.slice(0,e).join("").length;return this.getRangeBounds(a.node,r,t.length)}if(a.node&&"string"==typeof a.node.data){var i=a.node.splitText(t.length),o=this.getWrapperBounds(a.node,a.parent.hasTransform());return a.node=i,o}}else this.support.rangeBounds&&!a.parent.hasTransform()||(a.node=a.node.splitText(t.length));return{}}},i.prototype.getWrapperBounds=function(t,e){var n=t.ownerDocument.createElement("html2canvaswrapper"),r=t.parentNode,i=t.cloneNode(!0);n.appendChild(t.cloneNode(!0)),r.replaceChild(n,t);var o=e?w(n):a(n);return r.replaceChild(i,n),o},i.prototype.getRangeBounds=function(t,e,n){var r=this.range||(this.range=t.ownerDocument.createRange());return r.setStart(t,e),r.setEnd(t,e+n),r.getBoundingClientRect()},i.prototype.parse=function(t){var e=t.contexts.filter(I),n=t.children.filter(j),r=n.filter(R(B)),i=r.filter(R(O)).filter(R(F)),o=n.filter(R(O)).filter(B),a=r.filter(R(O)).filter(F),s=t.contexts.concat(r.filter(O)).filter(T),h=t.children.filter(M).filter(E),c=t.contexts.filter(C);e.concat(i).concat(o).concat(a).concat(s).concat(h).concat(c).forEach(function(t){this.renderQueue.push(t),P(t)&&(this.parse(t),this.renderQueue.push(new y))},this)},i.prototype.paint=function(t){try{t instanceof y?this.renderer.ctx.restore():M(t)?(D(t.parent)&&t.parent.appendToDOM(),this.paintText(t),D(t.parent)&&t.parent.cleanDOM()):this.paintNode(t)}catch(t){if(s(t),this.options.strict)throw t}},i.prototype.paintNode=function(t){P(t)&&(this.renderer.setOpacity(t.opacity),this.renderer.ctx.save(),t.hasTransform()&&this.renderer.setTransform(t.parseTransform())),"INPUT"===t.node.nodeName&&"checkbox"===t.node.type?this.paintCheckbox(t):"INPUT"===t.node.nodeName&&"radio"===t.node.type?this.paintRadio(t):this.paintElement(t)},i.prototype.paintElement=function(n){var r=n.parseBounds();this.renderer.clip(n.backgroundClip,function(){this.renderer.renderBackground(n,r,n.borders.borders.map(N))},this),this.renderer.clip(n.clip,function(){this.renderer.renderBorders(n.borders.borders)},this),this.renderer.clip(n.backgroundClip,function(){switch(n.node.nodeName){case"svg":case"IFRAME":var t=this.images.get(n.node);t?this.renderer.renderImage(n,r,n.borders,t):s("Error loading <"+n.node.nodeName+">",n.node);break;case"IMG":var e=this.images.get(n.node.src);e?this.renderer.renderImage(n,r,n.borders,e):s("Error loading <img>",n.node.src);break;case"CANVAS":this.renderer.renderImage(n,r,n.borders,{image:n.node});break;case"SELECT":case"INPUT":case"TEXTAREA":this.paintFormValue(n)}},this)},i.prototype.paintCheckbox=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height),r={width:n-1,height:n-1,top:e.top,left:e.left},i=[3,3],o=[i,i,i,i],a=[1,1,1,1].map(function(t){return{color:new u("#A5A5A5"),width:t}}),s=S(r,o,a);this.renderer.clip(t.backgroundClip,function(){this.renderer.rectangle(r.left+1,r.top+1,r.width-2,r.height-2,new u("#DEDEDE")),this.renderer.renderBorders(b(a,r,s,o)),t.node.checked&&(this.renderer.font(new u("#424242"),"normal","normal","bold",n-3+"px","arial"),this.renderer.text("✔",r.left+n/6,r.top+n-1))},this)},i.prototype.paintRadio=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height)-2;this.renderer.clip(t.backgroundClip,function(){this.renderer.circleStroke(e.left+1,e.top+1,n,new u("#DEDEDE"),1,new u("#A5A5A5")),t.node.checked&&this.renderer.circle(Math.ceil(e.left+n/4)+1,Math.ceil(e.top+n/4)+1,Math.floor(n/2),new u("#424242"))},this)},i.prototype.paintFormValue=function(e){var t=e.getValue();if(0<t.length){var n=e.node.ownerDocument,r=n.createElement("html2canvaswrapper");["lineHeight","textAlign","fontFamily","fontWeight","fontSize","color","paddingLeft","paddingTop","paddingRight","paddingBottom","width","height","borderLeftStyle","borderTopStyle","borderLeftWidth","borderTopWidth","boxSizing","whiteSpace","wordWrap"].forEach(function(t){try{r.style[t]=e.css(t)}catch(t){s("html2canvas: Parse: Exception caught in renderFormValue: "+t.message)}});var i=e.parseBounds();r.style.position="fixed",r.style.left=i.left+"px",r.style.top=i.top+"px",r.textContent=t,n.body.appendChild(r),this.paintText(new f(r.firstChild,e)),n.body.removeChild(r)}},i.prototype.paintText=function(n){n.applyTextTransform();var t,e=h.ucs2.decode(n.node.data),r=this.options.letterRendering&&!/^(normal|none|0px)$/.test(n.parent.css("letterSpacing"))||(t=n.node.data,/[^\u0000-\u00ff]/.test(t))?e.map(function(t){return h.ucs2.encode([t])}):function(t){var e,n=[],r=0,i=!1;for(;t.length;)o=t[r],-1!==[32,13,10,9,45].indexOf(o)===i?((e=t.splice(0,r)).length&&n.push(h.ucs2.encode(e)),i=!i,r=0):r++,r>=t.length&&(e=t.splice(0,r)).length&&n.push(h.ucs2.encode(e));var o;return n}(e),i=n.parent.fontWeight(),o=n.parent.css("fontSize"),a=n.parent.css("fontFamily"),s=n.parent.parseTextShadows();this.renderer.font(n.parent.color("color"),n.parent.css("fontStyle"),n.parent.css("fontVariant"),i,o,a),s.length?this.renderer.fontShadow(s[0].color,s[0].offsetX,s[0].offsetY,s[0].blur):this.renderer.clearShadow(),this.renderer.clip(n.parent.clip,function(){r.map(this.parseTextBounds(n),this).forEach(function(t,e){t&&!1===/^\s*$/.test(r[e])&&(this.renderer.text(r[e],t.left,t.bottom),this.renderTextDecoration(n.parent,t,this.fontMetrics.getMetrics(a,o)))},this)},this)},i.prototype.renderTextDecoration=function(t,e,n){switch(t.css("textDecoration").split(" ")[0]){case"underline":this.renderer.rectangle(e.left,Math.round(e.top+n.baseline+n.lineWidth),e.width,1,t.color("color"));break;case"overline":this.renderer.rectangle(e.left,Math.round(e.top),e.width,1,t.color("color"));break;case"line-through":this.renderer.rectangle(e.left,Math.ceil(e.top+n.middle+n.lineWidth),e.width,1,t.color("color"))}};var v={inset:[["darken",.6],["darken",.1],["darken",.1],["darken",.6]]};function b(a,s,h,c){return a.map(function(t,e){if(0<t.width){var n=s.left,r=s.top,i=s.width,o=s.height-a[2].width;switch(e){case 0:o=a[0].width,t.args=_({c1:[n,r],c2:[n+i,r],c3:[n+i-a[1].width,r+o],c4:[n+a[3].width,r+o]},c[0],c[1],h.topLeftOuter,h.topLeftInner,h.topRightOuter,h.topRightInner);break;case 1:n=s.left+s.width-a[1].width,i=a[1].width,t.args=_({c1:[n+i,r],c2:[n+i,r+o+a[2].width],c3:[n,r+o],c4:[n,r+a[0].width]},c[1],c[2],h.topRightOuter,h.topRightInner,h.bottomRightOuter,h.bottomRightInner);break;case 2:r=r+s.height-a[2].width,o=a[2].width,t.args=_({c1:[n+i,r+o],c2:[n,r+o],c3:[n+a[3].width,r],c4:[n+i-a[3].width,r]},c[2],c[3],h.bottomRightOuter,h.bottomRightInner,h.bottomLeftOuter,h.bottomLeftInner);break;case 3:i=a[3].width,t.args=_({c1:[n,r+o+a[2].width],c2:[n,r],c3:[n+i,r+a[0].width],c4:[n+i,r+o]},c[3],c[0],h.bottomLeftOuter,h.bottomLeftInner,h.topLeftOuter,h.topLeftInner)}}return t})}function x(t,e,n,r){var i=(Math.sqrt(2)-1)/3*4,o=n*i,a=r*i,s=t+n,h=e+r;return{topLeft:k({x:t,y:h},{x:t,y:h-a},{x:s-o,y:e},{x:s,y:e}),topRight:k({x:t,y:e},{x:t+o,y:e},{x:s,y:h-a},{x:s,y:h}),bottomRight:k({x:s,y:e},{x:s,y:e+a},{x:t+o,y:h},{x:t,y:h}),bottomLeft:k({x:s,y:h},{x:s-o,y:h},{x:t,y:e+a},{x:t,y:e})}}function S(t,e,n){var r=t.left,i=t.top,o=t.width,a=t.height,s=e[0][0]<o/2?e[0][0]:o/2,h=e[0][1]<a/2?e[0][1]:a/2,c=e[1][0]<o/2?e[1][0]:o/2,l=e[1][1]<a/2?e[1][1]:a/2,u=e[2][0]<o/2?e[2][0]:o/2,f=e[2][1]<a/2?e[2][1]:a/2,d=e[3][0]<o/2?e[3][0]:o/2,p=e[3][1]<a/2?e[3][1]:a/2,g=o-c,m=a-f,w=o-u,y=a-p;return{topLeftOuter:x(r,i,s,h).topLeft.subdivide(.5),topLeftInner:x(r+n[3].width,i+n[0].width,Math.max(0,s-n[3].width),Math.max(0,h-n[0].width)).topLeft.subdivide(.5),topRightOuter:x(r+g,i,c,l).topRight.subdivide(.5),topRightInner:x(r+Math.min(g,o+n[3].width),i+n[0].width,g>o+n[3].width?0:c-n[3].width,l-n[0].width).topRight.subdivide(.5),bottomRightOuter:x(r+w,i+m,u,f).bottomRight.subdivide(.5),bottomRightInner:x(r+Math.min(w,o-n[3].width),i+Math.min(m,a+n[0].width),Math.max(0,u-n[1].width),f-n[2].width).bottomRight.subdivide(.5),bottomLeftOuter:x(r,i+y,d,p).bottomLeft.subdivide(.5),bottomLeftInner:x(r+n[3].width,i+y,Math.max(0,d-n[3].width),p-n[2].width).bottomLeft.subdivide(.5)}}function k(s,h,c,l){var u=function(t,e,n){return{x:t.x+(e.x-t.x)*n,y:t.y+(e.y-t.y)*n}};return{start:s,startControl:h,endControl:c,end:l,subdivide:function(t){var e=u(s,h,t),n=u(h,c,t),r=u(c,l,t),i=u(e,n,t),o=u(n,r,t),a=u(i,o,t);return[k(s,e,i,a),k(a,o,r,l)]},curveTo:function(t){t.push(["bezierCurve",h.x,h.y,c.x,c.y,l.x,l.y])},curveToReversed:function(t){t.push(["bezierCurve",c.x,c.y,h.x,h.y,s.x,s.y])}}}function _(t,e,n,r,i,o,a){var s=[];return 0<e[0]||0<e[1]?(s.push(["line",r[1].start.x,r[1].start.y]),r[1].curveTo(s)):s.push(["line",t.c1[0],t.c1[1]]),0<n[0]||0<n[1]?(s.push(["line",o[0].start.x,o[0].start.y]),o[0].curveTo(s),s.push(["line",a[0].end.x,a[0].end.y]),a[0].curveToReversed(s)):(s.push(["line",t.c2[0],t.c2[1]]),s.push(["line",t.c3[0],t.c3[1]])),0<e[0]||0<e[1]?(s.push(["line",i[1].end.x,i[1].end.y]),i[1].curveToReversed(s)):s.push(["line",t.c4[0],t.c4[1]]),s}function A(t,e,n,r,i,o,a){0<e[0]||0<e[1]?(t.push(["line",r[0].start.x,r[0].start.y]),r[0].curveTo(t),r[1].curveTo(t)):t.push(["line",o,a]),(0<n[0]||0<n[1])&&t.push(["line",i[0].start.x,i[0].start.y])}function I(t){return t.cssInt("zIndex")<0}function C(t){return 0<t.cssInt("zIndex")}function T(t){return 0===t.cssInt("zIndex")}function F(t){return-1!==["inline","inline-block","inline-table"].indexOf(t.css("display"))}function P(t){return t instanceof p}function E(t){return 0<t.node.data.trim().length}function q(t){return t.nodeType===Node.TEXT_NODE||t.nodeType===Node.ELEMENT_NODE}function O(t){return"static"!==t.css("position")}function B(t){return"none"!==t.css("float")}function R(t){var e=this;return function(){return!t.apply(e,arguments)}}function j(t){return t.node.nodeType===Node.ELEMENT_NODE}function D(t){return!0===t.isPseudoElement}function M(t){return t.node.nodeType===Node.TEXT_NODE}function U(t){return parseInt(t,10)}function N(t){return t.width}function z(t){return t.node.nodeType!==Node.ELEMENT_NODE||-1===["SCRIPT","HEAD","TITLE","OBJECT","BR","OPTION"].indexOf(t.node.nodeName)}function L(t){return[].concat.apply([],t)}i.prototype.parseBorders=function(o){var r,t=o.parseBounds(),e=(r=o,["TopLeft","TopRight","BottomRight","BottomLeft"].map(function(t){var e=r.css("border"+t+"Radius"),n=e.split(" ");return n.length<=1&&(n[1]=n[0]),n.map(U)})),n=["Top","Right","Bottom","Left"].map(function(t,e){var n=o.css("border"+t+"Style"),r=o.color("border"+t+"Color");"inset"===n&&r.isBlack()&&(r=new u([255,255,255,r.a]));var i=v[n]?v[n][e]:null;return{width:o.cssInt("border"+t+"Width"),color:i?r[i[0]](i[1]):r,args:null}}),i=S(t,e,n);return{clip:this.parseBackgroundClip(o,i,n,e,t),borders:b(n,t,i,e)}},i.prototype.parseBackgroundClip=function(t,e,n,r,i){var o=[];switch(t.css("backgroundClip")){case"content-box":case"padding-box":A(o,r[0],r[1],e.topLeftInner,e.topRightInner,i.left+n[3].width,i.top+n[0].width),A(o,r[1],r[2],e.topRightInner,e.bottomRightInner,i.left+i.width-n[1].width,i.top+n[0].width),A(o,r[2],r[3],e.bottomRightInner,e.bottomLeftInner,i.left+i.width-n[1].width,i.top+i.height-n[2].width),A(o,r[3],r[0],e.bottomLeftInner,e.topLeftInner,i.left+n[3].width,i.top+i.height-n[2].width);break;default:A(o,r[0],r[1],e.topLeftOuter,e.topRightOuter,i.left,i.top),A(o,r[1],r[2],e.topRightOuter,e.bottomRightOuter,i.left+i.width,i.top),A(o,r[2],r[3],e.bottomRightOuter,e.bottomLeftOuter,i.left+i.width,i.top+i.height),A(o,r[3],r[0],e.bottomLeftOuter,e.topLeftOuter,i.left,i.top+i.height)}return o},e.exports=i},{"./color":3,"./fontmetrics":7,"./log":13,"./nodecontainer":14,"./pseudoelementcontainer":18,"./stackingcontext":21,"./textcontainer":25,"./utils":26,punycode:1}],16:[function(t,e,n){var a=t("./xhr"),r=t("./utils"),s=t("./log"),h=t("./clone"),c=r.decode64;function l(t,e,n){var r="withCredentials"in new XMLHttpRequest;if(!e)return Promise.reject("No proxy configured");var i=f(r),o=d(e,t,i);return r?a(o):u(n,o,i).then(function(t){return c(t.content)})}var i=0;function u(i,o,a){return new Promise(function(e,n){var t=i.createElement("script"),r=function(){delete window.html2canvas.proxy[a],i.body.removeChild(t)};window.html2canvas.proxy[a]=function(t){r(),e(t)},t.src=o,t.onerror=function(t){r(),n(t)},i.body.appendChild(t)})}function f(t){return t?"":"html2canvas_"+Date.now()+"_"+ ++i+"_"+Math.round(1e5*Math.random())}function d(t,e,n){return t+"?url="+encodeURIComponent(e)+(n.length?"&callback=html2canvas.proxy."+n:"")}n.Proxy=l,n.ProxyURL=function(t,e,n){var r="crossOrigin"in new Image,i=f(r),o=d(e,t,i);return r?Promise.resolve(o):u(n,o,i).then(function(t){return"data:"+t.type+";base64,"+t.content})},n.loadUrlDocument=function(t,e,n,r,i,o){return new l(t,e,window.document).then((a=t,function(e){var n,t=new DOMParser;try{n=t.parseFromString(e,"text/html")}catch(t){s("DOMParser not supported, falling back to createHTMLDocument"),n=document.implementation.createHTMLDocument("");try{n.open(),n.write(e),n.close()}catch(t){s("createHTMLDocument write not supported, falling back to document.body.innerHTML"),n.body.innerHTML=e}}var r=n.querySelector("base");if(!r||!r.href.host){var i=n.createElement("base");i.href=a,n.head.insertBefore(i,n.head.firstChild)}return n})).then(function(t){return h(t,n,r,i,o,0,0)});var a}},{"./clone":2,"./log":13,"./utils":26,"./xhr":28}],17:[function(t,e,n){var o=t("./proxy").ProxyURL;e.exports=function(n,r){var t=document.createElement("a");t.href=n,n=t.href,this.src=n,this.image=new Image;var i=this;this.promise=new Promise(function(t,e){i.image.crossOrigin="Anonymous",i.image.onload=t,i.image.onerror=e,new o(n,r,document).then(function(t){i.image.src=t}).catch(e)})}},{"./proxy":16}],18:[function(t,e,n){var r=t("./nodecontainer");function i(t,e,n){r.call(this,t,e),this.isPseudoElement=!0,this.before=":before"===n}i.prototype.cloneTo=function(t){i.prototype.cloneTo.call(this,t),t.isPseudoElement=!0,t.before=this.before},(i.prototype=Object.create(r.prototype)).appendToDOM=function(){this.before?this.parent.node.insertBefore(this.node,this.parent.node.firstChild):this.parent.node.appendChild(this.node),this.parent.node.className+=" "+this.getHideClass()},i.prototype.cleanDOM=function(){this.node.parentNode.removeChild(this.node),this.parent.node.className=this.parent.node.className.replace(this.getHideClass(),"")},i.prototype.getHideClass=function(){return this["PSEUDO_HIDE_ELEMENT_CLASS_"+(this.before?"BEFORE":"AFTER")]},i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE="___html2canvas___pseudoelement_before",i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER="___html2canvas___pseudoelement_after",e.exports=i},{"./nodecontainer":14}],19:[function(t,e,n){var h=t("./log");function r(t,e,n,r,i){this.width=t,this.height=e,this.images=n,this.options=r,this.document=i}r.prototype.renderImage=function(t,e,n,r){var i=t.cssInt("paddingLeft"),o=t.cssInt("paddingTop"),a=t.cssInt("paddingRight"),s=t.cssInt("paddingBottom"),h=n.borders,c=e.width-(h[1].width+h[3].width+i+a),l=e.height-(h[0].width+h[2].width+o+s);this.drawImage(r,0,0,r.image.width||c,r.image.height||l,e.left+i+h[3].width,e.top+o+h[0].width,c,l)},r.prototype.renderBackground=function(t,e,n){0<e.height&&0<e.width&&(this.renderBackgroundColor(t,e),this.renderBackgroundImage(t,e,n))},r.prototype.renderBackgroundColor=function(t,e){var n=t.color("backgroundColor");n.isTransparent()||this.rectangle(e.left,e.top,e.width,e.height,n)},r.prototype.renderBorders=function(t){t.forEach(this.renderBorder,this)},r.prototype.renderBorder=function(t){t.color.isTransparent()||null===t.args||this.drawShape(t.args,t.color)},r.prototype.renderBackgroundImage=function(o,a,s){o.parseBackgroundImages().reverse().forEach(function(t,e,n){switch(t.method){case"url":var r=this.images.get(t.args[0]);r?this.renderBackgroundRepeating(o,a,r,n.length-(e+1),s):h("Error loading background-image",t.args[0]);break;case"linear-gradient":case"gradient":var i=this.images.get(t.value);i?this.renderBackgroundGradient(i,a,s):h("Error loading background-image",t.args[0]);break;case"none":break;default:h("Unknown background-image type",t.args[0])}},this)},r.prototype.renderBackgroundRepeating=function(t,e,n,r,i){var o=t.parseBackgroundSize(e,n.image,r),a=t.parseBackgroundPosition(e,n.image,r,o);switch(t.parseBackgroundRepeat(r)){case"repeat-x":case"repeat no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+i[3],e.top+a.top+i[0],99999,o.height,i);break;case"repeat-y":case"no-repeat repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+i[0],o.width,99999,i);break;case"no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+a.top+i[0],o.width,o.height,i);break;default:this.renderBackgroundRepeat(n,a,o,{top:e.top,left:e.left},i[3],i[0])}},e.exports=r},{"./log":13}],20:[function(t,e,n){var r=t("../renderer"),i=t("../lineargradientcontainer"),o=t("../log");function a(t,e){r.apply(this,arguments),this.canvas=this.options.canvas||this.document.createElement("canvas"),this.options.canvas||(this.canvas.width=t,this.canvas.height=e),this.ctx=this.canvas.getContext("2d"),this.taintCtx=this.document.createElement("canvas").getContext("2d"),this.ctx.textBaseline="bottom",this.variables={},o("Initialized CanvasRenderer with size",t,"x",e)}function s(t){return 0<t.length}(a.prototype=Object.create(r.prototype)).setFillStyle=function(t){return this.ctx.fillStyle="object"==typeof t&&t.isColor?t.toString():t,this.ctx},a.prototype.rectangle=function(t,e,n,r,i){this.setFillStyle(i).fillRect(t,e,n,r)},a.prototype.circle=function(t,e,n,r){this.setFillStyle(r),this.ctx.beginPath(),this.ctx.arc(t+n/2,e+n/2,n/2,0,2*Math.PI,!0),this.ctx.closePath(),this.ctx.fill()},a.prototype.circleStroke=function(t,e,n,r,i,o){this.circle(t,e,n,r),this.ctx.strokeStyle=o.toString(),this.ctx.stroke()},a.prototype.drawShape=function(t,e){this.shape(t),this.setFillStyle(e).fill()},a.prototype.taints=function(e){if(null===e.tainted){this.taintCtx.drawImage(e.image,0,0);try{this.taintCtx.getImageData(0,0,1,1),e.tainted=!1}catch(t){this.taintCtx=document.createElement("canvas").getContext("2d"),e.tainted=!0}}return e.tainted},a.prototype.drawImage=function(t,e,n,r,i,o,a,s,h){this.taints(t)&&!this.options.allowTaint||this.ctx.drawImage(t.image,e,n,r,i,o,a,s,h)},a.prototype.clip=function(t,e,n){this.ctx.save(),t.filter(s).forEach(function(t){this.shape(t).clip()},this),e.call(n),this.ctx.restore()},a.prototype.shape=function(t){return this.ctx.beginPath(),t.forEach(function(t,e){"rect"===t[0]?this.ctx.rect.apply(this.ctx,t.slice(1)):this.ctx[0===e?"moveTo":t[0]+"To"].apply(this.ctx,t.slice(1))},this),this.ctx.closePath(),this.ctx},a.prototype.font=function(t,e,n,r,i,o){this.setFillStyle(t).font=[e,n,r,i,o].join(" ").split(",")[0]},a.prototype.fontShadow=function(t,e,n,r){this.setVariable("shadowColor",t.toString()).setVariable("shadowOffsetY",e).setVariable("shadowOffsetX",n).setVariable("shadowBlur",r)},a.prototype.clearShadow=function(){this.setVariable("shadowColor","rgba(0,0,0,0)")},a.prototype.setOpacity=function(t){this.ctx.globalAlpha=t},a.prototype.setTransform=function(t){this.ctx.translate(t.origin[0],t.origin[1]),this.ctx.transform.apply(this.ctx,t.matrix),this.ctx.translate(-t.origin[0],-t.origin[1])},a.prototype.setVariable=function(t,e){return this.variables[t]!==e&&(this.variables[t]=this.ctx[t]=e),this},a.prototype.text=function(t,e,n){this.ctx.fillText(t,e,n)},a.prototype.backgroundRepeatShape=function(t,e,n,r,i,o,a,s,h){var c=[["line",Math.round(i),Math.round(o)],["line",Math.round(i+a),Math.round(o)],["line",Math.round(i+a),Math.round(s+o)],["line",Math.round(i),Math.round(s+o)]];this.clip([c],function(){this.renderBackgroundRepeat(t,e,n,r,h[3],h[0])},this)},a.prototype.renderBackgroundRepeat=function(t,e,n,r,i,o){var a=Math.round(r.left+e.left+i),s=Math.round(r.top+e.top+o);this.setFillStyle(this.ctx.createPattern(this.resizeImage(t,n),"repeat")),this.ctx.translate(a,s),this.ctx.fill(),this.ctx.translate(-a,-s)},a.prototype.renderBackgroundGradient=function(t,e){if(t instanceof i){var n=this.ctx.createLinearGradient(e.left+e.width*t.x0,e.top+e.height*t.y0,e.left+e.width*t.x1,e.top+e.height*t.y1);t.colorStops.forEach(function(t){n.addColorStop(t.stop,t.color.toString())}),this.rectangle(e.left,e.top,e.width,e.height,n)}},a.prototype.resizeImage=function(t,e){var n=t.image;if(n.width===e.width&&n.height===e.height)return n;var r=document.createElement("canvas");return r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(n,0,0,n.width,n.height,0,0,e.width,e.height),r},e.exports=a},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(t,e,n){var i=t("./nodecontainer");function r(t,e,n,r){i.call(this,n,r),this.ownStacking=t,this.contexts=[],this.children=[],this.opacity=(this.parent?this.parent.stack.opacity:1)*e}(r.prototype=Object.create(i.prototype)).getParentStack=function(t){var e=this.parent?this.parent.stack:null;return e?e.ownStacking?e:e.getParentStack(t):t.stack},e.exports=r},{"./nodecontainer":14}],22:[function(t,e,n){function r(t){this.rangeBounds=this.testRangeBounds(t),this.cors=this.testCORS(),this.svg=this.testSVG()}r.prototype.testRangeBounds=function(t){var e,n,r=!1;return t.createRange&&(e=t.createRange()).getBoundingClientRect&&((n=t.createElement("boundtest")).style.height="123px",n.style.display="block",t.body.appendChild(n),e.selectNode(n),123===e.getBoundingClientRect().height&&(r=!0),t.body.removeChild(n)),r},r.prototype.testCORS=function(){return void 0!==(new Image).crossOrigin},r.prototype.testSVG=function(){var t=new Image,e=document.createElement("canvas"),n=e.getContext("2d");t.src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";try{n.drawImage(t,0,0),e.toDataURL()}catch(t){return!1}return!0},e.exports=r},{}],23:[function(t,e,n){var r=t("./xhr"),i=t("./utils").decode64;function o(t){this.src=t,this.image=null;var n=this;this.promise=this.hasFabric().then(function(){return n.isInline(t)?Promise.resolve(n.inlineFormatting(t)):r(t)}).then(function(e){return new Promise(function(t){window.html2canvas.svg.fabric.loadSVGFromString(e,n.createCanvas.call(n,t))})})}o.prototype.hasFabric=function(){return window.html2canvas.svg&&window.html2canvas.svg.fabric?Promise.resolve():Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg"))},o.prototype.inlineFormatting=function(t){return/^data:image\/svg\+xml;base64,/.test(t)?this.decode64(this.removeContentType(t)):this.removeContentType(t)},o.prototype.removeContentType=function(t){return t.replace(/^data:image\/svg\+xml(;base64)?,/,"")},o.prototype.isInline=function(t){return/^data:image\/svg\+xml/i.test(t)},o.prototype.createCanvas=function(r){var i=this;return function(t,e){var n=new window.html2canvas.svg.fabric.StaticCanvas("c");i.image=n.lowerCanvasEl,n.setWidth(e.width).setHeight(e.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(t,e)).renderAll(),r(n.lowerCanvasEl)}},o.prototype.decode64=function(t){return"function"==typeof window.atob?window.atob(t):i(t)},e.exports=o},{"./utils":26,"./xhr":28}],24:[function(t,e,n){var r=t("./svgcontainer");function i(n,t){this.src=n,this.image=null;var r=this;this.promise=t?new Promise(function(t,e){r.image=new Image,r.image.onload=t,r.image.onerror=e,r.image.src="data:image/svg+xml,"+(new XMLSerializer).serializeToString(n),!0===r.image.complete&&t(r.image)}):this.hasFabric().then(function(){return new Promise(function(t){window.html2canvas.svg.fabric.parseSVGDocument(n,r.createCanvas.call(r,t))})})}i.prototype=Object.create(r.prototype),e.exports=i},{"./svgcontainer":23}],25:[function(t,e,n){var r=t("./nodecontainer");function i(t,e){r.call(this,t,e)}function o(t,e,n){if(0<t.length)return e+n.toUpperCase()}(i.prototype=Object.create(r.prototype)).applyTextTransform=function(){this.node.data=this.transform(this.parent.css("textTransform"))},i.prototype.transform=function(t){var e=this.node.data;switch(t){case"lowercase":return e.toLowerCase();case"capitalize":return e.replace(/(^|\s|:|-|\(|\))([a-z])/g,o);case"uppercase":return e.toUpperCase();default:return e}},e.exports=i},{"./nodecontainer":14}],26:[function(t,e,n){n.smallImage=function(){return"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"},n.bind=function(t,e){return function(){return t.apply(e,arguments)}},
	/*
	   * base64-arraybuffer
	   * https://github.com/niklasvh/base64-arraybuffer
	   *
	   * Copyright (c) 2012 Niklas von Hertzen
	   * Licensed under the MIT license.
	   */
	n.decode64=function(t){var e,n,r,i,o,a,s,h="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",c=t.length,l="";for(e=0;e<c;e+=4)o=h.indexOf(t[e])<<2|(n=h.indexOf(t[e+1]))>>4,a=(15&n)<<4|(r=h.indexOf(t[e+2]))>>2,s=(3&r)<<6|(i=h.indexOf(t[e+3])),l+=64===r?String.fromCharCode(o):64===i||-1===i?String.fromCharCode(o,a):String.fromCharCode(o,a,s);return l},n.getBounds=function(t){if(t.getBoundingClientRect){var e=t.getBoundingClientRect(),n=null==t.offsetWidth?e.width:t.offsetWidth;return{top:e.top,bottom:e.bottom||e.top+e.height,right:e.left+n,left:e.left,width:n,height:null==t.offsetHeight?e.height:t.offsetHeight}}return{}},n.offsetBounds=function(t){var e=t.offsetParent?n.offsetBounds(t.offsetParent):{top:0,left:0};return{top:t.offsetTop+e.top,bottom:t.offsetTop+t.offsetHeight+e.top,right:t.offsetLeft+e.left+t.offsetWidth,left:t.offsetLeft+e.left,width:t.offsetWidth,height:t.offsetHeight}},n.parseBackgrounds=function(t){var e,n,r,i,o,a,s,h=[],c=0,l=0,u=function(){e&&('"'===n.substr(0,1)&&(n=n.substr(1,n.length-2)),n&&s.push(n),"-"===e.substr(0,1)&&0<(i=e.indexOf("-",1)+1)&&(r=e.substr(0,i),e=e.substr(i)),h.push({prefix:r,method:e.toLowerCase(),value:o,args:s,image:null})),s=[],e=r=n=o=""};return s=[],e=r=n=o="",t.split("").forEach(function(t){if(!(0===c&&-1<" \r\n\t".indexOf(t))){switch(t){case'"':a?a===t&&(a=null):a=t;break;case"(":if(a)break;if(0===c)return c=1,void(o+=t);l++;break;case")":if(a)break;if(1===c){if(0===l)return c=0,o+=t,void u();l--}break;case",":if(a)break;if(0===c)return void u();if(1===c&&0===l&&!e.match(/^url$/i))return s.push(n),n="",void(o+=t)}o+=t,0===c?e+=t:n+=t}}),u(),h}},{}],27:[function(t,e,n){var r=t("./gradientcontainer");function i(t){r.apply(this,arguments),this.type="linear"===t.args[0]?r.TYPES.LINEAR:r.TYPES.RADIAL}i.prototype=Object.create(r.prototype),e.exports=i},{"./gradientcontainer":9}],28:[function(t,e,n){e.exports=function(r){return new Promise(function(t,e){var n=new XMLHttpRequest;n.open("GET",r),n.onload=function(){200===n.status?t(n.responseText):e(new Error(n.statusText))},n.onerror=function(){e(new Error("Network Error"))},n.send()})}},{}]},{},[4])(4)}),function(t){var n="+".charCodeAt(0),r="/".charCodeAt(0),i="0".charCodeAt(0),o="a".charCodeAt(0),a="A".charCodeAt(0),s="-".charCodeAt(0),h="_".charCodeAt(0),l=function(t){var e=t.charCodeAt(0);return e===n||e===s?62:e===r||e===h?63:e<i?-1:e<i+10?e-i+26+26:e<a+26?e-a:e<o+26?e-o+26:void 0};t.API.TTFFont=function(){function i(t,e,n){var r;if(this.rawData=t,r=this.contents=new X(t),this.contents.pos=4,"ttcf"===r.readString(4)){if(!e)throw new Error("Must specify a font name for TTC files.");throw new Error("Font "+e+" not found in TTC file.")}r.pos=0,this.parse(),this.subset=new T(this),this.registerTTF()}return i.open=function(t,e,n,r){return new i(function(t){var e,n,r,i,o,a;if(0<t.length%4)throw new Error("Invalid string. Length must be a multiple of 4");var s=t.length;o="="===t.charAt(s-2)?2:"="===t.charAt(s-1)?1:0,a=new Uint8Array(3*t.length/4-o),r=0<o?t.length-4:t.length;var h=0;function c(t){a[h++]=t}for(n=e=0;e<r;e+=4,n+=3)c((16711680&(i=l(t.charAt(e))<<18|l(t.charAt(e+1))<<12|l(t.charAt(e+2))<<6|l(t.charAt(e+3))))>>16),c((65280&i)>>8),c(255&i);return 2===o?c(255&(i=l(t.charAt(e))<<2|l(t.charAt(e+1))>>4)):1===o&&(c((i=l(t.charAt(e))<<10|l(t.charAt(e+1))<<4|l(t.charAt(e+2))>>2)>>8&255),c(255&i)),a}(n),e,r)},i.prototype.parse=function(){return this.directory=new e(this.contents),this.head=new d(this),this.name=new b(this),this.cmap=new m(this),this.hhea=new g(this),this.maxp=new x(this),this.hmtx=new S(this),this.post=new y(this),this.os2=new w(this),this.loca=new C(this),this.glyf=new _(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},i.prototype.registerTTF=function(){var i,t,e,n,r;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.bbox).length;t<e;t++)i=n[t],r.push(Math.round(i*this.scaleFactor));return r}.call(this),this.stemV=0,this.post.exists?(e=255&(n=this.post.italic_angle),!0&(t=n>>16)&&(t=-(1+(65535^t))),this.italicAngle=+(t+"."+e)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(r=this.familyClass)||2===r||3===r||4===r||5===r||7===r,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},i.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},i.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},i.prototype.widthOfString=function(t,e,n){var r,i,o,a,s;for(i=a=o=0,s=(t=""+t).length;0<=s?a<s:s<a;i=0<=s?++a:--a)r=t.charCodeAt(i),o+=this.widthOfGlyph(this.characterToGlyph(r))+n*(1e3/e)||0;return o*(e/1e3)},i.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.decender)/1e3*t},i}();var c,X=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return 2147483648<=(t=this.readUInt32())?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return 32768<=(t=this.readUInt16())?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,n,r;for(n=[],e=r=0;0<=t?r<t:t<r;e=0<=t?++r:--r)n[e]=String.fromCharCode(this.readByte());return n.join("")},t.prototype.writeString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t.length;0<=r?n<r:r<n;e=0<=r?++n:--n)i.push(this.writeByte(t.charCodeAt(e)));return i},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,n,r,i,o,a,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),o=this.readByte(),a=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^o)+256*(255^a)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*o+256*a+s},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,n;for(e=[],n=0;0<=t?n<t:t<n;0<=t?++n:--n)e.push(this.readByte());return e},t.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},t}(),e=function(){var p;function t(t){var e,n,r;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},n=0,r=this.tableCount;0<=r?n<r:r<n;0<=r?++n:--n)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return t.prototype.encode=function(t){var e,n,r,i,o,a,s,h,c,l,u,f,d;for(d in u=Object.keys(t).length,a=Math.log(2),c=16*Math.floor(Math.log(u)/a),i=Math.floor(c/a),h=16*u-c,(n=new X).writeInt(this.scalarType),n.writeShort(u),n.writeShort(c),n.writeShort(i),n.writeShort(h),r=16*u,s=n.pos+r,o=null,f=[],t)for(l=t[d],n.writeString(d),n.writeInt(p(l)),n.writeInt(s),n.writeInt(l.length),f=f.concat(l),"head"===d&&(o=s),s+=l.length;s%4;)f.push(0),s++;return n.write(f),e=2981146554-p(n.data),n.pos=o+8,n.writeUInt32(e),n.data},p=function(t){var e,n,r,i;for(t=k.call(t);t.length%4;)t.push(0);for(n=new X(t),r=e=0,i=t.length;r<i;r+=4)e+=n.readUInt32();return 4294967295&e},t}(),u={}.hasOwnProperty,f=function(t,e){for(var n in e)u.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t};c=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var d=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e}(),p=function(){function t(n,t){var e,r,i,o,a,s,h,c,l,u,f,d,p,g,m,w,y,v;switch(this.platformID=n.readUInt16(),this.encodingID=n.readShort(),this.offset=t+n.readInt(),l=n.pos,n.pos=this.offset,this.format=n.readUInt16(),this.length=n.readUInt16(),this.language=n.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=m=0;m<256;s=++m)this.codeMap[s]=n.readByte();break;case 4:for(f=n.readUInt16(),u=f/2,n.pos+=6,i=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),n.pos+=2,p=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),h=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),c=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),r=(this.length-n.pos+this.offset)/2,a=function(){var t,e;for(e=[],s=t=0;0<=r?t<r:r<t;s=0<=r?++t:--t)e.push(n.readUInt16());return e}(),s=w=0,v=i.length;w<v;s=++w)for(g=i[s],e=y=d=p[s];d<=g?y<=g:g<=y;e=d<=g?++y:--y)0===c[s]?o=e+h[s]:0!==(o=a[c[s]/2+(e-d)-(u-s)]||0)&&(o+=h[s]),this.codeMap[e]=65535&o}n.pos=l}return t.encode=function(t,e){var n,r,i,o,a,s,h,c,l,u,f,d,p,g,m,w,y,v,b,x,S,k,_,A,I,C,T,F,P,E,q,O,B,R,j,D,M,U,N,z,L,H,W,G,V,Y;switch(F=new X,o=Object.keys(t).sort(function(t,e){return t-e}),e){case"macroman":for(p=0,g=function(){var t,e;for(e=[],d=t=0;t<256;d=++t)e.push(0);return e}(),w={0:0},i={},P=0,B=o.length;P<B;P++)null==w[W=t[r=o[P]]]&&(w[W]=++p),i[r]={old:t[r],new:w[t[r]]},g[r]=w[t[r]];return F.writeUInt16(1),F.writeUInt16(0),F.writeUInt32(12),F.writeUInt16(0),F.writeUInt16(262),F.writeUInt16(0),F.write(g),{charMap:i,subtable:F.data,maxGlyphID:p+1};case"unicode":for(C=[],l=[],w={},n={},m=h=null,E=y=0,R=o.length;E<R;E++)null==w[b=t[r=o[E]]]&&(w[b]=++y),n[r]={old:b,new:w[b]},a=w[b]-r,null!=m&&a===h||(m&&l.push(m),C.push(r),h=a),m=r;for(m&&l.push(m),l.push(65535),C.push(65535),A=2*(_=C.length),k=2*Math.pow(Math.log(_)/Math.LN2,2),u=Math.log(k/2)/Math.LN2,S=2*_-k,s=[],x=[],f=[],d=q=0,j=C.length;q<j;d=++q){if(I=C[d],c=l[d],65535===I){s.push(0),x.push(0);break}if(32768<=I-(T=n[I].new))for(s.push(0),x.push(2*(f.length+_-d)),r=O=I;I<=c?O<=c:c<=O;r=I<=c?++O:--O)f.push(n[r].new);else s.push(T-I),x.push(0)}for(F.writeUInt16(3),F.writeUInt16(1),F.writeUInt32(12),F.writeUInt16(4),F.writeUInt16(16+8*_+2*f.length),F.writeUInt16(0),F.writeUInt16(A),F.writeUInt16(k),F.writeUInt16(u),F.writeUInt16(S),L=0,D=l.length;L<D;L++)r=l[L],F.writeUInt16(r);for(F.writeUInt16(0),H=0,M=C.length;H<M;H++)r=C[H],F.writeUInt16(r);for(G=0,U=s.length;G<U;G++)a=s[G],F.writeUInt16(a);for(V=0,N=x.length;V<N;V++)v=x[V],F.writeUInt16(v);for(Y=0,z=f.length;Y<z;Y++)p=f[Y],F.writeUInt16(p);return{charMap:n,subtable:F.data,maxGlyphID:y+1}}},t}(),m=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,n,r;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:n<r;0<=n?++r:--r)e=new p(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var n,r;return null==e&&(e="macroman"),n=p.encode(t,e),(r=new X).writeUInt16(0),r.writeUInt16(1),n.table=r.data.concat(n.subtable),n},e}(),g=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),w=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="OS/2",e.prototype.parse=function(n){if(n.pos=this.offset,this.version=n.readUInt16(),this.averageCharWidth=n.readShort(),this.weightClass=n.readUInt16(),this.widthClass=n.readUInt16(),this.type=n.readShort(),this.ySubscriptXSize=n.readShort(),this.ySubscriptYSize=n.readShort(),this.ySubscriptXOffset=n.readShort(),this.ySubscriptYOffset=n.readShort(),this.ySuperscriptXSize=n.readShort(),this.ySuperscriptYSize=n.readShort(),this.ySuperscriptXOffset=n.readShort(),this.ySuperscriptYOffset=n.readShort(),this.yStrikeoutSize=n.readShort(),this.yStrikeoutPosition=n.readShort(),this.familyClass=n.readShort(),this.panose=function(){var t,e;for(e=[],t=0;t<10;++t)e.push(n.readByte());return e}(),this.charRange=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(n.readInt());return e}(),this.vendorID=n.readString(4),this.selection=n.readShort(),this.firstCharIndex=n.readShort(),this.lastCharIndex=n.readShort(),0<this.version&&(this.ascent=n.readShort(),this.descent=n.readShort(),this.lineGap=n.readShort(),this.winAscent=n.readShort(),this.winDescent=n.readShort(),this.codePageRange=function(){var t,e;for(e=[],t=0;t<2;++t)e.push(n.readInt());return e}(),1<this.version))return this.xHeight=n.readShort(),this.capHeight=n.readShort(),this.defaultChar=n.readShort(),this.breakChar=n.readShort(),this.maxContext=n.readShort()},e}(),y=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="post",e.prototype.parse=function(r){var t,e,n,i;switch(r.pos=this.offset,this.format=r.readInt(),this.italicAngle=r.readInt(),this.underlinePosition=r.readShort(),this.underlineThickness=r.readShort(),this.isFixedPitch=r.readInt(),this.minMemType42=r.readInt(),this.maxMemType42=r.readInt(),this.minMemType1=r.readInt(),this.maxMemType1=r.readInt(),this.format){case 65536:break;case 131072:for(e=r.readUInt16(),this.glyphNameIndex=[],n=0;0<=e?n<e:e<n;0<=e?++n:--n)this.glyphNameIndex.push(r.readUInt16());for(this.names=[],i=[];r.pos<this.offset+this.length;)t=r.readByte(),i.push(this.names.push(r.readString(t)));return i;case 151552:return e=r.readUInt16(),this.offsets=r.read(e);case 196608:break;case 262144:return this.map=function(){var t,e,n;for(n=[],t=0,e=this.file.maxp.numGlyphs;0<=e?t<e:e<t;0<=e?++t:--t)n.push(r.readUInt32());return n}.call(this)}},e}(),v=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},b=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="name",e.prototype.parse=function(t){var e,n,r,i,o,a,s,h,c,l,u,f;for(t.pos=this.offset,t.readShort(),e=t.readShort(),a=t.readShort(),n=[],i=c=0;0<=e?c<e:e<c;i=0<=e?++c:--c)n.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+a+t.readShort()});for(s={},i=l=0,u=n.length;l<u;i=++l)r=n[i],t.pos=r.offset,h=t.readString(r.length),o=new v(h,r),null==s[f=r.nameID]&&(s[f]=[]),s[r.nameID].push(o);return this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5],this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,""),this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),x=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),S=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="hmtx",e.prototype.parse=function(n){var t,r,i,e,o,a,s;for(n.pos=this.offset,this.metrics=[],e=0,a=this.file.hhea.numberOfMetrics;0<=a?e<a:a<e;0<=a?++e:--e)this.metrics.push({advance:n.readUInt16(),lsb:n.readInt16()});for(r=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var t,e;for(e=[],t=0;0<=r?t<r:r<t;0<=r?++t:--t)e.push(n.readInt16());return e}(),this.widths=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.metrics).length;t<e;t++)i=n[t],r.push(i.advance);return r}.call(this),t=this.widths[this.widths.length-1],s=[],o=0;0<=r?o<r:r<o;0<=r?++o:--o)s.push(this.widths.push(t));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),k=[].slice,_=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="glyf",e.prototype.parse=function(t){return this.cache={}},e.prototype.glyphFor=function(t){var e,n,r,i,o,a,s,h,c,l;return(t=t)in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,n=i.indexOf(t),0===(r=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+n,o=(a=new X(e.read(r))).readShort(),h=a.readShort(),l=a.readShort(),s=a.readShort(),c=a.readShort(),this.cache[t]=-1===o?new I(a,h,l,s,c):new A(a,o,h,l,s,c),this.cache[t]))},e.prototype.encode=function(t,e,n){var r,i,o,a,s;for(o=[],i=[],a=0,s=e.length;a<s;a++)r=t[e[a]],i.push(o.length),r&&(o=o.concat(r.encode(n)));return i.push(o.length),{table:o,offsets:i}},e}(),A=function(){function t(t,e,n,r,i,o){this.raw=t,this.numberOfContours=e,this.xMin=n,this.yMin=r,this.xMax=i,this.yMax=o,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),I=function(){function t(t,e,n,r,i){var o,a;for(this.raw=t,this.xMin=e,this.yMin=n,this.xMax=r,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],o=this.raw;a=o.readShort(),this.glyphOffsets.push(o.pos),this.glyphIDs.push(o.readShort()),32&a;)o.pos+=1&a?4:2,128&a?o.pos+=8:64&a?o.pos+=4:8&a&&(o.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(t){var e,n,r,i,o;for(n=new X(k.call(this.raw.data)),e=r=0,i=(o=this.glyphIDs).length;r<i;e=++r)o[e],n.pos=this.glyphOffsets[e];return n.data},t}(),C=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="loca",e.prototype.parse=function(r){var t;return r.pos=this.offset,t=this.file.head.indexToLocFormat,this.offsets=0===t?function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=2)n.push(2*r.readUInt16());return n}.call(this):function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=4)n.push(r.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var n=new Uint32Array(this.offsets.length),r=0,i=0,o=0;o<n.length;++o)if(n[o]=r,i<e.length&&e[i]==o){++i,n[o]=r;var a=this.offsets[o],s=this.offsets[o+1]-a;0<s&&(r+=s)}for(var h=new Array(4*n.length),c=0;c<n.length;++c)h[4*c+3]=255&n[c],h[4*c+2]=(65280&n[c])>>8,h[4*c+1]=(16711680&n[c])>>16,h[4*c]=(4278190080&n[c])>>24;return h},e}(),T=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,n,r,i;for(e in r=this.font.cmap.tables[0].codeMap,t={},i=this.subset)n=i[e],t[e]=r[n];return t},t.prototype.glyphsFor=function(t){var e,n,r,i,o,a,s;for(r={},o=0,a=t.length;o<a;o++)r[i=t[o]]=this.font.glyf.glyphFor(i);for(i in e=[],r)(null!=(n=r[i])?n.compound:void 0)&&e.push.apply(e,n.glyphIDs);if(0<e.length)for(i in s=this.glyphsFor(e))n=s[i],r[i]=n;return r},t.prototype.encode=function(t){var e,n,r,i,o,a,s,h,c,l,u,f,d,p,g;for(n in e=m.encode(this.generateCmap(),"unicode"),i=this.glyphsFor(t),u={0:0},g=e.charMap)u[(a=g[n]).old]=a.new;for(f in l=e.maxGlyphID,i)f in u||(u[f]=l++);return h=function(t){var e,n;for(e in n={},t)n[t[e]]=e;return n}(u),c=Object.keys(h).sort(function(t,e){return t-e}),d=function(){var t,e,n;for(n=[],t=0,e=c.length;t<e;t++)o=c[t],n.push(h[o]);return n}(),r=this.font.glyf.encode(i,d,u),s=this.font.loca.encode(r.offsets,d),p={cmap:this.font.cmap.raw(),glyf:r.table,loca:s,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.raw()},this.font.os2.exists&&(p["OS/2"]=this.font.os2.raw()),this.font.directory.encode(p)},t}();t.API.PDFObject=function(){var o;function a(){}return o=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},a.convert=function(r){var i,t,e,n;if(Array.isArray(r))return"["+function(){var t,e,n;for(n=[],t=0,e=r.length;t<e;t++)i=r[t],n.push(a.convert(i));return n}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+o(r.getUTCFullYear(),4)+o(r.getUTCMonth(),2)+o(r.getUTCDate(),2)+o(r.getUTCHours(),2)+o(r.getUTCMinutes(),2)+o(r.getUTCSeconds(),2)+"Z)";if("[object Object]"==={}.toString.call(r)){for(t in e=["<<"],r)n=r[t],e.push("/"+t+" "+a.convert(n));return e.push(">>"),e.join("\n")}return""+r},a}()}($),
	/*
	  # PNG.js
	  # Copyright (c) 2011 Devon Govett
	  # MIT LICENSE
	  # 
	  # 
	  */
	pt="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),gt=function(){var c,n,r;function i(t){var e,n,r,i,o,a,s,h,c,l,u,f,d,p;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),c=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===c&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,f=0;0<=e?f<e:e<f;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(0<(l=r-this.transparency.indexed.length))for(d=0;0<=l?d<l:l<d;0<=l?++d:--d)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(u=this.read(e)).indexOf(0),h=String.fromCharCode.apply(String,u.slice(0,s)),this.text[h]=String.fromCharCode.apply(String,u.slice(s+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(p=this.colorType)||6===p,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}i.load=function(t,e,n){var r;return"function"==typeof e&&(n=e),(r=new XMLHttpRequest).open("GET",t,!0),r.responseType="arraybuffer",r.onload=function(){var t;return t=new i(new Uint8Array(r.response||r.mozResponseArrayBuffer)),"function"==typeof(null!=e?e.getContext:void 0)&&t.render(e),"function"==typeof n?n(t):void 0},r.send(null)},i.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},i.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.decodePixels=function(E){var q=this.pixelBitlength/8,O=new Uint8Array(this.width*this.height*q),B=0,R=this;if(null==E&&(E=this.imgData),0===E.length)return new Uint8Array(0);function t(t,e,n,r){var i,o,a,s,h,c,l,u,f,d,p,g,m,w,y,v,b,x,S,k,_,A=Math.ceil((R.width-t)/n),I=Math.ceil((R.height-e)/r),C=R.width==A&&R.height==I;for(w=q*A,g=C?O:new Uint8Array(w*I),c=E.length,o=m=0;m<I&&B<c;){switch(E[B++]){case 0:for(s=b=0;b<w;s=b+=1)g[o++]=E[B++];break;case 1:for(s=x=0;x<w;s=x+=1)i=E[B++],h=s<q?0:g[o-q],g[o++]=(i+h)%256;break;case 2:for(s=S=0;S<w;s=S+=1)i=E[B++],a=(s-s%q)/q,y=m&&g[(m-1)*w+a*q+s%q],g[o++]=(y+i)%256;break;case 3:for(s=k=0;k<w;s=k+=1)i=E[B++],a=(s-s%q)/q,h=s<q?0:g[o-q],y=m&&g[(m-1)*w+a*q+s%q],g[o++]=(i+Math.floor((h+y)/2))%256;break;case 4:for(s=_=0;_<w;s=_+=1)i=E[B++],a=(s-s%q)/q,h=s<q?0:g[o-q],0===m?y=v=0:(y=g[(m-1)*w+a*q+s%q],v=a&&g[(m-1)*w+(a-1)*q+s%q]),l=h+y-v,u=Math.abs(l-h),d=Math.abs(l-y),p=Math.abs(l-v),f=u<=d&&u<=p?h:d<=p?y:v,g[o++]=(i+f)%256;break;default:throw new Error("Invalid filter algorithm: "+E[B-1])}if(!C){var T=((e+m*r)*R.width+t)*q,F=m*w;for(s=0;s<A;s+=1){for(var P=0;P<q;P+=1)O[T++]=g[F++];T+=(n-1)*q}}m++}}return E=(E=new kt(E)).getBytes(),1==R.interlaceMethod?(t(0,0,8,8),t(4,0,8,8),t(0,4,4,8),t(2,0,4,4),t(0,2,2,4),t(1,0,2,2),t(0,1,1,2)):t(0,0,1,1),O},i.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,h;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,n.length,e=a=t=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(h=o[t++])?h:255;return i},i.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,h,c,l,u,f;if(r=this.colors,l=null,n=this.hasAlphaChannel,this.palette.length&&(l=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),c=(i=t.data||t).length,a=l||e,o=s=0,1===r)for(;o<c;)h=l?4*e[o/4]:s,u=a[h++],i[o++]=u,i[o++]=u,i[o++]=u,i[o++]=n?a[h++]:255,s=h;else for(;o<c;)h=l?4*e[o/4]:s,i[o++]=a[h++],i[o++]=a[h++],i[o++]=a[h++],i[o++]=n?a[h++]:255,s=h},i.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{n=pt.document.createElement("canvas"),r=n.getContext("2d")}catch(t){return-1}return c=function(t){var e;return r.width=t.width,r.height=t.height,r.clearRect(0,0,t.width,t.height),r.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e},i.prototype.decodeFrames=function(t){var e,n,r,i,o,a,s,h;if(this.animation){for(h=[],n=o=0,a=(s=this.animation.frames).length;o<a;n=++o)e=s[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,h.push(e.image=c(r));return h}},i.prototype.renderFrame=function(t,e){var n,r,i;return n=(r=this.animation.frames)[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},i.prototype.animate=function(n){var r,i,o,a,s,t,h=this;return i=0,t=this.animation,a=t.numFrames,o=t.frames,s=t.numPlays,(r=function(){var t,e;if(t=i++%a,e=o[t],h.renderFrame(n,t),1<a&&i/a<s)return h.animation._timeout=setTimeout(r,e.delay)})()},i.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},i.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},i}(),pt.PNG=gt;
	/*
	   * Extracted from pdf.js
	   * https://github.com/andreasgal/pdf.js
	   *
	   * Copyright (c) 2011 Mozilla Foundation
	   *
	   * Contributors: Andreas Gal <gal@mozilla.com>
	   *               Chris G Jones <cjones@mozilla.com>
	   *               Shaon Barman <shaon.barman@gmail.com>
	   *               Vivien Nicolas <21@vingtetun.org>
	   *               Justin D'Arcangelo <justindarc@gmail.com>
	   *               Yury Delendik
	   *
	   * 
	   */
	var St=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;r<n&&(n=r)}else{for(;!this.eof;)this.readBlock();n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),kt=function(){if("undefined"!=typeof Uint32Array){var F=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),P=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),E=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),q=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],O=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return(t.prototype=Object.create(St.prototype)).getBits=function(t){for(var e,n=this.codeSize,r=this.codeBuf,i=this.bytes,o=this.bytesPos;n<t;)void 0===(e=i[o++])&&B("Bad encoding in flate stream"),r|=e<<n,n+=8;return e=r&(1<<t)-1,this.codeBuf=r>>t,this.codeSize=n-=t,this.bytesPos=o,e},t.prototype.getCode=function(t){for(var e=t[0],n=t[1],r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<n;){var s;void 0===(s=o[a++])&&B("Bad encoding in flate stream"),i|=s<<r,r+=8}var h=e[i&(1<<n)-1],c=h>>16,l=65535&h;return(0==r||r<c||0==c)&&B("Bad encoding in flate stream"),this.codeBuf=i>>c,this.codeSize=r-c,this.bytesPos=a,l},t.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,h=2;a<=n;++a,s<<=1,h<<=1)for(var c=0;c<e;++c)if(t[c]==a){var l=0,u=s;for(r=0;r<a;++r)l=l<<1|1&u,u>>=1;for(r=l;r<i;r+=h)o[r]=a<<16|c;++s}return[o,n]},t.prototype.readBlock=function(){function t(t,e,n,r,i){for(var o=t.getBits(n)+r;0<o--;)e[h++]=i}var e=this.getBits(3);if(1&e&&(this.eof=!0),0!=(e>>=1)){var n,r;if(1==e)n=q,r=O;else if(2==e){for(var i=this.getBits(5)+257,o=this.getBits(5)+1,a=this.getBits(4)+4,s=Array(F.length),h=0;h<a;)s[F[h++]]=this.getBits(3);for(var c=this.generateHuffmanTable(s),l=0,u=(h=0,i+o),f=new Array(u);h<u;){var d=this.getCode(c);16==d?t(this,f,2,3,l):17==d?t(this,f,3,3,l=0):18==d?t(this,f,7,11,l=0):f[h++]=l=d}n=this.generateHuffmanTable(f.slice(0,i)),r=this.generateHuffmanTable(f.slice(i,u))}else B("Unknown block type in flate stream");for(var p=(I=this.buffer)?I.length:0,g=this.bufferLength;;){var m=this.getCode(n);if(m<256)p<=g+1&&(p=(I=this.ensureBuffer(g+1)).length),I[g++]=m;else{if(256==m)return void(this.bufferLength=g);var w=(m=P[m-=257])>>16;0<w&&(w=this.getBits(w));l=(65535&m)+w;m=this.getCode(r),0<(w=(m=E[m])>>16)&&(w=this.getBits(w));var y=(65535&m)+w;p<=g+l&&(p=(I=this.ensureBuffer(g+l)).length);for(var v=0;v<l;++v,++g)I[g]=I[g-y]}}}else{var b,x=this.bytes,S=this.bytesPos;void 0===(b=x[S++])&&B("Bad block header in flate stream");var k=b;void 0===(b=x[S++])&&B("Bad block header in flate stream"),k|=b<<8,void 0===(b=x[S++])&&B("Bad block header in flate stream");var _=b;void 0===(b=x[S++])&&B("Bad block header in flate stream"),(_|=b<<8)!=(65535&~k)&&B("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var A=this.bufferLength,I=this.ensureBuffer(A+k),C=A+k;this.bufferLength=C;for(var T=A;T<C;++T){if(void 0===(b=x[S++])){this.eof=!0;break}I[T]=b}this.bytesPos=S}},t}function B(t){throw new Error(t)}function t(t){var e=0,n=t[e++],r=t[e++];-1!=n&&-1!=r||B("Invalid header in flate stream"),8!=(15&n)&&B("Unknown compression method in flate stream"),((n<<8)+r)%31!=0&&B("Bad FCHECK in flate stream"),32&r&&B("FDICT bit set in flate stream"),this.bytes=t,this.bytesPos=2,this.codeSize=0,this.codeBuf=0,St.call(this)}}();return function(t){if("object"!=typeof t.console){t.console={};for(var e,n,r=t.console,i=function(){},o=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=o.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=i)}var s,h,c,l,u="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var e,n,r,i,o,a=0,s=0,h="",c=[];if(!t)return t;for(;e=(o=t.charCodeAt(a++)<<16|t.charCodeAt(a++)<<8|t.charCodeAt(a++))>>18&63,n=o>>12&63,r=o>>6&63,i=63&o,c[s++]=u.charAt(e)+u.charAt(n)+u.charAt(r)+u.charAt(i),a<t.length;);h=c.join("");var l=t.length%3;return(l?h.slice(0,l-3):h)+"===".slice(l||3)}),void 0===t.atob&&(t.atob=function(t){var e,n,r,i,o,a,s=0,h=0,c=[];if(!t)return t;for(t+="";e=(a=u.indexOf(t.charAt(s++))<<18|u.indexOf(t.charAt(s++))<<12|(i=u.indexOf(t.charAt(s++)))<<6|(o=u.indexOf(t.charAt(s++))))>>16&255,n=a>>8&255,r=255&a,c[h++]=64==i?String.fromCharCode(e):64==o?String.fromCharCode(e,n):String.fromCharCode(e,n,r),s<t.length;);return c.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(null==this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=1<arguments.length?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(null==this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Object.keys||(Object.keys=(s=Object.prototype.hasOwnProperty,h=!{toString:null}.propertyIsEnumerable("toString"),l=(c=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(t){if("object"!=typeof t&&("function"!=typeof t||null===t))throw new TypeError;var e,n,r=[];for(e in t)s.call(t,e)&&r.push(e);if(h)for(n=0;n<l;n++)s.call(t,c[n])&&r.push(c[n]);return r})),"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var e=1;e<arguments.length;e++){var n=arguments[e];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")})}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),$});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(68)))

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	// Load in dependencies
	var computedStyle = __webpack_require__(361);
	
	/**
	 * Calculate the `line-height` of a given node
	 * @param {HTMLElement} node Element to calculate line height of. Must be in the DOM.
	 * @returns {Number} `line-height` of the element in pixels
	 */
	function lineHeight(node) {
	  // Grab the line-height via style
	  var lnHeightStr = computedStyle(node, 'line-height');
	  var lnHeight = parseFloat(lnHeightStr, 10);
	
	  // If the lineHeight did not contain a unit (i.e. it was numeric), convert it to ems (e.g. '2.3' === '2.3em')
	  if (lnHeightStr === lnHeight + '') {
	    // Save the old lineHeight style and update the em unit to the element
	    var _lnHeightStyle = node.style.lineHeight;
	    node.style.lineHeight = lnHeightStr + 'em';
	
	    // Calculate the em based height
	    lnHeightStr = computedStyle(node, 'line-height');
	    lnHeight = parseFloat(lnHeightStr, 10);
	
	    // Revert the lineHeight style
	    if (_lnHeightStyle) {
	      node.style.lineHeight = _lnHeightStyle;
	    } else {
	      delete node.style.lineHeight;
	    }
	  }
	
	  // If the lineHeight is in `pt`, convert it to pixels (4px for 3pt)
	  // DEV: `em` units are converted to `pt` in IE6
	  // Conversion ratio from https://developer.mozilla.org/en-US/docs/Web/CSS/length
	  if (lnHeightStr.indexOf('pt') !== -1) {
	    lnHeight *= 4;
	    lnHeight /= 3;
	  // Otherwise, if the lineHeight is in `mm`, convert it to pixels (96px for 25.4mm)
	  } else if (lnHeightStr.indexOf('mm') !== -1) {
	    lnHeight *= 96;
	    lnHeight /= 25.4;
	  // Otherwise, if the lineHeight is in `cm`, convert it to pixels (96px for 2.54cm)
	  } else if (lnHeightStr.indexOf('cm') !== -1) {
	    lnHeight *= 96;
	    lnHeight /= 2.54;
	  // Otherwise, if the lineHeight is in `in`, convert it to pixels (96px for 1in)
	  } else if (lnHeightStr.indexOf('in') !== -1) {
	    lnHeight *= 96;
	  // Otherwise, if the lineHeight is in `pc`, convert it to pixels (12pt for 1pc)
	  } else if (lnHeightStr.indexOf('pc') !== -1) {
	    lnHeight *= 16;
	  }
	
	  // Continue our computation
	  lnHeight = Math.round(lnHeight);
	
	  // If the line-height is "normal", calculate by font-size
	  if (lnHeightStr === 'normal') {
	    // Create a temporary node
	    var nodeName = node.nodeName;
	    var _node = document.createElement(nodeName);
	    _node.innerHTML = '&nbsp;';
	
	    // If we have a text area, reset it to only 1 row
	    // https://github.com/twolfson/line-height/issues/4
	    if (nodeName.toUpperCase() === 'TEXTAREA') {
	      _node.setAttribute('rows', '1');
	    }
	
	    // Set the font-size of the element
	    var fontSizeStr = computedStyle(node, 'font-size');
	    _node.style.fontSize = fontSizeStr;
	
	    // Remove default padding/border which can affect offset height
	    // https://github.com/twolfson/line-height/issues/4
	    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetHeight
	    _node.style.padding = '0px';
	    _node.style.border = '0px';
	
	    // Append it to the body
	    var body = document.body;
	    body.appendChild(_node);
	
	    // Assume the line height of the element is the height
	    var height = _node.offsetHeight;
	    lnHeight = height;
	
	    // Remove our child from the DOM
	    body.removeChild(_node);
	  }
	
	  // Return the calculated height
	  return lnHeight;
	}
	
	// Export lineHeight
	module.exports = lineHeight;


/***/ },
/* 451 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = baseFor;


/***/ },
/* 452 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseFor = __webpack_require__(451),
	    isArguments = __webpack_require__(200),
	    keysIn = __webpack_require__(454);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(200),
	    isArray = __webpack_require__(452);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(66),
	    root = __webpack_require__(32);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(66),
	    root = __webpack_require__(32);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(66),
	    root = __webpack_require__(32);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(66),
	    root = __webpack_require__(32);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(66),
	    root = __webpack_require__(32);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(468),
	    isArguments = __webpack_require__(210),
	    isArray = __webpack_require__(67),
	    isBuffer = __webpack_require__(211),
	    isIndex = __webpack_require__(475),
	    isTypedArray = __webpack_require__(214);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 461 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(461),
	    baseIsNaN = __webpack_require__(465),
	    strictIndexOf = __webpack_require__(479);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(205),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ },
/* 465 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(56),
	    isMasked = __webpack_require__(476),
	    isObject = __webpack_require__(122),
	    toSource = __webpack_require__(209);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    isLength = __webpack_require__(212),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 468 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(118),
	    arrayMap = __webpack_require__(201),
	    isArray = __webpack_require__(67),
	    isSymbol = __webpack_require__(124);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(201);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(32);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(208);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(118);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 474 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 475 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(471);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(208);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 478 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 479 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(462),
	    isArrayLike = __webpack_require__(120),
	    isString = __webpack_require__(123),
	    toInteger = __webpack_require__(488),
	    values = __webpack_require__(491);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(202),
	    getTag = __webpack_require__(205),
	    isArguments = __webpack_require__(210),
	    isArray = __webpack_require__(67),
	    isArrayLike = __webpack_require__(120),
	    isBuffer = __webpack_require__(211),
	    isPrototype = __webpack_require__(206),
	    isTypedArray = __webpack_require__(214);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 482 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	 * @example
	 *
	 * _.isNull(null);
	 * // => true
	 *
	 * _.isNull(void 0);
	 * // => false
	 */
	function isNull(value) {
	  return value === null;
	}
	
	module.exports = isNull;


/***/ },
/* 483 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(460),
	    baseKeys = __webpack_require__(202),
	    isArrayLike = __webpack_require__(120);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 485 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 486 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(489);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(487);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(122),
	    isSymbol = __webpack_require__(124);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(469);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(470),
	    keys = __webpack_require__(484);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 492 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(494)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 494 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(215);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(215);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(498);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 498 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	var styles = {
	  base: {
	    position: 'absolute',
	    userSelect: 'none',
	    MsUserSelect: 'none'
	  },
	  top: {
	    width: '100%',
	    height: '10px',
	    top: '-5px',
	    left: '0px',
	    cursor: 'row-resize'
	  },
	  right: {
	    width: '10px',
	    height: '100%',
	    top: '0px',
	    right: '-5px',
	    cursor: 'col-resize'
	  },
	  bottom: {
	    width: '100%',
	    height: '10px',
	    bottom: '-5px',
	    left: '0px',
	    cursor: 'row-resize'
	  },
	  left: {
	    width: '10px',
	    height: '100%',
	    top: '0px',
	    left: '-5px',
	    cursor: 'col-resize'
	  },
	  topRight: {
	    width: '20px',
	    height: '20px',
	    position: 'absolute',
	    right: '-10px',
	    top: '-10px',
	    cursor: 'ne-resize'
	  },
	  bottomRight: {
	    width: '20px',
	    height: '20px',
	    position: 'absolute',
	    right: '-10px',
	    bottom: '-10px',
	    cursor: 'se-resize'
	  },
	  bottomLeft: {
	    width: '20px',
	    height: '20px',
	    position: 'absolute',
	    left: '-10px',
	    bottom: '-10px',
	    cursor: 'sw-resize'
	  },
	  topLeft: {
	    width: '20px',
	    height: '20px',
	    position: 'absolute',
	    left: '-10px',
	    top: '-10px',
	    cursor: 'nw-resize'
	  }
	};
	
	var Resizer = (function (props) {
	  return React.createElement(
	    'div',
	    {
	      className: props.className,
	      style: _extends({}, styles.base, styles[props.direction], props.replaceStyles || {}),
	      onMouseDown: function onMouseDown(e) {
	        props.onResizeStart(e, props.direction);
	      },
	      onTouchStart: function onTouchStart(e) {
	        props.onResizeStart(e, props.direction);
	      }
	    },
	    props.children
	  );
	});
	
	var userSelectNone = {
	  userSelect: 'none',
	  MozUserSelect: 'none',
	  WebkitUserSelect: 'none',
	  MsUserSelect: 'none'
	};
	
	var userSelectAuto = {
	  userSelect: 'auto',
	  MozUserSelect: 'auto',
	  WebkitUserSelect: 'auto',
	  MsUserSelect: 'auto'
	};
	
	var clamp = function clamp(n, min, max) {
	  return Math.max(Math.min(n, max), min);
	};
	var snap = function snap(n, size) {
	  return Math.round(n / size) * size;
	};
	
	var endsWith = function endsWith(str, searchStr) {
	  return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
	};
	
	var getStringSize = function getStringSize(n) {
	  if (endsWith(n.toString(), 'px')) return n.toString();
	  if (endsWith(n.toString(), '%')) return n.toString();
	  return n + 'px';
	};
	
	var definedProps = ['style', 'className', 'grid', 'bounds', 'size', 'defaultSize', 'minWidth', 'minHeight', 'maxWidth', 'maxHeight', 'lockAspectRatio', 'lockAspectRatioExtraWidth', 'lockAspectRatioExtraHeight', 'enable', 'handleStyles', 'handleClasses', 'handleWrapperStyle', 'handleWrapperClass', 'children', 'onResizeStart', 'onResize', 'onResizeStop', 'handleComponent'];
	
	var baseClassName = '__resizable_base__';
	
	var Resizable = function (_React$Component) {
	  inherits(Resizable, _React$Component);
	
	  function Resizable(props) {
	    classCallCheck(this, Resizable);
	
	    var _this = possibleConstructorReturn(this, (Resizable.__proto__ || Object.getPrototypeOf(Resizable)).call(this, props));
	
	    _this.state = {
	      isResizing: false,
	      resizeCursor: 'auto',
	      width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
	      height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
	      direction: 'right',
	      original: {
	        x: 0,
	        y: 0,
	        width: 0,
	        height: 0
	      }
	    };
	
	    _this.updateExtendsProps(props);
	    _this.onResizeStart = _this.onResizeStart.bind(_this);
	    _this.onMouseMove = _this.onMouseMove.bind(_this);
	    _this.onMouseUp = _this.onMouseUp.bind(_this);
	
	    if (typeof window !== 'undefined') {
	      window.addEventListener('mouseup', _this.onMouseUp);
	      window.addEventListener('mousemove', _this.onMouseMove);
	      window.addEventListener('mouseleave', _this.onMouseUp);
	      window.addEventListener('touchmove', _this.onMouseMove);
	      window.addEventListener('touchend', _this.onMouseUp);
	    }
	    return _this;
	  }
	
	  createClass(Resizable, [{
	    key: 'updateExtendsProps',
	    value: function updateExtendsProps(props) {
	      this.extendsProps = Object.keys(props).reduce(function (acc, key) {
	        if (definedProps.indexOf(key) !== -1) return acc;
	        acc[key] = props[key];
	        return acc;
	      }, {});
	    }
	  }, {
	    key: 'getParentSize',
	    value: function getParentSize() {
	      var base = this.base;
	
	      if (!base) return { width: window.innerWidth, height: window.innerHeight };
	      // INFO: To calculate parent width with flex layout
	      var wrapChanged = false;
	      var wrap = this.parentNode.style.flexWrap;
	      var minWidth = base.style.minWidth;
	      if (wrap !== 'wrap') {
	        wrapChanged = true;
	        this.parentNode.style.flexWrap = 'wrap';
	        // HACK: Use relative to get parent padding size
	      }
	      base.style.position = 'relative';
	      base.style.minWidth = '100%';
	      var size = {
	        width: base.offsetWidth,
	        height: base.offsetHeight
	      };
	      base.style.position = 'absolute';
	      if (wrapChanged) this.parentNode.style.flexWrap = wrap;
	      base.style.minWidth = minWidth;
	      return size;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var size = this.size;
	
	      this.setState({
	        width: this.state.width || size.width,
	        height: this.state.height || size.height
	      });
	      var parent = this.parentNode;
	      if (!(parent instanceof HTMLElement)) return;
	      if (this.base) return;
	      var element = document.createElement('div');
	      element.style.width = '100%';
	      element.style.height = '100%';
	      element.style.position = 'absolute';
	      element.style.transform = 'scale(0, 0)';
	      element.style.left = '-2147483647px';
	      element.style.flex = '0';
	      if (element.classList) {
	        element.classList.add(baseClassName);
	      } else {
	        element.className += baseClassName;
	      }
	      parent.appendChild(element);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      this.updateExtendsProps(next);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (typeof window !== 'undefined') {
	        window.removeEventListener('mouseup', this.onMouseUp);
	        window.removeEventListener('mousemove', this.onMouseMove);
	        window.removeEventListener('mouseleave', this.onMouseUp);
	        window.removeEventListener('touchmove', this.onMouseMove);
	        window.removeEventListener('touchend', this.onMouseUp);
	        var parent = this.parentNode;
	        var base = this.base;
	
	        if (!base || !parent) return;
	        if (!(parent instanceof HTMLElement) || !(base instanceof Node)) return;
	        parent.removeChild(base);
	      }
	    }
	  }, {
	    key: 'calculateNewSize',
	    value: function calculateNewSize(newSize, kind) {
	      var propsSize = this.propsSize && this.propsSize[kind];
	      return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
	    }
	  }, {
	    key: 'onResizeStart',
	    value: function onResizeStart(event, direction) {
	      var clientX = 0;
	      var clientY = 0;
	      if (event.nativeEvent instanceof MouseEvent) {
	        clientX = event.nativeEvent.clientX;
	        clientY = event.nativeEvent.clientY;
	
	        // When user click with right button the resize is stuck in resizing mode
	        // until users clicks again, dont continue if right click is used.
	        // HACK: MouseEvent does not have `which` from flow-bin v0.68.
	        if (event.nativeEvent.which === 3) {
	          return;
	        }
	      } else if (event.nativeEvent instanceof TouchEvent) {
	        clientX = event.nativeEvent.touches[0].clientX;
	        clientY = event.nativeEvent.touches[0].clientY;
	      }
	      if (this.props.onResizeStart) {
	        this.props.onResizeStart(event, direction, this.resizable);
	      }
	
	      // Fix #168
	      if (this.props.size) {
	        if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) {
	          this.setState({ height: this.props.size.height });
	        }
	        if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) {
	          this.setState({ width: this.props.size.width });
	        }
	      }
	
	      this.setState({
	        original: {
	          x: clientX,
	          y: clientY,
	          width: this.size.width,
	          height: this.size.height
	        },
	        isResizing: true,
	        resizeCursor: window.getComputedStyle(event.target).cursor,
	        direction: direction
	      });
	    }
	  }, {
	    key: 'onMouseMove',
	    value: function onMouseMove(event) {
	      if (!this.state.isResizing) return;
	      var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
	      var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
	      var _state = this.state,
	          direction = _state.direction,
	          original = _state.original,
	          width = _state.width,
	          height = _state.height;
	      var _props = this.props,
	          lockAspectRatio = _props.lockAspectRatio,
	          lockAspectRatioExtraHeight = _props.lockAspectRatioExtraHeight,
	          lockAspectRatioExtraWidth = _props.lockAspectRatioExtraWidth;
	      var _props2 = this.props,
	          maxWidth = _props2.maxWidth,
	          maxHeight = _props2.maxHeight,
	          minWidth = _props2.minWidth,
	          minHeight = _props2.minHeight;
	
	      // TODO: refactor
	
	      var parentSize = this.getParentSize();
	      if (maxWidth && typeof maxWidth === 'string' && endsWith(maxWidth, '%')) {
	        var _ratio = Number(maxWidth.replace('%', '')) / 100;
	        maxWidth = parentSize.width * _ratio;
	      }
	      if (maxHeight && typeof maxHeight === 'string' && endsWith(maxHeight, '%')) {
	        var _ratio2 = Number(maxHeight.replace('%', '')) / 100;
	        maxHeight = parentSize.height * _ratio2;
	      }
	      if (minWidth && typeof minWidth === 'string' && endsWith(minWidth, '%')) {
	        var _ratio3 = Number(minWidth.replace('%', '')) / 100;
	        minWidth = parentSize.width * _ratio3;
	      }
	      if (minHeight && typeof minHeight === 'string' && endsWith(minHeight, '%')) {
	        var _ratio4 = Number(minHeight.replace('%', '')) / 100;
	        minHeight = parentSize.height * _ratio4;
	      }
	      maxWidth = typeof maxWidth === 'undefined' ? undefined : Number(maxWidth);
	      maxHeight = typeof maxHeight === 'undefined' ? undefined : Number(maxHeight);
	      minWidth = typeof minWidth === 'undefined' ? undefined : Number(minWidth);
	      minHeight = typeof minHeight === 'undefined' ? undefined : Number(minHeight);
	
	      var ratio = typeof lockAspectRatio === 'number' ? lockAspectRatio : original.width / original.height;
	      var newWidth = original.width;
	      var newHeight = original.height;
	      if (/right/i.test(direction)) {
	        newWidth = original.width + (clientX - original.x);
	        if (lockAspectRatio) newHeight = (newWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
	      }
	      if (/left/i.test(direction)) {
	        newWidth = original.width - (clientX - original.x);
	        if (lockAspectRatio) newHeight = (newWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
	      }
	      if (/bottom/i.test(direction)) {
	        newHeight = original.height + (clientY - original.y);
	        if (lockAspectRatio) newWidth = (newHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
	      }
	      if (/top/i.test(direction)) {
	        newHeight = original.height - (clientY - original.y);
	        if (lockAspectRatio) newWidth = (newHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
	      }
	
	      if (this.props.bounds === 'parent') {
	        var parent = this.parentNode;
	        if (parent instanceof HTMLElement) {
	          var parentRect = parent.getBoundingClientRect();
	          var parentLeft = parentRect.left;
	          var parentTop = parentRect.top;
	
	          var _resizable$getBoundin = this.resizable.getBoundingClientRect(),
	              _left = _resizable$getBoundin.left,
	              _top = _resizable$getBoundin.top;
	
	          var boundWidth = parent.offsetWidth + (parentLeft - _left);
	          var boundHeight = parent.offsetHeight + (parentTop - _top);
	          maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
	          maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
	        }
	      } else if (this.props.bounds === 'window') {
	        if (typeof window !== 'undefined') {
	          var _resizable$getBoundin2 = this.resizable.getBoundingClientRect(),
	              _left2 = _resizable$getBoundin2.left,
	              _top2 = _resizable$getBoundin2.top;
	
	          var _boundWidth = window.innerWidth - _left2;
	          var _boundHeight = window.innerHeight - _top2;
	          maxWidth = maxWidth && maxWidth < _boundWidth ? maxWidth : _boundWidth;
	          maxHeight = maxHeight && maxHeight < _boundHeight ? maxHeight : _boundHeight;
	        }
	      } else if (this.props.bounds instanceof HTMLElement) {
	        var targetRect = this.props.bounds.getBoundingClientRect();
	        var targetLeft = targetRect.left;
	        var targetTop = targetRect.top;
	
	        var _resizable$getBoundin3 = this.resizable.getBoundingClientRect(),
	            _left3 = _resizable$getBoundin3.left,
	            _top3 = _resizable$getBoundin3.top;
	
	        if (!(this.props.bounds instanceof HTMLElement)) return;
	        var _boundWidth2 = this.props.bounds.offsetWidth + (targetLeft - _left3);
	        var _boundHeight2 = this.props.bounds.offsetHeight + (targetTop - _top3);
	        maxWidth = maxWidth && maxWidth < _boundWidth2 ? maxWidth : _boundWidth2;
	        maxHeight = maxHeight && maxHeight < _boundHeight2 ? maxHeight : _boundHeight2;
	      }
	
	      var computedMinWidth = typeof minWidth === 'undefined' ? 10 : minWidth;
	      var computedMaxWidth = typeof maxWidth === 'undefined' || maxWidth < 0 ? newWidth : maxWidth;
	      var computedMinHeight = typeof minHeight === 'undefined' ? 10 : minHeight;
	      var computedMaxHeight = typeof maxHeight === 'undefined' || maxHeight < 0 ? newHeight : maxHeight;
	
	      if (lockAspectRatio) {
	        var extraMinWidth = (computedMinHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
	        var extraMaxWidth = (computedMaxHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
	        var extraMinHeight = (computedMinWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
	        var extraMaxHeight = (computedMaxWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
	        var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
	        var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
	        var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
	        var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
	        newWidth = clamp(newWidth, lockedMinWidth, lockedMaxWidth);
	        newHeight = clamp(newHeight, lockedMinHeight, lockedMaxHeight);
	      } else {
	        newWidth = clamp(newWidth, computedMinWidth, computedMaxWidth);
	        newHeight = clamp(newHeight, computedMinHeight, computedMaxHeight);
	      }
	      if (this.props.grid) {
	        newWidth = snap(newWidth, this.props.grid[0]);
	      }
	      if (this.props.grid) {
	        newHeight = snap(newHeight, this.props.grid[1]);
	      }
	
	      var delta = {
	        width: newWidth - original.width,
	        height: newHeight - original.height
	      };
	
	      if (width && typeof width === 'string' && endsWith(width, '%')) {
	        var percent = newWidth / parentSize.width * 100;
	        newWidth = percent + '%';
	      }
	
	      if (height && typeof height === 'string' && endsWith(height, '%')) {
	        var _percent = newHeight / parentSize.height * 100;
	        newHeight = _percent + '%';
	      }
	
	      this.setState({
	        width: this.calculateNewSize(newWidth, 'width'),
	        height: this.calculateNewSize(newHeight, 'height')
	      });
	
	      if (this.props.onResize) {
	        this.props.onResize(event, direction, this.resizable, delta);
	      }
	    }
	  }, {
	    key: 'onMouseUp',
	    value: function onMouseUp(event) {
	      var _state2 = this.state,
	          isResizing = _state2.isResizing,
	          direction = _state2.direction,
	          original = _state2.original;
	
	      if (!isResizing) return;
	      var delta = {
	        width: this.size.width - original.width,
	        height: this.size.height - original.height
	      };
	      if (this.props.onResizeStop) {
	        this.props.onResizeStop(event, direction, this.resizable, delta);
	      }
	      if (this.props.size) {
	        this.setState(this.props.size);
	      }
	      this.setState({ isResizing: false, resizeCursor: 'auto' });
	    }
	  }, {
	    key: 'updateSize',
	    value: function updateSize(size) {
	      this.setState({ width: size.width, height: size.height });
	    }
	  }, {
	    key: 'renderResizer',
	    value: function renderResizer() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          enable = _props3.enable,
	          handleStyles = _props3.handleStyles,
	          handleClasses = _props3.handleClasses,
	          handleWrapperStyle = _props3.handleWrapperStyle,
	          handleWrapperClass = _props3.handleWrapperClass,
	          handleComponent = _props3.handleComponent;
	
	      if (!enable) return null;
	      var resizers = Object.keys(enable).map(function (dir) {
	        if (enable[dir] !== false) {
	          return React.createElement(
	            Resizer,
	            {
	              key: dir,
	              direction: dir,
	              onResizeStart: _this2.onResizeStart,
	              replaceStyles: handleStyles && handleStyles[dir],
	              className: handleClasses && handleClasses[dir]
	            },
	            handleComponent && handleComponent[dir] ? React.createElement(handleComponent[dir]) : null
	          );
	        }
	        return null;
	      });
	
	      // #93 Wrap the resize box in span (will not break 100% width/height)
	      return React.createElement(
	        'span',
	        { className: handleWrapperClass, style: handleWrapperStyle },
	        resizers
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var userSelect = this.state.isResizing ? userSelectNone : userSelectAuto;
	      return React.createElement(
	        'div',
	        _extends({
	          ref: function ref(c) {
	            if (c) {
	              _this3.resizable = c;
	            }
	          },
	          style: _extends({
	            position: 'relative'
	          }, userSelect, this.props.style, this.sizeStyle, {
	            maxWidth: this.props.maxWidth,
	            maxHeight: this.props.maxHeight,
	            minWidth: this.props.minWidth,
	            minHeight: this.props.minHeight,
	            boxSizing: 'border-box'
	          }),
	          className: this.props.className
	        }, this.extendsProps),
	        this.state.isResizing && React.createElement('div', {
	          style: {
	            height: '100%',
	            width: '100%',
	            backgroundColor: 'rgba(0,0,0,0)',
	            cursor: '' + (this.state.resizeCursor || 'auto'),
	            opacity: '0',
	            position: 'fixed',
	            zIndex: '9999',
	            top: '0',
	            left: '0',
	            bottom: '0',
	            right: '0'
	          }
	        }),
	        this.props.children,
	        this.renderResizer()
	      );
	    }
	  }, {
	    key: 'parentNode',
	    get: function get$$1() {
	      return this.resizable.parentNode;
	    }
	  }, {
	    key: 'propsSize',
	    get: function get$$1() {
	      return this.props.size || this.props.defaultSize;
	    }
	  }, {
	    key: 'base',
	    get: function get$$1() {
	      var parent = this.parentNode;
	      if (!parent) return undefined;
	      return [].concat(toConsumableArray(parent.children)).find(function (n) {
	        if (n instanceof HTMLElement) {
	          return n.classList.contains(baseClassName);
	        }
	        return undefined;
	      });
	    }
	  }, {
	    key: 'size',
	    get: function get$$1() {
	      var width = 0;
	      var height = 0;
	      if (typeof window !== 'undefined') {
	        width = this.resizable.offsetWidth;
	        height = this.resizable.offsetHeight;
	      }
	      return { width: width, height: height };
	    }
	  }, {
	    key: 'sizeStyle',
	    get: function get$$1() {
	      var _this4 = this;
	
	      var size = this.props.size;
	
	      var getSize = function getSize(key) {
	        if (typeof _this4.state[key] === 'undefined' || _this4.state[key] === 'auto') return 'auto';
	        if (_this4.propsSize && _this4.propsSize[key] && endsWith(_this4.propsSize[key].toString(), '%')) {
	          if (endsWith(_this4.state[key].toString(), '%')) return _this4.state[key].toString();
	          var parentSize = _this4.getParentSize();
	          var value = Number(_this4.state[key].toString().replace('px', ''));
	          var percent = value / parentSize[key] * 100;
	          return percent + '%';
	        }
	        return getStringSize(_this4.state[key]);
	      };
	      var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? getStringSize(size.width) : getSize('width');
	      var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? getStringSize(size.height) : getSize('height');
	      return { width: width, height: height };
	    }
	  }]);
	  return Resizable;
	}(React.Component);
	
	Resizable.defaultProps = {
	  onResizeStart: function onResizeStart() {},
	  onResize: function onResize() {},
	  onResizeStop: function onResizeStop() {},
	  enable: {
	    top: true,
	    right: true,
	    bottom: true,
	    left: true,
	    topRight: true,
	    bottomRight: true,
	    bottomLeft: true,
	    topLeft: true
	  },
	  style: {},
	  grid: [1, 1],
	  lockAspectRatio: false,
	  lockAspectRatioExtraWidth: 0,
	  lockAspectRatioExtraHeight: 0
	};
	
	module.exports = Resizable;


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(2);
	var autosize = __webpack_require__(249);
	var _getLineHeight = __webpack_require__(450);
	var getLineHeight = _getLineHeight;
	var UPDATE = 'autosize:update';
	var DESTROY = 'autosize:destroy';
	var RESIZED = 'autosize:resized';
	/**
	 * A light replacement for built-in textarea component
	 * which automaticaly adjusts its height to match the content
	 */
	var TextareaAutosize = /** @class */ (function (_super) {
	    __extends(TextareaAutosize, _super);
	    function TextareaAutosize() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            lineHeight: null
	        };
	        _this.dispatchEvent = function (EVENT_TYPE) {
	            var event = document.createEvent('Event');
	            event.initEvent(EVENT_TYPE, true, false);
	            _this.textarea.dispatchEvent(event);
	        };
	        _this.updateLineHeight = function () {
	            _this.setState({
	                lineHeight: getLineHeight(_this.textarea)
	            });
	        };
	        _this.onChange = function (e) {
	            var onChange = _this.props.onChange;
	            _this.currentValue = e.currentTarget.value;
	            onChange && onChange(e);
	        };
	        _this.saveDOMNodeRef = function (ref) {
	            var innerRef = _this.props.innerRef;
	            if (innerRef) {
	                innerRef(ref);
	            }
	            _this.textarea = ref;
	        };
	        _this.getLocals = function () {
	            var _a = _this, _b = _a.props, onResize = _b.onResize, maxRows = _b.maxRows, onChange = _b.onChange, style = _b.style, innerRef = _b.innerRef, props = __rest(_b, ["onResize", "maxRows", "onChange", "style", "innerRef"]), lineHeight = _a.state.lineHeight, saveDOMNodeRef = _a.saveDOMNodeRef;
	            var maxHeight = maxRows && lineHeight ? lineHeight * maxRows : null;
	            return __assign({}, props, { saveDOMNodeRef: saveDOMNodeRef, style: maxHeight ? __assign({}, style, { maxHeight: maxHeight }) : style, onChange: _this.onChange });
	        };
	        return _this;
	    }
	    TextareaAutosize.prototype.componentDidMount = function () {
	        var _this = this;
	        var _a = this.props, onResize = _a.onResize, maxRows = _a.maxRows, async = _a.async;
	        if (typeof maxRows === 'number') {
	            this.updateLineHeight();
	        }
	        if (typeof maxRows === "number" || async) {
	            /*
	              the defer is needed to:
	                - force "autosize" to activate the scrollbar when this.props.maxRows is passed
	                - support StyledComponents (see #71)
	            */
	            setTimeout(function () { return autosize(_this.textarea); });
	        }
	        else {
	            autosize(this.textarea);
	        }
	        if (onResize) {
	            this.textarea.addEventListener(RESIZED, onResize);
	        }
	    };
	    TextareaAutosize.prototype.componentWillUnmount = function () {
	        var onResize = this.props.onResize;
	        if (onResize) {
	            this.textarea.removeEventListener(RESIZED, onResize);
	        }
	        this.dispatchEvent(DESTROY);
	    };
	    TextareaAutosize.prototype.render = function () {
	        var _a = this.getLocals(), children = _a.children, saveDOMNodeRef = _a.saveDOMNodeRef, locals = __rest(_a, ["children", "saveDOMNodeRef"]);
	        return (React.createElement("textarea", __assign({}, locals, { ref: saveDOMNodeRef }), children));
	    };
	    TextareaAutosize.prototype.componentDidUpdate = function (prevProps) {
	        if (this.props.value !== this.currentValue || this.props.rows !== prevProps.rows) {
	            this.dispatchEvent(UPDATE);
	        }
	    };
	    TextareaAutosize.defaultProps = {
	        rows: 1,
	        async: false
	    };
	    TextareaAutosize.propTypes = {
	        rows: PropTypes.number,
	        maxRows: PropTypes.number,
	        onResize: PropTypes.func,
	        innerRef: PropTypes.func,
	        async: PropTypes.bool
	    };
	    return TextareaAutosize;
	}(React.Component));
	exports["default"] = TextareaAutosize;


/***/ },
/* 502 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var vertical = exports.vertical = {
	  direction: 'vertical',
	  line: 'y',
	  crossLine: 'x',
	  start: 'top',
	  end: 'bottom',
	  size: 'height',
	  crossAxisStart: 'left',
	  crossAxisEnd: 'right',
	  crossAxisSize: 'width'
	};
	
	var horizontal = exports.horizontal = {
	  direction: 'horizontal',
	  line: 'x',
	  crossLine: 'y',
	  start: 'left',
	  end: 'right',
	  size: 'width',
	  crossAxisStart: 'top',
	  crossAxisEnd: 'bottom',
	  crossAxisSize: 'height'
	};

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(98);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _redux = __webpack_require__(11);
	
	var _reduxThunk = __webpack_require__(243);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducer = __webpack_require__(520);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var composeEnhancers = (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : _redux.compose;
	
	exports.default = function () {
	  return (0, _redux.createStore)(_reducer2.default, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default)));
	};

/***/ },
/* 504 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hooks, current, previous) {
	  var onDragStart = hooks.onDragStart,
	      onDragEnd = hooks.onDragEnd;
	
	  var currentPhase = current.phase;
	  var previousPhase = previous.phase;
	
	  if (currentPhase === previousPhase) {
	    return;
	  }
	
	  if (currentPhase === 'DRAGGING' && previousPhase !== 'DRAGGING') {
	    if (!onDragStart) {
	      return;
	    }
	
	    if (!current.drag) {
	      console.error('cannot fire onDragStart hook without drag state', { current: current, previous: previous });
	      return;
	    }
	
	    var start = {
	      draggableId: current.drag.current.id,
	      type: current.drag.current.type,
	      source: current.drag.initial.source
	    };
	
	    onDragStart(start);
	    return;
	  }
	
	  if (currentPhase === 'DROP_COMPLETE' && previousPhase !== 'DROP_COMPLETE') {
	    if (!current.drop || !current.drop.result) {
	      console.error('cannot fire onDragEnd hook without drag state', { current: current, previous: previous });
	      return;
	    }
	
	    var _current$drop$result = current.drop.result,
	        source = _current$drop$result.source,
	        destination = _current$drop$result.destination,
	        draggableId = _current$drop$result.draggableId,
	        type = _current$drop$result.type;
	
	    if (!destination) {
	      onDragEnd(current.drop.result);
	      return;
	    }
	
	    var didMove = source.droppableId !== destination.droppableId || source.index !== destination.index;
	
	    if (didMove) {
	      onDragEnd(current.drop.result);
	      return;
	    }
	
	    var muted = {
	      draggableId: draggableId,
	      type: type,
	      source: source,
	      destination: null
	    };
	
	    onDragEnd(muted);
	  }
	
	  if (currentPhase === 'IDLE' && previousPhase === 'DRAGGING') {
	    if (!previous.drag) {
	      console.error('cannot fire onDragEnd for cancel because cannot find previous drag');
	      return;
	    }
	    var result = {
	      draggableId: previous.drag.current.id,
	      type: previous.drag.current.type,
	      source: previous.drag.initial.source,
	      destination: null
	    };
	    onDragEnd(result);
	  }
	
	  if (currentPhase === 'IDLE' && previousPhase === 'DROP_ANIMATING') {
	    if (!previous.drop || !previous.drop.pending) {
	      console.error('cannot fire onDragEnd for cancel because cannot find previous pending drop');
	      return;
	    }
	
	    var _result = {
	      draggableId: previous.drop.pending.result.draggableId,
	      type: previous.drop.pending.result.type,
	      source: previous.drop.pending.result.source,
	      destination: null
	    };
	    onDragEnd(_result);
	  }
	};

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(14);
	
	exports.default = function (_ref) {
	  var pageCenter = _ref.pageCenter,
	      draggable = _ref.draggable,
	      destination = _ref.destination,
	      insideDestination = _ref.insideDestination;
	
	  var axis = destination.axis;
	
	  var destinationScrollDiff = (0, _position.subtract)(destination.container.scroll.current, destination.container.scroll.initial);
	
	  var currentCenter = (0, _position.add)(pageCenter, destinationScrollDiff);
	
	  var moved = insideDestination.filter(function (child) {
	    var threshold = child.page.withoutMargin[axis.end];
	    return threshold > currentCenter[axis.line];
	  }).map(function (dimension) {
	    return dimension.id;
	  });
	
	  var newIndex = insideDestination.length - moved.length;
	
	  var movement = {
	    amount: (0, _position.patch)(axis.line, draggable.page.withMargin[axis.size]),
	    draggables: moved,
	    isBeyondStartPosition: false
	  };
	
	  var impact = {
	    movement: movement,
	    direction: axis.direction,
	    destination: {
	      droppableId: destination.id,
	      index: newIndex
	    }
	  };
	
	  return impact;
	};

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(14);
	
	exports.default = function (_ref) {
	  var pageCenter = _ref.pageCenter,
	      draggable = _ref.draggable,
	      home = _ref.home,
	      insideHome = _ref.insideHome;
	
	  var axis = home.axis;
	  var homeScrollDiff = (0, _position.subtract)(home.container.scroll.current, home.container.scroll.initial);
	
	  var currentCenter = (0, _position.add)(pageCenter, homeScrollDiff);
	
	  var originalCenter = draggable.page.withoutMargin.center;
	
	  var isBeyondStartPosition = currentCenter[axis.line] - originalCenter[axis.line] > 0;
	
	  var moved = insideHome.filter(function (child) {
	    if (child === draggable) {
	      return false;
	    }
	
	    var fragment = child.page.withoutMargin;
	
	    if (isBeyondStartPosition) {
	      if (fragment.center[axis.line] < originalCenter[axis.line]) {
	        return false;
	      }
	
	      return currentCenter[axis.line] > fragment[axis.start];
	    }
	
	    if (originalCenter[axis.line] < fragment.center[axis.line]) {
	      return false;
	    }
	
	    return currentCenter[axis.line] < fragment[axis.end];
	  }).map(function (dimension) {
	    return dimension.id;
	  });
	
	  var ordered = isBeyondStartPosition ? moved.reverse() : moved;
	
	  var index = function () {
	    var startIndex = insideHome.indexOf(draggable);
	    if (!moved.length) {
	      return startIndex;
	    }
	
	    if (isBeyondStartPosition) {
	      return startIndex + moved.length;
	    }
	
	    return startIndex - moved.length;
	  }();
	
	  var movement = {
	    amount: (0, _position.patch)(axis.line, draggable.client.withMargin[axis.size]),
	    draggables: ordered,
	    isBeyondStartPosition: isBeyondStartPosition
	  };
	
	  var impact = {
	    movement: movement,
	    direction: axis.direction,
	    destination: {
	      droppableId: home.id,
	      index: index
	    }
	  };
	
	  return impact;
	};

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getDroppableOver = __webpack_require__(508);
	
	var _getDroppableOver2 = _interopRequireDefault(_getDroppableOver);
	
	var _getDraggablesInsideDroppable = __webpack_require__(44);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	var _noImpact = __webpack_require__(132);
	
	var _noImpact2 = _interopRequireDefault(_noImpact);
	
	var _inHomeList = __webpack_require__(506);
	
	var _inHomeList2 = _interopRequireDefault(_inHomeList);
	
	var _inForeignList = __webpack_require__(505);
	
	var _inForeignList2 = _interopRequireDefault(_inForeignList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var pageCenter = _ref.pageCenter,
	      draggable = _ref.draggable,
	      draggables = _ref.draggables,
	      droppables = _ref.droppables,
	      previousDroppableOverId = _ref.previousDroppableOverId;
	
	  var destinationId = (0, _getDroppableOver2.default)({
	    target: pageCenter,
	    draggable: draggable,
	    draggables: draggables,
	    droppables: droppables,
	    previousDroppableOverId: previousDroppableOverId
	  });
	
	  if (!destinationId) {
	    return _noImpact2.default;
	  }
	
	  var destination = droppables[destinationId];
	
	  if (!destination.isEnabled) {
	    return _noImpact2.default;
	  }
	
	  var home = droppables[draggable.droppableId];
	  var isWithinHomeDroppable = home.id === destinationId;
	  var insideDestination = (0, _getDraggablesInsideDroppable2.default)(destination, draggables);
	
	  if (isWithinHomeDroppable) {
	    return (0, _inHomeList2.default)({
	      pageCenter: pageCenter,
	      draggable: draggable,
	      home: home,
	      insideHome: insideDestination
	    });
	  }
	
	  return (0, _inForeignList2.default)({
	    pageCenter: pageCenter,
	    draggable: draggable,
	    destination: destination,
	    insideDestination: insideDestination
	  });
	};

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(35);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(36);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _memoizeOne = __webpack_require__(18);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _dimension = __webpack_require__(130);
	
	var _getClientRect = __webpack_require__(131);
	
	var _getClientRect2 = _interopRequireDefault(_getClientRect);
	
	var _getDraggablesInsideDroppable = __webpack_require__(44);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	var _isWithinVisibleBoundsOfDroppable = __webpack_require__(69);
	
	var _position = __webpack_require__(14);
	
	var _spacing = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noBuffer = { x: 0, y: 0 };
	
	var bufferDimensionFragment = function bufferDimensionFragment(buffer) {
	  return function (fragment) {
	    return (0, _dimension.getFragment)((0, _getClientRect2.default)((0, _spacing.addPosition)(fragment, buffer)));
	  };
	};
	
	var addBufferToDroppableDimension = (0, _memoizeOne2.default)(function (buffer, droppable) {
	  var id = droppable.id,
	      axis = droppable.axis,
	      isEnabled = droppable.isEnabled,
	      client = droppable.client,
	      container = droppable.container,
	      page = droppable.page;
	
	  var withBuffer = bufferDimensionFragment(buffer);
	
	  var newClient = {
	    withoutMargin: withBuffer(client.withoutMargin),
	    withMargin: withBuffer(client.withMargin),
	    withMarginAndPadding: withBuffer(client.withMarginAndPadding)
	  };
	
	  var newPage = {
	    withoutMargin: withBuffer(page.withoutMargin),
	    withMargin: withBuffer(page.withMargin),
	    withMarginAndPadding: withBuffer(page.withMarginAndPadding)
	  };
	
	  var shouldBufferContainer = droppable.page.withMargin[droppable.axis.size] <= droppable.container.bounds[droppable.axis.size];
	  var newContainerBounds = shouldBufferContainer ? withBuffer(container.bounds) : (0, _extends3.default)({}, container.bounds);
	
	  return {
	    id: id,
	    axis: axis,
	    isEnabled: isEnabled,
	    client: newClient,
	    page: newPage,
	    container: {
	      scroll: container.scroll,
	      bounds: newContainerBounds
	    }
	  };
	});
	
	var calculateBufferSize = (0, _memoizeOne2.default)(function (draggable, draggables, droppable) {
	
	  var draggablesInDroppable = (0, _getDraggablesInsideDroppable2.default)(droppable, draggables);
	
	  if (!draggablesInDroppable.length) {
	    return noBuffer;
	  }
	  var excessSpace = droppable.page.withMargin[droppable.axis.end] - draggablesInDroppable[draggablesInDroppable.length - 1].page.withMargin[droppable.axis.end];
	  var bufferSize = Math.max(draggable.page.withMargin[droppable.axis.size] - excessSpace, 0);
	
	  var buffer = (0, _position.patch)(droppable.axis.line, bufferSize);
	
	  return buffer;
	});
	
	var bufferDroppable = function bufferDroppable(_ref) {
	  var draggable = _ref.draggable,
	      draggables = _ref.draggables,
	      droppable = _ref.droppable,
	      previousDroppableOverId = _ref.previousDroppableOverId;
	
	  var isHomeDroppable = draggable.droppableId === droppable.id;
	  var isCurrentlyHovered = previousDroppableOverId && previousDroppableOverId === droppable.id;
	
	  if (isHomeDroppable || !isCurrentlyHovered) {
	    return droppable;
	  }
	
	  var buffer = calculateBufferSize(draggable, draggables, droppable);
	
	  return addBufferToDroppableDimension(buffer, droppable);
	};
	
	exports.default = function (_ref2) {
	  var target = _ref2.target,
	      draggable = _ref2.draggable,
	      draggables = _ref2.draggables,
	      droppables = _ref2.droppables,
	      previousDroppableOverId = _ref2.previousDroppableOverId;
	
	  var maybe = (0, _keys2.default)(droppables).map(function (id) {
	    return droppables[id];
	  }).find(function (droppable) {
	    var bufferedDroppable = bufferDroppable({
	      draggable: draggable, draggables: draggables, droppable: droppable, previousDroppableOverId: previousDroppableOverId
	    });
	
	    return (0, _isWithinVisibleBoundsOfDroppable.isPointWithinDroppable)(bufferedDroppable)(target);
	  });
	
	  return maybe ? maybe.id : null;
	};

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getDraggablesInsideDroppable = __webpack_require__(44);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	var _noImpact = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var draggable = _ref.draggable,
	      droppable = _ref.droppable,
	      draggables = _ref.draggables;
	
	  var insideDroppable = (0, _getDraggablesInsideDroppable2.default)(droppable, draggables);
	
	  var homeIndex = insideDroppable.indexOf(draggable);
	
	  if (homeIndex === -1) {
	    console.error('lifting a draggable that is not inside a droppable');
	    return null;
	  }
	
	  var home = {
	    index: homeIndex,
	    droppableId: droppable.id
	  };
	
	  var impact = {
	    movement: _noImpact.noMovement,
	    direction: droppable.axis.direction,
	    destination: home
	  };
	
	  return impact;
	};

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moveToEdge = __webpack_require__(70);
	
	var _moveToEdge2 = _interopRequireDefault(_moveToEdge);
	
	var _getDraggablesInsideDroppable = __webpack_require__(44);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var movement = _ref.movement,
	      draggable = _ref.draggable,
	      draggables = _ref.draggables,
	      destination = _ref.destination;
	
	  var homeCenter = draggable.client.withMargin.center;
	
	  if (destination == null) {
	    return homeCenter;
	  }
	
	  var movedDraggables = movement.draggables,
	      isBeyondStartPosition = movement.isBeyondStartPosition;
	
	  var axis = destination.axis;
	
	  var isWithinHomeDroppable = destination.id === draggable.droppableId;
	
	  if (isWithinHomeDroppable && !movedDraggables.length) {
	    return homeCenter;
	  }
	
	  var draggablesInDestination = (0, _getDraggablesInsideDroppable2.default)(destination, draggables);
	
	  var destinationFragment = function () {
	    if (isWithinHomeDroppable) {
	      return draggables[movedDraggables[0]].client.withMargin;
	    }
	
	    if (movedDraggables.length) {
	      return draggables[movedDraggables[0]].client.withMargin;
	    }
	
	    if (draggablesInDestination.length) {
	      return draggablesInDestination[draggablesInDestination.length - 1].client.withMargin;
	    }
	
	    return destination.client.withMarginAndPadding;
	  }();
	
	  var _ref2 = function () {
	    if (isWithinHomeDroppable) {
	      if (isBeyondStartPosition) {
	        return { sourceEdge: 'end', destinationEdge: 'end' };
	      }
	
	      return { sourceEdge: 'start', destinationEdge: 'start' };
	    }
	
	    if (!movedDraggables.length && draggablesInDestination.length) {
	      return { sourceEdge: 'start', destinationEdge: 'end' };
	    }
	
	    return { sourceEdge: 'start', destinationEdge: 'start' };
	  }(),
	      sourceEdge = _ref2.sourceEdge,
	      destinationEdge = _ref2.destinationEdge;
	
	  var source = draggable.client.withMargin;
	
	  var targetCenter = (0, _moveToEdge2.default)({
	    source: source,
	    sourceEdge: sourceEdge,
	    destination: destinationFragment,
	    destinationEdge: destinationEdge,
	    destinationAxis: axis
	  });
	
	  return targetCenter;
	};

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(35);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _position = __webpack_require__(14);
	
	var _isWithin = __webpack_require__(217);
	
	var _isWithin2 = _interopRequireDefault(_isWithin);
	
	var _spacing = __webpack_require__(83);
	
	var _isWithinVisibleBoundsOfDroppable = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      pageCenter = _ref.pageCenter,
	      source = _ref.source,
	      droppables = _ref.droppables;
	
	  var axis = source.axis;
	  var sourceBounds = (0, _isWithinVisibleBoundsOfDroppable.getVisibleBounds)(source);
	
	  var candidates = (0, _keys2.default)(droppables).map(function (id) {
	    return droppables[id];
	  }).filter(function (droppable) {
	    return droppable !== source;
	  }).filter(function (droppable) {
	    return droppable.isEnabled;
	  }).map(function (droppable) {
	    return {
	      bounds: (0, _isWithinVisibleBoundsOfDroppable.getVisibleBounds)(droppable),
	      droppable: droppable
	    };
	  }).filter(function (_ref2) {
	    var bounds = _ref2.bounds;
	
	    if (isMovingForward) {
	      return sourceBounds[axis.crossAxisEnd] <= bounds[axis.crossAxisStart];
	    }
	
	    return bounds[axis.crossAxisEnd] <= sourceBounds[axis.crossAxisStart];
	  }).filter(function (_ref3) {
	    var bounds = _ref3.bounds;
	
	    var isBetweenSourceBounds = (0, _isWithin2.default)(sourceBounds[axis.start], sourceBounds[axis.end]);
	    var isBetweenDestinationBounds = (0, _isWithin2.default)(bounds[axis.start], bounds[axis.end]);
	
	    return isBetweenSourceBounds(bounds[axis.start]) || isBetweenSourceBounds(bounds[axis.end]) || isBetweenDestinationBounds(sourceBounds[axis.start]) || isBetweenDestinationBounds(sourceBounds[axis.end]);
	  }).filter(function (_ref4) {
	    var droppable = _ref4.droppable;
	    return droppable.page.withoutMargin[axis.crossAxisStart] >= droppable.container.bounds[axis.crossAxisStart] && droppable.page.withoutMargin[axis.crossAxisEnd] <= droppable.container.bounds[axis.crossAxisEnd];
	  }).sort(function (_ref5, _ref6) {
	    var a = _ref5.bounds;
	    var b = _ref6.bounds;
	
	    var first = a[axis.crossAxisStart];
	    var second = b[axis.crossAxisStart];
	
	    if (isMovingForward) {
	      return first - second;
	    }
	    return second - first;
	  }).filter(function (_ref7, index, array) {
	    var bounds = _ref7.bounds;
	    return bounds[axis.crossAxisStart] === array[0].bounds[axis.crossAxisStart];
	  });
	
	  if (!candidates.length) {
	    return null;
	  }
	
	  if (candidates.length === 1) {
	    return candidates[0].droppable;
	  }
	
	  var contains = candidates.filter(function (_ref8) {
	    var bounds = _ref8.bounds;
	
	    var isWithinDroppable = (0, _isWithin2.default)(bounds[axis.start], bounds[axis.end]);
	    return isWithinDroppable(pageCenter[axis.line]);
	  });
	
	  if (contains.length === 1) {
	    return contains[0].droppable;
	  }
	
	  if (contains.length > 1) {
	    return contains.sort(function (_ref9, _ref10) {
	      var a = _ref9.bounds;
	      var b = _ref10.bounds;
	      return a[axis.start] - b[axis.start];
	    })[0].droppable;
	  }
	
	  return candidates.sort(function (_ref11, _ref12) {
	    var a = _ref11.bounds;
	    var b = _ref12.bounds;
	
	    var first = (0, _position.closest)(pageCenter, (0, _spacing.getCorners)(a));
	    var second = (0, _position.closest)(pageCenter, (0, _spacing.getCorners)(b));
	
	    if (first !== second) {
	      return first - second;
	    }
	
	    return a[axis.start] - b[axis.start];
	  })[0].droppable;
	};

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(14);
	
	var _isWithinVisibleBoundsOfDroppable = __webpack_require__(69);
	
	exports.default = function (_ref) {
	  var axis = _ref.axis,
	      pageCenter = _ref.pageCenter,
	      destination = _ref.destination,
	      insideDestination = _ref.insideDestination;
	
	  if (!insideDestination.length) {
	    return null;
	  }
	
	  var isWithinDestination = (0, _isWithinVisibleBoundsOfDroppable.isDraggableWithin)(destination.container.bounds);
	
	  var result = insideDestination.filter(isWithinDestination).sort(function (a, b) {
	    var distanceToA = (0, _position.distance)(pageCenter, a.page.withMargin.center);
	    var distanceToB = (0, _position.distance)(pageCenter, b.page.withMargin.center);
	
	    if (distanceToA < distanceToB) {
	      return -1;
	    }
	
	    if (distanceToB < distanceToA) {
	      return 1;
	    }
	
	    return a.page.withMargin[axis.start] - b.page.withMargin[axis.start];
	  });
	
	  return result.length ? result[0] : null;
	};

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBestCrossAxisDroppable = __webpack_require__(511);
	
	var _getBestCrossAxisDroppable2 = _interopRequireDefault(_getBestCrossAxisDroppable);
	
	var _getClosestDraggable = __webpack_require__(512);
	
	var _getClosestDraggable2 = _interopRequireDefault(_getClosestDraggable);
	
	var _moveToNewDroppable = __webpack_require__(514);
	
	var _moveToNewDroppable2 = _interopRequireDefault(_moveToNewDroppable);
	
	var _getDraggablesInsideDroppable = __webpack_require__(44);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      pageCenter = _ref.pageCenter,
	      draggableId = _ref.draggableId,
	      droppableId = _ref.droppableId,
	      home = _ref.home,
	      draggables = _ref.draggables,
	      droppables = _ref.droppables;
	
	  var draggable = draggables[draggableId];
	  var source = droppables[droppableId];
	
	  var destination = (0, _getBestCrossAxisDroppable2.default)({
	    isMovingForward: isMovingForward,
	    pageCenter: pageCenter,
	    source: source,
	    droppables: droppables
	  });
	
	  if (!destination) {
	    return null;
	  }
	
	  var insideDestination = (0, _getDraggablesInsideDroppable2.default)(destination, draggables);
	
	  var target = (0, _getClosestDraggable2.default)({
	    axis: destination.axis,
	    pageCenter: pageCenter,
	    destination: destination,
	    insideDestination: insideDestination
	  });
	
	  if (insideDestination.length && !target) {
	    return null;
	  }
	
	  return (0, _moveToNewDroppable2.default)({
	    pageCenter: pageCenter,
	    destination: destination,
	    draggable: draggable,
	    target: target,
	    insideDestination: insideDestination,
	    home: home
	  });
	};

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toHomeList = __webpack_require__(516);
	
	var _toHomeList2 = _interopRequireDefault(_toHomeList);
	
	var _toForeignList = __webpack_require__(515);
	
	var _toForeignList2 = _interopRequireDefault(_toForeignList);
	
	var _position = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var pageCenter = _ref.pageCenter,
	      destination = _ref.destination,
	      draggable = _ref.draggable,
	      target = _ref.target,
	      home = _ref.home,
	      insideDestination = _ref.insideDestination;
	
	  var amount = (0, _position.patch)(destination.axis.line, draggable.client.withMargin[destination.axis.size]);
	
	  if (destination.id === draggable.droppableId) {
	    return (0, _toHomeList2.default)({
	      amount: amount,
	      originalIndex: home.index,
	      target: target,
	      insideDroppable: insideDestination,
	      draggable: draggable,
	      droppable: destination
	    });
	  }
	
	  return (0, _toForeignList2.default)({
	    amount: amount,
	    pageCenter: pageCenter,
	    target: target,
	    insideDroppable: insideDestination,
	    draggable: draggable,
	    droppable: destination
	  });
	};

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moveToEdge = __webpack_require__(70);
	
	var _moveToEdge2 = _interopRequireDefault(_moveToEdge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var amount = _ref.amount,
	      pageCenter = _ref.pageCenter,
	      target = _ref.target,
	      insideDroppable = _ref.insideDroppable,
	      draggable = _ref.draggable,
	      droppable = _ref.droppable;
	
	  var axis = droppable.axis;
	  var isGoingBeforeTarget = Boolean(target && pageCenter[droppable.axis.line] < target.page.withMargin.center[droppable.axis.line]);
	
	  if (!target) {
	
	    var _newCenter = (0, _moveToEdge2.default)({
	      source: draggable.page.withoutMargin,
	      sourceEdge: 'start',
	      destination: droppable.page.withMarginAndPadding,
	      destinationEdge: 'start',
	      destinationAxis: axis
	    });
	
	    var _newImpact = {
	      movement: {
	        draggables: [],
	        amount: amount,
	        isBeyondStartPosition: false
	      },
	      direction: axis.direction,
	      destination: {
	        droppableId: droppable.id,
	        index: 0
	      }
	    };
	
	    return {
	      pageCenter: _newCenter,
	      impact: _newImpact
	    };
	  }
	
	  var targetIndex = insideDroppable.indexOf(target);
	  var proposedIndex = isGoingBeforeTarget ? targetIndex : targetIndex + 1;
	
	  if (targetIndex === -1) {
	    console.error('could not find target inside destination');
	    return null;
	  }
	
	  var newCenter = (0, _moveToEdge2.default)({
	    source: draggable.page.withoutMargin,
	    sourceEdge: 'start',
	    destination: target.page.withMargin,
	    destinationEdge: isGoingBeforeTarget ? 'start' : 'end',
	    destinationAxis: axis
	  });
	
	  var needsToMove = insideDroppable.slice(proposedIndex, insideDroppable.length).map(function (dimension) {
	    return dimension.id;
	  });
	
	  var newImpact = {
	    movement: {
	      draggables: needsToMove,
	      amount: amount,
	      isBeyondStartPosition: false
	    },
	    direction: axis.direction,
	    destination: {
	      droppableId: droppable.id,
	      index: proposedIndex
	    }
	  };
	
	  return {
	    pageCenter: newCenter,
	    impact: newImpact
	  };
	};

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moveToEdge = __webpack_require__(70);
	
	var _moveToEdge2 = _interopRequireDefault(_moveToEdge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var amount = _ref.amount,
	      originalIndex = _ref.originalIndex,
	      target = _ref.target,
	      insideDroppable = _ref.insideDroppable,
	      draggable = _ref.draggable,
	      droppable = _ref.droppable;
	
	  if (!target) {
	    console.error('there will always be a target in the original list');
	    return null;
	  }
	
	  var axis = droppable.axis;
	  var targetIndex = insideDroppable.indexOf(target);
	
	  if (targetIndex === -1) {
	    console.error('unable to find target in destination droppable');
	    return null;
	  }
	
	  if (targetIndex === originalIndex) {
	    var _newCenter = draggable.page.withoutMargin.center;
	    var _newImpact = {
	      movement: {
	        draggables: [],
	        amount: amount,
	        isBeyondStartPosition: false
	      },
	      direction: droppable.axis.direction,
	      destination: {
	        droppableId: droppable.id,
	        index: originalIndex
	      }
	    };
	
	    return {
	      pageCenter: _newCenter,
	      impact: _newImpact
	    };
	  }
	
	  var isMovingPastOriginalIndex = targetIndex > originalIndex;
	  var edge = isMovingPastOriginalIndex ? 'end' : 'start';
	
	  var newCenter = (0, _moveToEdge2.default)({
	    source: draggable.page.withoutMargin,
	    sourceEdge: edge,
	    destination: isMovingPastOriginalIndex ? target.page.withoutMargin : target.page.withMargin,
	    destinationEdge: edge,
	    destinationAxis: axis
	  });
	
	  var needsToMove = function () {
	    if (!isMovingPastOriginalIndex) {
	      return insideDroppable.slice(targetIndex, originalIndex);
	    }
	
	    var from = originalIndex + 1;
	
	    var to = targetIndex + 1;
	
	    return insideDroppable.slice(from, to).reverse();
	  }().map(function (d) {
	    return d.id;
	  });
	
	  var newImpact = {
	    movement: {
	      draggables: needsToMove,
	      amount: amount,
	      isBeyondStartPosition: isMovingPastOriginalIndex
	    },
	    direction: axis.direction,
	    destination: {
	      droppableId: droppable.id,
	      index: targetIndex
	    }
	  };
	
	  return {
	    pageCenter: newCenter,
	    impact: newImpact
	  };
	};

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(97);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getDraggablesInsideDroppable = __webpack_require__(44);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	var _isWithinVisibleBoundsOfDroppable = __webpack_require__(69);
	
	var _position = __webpack_require__(14);
	
	var _moveToEdge = __webpack_require__(70);
	
	var _moveToEdge2 = _interopRequireDefault(_moveToEdge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      draggableId = _ref.draggableId,
	      impact = _ref.impact,
	      droppable = _ref.droppable,
	      draggables = _ref.draggables;
	
	  if (!impact.destination) {
	    console.error('cannot move to next index when there is not previous destination');
	    return null;
	  }
	
	  var location = impact.destination;
	  var draggable = draggables[draggableId];
	  var axis = droppable.axis;
	
	  var insideForeignDroppable = (0, _getDraggablesInsideDroppable2.default)(droppable, draggables);
	
	  var currentIndex = location.index;
	  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
	  var lastIndex = insideForeignDroppable.length - 1;
	
	  if (proposedIndex > insideForeignDroppable.length) {
	    return null;
	  }
	
	  if (proposedIndex < 0) {
	    return null;
	  }
	
	  var movingRelativeTo = insideForeignDroppable[Math.min(proposedIndex, lastIndex)];
	
	  var isMovingPastLastIndex = proposedIndex > lastIndex;
	  var sourceEdge = 'start';
	  var destinationEdge = function () {
	    if (isMovingPastLastIndex) {
	      return 'end';
	    }
	
	    return 'start';
	  }();
	
	  var newCenter = (0, _moveToEdge2.default)({
	    source: draggable.page.withoutMargin,
	    sourceEdge: sourceEdge,
	    destination: movingRelativeTo.page.withMargin,
	    destinationEdge: destinationEdge,
	    destinationAxis: droppable.axis
	  });
	
	  var isVisible = function () {
	    if (isMovingPastLastIndex) {
	      return true;
	    }
	
	    return (0, _isWithinVisibleBoundsOfDroppable.isPointWithinDroppable)(droppable)(newCenter);
	  }();
	
	  if (!isVisible) {
	    return null;
	  }
	
	  var moved = isMovingForward ? impact.movement.draggables.slice(1, impact.movement.draggables.length) : [movingRelativeTo.id].concat((0, _toConsumableArray3.default)(impact.movement.draggables));
	
	  var newImpact = {
	    movement: {
	      draggables: moved,
	
	      amount: (0, _position.patch)(axis.line, draggable.page.withMargin[axis.size]),
	
	      isBeyondStartPosition: false
	    },
	    destination: {
	      droppableId: droppable.id,
	      index: proposedIndex
	    },
	    direction: droppable.axis.direction
	  };
	
	  return {
	    pageCenter: newCenter,
	    impact: newImpact
	  };
	};

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(97);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _memoizeOne = __webpack_require__(18);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _getDraggablesInsideDroppable = __webpack_require__(44);
	
	var _getDraggablesInsideDroppable2 = _interopRequireDefault(_getDraggablesInsideDroppable);
	
	var _isWithinVisibleBoundsOfDroppable = __webpack_require__(69);
	
	var _position = __webpack_require__(14);
	
	var _moveToEdge = __webpack_require__(70);
	
	var _moveToEdge2 = _interopRequireDefault(_moveToEdge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIndex = (0, _memoizeOne2.default)(function (draggables, target) {
	  return draggables.indexOf(target);
	});
	
	exports.default = function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      draggableId = _ref.draggableId,
	      impact = _ref.impact,
	      droppable = _ref.droppable,
	      draggables = _ref.draggables;
	
	  if (!impact.destination) {
	    console.error('cannot move to next index when there is not previous destination');
	    return null;
	  }
	
	  var location = impact.destination;
	  var draggable = draggables[draggableId];
	  var axis = droppable.axis;
	
	  var insideDroppable = (0, _getDraggablesInsideDroppable2.default)(droppable, draggables);
	
	  var startIndex = getIndex(insideDroppable, draggable);
	  var currentIndex = location.index;
	  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
	
	  if (startIndex === -1) {
	    console.error('could not find draggable inside current droppable');
	    return null;
	  }
	
	  if (proposedIndex > insideDroppable.length - 1) {
	    return null;
	  }
	
	  if (proposedIndex < 0) {
	    return null;
	  }
	
	  var destination = insideDroppable[proposedIndex];
	  var isMovingTowardStart = isMovingForward && proposedIndex <= startIndex || !isMovingForward && proposedIndex >= startIndex;
	
	  var edge = function () {
	    if (!isMovingTowardStart) {
	      return isMovingForward ? 'end' : 'start';
	    }
	
	    return isMovingForward ? 'start' : 'end';
	  }();
	
	  var newCenter = (0, _moveToEdge2.default)({
	    source: draggable.page.withoutMargin,
	    sourceEdge: edge,
	    destination: destination.page.withoutMargin,
	    destinationEdge: edge,
	    destinationAxis: droppable.axis
	  });
	
	  var isVisible = (0, _isWithinVisibleBoundsOfDroppable.isPointWithinDroppable)(droppable)(newCenter);
	
	  if (!isVisible) {
	    return null;
	  }
	
	  var moved = isMovingTowardStart ? impact.movement.draggables.slice(1, impact.movement.draggables.length) : [destination.id].concat((0, _toConsumableArray3.default)(impact.movement.draggables));
	
	  var newImpact = {
	    movement: {
	      draggables: moved,
	
	      amount: (0, _position.patch)(axis.line, draggable.page.withMargin[axis.size]),
	      isBeyondStartPosition: proposedIndex > startIndex
	    },
	    destination: {
	      droppableId: droppable.id,
	      index: proposedIndex
	    },
	    direction: droppable.axis.direction
	  };
	
	  var result = {
	    pageCenter: newCenter,
	    impact: newImpact
	  };
	
	  return result;
	};

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inHomeList = __webpack_require__(518);
	
	var _inHomeList2 = _interopRequireDefault(_inHomeList);
	
	var _inForeignList = __webpack_require__(517);
	
	var _inForeignList2 = _interopRequireDefault(_inForeignList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (args) {
	  var draggableId = args.draggableId,
	      draggables = args.draggables,
	      droppable = args.droppable;
	
	
	  var draggable = draggables[draggableId];
	  var isInHomeList = draggable.droppableId === droppable.id;
	
	  if (!droppable.isEnabled) {
	    return null;
	  }
	
	  if (isInHomeList) {
	    return (0, _inHomeList2.default)(args);
	  }
	
	  return (0, _inForeignList2.default)(args);
	};

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(35);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends6 = __webpack_require__(36);
	
	var _extends7 = _interopRequireDefault(_extends6);
	
	var _memoizeOne = __webpack_require__(18);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _getInitialImpact = __webpack_require__(509);
	
	var _getInitialImpact2 = _interopRequireDefault(_getInitialImpact);
	
	var _position = __webpack_require__(14);
	
	var _getDragImpact = __webpack_require__(507);
	
	var _getDragImpact2 = _interopRequireDefault(_getDragImpact);
	
	var _moveToNextIndex = __webpack_require__(519);
	
	var _moveToNextIndex2 = _interopRequireDefault(_moveToNextIndex);
	
	var _moveCrossAxis = __webpack_require__(513);
	
	var _moveCrossAxis2 = _interopRequireDefault(_moveCrossAxis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noDimensions = {
	  request: null,
	  draggable: {},
	  droppable: {}
	};
	
	var origin = { x: 0, y: 0 };
	
	var clean = (0, _memoizeOne2.default)(function () {
	  var phase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'IDLE';
	  return {
	    phase: phase,
	    drag: null,
	    drop: null,
	    dimension: noDimensions
	  };
	});
	
	var move = function move(_ref) {
	  var state = _ref.state,
	      clientSelection = _ref.clientSelection,
	      _ref$shouldAnimate = _ref.shouldAnimate,
	      shouldAnimate = _ref$shouldAnimate === undefined ? false : _ref$shouldAnimate,
	      windowScroll = _ref.windowScroll,
	      impact = _ref.impact;
	
	  if (state.phase !== 'DRAGGING') {
	    console.error('cannot move while not dragging');
	    return clean();
	  }
	
	  if (state.drag == null) {
	    console.error('cannot move if there is no drag information');
	    return clean();
	  }
	
	  var previous = state.drag.current;
	  var initial = state.drag.initial;
	  var currentWindowScroll = windowScroll || previous.windowScroll;
	
	  var client = function () {
	    var offset = (0, _position.subtract)(clientSelection, initial.client.selection);
	
	    var result = {
	      offset: offset,
	      selection: clientSelection,
	      center: (0, _position.add)(offset, initial.client.center)
	    };
	    return result;
	  }();
	
	  var page = {
	    selection: (0, _position.add)(client.selection, currentWindowScroll),
	    offset: (0, _position.add)(client.offset, currentWindowScroll),
	    center: (0, _position.add)(client.center, currentWindowScroll)
	  };
	
	  var current = {
	    id: previous.id,
	    type: previous.type,
	    isScrollAllowed: previous.isScrollAllowed,
	    client: client,
	    page: page,
	    shouldAnimate: shouldAnimate,
	    windowScroll: currentWindowScroll
	  };
	
	  var previousDroppableOverId = state.drag && state.drag.impact.destination ? state.drag.impact.destination.droppableId : null;
	
	  var newImpact = impact || (0, _getDragImpact2.default)({
	    pageCenter: page.center,
	    draggable: state.dimension.draggable[current.id],
	    draggables: state.dimension.draggable,
	    droppables: state.dimension.droppable,
	    previousDroppableOverId: previousDroppableOverId
	  });
	
	  var drag = {
	    initial: initial,
	    impact: newImpact,
	    current: current,
	    previous: {
	      droppableOverId: previousDroppableOverId
	    }
	  };
	
	  return (0, _extends7.default)({}, state, {
	    drag: drag
	  });
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : clean('IDLE');
	  var action = arguments[1];
	
	  if (action.type === 'CLEAN') {
	    return clean();
	  }
	
	  if (action.type === 'PREPARE') {
	    return clean('PREPARING');
	  }
	
	  if (action.type === 'REQUEST_DIMENSIONS') {
	    if (state.phase !== 'PREPARING') {
	      console.error('trying to start a lift while not preparing for a lift');
	      return clean();
	    }
	
	    var typeId = action.payload;
	
	    return {
	      phase: 'COLLECTING_DIMENSIONS',
	      drag: null,
	      drop: null,
	      dimension: {
	        request: typeId,
	        draggable: {},
	        droppable: {}
	      }
	    };
	  }
	
	  if (action.type === 'PUBLISH_DRAGGABLE_DIMENSION') {
	    var dimension = action.payload;
	
	    if (state.phase !== 'COLLECTING_DIMENSIONS') {
	      console.warn('dimension rejected as no longer requesting dimensions', dimension);
	      return state;
	    }
	
	    if (state.dimension.draggable[dimension.id]) {
	      console.error('dimension already exists for ' + dimension.id);
	      return state;
	    }
	
	    return (0, _extends7.default)({}, state, {
	      dimension: {
	        request: state.dimension.request,
	        droppable: state.dimension.droppable,
	        draggable: (0, _extends7.default)({}, state.dimension.draggable, (0, _defineProperty3.default)({}, dimension.id, dimension))
	      }
	    });
	  }
	
	  if (action.type === 'PUBLISH_DROPPABLE_DIMENSION') {
	    var _dimension = action.payload;
	
	    if (state.phase !== 'COLLECTING_DIMENSIONS') {
	      console.warn('dimension rejected as no longer requesting dimensions', _dimension);
	      return state;
	    }
	
	    if (state.dimension.droppable[_dimension.id]) {
	      console.error('dimension already exists for ' + _dimension.id);
	      return state;
	    }
	
	    return (0, _extends7.default)({}, state, {
	      dimension: {
	        request: state.dimension.request,
	        draggable: state.dimension.draggable,
	        droppable: (0, _extends7.default)({}, state.dimension.droppable, (0, _defineProperty3.default)({}, _dimension.id, _dimension))
	      }
	    });
	  }
	
	  if (action.type === 'COMPLETE_LIFT') {
	    if (state.phase !== 'COLLECTING_DIMENSIONS') {
	      console.error('trying complete lift without collecting dimensions');
	      return state;
	    }
	
	    var _action$payload = action.payload,
	        id = _action$payload.id,
	        type = _action$payload.type,
	        client = _action$payload.client,
	        _windowScroll = _action$payload.windowScroll,
	        isScrollAllowed = _action$payload.isScrollAllowed;
	
	    var draggables = state.dimension.draggable;
	    var draggable = state.dimension.draggable[id];
	    var droppable = state.dimension.droppable[draggable.droppableId];
	    var page = {
	      selection: (0, _position.add)(client.selection, _windowScroll),
	      center: (0, _position.add)(client.center, _windowScroll)
	    };
	
	    var _impact = (0, _getInitialImpact2.default)({
	      draggable: draggable,
	      droppable: droppable,
	      draggables: draggables
	    });
	
	    if (!_impact || !_impact.destination) {
	      console.error('invalid lift state');
	      return clean();
	    }
	
	    var source = _impact.destination;
	
	    var initial = {
	      source: source,
	      client: client,
	      page: page,
	      windowScroll: _windowScroll
	    };
	
	    var current = {
	      id: id,
	      type: type,
	      client: {
	        selection: client.selection,
	        center: client.center,
	        offset: origin
	      },
	      page: {
	        selection: page.selection,
	        center: page.center,
	        offset: origin
	      },
	      windowScroll: _windowScroll,
	      isScrollAllowed: isScrollAllowed,
	      shouldAnimate: false
	    };
	
	    return (0, _extends7.default)({}, state, {
	      phase: 'DRAGGING',
	      drag: {
	        initial: initial,
	        current: current,
	        impact: _impact
	      }
	    });
	  }
	
	  if (action.type === 'UPDATE_DROPPABLE_DIMENSION_SCROLL') {
	    if (state.phase !== 'DRAGGING') {
	      console.error('cannot update a droppable dimensions scroll when not dragging');
	      return clean();
	    }
	
	    if (state.drag == null) {
	      console.error('invalid store state');
	      return clean();
	    }
	
	    if (!state.drag.current.isScrollAllowed) {
	      return clean();
	    }
	
	    var _action$payload2 = action.payload,
	        _id = _action$payload2.id,
	        offset = _action$payload2.offset;
	
	
	    var target = state.dimension.droppable[_id];
	
	    if (!target) {
	      console.error('cannot update a droppable that is not inside of the state', _id);
	      return clean();
	    }
	
	    var _dimension2 = (0, _extends7.default)({}, target, {
	      container: (0, _extends7.default)({}, target.container, {
	        scroll: (0, _extends7.default)({}, target.container.scroll, {
	          current: offset
	        })
	      })
	    });
	
	    var withUpdatedDimension = (0, _extends7.default)({}, state, {
	      dimension: {
	        request: state.dimension.request,
	        draggable: state.dimension.draggable,
	        droppable: (0, _extends7.default)({}, state.dimension.droppable, (0, _defineProperty3.default)({}, _id, _dimension2))
	      }
	    });
	
	    return move({
	      state: withUpdatedDimension,
	      clientSelection: state.drag.current.client.selection
	    });
	  }
	
	  if (action.type === 'UPDATE_DROPPABLE_DIMENSION_IS_ENABLED') {
	    if (!(0, _keys2.default)(state.dimension.droppable).length) {
	      return state;
	    }
	
	    var _action$payload3 = action.payload,
	        _id2 = _action$payload3.id,
	        isEnabled = _action$payload3.isEnabled;
	
	    var _target = state.dimension.droppable[_id2];
	
	    if (!_target) {
	      console.error('cannot update enabled flag on droppable that does not have a dimension');
	      return clean();
	    }
	
	    if (_target.isEnabled === isEnabled) {
	      console.warn('trying to set droppable isEnabled to ' + String(isEnabled) + ' but it is already ' + String(isEnabled));
	      return state;
	    }
	
	    var updatedDroppableDimension = (0, _extends7.default)({}, _target, {
	      isEnabled: isEnabled
	    });
	
	    return (0, _extends7.default)({}, state, {
	      dimension: (0, _extends7.default)({}, state.dimension, {
	        droppable: (0, _extends7.default)({}, state.dimension.droppable, (0, _defineProperty3.default)({}, _id2, updatedDroppableDimension))
	      })
	    });
	  }
	
	  if (action.type === 'MOVE') {
	    var _action$payload4 = action.payload,
	        _client = _action$payload4.client,
	        _windowScroll2 = _action$payload4.windowScroll;
	
	    return move({
	      state: state,
	      clientSelection: _client,
	      windowScroll: _windowScroll2
	    });
	  }
	
	  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
	    var _windowScroll3 = action.payload.windowScroll;
	
	
	    if (!state.drag) {
	      console.error('cannot move with window scrolling if no current drag');
	      return clean();
	    }
	
	    return move({
	      state: state,
	      clientSelection: state.drag.current.client.selection,
	      windowScroll: _windowScroll3
	    });
	  }
	
	  if (action.type === 'MOVE_FORWARD' || action.type === 'MOVE_BACKWARD') {
	    if (state.phase !== 'DRAGGING') {
	      console.error('cannot move while not dragging', action);
	      return clean();
	    }
	
	    if (!state.drag) {
	      console.error('cannot move if there is no drag information');
	      return clean();
	    }
	
	    var existing = state.drag;
	    var isMovingForward = action.type === 'MOVE_FORWARD';
	
	    if (!existing.impact.destination) {
	      console.error('cannot move if there is no previous destination');
	      return clean();
	    }
	
	    var _droppable = state.dimension.droppable[existing.impact.destination.droppableId];
	
	    var result = (0, _moveToNextIndex2.default)({
	      isMovingForward: isMovingForward,
	      draggableId: existing.current.id,
	      impact: existing.impact,
	      droppable: _droppable,
	      draggables: state.dimension.draggable
	    });
	
	    if (!result) {
	      return state;
	    }
	
	    var _impact2 = result.impact;
	    var _page = result.pageCenter;
	    var _client2 = (0, _position.subtract)(_page, existing.current.windowScroll);
	
	    return move({
	      state: state,
	      impact: _impact2,
	      clientSelection: _client2,
	      shouldAnimate: true
	    });
	  }
	
	  if (action.type === 'CROSS_AXIS_MOVE_FORWARD' || action.type === 'CROSS_AXIS_MOVE_BACKWARD') {
	    if (state.phase !== 'DRAGGING') {
	      console.error('cannot move cross axis when not dragging');
	      return clean();
	    }
	
	    if (!state.drag) {
	      console.error('cannot move cross axis if there is no drag information');
	      return clean();
	    }
	
	    if (!state.drag.impact.destination) {
	      console.error('cannot move cross axis if not in a droppable');
	      return clean();
	    }
	
	    var _current = state.drag.current;
	    var draggableId = _current.id;
	    var center = _current.page.center;
	    var droppableId = state.drag.impact.destination.droppableId;
	    var home = state.drag.initial.source;
	
	    var _result = (0, _moveCrossAxis2.default)({
	      isMovingForward: action.type === 'CROSS_AXIS_MOVE_FORWARD',
	      pageCenter: center,
	      draggableId: draggableId,
	      droppableId: droppableId,
	      home: home,
	      draggables: state.dimension.draggable,
	      droppables: state.dimension.droppable
	    });
	
	    if (!_result) {
	      return state;
	    }
	
	    var _page2 = _result.pageCenter;
	    var _client3 = (0, _position.subtract)(_page2, _current.windowScroll);
	
	    return move({
	      state: state,
	      clientSelection: _client3,
	      impact: _result.impact,
	      shouldAnimate: true
	    });
	  }
	
	  if (action.type === 'DROP_ANIMATE') {
	    var _action$payload5 = action.payload,
	        trigger = _action$payload5.trigger,
	        newHomeOffset = _action$payload5.newHomeOffset,
	        _impact3 = _action$payload5.impact,
	        _result2 = _action$payload5.result;
	
	
	    if (state.phase !== 'DRAGGING') {
	      console.error('cannot animate drop while not dragging', action);
	      return state;
	    }
	
	    if (!state.drag) {
	      console.error('cannot animate drop - invalid drag state');
	      return clean();
	    }
	
	    var pending = {
	      trigger: trigger,
	      newHomeOffset: newHomeOffset,
	      result: _result2,
	      impact: _impact3
	    };
	
	    return {
	      phase: 'DROP_ANIMATING',
	      drag: null,
	      drop: {
	        pending: pending,
	        result: null
	      },
	      dimension: state.dimension
	    };
	  }
	
	  if (action.type === 'DROP_COMPLETE') {
	    var _result3 = action.payload;
	
	    return {
	      phase: 'DROP_COMPLETE',
	      drag: null,
	      drop: {
	        pending: null,
	        result: _result3
	      },
	      dimension: noDimensions
	    };
	  }
	
	  return state;
	};

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(23);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(24);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(25);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createStore = __webpack_require__(503);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _fireHooks = __webpack_require__(504);
	
	var _fireHooks2 = _interopRequireDefault(_fireHooks);
	
	var _contextKeys = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DragDropContext = function (_React$Component) {
	  (0, _inherits3.default)(DragDropContext, _React$Component);
	
	  function DragDropContext() {
	    (0, _classCallCheck3.default)(this, DragDropContext);
	    return (0, _possibleConstructorReturn3.default)(this, (DragDropContext.__proto__ || (0, _getPrototypeOf2.default)(DragDropContext)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DragDropContext, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return (0, _defineProperty3.default)({}, _contextKeys.storeKey, this.store);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.store = (0, _createStore2.default)();
	
	      var previous = this.store.getState();
	
	      this.unsubscribe = this.store.subscribe(function () {
	        var current = _this2.store.getState();
	
	        var hooks = {
	          onDragStart: _this2.props.onDragStart,
	          onDragEnd: _this2.props.onDragEnd
	        };
	
	        (0, _fireHooks2.default)(hooks, current, previous);
	        previous = current;
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unsubscribe();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return DragDropContext;
	}(_react2.default.Component);
	
	DragDropContext.childContextTypes = (0, _defineProperty3.default)({}, _contextKeys.storeKey, _propTypes2.default.shape({
	  dispatch: _propTypes2.default.func.isRequired,
	  subscribe: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	}).isRequired);
	exports.default = DragDropContext;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dragDropContext = __webpack_require__(521);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dragDropContext).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(23);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(24);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(25);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _memoizeOne = __webpack_require__(18);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _createMouseSensor = __webpack_require__(526);
	
	var _createMouseSensor2 = _interopRequireDefault(_createMouseSensor);
	
	var _createKeyboardSensor = __webpack_require__(525);
	
	var _createKeyboardSensor2 = _interopRequireDefault(_createKeyboardSensor);
	
	var _createTouchSensor = __webpack_require__(527);
	
	var _createTouchSensor2 = _interopRequireDefault(_createTouchSensor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getFalse = function getFalse() {
	  return false;
	};
	
	var DragHandle = function (_Component) {
	  (0, _inherits3.default)(DragHandle, _Component);
	
	  function DragHandle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DragHandle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DragHandle.__proto__ || (0, _getPrototypeOf2.default)(DragHandle)).call.apply(_ref, [this].concat(args))), _this), _this.mouseSensor = (0, _createMouseSensor2.default)(_this.props.callbacks, _this.props.getDraggableRef), _this.keyboardSensor = (0, _createKeyboardSensor2.default)(_this.props.callbacks, _this.props.getDraggableRef), _this.touchSensor = (0, _createTouchSensor2.default)(_this.props.callbacks, _this.props.getDraggableRef), _this.sensors = [_this.mouseSensor, _this.keyboardSensor, _this.touchSensor], _this.onKeyDown = function (event) {
	      if (_this.mouseSensor.isCapturing()) {
	        return;
	      }
	
	      _this.keyboardSensor.onKeyDown(event, _this.props);
	    }, _this.onMouseDown = function (event) {
	      if (_this.keyboardSensor.isCapturing() || _this.mouseSensor.isCapturing()) {
	        return;
	      }
	
	      _this.mouseSensor.onMouseDown(event, _this.props);
	    }, _this.onTouchStart = function (event) {
	      if (_this.mouseSensor.isCapturing() || _this.keyboardSensor.isCapturing()) {
	        console.error('mouse or keyboard already listening when attempting to touch drag');
	        return;
	      }
	
	      _this.touchSensor.onTouchStart(event, _this.props);
	    }, _this.onTouchMove = function (event) {
	      _this.touchSensor.onTouchMove(event);
	    }, _this.onClick = function (event) {
	      _this.mouseSensor.onClick(event);
	      _this.touchSensor.onClick(event);
	    }, _this.isAnySensorDragging = function () {
	      return _this.sensors.some(function (sensor) {
	        return sensor.isDragging();
	      });
	    }, _this.isAnySensorCapturing = function () {
	      return _this.sensors.some(function (sensor) {
	        return sensor.isCapturing();
	      });
	    }, _this.getProvided = (0, _memoizeOne2.default)(function (isEnabled, isDragging) {
	      if (!isEnabled) {
	        return null;
	      }
	
	      var provided = {
	        onMouseDown: _this.onMouseDown,
	        onKeyDown: _this.onKeyDown,
	        onTouchStart: _this.onTouchStart,
	        onTouchMove: _this.onTouchMove,
	        onClick: _this.onClick,
	        tabIndex: 0,
	        'aria-grabbed': isDragging,
	        draggable: false,
	        onDragStart: getFalse,
	        onDrop: getFalse
	      };
	
	      return provided;
	    }), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DragHandle, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this2 = this;
	
	      this.sensors.forEach(function (sensor) {
	        var wasCapturing = sensor.isCapturing();
	        var wasDragging = sensor.isDragging();
	
	        if (wasCapturing) {
	          sensor.kill();
	        }
	
	        if (wasDragging) {
	          _this2.props.callbacks.onCancel();
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var isCapturing = this.isAnySensorCapturing();
	
	      if (!isCapturing) {
	        return;
	      }
	
	      var isDragStopping = this.props.isDragging && !nextProps.isDragging;
	
	      if (isDragStopping) {
	        this.sensors.forEach(function (sensor) {
	          if (sensor.isCapturing()) {
	            sensor.kill();
	          }
	        });
	        return;
	      }
	
	      if (!nextProps.isEnabled) {
	        this.sensors.forEach(function (sensor) {
	          if (sensor.isCapturing()) {
	            var wasDragging = sensor.isDragging();
	
	            sensor.kill();
	
	            if (wasDragging) {
	              _this3.props.callbacks.onCancel();
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          isEnabled = _props.isEnabled;
	
	
	      return children(this.getProvided(isEnabled, this.isAnySensorDragging()));
	    }
	  }]);
	  return DragHandle;
	}(_react.Component);
	
	exports.default = DragHandle;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dragHandle = __webpack_require__(523);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dragHandle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(35);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stopEvent = __webpack_require__(84);
	
	var _stopEvent2 = _interopRequireDefault(_stopEvent);
	
	var _createScheduler = __webpack_require__(133);
	
	var _createScheduler2 = _interopRequireDefault(_createScheduler);
	
	var _blockStandardKeyEvents = __webpack_require__(220);
	
	var _blockStandardKeyEvents2 = _interopRequireDefault(_blockStandardKeyEvents);
	
	var _keyCodes = __webpack_require__(137);
	
	var keyCodes = _interopRequireWildcard(_keyCodes);
	
	var _getWindowFromRef = __webpack_require__(135);
	
	var _getWindowFromRef2 = _interopRequireDefault(_getWindowFromRef);
	
	var _getCenterPosition = __webpack_require__(221);
	
	var _getCenterPosition2 = _interopRequireDefault(_getCenterPosition);
	
	var _shouldAllowDraggingFromTarget = __webpack_require__(134);
	
	var _shouldAllowDraggingFromTarget2 = _interopRequireDefault(_shouldAllowDraggingFromTarget);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noop = function noop() {};
	
	exports.default = function (callbacks, getDraggableRef) {
	  var state = {
	    isDragging: false
	  };
	  var setState = function setState(newState) {
	    state = newState;
	  };
	  var startDragging = function startDragging() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    setState({
	      isDragging: true
	    });
	    bindWindowEvents();
	    fn();
	  };
	  var stopDragging = function stopDragging() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    unbindWindowEvents();
	    setState({
	      isDragging: false
	    });
	    fn();
	  };
	  var kill = function kill() {
	    return stopDragging();
	  };
	  var cancel = function cancel() {
	    stopDragging(callbacks.onCancel);
	  };
	  var isDragging = function isDragging() {
	    return state.isDragging;
	  };
	  var schedule = (0, _createScheduler2.default)(callbacks, isDragging);
	
	  var onKeyDown = function onKeyDown(event, props) {
	    var canLift = props.canLift,
	        direction = props.direction;
	
	    if (!isDragging()) {
	      if (!canLift) {
	        return;
	      }
	
	      if (event.keyCode !== keyCodes.space) {
	        return;
	      }
	
	      if (!(0, _shouldAllowDraggingFromTarget2.default)(event, props)) {
	        return;
	      }
	
	      (0, _stopEvent2.default)(event);
	
	      var ref = getDraggableRef();
	
	      if (!ref) {
	        console.error('cannot start a keyboard drag without a draggable ref');
	        return;
	      }
	
	      var center = (0, _getCenterPosition2.default)(ref);
	
	      startDragging(function () {
	        return callbacks.onLift({ client: center, isScrollAllowed: false });
	      });
	      return;
	    }
	
	    if (!direction) {
	      console.error('cannot handle keyboard event if direction is not provided');
	      (0, _stopEvent2.default)(event);
	      cancel();
	      return;
	    }
	
	    if (event.keyCode === keyCodes.escape) {
	      (0, _stopEvent2.default)(event);
	      cancel();
	      return;
	    }
	
	    if (event.keyCode === keyCodes.space) {
	      (0, _stopEvent2.default)(event);
	      stopDragging(callbacks.onDrop);
	      return;
	    }
	
	    var executeBasedOnDirection = function executeBasedOnDirection(fns) {
	      if (direction === 'vertical') {
	        fns.vertical();
	        return;
	      }
	      fns.horizontal();
	    };
	
	    if (event.keyCode === keyCodes.arrowDown) {
	      (0, _stopEvent2.default)(event);
	      executeBasedOnDirection({
	        vertical: schedule.moveForward,
	        horizontal: schedule.crossAxisMoveForward
	      });
	      return;
	    }
	
	    if (event.keyCode === keyCodes.arrowUp) {
	      (0, _stopEvent2.default)(event);
	      executeBasedOnDirection({
	        vertical: schedule.moveBackward,
	        horizontal: schedule.crossAxisMoveBackward
	      });
	      return;
	    }
	
	    if (event.keyCode === keyCodes.arrowRight) {
	      (0, _stopEvent2.default)(event);
	      executeBasedOnDirection({
	        vertical: schedule.crossAxisMoveForward,
	        horizontal: schedule.moveForward
	      });
	      return;
	    }
	
	    if (event.keyCode === keyCodes.arrowLeft) {
	      (0, _stopEvent2.default)(event);
	      executeBasedOnDirection({
	        vertical: schedule.crossAxisMoveBackward,
	        horizontal: schedule.moveBackward
	      });
	    }
	
	    (0, _blockStandardKeyEvents2.default)(event);
	  };
	
	  var windowBindings = {
	    mousedown: cancel,
	    resize: cancel,
	
	    scroll: cancel
	  };
	
	  var eventKeys = (0, _keys2.default)(windowBindings);
	
	  var bindWindowEvents = function bindWindowEvents() {
	    var win = (0, _getWindowFromRef2.default)(getDraggableRef());
	
	    eventKeys.forEach(function (eventKey) {
	      win.addEventListener(eventKey, windowBindings[eventKey]);
	    });
	  };
	
	  var unbindWindowEvents = function unbindWindowEvents() {
	    var win = (0, _getWindowFromRef2.default)(getDraggableRef());
	
	    eventKeys.forEach(function (eventKey) {
	      win.removeEventListener(eventKey, windowBindings[eventKey]);
	    });
	  };
	
	  var sensor = {
	    onKeyDown: onKeyDown,
	    kill: kill,
	    isDragging: isDragging,
	
	    isCapturing: isDragging
	  };
	
	  return sensor;
	};

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(35);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(36);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stopEvent = __webpack_require__(84);
	
	var _stopEvent2 = _interopRequireDefault(_stopEvent);
	
	var _createScheduler = __webpack_require__(133);
	
	var _createScheduler2 = _interopRequireDefault(_createScheduler);
	
	var _isSloppyClickThresholdExceeded = __webpack_require__(528);
	
	var _isSloppyClickThresholdExceeded2 = _interopRequireDefault(_isSloppyClickThresholdExceeded);
	
	var _getWindowFromRef = __webpack_require__(135);
	
	var _getWindowFromRef2 = _interopRequireDefault(_getWindowFromRef);
	
	var _keyCodes = __webpack_require__(137);
	
	var keyCodes = _interopRequireWildcard(_keyCodes);
	
	var _blockStandardKeyEvents = __webpack_require__(220);
	
	var _blockStandardKeyEvents2 = _interopRequireDefault(_blockStandardKeyEvents);
	
	var _shouldAllowDraggingFromTarget = __webpack_require__(134);
	
	var _shouldAllowDraggingFromTarget2 = _interopRequireDefault(_shouldAllowDraggingFromTarget);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var primaryButton = 0;
	var noop = function noop() {};
	
	exports.default = function (callbacks, getDraggableRef) {
	  var state = {
	    isDragging: false,
	    pending: null,
	    preventClick: false
	  };
	  var setState = function setState(partial) {
	    var newState = (0, _extends3.default)({}, state, partial);
	    state = newState;
	  };
	  var isDragging = function isDragging() {
	    return state.isDragging;
	  };
	  var isCapturing = function isCapturing() {
	    return Boolean(state.pending || state.isDragging);
	  };
	  var schedule = (0, _createScheduler2.default)(callbacks, isDragging);
	
	  var startDragging = function startDragging() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    setState({
	      pending: null,
	      isDragging: true,
	      preventClick: true
	    });
	    fn();
	  };
	  var stopDragging = function stopDragging() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    unbindWindowEvents();
	    setState({
	      isDragging: false,
	      pending: null
	    });
	    fn();
	  };
	  var startPendingDrag = function startPendingDrag(point) {
	    setState({ pending: point, isDragging: false });
	    bindWindowEvents();
	  };
	  var stopPendingDrag = function stopPendingDrag() {
	    setState({
	      preventClick: false
	    });
	    stopDragging();
	  };
	
	  var kill = function kill() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    if (state.pending) {
	      stopPendingDrag();
	      return;
	    }
	    stopDragging(fn);
	  };
	
	  var cancel = function cancel() {
	    kill(callbacks.onCancel);
	  };
	
	  var windowBindings = {
	    mousemove: function mousemove(event) {
	      var button = event.button,
	          clientX = event.clientX,
	          clientY = event.clientY;
	
	      if (button !== primaryButton) {
	        return;
	      }
	
	      var point = {
	        x: clientX,
	        y: clientY
	      };
	
	      if (state.isDragging) {
	        schedule.move(point);
	        return;
	      }
	
	      if (!state.pending) {
	        console.error('invalid state');
	        return;
	      }
	
	      if (!(0, _isSloppyClickThresholdExceeded2.default)(state.pending, point)) {
	        return;
	      }
	
	      startDragging(function () {
	        return callbacks.onLift({ client: point, isScrollAllowed: true });
	      });
	    },
	    mouseup: function mouseup() {
	      if (state.pending) {
	        stopPendingDrag();
	        return;
	      }
	
	      stopDragging(callbacks.onDrop);
	    },
	    mousedown: function mousedown() {
	      stopDragging(callbacks.onCancel);
	    },
	    keydown: function keydown(event) {
	      if (event.keyCode === keyCodes.escape) {
	        (0, _stopEvent2.default)(event);
	        cancel();
	        return;
	      }
	
	      (0, _blockStandardKeyEvents2.default)(event);
	    },
	    resize: cancel,
	    scroll: function scroll() {
	      if (state.pending) {
	        stopPendingDrag();
	        return;
	      }
	      schedule.windowScrollMove();
	    },
	
	    webkitmouseforcechanged: function webkitmouseforcechanged(event) {
	      if (event.webkitForce == null || MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN == null) {
	        console.error('handling a mouse force changed event when it is not supported');
	        return;
	      }
	
	      var forcePressThreshold = MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN;
	      var isForcePressing = event.webkitForce >= forcePressThreshold;
	
	      if (isForcePressing) {
	        cancel();
	      }
	    }
	  };
	
	  var eventKeys = (0, _keys2.default)(windowBindings);
	
	  var bindWindowEvents = function bindWindowEvents() {
	    var win = (0, _getWindowFromRef2.default)(getDraggableRef());
	
	    eventKeys.forEach(function (eventKey) {
	      if (eventKey === 'scroll') {
	        win.addEventListener(eventKey, windowBindings.scroll, { passive: true });
	        return;
	      }
	
	      win.addEventListener(eventKey, windowBindings[eventKey]);
	    });
	  };
	
	  var unbindWindowEvents = function unbindWindowEvents() {
	    var win = (0, _getWindowFromRef2.default)(getDraggableRef());
	
	    eventKeys.forEach(function (eventKey) {
	      return win.removeEventListener(eventKey, windowBindings[eventKey]);
	    });
	  };
	
	  var onMouseDown = function onMouseDown(event, props) {
	    if (!props.canLift) {
	      return;
	    }
	
	    if (isCapturing()) {
	      console.error('should not be able to perform a mouse down while a drag or pending drag is occurring');
	      cancel();
	      return;
	    }
	
	    if (!(0, _shouldAllowDraggingFromTarget2.default)(event, props)) {
	      return;
	    }
	
	    var button = event.button,
	        clientX = event.clientX,
	        clientY = event.clientY;
	
	    if (button !== primaryButton) {
	      return;
	    }
	
	    (0, _stopEvent2.default)(event);
	    var point = {
	      x: clientX,
	      y: clientY
	    };
	
	    startPendingDrag(point);
	  };
	
	  var onClick = function onClick(event) {
	    if (!state.preventClick) {
	      return;
	    }
	
	    setState({
	      preventClick: false
	    });
	    (0, _stopEvent2.default)(event);
	  };
	
	  var sensor = {
	    onMouseDown: onMouseDown,
	    onClick: onClick,
	    kill: kill,
	    isCapturing: isCapturing,
	    isDragging: isDragging
	  };
	
	  return sensor;
	};

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forcePressThreshold = exports.timeForLongPress = undefined;
	
	var _keys = __webpack_require__(35);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(36);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stopEvent = __webpack_require__(84);
	
	var _stopEvent2 = _interopRequireDefault(_stopEvent);
	
	var _createScheduler = __webpack_require__(133);
	
	var _createScheduler2 = _interopRequireDefault(_createScheduler);
	
	var _getWindowFromRef = __webpack_require__(135);
	
	var _getWindowFromRef2 = _interopRequireDefault(_getWindowFromRef);
	
	var _shouldAllowDraggingFromTarget = __webpack_require__(134);
	
	var _shouldAllowDraggingFromTarget2 = _interopRequireDefault(_shouldAllowDraggingFromTarget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeForLongPress = exports.timeForLongPress = 150;
	var forcePressThreshold = exports.forcePressThreshold = 0.15;
	
	var noop = function noop() {};
	
	var initial = {
	  isDragging: false,
	  pending: null,
	  hasMoved: false,
	  preventClick: false,
	  longPressTimerId: null
	};
	
	exports.default = function (callbacks, getDraggableRef) {
	  var state = initial;
	
	  var setState = function setState(partial) {
	    state = (0, _extends3.default)({}, state, partial);
	  };
	  var isDragging = function isDragging() {
	    return state.isDragging;
	  };
	  var isCapturing = function isCapturing() {
	    return Boolean(state.pending || state.isDragging || state.longPressTimerId);
	  };
	  var schedule = (0, _createScheduler2.default)(callbacks, isDragging);
	
	  var startDragging = function startDragging() {
	    var pending = state.pending;
	
	    if (!pending) {
	      console.error('cannot start a touch drag without a pending position');
	      kill();
	      return;
	    }
	
	    setState({
	      isDragging: true,
	
	      hasMoved: false,
	
	      pending: null,
	      longPressTimerId: null
	    });
	
	    callbacks.onLift({
	      client: pending,
	
	      isScrollAllowed: false
	    });
	  };
	  var stopDragging = function stopDragging() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    unbindWindowEvents();
	    setState((0, _extends3.default)({}, initial, {
	      preventClick: true
	    }));
	    fn();
	  };
	
	  var startPendingDrag = function startPendingDrag(event) {
	    var touch = event.touches[0];
	    var clientX = touch.clientX,
	        clientY = touch.clientY;
	
	    var point = {
	      x: clientX,
	      y: clientY
	    };
	
	    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
	
	    setState({
	      longPressTimerId: longPressTimerId,
	      pending: point,
	      isDragging: false,
	      hasMoved: false
	    });
	    bindWindowEvents();
	  };
	
	  var stopPendingDrag = function stopPendingDrag() {
	    clearTimeout(state.longPressTimerId);
	    unbindWindowEvents();
	
	    setState(initial);
	  };
	
	  var kill = function kill() {
	    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    if (state.pending) {
	      stopPendingDrag();
	      return;
	    }
	    stopDragging(fn);
	  };
	
	  var cancel = function cancel() {
	    kill(callbacks.onCancel);
	  };
	
	  var windowBindings = {
	    touchmove: function touchmove(event) {
	      if (state.pending) {
	        stopPendingDrag();
	        return;
	      }
	
	      if (!state.hasMoved) {
	        setState({
	          hasMoved: true
	        });
	      }
	
	      (0, _stopEvent2.default)(event);
	
	      var _event$touches$ = event.touches[0],
	          clientX = _event$touches$.clientX,
	          clientY = _event$touches$.clientY;
	
	
	      var point = {
	        x: clientX,
	        y: clientY
	      };
	
	      schedule.move(point);
	    },
	    touchend: function touchend(event) {
	      if (state.pending) {
	        stopPendingDrag();
	
	        return;
	      }
	
	      stopDragging(callbacks.onDrop);
	      (0, _stopEvent2.default)(event);
	    },
	    touchcancel: cancel,
	    touchstart: function touchstart() {
	      if (isDragging()) {
	        console.error('touch start fired while already dragging');
	        cancel();
	      }
	    },
	
	    orientationchange: cancel,
	
	    resize: cancel,
	
	    scroll: cancel,
	
	    contextmenu: _stopEvent2.default,
	
	    keydown: cancel,
	
	    touchforcechange: function touchforcechange(event) {
	      if (state.hasMoved) {
	        return;
	      }
	
	      var touch = event.touches[0];
	
	      if (touch.force >= forcePressThreshold) {
	        cancel();
	      }
	    }
	  };
	
	  var eventKeys = (0, _keys2.default)(windowBindings);
	
	  var bindWindowEvents = function bindWindowEvents() {
	    var win = (0, _getWindowFromRef2.default)(getDraggableRef());
	
	    eventKeys.forEach(function (eventKey) {
	      var fn = windowBindings[eventKey];
	
	      if (eventKey === 'touchmove') {
	        win.addEventListener(eventKey, fn, { passive: false });
	        return;
	      }
	
	      win.addEventListener(eventKey, fn);
	    });
	  };
	
	  var unbindWindowEvents = function unbindWindowEvents() {
	    var win = (0, _getWindowFromRef2.default)(getDraggableRef());
	
	    eventKeys.forEach(function (eventKey) {
	      return win.removeEventListener(eventKey, windowBindings[eventKey]);
	    });
	  };
	
	  var onTouchStart = function onTouchStart(event, props) {
	    if (!props.canLift) {
	      return;
	    }
	
	    if (isCapturing()) {
	      console.error('should not be able to perform a touch start while a drag or pending drag is occurring');
	      cancel();
	      return;
	    }
	
	    if (!(0, _shouldAllowDraggingFromTarget2.default)(event, props)) {
	      return;
	    }
	
	    event.stopPropagation();
	
	    startPendingDrag(event);
	  };
	
	  var onTouchMove = function onTouchMove() {
	    if (state.pending) {
	      stopPendingDrag();
	    }
	  };
	
	  var onClick = function onClick(event) {
	    if (!state.preventClick) {
	      return;
	    }
	
	    (0, _stopEvent2.default)(event);
	    setState(initial);
	  };
	
	  var sensor = {
	    onTouchStart: onTouchStart,
	    onTouchMove: onTouchMove,
	    onClick: onClick,
	    kill: kill,
	    isCapturing: isCapturing,
	    isDragging: isDragging
	  };
	
	  return sensor;
	};

/***/ },
/* 528 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var sloppyClickThreshold = exports.sloppyClickThreshold = 5;
	
	exports.default = function (original, current) {
	  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
	};

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelector = undefined;
	
	var _reactRedux = __webpack_require__(8);
	
	var _memoizeOne = __webpack_require__(18);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _reselect = __webpack_require__(71);
	
	var _contextKeys = __webpack_require__(45);
	
	var _actionCreators = __webpack_require__(129);
	
	var _draggableDimensionPublisher = __webpack_require__(530);
	
	var _draggableDimensionPublisher2 = _interopRequireDefault(_draggableDimensionPublisher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestDimensionSelector = function requestDimensionSelector(state) {
	  return state.dimension.request;
	};
	
	var getOwnType = function getOwnType(state, props) {
	  return props.type;
	};
	
	var makeSelector = exports.makeSelector = function makeSelector() {
	  var getMapProps = (0, _memoizeOne2.default)(function (shouldPublish) {
	    return {
	      shouldPublish: shouldPublish
	    };
	  });
	
	  return (0, _reselect.createSelector)([getOwnType, requestDimensionSelector], function (ownType, requestId) {
	    return getMapProps(ownType === requestId);
	  });
	};
	
	var makeMapStateToProps = function makeMapStateToProps() {
	  var selector = makeSelector();
	  return function (state, props) {
	    return selector(state, props);
	  };
	};
	
	var mapDispatchToProps = {
	  publish: _actionCreators.publishDraggableDimension
	};
	
	exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps, null, { storeKey: _contextKeys.storeKey })(_draggableDimensionPublisher2.default);

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(23);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(24);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(25);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _getWindowScrollPosition = __webpack_require__(136);
	
	var _getWindowScrollPosition2 = _interopRequireDefault(_getWindowScrollPosition);
	
	var _dimension = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DraggableDimensionPublisher = function (_Component) {
	  (0, _inherits3.default)(DraggableDimensionPublisher, _Component);
	
	  function DraggableDimensionPublisher() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DraggableDimensionPublisher);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DraggableDimensionPublisher.__proto__ || (0, _getPrototypeOf2.default)(DraggableDimensionPublisher)).call.apply(_ref, [this].concat(args))), _this), _this.getDimension = function () {
	      var _this$props = _this.props,
	          draggableId = _this$props.draggableId,
	          droppableId = _this$props.droppableId,
	          targetRef = _this$props.targetRef;
	
	
	      (0, _invariant2.default)(targetRef, 'DraggableDimensionPublisher cannot calculate a dimension when not attached to the DOM');
	
	      var style = window.getComputedStyle(targetRef);
	
	      var margin = {
	        top: parseInt(style.marginTop, 10),
	        right: parseInt(style.marginRight, 10),
	        bottom: parseInt(style.marginBottom, 10),
	        left: parseInt(style.marginLeft, 10)
	      };
	
	      var clientRect = targetRef.getBoundingClientRect();
	
	      var dimension = (0, _dimension.getDraggableDimension)({
	        id: draggableId,
	        droppableId: droppableId,
	        clientRect: clientRect,
	        margin: margin,
	        windowScroll: (0, _getWindowScrollPosition2.default)()
	      });
	
	      return dimension;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DraggableDimensionPublisher, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var shouldPublish = !this.props.shouldPublish && nextProps.shouldPublish;
	
	      if (shouldPublish) {
	        this.props.publish(this.getDimension());
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return DraggableDimensionPublisher;
	}(_react.Component);
	
	exports.default = DraggableDimensionPublisher;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _connectedDraggableDimensionPublisher = __webpack_require__(529);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_connectedDraggableDimensionPublisher).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelector = undefined;
	
	var _extends2 = __webpack_require__(36);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _memoizeOne = __webpack_require__(18);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _reactRedux = __webpack_require__(8);
	
	var _reselect = __webpack_require__(71);
	
	var _selectors = __webpack_require__(218);
	
	var _draggable = __webpack_require__(533);
	
	var _draggable2 = _interopRequireDefault(_draggable);
	
	var _contextKeys = __webpack_require__(45);
	
	var _position = __webpack_require__(14);
	
	var _actionCreators = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origin = { x: 0, y: 0 };
	
	var defaultMapProps = {
	  isDropAnimating: false,
	  isDragging: false,
	  canLift: true,
	
	  canAnimate: false,
	  offset: origin,
	
	  dimension: null,
	  direction: null
	};
	
	var preLiftMapProps = (0, _extends3.default)({}, defaultMapProps, {
	  canLift: false
	});
	
	var makeSelector = exports.makeSelector = function makeSelector() {
	  var idSelector = function idSelector(state, ownProps) {
	    return ownProps.draggableId;
	  };
	  var typeSelector = function typeSelector(state, ownProps) {
	    return ownProps.type || 'DEFAULT';
	  };
	
	  var memoizedOffset = (0, _memoizeOne2.default)(function (x, y) {
	    return {
	      x: x, y: y
	    };
	  });
	
	  var getWithMovement = (0, _memoizeOne2.default)(function (offset, canLift) {
	    return {
	      isDropAnimating: false,
	      isDragging: false,
	      canAnimate: true,
	      canLift: canLift,
	      offset: offset,
	      dimension: null,
	      direction: null
	    };
	  });
	
	  var getNotDraggingProps = (0, _memoizeOne2.default)(function (draggableId, movement, canLift) {
	    var needsToMove = movement.draggables.indexOf(draggableId) !== -1;
	
	    if (!needsToMove) {
	      return getWithMovement(origin, canLift);
	    }
	
	    var amount = movement.isBeyondStartPosition ? (0, _position.negate)(movement.amount) : movement.amount;
	
	    return getWithMovement(memoizedOffset(amount.x, amount.y), canLift);
	  });
	
	  var draggableSelector = function draggableSelector(state, ownProps) {
	    if (!state.dimension) {
	      return null;
	    }
	    var dimension = state.dimension.draggable[ownProps.draggableId];
	
	    if (!dimension) {
	      return null;
	    }
	
	    return dimension;
	  };
	
	  return (0, _reselect.createSelector)([idSelector, typeSelector, _selectors.phaseSelector, _selectors.dragSelector, _selectors.pendingDropSelector, draggableSelector], function (id, type, phase, drag, pending, dimension) {
	    if (phase === 'DRAGGING') {
	      if (!drag) {
	        console.error('invalid dragging state');
	        return defaultMapProps;
	      }
	
	      var current = drag.current,
	          impact = drag.impact;
	
	
	      if (current.type !== type) {
	        return defaultMapProps;
	      }
	
	      if (current.id !== id) {
	        return getNotDraggingProps(id, impact.movement, false);
	      }
	
	      var offset = current.client.offset;
	      var canAnimate = current.shouldAnimate;
	
	      return {
	        isDragging: true,
	        canLift: false,
	        isDropAnimating: false,
	        canAnimate: canAnimate,
	        offset: offset,
	        dimension: dimension,
	        direction: impact.direction
	      };
	    }
	
	    if (phase === 'DROP_ANIMATING') {
	      if (!pending) {
	        console.error('cannot animate drop without a pending drop');
	        return defaultMapProps;
	      }
	
	      if (type !== pending.result.type) {
	        return defaultMapProps;
	      }
	
	      if (pending.result.draggableId !== id) {
	        var canLift = pending.trigger === 'DROP';
	
	        return getNotDraggingProps(id, pending.impact.movement, canLift);
	      }
	
	      return {
	        isDragging: false,
	        isDropAnimating: true,
	        canAnimate: true,
	        offset: pending.newHomeOffset,
	
	        canLift: false,
	
	        dimension: dimension,
	
	        direction: null
	      };
	    }
	
	    if (phase === 'PREPARING' || phase === 'COLLECTING_DIMENSIONS') {
	      return preLiftMapProps;
	    }
	
	    return defaultMapProps;
	  });
	};
	
	var makeMapStateToProps = function makeMapStateToProps() {
	  var selector = makeSelector();
	
	  return function (state, props) {
	    return selector(state, props);
	  };
	};
	
	var mapDispatchToProps = {
	  lift: _actionCreators.lift,
	  move: _actionCreators.move,
	  moveForward: _actionCreators.moveForward,
	  moveBackward: _actionCreators.moveBackward,
	  crossAxisMoveForward: _actionCreators.crossAxisMoveForward,
	  crossAxisMoveBackward: _actionCreators.crossAxisMoveBackward,
	  moveByWindowScroll: _actionCreators.moveByWindowScroll,
	  drop: _actionCreators.drop,
	  dropAnimationFinished: _actionCreators.dropAnimationFinished,
	  cancel: _actionCreators.cancel
	};
	
	exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps, null, { storeKey: _contextKeys.storeKey })(_draggable2.default);

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.zIndexOptions = undefined;
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(23);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(24);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(25);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _memoizeOne = __webpack_require__(18);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _draggableDimensionPublisher = __webpack_require__(531);
	
	var _draggableDimensionPublisher2 = _interopRequireDefault(_draggableDimensionPublisher);
	
	var _moveable = __webpack_require__(542);
	
	var _moveable2 = _interopRequireDefault(_moveable);
	
	var _dragHandle = __webpack_require__(524);
	
	var _dragHandle2 = _interopRequireDefault(_dragHandle);
	
	var _animation = __webpack_require__(219);
	
	var _getWindowScrollPosition = __webpack_require__(136);
	
	var _getWindowScrollPosition2 = _interopRequireDefault(_getWindowScrollPosition);
	
	var _getCenterPosition = __webpack_require__(221);
	
	var _getCenterPosition2 = _interopRequireDefault(_getCenterPosition);
	
	var _placeholder = __webpack_require__(222);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	var _contextKeys = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var zIndexOptions = exports.zIndexOptions = {
	  dragging: 5000,
	  dropAnimating: 4500
	};
	
	var Draggable = function (_Component) {
	  (0, _inherits3.default)(Draggable, _Component);
	
	  function Draggable(props, context) {
	    (0, _classCallCheck3.default)(this, Draggable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Draggable.__proto__ || (0, _getPrototypeOf2.default)(Draggable)).call(this, props, context));
	
	    _this.state = {
	      ref: null
	    };
	
	    _this.onMoveEnd = function () {
	      if (!_this.props.isDropAnimating) {
	        return;
	      }
	
	      _this.props.dropAnimationFinished();
	    };
	
	    _this.onLift = function (options) {
	      _this.throwIfCannotDrag();
	      var client = options.client,
	          isScrollAllowed = options.isScrollAllowed;
	      var _this$props = _this.props,
	          lift = _this$props.lift,
	          draggableId = _this$props.draggableId,
	          type = _this$props.type;
	      var ref = _this.state.ref;
	
	
	      if (!ref) {
	        throw new Error('cannot lift at this time');
	      }
	
	      var initial = {
	        selection: client,
	        center: (0, _getCenterPosition2.default)(ref)
	      };
	
	      var windowScroll = (0, _getWindowScrollPosition2.default)();
	
	      lift(draggableId, type, initial, windowScroll, isScrollAllowed);
	    };
	
	    _this.onMove = function (client) {
	      _this.throwIfCannotDrag();
	
	      var _this$props2 = _this.props,
	          draggableId = _this$props2.draggableId,
	          dimension = _this$props2.dimension,
	          move = _this$props2.move;
	
	      if (!dimension) {
	        return;
	      }
	
	      var windowScroll = (0, _getWindowScrollPosition2.default)();
	
	      move(draggableId, client, windowScroll);
	    };
	
	    _this.onMoveForward = function () {
	      _this.throwIfCannotDrag();
	      _this.props.moveForward(_this.props.draggableId);
	    };
	
	    _this.onMoveBackward = function () {
	      _this.throwIfCannotDrag();
	      _this.props.moveBackward(_this.props.draggableId);
	    };
	
	    _this.onCrossAxisMoveForward = function () {
	      _this.throwIfCannotDrag();
	      _this.props.crossAxisMoveForward(_this.props.draggableId);
	    };
	
	    _this.onCrossAxisMoveBackward = function () {
	      _this.throwIfCannotDrag();
	      _this.props.crossAxisMoveBackward(_this.props.draggableId);
	    };
	
	    _this.onWindowScroll = function () {
	      _this.throwIfCannotDrag();
	      var windowScroll = (0, _getWindowScrollPosition2.default)();
	      _this.props.moveByWindowScroll(_this.props.draggableId, windowScroll);
	    };
	
	    _this.onDrop = function () {
	      _this.throwIfCannotDrag();
	      _this.props.drop();
	    };
	
	    _this.onCancel = function () {
	      _this.props.cancel();
	    };
	
	    _this.setRef = function (ref) {
	      if (ref === null) {
	        return;
	      }
	
	      if (ref === _this.state.ref) {
	        return;
	      }
	
	      _this.setState({
	        ref: ref
	      });
	    };
	
	    _this.getDraggableRef = function () {
	      return _this.state.ref;
	    };
	
	    _this.getDraggingStyle = (0, _memoizeOne2.default)(function (dimension, isDropAnimating, movementStyle) {
	      var _dimension$client$wit = dimension.client.withoutMargin,
	          width = _dimension$client$wit.width,
	          height = _dimension$client$wit.height,
	          top = _dimension$client$wit.top,
	          left = _dimension$client$wit.left;
	
	      var style = {
	        position: 'fixed',
	        boxSizing: 'border-box',
	        pointerEvents: 'none',
	        zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
	        width: width,
	        height: height,
	        top: top,
	        left: left,
	        margin: 0,
	        transform: movementStyle.transform ? '' + movementStyle.transform : null,
	
	        WebkitTouchCallout: 'none',
	        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	        touchAction: 'manipulation'
	      };
	      return style;
	    });
	    _this.getNotDraggingStyle = (0, _memoizeOne2.default)(function (canAnimate, movementStyle, canLift) {
	      var style = {
	        transition: canAnimate ? _animation.css.outOfTheWay : null,
	        transform: movementStyle.transform,
	        pointerEvents: canLift ? 'auto' : 'none',
	
	        WebkitTouchCallout: 'none',
	        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	        touchAction: 'manipulation'
	      };
	      return style;
	    });
	    _this.getProvided = (0, _memoizeOne2.default)(function (isDragging, isDropAnimating, canLift, canAnimate, dimension, dragHandleProps, movementStyle) {
	      var useDraggingStyle = isDragging || isDropAnimating;
	
	      var draggableStyle = function () {
	        if (!useDraggingStyle) {
	          return _this.getNotDraggingStyle(canAnimate, movementStyle, canLift);
	        }
	
	        (0, _invariant2.default)(dimension, 'draggable dimension required for dragging');
	
	        return _this.getDraggingStyle(dimension, isDropAnimating, movementStyle);
	      }();
	
	      var provided = {
	        innerRef: _this.setRef,
	        placeholder: useDraggingStyle ? _this.getPlaceholder() : null,
	        dragHandleProps: dragHandleProps,
	        draggableStyle: draggableStyle
	      };
	      return provided;
	    });
	    _this.getSnapshot = (0, _memoizeOne2.default)(function (isDragging, isDropAnimating) {
	      return {
	        isDragging: isDragging || isDropAnimating
	      };
	    });
	    _this.getSpeed = (0, _memoizeOne2.default)(function (isDragging, isDropAnimating, canAnimate) {
	      if (!canAnimate) {
	        return 'INSTANT';
	      }
	
	      if (isDropAnimating) {
	        return 'STANDARD';
	      }
	
	      if (isDragging) {
	        return 'FAST';
	      }
	
	      return 'INSTANT';
	    });
	
	
	    var callbacks = {
	      onLift: _this.onLift,
	      onMove: _this.onMove,
	      onDrop: _this.onDrop,
	      onCancel: _this.onCancel,
	      onMoveBackward: _this.onMoveBackward,
	      onMoveForward: _this.onMoveForward,
	      onCrossAxisMoveForward: _this.onCrossAxisMoveForward,
	      onCrossAxisMoveBackward: _this.onCrossAxisMoveBackward,
	      onWindowScroll: _this.onWindowScroll
	    };
	
	    _this.callbacks = callbacks;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Draggable, [{
	    key: 'throwIfCannotDrag',
	    value: function throwIfCannotDrag() {
	      (0, _invariant2.default)(this.state.ref, 'Draggable: cannot drag as no DOM node has been provided');
	      (0, _invariant2.default)(!this.props.isDragDisabled, 'Draggable: cannot drag as dragging is not enabled');
	    }
	  }, {
	    key: 'getPlaceholder',
	    value: function getPlaceholder() {
	      var dimension = this.props.dimension;
	      (0, _invariant2.default)(dimension, 'cannot get a drag placeholder when not dragging');
	
	      return _react2.default.createElement(_placeholder2.default, { placeholder: dimension.placeholder });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          draggableId = _props.draggableId,
	          type = _props.type,
	          offset = _props.offset,
	          isDragging = _props.isDragging,
	          isDropAnimating = _props.isDropAnimating,
	          canLift = _props.canLift,
	          canAnimate = _props.canAnimate,
	          isDragDisabled = _props.isDragDisabled,
	          dimension = _props.dimension,
	          children = _props.children,
	          direction = _props.direction,
	          disableInteractiveElementBlocking = _props.disableInteractiveElementBlocking;
	
	
	      var speed = this.getSpeed(isDragging, isDropAnimating, canAnimate);
	
	      return _react2.default.createElement(
	        _draggableDimensionPublisher2.default,
	        {
	          draggableId: draggableId,
	          droppableId: this.context[_contextKeys.droppableIdKey],
	          type: type,
	          targetRef: this.state.ref
	        },
	        _react2.default.createElement(
	          _moveable2.default,
	          {
	            speed: speed,
	            destination: offset,
	            onMoveEnd: this.onMoveEnd
	          },
	          function (movementStyle) {
	            return _react2.default.createElement(
	              _dragHandle2.default,
	              {
	                isDragging: isDragging,
	                direction: direction,
	                isEnabled: !isDragDisabled,
	                canLift: canLift,
	                callbacks: _this2.callbacks,
	                getDraggableRef: _this2.getDraggableRef,
	
	                canDragInteractiveElements: disableInteractiveElementBlocking
	              },
	              function (dragHandleProps) {
	                return children(_this2.getProvided(isDragging, isDropAnimating, canLift, canAnimate, dimension, dragHandleProps, movementStyle), _this2.getSnapshot(isDragging, isDropAnimating));
	              }
	            );
	          }
	        )
	      );
	    }
	  }]);
	  return Draggable;
	}(_react.Component);
	
	Draggable.defaultProps = {
	  isDragDisabled: false,
	  type: 'DEFAULT',
	
	  disableInteractiveElementBlocking: false
	};
	Draggable.contextTypes = (0, _defineProperty3.default)({}, _contextKeys.droppableIdKey, _propTypes2.default.string.isRequired);
	exports.default = Draggable;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _connectedDraggable = __webpack_require__(532);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_connectedDraggable).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelector = undefined;
	
	var _reactRedux = __webpack_require__(8);
	
	var _reselect = __webpack_require__(71);
	
	var _memoizeOne = __webpack_require__(18);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _contextKeys = __webpack_require__(45);
	
	var _droppableDimensionPublisher = __webpack_require__(536);
	
	var _droppableDimensionPublisher2 = _interopRequireDefault(_droppableDimensionPublisher);
	
	var _actionCreators = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestDimensionSelector = function requestDimensionSelector(state) {
	  return state.dimension.request;
	};
	
	var getOwnType = function getOwnType(state, props) {
	  return props.type;
	};
	
	var makeSelector = exports.makeSelector = function makeSelector() {
	  var getMapProps = (0, _memoizeOne2.default)(function (shouldPublish) {
	    return {
	      shouldPublish: shouldPublish
	    };
	  });
	
	  return (0, _reselect.createSelector)([getOwnType, requestDimensionSelector], function (ownType, requested) {
	    return getMapProps(ownType === requested);
	  });
	};
	
	var makeMapStateToProps = function makeMapStateToProps() {
	  var selector = makeSelector();
	  return function (state, props) {
	    return selector(state, props);
	  };
	};
	
	var mapDispatchToProps = {
	  publish: _actionCreators.publishDroppableDimension,
	  updateScroll: _actionCreators.updateDroppableDimensionScroll,
	  updateIsEnabled: _actionCreators.updateDroppableDimensionIsEnabled
	};
	
	exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps, null, { storeKey: _contextKeys.storeKey })(_droppableDimensionPublisher2.default);

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(23);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(24);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(25);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _rafSchd = __webpack_require__(216);
	
	var _rafSchd2 = _interopRequireDefault(_rafSchd);
	
	var _memoizeOne = __webpack_require__(18);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _getWindowScrollPosition = __webpack_require__(136);
	
	var _getWindowScrollPosition2 = _interopRequireDefault(_getWindowScrollPosition);
	
	var _getClientRect = __webpack_require__(131);
	
	var _getClientRect2 = _interopRequireDefault(_getClientRect);
	
	var _dimension = __webpack_require__(130);
	
	var _getClosestScrollable = __webpack_require__(541);
	
	var _getClosestScrollable2 = _interopRequireDefault(_getClosestScrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origin = { x: 0, y: 0 };
	
	var DroppableDimensionPublisher = function (_Component) {
	  (0, _inherits3.default)(DroppableDimensionPublisher, _Component);
	
	  function DroppableDimensionPublisher() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DroppableDimensionPublisher);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DroppableDimensionPublisher.__proto__ || (0, _getPrototypeOf2.default)(DroppableDimensionPublisher)).call.apply(_ref, [this].concat(args))), _this), _this.isWatchingScroll = false, _this.closestScrollable = null, _this.getScrollOffset = function () {
	      if (!_this.closestScrollable) {
	        return origin;
	      }
	
	      var offset = {
	        x: _this.closestScrollable.scrollLeft,
	        y: _this.closestScrollable.scrollTop
	      };
	
	      return offset;
	    }, _this.getDimension = function () {
	      var _this$props = _this.props,
	          droppableId = _this$props.droppableId,
	          direction = _this$props.direction,
	          ignoreContainerClipping = _this$props.ignoreContainerClipping,
	          isDropDisabled = _this$props.isDropDisabled,
	          targetRef = _this$props.targetRef;
	
	      if (!targetRef) {
	        throw new Error('DimensionPublisher cannot calculate a dimension when not attached to the DOM');
	      }
	
	      var scroll = _this.getScrollOffset();
	      var style = window.getComputedStyle(targetRef);
	
	      var margin = {
	        top: parseInt(style.marginTop, 10),
	        right: parseInt(style.marginRight, 10),
	        bottom: parseInt(style.marginBottom, 10),
	        left: parseInt(style.marginLeft, 10)
	      };
	      var padding = {
	        top: parseInt(style.paddingTop, 10),
	        right: parseInt(style.paddingRight, 10),
	        bottom: parseInt(style.paddingBottom, 10),
	        left: parseInt(style.paddingLeft, 10)
	      };
	
	      var clientRect = targetRef.getBoundingClientRect();
	
	      var containerRect = ignoreContainerClipping || !_this.closestScrollable || _this.closestScrollable === targetRef ? clientRect : (0, _getClientRect2.default)(_this.closestScrollable.getBoundingClientRect());
	
	      var dimension = (0, _dimension.getDroppableDimension)({
	        id: droppableId,
	        direction: direction,
	        clientRect: clientRect,
	        containerRect: containerRect,
	        margin: margin,
	        padding: padding,
	        windowScroll: (0, _getWindowScrollPosition2.default)(),
	        scroll: scroll,
	        isEnabled: !isDropDisabled
	      });
	
	      return dimension;
	    }, _this.memoizedUpdateScroll = (0, _memoizeOne2.default)(function (x, y) {
	      var offset = { x: x, y: y };
	      _this.props.updateScroll(_this.props.droppableId, offset);
	    }), _this.scheduleScrollUpdate = (0, _rafSchd2.default)(function (offset) {
	      if (_this.isWatchingScroll) {
	        _this.memoizedUpdateScroll(offset.x, offset.y);
	      }
	    }), _this.onClosestScroll = function () {
	      _this.scheduleScrollUpdate(_this.getScrollOffset());
	    }, _this.watchScroll = function () {
	      (0, _invariant2.default)(_this.props.targetRef, 'cannot watch scroll if not in the dom');
	
	      if (_this.closestScrollable == null) {
	        return;
	      }
	
	      if (_this.isWatchingScroll) {
	        return;
	      }
	
	      _this.isWatchingScroll = true;
	      _this.closestScrollable.addEventListener('scroll', _this.onClosestScroll, { passive: true });
	    }, _this.unwatchScroll = function () {
	      if (!_this.isWatchingScroll) {
	        return;
	      }
	
	      _this.isWatchingScroll = false;
	
	      if (!_this.closestScrollable) {
	        console.error('cannot unbind event listener if element is null');
	        return;
	      }
	
	      _this.closestScrollable.removeEventListener('scroll', _this.onClosestScroll);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DroppableDimensionPublisher, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.isWatchingScroll) {
	        this.unwatchScroll();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	
	      var shouldStartPublishing = !this.props.shouldPublish && nextProps.shouldPublish;
	      var alreadyPublishing = this.props.shouldPublish && nextProps.shouldPublish;
	      var stopPublishing = this.props.shouldPublish && !nextProps.shouldPublish;
	
	      if (stopPublishing) {
	        this.unwatchScroll();
	        return;
	      }
	
	      if (alreadyPublishing) {
	        if (nextProps.targetRef !== this.props.targetRef) {
	          if (this.isWatchingScroll) {
	            console.warn('changing targetRef while watching scroll!');
	            this.unwatchScroll();
	          }
	        }
	
	        if (nextProps.isDropDisabled !== this.props.isDropDisabled) {
	          this.props.updateIsEnabled(this.props.droppableId, !nextProps.isDropDisabled);
	        }
	
	        return;
	      }
	
	      if (!shouldStartPublishing) {
	        return;
	      }
	
	      this.closestScrollable = (0, _getClosestScrollable2.default)(this.props.targetRef);
	      this.props.publish(this.getDimension());
	      this.watchScroll();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return DroppableDimensionPublisher;
	}(_react.Component);
	
	exports.default = DroppableDimensionPublisher;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _connectedDroppableDimensionPublisher = __webpack_require__(535);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_connectedDroppableDimensionPublisher).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelector = undefined;
	
	var _reactRedux = __webpack_require__(8);
	
	var _reselect = __webpack_require__(71);
	
	var _memoizeOne = __webpack_require__(18);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _contextKeys = __webpack_require__(45);
	
	var _selectors = __webpack_require__(218);
	
	var _droppable = __webpack_require__(539);
	
	var _droppable2 = _interopRequireDefault(_droppable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeSelector = exports.makeSelector = function makeSelector() {
	  var idSelector = function idSelector(state, ownProps) {
	    return ownProps.droppableId;
	  };
	  var isDropDisabledSelector = function isDropDisabledSelector(state, ownProps) {
	    return ownProps.isDropDisabled || false;
	  };
	
	  var getIsDraggingOver = (0, _memoizeOne2.default)(function (id, destination) {
	    if (!destination) {
	      return false;
	    }
	    return destination.droppableId === id;
	  });
	
	  var getPlaceholder = (0, _memoizeOne2.default)(function (id, source, destination, draggable) {
	    if (!destination) {
	      return null;
	    }
	
	    if (destination.droppableId !== id) {
	      return null;
	    }
	
	    if (source.droppableId === destination.droppableId) {
	      return null;
	    }
	
	    if (!draggable) {
	      return null;
	    }
	
	    return draggable.placeholder;
	  });
	
	  var getMapProps = (0, _memoizeOne2.default)(function (isDraggingOver, placeholder) {
	    return {
	      isDraggingOver: isDraggingOver,
	      placeholder: placeholder
	    };
	  });
	
	  return (0, _reselect.createSelector)([_selectors.phaseSelector, _selectors.dragSelector, _selectors.draggingDraggableSelector, _selectors.pendingDropSelector, idSelector, isDropDisabledSelector], function (phase, drag, draggable, pending, id, isDropDisabled) {
	    if (isDropDisabled) {
	      return getMapProps(false, null);
	    }
	
	    if (phase === 'DRAGGING') {
	      if (!drag) {
	        console.error('cannot determine dragging over as there is not drag');
	        return getMapProps(false, null);
	      }
	
	      var isDraggingOver = getIsDraggingOver(id, drag.impact.destination);
	
	      var placeholder = getPlaceholder(id, drag.initial.source, drag.impact.destination, draggable);
	      return getMapProps(isDraggingOver, placeholder);
	    }
	
	    if (phase === 'DROP_ANIMATING') {
	      if (!pending) {
	        console.error('cannot determine dragging over as there is no pending result');
	        return getMapProps(false, null);
	      }
	
	      var _isDraggingOver = getIsDraggingOver(id, pending.impact.destination);
	      var _placeholder = getPlaceholder(id, pending.result.source, pending.result.destination, draggable);
	      return getMapProps(_isDraggingOver, _placeholder);
	    }
	
	    return getMapProps(false, null);
	  });
	};
	
	var makeMapStateToProps = function makeMapStateToProps() {
	  var selector = makeSelector();
	  return function (state, props) {
	    return selector(state, props);
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(makeMapStateToProps, null, null, { storeKey: _contextKeys.storeKey })(_droppable2.default);

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(23);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(24);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(25);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _droppableDimensionPublisher = __webpack_require__(537);
	
	var _droppableDimensionPublisher2 = _interopRequireDefault(_droppableDimensionPublisher);
	
	var _placeholder = __webpack_require__(222);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	var _contextKeys = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Droppable = function (_Component) {
	  (0, _inherits3.default)(Droppable, _Component);
	
	  function Droppable() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Droppable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Droppable.__proto__ || (0, _getPrototypeOf2.default)(Droppable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      ref: null
	    }, _this.setRef = function (ref) {
	      if (ref === null) {
	        return;
	      }
	
	      if (ref === _this.state.ref) {
	        return;
	      }
	
	      _this.setState({
	        ref: ref
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Droppable, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var value = (0, _defineProperty3.default)({}, _contextKeys.droppableIdKey, this.props.droppableId);
	      return value;
	    }
	  }, {
	    key: 'getPlaceholder',
	    value: function getPlaceholder() {
	      if (!this.props.placeholder) {
	        return null;
	      }
	
	      return _react2.default.createElement(_placeholder2.default, { placeholder: this.props.placeholder });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          direction = _props.direction,
	          droppableId = _props.droppableId,
	          ignoreContainerClipping = _props.ignoreContainerClipping,
	          isDraggingOver = _props.isDraggingOver,
	          isDropDisabled = _props.isDropDisabled,
	          type = _props.type;
	
	      var provided = {
	        innerRef: this.setRef,
	        placeholder: this.getPlaceholder()
	      };
	      var snapshot = {
	        isDraggingOver: isDraggingOver
	      };
	
	      return _react2.default.createElement(
	        _droppableDimensionPublisher2.default,
	        {
	          droppableId: droppableId,
	          direction: direction,
	          ignoreContainerClipping: ignoreContainerClipping,
	          isDropDisabled: isDropDisabled,
	          type: type,
	          targetRef: this.state.ref
	        },
	        children(provided, snapshot)
	      );
	    }
	  }]);
	  return Droppable;
	}(_react.Component);
	
	Droppable.defaultProps = {
	  type: 'DEFAULT',
	  isDropDisabled: false,
	  direction: 'vertical',
	  ignoreContainerClipping: false
	};
	Droppable.childContextTypes = (0, _defineProperty3.default)({}, _contextKeys.droppableIdKey, _propTypes2.default.string.isRequired);
	exports.default = Droppable;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _connectedDroppable = __webpack_require__(538);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_connectedDroppable).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 541 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var isScrollable = function isScrollable() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return values.some(function (value) {
	    return value === 'auto' || value === 'scroll';
	  });
	};
	
	var isElementScrollable = function isElementScrollable(el) {
	  var style = window.getComputedStyle(el);
	  return isScrollable(style.overflow, style.overflowY, style.overflowX);
	};
	
	var getClosestScrollable = function getClosestScrollable(el) {
	  if (el == null) {
	    return null;
	  }
	
	  if (!isElementScrollable(el)) {
	    return getClosestScrollable(el.parentElement);
	  }
	
	  return el;
	};
	
	exports.default = getClosestScrollable;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moveable = __webpack_require__(543);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_moveable).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(23);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(24);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(25);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(555);
	
	var _animation = __webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origin = {
	  x: 0,
	  y: 0
	};
	
	var noMovement = {
	  transform: null
	};
	
	var isAtOrigin = function isAtOrigin(point) {
	  return point.x === origin.x && point.y === origin.y;
	};
	
	var getStyle = function getStyle(isNotMoving, x, y) {
	  if (isNotMoving) {
	    return noMovement;
	  }
	
	  var point = { x: x, y: y };
	
	  if (isAtOrigin(point)) {
	    return noMovement;
	  }
	  var style = {
	    transform: 'translate(' + point.x + 'px, ' + point.y + 'px)'
	  };
	  return style;
	};
	
	var Movable = function (_Component) {
	  (0, _inherits3.default)(Movable, _Component);
	
	  function Movable() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Movable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Movable.__proto__ || (0, _getPrototypeOf2.default)(Movable)).call.apply(_ref, [this].concat(args))), _this), _this.onRest = function () {
	      var onMoveEnd = _this.props.onMoveEnd;
	
	
	      if (!onMoveEnd) {
	        return;
	      }
	
	      setTimeout(function () {
	        return onMoveEnd();
	      });
	    }, _this.getFinal = function () {
	      var destination = _this.props.destination;
	      var speed = _this.props.speed;
	
	      if (speed === 'INSTANT') {
	        return destination;
	      }
	
	      var selected = speed === 'FAST' ? _animation.physics.fast : _animation.physics.standard;
	
	      return {
	        x: (0, _reactMotion.spring)(destination.x, selected),
	        y: (0, _reactMotion.spring)(destination.y, selected)
	      };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Movable, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var final = this.getFinal();
	
	      var isNotMoving = isAtOrigin(final);
	
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        { defaultStyle: origin, style: final, onRest: this.onRest },
	        function (current) {
	          return _this2.props.children(getStyle(isNotMoving, current.x, current.y));
	        }
	      );
	    }
	  }]);
	  return Movable;
	}(_react.Component);
	
	Movable.defaultProps = {
	  destination: origin
	};
	exports.default = Movable;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(23);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(24);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(25);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Placeholder = function (_PureComponent) {
	  (0, _inherits3.default)(Placeholder, _PureComponent);
	
	  function Placeholder() {
	    (0, _classCallCheck3.default)(this, Placeholder);
	    return (0, _possibleConstructorReturn3.default)(this, (Placeholder.__proto__ || (0, _getPrototypeOf2.default)(Placeholder)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Placeholder, [{
	    key: 'render',
	    value: function render() {
	
	      var placeholder = this.props.placeholder;
	      var _placeholder$margin = placeholder.margin,
	          top = _placeholder$margin.top,
	          left = _placeholder$margin.left,
	          bottom = _placeholder$margin.bottom,
	          right = _placeholder$margin.right;
	      var _placeholder$withoutM = placeholder.withoutMargin,
	          width = _placeholder$withoutM.width,
	          height = _placeholder$withoutM.height;
	
	
	      var style = {
	        width: width,
	        height: height,
	        marginTop: top,
	        marginLeft: left,
	        marginBottom: bottom,
	        marginRight: right,
	        pointerEvents: 'none',
	        boxSizing: 'border-box'
	      };
	      return _react2.default.createElement('div', { style: style });
	    }
	  }]);
	  return Placeholder;
	}(_react.PureComponent);
	
	exports.default = Placeholder;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.3.1
	 * react-dom.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var ba=__webpack_require__(1),m=__webpack_require__(411),A=__webpack_require__(125),C=__webpack_require__(413),ea=__webpack_require__(415),fa=__webpack_require__(418),ha=__webpack_require__(412),ja=__webpack_require__(414);
	function D(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}ba?void 0:D("227");
	function ka(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
	var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ka.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return ma.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
	E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function ma(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var na=null,oa={};
	function pa(){if(na)for(var a in oa){var b=oa[a],c=na.indexOf(a);-1<c?void 0:D("96",a);if(!qa[c]){b.extractEvents?void 0:D("97",a);qa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;ra.hasOwnProperty(g)?D("99",g):void 0;ra[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&sa(k[e],h,g);e=!0}else f.registrationName?(sa(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
	function sa(a,b,c){ta[a]?D("100",a):void 0;ta[a]=b;ua[a]=b.eventTypes[c].dependencies}var qa=[],ra={},ta={},ua={};function va(a){na?D("101"):void 0;na=Array.prototype.slice.call(a);pa()}function wa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];oa.hasOwnProperty(c)&&oa[c]===d||(oa[c]?D("102",c):void 0,oa[c]=d,b=!0)}b&&pa()}
	var xa=Object.freeze({plugins:qa,eventNameDispatchConfigs:ra,registrationNameModules:ta,registrationNameDependencies:ua,possibleRegistrationNames:null,injectEventPluginOrder:va,injectEventPluginsByName:wa}),Ca=null,Da=null,Ea=null;function Fa(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ea(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
	function Ga(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ha(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ia=null;
	function Ja(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Fa(a,b,c[e],d[e]);else c&&Fa(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ka(a){return Ja(a,!0)}function La(a){return Ja(a,!1)}var Ma={injectEventPluginOrder:va,injectEventPluginsByName:wa};
	function Na(a,b){var c=a.stateNode;if(!c)return null;var d=Ca(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
	return c}function Oa(a,b){null!==a&&(Ia=Ga(Ia,a));a=Ia;Ia=null;a&&(b?Ha(a,Ka):Ha(a,La),Ia?D("95"):void 0,E.rethrowCaughtError())}function Pa(a,b,c,d){for(var e=null,f=0;f<qa.length;f++){var h=qa[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ga(e,h))}Oa(e,!1)}var Qa=Object.freeze({injection:Ma,getListener:Na,runEventsInBatch:Oa,runExtractedEventsInBatch:Pa}),Ra=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Ra,Sa="__reactEventHandlers$"+Ra;
	function Ta(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Ua(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Va(a){return a[Sa]||null}var Xa=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ta,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Ua,getFiberCurrentPropsFromNode:Va,updateFiberProps:function(a,b){a[Sa]=b}});
	function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function bb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function cb(a,b,c){if(b=Na(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ga(c._dispatchListeners,b),c._dispatchInstances=Ga(c._dispatchInstances,a)}function db(a){a&&a.dispatchConfig.phasedRegistrationNames&&bb(a._targetInst,cb,a)}
	function eb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;bb(b,cb,a)}}function fb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Na(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ga(c._dispatchListeners,b),c._dispatchInstances=Ga(c._dispatchInstances,a))}function gb(a){a&&a.dispatchConfig.registrationName&&fb(a._targetInst,null,a)}function hb(a){Ha(a,db)}
	function ib(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)fb(e[d],"bubbled",a);for(a=c.length;0<a--;)fb(c[a],"captured",b)}
	var jb=Object.freeze({accumulateTwoPhaseDispatches:hb,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ha(a,eb)},accumulateEnterLeaveDispatches:ib,accumulateDirectDispatches:function(a){Ha(a,gb)}}),kb=null;function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var M={_root:null,_startText:null,_fallbackText:null};
	function mb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function nb(){return"value"in M._root?M._root.value:M._root[lb()]}
	var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
	A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
	destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});N.Interface=pb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(N);
	function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=N.extend({data:null}),ub=N.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
	var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Kb=!1;
	function Lb(a,b){switch(a){case "topKeyUp":return-1!==vb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Mb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Nb=!1;function Ob(a,b){switch(a){case "topCompositionEnd":return Mb(b);case "topKeyPress":if(32!==b.which)return null;Kb=!0;return Ab;case "topTextInput":return a=b.data,a===Ab&&Kb?null:a;default:return null}}
	function Pb(a,b){if(Nb)return"topCompositionEnd"===a||!wb&&Lb(a,b)?(a=mb(),M._root=null,M._startText=null,M._fallbackText=null,Nb=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return zb?null:b.data;default:return null}}
	var Qb={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "topCompositionStart":e=Bb.compositionStart;break b;case "topCompositionEnd":e=Bb.compositionEnd;break b;case "topCompositionUpdate":e=Bb.compositionUpdate;break b}e=void 0}else Nb?Lb(a,c)&&(e=Bb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Nb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Nb&&(f=mb()):(M._root=d,M._startText=nb(),Nb=!0)),e=tb.getPooled(e,
	b,c,d),f?e.data=f:(f=Mb(c),null!==f&&(e.data=f)),hb(e),f=e):f=null;(a=yb?Ob(a,c):Pb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,hb(b)):b=null;return null===f?b:null===b?f:[f,b]}},Rb=null,Sb=null,Tb=null;function Ub(a){if(a=Da(a)){Rb&&"function"===typeof Rb.restoreControlledState?void 0:D("194");var b=Ca(a.stateNode);Rb.restoreControlledState(a.stateNode,a.type,b)}}var Vb={injectFiberControlledHostComponent:function(a){Rb=a}};function Wb(a){Sb?Tb?Tb.push(a):Tb=[a]:Sb=a}
	function Xb(){return null!==Sb||null!==Tb}function Yb(){if(Sb){var a=Sb,b=Tb;Tb=Sb=null;Ub(a);if(b)for(a=0;a<b.length;a++)Ub(b[a])}}var Zb=Object.freeze({injection:Vb,enqueueStateRestore:Wb,needsStateRestore:Xb,restoreStateIfNeeded:Yb});function $b(a,b){return a(b)}function ac(a,b,c){return a(b,c)}function bc(){}var cc=!1;function dc(a,b){if(cc)return a(b);cc=!0;try{return $b(a,b)}finally{cc=!1,Xb()&&(bc(),Yb())}}
	var ec={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function fc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!ec[a.type]:"textarea"===b?!0:!1}function gc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
	function hc(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ic(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function jc(a){var b=ic(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
	function kc(a){a._valueTracker||(a._valueTracker=jc(a))}function lc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ic(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
	var mc=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],nc=O?Symbol["for"]("react.element"):60103,oc=O?Symbol["for"]("react.call"):60104,pc=O?Symbol["for"]("react.return"):60105,qc=O?Symbol["for"]("react.portal"):60106,rc=O?Symbol["for"]("react.fragment"):60107,sc=O?Symbol["for"]("react.strict_mode"):60108,tc=O?Symbol["for"]("react.provider"):60109,uc=O?Symbol["for"]("react.context"):60110,vc=O?Symbol["for"]("react.async_mode"):60111,
	wc=O?Symbol["for"]("react.forward_ref"):60112,xc="function"===typeof Symbol&&Symbol.iterator;function yc(a){if(null===a||"undefined"===typeof a)return null;a=xc&&a[xc]||a["@@iterator"];return"function"===typeof a?a:null}function zc(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case rc:return"ReactFragment";case qc:return"ReactPortal";case oc:return"ReactCall";case pc:return"ReactReturn"}return null}
	function Ac(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=zc(a);var f=null;c&&(f=zc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
	var Bc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Cc={},Dc={};function Ec(a){if(Dc.hasOwnProperty(a))return!0;if(Cc.hasOwnProperty(a))return!1;if(Bc.test(a))return Dc[a]=!0;Cc[a]=!0;return!1}
	function Fc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Gc(a,b,c,d){if(null===b||"undefined"===typeof b||Fc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
	function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
	[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
	"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
	["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Hc=/[\-\:]([a-z])/g;function Sc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Hc,
	Sc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Hc,Sc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Hc,Sc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
	function Tc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Gc(b,c,e,d)&&(c=null),d||null===e?Ec(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function Uc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Vc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Wc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Xc(a,b){b=b.checked;null!=b&&Tc(a,"checked",b,!1)}
	function Yc(a,b){Xc(a,b);var c=Wc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Zc(a,b.type,Wc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function $c(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
	function Wc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var ad={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function bd(a,b,c){a=N.getPooled(ad.change,a,b,c);a.type="change";Wb(c);hb(a);return a}var cd=null,dd=null;function ed(a){Oa(a,!1)}
	function fd(a){var b=Ua(a);if(lc(b))return a}function gd(a,b){if("topChange"===a)return b}var hd=!1;m.canUseDOM&&(hd=hc("input")&&(!document.documentMode||9<document.documentMode));function id(){cd&&(cd.detachEvent("onpropertychange",jd),dd=cd=null)}function jd(a){"value"===a.propertyName&&fd(dd)&&(a=bd(dd,a,gc(a)),dc(ed,a))}function kd(a,b,c){"topFocus"===a?(id(),cd=b,dd=c,cd.attachEvent("onpropertychange",jd)):"topBlur"===a&&id()}
	function ld(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return fd(dd)}function md(a,b){if("topClick"===a)return fd(b)}function nd(a,b){if("topInput"===a||"topChange"===a)return fd(b)}
	var od={eventTypes:ad,_isInputEventSupported:hd,extractEvents:function(a,b,c,d){var e=b?Ua(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=gd:fc(e)?hd?f=nd:(f=ld,h=kd):(g=e.nodeName,!g||"input"!==g.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(f=md));if(f&&(f=f(a,b)))return bd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&Zc(e,"number",e.value)}},pd=N.extend({view:null,
	detail:null}),qd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function rd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=qd[a])?!!b[a]:!1}function sd(){return rd}
	var td=pd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:sd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),ud={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},vd={eventTypes:ud,extractEvents:function(a,
	b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ta(b):null):a=null;if(a===b)return null;var f=null==a?e:Ua(a);e=null==b?e:Ua(b);var h=td.getPooled(ud.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=td.getPooled(ud.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
	f;ib(h,c,a,b);return[h,c]}};function wd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function xd(a){return(a=a._reactInternalFiber)?2===wd(a):!1}function yd(a){2!==wd(a)?D("188"):void 0}
	function zd(a){var b=a.alternate;if(!b)return b=wd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return yd(e),a;if(h===d)return yd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
	void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Ad(a){a=zd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
	function Bd(a){a=zd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Cd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Dd=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Ed=pd.extend({relatedTarget:null});
	function Fd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var Gd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Hd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Id=pd.extend({key:function(a){if(a.key){var b=Gd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Fd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Hd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:sd,charCode:function(a){return"keypress"===
	a.type?Fd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Fd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Jd=td.extend({dataTransfer:null}),Kd=pd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:sd}),Ld=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Md=td.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Nd={},Od={};function Pd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Nd[a]=b;Od[c]=b}
	"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Pd(a,!0)});
	"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Pd(a,!1)});
	var Qd={eventTypes:Nd,isInteractiveTopLevelEventType:function(a){a=Od[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Od[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Fd(c))return null;case "topKeyDown":case "topKeyUp":a=Id;break;case "topBlur":case "topFocus":a=Ed;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
	td;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Jd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Kd;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Cd;break;case "topTransitionEnd":a=Ld;break;case "topScroll":a=pd;break;case "topWheel":a=Md;break;case "topCopy":case "topCut":case "topPaste":a=Dd;break;default:a=
	N}b=a.getPooled(e,b,c,d);hb(b);return b}},Rd=Qd.isInteractiveTopLevelEventType,Sd=[];function Td(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ta(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Pa(a.topLevelType,b,a.nativeEvent,gc(a.nativeEvent))}var Ud=!0;function Vd(a){Ud=!!a}
	function W(a,b,c){if(!c)return null;a=(Rd(a)?Wd:Xd).bind(null,a);c.addEventListener(b,a,!1)}function Yd(a,b,c){if(!c)return null;a=(Rd(a)?Wd:Xd).bind(null,a);c.addEventListener(b,a,!0)}function Wd(a,b){ac(Xd,a,b)}
	function Xd(a,b){if(Ud){var c=gc(b);c=Ta(c);null!==c&&"number"===typeof c.tag&&2!==wd(c)&&(c=null);if(Sd.length){var d=Sd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{dc(Td,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Sd.length&&Sd.push(a)}}}
	var Zd=Object.freeze({get _enabled(){return Ud},setEnabled:Vd,isEnabled:function(){return Ud},trapBubbledEvent:W,trapCapturedEvent:Yd,dispatchEvent:Xd});function $d(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
	var ae={animationend:$d("Animation","AnimationEnd"),animationiteration:$d("Animation","AnimationIteration"),animationstart:$d("Animation","AnimationStart"),transitionend:$d("Transition","TransitionEnd")},be={},ce={};m.canUseDOM&&(ce=document.createElement("div").style,"AnimationEvent"in window||(delete ae.animationend.animation,delete ae.animationiteration.animation,delete ae.animationstart.animation),"TransitionEvent"in window||delete ae.transitionend.transition);
	function de(a){if(be[a])return be[a];if(!ae[a])return a;var b=ae[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in ce)return be[a]=b[c];return a}
	var ee={topAnimationEnd:de("animationend"),topAnimationIteration:de("animationiteration"),topAnimationStart:de("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
	topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
	topTouchStart:"touchstart",topTransitionEnd:de("transitionend"),topWheel:"wheel"},fe={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
	topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},ge={},he=0,ie="_reactListenersID"+(""+Math.random()).slice(2);function je(a){Object.prototype.hasOwnProperty.call(a,ie)||(a[ie]=he++,ge[a[ie]]={});return ge[a[ie]]}function ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function le(a,b){var c=ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ke(c)}}function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
	var ne=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,oe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},pe=null,qe=null,re=null,se=!1;
	function ue(a,b){if(se||null==pe||pe!==ea())return null;var c=pe;"selectionStart"in c&&me(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return re&&fa(re,c)?null:(re=c,a=N.getPooled(oe.select,qe,a,b),a.type="select",a.target=pe,hb(a),a)}
	var we={eventTypes:oe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=je(e);f=ua.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ua(b):window;switch(a){case "topFocus":if(fc(e)||"true"===e.contentEditable)pe=e,qe=b,re=null;break;case "topBlur":re=qe=pe=null;break;case "topMouseDown":se=!0;break;case "topContextMenu":case "topMouseUp":return se=!1,ue(c,d);case "topSelectionChange":if(ne)break;
	case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Ma.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Ca=Xa.getFiberCurrentPropsFromNode;Da=Xa.getInstanceFromNode;Ea=Xa.getNodeFromInstance;Ma.injectEventPluginsByName({SimpleEventPlugin:Qd,EnterLeaveEventPlugin:vd,ChangeEventPlugin:od,SelectEventPlugin:we,BeforeInputEventPlugin:Qb});
	function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
	function ye(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
	function ze(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case rc:return Ae(a.children,b,c,e);case vc:f=11;b|=3;break;case sc:f=11;b|=2;break;case oc:f=7;break;case pc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case tc:f=13;break;case uc:f=12;break;case wc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
	b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Ae(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Be(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function Ce(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var De=null,Ee=null;
	function Fe(a){return function(b){try{return a(b)}catch(c){}}}function Ge(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);De=Fe(function(a){return b.onCommitFiberRoot(c,a)});Ee=Fe(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function He(a){"function"===typeof De&&De(a)}function Ie(a){"function"===typeof Ee&&Ee(a)}new Set;
	function Je(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Ke(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Le=void 0,Me=void 0;
	function Ne(a){Le=Me=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Je(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Je(null))):a=null;Le=c;Me=a!==c?a:null}function Oe(a,b){Ne(a);a=Le;var c=Me;null===c?Ke(a,b):null===a.last||null===c.last?(Ke(a,b),Ke(c,b)):(Ke(a,b),c.last=b)}function Pe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
	function Qe(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
	(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Pe(g,d,a,e),h=!0;else if(v=Pe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
	return a}function Re(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
	function Se(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!fa(b,c)||!fa(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
	b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,z=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:xd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Oe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
	capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Oe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Oe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
	constructClassInstance:function(a,b){var c=a.type,d=p(a),e=z(a),f=e?l(a,d):ja;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ja;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
	"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Qe(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
	a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,z=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||z!==q)&&g(a,n,r,q);z=a.memoizedState;b=null!==a.updateQueue?Qe(null,a,a.updateQueue,n,r,b):z;var u=void 0;h!==r&&(u=k(a,n,r,b));if(null!==u&&void 0!==u){b=null===b||void 0===b?u:A({},b,u);var t=a.updateQueue;
	null!==t&&(t.baseState=A({},t.baseState,u))}if(!(h!==r||z!==b||B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,z,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=
	4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,u=p(b);u=l(b,u);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||
	(h!==r||q!==u)&&g(b,x,r,u);q=b.memoizedState;c=null!==b.updateQueue?Qe(a,b,b.updateQueue,x,r,c):q;var t=void 0;h!==r&&(t=k(b,x,r,c));if(null!==t&&void 0!==t){c=null===c||void 0===c?t:A({},c,t);var y=b.updateQueue;null!==y&&(y.baseState=A({},y.baseState,t))}if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&
	q===a.memoizedState||(b.effectTag|=2048),!1;(t=f(b,h,r,q,c,u))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,u),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,u)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&
	q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=u;return t}}}var Te=Array.isArray;
	function Ue(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ja?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
	function Ve(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function We(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ye(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Be(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ue(a,b,c),d["return"]=a,d;d=ze(c,a.mode,d);d.ref=Ue(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
	Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Ae(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Be(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case nc:return c=ze(b,a.mode,c),c.ref=Ue(a,null,b),c["return"]=a,c;case qc:return b=Ce(b,a.mode,c),b["return"]=a,b}if(Te(b)||yc(b))return b=Ae(b,
	a.mode,c,null),b["return"]=a,b;Ve(a,b)}return null}function z(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case nc:return c.key===e?c.type===rc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case qc:return c.key===e?v(a,b,c,d):null}if(Te(c)||yc(c))return null!==e?null:l(a,b,c,d,null);Ve(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
	null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case nc:return a=a.get(null===d.key?c:d.key)||null,d.type===rc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case qc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Te(d)||yc(d))return a=a.get(c)||null,l(b,a,d,e,null);Ve(b,d)}return null}function r(e,g,l,h){for(var r=null,k=null,q=g,u=g=0,t=null;null!==q&&u<l.length;u++){q.index>u?(t=q,q=null):t=q.sibling;var n=z(e,q,l[u],h);if(null===n){null===q&&(q=t);break}a&&q&&null===
	n.alternate&&b(e,q);g=f(n,g,u);null===k?r=n:k.sibling=n;k=n;q=t}if(u===l.length)return c(e,q),r;if(null===q){for(;u<l.length;u++)if(q=p(e,l[u],h))g=f(q,g,u),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);u<l.length;u++)if(t=B(q,e,u,l[u],h)){if(a&&null!==t.alternate)q["delete"](null===t.key?u:t.key);g=f(t,g,u);null===k?r=t:k.sibling=t;k=t}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,g,l,h){var r=yc(l);"function"!==typeof r?D("150"):void 0;l=r.call(l);null==l?D("151"):void 0;for(var k=
	r=null,q=g,u=g=0,t=null,n=l.next();null!==q&&!n.done;u++,n=l.next()){q.index>u?(t=q,q=null):t=q.sibling;var H=z(e,q,n.value,h);if(null===H){q||(q=t);break}a&&q&&null===H.alternate&&b(e,q);g=f(H,g,u);null===k?r=H:k.sibling=H;k=H;q=t}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;u++,n=l.next())n=p(e,n.value,h),null!==n&&(g=f(n,g,u),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;u++,n=l.next())if(n=B(q,e,u,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?u:n.key);
	g=f(n,g,u);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,g){"object"===typeof f&&null!==f&&f.type===rc&&null===f.key&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case nc:a:{var k=f.key;for(l=d;null!==l;){if(l.key===k)if(10===l.tag?f.type===rc:l.type===f.type){c(a,l.sibling);d=e(l,f.type===rc?f.props.children:f.props,g);d.ref=Ue(a,l,f);d["return"]=a;a=d;break a}else{c(a,l);break}else b(a,l);l=l.sibling}f.type===
	rc?(d=Ae(f.props.children,a.mode,g,f.key),d["return"]=a,a=d):(g=ze(f,a.mode,g),g.ref=Ue(a,d,f),g["return"]=a,a=g)}return h(a);case qc:a:{for(l=f.key;null!==d;){if(d.key===l)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],g);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ce(f,a.mode,g);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
	6===d.tag?(c(a,d.sibling),d=e(d,f,g)):(c(a,d),d=Be(f,a.mode,g)),d["return"]=a,a=d,h(a);if(Te(f))return r(a,d,f,g);if(yc(f))return Q(a,d,f,g);l&&Ve(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:g=a.type,D("152",g.displayName||g.name||"Component")}return c(a,d)}}var Xe=We(!0),Ye=We(!1);
	function Ze(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ye(b,null,c,d):Xe(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&y(b,!1),r(a,b);c=b.stateNode;mc.current=b;var g=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,g,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&y(b,!0);return b.child}function p(a){var b=a.stateNode;
	b.pendingContext?t(a,b.pendingContext,b.pendingContext!==b.context):b.context&&t(a,b.context,!1);Y(a,b.containerInfo)}function z(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=
	d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
	r(a,b);l=0}else{var u=f.value;if(u===l&&(0!==u||1/u===1/l)||u!==u&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(u,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else z(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ye(a,a.pendingProps,a.expirationTime);
	b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ye(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,u=c.pushContextProvider,t=c.pushTopLevelContextObject,y=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Cb=e.tryToClaimNextHydratableInstance;
	a=Se(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Db=a.mountClassInstance,Mc=a.resumeMountClassInstance,Eb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:u(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
	e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=u(b),Jc(b,d),Db(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
	b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=u(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Db(b,c),d=!0):d=Mc(b,c):d=Eb(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Qe(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
	e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ye(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Cb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
	1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Cb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ye(b,b.stateNode,d,c):Xe(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Xe(b,null,e,c):g(a,b,e),b.memoizedProps=
	e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:d=b.type;f=b.pendingProps;var t=b.memoizedProps;e=d._currentValue;h=d._changedBits;if(q()||0!==h||t!==f){b.memoizedProps=
	f;t=f.unstable_observedBits;if(void 0===t||null===t)t=1073741823;b.stateNode=t;0!==(h&t)&&z(b,d,h,c);c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b);return a;default:D("156")}}}}
	function $e(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,z=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,u=void 0,t=void 0;a.mutation?(q=function(){},u=function(a,b,c){(b.updateQueue=
	c)&&f(b)},t=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
	null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=z();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,y=r();H=l(H,e,p,d,c,y);u(a,b,H,e,p,d,c,y);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(y=b.child;null!==y;){if(5===y.tag||6===y.tag)k(p,y.stateNode);else if(4!==y.tag&&null!==y.child){y.child["return"]=y;y=y.child;continue}if(y===b)break;
	for(;null===y.sibling;){if(null===y["return"]||y["return"]===b)break a;y=y["return"]}y.sibling["return"]=y["return"];y=y.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)t(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=z();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
	p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Xe(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
	case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
	function af(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Ac(b)};do{switch(a.tag){case 3:Ne(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Ne(a);c=a.updateQueue;var d=c.capturedValues;null===d?
	c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
	function bf(a,b){var c=b.source;null===b.stack&&Ac(c);null!==c&&zc(c);b=b.value;null!==a&&2===a.tag&&zc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
	function cf(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(t){b(a,t)}else c.current=null}function h(a){"function"===typeof Ie&&Ie(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(t){b(a,t)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
	a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
	b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var z=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
	x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
	commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
	c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
	a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
	c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Re(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Re(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
	4&&z(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var g=d.value,h=d.stack;bf(a,d);b.componentDidCatch(g,{componentStack:null!==h?h:""})}break;
	case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],bf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var df={};
	function ef(a,b){function c(a){a===df?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(df),k=a(df),v=a(df);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);f(k,a,a);f(g,df,a);b=e(b);h(g,a);f(g,b,a)},pushHostContext:function(a){var b=
	c(v.current),e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
	function ff(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
	a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,z=null,B=!1;return{enterHydrationState:function(a){z=
	k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){z=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=z;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,z)}p=a;z=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
	p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=z;c;)b(a,c),c=g(c);d(a);z=p?g(a.stateNode):null;return!0}}}
	function gf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",zc(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ja),k=e(!1),v=ja;return{getUnmaskedContext:function(a){return c(a)?
	v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ja;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
	a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ja;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
	wd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
	function hf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type._context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type._context;a._currentValue=c;a._changedBits=b}}}
	function jf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
	function kf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Ya=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Cb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
	g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
	null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));mc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Ya||null===I)b(),Ya=a,Z=c,I=ye(Ya.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
	ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Ac(a)};Oe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Za?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
	1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Za?1:Z:a.mode&1?za?10*(((l()+50)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
	a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Za&&Ya===d||B(d,c);Fb>wg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ve=Ic()-Pc;return xg=(ve/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function z(a){if(0!==Gb){if(a>Gb)return;yg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
	else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():z(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
	d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){$a=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==$a&&(Gb=0,Qc=-1);0!==P&&z(P);$a=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
	0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(vg){Ba||(Ba=!0,Jb=vg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
	0;return}a.finishedWork=null;Za=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();mc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Db(w.alternate,w),w=w.nextEffect}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==
	w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Eb(w);w.effectTag&=-3;break;case 6:Eb(w);w.effectTag&=-3;te(w.alternate,w);break;case 4:te(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
	r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch(ab){p=!0,n=ab}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Za=!1;"function"===typeof He&&He(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===$a||$a.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var u=jf(),t=ef(a,u),y=gf(u);u=hf(u);var H=ff(a),
	Wa=Ze(a,t,y,u,H,v,k).beginWork,Cb=$e(a,t,y,u,H).completeWork;t=af(t,y,u,v,c);var Jc=t.throwException,Kc=t.unwindWork,Lc=t.unwindInterruptedWork;t=cf(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Db=t.commitBeforeMutationLifeCycles,Mc=t.commitResetTextContent,Eb=t.commitPlacement,gg=t.commitDeletion,te=t.commitWork,hg=t.commitLifeCycles,ig=t.commitErrorLogging,jg=t.commitAttachRef,kg=t.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,yg=a.cancelDeferredCallback,zg=a.prepareForCommit,
	Ag=a.resetAfterCommit,Pc=Ic(),xg=2,ve=Pc,Rc=0,ia=0,ca=!1,I=null,Ya=null,Z=0,w=null,Za=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,$a=null,J=!1,Hb=!1,za=!1,Aa=null,wg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
	!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
	0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:y}}
	function lf(a){function b(a,b,c,d,e,f){d=b.current;if(c){c=c._reactInternalFiber;var g=k(c);c=v(c)?l(c,g):g}else c=ja;null===b.context?b.context=c:b.pendingContext=c;b=f;Oe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});h(d,e);return e}function c(a){a=Ad(a);return null===a?null:a.stateNode}var d=a.getPublicInstance;a=kf(a);var e=a.recalculateCurrentTime,f=a.computeExpirationForFiber,h=a.scheduleWork,g=a.legacyContext,
	k=g.findCurrentUnmaskedContext,v=g.isContextProvider,l=g.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,d,g){var h=c.current,k=e();h=f(h);return b(a,c,d,k,h,g)},updateContainerAtExpirationTime:function(a,
	c,d,f,g){var h=e();return b(a,c,d,h,f,g)},flushRoot:a.flushRoot,requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return d(a.child.stateNode);
	default:return a.child.stateNode}},findHostInstance:c,findHostInstanceWithNoPortals:function(a){a=Bd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return Ge(A({},a,{findHostInstanceByFiber:function(a){return c(a)},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;
	function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:qc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};var sf=void 0,tf=void 0;
	if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf=void 0;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==
	wf&&wf<=a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=
	function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},tf=function(a){clearTimeout(a)};function Ef(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Ff(a,b){a=A({children:void 0},b);if(b=Ef(b.children))a.children=b;return a}
	function Gf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Hf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function If(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
	function Kf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Lf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Mf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Of(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pf=void 0,Qf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mf.svg||"innerHTML"in a)a.innerHTML=b;else{Pf=Pf||document.createElement("div");Pf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Pf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var Sf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
	stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Tf=["Webkit","ms","Moz","O"];Object.keys(Sf).forEach(function(a){Tf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Sf[b]=Sf[a]})});
	function Uf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Sf.hasOwnProperty(e)&&Sf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Vf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function Wf(a,b,c){b&&(Vf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
	function Xf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Yf=Mf.html,Zf=C.thatReturns("");
	function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=je(a);b=ua[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Yd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Yd("topFocus","focus",a),Yd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(hc("cancel",!0)&&Yd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(hc("close",!0)&&Yd("topClose","close",a),c.topClose=!0):ee.hasOwnProperty(e)&&W(e,ee[e],a),c[e]=!0)}}
	function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Yf&&(d=Nf(a));d===Yf?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
	function cg(a,b,c,d){var e=Xf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in fe)fe.hasOwnProperty(f)&&W(f,fe[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Vc(a,c);f=Uc(a,c);W("topInvalid",
	"invalid",a);$f(d,"onChange");break;case "option":f=Ff(a,c);break;case "select":Hf(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Jf(a,c);f=If(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Wf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Uf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Qf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Rf(a,k):"number"===typeof k&&
	Rf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ta.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Tc(a,g,k,e))}switch(b){case "input":kc(a);$c(a,c);break;case "textarea":kc(a);Lf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Gf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Gf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
	function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Uc(a,c);d=Uc(a,d);f=[];break;case "option":c=Ff(a,c);d=Ff(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=If(a,c);d=If(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Wf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
	(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ta.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
	h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ta.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
	function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Xc(a,e);Xf(c,d);d=Xf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Uf(a,g,Zf):"dangerouslySetInnerHTML"===h?Qf(a,g):"children"===h?Rf(a,g):Tc(a,h,g,d)}switch(c){case "input":Yc(a,e);break;case "textarea":Kf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Gf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
	Gf(a,!!e.multiple,e.defaultValue,!0):Gf(a,!!e.multiple,e.multiple?[]:"",!1))}}
	function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in fe)fe.hasOwnProperty(f)&&W(f,fe[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Vc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":Hf(a,
	c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Jf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Wf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ta.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":kc(a);$c(a,c);break;case "textarea":kc(a);Lf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
	(a.onclick=C)}return d}function mg(a,b){return a.nodeValue!==b}
	var ng=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:mg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
	c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Va(d);e?void 0:D("90");lc(d);Yc(d,e)}}}break;case "textarea":Kf(a,c);break;case "select":b=c.value,null!=b&&Gf(a,!!c.multiple,b,!1)}}});Vb.injectFiberControlledHostComponent(ng);var og=null,pg=null;
	function qg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}qg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new rg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
	qg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	qg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
	null,this._defer=!1};qg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function rg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}rg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	rg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function sg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}sg.prototype.render=function(a,b){var c=this._internalRoot,d=new rg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
	sg.prototype.unmount=function(a){var b=this._internalRoot,c=new rg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};sg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new rg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
	sg.prototype.createBatch=function(){var a=new qg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function tg(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
	function ug(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	var X=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Of(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Of(a,b)}return a},getChildHostContext:function(a,b){return Of(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){og=Ud;var a=ea();if(me(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
	if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var z;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(z=l.firstChild))break;p=l;l=z}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(z=l.nextSibling))break;l=p;p=l.parentNode}l=z}b=-1===h||-1===g?null:
	{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;pg={focusedElem:a,selectionRange:b};Vd(!1)},resetAfterCommit:function(){var a=pg,b=ea(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ha(document.documentElement,c)){if(me(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[lb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
	d&&(e=d,d=a,a=e);e=le(c,a);var f=le(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
	a.element.scrollTop=a.top}pg=null;Vd(og);og=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Sa]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return ug(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
	typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:rf,mutation:{commitMount:function(a,b,c){ug(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Sa]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Rf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
	insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
	a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Sa]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return mg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
	didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf}),Cg=X;$b=Cg.batchedUpdates;ac=Cg.interactiveUpdates;bc=Cg.flushInteractiveUpdates;
	function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new sg(a,!1,b)}
	function Eg(a,b,c,d,e){tg(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
	function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;tg(b)?void 0:D("200");return pf(a,b,null,c)}
	var Gg={createPortal:Fg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return X.findHostInstance(b);"function"===typeof a.render?D("188"):D("213",Object.keys(a))},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){tg(a)?void 0:
	D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Qa,EventPluginRegistry:xa,EventPropagators:jb,ReactControlledComponent:Zb,ReactDOMComponentTree:Xa,
	ReactDOMEventListener:Zd},unstable_createRoot:function(a,b){return new sg(a,!0,null!=b&&!0===b.hydrate)}};X.injectIntoDevTools({findFiberByHostInstance:Ta,bundleType:0,version:"16.3.1",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(15), __webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react-dom", "react"], factory);
		else if(typeof exports === 'object')
			exports["ReactDraggable"] = factory(require("react-dom"), require("react"));
		else
			root["ReactDraggable"] = factory(root["ReactDOM"], root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 12);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findInArray = findInArray;
	exports.isFunction = isFunction;
	exports.isNum = isNum;
	exports.int = int;
	exports.dontSetMe = dontSetMe;
	
	// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
	function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
	  for (var i = 0, length = array.length; i < length; i++) {
	    if (callback.apply(callback, [array[i], i, array])) return array[i];
	  }
	}
	
	function isFunction(func /*: any*/) /*: boolean*/ {
	  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
	}
	
	function isNum(num /*: any*/) /*: boolean*/ {
	  return typeof num === 'number' && !isNaN(num);
	}
	
	function int(a /*: string*/) /*: number*/ {
	  return parseInt(a, 10);
	}
	
	function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
	  if (props[propName]) {
	    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
	  }
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.matchesSelector = matchesSelector;
	exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
	exports.addEvent = addEvent;
	exports.removeEvent = removeEvent;
	exports.outerHeight = outerHeight;
	exports.outerWidth = outerWidth;
	exports.innerHeight = innerHeight;
	exports.innerWidth = innerWidth;
	exports.offsetXYFromParent = offsetXYFromParent;
	exports.createCSSTransform = createCSSTransform;
	exports.createSVGTransform = createSVGTransform;
	exports.getTouch = getTouch;
	exports.getTouchIdentifier = getTouchIdentifier;
	exports.addUserSelectStyles = addUserSelectStyles;
	exports.removeUserSelectStyles = removeUserSelectStyles;
	exports.styleHacks = styleHacks;
	exports.addClassName = addClassName;
	exports.removeClassName = removeClassName;
	
	var _shims = __webpack_require__(0);
	
	var _getPrefix = __webpack_require__(19);
	
	var _getPrefix2 = _interopRequireDefault(_getPrefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*:: import type {ControlPosition, MouseTouchEvent} from './types';*/
	
	
	var matchesSelectorFunc = '';
	function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
	  if (!matchesSelectorFunc) {
	    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
	      // $FlowIgnore: Doesn't think elements are indexable
	      return (0, _shims.isFunction)(el[method]);
	    });
	  }
	
	  // Might not be found entirely (not an Element?) - in that case, bail
	  // $FlowIgnore: Doesn't think elements are indexable
	  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false;
	
	  // $FlowIgnore: Doesn't think elements are indexable
	  return el[matchesSelectorFunc](selector);
	}
	
	// Works up the tree to the draggable itself attempting to match selector.
	function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
	  var node = el;
	  do {
	    if (matchesSelector(node, selector)) return true;
	    if (node === baseNode) return false;
	    node = node.parentNode;
	  } while (node);
	
	  return false;
	}
	
	function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
	  if (!el) {
	    return;
	  }
	  if (el.attachEvent) {
	    el.attachEvent('on' + event, handler);
	  } else if (el.addEventListener) {
	    el.addEventListener(event, handler, true);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = handler;
	  }
	}
	
	function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
	  if (!el) {
	    return;
	  }
	  if (el.detachEvent) {
	    el.detachEvent('on' + event, handler);
	  } else if (el.removeEventListener) {
	    el.removeEventListener(event, handler, true);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = null;
	  }
	}
	
	function outerHeight(node /*: HTMLElement*/) /*: number*/ {
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetTop which is including margin. See getBoundPosition
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height += (0, _shims.int)(computedStyle.borderTopWidth);
	  height += (0, _shims.int)(computedStyle.borderBottomWidth);
	  return height;
	}
	
	function outerWidth(node /*: HTMLElement*/) /*: number*/ {
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetLeft which is including margin. See getBoundPosition
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width += (0, _shims.int)(computedStyle.borderLeftWidth);
	  width += (0, _shims.int)(computedStyle.borderRightWidth);
	  return width;
	}
	function innerHeight(node /*: HTMLElement*/) /*: number*/ {
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height -= (0, _shims.int)(computedStyle.paddingTop);
	  height -= (0, _shims.int)(computedStyle.paddingBottom);
	  return height;
	}
	
	function innerWidth(node /*: HTMLElement*/) /*: number*/ {
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width -= (0, _shims.int)(computedStyle.paddingLeft);
	  width -= (0, _shims.int)(computedStyle.paddingRight);
	  return width;
	}
	
	// Get from offsetParent
	function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
	  var isBody = offsetParent === offsetParent.ownerDocument.body;
	  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();
	
	  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
	  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;
	
	  return { x: x, y: y };
	}
	
	function createCSSTransform(_ref) /*: Object*/ {
	  var x = _ref.x,
	      y = _ref.y;
	
	  // Replace unitless items with px
	  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix2.default), 'translate(' + x + 'px,' + y + 'px)');
	}
	
	function createSVGTransform(_ref3) /*: string*/ {
	  var x = _ref3.x,
	      y = _ref3.y;
	
	  return 'translate(' + x + ',' + y + ')';
	}
	
	function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
	  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
	    return identifier === t.identifier;
	  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
	    return identifier === t.identifier;
	  });
	}
	
	function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
	  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
	  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
	}
	
	// User-select Hacks:
	//
	// Useful for preventing blue highlights all over everything when dragging.
	
	// Note we're passing `document` b/c we could be iframed
	function addUserSelectStyles(doc /*: ?Document*/) {
	  if (!doc) return;
	  var styleEl = doc.getElementById('react-draggable-style-el');
	  if (!styleEl) {
	    styleEl = doc.createElement('style');
	    styleEl.type = 'text/css';
	    styleEl.id = 'react-draggable-style-el';
	    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {background: transparent;}\n';
	    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {background: transparent;}\n';
	    doc.getElementsByTagName('head')[0].appendChild(styleEl);
	  }
	  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
	}
	
	function removeUserSelectStyles(doc /*: ?Document*/) {
	  try {
	    if (doc && doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
	    window.getSelection().removeAllRanges(); // remove selection caused by scroll
	  } catch (e) {
	    // probably IE
	  }
	}
	
	function styleHacks() /*: Object*/ {
	  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  // Workaround IE pointer events; see #51
	  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
	  return _extends({
	    touchAction: 'none'
	  }, childStyle);
	}
	
	function addClassName(el /*: HTMLElement*/, className /*: string*/) {
	  if (el.classList) {
	    el.classList.add(className);
	  } else {
	    if (!el.className.match(new RegExp('(?:^|\\s)' + className + '(?!\\S)'))) {
	      el.className += ' ' + className;
	    }
	  }
	}
	
	function removeClassName(el /*: HTMLElement*/, className /*: string*/) {
	  if (el.classList) {
	    el.classList.remove(className);
	  } else {
	    el.className = el.className.replace(new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'g'), '');
	  }
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(14)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(17)();
	}
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBoundPosition = getBoundPosition;
	exports.snapToGrid = snapToGrid;
	exports.canDragX = canDragX;
	exports.canDragY = canDragY;
	exports.getControlPosition = getControlPosition;
	exports.createCoreData = createCoreData;
	exports.createDraggableData = createDraggableData;
	
	var _shims = __webpack_require__(0);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domFns = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*:: import type Draggable from '../Draggable';*/
	/*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/
	/*:: import type DraggableCore from '../DraggableCore';*/
	function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
	  // If no bounds, short-circuit and move on
	  if (!draggable.props.bounds) return [x, y];
	
	  // Clone new bounds
	  var bounds = draggable.props.bounds;
	
	  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
	  var node = findDOMNode(draggable);
	
	  if (typeof bounds === 'string') {
	    var ownerDocument = node.ownerDocument;
	
	    var ownerWindow = ownerDocument.defaultView;
	    var boundNode = void 0;
	    if (bounds === 'parent') {
	      boundNode = node.parentNode;
	    } else {
	      boundNode = ownerDocument.querySelector(bounds);
	    }
	    if (!(boundNode instanceof HTMLElement)) {
	      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
	    }
	    var nodeStyle = ownerWindow.getComputedStyle(node);
	    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
	    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
	    bounds = {
	      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
	      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
	      right: (0, _domFns.innerWidth)(boundNode) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
	      bottom: (0, _domFns.innerHeight)(boundNode) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
	    };
	  }
	
	  // Keep x and y below right and bottom limits...
	  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
	  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
	
	  // But above left and top limits.
	  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
	  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
	
	  return [x, y];
	}
	
	function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
	  var x = Math.round(pendingX / grid[0]) * grid[0];
	  var y = Math.round(pendingY / grid[1]) * grid[1];
	  return [x, y];
	}
	
	function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
	  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
	}
	
	function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
	  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
	}
	
	// Get {x, y} positions from event.
	function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
	  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
	  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
	  var node = findDOMNode(draggableCore);
	  // User can provide an offsetParent if desired.
	  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
	  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent);
	}
	
	// Create an data object exposed by <DraggableCore>'s events
	function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
	  var state = draggable.state;
	  var isStart = !(0, _shims.isNum)(state.lastX);
	  var node = findDOMNode(draggable);
	
	  if (isStart) {
	    // If this is our first move, use the x and y as last coords.
	    return {
	      node: node,
	      deltaX: 0, deltaY: 0,
	      lastX: x, lastY: y,
	      x: x, y: y
	    };
	  } else {
	    // Otherwise calculate proper values.
	    return {
	      node: node,
	      deltaX: x - state.lastX, deltaY: y - state.lastY,
	      lastX: state.lastX, lastY: state.lastY,
	      x: x, y: y
	    };
	  }
	}
	
	// Create an data exposed by <Draggable>'s events
	function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
	  return {
	    node: coreData.node,
	    x: draggable.state.x + coreData.deltaX,
	    y: draggable.state.y + coreData.deltaY,
	    deltaX: coreData.deltaX,
	    deltaY: coreData.deltaY,
	    lastX: draggable.state.x,
	    lastY: draggable.state.y
	  };
	}
	
	// A lot faster than stringify/parse
	function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
	  return {
	    left: bounds.left,
	    top: bounds.top,
	    right: bounds.right,
	    bottom: bounds.bottom
	  };
	}
	
	function findDOMNode(draggable /*: Draggable | DraggableCore*/) /*: HTMLElement*/ {
	  var node = _reactDom2.default.findDOMNode(draggable);
	  if (!node) {
	    throw new Error('<DraggableCore>: Unmounted during event!');
	  }
	  // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
	  return node;
	}
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domFns = __webpack_require__(5);
	
	var _positionFns = __webpack_require__(9);
	
	var _shims = __webpack_require__(0);
	
	var _log = __webpack_require__(11);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/
	
	
	// Simple abstraction for dragging events names.
	/*:: import type {Element as ReactElement} from 'react';*/
	var eventsFor = {
	  touch: {
	    start: 'touchstart',
	    move: 'touchmove',
	    stop: 'touchend'
	  },
	  mouse: {
	    start: 'mousedown',
	    move: 'mousemove',
	    stop: 'mouseup'
	  }
	};
	
	// Default to mouse events.
	var dragEventFor = eventsFor.mouse;
	
	/*:: type DraggableCoreState = {
	  dragging: boolean,
	  lastX: number,
	  lastY: number,
	  touchIdentifier: ?number
	};*/
	/*:: export type DraggableBounds = {
	  left: number,
	  right: number,
	  top: number,
	  bottom: number,
	};*/
	/*:: export type DraggableData = {
	  node: HTMLElement,
	  x: number, y: number,
	  deltaX: number, deltaY: number,
	  lastX: number, lastY: number,
	};*/
	/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void;*/
	/*:: export type ControlPosition = {x: number, y: number};*/
	
	
	//
	// Define <DraggableCore>.
	//
	// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
	// work well with libraries that require more control over the element.
	//
	
	/*:: export type DraggableCoreProps = {
	  allowAnyClick: boolean,
	  cancel: string,
	  children: ReactElement<any>,
	  disabled: boolean,
	  enableUserSelectHack: boolean,
	  offsetParent: HTMLElement,
	  grid: [number, number],
	  handle: string,
	  onStart: DraggableEventHandler,
	  onDrag: DraggableEventHandler,
	  onStop: DraggableEventHandler,
	  onMouseDown: (e: MouseEvent) => void,
	};*/
	
	var DraggableCore = function (_React$Component) {
	  _inherits(DraggableCore, _React$Component);
	
	  function DraggableCore() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DraggableCore);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      dragging: false,
	      // Used while dragging to determine deltas.
	      lastX: NaN, lastY: NaN,
	      touchIdentifier: null
	    }, _this.handleDragStart = function (e) {
	      // Make it possible to attach event handlers on top of this one.
	      _this.props.onMouseDown(e);
	
	      // Only accept left-clicks.
	      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
	
	      // Get nodes. Be sure to grab relative document (could be iframed)
	      var thisNode = _reactDom2.default.findDOMNode(_this);
	      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
	        throw new Error('<DraggableCore> not mounted on DragStart!');
	      }
	      var ownerDocument = thisNode.ownerDocument;
	
	      // Short circuit if handle or cancel prop was provided and selector doesn't match.
	
	      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
	        return;
	      }
	
	      // Set touch identifier in component state if this is a touch event. This allows us to
	      // distinguish between individual touches on multitouch screens by identifying which
	      // touchpoint was set to this element.
	      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
	      _this.setState({ touchIdentifier: touchIdentifier });
	
	      // Get the current drag point from the event. This is used as the offset.
	      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _this);
	      if (position == null) return; // not possible but satisfies flow
	      var x = position.x,
	          y = position.y;
	
	      // Create an event object with all the data parents need to make a decision here.
	
	      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
	
	      (0, _log2.default)('DraggableCore: handleDragStart: %j', coreEvent);
	
	      // Call event handler. If it returns explicit false, cancel.
	      (0, _log2.default)('calling', _this.props.onStart);
	      var shouldUpdate = _this.props.onStart(e, coreEvent);
	      if (shouldUpdate === false) return;
	
	      // Add a style to the body to disable user-select. This prevents text from
	      // being selected all over the page.
	      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument);
	
	      // Initiate dragging. Set the current x and y as offsets
	      // so we know how much we've moved during the drag. This allows us
	      // to drag elements around even if they have been moved, without issue.
	      _this.setState({
	        dragging: true,
	
	        lastX: x,
	        lastY: y
	      });
	
	      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
	      // this element. We use different events depending on whether or not we have detected that this
	      // is a touch-capable device.
	      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
	      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
	    }, _this.handleDrag = function (e) {
	
	      // Prevent scrolling on mobile devices, like ipad/iphone.
	      if (e.type === 'touchmove') e.preventDefault();
	
	      // Get the current drag point from the event. This is used as the offset.
	      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
	      if (position == null) return;
	      var x = position.x,
	          y = position.y;
	
	      // Snap to grid if prop has been provided
	
	      if (Array.isArray(_this.props.grid)) {
	        var _deltaX = x - _this.state.lastX,
	            _deltaY = y - _this.state.lastY;
	
	        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, _deltaX, _deltaY);
	
	        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
	
	        _deltaX = _snapToGrid2[0];
	        _deltaY = _snapToGrid2[1];
	
	        if (!_deltaX && !_deltaY) return; // skip useless drag
	        x = _this.state.lastX + _deltaX, y = _this.state.lastY + _deltaY;
	      }
	
	      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
	
	      (0, _log2.default)('DraggableCore: handleDrag: %j', coreEvent);
	
	      // Call event handler. If it returns explicit false, trigger end.
	      var shouldUpdate = _this.props.onDrag(e, coreEvent);
	      if (shouldUpdate === false) {
	        try {
	          // $FlowIgnore
	          _this.handleDragStop(new MouseEvent('mouseup'));
	        } catch (err) {
	          // Old browsers
	          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
	          // I see why this insanity was deprecated
	          // $FlowIgnore
	          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	          _this.handleDragStop(event);
	        }
	        return;
	      }
	
	      _this.setState({
	        lastX: x,
	        lastY: y
	      });
	    }, _this.handleDragStop = function (e) {
	      if (!_this.state.dragging) return;
	
	      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
	      if (position == null) return;
	      var x = position.x,
	          y = position.y;
	
	      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
	
	      var thisNode = _reactDom2.default.findDOMNode(_this);
	      if (thisNode) {
	        // Remove user-select hack
	        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
	      }
	
	      (0, _log2.default)('DraggableCore: handleDragStop: %j', coreEvent);
	
	      // Reset the el.
	      _this.setState({
	        dragging: false,
	        lastX: NaN,
	        lastY: NaN
	      });
	
	      // Call event handler
	      _this.props.onStop(e, coreEvent);
	
	      if (thisNode) {
	        // Remove event handlers
	        (0, _log2.default)('DraggableCore: Removing handlers');
	        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
	        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
	      }
	    }, _this.onMouseDown = function (e) {
	      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
	
	      return _this.handleDragStart(e);
	    }, _this.onMouseUp = function (e) {
	      dragEventFor = eventsFor.mouse;
	
	      return _this.handleDragStop(e);
	    }, _this.onTouchStart = function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;
	
	      return _this.handleDragStart(e);
	    }, _this.onTouchEnd = function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;
	
	      return _this.handleDragStop(e);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DraggableCore, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
	      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
	      var thisNode = _reactDom2.default.findDOMNode(this);
	      if (thisNode) {
	        var ownerDocument = thisNode.ownerDocument;
	
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
	        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
	      }
	    }
	
	    // Same as onMouseDown (start drag), but now consider this a touch device.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
	        style: (0, _domFns.styleHacks)(this.props.children.props.style),
	
	        // Note: mouseMove handler is attached to document so it will still function
	        // when the user drags quickly and leaves the bounds of the element.
	        onMouseDown: this.onMouseDown,
	        onTouchStart: this.onTouchStart,
	        onMouseUp: this.onMouseUp,
	        onTouchEnd: this.onTouchEnd
	      });
	    }
	  }]);
	
	  return DraggableCore;
	}(_react2.default.Component);
	
	DraggableCore.displayName = 'DraggableCore';
	DraggableCore.propTypes = {
	  /**
	   * `allowAnyClick` allows dragging using any mouse button.
	   * By default, we only accept the left button.
	   *
	   * Defaults to `false`.
	   */
	  allowAnyClick: _propTypes2.default.bool,
	
	  /**
	   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
	   * with the exception of `onMouseDown`, will not fire.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * By default, we add 'user-select:none' attributes to the document body
	   * to prevent ugly text selection during drag. If this is causing problems
	   * for your app, set this to `false`.
	   */
	  enableUserSelectHack: _propTypes2.default.bool,
	
	  /**
	   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
	   * instead of using the parent node.
	   */
	  offsetParent: function offsetParent(props /*: DraggableCoreProps*/, propName /*: $Keys<DraggableCoreProps>*/) {
	    if (process.browser === true && props[propName] && props[propName].nodeType !== 1) {
	      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
	    }
	  },
	
	  /**
	   * `grid` specifies the x and y that dragging should snap to.
	   */
	  grid: _propTypes2.default.arrayOf(_propTypes2.default.number),
	
	  /**
	   * `handle` specifies a selector to be used as the handle that initiates drag.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable handle=".handle">
	   *              <div>
	   *                  <div className="handle">Click me to drag</div>
	   *                  <div>This is some other content</div>
	   *              </div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  handle: _propTypes2.default.string,
	
	  /**
	   * `cancel` specifies a selector to be used to prevent drag initialization.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *           return(
	   *               <Draggable cancel=".cancel">
	   *                   <div>
	   *                     <div className="cancel">You can't drag from here</div>
	   *                     <div>Dragging here works fine</div>
	   *                   </div>
	   *               </Draggable>
	   *           );
	   *       }
	   *   });
	   * ```
	   */
	  cancel: _propTypes2.default.string,
	
	  /**
	   * Called when dragging starts.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onStart: _propTypes2.default.func,
	
	  /**
	   * Called while dragging.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onDrag: _propTypes2.default.func,
	
	  /**
	   * Called when dragging stops.
	   * If this function returns the boolean false, the drag will remain active.
	   */
	  onStop: _propTypes2.default.func,
	
	  /**
	   * A workaround option which can be passed if onMouseDown needs to be accessed,
	   * since it'll always be blocked (as there is internal use of onMouseDown)
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	};
	DraggableCore.defaultProps = {
	  allowAnyClick: false, // by default only accept left click
	  cancel: null,
	  disabled: false,
	  enableUserSelectHack: true,
	  offsetParent: null,
	  handle: null,
	  grid: null,
	  transform: null,
	  onStart: function onStart() {},
	  onDrag: function onDrag() {},
	  onStop: function onStop() {},
	  onMouseDown: function onMouseDown() {}
	};
	exports.default = DraggableCore;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	
	/*eslint no-console:0*/
	function log() {
	  var _console;
	
	  if (undefined) (_console = console).log.apply(_console, arguments);
	}
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var Draggable = __webpack_require__(13).default;
	
	// Previous versions of this lib exported <Draggable> as the root export. As to not break
	// them, or TypeScript, we export *both* as the root and as 'default'.
	// See https://github.com/mzabriskie/react-draggable/pull/254
	// and https://github.com/mzabriskie/react-draggable/issues/266
	module.exports = Draggable;
	module.exports.default = Draggable;
	module.exports.DraggableCore = __webpack_require__(10).default;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(18);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domFns = __webpack_require__(5);
	
	var _positionFns = __webpack_require__(9);
	
	var _shims = __webpack_require__(0);
	
	var _DraggableCore = __webpack_require__(10);
	
	var _DraggableCore2 = _interopRequireDefault(_DraggableCore);
	
	var _log = __webpack_require__(11);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*:: import type {ControlPosition, DraggableBounds, DraggableCoreProps} from './DraggableCore';*/
	/*:: import type {DraggableEventHandler} from './utils/types';*/
	/*:: import type {Element as ReactElement} from 'react';*/
	/*:: type DraggableState = {
	  dragging: boolean,
	  dragged: boolean,
	  x: number, y: number,
	  slackX: number, slackY: number,
	  isElementSVG: boolean
	};*/
	
	
	//
	// Define <Draggable>
	//
	
	/*:: export type DraggableProps = {
	  ...$Exact<DraggableCoreProps>,
	  axis: 'both' | 'x' | 'y' | 'none',
	  bounds: DraggableBounds | string | false,
	  defaultClassName: string,
	  defaultClassNameDragging: string,
	  defaultClassNameDragged: string,
	  defaultPosition: ControlPosition,
	  position: ControlPosition,
	};*/
	
	var Draggable = function (_React$Component) {
	  _inherits(Draggable, _React$Component);
	
	  function Draggable(props /*: DraggableProps*/) {
	    _classCallCheck(this, Draggable);
	
	    var _this = _possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));
	
	    _this.onDragStart = function (e, coreData) {
	      (0, _log2.default)('Draggable: onDragStart: %j', coreData);
	
	      // Short-circuit if user's callback killed it.
	      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_this, coreData));
	      // Kills start event on core as well, so move handlers are never bound.
	      if (shouldStart === false) return false;
	
	      _this.setState({ dragging: true, dragged: true });
	    };
	
	    _this.onDrag = function (e, coreData) {
	      if (!_this.state.dragging) return false;
	      (0, _log2.default)('Draggable: onDrag: %j', coreData);
	
	      var uiData = (0, _positionFns.createDraggableData)(_this, coreData);
	
	      var newState /*: $Shape<DraggableState>*/ = {
	        x: uiData.x,
	        y: uiData.y
	      };
	
	      // Keep within bounds.
	      if (_this.props.bounds) {
	        // Save original x and y.
	        var _x = newState.x,
	            _y = newState.y;
	
	        // Add slack to the values used to calculate bound position. This will ensure that if
	        // we start removing slack, the element won't react to it right away until it's been
	        // completely removed.
	
	        newState.x += _this.state.slackX;
	        newState.y += _this.state.slackY;
	
	        // Get bound position. This will ceil/floor the x and y within the boundaries.
	
	        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_this, newState.x, newState.y),
	            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
	            newStateX = _getBoundPosition2[0],
	            newStateY = _getBoundPosition2[1];
	
	        newState.x = newStateX;
	        newState.y = newStateY;
	
	        // Recalculate slack by noting how much was shaved by the boundPosition handler.
	        newState.slackX = _this.state.slackX + (_x - newState.x);
	        newState.slackY = _this.state.slackY + (_y - newState.y);
	
	        // Update the event we fire to reflect what really happened after bounds took effect.
	        uiData.x = newState.x;
	        uiData.y = newState.y;
	        uiData.deltaX = newState.x - _this.state.x;
	        uiData.deltaY = newState.y - _this.state.y;
	      }
	
	      // Short-circuit if user's callback killed it.
	      var shouldUpdate = _this.props.onDrag(e, uiData);
	      if (shouldUpdate === false) return false;
	
	      _this.setState(newState);
	    };
	
	    _this.onDragStop = function (e, coreData) {
	      if (!_this.state.dragging) return false;
	
	      // Short-circuit if user's callback killed it.
	      var shouldStop = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_this, coreData));
	      if (shouldStop === false) return false;
	
	      (0, _log2.default)('Draggable: onDragStop: %j', coreData);
	
	      var newState /*: $Shape<DraggableState>*/ = {
	        dragging: false,
	        slackX: 0,
	        slackY: 0
	      };
	
	      // If this is a controlled component, the result of this operation will be to
	      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
	      var controlled = Boolean(_this.props.position);
	      if (controlled) {
	        var _this$props$position = _this.props.position,
	            _x2 = _this$props$position.x,
	            _y2 = _this$props$position.y;
	
	        newState.x = _x2;
	        newState.y = _y2;
	      }
	
	      _this.setState(newState);
	    };
	
	    _this.state = {
	      // Whether or not we are currently dragging.
	      dragging: false,
	
	      // Whether or not we have been dragged before.
	      dragged: false,
	
	      // Current transform x and y.
	      x: props.position ? props.position.x : props.defaultPosition.x,
	      y: props.position ? props.position.y : props.defaultPosition.y,
	
	      // Used for compensating for out-of-bounds drags
	      slackX: 0, slackY: 0,
	
	      // Can only determine if SVG after mounting
	      isElementSVG: false
	    };
	    return _this;
	  }
	
	  _createClass(Draggable, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.position && !(this.props.onDrag || this.props.onStop)) {
	        // eslint-disable-next-line
	        console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Check to see if the element passed is an instanceof SVGElement
	      if (typeof window.SVGElement !== 'undefined' && _reactDom2.default.findDOMNode(this) instanceof window.SVGElement) {
	        this.setState({ isElementSVG: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps /*: Object*/) {
	      // Set x/y if position has changed
	      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
	        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
	    }
	  }, {
	    key: 'render',
	    value: function render() /*: ReactElement<any>*/ {
	      var _classNames;
	
	      var style = {},
	          svgTransform = null;
	
	      // If this is controlled, we don't want to move it - unless it's dragging.
	      var controlled = Boolean(this.props.position);
	      var draggable = !controlled || this.state.dragging;
	
	      var position = this.props.position || this.props.defaultPosition;
	      var transformOpts = {
	        // Set left if horizontal drag is enabled
	        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : position.x,
	
	        // Set top if vertical drag is enabled
	        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : position.y
	      };
	
	      // If this element was SVG, we use the `transform` attribute.
	      if (this.state.isElementSVG) {
	        svgTransform = (0, _domFns.createSVGTransform)(transformOpts);
	      } else {
	        // Add a CSS transform to move the element around. This allows us to move the element around
	        // without worrying about whether or not it is relatively or absolutely positioned.
	        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
	        // has a clean slate.
	        style = (0, _domFns.createCSSTransform)(transformOpts);
	      }
	
	      var _props = this.props,
	          defaultClassName = _props.defaultClassName,
	          defaultClassNameDragging = _props.defaultClassNameDragging,
	          defaultClassNameDragged = _props.defaultClassNameDragged;
	
	
	      var children = _react2.default.Children.only(this.props.children);
	
	      // Mark with class while dragging
	      var className = (0, _classnames2.default)(children.props.className || '', defaultClassName, (_classNames = {}, _defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), _defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));
	
	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return _react2.default.createElement(
	        _DraggableCore2.default,
	        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
	        _react2.default.cloneElement(children, {
	          className: className,
	          style: _extends({}, children.props.style, style),
	          transform: svgTransform
	        })
	      );
	    }
	  }]);
	
	  return Draggable;
	}(_react2.default.Component);
	
	Draggable.displayName = 'Draggable';
	Draggable.propTypes = _extends({}, _DraggableCore2.default.propTypes, {
	
	  /**
	   * `axis` determines which axis the draggable can move.
	   *
	   *  Note that all callbacks will still return data as normal. This only
	   *  controls flushing to the DOM.
	   *
	   * 'both' allows movement horizontally and vertically.
	   * 'x' limits movement to horizontal axis.
	   * 'y' limits movement to vertical axis.
	   * 'none' limits all movement.
	   *
	   * Defaults to 'both'.
	   */
	  axis: _propTypes2.default.oneOf(['both', 'x', 'y', 'none']),
	
	  /**
	   * `bounds` determines the range of movement available to the element.
	   * Available values are:
	   *
	   * 'parent' restricts movement within the Draggable's parent node.
	   *
	   * Alternatively, pass an object with the following properties, all of which are optional:
	   *
	   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
	   *
	   * All values are in px.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable bounds={{right: 300, bottom: 300}}>
	   *              <div>Content</div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  bounds: _propTypes2.default.oneOfType([_propTypes2.default.shape({
	    left: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    top: _propTypes2.default.number,
	    bottom: _propTypes2.default.number
	  }), _propTypes2.default.string, _propTypes2.default.oneOf([false])]),
	
	  defaultClassName: _propTypes2.default.string,
	  defaultClassNameDragging: _propTypes2.default.string,
	  defaultClassNameDragged: _propTypes2.default.string,
	
	  /**
	   * `defaultPosition` specifies the x and y that the dragged item should start at
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  defaultPosition: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	
	  /**
	   * `position`, if present, defines the current position of the element.
	   *
	   *  This is similar to how form elements in React work - if no `position` is supplied, the component
	   *  is uncontrolled.
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable position={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  position: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	});
	Draggable.defaultProps = _extends({}, _DraggableCore2.default.defaultProps, {
	  axis: 'both',
	  bounds: false,
	  defaultClassName: 'react-draggable',
	  defaultClassNameDragging: 'react-draggable-dragging',
	  defaultClassNameDragged: 'react-draggable-dragged',
	  defaultPosition: { x: 0, y: 0 },
	  position: null
	});
	exports.default = Draggable;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(8);
	var assign = __webpack_require__(15);
	
	var ReactPropTypesSecret = __webpack_require__(3);
	var checkPropTypes = __webpack_require__(16);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
	  var invariant = __webpack_require__(2);
	  var warning = __webpack_require__(8);
	  var ReactPropTypesSecret = __webpack_require__(3);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	var invariant = __webpack_require__(2);
	var ReactPropTypesSecret = __webpack_require__(3);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPrefix = getPrefix;
	exports.browserPrefixToKey = browserPrefixToKey;
	exports.browserPrefixToStyle = browserPrefixToStyle;
	var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
	function getPrefix() /*: string*/ {
	  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
	
	  // Checking specifically for 'window.document' is for pseudo-browser server-side
	  // environments that define 'window' as the global context.
	  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
	  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';
	
	  var style = window.document.documentElement.style;
	
	  if (prop in style) return '';
	
	  for (var i = 0; i < prefixes.length; i++) {
	    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
	  }
	
	  return '';
	}
	
	function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
	  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
	}
	
	function browserPrefixToStyle(prop /*: string*/, prefix /*: string*/) /*: string*/ {
	  return prefix ? '-' + prefix.toLowerCase() + '-' + prop : prop;
	}
	
	function kebabToTitleCase(str /*: string*/) /*: string*/ {
	  var out = '';
	  var shouldCapitalize = true;
	  for (var i = 0; i < str.length; i++) {
	    if (shouldCapitalize) {
	      out += str[i].toUpperCase();
	      shouldCapitalize = false;
	    } else if (str[i] === '-') {
	      shouldCapitalize = true;
	    } else {
	      out += str[i];
	    }
	  }
	  return out;
	}
	
	// Default export is the prefix itself, like 'Moz', 'Webkit', etc
	// Note that you may have to re-test for certain things; for instance, Chrome 50
	// can handle unprefixed `transform`, but not unprefixed `user-select`
	exports.default = getPrefix();
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=react-draggable.js.map

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(2));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 2);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = warn;
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testModeAPI = exports.OutboundLink = exports.plugin = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	
	var _format2 = __webpack_require__(3);
	
	var _format3 = _interopRequireDefault(_format2);
	
	var _removeLeadingSlash = __webpack_require__(6);
	
	var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);
	
	var _trim = __webpack_require__(1);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _loadGA = __webpack_require__(7);
	
	var _loadGA2 = _interopRequireDefault(_loadGA);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	var _log = __webpack_require__(8);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _testModeAPI = __webpack_require__(9);
	
	var _testModeAPI2 = _interopRequireDefault(_testModeAPI);
	
	var _OutboundLink = __webpack_require__(10);
	
	var _OutboundLink2 = _interopRequireDefault(_OutboundLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
	                                                                                                                                                                                                     * React Google Analytics Module
	                                                                                                                                                                                                     *
	                                                                                                                                                                                                     * @package react-ga
	                                                                                                                                                                                                     * @author  Adam Lofting <adam@mozillafoundation.org>
	                                                                                                                                                                                                     *          Atul Varma <atul@mozillafoundation.org>
	                                                                                                                                                                                                     */
	
	/**
	 * Utilities
	 */
	
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI2.default.ga.apply(_testModeAPI2.default, arguments);
	  if (!window.ga) return (0, _warn2.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format3.default)(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn2.default)('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(undefined, args);
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn2.default)('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (typeof window === 'undefined') {
	      return false;
	    }
	
	    (0, _loadGA2.default)(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
	        (0, _warn2.default)('All configs must be an object');
	        return;
	      }
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	  return true;
	}
	
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	function ga() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(undefined, args);
	    if (_debug) {
	      (0, _log2.default)('called ga(\'arguments\');');
	      (0, _log2.default)('with arguments: ' + JSON.stringify(args));
	    }
	  }
	
	  return window.ga;
	}
	
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn2.default)('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
	    (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn2.default)('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log2.default)('called ga(\'set\', fieldsObject);');
	    (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
	  }
	}
	
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	  if (_debug) {
	    (0, _log2.default)('called ga(\'send\', fieldObject);');
	    (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
	    (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
	  }
	}
	
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn2.default)('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim2.default)(rawPath);
	  if (path === '') {
	    (0, _warn2.default)('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _extends({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	      if (title) {
	        extraLog = ' and title: ' + title;
	      }
	      (0, _log2.default)('with path: ' + path + extraLog);
	    }
	  }
	}
	
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn2.default)('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = '/modal/' + modalName;
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
	      (0, _log2.default)('with path: ' + path);
	    }
	  }
	}
	
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments[1];
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var trackerNames = arguments[1];
	
	  var category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn2.default)('args.category AND args.action are required in event()');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    };
	
	    // Optional Fields
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn2.default)('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn2.default)('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  }
	}
	
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    };
	
	    // Optional Fields
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn2.default)('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    }
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = exports.plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   */
	  require: function require(rawName, options) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn2.default)('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim2.default)(rawName);
	      if (name === '') {
	        (0, _warn2.default)('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      // Optional Fields
	      if (options) {
	        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
	          (0, _warn2.default)('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn2.default)('Empty `options` given to .require()');
	        }
	
	        ga('require', name, options);
	
	        if (_debug) {
	          (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
	        }
	      } else {
	        ga('require', name);
	
	        if (_debug) {
	          (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload = void 0;
	    var actionType = void 0;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn2.default)('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn2.default)('Expected `action` arg to be a String.');
	      } else {
	        var command = pluginName + ':' + action;
	        payload = payload || null;
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	            (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
	          }
	        } else if (payload) {
	          ga(command, payload);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	            (0, _log2.default)('with payload: ' + JSON.stringify(payload));
	          }
	        } else {
	          ga(command);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	          }
	        }
	      }
	    }
	  }
	};
	
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn2.default)('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn2.default)('args.label is required in outboundLink()');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	
	    var safetyCallbackCalled = false;
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	
	      hitCallback();
	    };
	
	    // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	
	    // register safety net timeout:
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA;
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	_OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
	_OutboundLink2.default.trackLink = outboundLink;
	var OutboundLink = exports.OutboundLink = _OutboundLink2.default;
	var testModeAPI = exports.testModeAPI = _testModeAPI2.default;
	
	exports.default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  OutboundLink: OutboundLink,
	  testModeAPI: _testModeAPI2.default
	};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _mightBeEmail = __webpack_require__(4);
	
	var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);
	
	var _toTitleCase = __webpack_require__(5);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail2.default)(s)) {
	    (0, _warn2.default)('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase2.default)(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mightBeEmail;
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return (/[^@]+@[^@]+/.test(s)
	  );
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toTitleCase;
	
	var _trim = __webpack_require__(1);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
	                                                                                                * To Title Case 2.1 - http://individed.com/code/to-title-case/
	                                                                                                * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	                                                                                                * https://github.com/gouch/to-title-case
	                                                                                                */
	
	function toTitleCase(string) {
	  return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeLeadingSlash;
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (options) {
	  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	  /* eslint-disable */
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', options && options.gaAddress ? options.gaAddress : 'https://www.google-analytics.com/analytics.js', 'ga');
	  /* eslint-enable */
	};
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var gaCalls = exports.gaCalls = [];
	
	exports.default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  }
	};
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink = function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick;
	
	      var eventMeta = { label: eventLabel };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        });
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {});
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OutboundLink, [{
	    key: 'render',
	    value: function render() {
	      var props = _extends({}, this.props, {
	        href: this.props.to,
	        onClick: this.handleClick
	      });
	      delete props.eventLabel;
	      return _react2.default.createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	OutboundLink.propTypes = {
	  eventLabel: _propTypes2.default.string.isRequired,
	  target: _propTypes2.default.string,
	  to: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	OutboundLink.defaultProps = {
	  target: null,
	  to: null,
	  onClick: null
	};
	
	OutboundLink.trackLink = function () {
	  (0, _warn2.default)('ga tracking not enabled');
	};
	
	exports.default = OutboundLink;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// a basic form
	var SimpleForm = function SimpleForm(_ref) {
	  var status = _ref.status,
	      message = _ref.message,
	      className = _ref.className,
	      style = _ref.style,
	      onSubmitted = _ref.onSubmitted;
	
	  var input = void 0;
	  var submit = function submit() {
	    return input && input.value.indexOf("@") > -1 && onSubmitted({
	      EMAIL: input.value
	    });
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: className, style: style },
	    status === "sending" && _react2.default.createElement(
	      "div",
	      { style: { color: "blue" } },
	      "sending..."
	    ),
	    status === "error" && _react2.default.createElement("div", {
	      style: { color: "red" },
	      dangerouslySetInnerHTML: { __html: message }
	    }),
	    status === "success" && _react2.default.createElement("div", {
	      style: { color: "green" },
	      dangerouslySetInnerHTML: { __html: message }
	    }),
	    _react2.default.createElement("input", {
	      ref: function ref(node) {
	        return input = node;
	      },
	      type: "email",
	      placeholder: "Your email"
	    }),
	    _react2.default.createElement(
	      "button",
	      { onClick: submit },
	      "Submit"
	    )
	  );
	};
	
	exports.default = SimpleForm;
	module.exports = exports["default"];

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsonp = __webpack_require__(448);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _toQuerystring = __webpack_require__(607);
	
	var _toQuerystring2 = _interopRequireDefault(_toQuerystring);
	
	var _SimpleForm = __webpack_require__(549);
	
	var _SimpleForm2 = _interopRequireDefault(_SimpleForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getAjaxUrl = function getAjaxUrl(url) {
	  return url.replace("/post?", "/post-json?");
	};
	
	var MailchimpSubscribe = function (_React$Component) {
	  _inherits(MailchimpSubscribe, _React$Component);
	
	  function MailchimpSubscribe() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MailchimpSubscribe);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      status: null,
	      message: null
	    }, _this.subscribe = function (data) {
	      var params = (0, _toQuerystring2.default)(data);
	      var url = getAjaxUrl(_this.props.url) + "&" + params;
	      _this.setState({
	        status: "sending",
	        message: null
	      }, function () {
	        return (0, _jsonp2.default)(url, {
	          param: "c"
	        }, function (err, data) {
	          if (err) {
	            _this.setState({
	              status: "error",
	              message: err
	            });
	          } else if (data.result !== "success") {
	            _this.setState({
	              status: "error",
	              message: data.msg
	            });
	          } else {
	            _this.setState({
	              status: "success",
	              message: data.msg
	            });
	          }
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MailchimpSubscribe.prototype.render = function render() {
	    return this.props.render({
	      subscribe: this.subscribe,
	      status: this.state.status,
	      message: this.state.message
	    });
	  };
	
	  return MailchimpSubscribe;
	}(_react2.default.Component);
	
	MailchimpSubscribe.propTypes =  false ? {
	  render: _propTypes2.default.func,
	  url: _propTypes2.default.string.isRequired
	} : {};
	
	MailchimpSubscribe.defaultProps = {
	  render: function render(_ref) {
	    var subscribe = _ref.subscribe,
	        status = _ref.status,
	        message = _ref.message;
	    return _react2.default.createElement(_SimpleForm2.default, {
	      status: status,
	      message: message,
	      onSubmitted: function onSubmitted(formData) {
	        return subscribe(formData);
	      }
	    });
	  }
	};
	
	exports.default = MailchimpSubscribe;
	module.exports = exports["default"];

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(138);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(85);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(140);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(126);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(127);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(139);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(138);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(85);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(140);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(126);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(127);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(139);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(138);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(85);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(140);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(554);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(126);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(127);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(139);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ },
/* 554 */
/***/ function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(551);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(552);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(553);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(557);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(223);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(85);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(556);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(223);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(226);
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(224);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(566);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(560);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(561);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(562);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(563);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(11);
	
	var _wrapMapToProps = __webpack_require__(225);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(225);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(227);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(564);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 565 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 566 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var reactDom = __webpack_require__(15);
	var Draggable = _interopDefault(__webpack_require__(546));
	var Resizable = _interopDefault(__webpack_require__(500));
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var resizableStyle = {
	  width: 'auto',
	  height: 'auto',
	  display: 'inline-block',
	  position: 'absolute',
	  top: 0,
	  left: 0
	};
	
	var Rnd = function (_React$Component) {
	  inherits(Rnd, _React$Component);
	
	  function Rnd(props) {
	    classCallCheck(this, Rnd);
	
	    var _this = possibleConstructorReturn(this, (Rnd.__proto__ || Object.getPrototypeOf(Rnd)).call(this, props));
	
	    _this.state = {
	      z: props.z,
	      original: {
	        x: 0,
	        y: 0
	      },
	      bounds: {
	        top: 0,
	        right: 0,
	        bottom: 0,
	        left: 0
	      },
	      maxWidth: props.maxWidth,
	      maxHeight: props.maxHeight,
	      isMounted: false
	    };
	    _this.onResizeStart = _this.onResizeStart.bind(_this);
	    _this.onResize = _this.onResize.bind(_this);
	    _this.onResizeStop = _this.onResizeStop.bind(_this);
	    _this.onDragStart = _this.onDragStart.bind(_this);
	    _this.onDrag = _this.onDrag.bind(_this);
	    _this.onDragStop = _this.onDragStop.bind(_this);
	    _this.getMaxSizesFromProps = _this.getMaxSizesFromProps.bind(_this);
	    return _this;
	  }
	
	  createClass(Rnd, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.z !== nextProps.z) {
	        this.setState({ z: nextProps.z });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setParentPosition();
	    }
	  }, {
	    key: 'getParentSize',
	    value: function getParentSize() {
	      return this.resizable.getParentSize();
	    }
	  }, {
	    key: 'getMaxSizesFromProps',
	    value: function getMaxSizesFromProps() {
	      var maxWidth = typeof this.props.maxWidth === 'undefined' ? Number.MAX_SAFE_INTEGER : this.props.maxWidth;
	      var maxHeight = typeof this.props.maxHeight === 'undefined' ? Number.MAX_SAFE_INTEGER : this.props.maxHeight;
	      return { maxWidth: maxWidth, maxHeight: maxHeight };
	    }
	  }, {
	    key: 'getSelfElement',
	    value: function getSelfElement() {
	      if (!this) return null;
	      return reactDom.findDOMNode(this);
	    }
	  }, {
	    key: 'setParentPosition',
	    value: function setParentPosition() {
	      var element = this.getSelfElement();
	      if (element instanceof Element) {
	        var parent = element.parentNode;
	        if (!parent || typeof window === 'undefined') return;
	        if (!(parent instanceof HTMLElement)) return;
	        if (getComputedStyle(parent).position !== 'static') {
	          this.setState({ isMounted: true });
	          return;
	        }
	        parent.style.position = 'relative';
	        this.setState({ isMounted: true });
	      }
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(e, data) {
	      if (this.props.onDragStart) {
	        this.props.onDragStart(e, data);
	      }
	      if (!this.props.bounds) return;
	      var parent = this.resizable && this.resizable.parentNode;
	      var target = this.props.bounds === 'parent' ? parent : document.querySelector(this.props.bounds);
	      if (!(target instanceof HTMLElement) || !(parent instanceof HTMLElement)) {
	        return;
	      }
	      var targetRect = target.getBoundingClientRect();
	      var targetLeft = targetRect.left;
	      var targetTop = targetRect.top;
	      var parentRect = parent.getBoundingClientRect();
	      var parentLeft = parentRect.left;
	      var parentTop = parentRect.top;
	      var left = targetLeft - parentLeft;
	      var top = targetTop - parentTop;
	      if (!this.resizable) return;
	      this.setState({
	        bounds: {
	          top: top,
	          right: left + (target.offsetWidth - this.resizable.size.width),
	          bottom: this.props._freeBottomBounds // eslint-disable-line
	          ? 2147483647 : top + (target.offsetHeight - this.resizable.size.height),
	          left: left
	        }
	      });
	    }
	  }, {
	    key: 'onDrag',
	    value: function onDrag(e, data) {
	      if (this.props.onDrag) {
	        this.props.onDrag(e, data);
	      }
	    }
	  }, {
	    key: 'onDragStop',
	    value: function onDragStop(e, data) {
	      if (this.props.onDragStop) {
	        this.props.onDragStop(e, data);
	      }
	    }
	  }, {
	    key: 'onResizeStart',
	    value: function onResizeStart(e, dir, refToElement) {
	      e.stopPropagation();
	      this.setState({
	        original: { x: this.draggable.state.x, y: this.draggable.state.y }
	      });
	      if (this.props.bounds) {
	        var parent = this.resizable && this.resizable.parentNode;
	        var target = this.props.bounds === 'parent' ? parent : document.querySelector(this.props.bounds);
	        var self = this.getSelfElement();
	        if (self instanceof Element && target instanceof HTMLElement && parent instanceof HTMLElement) {
	          var _getMaxSizesFromProps = this.getMaxSizesFromProps(),
	              _maxWidth = _getMaxSizesFromProps.maxWidth,
	              _maxHeight = _getMaxSizesFromProps.maxHeight;
	
	          var parentSize = this.getParentSize();
	          if (_maxWidth && typeof _maxWidth === 'string') {
	            if (_maxWidth.endsWith('%')) {
	              var ratio = Number(_maxWidth.replace('%', '')) / 100;
	              _maxWidth = parentSize.width * ratio;
	            } else if (_maxWidth.endsWith('px')) {
	              _maxWidth = Number(_maxWidth.replace('px', ''));
	            }
	          }
	          if (_maxHeight && typeof _maxHeight === 'string') {
	            if (_maxHeight.endsWith('%')) {
	              var _ratio = Number(_maxHeight.replace('%', '')) / 100;
	              _maxHeight = parentSize.width * _ratio;
	            } else if (_maxHeight.endsWith('px')) {
	              _maxHeight = Number(_maxHeight.replace('px', ''));
	            }
	          }
	          var selfRect = self.getBoundingClientRect();
	          var selfLeft = selfRect.left;
	          var selfTop = selfRect.top;
	          var targetRect = target.getBoundingClientRect();
	          var targetLeft = targetRect.left;
	          var targetTop = targetRect.top;
	          if (/left/i.test(dir) && this.resizable) {
	            var max = selfLeft - targetLeft + this.resizable.size.width;
	            this.setState({ maxWidth: max > Number(_maxWidth) ? _maxWidth : max });
	          }
	          if (/right/i.test(dir)) {
	            var _max = target.offsetWidth + (targetLeft - selfLeft);
	            this.setState({ maxWidth: _max > Number(_maxWidth) ? _maxWidth : _max });
	          }
	          if (/top/i.test(dir) && this.resizable) {
	            var _max2 = selfTop - targetTop + this.resizable.size.height;
	            this.setState({
	              maxHeight: _max2 > Number(_maxHeight) ? _maxHeight : _max2
	            });
	          }
	          if (/bottom/i.test(dir)) {
	            var _max3 = target.offsetHeight + (targetTop - selfTop);
	            this.setState({
	              maxHeight: _max3 > Number(_maxHeight) ? _maxHeight : _max3
	            });
	          }
	        }
	      } else {
	        this.setState({
	          maxWidth: this.props.maxWidth,
	          maxHeight: this.props.maxHeight
	        });
	      }
	      if (this.props.onResizeStart) {
	        this.props.onResizeStart(e, dir, refToElement);
	      }
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize(e, direction, refToResizableElement, delta) {
	      var x = void 0;
	      var y = void 0;
	      if (/left/i.test(direction)) {
	        x = this.state.original.x - delta.width;
	        this.draggable.setState({ x: x });
	      }
	      if (/top/i.test(direction)) {
	        y = this.state.original.y - delta.height;
	        this.draggable.setState({ y: y });
	      }
	      if (this.props.onResize) {
	        this.props.onResize(e, direction, refToResizableElement, delta, {
	          x: x || this.draggable.state.x,
	          y: y || this.draggable.state.y
	        });
	      }
	    }
	  }, {
	    key: 'onResizeStop',
	    value: function onResizeStop(e, direction, refToResizableElement, delta) {
	      var _getMaxSizesFromProps2 = this.getMaxSizesFromProps(),
	          maxWidth = _getMaxSizesFromProps2.maxWidth,
	          maxHeight = _getMaxSizesFromProps2.maxHeight;
	
	      this.setState({ maxWidth: maxWidth, maxHeight: maxHeight });
	      if (this.props.onResizeStop) {
	        var _position = {
	          x: this.draggable.state.x,
	          y: this.draggable.state.y
	        };
	        this.props.onResizeStop(e, direction, refToResizableElement, delta, _position);
	      }
	    }
	  }, {
	    key: 'updateSize',
	    value: function updateSize(size) {
	      if (!this.resizable) return;
	      this.resizable.updateSize({ width: size.width, height: size.height });
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(position) {
	      this.draggable.setState(position);
	    }
	  }, {
	    key: 'updateZIndex',
	    value: function updateZIndex(z) {
	      this.setState({ z: z });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var cursorStyle = this.props.disableDragging || this.props.dragHandleClassName ? { cursor: 'normal' } : { cursor: 'move' };
	      var innerStyle = _extends({}, resizableStyle, {
	        zIndex: this.state.z
	      }, cursorStyle, this.props.style);
	      // HACK: Wait for setting relative to parent element.
	      if (!this.state.isMounted) return React.createElement('div', null);
	      var maxHeight = this.props._freeBottomBounds ? 2147483647 : this.state.maxHeight; // eslint-disable-line
	      return React.createElement(
	        Draggable,
	        {
	          ref: function ref(c) {
	            _this2.draggable = c;
	          },
	          handle: this.props.dragHandleClassName,
	          defaultPosition: this.props.default,
	          onStart: this.onDragStart,
	          onDrag: this.onDrag,
	          onStop: this.onDragStop,
	          axis: this.props.dragAxis,
	          disabled: this.props.disableDragging,
	          grid: this.props.dragGrid,
	          bounds: this.props.bounds ? this.state.bounds : undefined,
	          position: this.props.position,
	          enableUserSelectHack: this.props.enableUserSelectHack,
	          cancel: this.props.cancel
	        },
	        React.createElement(
	          Resizable,
	          _extends({}, this.props.extendsProps, {
	            className: this.props.className,
	            ref: function ref(c) {
	              _this2.resizable = c;
	            },
	            defaultSize: this.props.default,
	            size: this.props.size,
	            enable: this.props.enableResizing,
	            onResizeStart: this.onResizeStart,
	            onResize: this.onResize,
	            onResizeStop: this.onResizeStop,
	            style: innerStyle,
	            minWidth: this.props.minWidth,
	            minHeight: this.props.minHeight,
	            maxWidth: this.state.maxWidth,
	            maxHeight: maxHeight,
	            grid: this.props.resizeGrid,
	            handleWrapperClass: this.props.resizeHandleWrapperClass,
	            handleWrapperStyle: this.props.resizeHandleWrapperStyle,
	            lockAspectRatio: this.props.lockAspectRatio,
	            lockAspectRatioExtraWidth: this.props.lockAspectRatioExtraWidth,
	            lockAspectRatioExtraHeight: this.props.lockAspectRatioExtraHeight,
	            handleStyles: this.props.resizeHandleStyles,
	            handleClasses: this.props.resizeHandleClasses
	          }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return Rnd;
	}(React.Component);
	
	Rnd.defaultProps = {
	  maxWidth: Number.MAX_SAFE_INTEGER,
	  maxHeight: Number.MAX_SAFE_INTEGER,
	  onResizeStart: function onResizeStart() {},
	  onResize: function onResize() {},
	  onResizeStop: function onResizeStop() {},
	  onDragStart: function onDragStart() {},
	  onDrag: function onDrag() {},
	  onDragStop: function onDragStop() {}
	};
	
	exports.default = Rnd;
	//# sourceMappingURL=index.es5.js.map


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(184);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(142);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(185);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(142);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(578);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(229);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(228);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(579);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(580);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(581);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(582);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(144);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(583);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(186);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(143);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(420);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(53);
	
	var _Router = __webpack_require__(143);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(144);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          sensitive = _element$props.sensitive,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(187);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(230);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(496).enable();
	  window.Promise = __webpack_require__(495);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(616);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(125);


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(231);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(232);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(86);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 586 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ },
/* 587 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.8.4
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(125),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
	60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
	function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
	H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("307"):void 0;return a}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
	b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.4",
	unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 589 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = reduceReducers;
	
	function reduceReducers() {
	  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
	    reducers[_key] = arguments[_key];
	  }
	
	  return function (previous, current) {
	    return reducers.reduce(function (p, r) {
	      return r(p, current);
	    }, previous);
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 590 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (array, callback) {
	  return array.reduce(function (partialObject, element) {
	    return callback(partialObject, element);
	  }, {});
	};

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createActions;
	
	var _camelCase = __webpack_require__(238);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _identity = __webpack_require__(119);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isPlainObject = __webpack_require__(43);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isArray = __webpack_require__(67);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _last = __webpack_require__(485);
	
	var _last2 = _interopRequireDefault(_last);
	
	var _isString = __webpack_require__(123);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isFunction = __webpack_require__(56);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isNil = __webpack_require__(213);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _createAction = __webpack_require__(240);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _arrayToObject = __webpack_require__(590);
	
	var _arrayToObject2 = _interopRequireDefault(_arrayToObject);
	
	var _flattenUtils = __webpack_require__(241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function createActions(actionMap) {
	  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    identityActions[_key - 1] = arguments[_key];
	  }
	
	  var options = (0, _isPlainObject2.default)((0, _last2.default)(identityActions)) ? identityActions.pop() : {};
	  (0, _invariant2.default)(identityActions.every(_isString2.default) && ((0, _isString2.default)(actionMap) || (0, _isPlainObject2.default)(actionMap)), 'Expected optional object followed by string action types');
	  if ((0, _isString2.default)(actionMap)) {
	    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions), options);
	  }
	  return _extends({}, actionCreatorsFromActionMap(actionMap, options), actionCreatorsFromIdentityActions(identityActions, options));
	}
	
	function actionCreatorsFromActionMap(actionMap, options) {
	  var flatActionMap = (0, _flattenUtils.flattenActionMap)(actionMap, options);
	  var flatActionCreators = actionMapToActionCreators(flatActionMap);
	  return (0, _flattenUtils.unflattenActionCreators)(flatActionCreators, options);
	}
	
	function actionMapToActionCreators(actionMap) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      prefix = _ref.prefix,
	      _ref$namespace = _ref.namespace,
	      namespace = _ref$namespace === undefined ? _flattenUtils.defaultNamespace : _ref$namespace;
	
	  function isValidActionMapValue(actionMapValue) {
	    if ((0, _isFunction2.default)(actionMapValue) || (0, _isNil2.default)(actionMapValue)) {
	      return true;
	    } else if ((0, _isArray2.default)(actionMapValue)) {
	      var _actionMapValue = _slicedToArray(actionMapValue, 2),
	          _actionMapValue$ = _actionMapValue[0],
	          payload = _actionMapValue$ === undefined ? _identity2.default : _actionMapValue$,
	          meta = _actionMapValue[1];
	
	      return (0, _isFunction2.default)(payload) && (0, _isFunction2.default)(meta);
	    }
	    return false;
	  }
	
	  return (0, _arrayToObject2.default)(Object.keys(actionMap), function (partialActionCreators, type) {
	    var actionMapValue = actionMap[type];
	    (0, _invariant2.default)(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ('functions for ' + type));
	    var prefixedType = prefix ? '' + prefix + namespace + type : type;
	    var actionCreator = (0, _isArray2.default)(actionMapValue) ? _createAction2.default.apply(undefined, [prefixedType].concat(_toConsumableArray(actionMapValue))) : (0, _createAction2.default)(prefixedType, actionMapValue);
	    return _extends({}, partialActionCreators, _defineProperty({}, type, actionCreator));
	  });
	}
	
	function actionCreatorsFromIdentityActions(identityActions, options) {
	  var actionMap = (0, _arrayToObject2.default)(identityActions, function (partialActionMap, type) {
	    return _extends({}, partialActionMap, _defineProperty({}, type, _identity2.default));
	  });
	  var actionCreators = actionMapToActionCreators(actionMap, options);
	  return (0, _arrayToObject2.default)(Object.keys(actionCreators), function (partialActionCreators, type) {
	    return _extends({}, partialActionCreators, _defineProperty({}, (0, _camelCase2.default)(type), actionCreators[type]));
	  });
	}

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleActions;
	
	var _isPlainObject = __webpack_require__(43);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isMap = __webpack_require__(121);
	
	var _isMap2 = _interopRequireDefault(_isMap);
	
	var _reduceReducers = __webpack_require__(589);
	
	var _reduceReducers2 = _interopRequireDefault(_reduceReducers);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _handleAction = __webpack_require__(242);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _ownKeys = __webpack_require__(147);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	var _flattenUtils = __webpack_require__(241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function get(key, x) {
	  return (0, _isMap2.default)(x) ? x.get(key) : x[key];
	}
	
	function handleActions(handlers, defaultState) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  (0, _invariant2.default)((0, _isPlainObject2.default)(handlers) || (0, _isMap2.default)(handlers), 'Expected handlers to be a plain object.');
	  var flattenedReducerMap = (0, _flattenUtils.flattenReducerMap)(handlers, options);
	  var reducers = (0, _ownKeys2.default)(flattenedReducerMap).map(function (type) {
	    return (0, _handleAction2.default)(type, get(type, flattenedReducerMap), defaultState);
	  });
	  var reducer = _reduceReducers2.default.apply(undefined, _toConsumableArray(reducers));
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	    return reducer(state, action);
	  };
	}

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasGeneratorInterface;
	
	var _ownKeys = __webpack_require__(147);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasGeneratorInterface(handler) {
	  var keys = (0, _ownKeys2.default)(handler);
	  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
	    return ownKey === 'next' || ownKey === 'throw';
	  });
	  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
	}

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = promiseMiddleware;
	
	var _fluxStandardAction = __webpack_require__(419);
	
	function isPromise(val) {
	  return val && typeof val.then === 'function';
	}
	
	function promiseMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	
	  return function (next) {
	    return function (action) {
	      if (!_fluxStandardAction.isFSA(action)) {
	        return isPromise(action) ? action.then(dispatch) : next(action);
	      }
	
	      return isPromise(action.payload) ? action.payload.then(function (result) {
	        return dispatch(_extends({}, action, { payload: result }));
	      }, function (error) {
	        return dispatch(_extends({}, action, { payload: error, error: true }));
	      }) : next(action);
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(244);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 597 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(245);
	
	var _isPlainObject = __webpack_require__(43);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(246);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 599 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RIEStatefulBase2 = __webpack_require__(72);
	
	var _RIEStatefulBase3 = _interopRequireDefault(_RIEStatefulBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = __webpack_require__(76)('RIENumber');
	
	var RIENumber = function (_RIEStatefulBase) {
	    _inherits(RIENumber, _RIEStatefulBase);
	
	    function RIENumber(props) {
	        _classCallCheck(this, RIENumber);
	
	        var _this = _possibleConstructorReturn(this, (RIENumber.__proto__ || Object.getPrototypeOf(RIENumber)).call(this, props));
	
	        _this.validate = function (value) {
	            debug('validate(' + value + ')');
	            return !isNaN(value) && isFinite(value) && value.length > 0;
	        };
	
	        _this.selectInputText = function (element) {
	            debug('selectInputText(' + element + ')'
	            // element.setSelectionRange won't work for an input of type "number"
	            );setTimeout(function () {
	                element.select();
	            }, 10);
	        };
	
	        _this.elementBlur = function (element) {
	            debug('elementBlur(' + element + ')'
	            /*  
	                        Firefox workaround
	                        Found at https://tirdadc.github.io/blog/2015/06/11/react-dot-js-firefox-issue-with-onblur/
	            */
	            );if (element.nativeEvent.explicitOriginalTarget && element.nativeEvent.explicitOriginalTarget == element.nativeEvent.originalTarget) {
	                return;
	            }
	            _this.finishEditing();
	        };
	
	        _this.renderNormalComponent = function () {
	            debug('renderNormalComponent()');
	            return _react2.default.createElement(
	                'span',
	                _extends({
	                    tabIndex: '0',
	                    className: _this.makeClassString(),
	                    onFocus: _this.startEditing,
	                    onClick: _this.elementClick
	                }, _this.props.defaultProps),
	                _this.props.format ? _this.props.format(_this.state.newValue || _this.props.value) : _this.state.newValue || _this.props.value
	            );
	        };
	
	        _this.renderEditingComponent = function () {
	            debug('renderEditingComponent()');
	            return _react2.default.createElement('input', _extends({ disabled: _this.props.shouldBlockWhileLoading && _this.state.loading,
	                type: 'number',
	                className: _this.makeClassString(),
	                defaultValue: _this.props.value,
	                onInput: _this.textChanged,
	                onBlur: _this.elementBlur,
	                ref: 'input',
	                onKeyDown: _this.keyDown
	            }, _this.props.editProps));
	        };
	
	        return _this;
	    }
	
	    return RIENumber;
	}(_RIEStatefulBase3.default);
	
	RIENumber.propTypes = {
	    format: _propTypes2.default.func
	};
	exports.default = RIENumber;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RIEStatefulBase2 = __webpack_require__(72);
	
	var _RIEStatefulBase3 = _interopRequireDefault(_RIEStatefulBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RIESelect = function (_RIEStatefulBase) {
	    _inherits(RIESelect, _RIEStatefulBase);
	
	    function RIESelect() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RIESelect);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RIESelect.__proto__ || Object.getPrototypeOf(RIESelect)).call.apply(_ref, [this].concat(args))), _this), _this.finishEditing = function () {
	            // get the object from options that matches user selected value
	            var newValue = _this.props.options.find(function (option) {
	                return option.id === _reactDom2.default.findDOMNode(this.refs.input).value;
	            }, _this);
	            _this.doValidations(newValue);
	            if (!_this.state.invalid && _this.props.value !== newValue) {
	                _this.commit(newValue);
	            }
	            _this.cancelEditing();
	        }, _this.renderEditingComponent = function () {
	            var optionNodes = _this.props.options.map(function (option) {
	                return _react2.default.createElement(
	                    'option',
	                    { value: option.id, key: option.id },
	                    option.text
	                );
	            });
	
	            return _react2.default.createElement(
	                'select',
	                _extends({ disabled: _this.props.shouldBlockWhileLoading && _this.state.loading,
	                    value: _this.props.value.id,
	                    className: _this.makeClassString(),
	                    onChange: _this.finishEditing,
	                    onBlur: _this.cancelEditing,
	                    ref: 'input',
	                    onKeyDown: _this.keyDown
	                }, _this.props.editProps),
	                optionNodes
	            );
	        }, _this.renderNormalComponent = function () {
	            return _react2.default.createElement(
	                'span',
	                _extends({
	                    tabIndex: '0',
	                    className: _this.makeClassString(),
	                    onFocus: _this.startEditing,
	                    onClick: _this.startEditing
	                }, _this.props.defaultProps),
	                !!_this.state.newValue ? _this.state.newValue.text : _this.props.value.text
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return RIESelect;
	}(_RIEStatefulBase3.default);
	
	RIESelect.propTypes = {
	    options: _propTypes2.default.array.isRequired
	};
	exports.default = RIESelect;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RIEStatefulBase2 = __webpack_require__(72);
	
	var _RIEStatefulBase3 = _interopRequireDefault(_RIEStatefulBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RIETag = function (_React$Component) {
	    _inherits(RIETag, _React$Component);
	
	    function RIETag(props) {
	        _classCallCheck(this, RIETag);
	
	        var _this = _possibleConstructorReturn(this, (RIETag.__proto__ || Object.getPrototypeOf(RIETag)).call(this, props));
	
	        _this.remove = function () {
	            _this.props.removeHandler(_this.props.text);
	        };
	
	        _this.render = function () {
	            return _react2.default.createElement(
	                'div',
	                { key: _this.props.text },
	                _this.props.text,
	                _react2.default.createElement(
	                    'div',
	                    { onClick: _this.remove, className: _this.props.className || "remove" },
	                    ' \xD7 '
	                )
	            );
	        };
	
	        return _this;
	    }
	
	    return RIETag;
	}(_react2.default.Component);
	
	RIETag.propTypes = {
	    text: _propTypes2.default.string.isRequired,
	    removeHandler: _propTypes2.default.func,
	    className: _propTypes2.default.string
	};
	
	var RIETags = function (_RIEStatefulBase) {
	    _inherits(RIETags, _RIEStatefulBase);
	
	    function RIETags(props) {
	        _classCallCheck(this, RIETags);
	
	        var _this2 = _possibleConstructorReturn(this, (RIETags.__proto__ || Object.getPrototypeOf(RIETags)).call(this, props));
	
	        _this2.addTag = function (tag) {
	            if ([].concat(_toConsumableArray(_this2.props.value)).length < (_this2.props.maxTags || 65535)) {
	                _this2.commit(_this2.props.value.add(tag));
	            }
	        };
	
	        _this2.removeTag = function (tag) {
	
	            clearTimeout(_this2.state.blurTimer);
	
	            if ([].concat(_toConsumableArray(_this2.props.value)).length >= (_this2.props.minTags || 1)) {
	                var newSet = _this2.props.value;
	                newSet.delete(tag);
	                _this2.commit(newSet);
	            }
	        };
	
	        _this2.componentWillReceiveProps = function (nextProps) {
	            if ('value' in nextProps) _this2.setState({ loading: false, invalid: false });
	        };
	
	        _this2.keyDown = function (event) {
	            if (event.keyCode === 8) {
	                // Backspace
	                if (event.target.value.length == 0) {
	                    var tagToRemove = [].concat(_toConsumableArray(_this2.props.value)).pop();
	                    _this2.removeTag(tagToRemove);
	                }
	            } else if (event.keyCode === 13) {
	                // Enter
	                event.preventDefault();
	                if (event.target.value.length === 0) {
	                    _this2.cancelEditing();
	                } else {
	                    _this2.addTag(event.target.value);
	                    event.target.value = "";
	                }
	            } else if (event.keyCode === 27) {
	                // Escape
	                _this2.cancelEditing();
	            }
	        };
	
	        _this2.cancelEditingDelayed = function () {
	            _this2.setState({ blurTimer: setTimeout(_this2.cancelEditing, _this2.props.blurDelay || 180) });
	        };
	
	        _this2.cancelEditing = function () {
	            _this2.setState({ editing: false, invalid: false });
	        };
	
	        _this2.componentDidUpdate = function (prevProps, prevState) {
	            var inputElem = _reactDom2.default.findDOMNode(_this2.refs.input);
	            if (_this2.state.editing) {
	                inputElem.focus();
	            }
	        };
	
	        _this2.renderNormalComponent = function () {
	            var tags = [].concat(_toConsumableArray(_this2.props.value)).join(_this2.props.separator || ", ");
	            return _react2.default.createElement(
	                'span',
	                _extends({
	                    tabIndex: '0',
	                    className: _this2.makeClassString(),
	                    onFocus: _this2.startEditing
	                }, _this2.props.defaultProps),
	                tags
	            );
	        };
	
	        _this2.makeTagElement = function (text) {
	            return _react2.default.createElement(RIETag, { key: text, text: text, removeHandler: _this2.removeTag });
	        };
	
	        _this2.renderEditingComponent = function () {
	            var elements = [].concat(_toConsumableArray(_this2.props.value)).map(_this2.makeTagElement);
	            return _react2.default.createElement(
	                'div',
	                _extends({ tabIndex: '1', onClick: _this2.startEditing, className: _this2.makeClassString() }, _this2.props.editProps),
	                elements,
	                _react2.default.createElement('input', {
	                    onBlur: _this2.cancelEditingDelayed,
	                    onKeyDown: _this2.keyDown,
	                    placeholder: _this2.props.placeholder || "New tag",
	                    ref: 'input' })
	            );
	        };
	
	        _this2.state.currentText = "";
	        _this2.state.blurTimer = null;
	        return _this2;
	    }
	
	    return RIETags;
	}(_RIEStatefulBase3.default);
	
	RIETags.propTyes = {
	    value: _propTypes2.default.object.isRequired,
	    maxTags: _propTypes2.default.number,
	    minTags: _propTypes2.default.number,
	    separator: _propTypes2.default.string,
	    elementClass: _propTypes2.default.string,
	    blurDelay: _propTypes2.default.number,
	    placeholder: _propTypes2.default.string
	};
	exports.default = RIETags;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RIEStatefulBase2 = __webpack_require__(72);
	
	var _RIEStatefulBase3 = _interopRequireDefault(_RIEStatefulBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RIETextArea = function (_RIEStatefulBase) {
	    _inherits(RIETextArea, _RIEStatefulBase);
	
	    function RIETextArea() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RIETextArea);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RIETextArea.__proto__ || Object.getPrototypeOf(RIETextArea)).call.apply(_ref, [this].concat(args))), _this), _this.keyDown = function (event) {
	            if (event.keyCode === 27) {
	                _this.cancelEditing();
	            } // Escape
	        }, _this.renderEditingComponent = function () {
	            return _react2.default.createElement('textarea', _extends({
	                rows: _this.props.rows,
	                cols: _this.props.cols,
	                disabled: _this.state.loading,
	                className: _this.makeClassString(),
	                defaultValue: _this.props.value,
	                onInput: _this.textChanged,
	                onBlur: _this.finishEditing,
	                ref: 'input',
	                onKeyDown: _this.keyDown
	            }, _this.props.editProps));
	        }, _this.renderNormalComponent = function () {
	            var value = _this.state.newValue || _this.props.value;
	            var spans_and_brs = [];
	            var i = 0;
	            value.split("\n").map(function (line) {
	                spans_and_brs.push(_react2.default.createElement(
	                    'span',
	                    { key: i },
	                    line
	                ));
	                spans_and_brs.push(_react2.default.createElement('br', { key: i + 1 }));
	                i += 2;
	            });
	            spans_and_brs.pop // remove last br tag
	
	            ();return _react2.default.createElement(
	                'span',
	                _extends({
	                    tabIndex: '0',
	                    className: _this.makeClassString(),
	                    onFocus: _this.startEditing,
	                    onClick: _this.startEditing
	                }, _this.props.defaultProps),
	                spans_and_brs
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return RIETextArea;
	}(_RIEStatefulBase3.default);
	
	exports.default = RIETextArea;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RIEBase2 = __webpack_require__(247);
	
	var _RIEBase3 = _interopRequireDefault(_RIEBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RIEToggle = function (_RIEBase) {
	    _inherits(RIEToggle, _RIEBase);
	
	    function RIEToggle() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RIEToggle);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RIEToggle.__proto__ || Object.getPrototypeOf(RIEToggle)).call.apply(_ref, [this].concat(args))), _this), _this.elementClick = function (e) {
	            if (_this.props.isDisabled) return;
	            _this.setState({ value: !_this.props.value });
	            _this.commit(!_this.props.value);
	        }, _this.render = function () {
	            var valueToRender = _this.state.loading ? _this.state.value : _this.props.value;
	            return _react2.default.createElement(
	                'span',
	                _extends({
	                    tabIndex: '0',
	                    onKeyPress: _this.elementClick,
	                    onClick: _this.elementClick,
	                    className: _this.makeClassString()
	                }, _this.props.defaultProps),
	                valueToRender ? _this.props.textTrue || 'yes' : _this.props.textFalse || 'no'
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return RIEToggle;
	}(_RIEBase3.default);
	
	RIEToggle.propTypes = {
	    textTrue: _propTypes2.default.string,
	    textFalse: _propTypes2.default.string
	};
	exports.default = RIEToggle;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(606);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(148)(module)))

/***/ },
/* 606 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("to-querystring",[],t):"object"==typeof exports?exports["to-querystring"]=t():e["to-querystring"]=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:o})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){"use strict";function o(e,t,n){if("object"===(void 0===t?"undefined":i(t))){return""+u(t,""+n+(""+e+(n&&"]")+"["))}return n&&n.length?""+n+e+"]="+encodeURIComponent(t):e+"="+encodeURIComponent(t)}function r(e,t,n){return t.map(function(t){return o(e,t,n)}).join("&")}function u(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},u=n.arrayPrefix||"",i=[];return i=Array.isArray(e)?e.map(function(e,n){return o(""+n+u,e,t)}):Object.keys(e).filter(function(t){return void 0!==e[t]}).map(function(n){return e[n]&&Array.isArray(e[n])?r(""+n+u,e[n],t):o(n,e[n],t)}),i.join("&").replace(/%20/g,"+")}Object.defineProperty(t,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=u}])});

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/AvoidDave.c0234d5b.jpg";

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/VirgoSillamaa.c4eff191.jpg";

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/campaign-feature-1.396166ee.png";

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/campaign-feature-2.af2883f9.png";

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/campaign-feature-3.f66fb967.png";

/***/ },
/* 613 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 614 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 615 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 616 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.1107a3ca.js